var jM = Object.defineProperty;
var $M = (e, t, n) => t in e ? jM(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var qe = (e, t, n) => $M(e, typeof t != "symbol" ? t + "" : t, n);
import * as w from "react";
import Ae, { forwardRef as El, useContext as Qa, isValidElement as ou, cloneElement as iu, Children as Q0, useCallback as $t, useState as Kt, useMemo as rr, useRef as Ti, useReducer as Jm, useEffect as mn, useImperativeHandle as eh, Fragment as AM, PureComponent as NM, createRef as tv, useLayoutEffect as th, useId as FM } from "react";
import * as LM from "react-dom";
import $c, { createPortal as BM } from "react-dom";
var Ei = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Rl(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ac = { exports: {} }, _s = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var nv;
function VM() {
  if (nv) return _s;
  nv = 1;
  var e = Ae, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(u, d, p) {
    var m, h = {}, g = null, v = null;
    p !== void 0 && (g = "" + p), d.key !== void 0 && (g = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (m in d) r.call(d, m) && !a.hasOwnProperty(m) && (h[m] = d[m]);
    if (u && u.defaultProps) for (m in d = u.defaultProps, d) h[m] === void 0 && (h[m] = d[m]);
    return { $$typeof: t, type: u, key: g, ref: v, props: h, _owner: i.current };
  }
  return _s.Fragment = n, _s.jsx = l, _s.jsxs = l, _s;
}
var Is = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rv;
function zM() {
  return rv || (rv = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Ae, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), u = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), m = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), b = Symbol.iterator, y = "@@iterator";
    function S(H) {
      if (H === null || typeof H != "object")
        return null;
      var Se = b && H[b] || H[y];
      return typeof Se == "function" ? Se : null;
    }
    var O = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function P(H) {
      {
        for (var Se = arguments.length, _e = new Array(Se > 1 ? Se - 1 : 0), Qe = 1; Qe < Se; Qe++)
          _e[Qe - 1] = arguments[Qe];
        k("error", H, _e);
      }
    }
    function k(H, Se, _e) {
      {
        var Qe = O.ReactDebugCurrentFrame, Ot = Qe.getStackAddendum();
        Ot !== "" && (Se += "%s", _e = _e.concat([Ot]));
        var fe = _e.map(function(oe) {
          return String(oe);
        });
        fe.unshift("Warning: " + Se), Function.prototype.apply.call(console[H], console, fe);
      }
    }
    var R = !1, E = !1, M = !1, _ = !1, I = !1, F;
    F = Symbol.for("react.module.reference");
    function T(H) {
      return !!(typeof H == "string" || typeof H == "function" || H === r || H === a || I || H === i || H === p || H === m || _ || H === v || R || E || M || typeof H == "object" && H !== null && (H.$$typeof === g || H.$$typeof === h || H.$$typeof === l || H.$$typeof === u || H.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      H.$$typeof === F || H.getModuleId !== void 0));
    }
    function $(H, Se, _e) {
      var Qe = H.displayName;
      if (Qe)
        return Qe;
      var Ot = Se.displayName || Se.name || "";
      return Ot !== "" ? _e + "(" + Ot + ")" : _e;
    }
    function N(H) {
      return H.displayName || "Context";
    }
    function W(H) {
      if (H == null)
        return null;
      if (typeof H.tag == "number" && P("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof H == "function")
        return H.displayName || H.name || null;
      if (typeof H == "string")
        return H;
      switch (H) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case a:
          return "Profiler";
        case i:
          return "StrictMode";
        case p:
          return "Suspense";
        case m:
          return "SuspenseList";
      }
      if (typeof H == "object")
        switch (H.$$typeof) {
          case u:
            var Se = H;
            return N(Se) + ".Consumer";
          case l:
            var _e = H;
            return N(_e._context) + ".Provider";
          case d:
            return $(H, H.render, "ForwardRef");
          case h:
            var Qe = H.displayName || null;
            return Qe !== null ? Qe : W(H.type) || "Memo";
          case g: {
            var Ot = H, fe = Ot._payload, oe = Ot._init;
            try {
              return W(oe(fe));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var L = Object.assign, V = 0, z, X, le, ne, G, Q, be;
    function we() {
    }
    we.__reactDisabledLog = !0;
    function se() {
      {
        if (V === 0) {
          z = console.log, X = console.info, le = console.warn, ne = console.error, G = console.group, Q = console.groupCollapsed, be = console.groupEnd;
          var H = {
            configurable: !0,
            enumerable: !0,
            value: we,
            writable: !0
          };
          Object.defineProperties(console, {
            info: H,
            log: H,
            warn: H,
            error: H,
            group: H,
            groupCollapsed: H,
            groupEnd: H
          });
        }
        V++;
      }
    }
    function U() {
      {
        if (V--, V === 0) {
          var H = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: L({}, H, {
              value: z
            }),
            info: L({}, H, {
              value: X
            }),
            warn: L({}, H, {
              value: le
            }),
            error: L({}, H, {
              value: ne
            }),
            group: L({}, H, {
              value: G
            }),
            groupCollapsed: L({}, H, {
              value: Q
            }),
            groupEnd: L({}, H, {
              value: be
            })
          });
        }
        V < 0 && P("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var de = O.ReactCurrentDispatcher, ce;
    function K(H, Se, _e) {
      {
        if (ce === void 0)
          try {
            throw Error();
          } catch (Ot) {
            var Qe = Ot.stack.trim().match(/\n( *(at )?)/);
            ce = Qe && Qe[1] || "";
          }
        return `
` + ce + H;
      }
    }
    var Z = !1, ue;
    {
      var he = typeof WeakMap == "function" ? WeakMap : Map;
      ue = new he();
    }
    function B(H, Se) {
      if (!H || Z)
        return "";
      {
        var _e = ue.get(H);
        if (_e !== void 0)
          return _e;
      }
      var Qe;
      Z = !0;
      var Ot = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var fe;
      fe = de.current, de.current = null, se();
      try {
        if (Se) {
          var oe = function() {
            throw Error();
          };
          if (Object.defineProperty(oe.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(oe, []);
            } catch (kn) {
              Qe = kn;
            }
            Reflect.construct(H, [], oe);
          } else {
            try {
              oe.call();
            } catch (kn) {
              Qe = kn;
            }
            H.call(oe.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (kn) {
            Qe = kn;
          }
          H();
        }
      } catch (kn) {
        if (kn && Qe && typeof kn.stack == "string") {
          for (var Te = kn.stack.split(`
`), Ke = Qe.stack.split(`
`), Ye = Te.length - 1, tt = Ke.length - 1; Ye >= 1 && tt >= 0 && Te[Ye] !== Ke[tt]; )
            tt--;
          for (; Ye >= 1 && tt >= 0; Ye--, tt--)
            if (Te[Ye] !== Ke[tt]) {
              if (Ye !== 1 || tt !== 1)
                do
                  if (Ye--, tt--, tt < 0 || Te[Ye] !== Ke[tt]) {
                    var Mt = `
` + Te[Ye].replace(" at new ", " at ");
                    return H.displayName && Mt.includes("<anonymous>") && (Mt = Mt.replace("<anonymous>", H.displayName)), typeof H == "function" && ue.set(H, Mt), Mt;
                  }
                while (Ye >= 1 && tt >= 0);
              break;
            }
        }
      } finally {
        Z = !1, de.current = fe, U(), Error.prepareStackTrace = Ot;
      }
      var Jt = H ? H.displayName || H.name : "", Jn = Jt ? K(Jt) : "";
      return typeof H == "function" && ue.set(H, Jn), Jn;
    }
    function ee(H, Se, _e) {
      return B(H, !1);
    }
    function ie(H) {
      var Se = H.prototype;
      return !!(Se && Se.isReactComponent);
    }
    function ge(H, Se, _e) {
      if (H == null)
        return "";
      if (typeof H == "function")
        return B(H, ie(H));
      if (typeof H == "string")
        return K(H);
      switch (H) {
        case p:
          return K("Suspense");
        case m:
          return K("SuspenseList");
      }
      if (typeof H == "object")
        switch (H.$$typeof) {
          case d:
            return ee(H.render);
          case h:
            return ge(H.type, Se, _e);
          case g: {
            var Qe = H, Ot = Qe._payload, fe = Qe._init;
            try {
              return ge(fe(Ot), Se, _e);
            } catch {
            }
          }
        }
      return "";
    }
    var xe = Object.prototype.hasOwnProperty, pe = {}, Ee = O.ReactDebugCurrentFrame;
    function Pe(H) {
      if (H) {
        var Se = H._owner, _e = ge(H.type, H._source, Se ? Se.type : null);
        Ee.setExtraStackFrame(_e);
      } else
        Ee.setExtraStackFrame(null);
    }
    function Be(H, Se, _e, Qe, Ot) {
      {
        var fe = Function.call.bind(xe);
        for (var oe in H)
          if (fe(H, oe)) {
            var Te = void 0;
            try {
              if (typeof H[oe] != "function") {
                var Ke = Error((Qe || "React class") + ": " + _e + " type `" + oe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof H[oe] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Ke.name = "Invariant Violation", Ke;
              }
              Te = H[oe](Se, oe, Qe, _e, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ye) {
              Te = Ye;
            }
            Te && !(Te instanceof Error) && (Pe(Ot), P("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Qe || "React class", _e, oe, typeof Te), Pe(null)), Te instanceof Error && !(Te.message in pe) && (pe[Te.message] = !0, Pe(Ot), P("Failed %s type: %s", _e, Te.message), Pe(null));
          }
      }
    }
    var Ge = Array.isArray;
    function Ie(H) {
      return Ge(H);
    }
    function Dt(H) {
      {
        var Se = typeof Symbol == "function" && Symbol.toStringTag, _e = Se && H[Symbol.toStringTag] || H.constructor.name || "Object";
        return _e;
      }
    }
    function Re(H) {
      try {
        return $e(H), !1;
      } catch {
        return !0;
      }
    }
    function $e(H) {
      return "" + H;
    }
    function dt(H) {
      if (Re(H))
        return P("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Dt(H)), $e(H);
    }
    var He = O.ReactCurrentOwner, Je = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ze, nt;
    function Ne(H) {
      if (xe.call(H, "ref")) {
        var Se = Object.getOwnPropertyDescriptor(H, "ref").get;
        if (Se && Se.isReactWarning)
          return !1;
      }
      return H.ref !== void 0;
    }
    function Ct(H) {
      if (xe.call(H, "key")) {
        var Se = Object.getOwnPropertyDescriptor(H, "key").get;
        if (Se && Se.isReactWarning)
          return !1;
      }
      return H.key !== void 0;
    }
    function Rt(H, Se) {
      typeof H.ref == "string" && He.current;
    }
    function At(H, Se) {
      {
        var _e = function() {
          Ze || (Ze = !0, P("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Se));
        };
        _e.isReactWarning = !0, Object.defineProperty(H, "key", {
          get: _e,
          configurable: !0
        });
      }
    }
    function Xt(H, Se) {
      {
        var _e = function() {
          nt || (nt = !0, P("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Se));
        };
        _e.isReactWarning = !0, Object.defineProperty(H, "ref", {
          get: _e,
          configurable: !0
        });
      }
    }
    var je = function(H, Se, _e, Qe, Ot, fe, oe) {
      var Te = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: H,
        key: Se,
        ref: _e,
        props: oe,
        // Record the component responsible for creating this element.
        _owner: fe
      };
      return Te._store = {}, Object.defineProperty(Te._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Te, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Qe
      }), Object.defineProperty(Te, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ot
      }), Object.freeze && (Object.freeze(Te.props), Object.freeze(Te)), Te;
    };
    function ot(H, Se, _e, Qe, Ot) {
      {
        var fe, oe = {}, Te = null, Ke = null;
        _e !== void 0 && (dt(_e), Te = "" + _e), Ct(Se) && (dt(Se.key), Te = "" + Se.key), Ne(Se) && (Ke = Se.ref, Rt(Se, Ot));
        for (fe in Se)
          xe.call(Se, fe) && !Je.hasOwnProperty(fe) && (oe[fe] = Se[fe]);
        if (H && H.defaultProps) {
          var Ye = H.defaultProps;
          for (fe in Ye)
            oe[fe] === void 0 && (oe[fe] = Ye[fe]);
        }
        if (Te || Ke) {
          var tt = typeof H == "function" ? H.displayName || H.name || "Unknown" : H;
          Te && At(oe, tt), Ke && Xt(oe, tt);
        }
        return je(H, Te, Ke, Ot, Qe, He.current, oe);
      }
    }
    var vt = O.ReactCurrentOwner, gt = O.ReactDebugCurrentFrame;
    function kt(H) {
      if (H) {
        var Se = H._owner, _e = ge(H.type, H._source, Se ? Se.type : null);
        gt.setExtraStackFrame(_e);
      } else
        gt.setExtraStackFrame(null);
    }
    var xn;
    xn = !1;
    function on(H) {
      return typeof H == "object" && H !== null && H.$$typeof === t;
    }
    function br() {
      {
        if (vt.current) {
          var H = W(vt.current.type);
          if (H)
            return `

Check the render method of \`` + H + "`.";
        }
        return "";
      }
    }
    function Un(H) {
      return "";
    }
    var no = {};
    function mo(H) {
      {
        var Se = br();
        if (!Se) {
          var _e = typeof H == "string" ? H : H.displayName || H.name;
          _e && (Se = `

Check the top-level render call using <` + _e + ">.");
        }
        return Se;
      }
    }
    function et(H, Se) {
      {
        if (!H._store || H._store.validated || H.key != null)
          return;
        H._store.validated = !0;
        var _e = mo(Se);
        if (no[_e])
          return;
        no[_e] = !0;
        var Qe = "";
        H && H._owner && H._owner !== vt.current && (Qe = " It was passed a child from " + W(H._owner.type) + "."), kt(H), P('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', _e, Qe), kt(null);
      }
    }
    function jn(H, Se) {
      {
        if (typeof H != "object")
          return;
        if (Ie(H))
          for (var _e = 0; _e < H.length; _e++) {
            var Qe = H[_e];
            on(Qe) && et(Qe, Se);
          }
        else if (on(H))
          H._store && (H._store.validated = !0);
        else if (H) {
          var Ot = S(H);
          if (typeof Ot == "function" && Ot !== H.entries)
            for (var fe = Ot.call(H), oe; !(oe = fe.next()).done; )
              on(oe.value) && et(oe.value, Se);
        }
      }
    }
    function ho(H) {
      {
        var Se = H.type;
        if (Se == null || typeof Se == "string")
          return;
        var _e;
        if (typeof Se == "function")
          _e = Se.propTypes;
        else if (typeof Se == "object" && (Se.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Se.$$typeof === h))
          _e = Se.propTypes;
        else
          return;
        if (_e) {
          var Qe = W(Se);
          Be(_e, H.props, "prop", Qe, H);
        } else if (Se.PropTypes !== void 0 && !xn) {
          xn = !0;
          var Ot = W(Se);
          P("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Ot || "Unknown");
        }
        typeof Se.getDefaultProps == "function" && !Se.getDefaultProps.isReactClassApproved && P("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ro(H) {
      {
        for (var Se = Object.keys(H.props), _e = 0; _e < Se.length; _e++) {
          var Qe = Se[_e];
          if (Qe !== "children" && Qe !== "key") {
            kt(H), P("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Qe), kt(null);
            break;
          }
        }
        H.ref !== null && (kt(H), P("Invalid attribute `ref` supplied to `React.Fragment`."), kt(null));
      }
    }
    var $r = {};
    function go(H, Se, _e, Qe, Ot, fe) {
      {
        var oe = T(H);
        if (!oe) {
          var Te = "";
          (H === void 0 || typeof H == "object" && H !== null && Object.keys(H).length === 0) && (Te += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Ke = Un();
          Ke ? Te += Ke : Te += br();
          var Ye;
          H === null ? Ye = "null" : Ie(H) ? Ye = "array" : H !== void 0 && H.$$typeof === t ? (Ye = "<" + (W(H.type) || "Unknown") + " />", Te = " Did you accidentally export a JSX literal instead of a component?") : Ye = typeof H, P("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ye, Te);
        }
        var tt = ot(H, Se, _e, Ot, fe);
        if (tt == null)
          return tt;
        if (oe) {
          var Mt = Se.children;
          if (Mt !== void 0)
            if (Qe)
              if (Ie(Mt)) {
                for (var Jt = 0; Jt < Mt.length; Jt++)
                  jn(Mt[Jt], H);
                Object.freeze && Object.freeze(Mt);
              } else
                P("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jn(Mt, H);
        }
        if (xe.call(Se, "key")) {
          var Jn = W(H), kn = Object.keys(Se).filter(function(ui) {
            return ui !== "key";
          }), li = kn.length > 0 ? "{key: someKey, " + kn.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!$r[Jn + li]) {
            var ci = kn.length > 0 ? "{" + kn.join(": ..., ") + ": ...}" : "{}";
            P(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, li, Jn, ci, Jn), $r[Jn + li] = !0;
          }
        }
        return H === r ? ro(tt) : ho(tt), tt;
      }
    }
    function Ao(H, Se, _e) {
      return go(H, Se, _e, !0);
    }
    function Li(H, Se, _e) {
      return go(H, Se, _e, !1);
    }
    var Bi = Li, Vi = Ao;
    Is.Fragment = r, Is.jsx = Bi, Is.jsxs = Vi;
  }()), Is;
}
var ov;
function WM() {
  return ov || (ov = 1, process.env.NODE_ENV === "production" ? Ac.exports = VM() : Ac.exports = zM()), Ac.exports;
}
var x = WM();
function _o(e, ...t) {
  const n = new URL(`https://mui.com/production-error/?code=${e}`);
  return t.forEach((r) => n.searchParams.append("args[]", r)), `Minified MUI error #${e}; visit ${n} for the full message.`;
}
const Gr = "$$material";
function J() {
  return J = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, J.apply(null, arguments);
}
function qM(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function HM(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var UM = /* @__PURE__ */ function() {
  function e(n) {
    var r = this;
    this._insertTag = function(i) {
      var a;
      r.tags.length === 0 ? r.insertionPoint ? a = r.insertionPoint.nextSibling : r.prepend ? a = r.container.firstChild : a = r.before : a = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(i, a), r.tags.push(i);
    }, this.isSpeedy = n.speedy === void 0 ? !0 : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(r) {
    r.forEach(this._insertTag);
  }, t.insert = function(r) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(HM(this));
    var i = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var a = qM(i);
      try {
        a.insertRule(r, a.cssRules.length);
      } catch {
      }
    } else
      i.appendChild(document.createTextNode(r));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(r) {
      var i;
      return (i = r.parentNode) == null ? void 0 : i.removeChild(r);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), Kn = "-ms-", yu = "-moz-", Lt = "-webkit-", Z0 = "comm", nh = "rule", rh = "decl", YM = "@import", J0 = "@keyframes", GM = "@layer", KM = Math.abs, Wu = String.fromCharCode, XM = Object.assign;
function QM(e, t) {
  return Wn(e, 0) ^ 45 ? (((t << 2 ^ Wn(e, 0)) << 2 ^ Wn(e, 1)) << 2 ^ Wn(e, 2)) << 2 ^ Wn(e, 3) : 0;
}
function e1(e) {
  return e.trim();
}
function ZM(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function Bt(e, t, n) {
  return e.replace(t, n);
}
function Tm(e, t) {
  return e.indexOf(t);
}
function Wn(e, t) {
  return e.charCodeAt(t) | 0;
}
function ll(e, t, n) {
  return e.slice(t, n);
}
function So(e) {
  return e.length;
}
function oh(e) {
  return e.length;
}
function Nc(e, t) {
  return t.push(e), e;
}
function JM(e, t) {
  return e.map(t).join("");
}
var qu = 1, Za = 1, t1 = 0, yr = 0, $n = 0, ls = "";
function Hu(e, t, n, r, i, a, l) {
  return { value: e, root: t, parent: n, type: r, props: i, children: a, line: qu, column: Za, length: l, return: "" };
}
function js(e, t) {
  return XM(Hu("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function e_() {
  return $n;
}
function t_() {
  return $n = yr > 0 ? Wn(ls, --yr) : 0, Za--, $n === 10 && (Za = 1, qu--), $n;
}
function Dr() {
  return $n = yr < t1 ? Wn(ls, yr++) : 0, Za++, $n === 10 && (Za = 1, qu++), $n;
}
function Po() {
  return Wn(ls, yr);
}
function au() {
  return yr;
}
function kl(e, t) {
  return ll(ls, e, t);
}
function cl(e) {
  switch (e) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function n1(e) {
  return qu = Za = 1, t1 = So(ls = e), yr = 0, [];
}
function r1(e) {
  return ls = "", e;
}
function su(e) {
  return e1(kl(yr - 1, Em(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function n_(e) {
  for (; ($n = Po()) && $n < 33; )
    Dr();
  return cl(e) > 2 || cl($n) > 3 ? "" : " ";
}
function r_(e, t) {
  for (; --t && Dr() && !($n < 48 || $n > 102 || $n > 57 && $n < 65 || $n > 70 && $n < 97); )
    ;
  return kl(e, au() + (t < 6 && Po() == 32 && Dr() == 32));
}
function Em(e) {
  for (; Dr(); )
    switch ($n) {
      // ] ) " '
      case e:
        return yr;
      // " '
      case 34:
      case 39:
        e !== 34 && e !== 39 && Em($n);
        break;
      // (
      case 40:
        e === 41 && Em(e);
        break;
      // \
      case 92:
        Dr();
        break;
    }
  return yr;
}
function o_(e, t) {
  for (; Dr() && e + $n !== 57; )
    if (e + $n === 84 && Po() === 47)
      break;
  return "/*" + kl(t, yr - 1) + "*" + Wu(e === 47 ? e : Dr());
}
function i_(e) {
  for (; !cl(Po()); )
    Dr();
  return kl(e, yr);
}
function a_(e) {
  return r1(lu("", null, null, null, [""], e = n1(e), 0, [0], e));
}
function lu(e, t, n, r, i, a, l, u, d) {
  for (var p = 0, m = 0, h = l, g = 0, v = 0, b = 0, y = 1, S = 1, O = 1, P = 0, k = "", R = i, E = a, M = r, _ = k; S; )
    switch (b = P, P = Dr()) {
      // (
      case 40:
        if (b != 108 && Wn(_, h - 1) == 58) {
          Tm(_ += Bt(su(P), "&", "&\f"), "&\f") != -1 && (O = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        _ += su(P);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        _ += n_(b);
        break;
      // \
      case 92:
        _ += r_(au() - 1, 7);
        continue;
      // /
      case 47:
        switch (Po()) {
          case 42:
          case 47:
            Nc(s_(o_(Dr(), au()), t, n), d);
            break;
          default:
            _ += "/";
        }
        break;
      // {
      case 123 * y:
        u[p++] = So(_) * O;
      // } ; \0
      case 125 * y:
      case 59:
      case 0:
        switch (P) {
          // \0 }
          case 0:
          case 125:
            S = 0;
          // ;
          case 59 + m:
            O == -1 && (_ = Bt(_, /\f/g, "")), v > 0 && So(_) - h && Nc(v > 32 ? av(_ + ";", r, n, h - 1) : av(Bt(_, " ", "") + ";", r, n, h - 2), d);
            break;
          // @ ;
          case 59:
            _ += ";";
          // { rule/at-rule
          default:
            if (Nc(M = iv(_, t, n, p, m, i, u, k, R = [], E = [], h), a), P === 123)
              if (m === 0)
                lu(_, t, M, M, R, a, h, u, E);
              else
                switch (g === 99 && Wn(_, 3) === 110 ? 100 : g) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    lu(e, M, M, r && Nc(iv(e, M, M, 0, 0, i, u, k, i, R = [], h), E), i, E, h, u, r ? R : E);
                    break;
                  default:
                    lu(_, M, M, M, [""], E, 0, u, E);
                }
        }
        p = m = v = 0, y = O = 1, k = _ = "", h = l;
        break;
      // :
      case 58:
        h = 1 + So(_), v = b;
      default:
        if (y < 1) {
          if (P == 123)
            --y;
          else if (P == 125 && y++ == 0 && t_() == 125)
            continue;
        }
        switch (_ += Wu(P), P * y) {
          // &
          case 38:
            O = m > 0 ? 1 : (_ += "\f", -1);
            break;
          // ,
          case 44:
            u[p++] = (So(_) - 1) * O, O = 1;
            break;
          // @
          case 64:
            Po() === 45 && (_ += su(Dr())), g = Po(), m = h = So(k = _ += i_(au())), P++;
            break;
          // -
          case 45:
            b === 45 && So(_) == 2 && (y = 0);
        }
    }
  return a;
}
function iv(e, t, n, r, i, a, l, u, d, p, m) {
  for (var h = i - 1, g = i === 0 ? a : [""], v = oh(g), b = 0, y = 0, S = 0; b < r; ++b)
    for (var O = 0, P = ll(e, h + 1, h = KM(y = l[b])), k = e; O < v; ++O)
      (k = e1(y > 0 ? g[O] + " " + P : Bt(P, /&\f/g, g[O]))) && (d[S++] = k);
  return Hu(e, t, n, i === 0 ? nh : u, d, p, m);
}
function s_(e, t, n) {
  return Hu(e, t, n, Z0, Wu(e_()), ll(e, 2, -2), 0);
}
function av(e, t, n, r) {
  return Hu(e, t, n, rh, ll(e, 0, r), ll(e, r + 1, -1), r);
}
function qa(e, t) {
  for (var n = "", r = oh(e), i = 0; i < r; i++)
    n += t(e[i], i, e, t) || "";
  return n;
}
function l_(e, t, n, r) {
  switch (e.type) {
    case GM:
      if (e.children.length) break;
    case YM:
    case rh:
      return e.return = e.return || e.value;
    case Z0:
      return "";
    case J0:
      return e.return = e.value + "{" + qa(e.children, r) + "}";
    case nh:
      e.value = e.props.join(",");
  }
  return So(n = qa(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function c_(e) {
  var t = oh(e);
  return function(n, r, i, a) {
    for (var l = "", u = 0; u < t; u++)
      l += e[u](n, r, i, a) || "";
    return l;
  };
}
function u_(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function o1(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var d_ = function(t, n, r) {
  for (var i = 0, a = 0; i = a, a = Po(), i === 38 && a === 12 && (n[r] = 1), !cl(a); )
    Dr();
  return kl(t, yr);
}, p_ = function(t, n) {
  var r = -1, i = 44;
  do
    switch (cl(i)) {
      case 0:
        i === 38 && Po() === 12 && (n[r] = 1), t[r] += d_(yr - 1, n, r);
        break;
      case 2:
        t[r] += su(i);
        break;
      case 4:
        if (i === 44) {
          t[++r] = Po() === 58 ? "&\f" : "", n[r] = t[r].length;
          break;
        }
      // fallthrough
      default:
        t[r] += Wu(i);
    }
  while (i = Dr());
  return t;
}, f_ = function(t, n) {
  return r1(p_(n1(t), n));
}, sv = /* @__PURE__ */ new WeakMap(), m_ = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, r = t.parent, i = t.column === r.column && t.line === r.line; r.type !== "rule"; )
      if (r = r.parent, !r) return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !sv.get(r)) && !i) {
      sv.set(t, !0);
      for (var a = [], l = f_(n, a), u = r.props, d = 0, p = 0; d < l.length; d++)
        for (var m = 0; m < u.length; m++, p++)
          t.props[p] = a[d] ? l[d].replace(/&\f/g, u[m]) : u[m] + " " + l[d];
    }
  }
}, h_ = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function i1(e, t) {
  switch (QM(e, t)) {
    // color-adjust
    case 5103:
      return Lt + "print-" + e + e;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Lt + e + e;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Lt + e + yu + e + Kn + e + e;
    // flex, flex-direction
    case 6828:
    case 4268:
      return Lt + e + Kn + e + e;
    // order
    case 6165:
      return Lt + e + Kn + "flex-" + e + e;
    // align-items
    case 5187:
      return Lt + e + Bt(e, /(\w+).+(:[^]+)/, Lt + "box-$1$2" + Kn + "flex-$1$2") + e;
    // align-self
    case 5443:
      return Lt + e + Kn + "flex-item-" + Bt(e, /flex-|-self/, "") + e;
    // align-content
    case 4675:
      return Lt + e + Kn + "flex-line-pack" + Bt(e, /align-content|flex-|-self/, "") + e;
    // flex-shrink
    case 5548:
      return Lt + e + Kn + Bt(e, "shrink", "negative") + e;
    // flex-basis
    case 5292:
      return Lt + e + Kn + Bt(e, "basis", "preferred-size") + e;
    // flex-grow
    case 6060:
      return Lt + "box-" + Bt(e, "-grow", "") + Lt + e + Kn + Bt(e, "grow", "positive") + e;
    // transition
    case 4554:
      return Lt + Bt(e, /([^-])(transform)/g, "$1" + Lt + "$2") + e;
    // cursor
    case 6187:
      return Bt(Bt(Bt(e, /(zoom-|grab)/, Lt + "$1"), /(image-set)/, Lt + "$1"), e, "") + e;
    // background, background-image
    case 5495:
    case 3959:
      return Bt(e, /(image-set\([^]*)/, Lt + "$1$`$1");
    // justify-content
    case 4968:
      return Bt(Bt(e, /(.+:)(flex-)?(.*)/, Lt + "box-pack:$3" + Kn + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Lt + e + e;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Bt(e, /(.+)-inline(.+)/, Lt + "$1$2") + e;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (So(e) - 1 - t > 6) switch (Wn(e, t + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          if (Wn(e, t + 4) !== 45) break;
        // (f)ill-available, (f)it-content
        case 102:
          return Bt(e, /(.+:)(.+)-([^]+)/, "$1" + Lt + "$2-$3$1" + yu + (Wn(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        // (s)tretch
        case 115:
          return ~Tm(e, "stretch") ? i1(Bt(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    // position: sticky
    case 4949:
      if (Wn(e, t + 1) !== 115) break;
    // display: (flex|inline-flex)
    case 6444:
      switch (Wn(e, So(e) - 3 - (~Tm(e, "!important") && 10))) {
        // stic(k)y
        case 107:
          return Bt(e, ":", ":" + Lt) + e;
        // (inline-)?fl(e)x
        case 101:
          return Bt(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Lt + (Wn(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Lt + "$2$3$1" + Kn + "$2box$3") + e;
      }
      break;
    // writing-mode
    case 5936:
      switch (Wn(e, t + 11)) {
        // vertical-l(r)
        case 114:
          return Lt + e + Kn + Bt(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        // vertical-r(l)
        case 108:
          return Lt + e + Kn + Bt(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        // horizontal(-)tb
        case 45:
          return Lt + e + Kn + Bt(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return Lt + e + Kn + e + e;
  }
  return e;
}
var g_ = function(t, n, r, i) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case rh:
      t.return = i1(t.value, t.length);
      break;
    case J0:
      return qa([js(t, {
        value: Bt(t.value, "@", "@" + Lt)
      })], i);
    case nh:
      if (t.length) return JM(t.props, function(a) {
        switch (ZM(a, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ":read-only":
          case ":read-write":
            return qa([js(t, {
              props: [Bt(a, /:(read-\w+)/, ":" + yu + "$1")]
            })], i);
          // :placeholder
          case "::placeholder":
            return qa([js(t, {
              props: [Bt(a, /:(plac\w+)/, ":" + Lt + "input-$1")]
            }), js(t, {
              props: [Bt(a, /:(plac\w+)/, ":" + yu + "$1")]
            }), js(t, {
              props: [Bt(a, /:(plac\w+)/, Kn + "input-$1")]
            })], i);
        }
        return "";
      });
  }
}, y_ = [g_], b_ = function(t) {
  var n = t.key;
  if (n === "css") {
    var r = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(r, function(y) {
      var S = y.getAttribute("data-emotion");
      S.indexOf(" ") !== -1 && (document.head.appendChild(y), y.setAttribute("data-s", ""));
    });
  }
  var i = t.stylisPlugins || y_, a = {}, l, u = [];
  l = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(y) {
      for (var S = y.getAttribute("data-emotion").split(" "), O = 1; O < S.length; O++)
        a[S[O]] = !0;
      u.push(y);
    }
  );
  var d, p = [m_, h_];
  {
    var m, h = [l_, u_(function(y) {
      m.insert(y);
    })], g = c_(p.concat(i, h)), v = function(S) {
      return qa(a_(S), g);
    };
    d = function(S, O, P, k) {
      m = P, v(S ? S + "{" + O.styles + "}" : O.styles), k && (b.inserted[O.name] = !0);
    };
  }
  var b = {
    key: n,
    sheet: new UM({
      key: n,
      container: l,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: a,
    registered: {},
    insert: d
  };
  return b.sheet.hydrate(u), b;
}, Fc = { exports: {} }, Wt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lv;
function v_() {
  if (lv) return Wt;
  lv = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, m = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, v = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, y = e ? Symbol.for("react.block") : 60121, S = e ? Symbol.for("react.fundamental") : 60117, O = e ? Symbol.for("react.responder") : 60118, P = e ? Symbol.for("react.scope") : 60119;
  function k(E) {
    if (typeof E == "object" && E !== null) {
      var M = E.$$typeof;
      switch (M) {
        case t:
          switch (E = E.type, E) {
            case d:
            case p:
            case r:
            case a:
            case i:
            case h:
              return E;
            default:
              switch (E = E && E.$$typeof, E) {
                case u:
                case m:
                case b:
                case v:
                case l:
                  return E;
                default:
                  return M;
              }
          }
        case n:
          return M;
      }
    }
  }
  function R(E) {
    return k(E) === p;
  }
  return Wt.AsyncMode = d, Wt.ConcurrentMode = p, Wt.ContextConsumer = u, Wt.ContextProvider = l, Wt.Element = t, Wt.ForwardRef = m, Wt.Fragment = r, Wt.Lazy = b, Wt.Memo = v, Wt.Portal = n, Wt.Profiler = a, Wt.StrictMode = i, Wt.Suspense = h, Wt.isAsyncMode = function(E) {
    return R(E) || k(E) === d;
  }, Wt.isConcurrentMode = R, Wt.isContextConsumer = function(E) {
    return k(E) === u;
  }, Wt.isContextProvider = function(E) {
    return k(E) === l;
  }, Wt.isElement = function(E) {
    return typeof E == "object" && E !== null && E.$$typeof === t;
  }, Wt.isForwardRef = function(E) {
    return k(E) === m;
  }, Wt.isFragment = function(E) {
    return k(E) === r;
  }, Wt.isLazy = function(E) {
    return k(E) === b;
  }, Wt.isMemo = function(E) {
    return k(E) === v;
  }, Wt.isPortal = function(E) {
    return k(E) === n;
  }, Wt.isProfiler = function(E) {
    return k(E) === a;
  }, Wt.isStrictMode = function(E) {
    return k(E) === i;
  }, Wt.isSuspense = function(E) {
    return k(E) === h;
  }, Wt.isValidElementType = function(E) {
    return typeof E == "string" || typeof E == "function" || E === r || E === p || E === a || E === i || E === h || E === g || typeof E == "object" && E !== null && (E.$$typeof === b || E.$$typeof === v || E.$$typeof === l || E.$$typeof === u || E.$$typeof === m || E.$$typeof === S || E.$$typeof === O || E.$$typeof === P || E.$$typeof === y);
  }, Wt.typeOf = k, Wt;
}
var qt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cv;
function x_() {
  return cv || (cv = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, m = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, v = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, y = e ? Symbol.for("react.block") : 60121, S = e ? Symbol.for("react.fundamental") : 60117, O = e ? Symbol.for("react.responder") : 60118, P = e ? Symbol.for("react.scope") : 60119;
    function k(B) {
      return typeof B == "string" || typeof B == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      B === r || B === p || B === a || B === i || B === h || B === g || typeof B == "object" && B !== null && (B.$$typeof === b || B.$$typeof === v || B.$$typeof === l || B.$$typeof === u || B.$$typeof === m || B.$$typeof === S || B.$$typeof === O || B.$$typeof === P || B.$$typeof === y);
    }
    function R(B) {
      if (typeof B == "object" && B !== null) {
        var ee = B.$$typeof;
        switch (ee) {
          case t:
            var ie = B.type;
            switch (ie) {
              case d:
              case p:
              case r:
              case a:
              case i:
              case h:
                return ie;
              default:
                var ge = ie && ie.$$typeof;
                switch (ge) {
                  case u:
                  case m:
                  case b:
                  case v:
                  case l:
                    return ge;
                  default:
                    return ee;
                }
            }
          case n:
            return ee;
        }
      }
    }
    var E = d, M = p, _ = u, I = l, F = t, T = m, $ = r, N = b, W = v, L = n, V = a, z = i, X = h, le = !1;
    function ne(B) {
      return le || (le = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), G(B) || R(B) === d;
    }
    function G(B) {
      return R(B) === p;
    }
    function Q(B) {
      return R(B) === u;
    }
    function be(B) {
      return R(B) === l;
    }
    function we(B) {
      return typeof B == "object" && B !== null && B.$$typeof === t;
    }
    function se(B) {
      return R(B) === m;
    }
    function U(B) {
      return R(B) === r;
    }
    function de(B) {
      return R(B) === b;
    }
    function ce(B) {
      return R(B) === v;
    }
    function K(B) {
      return R(B) === n;
    }
    function Z(B) {
      return R(B) === a;
    }
    function ue(B) {
      return R(B) === i;
    }
    function he(B) {
      return R(B) === h;
    }
    qt.AsyncMode = E, qt.ConcurrentMode = M, qt.ContextConsumer = _, qt.ContextProvider = I, qt.Element = F, qt.ForwardRef = T, qt.Fragment = $, qt.Lazy = N, qt.Memo = W, qt.Portal = L, qt.Profiler = V, qt.StrictMode = z, qt.Suspense = X, qt.isAsyncMode = ne, qt.isConcurrentMode = G, qt.isContextConsumer = Q, qt.isContextProvider = be, qt.isElement = we, qt.isForwardRef = se, qt.isFragment = U, qt.isLazy = de, qt.isMemo = ce, qt.isPortal = K, qt.isProfiler = Z, qt.isStrictMode = ue, qt.isSuspense = he, qt.isValidElementType = k, qt.typeOf = R;
  }()), qt;
}
var uv;
function w_() {
  return uv || (uv = 1, process.env.NODE_ENV === "production" ? Fc.exports = v_() : Fc.exports = x_()), Fc.exports;
}
var Zp, dv;
function C_() {
  if (dv) return Zp;
  dv = 1;
  var e = w_(), t = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, n = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, r = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, i = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, a = {};
  a[e.ForwardRef] = r, a[e.Memo] = i;
  function l(b) {
    return e.isMemo(b) ? i : a[b.$$typeof] || t;
  }
  var u = Object.defineProperty, d = Object.getOwnPropertyNames, p = Object.getOwnPropertySymbols, m = Object.getOwnPropertyDescriptor, h = Object.getPrototypeOf, g = Object.prototype;
  function v(b, y, S) {
    if (typeof y != "string") {
      if (g) {
        var O = h(y);
        O && O !== g && v(b, O, S);
      }
      var P = d(y);
      p && (P = P.concat(p(y)));
      for (var k = l(b), R = l(y), E = 0; E < P.length; ++E) {
        var M = P[E];
        if (!n[M] && !(S && S[M]) && !(R && R[M]) && !(k && k[M])) {
          var _ = m(y, M);
          try {
            u(b, M, _);
          } catch {
          }
        }
      }
    }
    return b;
  }
  return Zp = v, Zp;
}
C_();
var S_ = !0;
function a1(e, t, n) {
  var r = "";
  return n.split(" ").forEach(function(i) {
    e[i] !== void 0 ? t.push(e[i] + ";") : i && (r += i + " ");
  }), r;
}
var ih = function(t, n, r) {
  var i = t.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (r === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  S_ === !1) && t.registered[i] === void 0 && (t.registered[i] = n.styles);
}, ah = function(t, n, r) {
  ih(t, n, r);
  var i = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var a = n;
    do
      t.insert(n === a ? "." + i : "", a, t.sheet, !0), a = a.next;
    while (a !== void 0);
  }
};
function O_(e) {
  for (var t = 0, n, r = 0, i = e.length; i >= 4; ++r, i -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (i) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var T_ = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, E_ = /[A-Z]|^ms/g, R_ = /_EMO_([^_]+?)_([^]*?)_EMO_/g, s1 = function(t) {
  return t.charCodeAt(1) === 45;
}, pv = function(t) {
  return t != null && typeof t != "boolean";
}, Jp = /* @__PURE__ */ o1(function(e) {
  return s1(e) ? e : e.replace(E_, "-$&").toLowerCase();
}), fv = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(R_, function(r, i, a) {
          return Oo = {
            name: i,
            styles: a,
            next: Oo
          }, i;
        });
  }
  return T_[t] !== 1 && !s1(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
function ul(e, t, n) {
  if (n == null)
    return "";
  var r = n;
  if (r.__emotion_styles !== void 0)
    return r;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var i = n;
      if (i.anim === 1)
        return Oo = {
          name: i.name,
          styles: i.styles,
          next: Oo
        }, i.name;
      var a = n;
      if (a.styles !== void 0) {
        var l = a.next;
        if (l !== void 0)
          for (; l !== void 0; )
            Oo = {
              name: l.name,
              styles: l.styles,
              next: Oo
            }, l = l.next;
        var u = a.styles + ";";
        return u;
      }
      return k_(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var d = Oo, p = n(e);
        return Oo = d, ul(e, t, p);
      }
      break;
    }
  }
  var m = n;
  if (t == null)
    return m;
  var h = t[m];
  return h !== void 0 ? h : m;
}
function k_(e, t, n) {
  var r = "";
  if (Array.isArray(n))
    for (var i = 0; i < n.length; i++)
      r += ul(e, t, n[i]) + ";";
  else
    for (var a in n) {
      var l = n[a];
      if (typeof l != "object") {
        var u = l;
        t != null && t[u] !== void 0 ? r += a + "{" + t[u] + "}" : pv(u) && (r += Jp(a) + ":" + fv(a, u) + ";");
      } else if (Array.isArray(l) && typeof l[0] == "string" && (t == null || t[l[0]] === void 0))
        for (var d = 0; d < l.length; d++)
          pv(l[d]) && (r += Jp(a) + ":" + fv(a, l[d]) + ";");
      else {
        var p = ul(e, t, l);
        switch (a) {
          case "animation":
          case "animationName": {
            r += Jp(a) + ":" + p + ";";
            break;
          }
          default:
            r += a + "{" + p + "}";
        }
      }
    }
  return r;
}
var mv = /label:\s*([^\s;{]+)\s*(;|$)/g, Oo;
function Pl(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var r = !0, i = "";
  Oo = void 0;
  var a = e[0];
  if (a == null || a.raw === void 0)
    r = !1, i += ul(n, t, a);
  else {
    var l = a;
    i += l[0];
  }
  for (var u = 1; u < e.length; u++)
    if (i += ul(n, t, e[u]), r) {
      var d = a;
      i += d[u];
    }
  mv.lastIndex = 0;
  for (var p = "", m; (m = mv.exec(i)) !== null; )
    p += "-" + m[1];
  var h = O_(i) + p;
  return {
    name: h,
    styles: i,
    next: Oo
  };
}
var P_ = function(t) {
  return t();
}, l1 = w.useInsertionEffect ? w.useInsertionEffect : !1, c1 = l1 || P_, hv = l1 || w.useLayoutEffect, u1 = /* @__PURE__ */ w.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ b_({
    key: "css"
  }) : null
);
u1.Provider;
var sh = function(t) {
  return /* @__PURE__ */ El(function(n, r) {
    var i = Qa(u1);
    return t(n, i, r);
  });
}, Dl = /* @__PURE__ */ w.createContext({}), lh = {}.hasOwnProperty, Rm = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", D_ = function(t, n) {
  var r = {};
  for (var i in n)
    lh.call(n, i) && (r[i] = n[i]);
  return r[Rm] = t, r;
}, M_ = function(t) {
  var n = t.cache, r = t.serialized, i = t.isStringTag;
  return ih(n, r, i), c1(function() {
    return ah(n, r, i);
  }), null;
}, __ = /* @__PURE__ */ sh(function(e, t, n) {
  var r = e.css;
  typeof r == "string" && t.registered[r] !== void 0 && (r = t.registered[r]);
  var i = e[Rm], a = [r], l = "";
  typeof e.className == "string" ? l = a1(t.registered, a, e.className) : e.className != null && (l = e.className + " ");
  var u = Pl(a, void 0, w.useContext(Dl));
  l += t.key + "-" + u.name;
  var d = {};
  for (var p in e)
    lh.call(e, p) && p !== "css" && p !== Rm && (d[p] = e[p]);
  return d.className = l, n && (d.ref = n), /* @__PURE__ */ w.createElement(w.Fragment, null, /* @__PURE__ */ w.createElement(M_, {
    cache: t,
    serialized: u,
    isStringTag: typeof i == "string"
  }), /* @__PURE__ */ w.createElement(i, d));
}), I_ = __, gv = function(t, n) {
  var r = arguments;
  if (n == null || !lh.call(n, "css"))
    return w.createElement.apply(void 0, r);
  var i = r.length, a = new Array(i);
  a[0] = I_, a[1] = D_(t, n);
  for (var l = 2; l < i; l++)
    a[l] = r[l];
  return w.createElement.apply(null, a);
};
(function(e) {
  var t;
  t || (t = e.JSX || (e.JSX = {}));
})(gv || (gv = {}));
var j_ = /* @__PURE__ */ sh(function(e, t) {
  var n = e.styles, r = Pl([n], void 0, w.useContext(Dl)), i = w.useRef();
  return hv(function() {
    var a = t.key + "-global", l = new t.sheet.constructor({
      key: a,
      nonce: t.sheet.nonce,
      container: t.sheet.container,
      speedy: t.sheet.isSpeedy
    }), u = !1, d = document.querySelector('style[data-emotion="' + a + " " + r.name + '"]');
    return t.sheet.tags.length && (l.before = t.sheet.tags[0]), d !== null && (u = !0, d.setAttribute("data-emotion", a), l.hydrate([d])), i.current = [l, u], function() {
      l.flush();
    };
  }, [t]), hv(function() {
    var a = i.current, l = a[0], u = a[1];
    if (u) {
      a[1] = !1;
      return;
    }
    if (r.next !== void 0 && ah(t, r.next, !0), l.tags.length) {
      var d = l.tags[l.tags.length - 1].nextElementSibling;
      l.before = d, l.flush();
    }
    t.insert("", r, l, !1);
  }, [t, r.name]), null;
});
function ch() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return Pl(t);
}
function Ml() {
  var e = ch.apply(void 0, arguments), t = "animation-" + e.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + e.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
var $_ = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, A_ = /* @__PURE__ */ o1(
  function(e) {
    return $_.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), N_ = A_, F_ = function(t) {
  return t !== "theme";
}, yv = function(t) {
  return typeof t == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  t.charCodeAt(0) > 96 ? N_ : F_;
}, bv = function(t, n, r) {
  var i;
  if (n) {
    var a = n.shouldForwardProp;
    i = t.__emotion_forwardProp && a ? function(l) {
      return t.__emotion_forwardProp(l) && a(l);
    } : a;
  }
  return typeof i != "function" && r && (i = t.__emotion_forwardProp), i;
}, L_ = function(t) {
  var n = t.cache, r = t.serialized, i = t.isStringTag;
  return ih(n, r, i), c1(function() {
    return ah(n, r, i);
  }), null;
}, B_ = function e(t, n) {
  var r = t.__emotion_real === t, i = r && t.__emotion_base || t, a, l;
  n !== void 0 && (a = n.label, l = n.target);
  var u = bv(t, n, r), d = u || yv(i), p = !d("as");
  return function() {
    var m = arguments, h = r && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (a !== void 0 && h.push("label:" + a + ";"), m[0] == null || m[0].raw === void 0)
      h.push.apply(h, m);
    else {
      var g = m[0];
      h.push(g[0]);
      for (var v = m.length, b = 1; b < v; b++)
        h.push(m[b], g[b]);
    }
    var y = sh(function(S, O, P) {
      var k = p && S.as || i, R = "", E = [], M = S;
      if (S.theme == null) {
        M = {};
        for (var _ in S)
          M[_] = S[_];
        M.theme = w.useContext(Dl);
      }
      typeof S.className == "string" ? R = a1(O.registered, E, S.className) : S.className != null && (R = S.className + " ");
      var I = Pl(h.concat(E), O.registered, M);
      R += O.key + "-" + I.name, l !== void 0 && (R += " " + l);
      var F = p && u === void 0 ? yv(k) : d, T = {};
      for (var $ in S)
        p && $ === "as" || F($) && (T[$] = S[$]);
      return T.className = R, P && (T.ref = P), /* @__PURE__ */ w.createElement(w.Fragment, null, /* @__PURE__ */ w.createElement(L_, {
        cache: O,
        serialized: I,
        isStringTag: typeof k == "string"
      }), /* @__PURE__ */ w.createElement(k, T));
    });
    return y.displayName = a !== void 0 ? a : "Styled(" + (typeof i == "string" ? i : i.displayName || i.name || "Component") + ")", y.defaultProps = t.defaultProps, y.__emotion_real = y, y.__emotion_base = i, y.__emotion_styles = h, y.__emotion_forwardProp = u, Object.defineProperty(y, "toString", {
      value: function() {
        return "." + l;
      }
    }), y.withComponent = function(S, O) {
      var P = e(S, J({}, n, O, {
        shouldForwardProp: bv(y, O, !0)
      }));
      return P.apply(void 0, h);
    }, y;
  };
}, V_ = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], km = B_.bind(null);
V_.forEach(function(e) {
  km[e] = km(e);
});
var Lc = { exports: {} }, Bc = { exports: {} }, Ht = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vv;
function z_() {
  if (vv) return Ht;
  vv = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, m = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, v = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, y = e ? Symbol.for("react.block") : 60121, S = e ? Symbol.for("react.fundamental") : 60117, O = e ? Symbol.for("react.responder") : 60118, P = e ? Symbol.for("react.scope") : 60119;
  function k(E) {
    if (typeof E == "object" && E !== null) {
      var M = E.$$typeof;
      switch (M) {
        case t:
          switch (E = E.type, E) {
            case d:
            case p:
            case r:
            case a:
            case i:
            case h:
              return E;
            default:
              switch (E = E && E.$$typeof, E) {
                case u:
                case m:
                case b:
                case v:
                case l:
                  return E;
                default:
                  return M;
              }
          }
        case n:
          return M;
      }
    }
  }
  function R(E) {
    return k(E) === p;
  }
  return Ht.AsyncMode = d, Ht.ConcurrentMode = p, Ht.ContextConsumer = u, Ht.ContextProvider = l, Ht.Element = t, Ht.ForwardRef = m, Ht.Fragment = r, Ht.Lazy = b, Ht.Memo = v, Ht.Portal = n, Ht.Profiler = a, Ht.StrictMode = i, Ht.Suspense = h, Ht.isAsyncMode = function(E) {
    return R(E) || k(E) === d;
  }, Ht.isConcurrentMode = R, Ht.isContextConsumer = function(E) {
    return k(E) === u;
  }, Ht.isContextProvider = function(E) {
    return k(E) === l;
  }, Ht.isElement = function(E) {
    return typeof E == "object" && E !== null && E.$$typeof === t;
  }, Ht.isForwardRef = function(E) {
    return k(E) === m;
  }, Ht.isFragment = function(E) {
    return k(E) === r;
  }, Ht.isLazy = function(E) {
    return k(E) === b;
  }, Ht.isMemo = function(E) {
    return k(E) === v;
  }, Ht.isPortal = function(E) {
    return k(E) === n;
  }, Ht.isProfiler = function(E) {
    return k(E) === a;
  }, Ht.isStrictMode = function(E) {
    return k(E) === i;
  }, Ht.isSuspense = function(E) {
    return k(E) === h;
  }, Ht.isValidElementType = function(E) {
    return typeof E == "string" || typeof E == "function" || E === r || E === p || E === a || E === i || E === h || E === g || typeof E == "object" && E !== null && (E.$$typeof === b || E.$$typeof === v || E.$$typeof === l || E.$$typeof === u || E.$$typeof === m || E.$$typeof === S || E.$$typeof === O || E.$$typeof === P || E.$$typeof === y);
  }, Ht.typeOf = k, Ht;
}
var Ut = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xv;
function W_() {
  return xv || (xv = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, m = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, v = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, y = e ? Symbol.for("react.block") : 60121, S = e ? Symbol.for("react.fundamental") : 60117, O = e ? Symbol.for("react.responder") : 60118, P = e ? Symbol.for("react.scope") : 60119;
    function k(B) {
      return typeof B == "string" || typeof B == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      B === r || B === p || B === a || B === i || B === h || B === g || typeof B == "object" && B !== null && (B.$$typeof === b || B.$$typeof === v || B.$$typeof === l || B.$$typeof === u || B.$$typeof === m || B.$$typeof === S || B.$$typeof === O || B.$$typeof === P || B.$$typeof === y);
    }
    function R(B) {
      if (typeof B == "object" && B !== null) {
        var ee = B.$$typeof;
        switch (ee) {
          case t:
            var ie = B.type;
            switch (ie) {
              case d:
              case p:
              case r:
              case a:
              case i:
              case h:
                return ie;
              default:
                var ge = ie && ie.$$typeof;
                switch (ge) {
                  case u:
                  case m:
                  case b:
                  case v:
                  case l:
                    return ge;
                  default:
                    return ee;
                }
            }
          case n:
            return ee;
        }
      }
    }
    var E = d, M = p, _ = u, I = l, F = t, T = m, $ = r, N = b, W = v, L = n, V = a, z = i, X = h, le = !1;
    function ne(B) {
      return le || (le = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), G(B) || R(B) === d;
    }
    function G(B) {
      return R(B) === p;
    }
    function Q(B) {
      return R(B) === u;
    }
    function be(B) {
      return R(B) === l;
    }
    function we(B) {
      return typeof B == "object" && B !== null && B.$$typeof === t;
    }
    function se(B) {
      return R(B) === m;
    }
    function U(B) {
      return R(B) === r;
    }
    function de(B) {
      return R(B) === b;
    }
    function ce(B) {
      return R(B) === v;
    }
    function K(B) {
      return R(B) === n;
    }
    function Z(B) {
      return R(B) === a;
    }
    function ue(B) {
      return R(B) === i;
    }
    function he(B) {
      return R(B) === h;
    }
    Ut.AsyncMode = E, Ut.ConcurrentMode = M, Ut.ContextConsumer = _, Ut.ContextProvider = I, Ut.Element = F, Ut.ForwardRef = T, Ut.Fragment = $, Ut.Lazy = N, Ut.Memo = W, Ut.Portal = L, Ut.Profiler = V, Ut.StrictMode = z, Ut.Suspense = X, Ut.isAsyncMode = ne, Ut.isConcurrentMode = G, Ut.isContextConsumer = Q, Ut.isContextProvider = be, Ut.isElement = we, Ut.isForwardRef = se, Ut.isFragment = U, Ut.isLazy = de, Ut.isMemo = ce, Ut.isPortal = K, Ut.isProfiler = Z, Ut.isStrictMode = ue, Ut.isSuspense = he, Ut.isValidElementType = k, Ut.typeOf = R;
  }()), Ut;
}
var wv;
function d1() {
  return wv || (wv = 1, process.env.NODE_ENV === "production" ? Bc.exports = z_() : Bc.exports = W_()), Bc.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var ef, Cv;
function q_() {
  if (Cv) return ef;
  Cv = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var l = {}, u = 0; u < 10; u++)
        l["_" + String.fromCharCode(u)] = u;
      var d = Object.getOwnPropertyNames(l).map(function(m) {
        return l[m];
      });
      if (d.join("") !== "0123456789")
        return !1;
      var p = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(m) {
        p[m] = m;
      }), Object.keys(Object.assign({}, p)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return ef = i() ? Object.assign : function(a, l) {
    for (var u, d = r(a), p, m = 1; m < arguments.length; m++) {
      u = Object(arguments[m]);
      for (var h in u)
        t.call(u, h) && (d[h] = u[h]);
      if (e) {
        p = e(u);
        for (var g = 0; g < p.length; g++)
          n.call(u, p[g]) && (d[p[g]] = u[p[g]]);
      }
    }
    return d;
  }, ef;
}
var tf, Sv;
function uh() {
  if (Sv) return tf;
  Sv = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return tf = e, tf;
}
var nf, Ov;
function p1() {
  return Ov || (Ov = 1, nf = Function.call.bind(Object.prototype.hasOwnProperty)), nf;
}
var rf, Tv;
function H_() {
  if (Tv) return rf;
  Tv = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ uh(), n = {}, r = /* @__PURE__ */ p1();
    e = function(a) {
      var l = "Warning: " + a;
      typeof console < "u" && console.error(l);
      try {
        throw new Error(l);
      } catch {
      }
    };
  }
  function i(a, l, u, d, p) {
    if (process.env.NODE_ENV !== "production") {
      for (var m in a)
        if (r(a, m)) {
          var h;
          try {
            if (typeof a[m] != "function") {
              var g = Error(
                (d || "React class") + ": " + u + " type `" + m + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[m] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw g.name = "Invariant Violation", g;
            }
            h = a[m](l, m, d, u, null, t);
          } catch (b) {
            h = b;
          }
          if (h && !(h instanceof Error) && e(
            (d || "React class") + ": type specification of " + u + " `" + m + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof h + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), h instanceof Error && !(h.message in n)) {
            n[h.message] = !0;
            var v = p ? p() : "";
            e(
              "Failed " + u + " type: " + h.message + (v ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, rf = i, rf;
}
var of, Ev;
function U_() {
  if (Ev) return of;
  Ev = 1;
  var e = d1(), t = q_(), n = /* @__PURE__ */ uh(), r = /* @__PURE__ */ p1(), i = /* @__PURE__ */ H_(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(u) {
    var d = "Warning: " + u;
    typeof console < "u" && console.error(d);
    try {
      throw new Error(d);
    } catch {
    }
  });
  function l() {
    return null;
  }
  return of = function(u, d) {
    var p = typeof Symbol == "function" && Symbol.iterator, m = "@@iterator";
    function h(G) {
      var Q = G && (p && G[p] || G[m]);
      if (typeof Q == "function")
        return Q;
    }
    var g = "<<anonymous>>", v = {
      array: O("array"),
      bigint: O("bigint"),
      bool: O("boolean"),
      func: O("function"),
      number: O("number"),
      object: O("object"),
      string: O("string"),
      symbol: O("symbol"),
      any: P(),
      arrayOf: k,
      element: R(),
      elementType: E(),
      instanceOf: M,
      node: T(),
      objectOf: I,
      oneOf: _,
      oneOfType: F,
      shape: N,
      exact: W
    };
    function b(G, Q) {
      return G === Q ? G !== 0 || 1 / G === 1 / Q : G !== G && Q !== Q;
    }
    function y(G, Q) {
      this.message = G, this.data = Q && typeof Q == "object" ? Q : {}, this.stack = "";
    }
    y.prototype = Error.prototype;
    function S(G) {
      if (process.env.NODE_ENV !== "production")
        var Q = {}, be = 0;
      function we(U, de, ce, K, Z, ue, he) {
        if (K = K || g, ue = ue || ce, he !== n) {
          if (d) {
            var B = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw B.name = "Invariant Violation", B;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ee = K + ":" + ce;
            !Q[ee] && // Avoid spamming the console because they are often not actionable except for lib authors
            be < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + ue + "` prop on `" + K + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), Q[ee] = !0, be++);
          }
        }
        return de[ce] == null ? U ? de[ce] === null ? new y("The " + Z + " `" + ue + "` is marked as required " + ("in `" + K + "`, but its value is `null`.")) : new y("The " + Z + " `" + ue + "` is marked as required in " + ("`" + K + "`, but its value is `undefined`.")) : null : G(de, ce, K, Z, ue);
      }
      var se = we.bind(null, !1);
      return se.isRequired = we.bind(null, !0), se;
    }
    function O(G) {
      function Q(be, we, se, U, de, ce) {
        var K = be[we], Z = z(K);
        if (Z !== G) {
          var ue = X(K);
          return new y(
            "Invalid " + U + " `" + de + "` of type " + ("`" + ue + "` supplied to `" + se + "`, expected ") + ("`" + G + "`."),
            { expectedType: G }
          );
        }
        return null;
      }
      return S(Q);
    }
    function P() {
      return S(l);
    }
    function k(G) {
      function Q(be, we, se, U, de) {
        if (typeof G != "function")
          return new y("Property `" + de + "` of component `" + se + "` has invalid PropType notation inside arrayOf.");
        var ce = be[we];
        if (!Array.isArray(ce)) {
          var K = z(ce);
          return new y("Invalid " + U + " `" + de + "` of type " + ("`" + K + "` supplied to `" + se + "`, expected an array."));
        }
        for (var Z = 0; Z < ce.length; Z++) {
          var ue = G(ce, Z, se, U, de + "[" + Z + "]", n);
          if (ue instanceof Error)
            return ue;
        }
        return null;
      }
      return S(Q);
    }
    function R() {
      function G(Q, be, we, se, U) {
        var de = Q[be];
        if (!u(de)) {
          var ce = z(de);
          return new y("Invalid " + se + " `" + U + "` of type " + ("`" + ce + "` supplied to `" + we + "`, expected a single ReactElement."));
        }
        return null;
      }
      return S(G);
    }
    function E() {
      function G(Q, be, we, se, U) {
        var de = Q[be];
        if (!e.isValidElementType(de)) {
          var ce = z(de);
          return new y("Invalid " + se + " `" + U + "` of type " + ("`" + ce + "` supplied to `" + we + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return S(G);
    }
    function M(G) {
      function Q(be, we, se, U, de) {
        if (!(be[we] instanceof G)) {
          var ce = G.name || g, K = ne(be[we]);
          return new y("Invalid " + U + " `" + de + "` of type " + ("`" + K + "` supplied to `" + se + "`, expected ") + ("instance of `" + ce + "`."));
        }
        return null;
      }
      return S(Q);
    }
    function _(G) {
      if (!Array.isArray(G))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), l;
      function Q(be, we, se, U, de) {
        for (var ce = be[we], K = 0; K < G.length; K++)
          if (b(ce, G[K]))
            return null;
        var Z = JSON.stringify(G, function(he, B) {
          var ee = X(B);
          return ee === "symbol" ? String(B) : B;
        });
        return new y("Invalid " + U + " `" + de + "` of value `" + String(ce) + "` " + ("supplied to `" + se + "`, expected one of " + Z + "."));
      }
      return S(Q);
    }
    function I(G) {
      function Q(be, we, se, U, de) {
        if (typeof G != "function")
          return new y("Property `" + de + "` of component `" + se + "` has invalid PropType notation inside objectOf.");
        var ce = be[we], K = z(ce);
        if (K !== "object")
          return new y("Invalid " + U + " `" + de + "` of type " + ("`" + K + "` supplied to `" + se + "`, expected an object."));
        for (var Z in ce)
          if (r(ce, Z)) {
            var ue = G(ce, Z, se, U, de + "." + Z, n);
            if (ue instanceof Error)
              return ue;
          }
        return null;
      }
      return S(Q);
    }
    function F(G) {
      if (!Array.isArray(G))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), l;
      for (var Q = 0; Q < G.length; Q++) {
        var be = G[Q];
        if (typeof be != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + le(be) + " at index " + Q + "."
          ), l;
      }
      function we(se, U, de, ce, K) {
        for (var Z = [], ue = 0; ue < G.length; ue++) {
          var he = G[ue], B = he(se, U, de, ce, K, n);
          if (B == null)
            return null;
          B.data && r(B.data, "expectedType") && Z.push(B.data.expectedType);
        }
        var ee = Z.length > 0 ? ", expected one of type [" + Z.join(", ") + "]" : "";
        return new y("Invalid " + ce + " `" + K + "` supplied to " + ("`" + de + "`" + ee + "."));
      }
      return S(we);
    }
    function T() {
      function G(Q, be, we, se, U) {
        return L(Q[be]) ? null : new y("Invalid " + se + " `" + U + "` supplied to " + ("`" + we + "`, expected a ReactNode."));
      }
      return S(G);
    }
    function $(G, Q, be, we, se) {
      return new y(
        (G || "React class") + ": " + Q + " type `" + be + "." + we + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + se + "`."
      );
    }
    function N(G) {
      function Q(be, we, se, U, de) {
        var ce = be[we], K = z(ce);
        if (K !== "object")
          return new y("Invalid " + U + " `" + de + "` of type `" + K + "` " + ("supplied to `" + se + "`, expected `object`."));
        for (var Z in G) {
          var ue = G[Z];
          if (typeof ue != "function")
            return $(se, U, de, Z, X(ue));
          var he = ue(ce, Z, se, U, de + "." + Z, n);
          if (he)
            return he;
        }
        return null;
      }
      return S(Q);
    }
    function W(G) {
      function Q(be, we, se, U, de) {
        var ce = be[we], K = z(ce);
        if (K !== "object")
          return new y("Invalid " + U + " `" + de + "` of type `" + K + "` " + ("supplied to `" + se + "`, expected `object`."));
        var Z = t({}, be[we], G);
        for (var ue in Z) {
          var he = G[ue];
          if (r(G, ue) && typeof he != "function")
            return $(se, U, de, ue, X(he));
          if (!he)
            return new y(
              "Invalid " + U + " `" + de + "` key `" + ue + "` supplied to `" + se + "`.\nBad object: " + JSON.stringify(be[we], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(G), null, "  ")
            );
          var B = he(ce, ue, se, U, de + "." + ue, n);
          if (B)
            return B;
        }
        return null;
      }
      return S(Q);
    }
    function L(G) {
      switch (typeof G) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !G;
        case "object":
          if (Array.isArray(G))
            return G.every(L);
          if (G === null || u(G))
            return !0;
          var Q = h(G);
          if (Q) {
            var be = Q.call(G), we;
            if (Q !== G.entries) {
              for (; !(we = be.next()).done; )
                if (!L(we.value))
                  return !1;
            } else
              for (; !(we = be.next()).done; ) {
                var se = we.value;
                if (se && !L(se[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function V(G, Q) {
      return G === "symbol" ? !0 : Q ? Q["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && Q instanceof Symbol : !1;
    }
    function z(G) {
      var Q = typeof G;
      return Array.isArray(G) ? "array" : G instanceof RegExp ? "object" : V(Q, G) ? "symbol" : Q;
    }
    function X(G) {
      if (typeof G > "u" || G === null)
        return "" + G;
      var Q = z(G);
      if (Q === "object") {
        if (G instanceof Date)
          return "date";
        if (G instanceof RegExp)
          return "regexp";
      }
      return Q;
    }
    function le(G) {
      var Q = X(G);
      switch (Q) {
        case "array":
        case "object":
          return "an " + Q;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + Q;
        default:
          return Q;
      }
    }
    function ne(G) {
      return !G.constructor || !G.constructor.name ? g : G.constructor.name;
    }
    return v.checkPropTypes = i, v.resetWarningCache = i.resetWarningCache, v.PropTypes = v, v;
  }, of;
}
var af, Rv;
function Y_() {
  if (Rv) return af;
  Rv = 1;
  var e = /* @__PURE__ */ uh();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, af = function() {
    function r(l, u, d, p, m, h) {
      if (h !== e) {
        var g = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw g.name = "Invariant Violation", g;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var a = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, af;
}
var kv;
function G_() {
  if (kv) return Lc.exports;
  if (kv = 1, process.env.NODE_ENV !== "production") {
    var e = d1(), t = !0;
    Lc.exports = /* @__PURE__ */ U_()(e.isElement, t);
  } else
    Lc.exports = /* @__PURE__ */ Y_()();
  return Lc.exports;
}
var K_ = /* @__PURE__ */ G_();
const o = /* @__PURE__ */ Rl(K_);
function X_(e) {
  return e == null || Object.keys(e).length === 0;
}
function dh(e) {
  const {
    styles: t,
    defaultTheme: n = {}
  } = e, r = typeof t == "function" ? (i) => t(X_(i) ? n : i) : t;
  return /* @__PURE__ */ x.jsx(j_, {
    styles: r
  });
}
process.env.NODE_ENV !== "production" && (dh.propTypes = {
  defaultTheme: o.object,
  styles: o.oneOfType([o.array, o.string, o.object, o.func])
});
/**
 * @mui/styled-engine v6.4.3
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function f1(e, t) {
  const n = km(e, t);
  return process.env.NODE_ENV !== "production" ? (...r) => {
    const i = typeof e == "string" ? `"${e}"` : "component";
    return r.length === 0 ? console.error([`MUI: Seems like you called \`styled(${i})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : r.some((a) => a === void 0) && console.error(`MUI: the styled(${i})(...args) API requires all its args to be defined.`), n(...r);
  } : n;
}
function Q_(e, t) {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}
const Pv = [];
function Dv(e) {
  return Pv[0] = e, Pl(Pv);
}
var Vc = { exports: {} }, Qt = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mv;
function Z_() {
  if (Mv) return Qt;
  Mv = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.consumer"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), m = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), v = Symbol.for("react.client.reference");
  function b(y) {
    if (typeof y == "object" && y !== null) {
      var S = y.$$typeof;
      switch (S) {
        case e:
          switch (y = y.type, y) {
            case n:
            case i:
            case r:
            case d:
            case p:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case l:
                case u:
                case h:
                case m:
                  return y;
                case a:
                  return y;
                default:
                  return S;
              }
          }
        case t:
          return S;
      }
    }
  }
  return Qt.ContextConsumer = a, Qt.ContextProvider = l, Qt.Element = e, Qt.ForwardRef = u, Qt.Fragment = n, Qt.Lazy = h, Qt.Memo = m, Qt.Portal = t, Qt.Profiler = i, Qt.StrictMode = r, Qt.Suspense = d, Qt.SuspenseList = p, Qt.isContextConsumer = function(y) {
    return b(y) === a;
  }, Qt.isContextProvider = function(y) {
    return b(y) === l;
  }, Qt.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === e;
  }, Qt.isForwardRef = function(y) {
    return b(y) === u;
  }, Qt.isFragment = function(y) {
    return b(y) === n;
  }, Qt.isLazy = function(y) {
    return b(y) === h;
  }, Qt.isMemo = function(y) {
    return b(y) === m;
  }, Qt.isPortal = function(y) {
    return b(y) === t;
  }, Qt.isProfiler = function(y) {
    return b(y) === i;
  }, Qt.isStrictMode = function(y) {
    return b(y) === r;
  }, Qt.isSuspense = function(y) {
    return b(y) === d;
  }, Qt.isSuspenseList = function(y) {
    return b(y) === p;
  }, Qt.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === n || y === i || y === r || y === d || y === p || y === g || typeof y == "object" && y !== null && (y.$$typeof === h || y.$$typeof === m || y.$$typeof === l || y.$$typeof === a || y.$$typeof === u || y.$$typeof === v || y.getModuleId !== void 0);
  }, Qt.typeOf = b, Qt;
}
var Zt = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _v;
function J_() {
  return _v || (_v = 1, process.env.NODE_ENV !== "production" && function() {
    function e(y) {
      if (typeof y == "object" && y !== null) {
        var S = y.$$typeof;
        switch (S) {
          case t:
            switch (y = y.type, y) {
              case r:
              case a:
              case i:
              case p:
              case m:
                return y;
              default:
                switch (y = y && y.$$typeof, y) {
                  case u:
                  case d:
                  case g:
                  case h:
                    return y;
                  case l:
                    return y;
                  default:
                    return S;
                }
            }
          case n:
            return S;
        }
      }
    }
    var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), l = Symbol.for("react.consumer"), u = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), m = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), b = Symbol.for("react.client.reference");
    Zt.ContextConsumer = l, Zt.ContextProvider = u, Zt.Element = t, Zt.ForwardRef = d, Zt.Fragment = r, Zt.Lazy = g, Zt.Memo = h, Zt.Portal = n, Zt.Profiler = a, Zt.StrictMode = i, Zt.Suspense = p, Zt.SuspenseList = m, Zt.isContextConsumer = function(y) {
      return e(y) === l;
    }, Zt.isContextProvider = function(y) {
      return e(y) === u;
    }, Zt.isElement = function(y) {
      return typeof y == "object" && y !== null && y.$$typeof === t;
    }, Zt.isForwardRef = function(y) {
      return e(y) === d;
    }, Zt.isFragment = function(y) {
      return e(y) === r;
    }, Zt.isLazy = function(y) {
      return e(y) === g;
    }, Zt.isMemo = function(y) {
      return e(y) === h;
    }, Zt.isPortal = function(y) {
      return e(y) === n;
    }, Zt.isProfiler = function(y) {
      return e(y) === a;
    }, Zt.isStrictMode = function(y) {
      return e(y) === i;
    }, Zt.isSuspense = function(y) {
      return e(y) === p;
    }, Zt.isSuspenseList = function(y) {
      return e(y) === m;
    }, Zt.isValidElementType = function(y) {
      return typeof y == "string" || typeof y == "function" || y === r || y === a || y === i || y === p || y === m || y === v || typeof y == "object" && y !== null && (y.$$typeof === g || y.$$typeof === h || y.$$typeof === u || y.$$typeof === l || y.$$typeof === d || y.$$typeof === b || y.getModuleId !== void 0);
    }, Zt.typeOf = e;
  }()), Zt;
}
var Iv;
function eI() {
  return Iv || (Iv = 1, process.env.NODE_ENV === "production" ? Vc.exports = /* @__PURE__ */ Z_() : Vc.exports = /* @__PURE__ */ J_()), Vc.exports;
}
var ua = /* @__PURE__ */ eI();
function Eo(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function m1(e) {
  if (/* @__PURE__ */ w.isValidElement(e) || ua.isValidElementType(e) || !Eo(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[n] = m1(e[n]);
  }), t;
}
function Bn(e, t, n = {
  clone: !0
}) {
  const r = n.clone ? {
    ...e
  } : e;
  return Eo(e) && Eo(t) && Object.keys(t).forEach((i) => {
    /* @__PURE__ */ w.isValidElement(t[i]) || ua.isValidElementType(t[i]) ? r[i] = t[i] : Eo(t[i]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, i) && Eo(e[i]) ? r[i] = Bn(e[i], t[i], n) : n.clone ? r[i] = Eo(t[i]) ? m1(t[i]) : t[i] : r[i] = t[i];
  }), r;
}
const tI = (e) => {
  const t = Object.keys(e).map((n) => ({
    key: n,
    val: e[n]
  })) || [];
  return t.sort((n, r) => n.val - r.val), t.reduce((n, r) => ({
    ...n,
    [r.key]: r.val
  }), {});
};
function nI(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: n = "px",
    step: r = 5,
    ...i
  } = e, a = tI(t), l = Object.keys(a);
  function u(g) {
    return `@media (min-width:${typeof t[g] == "number" ? t[g] : g}${n})`;
  }
  function d(g) {
    return `@media (max-width:${(typeof t[g] == "number" ? t[g] : g) - r / 100}${n})`;
  }
  function p(g, v) {
    const b = l.indexOf(v);
    return `@media (min-width:${typeof t[g] == "number" ? t[g] : g}${n}) and (max-width:${(b !== -1 && typeof t[l[b]] == "number" ? t[l[b]] : v) - r / 100}${n})`;
  }
  function m(g) {
    return l.indexOf(g) + 1 < l.length ? p(g, l[l.indexOf(g) + 1]) : u(g);
  }
  function h(g) {
    const v = l.indexOf(g);
    return v === 0 ? u(l[1]) : v === l.length - 1 ? d(l[v]) : p(g, l[l.indexOf(g) + 1]).replace("@media", "@media not all and");
  }
  return {
    keys: l,
    values: a,
    up: u,
    down: d,
    between: p,
    only: m,
    not: h,
    unit: n,
    ...i
  };
}
function rI(e, t) {
  if (!e.containerQueries)
    return t;
  const n = Object.keys(t).filter((r) => r.startsWith("@container")).sort((r, i) => {
    var l, u;
    const a = /min-width:\s*([0-9.]+)/;
    return +(((l = r.match(a)) == null ? void 0 : l[1]) || 0) - +(((u = i.match(a)) == null ? void 0 : u[1]) || 0);
  });
  return n.length ? n.reduce((r, i) => {
    const a = t[i];
    return delete r[i], r[i] = a, r;
  }, {
    ...t
  }) : t;
}
function oI(e, t) {
  return t === "@" || t.startsWith("@") && (e.some((n) => t.startsWith(`@${n}`)) || !!t.match(/^@\d/));
}
function iI(e, t) {
  const n = t.match(/^@([^/]+)?\/?(.+)?$/);
  if (!n) {
    if (process.env.NODE_ENV !== "production")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The provided shorthand ${`(${t})`} is invalid. The format should be \`@<breakpoint | number>\` or \`@<breakpoint | number>/<container>\`.
For example, \`@sm\` or \`@600\` or \`@40rem/sidebar\`.` : _o(18, `(${t})`));
    return null;
  }
  const [, r, i] = n, a = Number.isNaN(+r) ? r || 0 : +r;
  return e.containerQueries(i).up(a);
}
function aI(e) {
  const t = (a, l) => a.replace("@media", l ? `@container ${l}` : "@container");
  function n(a, l) {
    a.up = (...u) => t(e.breakpoints.up(...u), l), a.down = (...u) => t(e.breakpoints.down(...u), l), a.between = (...u) => t(e.breakpoints.between(...u), l), a.only = (...u) => t(e.breakpoints.only(...u), l), a.not = (...u) => {
      const d = t(e.breakpoints.not(...u), l);
      return d.includes("not all and") ? d.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or") : d;
    };
  }
  const r = {}, i = (a) => (n(r, a), r);
  return n(i), {
    ...e,
    containerQueries: i
  };
}
const sI = {
  borderRadius: 4
}, ji = process.env.NODE_ENV !== "production" ? o.oneOfType([o.number, o.string, o.object, o.array]) : {};
function tl(e, t) {
  return t ? Bn(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const Uu = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, jv = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${Uu[e]}px)`
}, lI = {
  containerQueries: (e) => ({
    up: (t) => {
      let n = typeof t == "number" ? t : Uu[t] || t;
      return typeof n == "number" && (n = `${n}px`), e ? `@container ${e} (min-width:${n})` : `@container (min-width:${n})`;
    }
  })
};
function po(e, t, n) {
  const r = e.theme || {};
  if (Array.isArray(t)) {
    const a = r.breakpoints || jv;
    return t.reduce((l, u, d) => (l[a.up(a.keys[d])] = n(t[d]), l), {});
  }
  if (typeof t == "object") {
    const a = r.breakpoints || jv;
    return Object.keys(t).reduce((l, u) => {
      if (oI(a.keys, u)) {
        const d = iI(r.containerQueries ? r : lI, u);
        d && (l[d] = n(t[u], u));
      } else if (Object.keys(a.values || Uu).includes(u)) {
        const d = a.up(u);
        l[d] = n(t[u], u);
      } else {
        const d = u;
        l[d] = t[d];
      }
      return l;
    }, {});
  }
  return n(t);
}
function h1(e = {}) {
  var n;
  return ((n = e.keys) == null ? void 0 : n.reduce((r, i) => {
    const a = e.up(i);
    return r[a] = {}, r;
  }, {})) || {};
}
function g1(e, t) {
  return e.reduce((n, r) => {
    const i = n[r];
    return (!i || Object.keys(i).length === 0) && delete n[r], n;
  }, t);
}
function cI(e, ...t) {
  const n = h1(e), r = [n, ...t].reduce((i, a) => Bn(i, a), {});
  return g1(Object.keys(n), r);
}
function uI(e, t) {
  if (typeof e != "object")
    return {};
  const n = {}, r = Object.keys(t);
  return Array.isArray(e) ? r.forEach((i, a) => {
    a < e.length && (n[i] = !0);
  }) : r.forEach((i) => {
    e[i] != null && (n[i] = !0);
  }), n;
}
function sf({
  values: e,
  breakpoints: t,
  base: n
}) {
  const r = n || uI(e, t), i = Object.keys(r);
  if (i.length === 0)
    return e;
  let a;
  return i.reduce((l, u, d) => (Array.isArray(e) ? (l[u] = e[d] != null ? e[d] : e[a], a = d) : typeof e == "object" ? (l[u] = e[u] != null ? e[u] : e[a], a = u) : l[u] = e, l), {});
}
function ke(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : _o(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function Yu(e, t, n = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && n) {
    const r = `vars.${t}`.split(".").reduce((i, a) => i && i[a] ? i[a] : null, e);
    if (r != null)
      return r;
  }
  return t.split(".").reduce((r, i) => r && r[i] != null ? r[i] : null, e);
}
function bu(e, t, n, r = n) {
  let i;
  return typeof e == "function" ? i = e(n) : Array.isArray(e) ? i = e[n] || r : i = Yu(e, n) || r, t && (i = t(i, r, e)), i;
}
function In(e) {
  const {
    prop: t,
    cssProperty: n = e.prop,
    themeKey: r,
    transform: i
  } = e, a = (l) => {
    if (l[t] == null)
      return null;
    const u = l[t], d = l.theme, p = Yu(d, r) || {};
    return po(l, u, (h) => {
      let g = bu(p, i, h);
      return h === g && typeof h == "string" && (g = bu(p, i, `${t}${h === "default" ? "" : ke(h)}`, h)), n === !1 ? g : {
        [n]: g
      };
    });
  };
  return a.propTypes = process.env.NODE_ENV !== "production" ? {
    [t]: ji
  } : {}, a.filterProps = [t], a;
}
function dI(e) {
  const t = {};
  return (n) => (t[n] === void 0 && (t[n] = e(n)), t[n]);
}
const pI = {
  m: "margin",
  p: "padding"
}, fI = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, $v = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, mI = dI((e) => {
  if (e.length > 2)
    if ($v[e])
      e = $v[e];
    else
      return [e];
  const [t, n] = e.split(""), r = pI[t], i = fI[n] || "";
  return Array.isArray(i) ? i.map((a) => r + a) : [r + i];
}), Gu = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], Ku = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], hI = [...Gu, ...Ku];
function _l(e, t, n, r) {
  const i = Yu(e, t, !0) ?? n;
  return typeof i == "number" || typeof i == "string" ? (a) => typeof a == "string" ? a : (process.env.NODE_ENV !== "production" && typeof a != "number" && console.error(`MUI: Expected ${r} argument to be a number or a string, got ${a}.`), typeof i == "string" ? `calc(${a} * ${i})` : i * a) : Array.isArray(i) ? (a) => {
    if (typeof a == "string")
      return a;
    const l = Math.abs(a);
    process.env.NODE_ENV !== "production" && (Number.isInteger(l) ? l > i.length - 1 && console.error([`MUI: The value provided (${l}) overflows.`, `The supported values are: ${JSON.stringify(i)}.`, `${l} > ${i.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join(`
`)));
    const u = i[l];
    return a >= 0 ? u : typeof u == "number" ? -u : `-${u}`;
  } : typeof i == "function" ? i : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${i}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function Xu(e) {
  return _l(e, "spacing", 8, "spacing");
}
function da(e, t) {
  return typeof t == "string" || t == null ? t : e(t);
}
function gI(e, t) {
  return (n) => e.reduce((r, i) => (r[i] = da(t, n), r), {});
}
function yI(e, t, n, r) {
  if (!t.includes(n))
    return null;
  const i = mI(n), a = gI(i, r), l = e[n];
  return po(e, l, a);
}
function y1(e, t) {
  const n = Xu(e.theme);
  return Object.keys(e).map((r) => yI(e, t, r, n)).reduce(tl, {});
}
function Cn(e) {
  return y1(e, Gu);
}
Cn.propTypes = process.env.NODE_ENV !== "production" ? Gu.reduce((e, t) => (e[t] = ji, e), {}) : {};
Cn.filterProps = Gu;
function Sn(e) {
  return y1(e, Ku);
}
Sn.propTypes = process.env.NODE_ENV !== "production" ? Ku.reduce((e, t) => (e[t] = ji, e), {}) : {};
Sn.filterProps = Ku;
process.env.NODE_ENV !== "production" && hI.reduce((e, t) => (e[t] = ji, e), {});
function b1(e = 8, t = Xu({
  spacing: e
})) {
  if (e.mui)
    return e;
  const n = (...r) => (process.env.NODE_ENV !== "production" && (r.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${r.length}`)), (r.length === 0 ? [1] : r).map((a) => {
    const l = t(a);
    return typeof l == "number" ? `${l}px` : l;
  }).join(" "));
  return n.mui = !0, n;
}
function Qu(...e) {
  const t = e.reduce((r, i) => (i.filterProps.forEach((a) => {
    r[a] = i;
  }), r), {}), n = (r) => Object.keys(r).reduce((i, a) => t[a] ? tl(i, t[a](r)) : i, {});
  return n.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((r, i) => Object.assign(r, i.propTypes), {}) : {}, n.filterProps = e.reduce((r, i) => r.concat(i.filterProps), []), n;
}
function Yr(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function Jr(e, t) {
  return In({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const bI = Jr("border", Yr), vI = Jr("borderTop", Yr), xI = Jr("borderRight", Yr), wI = Jr("borderBottom", Yr), CI = Jr("borderLeft", Yr), SI = Jr("borderColor"), OI = Jr("borderTopColor"), TI = Jr("borderRightColor"), EI = Jr("borderBottomColor"), RI = Jr("borderLeftColor"), kI = Jr("outline", Yr), PI = Jr("outlineColor"), Zu = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = _l(e.theme, "shape.borderRadius", 4, "borderRadius"), n = (r) => ({
      borderRadius: da(t, r)
    });
    return po(e, e.borderRadius, n);
  }
  return null;
};
Zu.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: ji
} : {};
Zu.filterProps = ["borderRadius"];
Qu(bI, vI, xI, wI, CI, SI, OI, TI, EI, RI, Zu, kI, PI);
const Ju = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = _l(e.theme, "spacing", 8, "gap"), n = (r) => ({
      gap: da(t, r)
    });
    return po(e, e.gap, n);
  }
  return null;
};
Ju.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: ji
} : {};
Ju.filterProps = ["gap"];
const ed = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = _l(e.theme, "spacing", 8, "columnGap"), n = (r) => ({
      columnGap: da(t, r)
    });
    return po(e, e.columnGap, n);
  }
  return null;
};
ed.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: ji
} : {};
ed.filterProps = ["columnGap"];
const td = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = _l(e.theme, "spacing", 8, "rowGap"), n = (r) => ({
      rowGap: da(t, r)
    });
    return po(e, e.rowGap, n);
  }
  return null;
};
td.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: ji
} : {};
td.filterProps = ["rowGap"];
const DI = In({
  prop: "gridColumn"
}), MI = In({
  prop: "gridRow"
}), _I = In({
  prop: "gridAutoFlow"
}), II = In({
  prop: "gridAutoColumns"
}), jI = In({
  prop: "gridAutoRows"
}), $I = In({
  prop: "gridTemplateColumns"
}), AI = In({
  prop: "gridTemplateRows"
}), NI = In({
  prop: "gridTemplateAreas"
}), FI = In({
  prop: "gridArea"
});
Qu(Ju, ed, td, DI, MI, _I, II, jI, $I, AI, NI, FI);
function Ha(e, t) {
  return t === "grey" ? t : e;
}
const LI = In({
  prop: "color",
  themeKey: "palette",
  transform: Ha
}), BI = In({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: Ha
}), VI = In({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: Ha
});
Qu(LI, BI, VI);
function Pr(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const zI = In({
  prop: "width",
  transform: Pr
}), ph = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (n) => {
      var i, a, l, u, d;
      const r = ((l = (a = (i = e.theme) == null ? void 0 : i.breakpoints) == null ? void 0 : a.values) == null ? void 0 : l[n]) || Uu[n];
      return r ? ((d = (u = e.theme) == null ? void 0 : u.breakpoints) == null ? void 0 : d.unit) !== "px" ? {
        maxWidth: `${r}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: r
      } : {
        maxWidth: Pr(n)
      };
    };
    return po(e, e.maxWidth, t);
  }
  return null;
};
ph.filterProps = ["maxWidth"];
const WI = In({
  prop: "minWidth",
  transform: Pr
}), qI = In({
  prop: "height",
  transform: Pr
}), HI = In({
  prop: "maxHeight",
  transform: Pr
}), UI = In({
  prop: "minHeight",
  transform: Pr
});
In({
  prop: "size",
  cssProperty: "width",
  transform: Pr
});
In({
  prop: "size",
  cssProperty: "height",
  transform: Pr
});
const YI = In({
  prop: "boxSizing"
});
Qu(zI, ph, WI, qI, HI, UI, YI);
const Il = {
  // borders
  border: {
    themeKey: "borders",
    transform: Yr
  },
  borderTop: {
    themeKey: "borders",
    transform: Yr
  },
  borderRight: {
    themeKey: "borders",
    transform: Yr
  },
  borderBottom: {
    themeKey: "borders",
    transform: Yr
  },
  borderLeft: {
    themeKey: "borders",
    transform: Yr
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: Yr
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: Zu
  },
  // palette
  color: {
    themeKey: "palette",
    transform: Ha
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: Ha
  },
  backgroundColor: {
    themeKey: "palette",
    transform: Ha
  },
  // spacing
  p: {
    style: Sn
  },
  pt: {
    style: Sn
  },
  pr: {
    style: Sn
  },
  pb: {
    style: Sn
  },
  pl: {
    style: Sn
  },
  px: {
    style: Sn
  },
  py: {
    style: Sn
  },
  padding: {
    style: Sn
  },
  paddingTop: {
    style: Sn
  },
  paddingRight: {
    style: Sn
  },
  paddingBottom: {
    style: Sn
  },
  paddingLeft: {
    style: Sn
  },
  paddingX: {
    style: Sn
  },
  paddingY: {
    style: Sn
  },
  paddingInline: {
    style: Sn
  },
  paddingInlineStart: {
    style: Sn
  },
  paddingInlineEnd: {
    style: Sn
  },
  paddingBlock: {
    style: Sn
  },
  paddingBlockStart: {
    style: Sn
  },
  paddingBlockEnd: {
    style: Sn
  },
  m: {
    style: Cn
  },
  mt: {
    style: Cn
  },
  mr: {
    style: Cn
  },
  mb: {
    style: Cn
  },
  ml: {
    style: Cn
  },
  mx: {
    style: Cn
  },
  my: {
    style: Cn
  },
  margin: {
    style: Cn
  },
  marginTop: {
    style: Cn
  },
  marginRight: {
    style: Cn
  },
  marginBottom: {
    style: Cn
  },
  marginLeft: {
    style: Cn
  },
  marginX: {
    style: Cn
  },
  marginY: {
    style: Cn
  },
  marginInline: {
    style: Cn
  },
  marginInlineStart: {
    style: Cn
  },
  marginInlineEnd: {
    style: Cn
  },
  marginBlock: {
    style: Cn
  },
  marginBlockStart: {
    style: Cn
  },
  marginBlockEnd: {
    style: Cn
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: Ju
  },
  rowGap: {
    style: td
  },
  columnGap: {
    style: ed
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: Pr
  },
  maxWidth: {
    style: ph
  },
  minWidth: {
    transform: Pr
  },
  height: {
    transform: Pr
  },
  maxHeight: {
    transform: Pr
  },
  minHeight: {
    transform: Pr
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function GI(...e) {
  const t = e.reduce((r, i) => r.concat(Object.keys(i)), []), n = new Set(t);
  return e.every((r) => n.size === Object.keys(r).length);
}
function KI(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function XI() {
  function e(n, r, i, a) {
    const l = {
      [n]: r,
      theme: i
    }, u = a[n];
    if (!u)
      return {
        [n]: r
      };
    const {
      cssProperty: d = n,
      themeKey: p,
      transform: m,
      style: h
    } = u;
    if (r == null)
      return null;
    if (p === "typography" && r === "inherit")
      return {
        [n]: r
      };
    const g = Yu(i, p) || {};
    return h ? h(l) : po(l, r, (b) => {
      let y = bu(g, m, b);
      return b === y && typeof b == "string" && (y = bu(g, m, `${n}${b === "default" ? "" : ke(b)}`, b)), d === !1 ? y : {
        [d]: y
      };
    });
  }
  function t(n) {
    const {
      sx: r,
      theme: i = {}
    } = n || {};
    if (!r)
      return null;
    const a = i.unstable_sxConfig ?? Il;
    function l(u) {
      let d = u;
      if (typeof u == "function")
        d = u(i);
      else if (typeof u != "object")
        return u;
      if (!d)
        return null;
      const p = h1(i.breakpoints), m = Object.keys(p);
      let h = p;
      return Object.keys(d).forEach((g) => {
        const v = KI(d[g], i);
        if (v != null)
          if (typeof v == "object")
            if (a[g])
              h = tl(h, e(g, v, i, a));
            else {
              const b = po({
                theme: i
              }, v, (y) => ({
                [g]: y
              }));
              GI(b, v) ? h[g] = t({
                sx: v,
                theme: i
              }) : h = tl(h, b);
            }
          else
            h = tl(h, e(g, v, i, a));
      }), rI(i, g1(m, h));
    }
    return Array.isArray(r) ? r.map(l) : l(r);
  }
  return t;
}
const Pi = XI();
Pi.filterProps = ["sx"];
function QI(e, t) {
  var r;
  const n = this;
  if (n.vars) {
    if (!((r = n.colorSchemes) != null && r[e]) || typeof n.getColorSchemeSelector != "function")
      return {};
    let i = n.getColorSchemeSelector(e);
    return i === "&" ? t : ((i.includes("data-") || i.includes(".")) && (i = `*:where(${i.replace(/\s*&$/, "")}) &`), {
      [i]: t
    });
  }
  return n.palette.mode === e ? t : {};
}
function jl(e = {}, ...t) {
  const {
    breakpoints: n = {},
    palette: r = {},
    spacing: i,
    shape: a = {},
    ...l
  } = e, u = nI(n), d = b1(i);
  let p = Bn({
    breakpoints: u,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: {
      mode: "light",
      ...r
    },
    spacing: d,
    shape: {
      ...sI,
      ...a
    }
  }, l);
  return p = aI(p), p.applyStyles = QI, p = t.reduce((m, h) => Bn(m, h), p), p.unstable_sxConfig = {
    ...Il,
    ...l == null ? void 0 : l.unstable_sxConfig
  }, p.unstable_sx = function(h) {
    return Pi({
      sx: h,
      theme: this
    });
  }, p;
}
function ZI(e) {
  return Object.keys(e).length === 0;
}
function fh(e = null) {
  const t = w.useContext(Dl);
  return !t || ZI(t) ? e : t;
}
const JI = jl();
function $l(e = JI) {
  return fh(e);
}
function v1({
  styles: e,
  themeId: t,
  defaultTheme: n = {}
}) {
  const r = $l(n), i = typeof e == "function" ? e(t && r[t] || r) : e;
  return /* @__PURE__ */ x.jsx(dh, {
    styles: i
  });
}
process.env.NODE_ENV !== "production" && (v1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  defaultTheme: o.object,
  /**
   * @ignore
   */
  styles: o.oneOfType([o.array, o.func, o.number, o.object, o.string, o.bool]),
  /**
   * @ignore
   */
  themeId: o.string
});
const ej = (e) => {
  var r;
  const t = {
    systemProps: {},
    otherProps: {}
  }, n = ((r = e == null ? void 0 : e.theme) == null ? void 0 : r.unstable_sxConfig) ?? Il;
  return Object.keys(e).forEach((i) => {
    n[i] ? t.systemProps[i] = e[i] : t.otherProps[i] = e[i];
  }), t;
};
function nd(e) {
  const {
    sx: t,
    ...n
  } = e, {
    systemProps: r,
    otherProps: i
  } = ej(n);
  let a;
  return Array.isArray(t) ? a = [r, ...t] : typeof t == "function" ? a = (...l) => {
    const u = t(...l);
    return Eo(u) ? {
      ...r,
      ...u
    } : r;
  } : a = {
    ...r,
    ...t
  }, {
    ...i,
    sx: a
  };
}
const Av = (e) => e, tj = () => {
  let e = Av;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = Av;
    }
  };
}, x1 = tj();
function w1(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var i = e.length;
    for (t = 0; t < i; t++) e[t] && (n = w1(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function Me() {
  for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = w1(e)) && (r && (r += " "), r += t);
  return r;
}
function nj(e = {}) {
  const {
    themeId: t,
    defaultTheme: n,
    defaultClassName: r = "MuiBox-root",
    generateClassName: i
  } = e, a = f1("div", {
    shouldForwardProp: (u) => u !== "theme" && u !== "sx" && u !== "as"
  })(Pi);
  return /* @__PURE__ */ w.forwardRef(function(d, p) {
    const m = $l(n), {
      className: h,
      component: g = "div",
      ...v
    } = nd(d);
    return /* @__PURE__ */ x.jsx(a, {
      as: g,
      ref: p,
      className: Me(h, i ? i(r) : r),
      theme: t && m[t] || m,
      ...v
    });
  });
}
const rj = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function ze(e, t, n = "Mui") {
  const r = rj[t];
  return r ? `${n}-${r}` : `${x1.generate(e)}-${t}`;
}
function Ve(e, t, n = "Mui") {
  const r = {};
  return t.forEach((i) => {
    r[i] = ze(e, i, n);
  }), r;
}
function C1(e, t = "") {
  return e.displayName || e.name || t;
}
function Nv(e, t, n) {
  const r = C1(t);
  return e.displayName || (r !== "" ? `${n}(${r})` : n);
}
function oj(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return C1(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case ua.ForwardRef:
          return Nv(e, e.render, "ForwardRef");
        case ua.Memo:
          return Nv(e, e.type, "memo");
        default:
          return;
      }
  }
}
function S1(e) {
  const {
    variants: t,
    ...n
  } = e, r = {
    variants: t,
    style: Dv(n),
    isProcessed: !0
  };
  return r.style === n || t && t.forEach((i) => {
    typeof i.style != "function" && (i.style = Dv(i.style));
  }), r;
}
const ij = jl();
function cu(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
function aj(e) {
  return e ? (t, n) => n[e] : null;
}
function sj(e, t, n) {
  e.theme = uj(e.theme) ? n : e.theme[t] || e.theme;
}
function uu(e, t) {
  const n = typeof t == "function" ? t(e) : t;
  if (Array.isArray(n))
    return n.flatMap((r) => uu(e, r));
  if (Array.isArray(n == null ? void 0 : n.variants)) {
    let r;
    if (n.isProcessed)
      r = n.style;
    else {
      const {
        variants: i,
        ...a
      } = n;
      r = a;
    }
    return O1(e, n.variants, [r]);
  }
  return n != null && n.isProcessed ? n.style : n;
}
function O1(e, t, n = []) {
  var i;
  let r;
  e: for (let a = 0; a < t.length; a += 1) {
    const l = t[a];
    if (typeof l.props == "function") {
      if (r ?? (r = {
        ...e,
        ...e.ownerState,
        ownerState: e.ownerState
      }), !l.props(r))
        continue;
    } else
      for (const u in l.props)
        if (e[u] !== l.props[u] && ((i = e.ownerState) == null ? void 0 : i[u]) !== l.props[u])
          continue e;
    typeof l.style == "function" ? (r ?? (r = {
      ...e,
      ...e.ownerState,
      ownerState: e.ownerState
    }), n.push(l.style(r))) : n.push(l.style);
  }
  return n;
}
function T1(e = {}) {
  const {
    themeId: t,
    defaultTheme: n = ij,
    rootShouldForwardProp: r = cu,
    slotShouldForwardProp: i = cu
  } = e;
  function a(u) {
    sj(u, t, n);
  }
  return (u, d = {}) => {
    Q_(u, (E) => E.filter((M) => M !== Pi));
    const {
      name: p,
      slot: m,
      skipVariantsResolver: h,
      skipSx: g,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: v = aj(E1(m)),
      ...b
    } = d, y = h !== void 0 ? h : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      m && m !== "Root" && m !== "root" || !1
    ), S = g || !1;
    let O = cu;
    m === "Root" || m === "root" ? O = r : m ? O = i : dj(u) && (O = void 0);
    const P = f1(u, {
      shouldForwardProp: O,
      label: cj(p, m),
      ...b
    }), k = (E) => {
      if (typeof E == "function" && E.__emotion_real !== E)
        return function(_) {
          return uu(_, E);
        };
      if (Eo(E)) {
        const M = S1(E);
        return M.variants ? function(I) {
          return uu(I, M);
        } : M.style;
      }
      return E;
    }, R = (...E) => {
      const M = [], _ = E.map(k), I = [];
      if (M.push(a), p && v && I.push(function(N) {
        var z, X;
        const L = (X = (z = N.theme.components) == null ? void 0 : z[p]) == null ? void 0 : X.styleOverrides;
        if (!L)
          return null;
        const V = {};
        for (const le in L)
          V[le] = uu(N, L[le]);
        return v(N, V);
      }), p && !y && I.push(function(N) {
        var V, z;
        const W = N.theme, L = (z = (V = W == null ? void 0 : W.components) == null ? void 0 : V[p]) == null ? void 0 : z.variants;
        return L ? O1(N, L) : null;
      }), S || I.push(Pi), Array.isArray(_[0])) {
        const $ = _.shift(), N = new Array(M.length).fill(""), W = new Array(I.length).fill("");
        let L;
        L = [...N, ...$, ...W], L.raw = [...N, ...$.raw, ...W], M.unshift(L);
      }
      const F = [...M, ..._, ...I], T = P(...F);
      return u.muiName && (T.muiName = u.muiName), process.env.NODE_ENV !== "production" && (T.displayName = lj(p, m, u)), T;
    };
    return P.withConfig && (R.withConfig = P.withConfig), R;
  };
}
function lj(e, t, n) {
  return e ? `${e}${ke(t || "")}` : `Styled(${oj(n)})`;
}
function cj(e, t) {
  let n;
  return process.env.NODE_ENV !== "production" && e && (n = `${e}-${E1(t || "Root")}`), n;
}
function uj(e) {
  for (const t in e)
    return !1;
  return !0;
}
function dj(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function E1(e) {
  return e && e.charAt(0).toLowerCase() + e.slice(1);
}
const R1 = T1();
function dl(e, t) {
  const n = {
    ...t
  };
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      const i = r;
      if (i === "components" || i === "slots")
        n[i] = {
          ...e[i],
          ...n[i]
        };
      else if (i === "componentsProps" || i === "slotProps") {
        const a = e[i], l = t[i];
        if (!l)
          n[i] = a || {};
        else if (!a)
          n[i] = l;
        else {
          n[i] = {
            ...l
          };
          for (const u in a)
            if (Object.prototype.hasOwnProperty.call(a, u)) {
              const d = u;
              n[i][d] = dl(a[d], l[d]);
            }
        }
      } else n[i] === void 0 && (n[i] = e[i]);
    }
  return n;
}
function k1(e) {
  const {
    theme: t,
    name: n,
    props: r
  } = e;
  return !t || !t.components || !t.components[n] || !t.components[n].defaultProps ? r : dl(t.components[n].defaultProps, r);
}
function mh({
  props: e,
  name: t,
  defaultTheme: n,
  themeId: r
}) {
  let i = $l(n);
  return r && (i = i[r] || i), k1({
    theme: i,
    name: t,
    props: e
  });
}
const An = typeof window < "u" ? w.useLayoutEffect : w.useEffect;
function pj(e, t, n, r, i) {
  const [a, l] = w.useState(() => i && n ? n(e).matches : r ? r(e).matches : t);
  return An(() => {
    if (!n)
      return;
    const u = n(e), d = () => {
      l(u.matches);
    };
    return d(), u.addEventListener("change", d), () => {
      u.removeEventListener("change", d);
    };
  }, [e, n]), a;
}
const fj = {
  ...w
}, P1 = fj.useSyncExternalStore;
function mj(e, t, n, r, i) {
  const a = w.useCallback(() => t, [t]), l = w.useMemo(() => {
    if (i && n)
      return () => n(e).matches;
    if (r !== null) {
      const {
        matches: m
      } = r(e);
      return () => m;
    }
    return a;
  }, [a, e, r, i, n]), [u, d] = w.useMemo(() => {
    if (n === null)
      return [a, () => () => {
      }];
    const m = n(e);
    return [() => m.matches, (h) => (m.addEventListener("change", h), () => {
      m.removeEventListener("change", h);
    })];
  }, [a, n, e]);
  return P1(d, u, l);
}
function D1(e = {}) {
  const {
    themeId: t
  } = e;
  return function(r, i = {}) {
    let a = fh();
    a && t && (a = a[t] || a);
    const l = typeof window < "u" && typeof window.matchMedia < "u", {
      defaultMatches: u = !1,
      matchMedia: d = l ? window.matchMedia : null,
      ssrMatchMedia: p = null,
      noSsr: m = !1
    } = k1({
      name: "MuiUseMediaQuery",
      props: i,
      theme: a
    });
    process.env.NODE_ENV !== "production" && typeof r == "function" && a === null && console.error(["MUI: The `query` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`));
    let h = typeof r == "function" ? r(a) : r;
    h = h.replace(/^@media( ?)/m, "");
    const v = (P1 !== void 0 ? mj : pj)(h, u, d, p, m);
    return process.env.NODE_ENV !== "production" && w.useDebugValue({
      query: h,
      match: v
    }), v;
  };
}
D1();
function hj(e, t = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, n));
}
function hh(e, t = 0, n = 1) {
  return process.env.NODE_ENV !== "production" && (e < t || e > n) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${n}].`), hj(e, t, n);
}
function gj(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let n = e.match(t);
  return n && n[0].length === 1 && (n = n.map((r) => r + r)), process.env.NODE_ENV !== "production" && e.length !== e.trim().length && console.error(`MUI: The color: "${e}" is invalid. Make sure the color input doesn't contain leading/trailing space.`), n ? `rgb${n.length === 4 ? "a" : ""}(${n.map((r, i) => i < 3 ? parseInt(r, 16) : Math.round(parseInt(r, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function Di(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return Di(gj(e));
  const t = e.indexOf("("), n = e.substring(0, t);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(n))
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : _o(9, e));
  let r = e.substring(t + 1, e.length - 1), i;
  if (n === "color") {
    if (r = r.split(" "), i = r.shift(), r.length === 4 && r[3].charAt(0) === "/" && (r[3] = r[3].slice(1)), !["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(i))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${i}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : _o(10, i));
  } else
    r = r.split(",");
  return r = r.map((a) => parseFloat(a)), {
    type: n,
    values: r,
    colorSpace: i
  };
}
const yj = (e) => {
  const t = Di(e);
  return t.values.slice(0, 3).map((n, r) => t.type.includes("hsl") && r !== 0 ? `${n}%` : n).join(" ");
}, Xs = (e, t) => {
  try {
    return yj(e);
  } catch {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
};
function rd(e) {
  const {
    type: t,
    colorSpace: n
  } = e;
  let {
    values: r
  } = e;
  return t.includes("rgb") ? r = r.map((i, a) => a < 3 ? parseInt(i, 10) : i) : t.includes("hsl") && (r[1] = `${r[1]}%`, r[2] = `${r[2]}%`), t.includes("color") ? r = `${n} ${r.join(" ")}` : r = `${r.join(", ")}`, `${t}(${r})`;
}
function M1(e) {
  e = Di(e);
  const {
    values: t
  } = e, n = t[0], r = t[1] / 100, i = t[2] / 100, a = r * Math.min(i, 1 - i), l = (p, m = (p + n / 30) % 12) => i - a * Math.max(Math.min(m - 3, 9 - m, 1), -1);
  let u = "rgb";
  const d = [Math.round(l(0) * 255), Math.round(l(8) * 255), Math.round(l(4) * 255)];
  return e.type === "hsla" && (u += "a", d.push(t[3])), rd({
    type: u,
    values: d
  });
}
function Pm(e) {
  e = Di(e);
  let t = e.type === "hsl" || e.type === "hsla" ? Di(M1(e)).values : e.values;
  return t = t.map((n) => (e.type !== "color" && (n /= 255), n <= 0.03928 ? n / 12.92 : ((n + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function Fv(e, t) {
  const n = Pm(e), r = Pm(t);
  return (Math.max(n, r) + 0.05) / (Math.min(n, r) + 0.05);
}
function mt(e, t) {
  return e = Di(e), t = hh(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, rd(e);
}
function zc(e, t, n) {
  try {
    return mt(e, t);
  } catch {
    return e;
  }
}
function od(e, t) {
  if (e = Di(e), t = hh(t), e.type.includes("hsl"))
    e.values[2] *= 1 - t;
  else if (e.type.includes("rgb") || e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] *= 1 - t;
  return rd(e);
}
function tn(e, t, n) {
  try {
    return od(e, t);
  } catch {
    return e;
  }
}
function id(e, t) {
  if (e = Di(e), t = hh(t), e.type.includes("hsl"))
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.includes("rgb"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (255 - e.values[n]) * t;
  else if (e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (1 - e.values[n]) * t;
  return rd(e);
}
function nn(e, t, n) {
  try {
    return id(e, t);
  } catch {
    return e;
  }
}
function bj(e, t = 0.15) {
  return Pm(e) > 0.5 ? od(e, t) : id(e, t);
}
function Wc(e, t, n) {
  try {
    return bj(e, t);
  } catch {
    return e;
  }
}
function fo(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : function(...r) {
    return e(...r) || t(...r);
  };
}
function vj(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function _1(e, t, n, r, i) {
  const a = e[t], l = i || t;
  if (a == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let u;
  const d = a.type;
  return typeof d == "function" && !vj(d) && (u = "Did you accidentally use a plain function component for an element instead?"), u !== void 0 ? new Error(`Invalid ${r} \`${l}\` supplied to \`${n}\`. Expected an element that can hold a ref. ${u} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const cs = fo(o.element, _1);
cs.isRequired = fo(o.element.isRequired, _1);
function xj(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function wj(e, t, n, r, i) {
  const a = e[t], l = i || t;
  if (a == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let u;
  return typeof a == "function" && !xj(a) && (u = "Did you accidentally provide a plain function component instead?"), u !== void 0 ? new Error(`Invalid ${r} \`${l}\` supplied to \`${n}\`. Expected an element type that can hold a ref. ${u} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const ad = fo(o.elementType, wj), Cj = "exact-prop: ​";
function sd(e) {
  return process.env.NODE_ENV === "production" ? e : {
    ...e,
    [Cj]: (t) => {
      const n = Object.keys(t).filter((r) => !e.hasOwnProperty(r));
      return n.length > 0 ? new Error(`The following props are not supported: ${n.map((r) => `\`${r}\``).join(", ")}. Please remove them.`) : null;
    }
  };
}
function ei(e, t, n, r, i) {
  if (process.env.NODE_ENV === "production")
    return null;
  const a = e[t], l = i || t;
  return a == null ? null : a && a.nodeType !== 1 ? new Error(`Invalid ${r} \`${l}\` supplied to \`${n}\`. Expected an HTMLElement.`) : null;
}
const gn = o.oneOfType([o.func, o.object]);
function Dm(...e) {
  return e.reduce((t, n) => n == null ? t : function(...i) {
    t.apply(this, i), n.apply(this, i);
  }, () => {
  });
}
function gh(e, t = 166) {
  let n;
  function r(...i) {
    const a = () => {
      e.apply(this, i);
    };
    clearTimeout(n), n = setTimeout(a, t);
  }
  return r.clear = () => {
    clearTimeout(n);
  }, r;
}
function Ua(e, t) {
  var n, r, i;
  return /* @__PURE__ */ w.isValidElement(e) && t.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    e.type.muiName ?? ((i = (r = (n = e.type) == null ? void 0 : n._payload) == null ? void 0 : r.value) == null ? void 0 : i.muiName)
  ) !== -1;
}
function Qn(e) {
  return e && e.ownerDocument || document;
}
function ti(e) {
  return Qn(e).defaultView || window;
}
function Sj(e, t) {
  if (process.env.NODE_ENV === "production")
    return () => null;
  const n = t ? {
    ...t.propTypes
  } : null;
  return (i) => (a, l, u, d, p, ...m) => {
    const h = p || l, g = n == null ? void 0 : n[h];
    if (g) {
      const v = g(a, l, u, d, p, ...m);
      if (v)
        return v;
    }
    return typeof a[l] < "u" && !a[i] ? new Error(`The prop \`${h}\` of \`${e}\` can only be used together with the \`${i}\` prop.`) : null;
  };
}
function vu(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
let Lv = 0;
function Oj(e) {
  const [t, n] = w.useState(e), r = e || t;
  return w.useEffect(() => {
    t == null && (Lv += 1, n(`mui-${Lv}`));
  }, [t]), r;
}
const Tj = {
  ...w
}, Bv = Tj.useId;
function Ir(e) {
  if (Bv !== void 0) {
    const t = Bv();
    return e ?? t;
  }
  return Oj(e);
}
function Ej(e, t, n, r, i) {
  if (process.env.NODE_ENV === "production")
    return null;
  const a = i || t;
  return typeof e[t] < "u" ? new Error(`The prop \`${a}\` is not supported. Please remove it.`) : null;
}
function or({
  controlled: e,
  default: t,
  name: n,
  state: r = "value"
}) {
  const {
    current: i
  } = w.useRef(e !== void 0), [a, l] = w.useState(t), u = i ? e : a;
  if (process.env.NODE_ENV !== "production") {
    w.useEffect(() => {
      i !== (e !== void 0) && console.error([`MUI: A component is changing the ${i ? "" : "un"}controlled ${r} state of ${n} to be ${i ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [r, n, e]);
    const {
      current: p
    } = w.useRef(t);
    w.useEffect(() => {
      !i && !Object.is(p, t) && console.error([`MUI: A component is changing the default ${r} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const d = w.useCallback((p) => {
    i || l(p);
  }, []);
  return [u, d];
}
function Le(e) {
  const t = w.useRef(e);
  return An(() => {
    t.current = e;
  }), w.useRef((...n) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...n)
  )).current;
}
function It(...e) {
  return w.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      vu(n, t);
    });
  }, e);
}
const Vv = {};
function I1(e, t) {
  const n = w.useRef(Vv);
  return n.current === Vv && (n.current = e(t)), n;
}
const Rj = [];
function kj(e) {
  w.useEffect(e, Rj);
}
class ld {
  constructor() {
    qe(this, "currentId", null);
    qe(this, "clear", () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    });
    qe(this, "disposeEffect", () => this.clear);
  }
  static create() {
    return new ld();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, n();
    }, t);
  }
}
function za() {
  const e = I1(ld.create).current;
  return kj(e.disposeEffect), e;
}
function xu(e) {
  try {
    return e.matches(":focus-visible");
  } catch {
    process.env.NODE_ENV !== "production" && !/jsdom/.test(window.navigator.userAgent) && console.warn(["MUI: The `:focus-visible` pseudo class is not supported in this browser.", "Some components rely on this feature to work properly."].join(`
`));
  }
  return !1;
}
function j1(e = window) {
  const t = e.document.documentElement.clientWidth;
  return e.innerWidth - t;
}
const Pj = (e) => {
  const t = w.useRef({});
  return w.useEffect(() => {
    t.current = e;
  }), t.current;
}, Dj = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px"
};
function Mj(e) {
  const t = typeof e;
  switch (t) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";
    case "object":
      return e === null ? "null" : e.constructor.name;
    default:
      return t;
  }
}
function $1(e, t, n, r) {
  const i = e[t];
  if (i == null || !Number.isInteger(i)) {
    const a = Mj(i);
    return new RangeError(`Invalid ${r} \`${t}\` of type \`${a}\` supplied to \`${n}\`, expected \`integer\`.`);
  }
  return null;
}
function A1(e, t, ...n) {
  return e[t] === void 0 ? null : $1(e, t, ...n);
}
function Mm() {
  return null;
}
A1.isRequired = $1;
Mm.isRequired = Mm;
const yh = process.env.NODE_ENV === "production" ? Mm : A1;
function We(e, t, n = void 0) {
  const r = {};
  for (const i in e) {
    const a = e[i];
    let l = "", u = !0;
    for (let d = 0; d < a.length; d += 1) {
      const p = a[d];
      p && (l += (u === !0 ? "" : " ") + t(p), u = !1, n && n[p] && (l += " " + n[p]));
    }
    r[i] = l;
  }
  return r;
}
function _j(e) {
  return typeof e == "string";
}
function N1(e, t, n) {
  return e === void 0 || _j(e) ? t : {
    ...t,
    ownerState: {
      ...t.ownerState,
      ...n
    }
  };
}
function F1(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((r) => r.match(/^on[A-Z]/) && typeof e[r] == "function" && !t.includes(r)).forEach((r) => {
    n[r] = e[r];
  }), n;
}
function zv(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function L1(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: r,
    externalForwardedProps: i,
    className: a
  } = e;
  if (!t) {
    const v = Me(n == null ? void 0 : n.className, a, i == null ? void 0 : i.className, r == null ? void 0 : r.className), b = {
      ...n == null ? void 0 : n.style,
      ...i == null ? void 0 : i.style,
      ...r == null ? void 0 : r.style
    }, y = {
      ...n,
      ...i,
      ...r
    };
    return v.length > 0 && (y.className = v), Object.keys(b).length > 0 && (y.style = b), {
      props: y,
      internalRef: void 0
    };
  }
  const l = F1({
    ...i,
    ...r
  }), u = zv(r), d = zv(i), p = t(l), m = Me(p == null ? void 0 : p.className, n == null ? void 0 : n.className, a, i == null ? void 0 : i.className, r == null ? void 0 : r.className), h = {
    ...p == null ? void 0 : p.style,
    ...n == null ? void 0 : n.style,
    ...i == null ? void 0 : i.style,
    ...r == null ? void 0 : r.style
  }, g = {
    ...p,
    ...n,
    ...d,
    ...u
  };
  return m.length > 0 && (g.className = m), Object.keys(h).length > 0 && (g.style = h), {
    props: g,
    internalRef: p.ref
  };
}
function cd(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
function Nt(e) {
  var h;
  const {
    elementType: t,
    externalSlotProps: n,
    ownerState: r,
    skipResolvingSlotProps: i = !1,
    ...a
  } = e, l = i ? {} : cd(n, r), {
    props: u,
    internalRef: d
  } = L1({
    ...a,
    externalSlotProps: l
  }), p = It(d, l == null ? void 0 : l.ref, (h = e.additionalProps) == null ? void 0 : h.ref);
  return N1(t, {
    ...u,
    ref: p
  }, r);
}
function us(e) {
  var t;
  return parseInt(w.version, 10) >= 19 ? ((t = e == null ? void 0 : e.props) == null ? void 0 : t.ref) || null : (e == null ? void 0 : e.ref) || null;
}
const bh = /* @__PURE__ */ w.createContext(null);
process.env.NODE_ENV !== "production" && (bh.displayName = "ThemeContext");
function vh() {
  const e = w.useContext(bh);
  return process.env.NODE_ENV !== "production" && w.useDebugValue(e), e;
}
const Ij = typeof Symbol == "function" && Symbol.for, jj = Ij ? Symbol.for("mui.nested") : "__THEME_NESTED__";
function $j(e, t) {
  if (typeof t == "function") {
    const n = t(e);
    return process.env.NODE_ENV !== "production" && (n || console.error(["MUI: You should return an object from your theme function, i.e.", "<ThemeProvider theme={() => ({})} />"].join(`
`))), n;
  }
  return {
    ...e,
    ...t
  };
}
function wu(e) {
  const {
    children: t,
    theme: n
  } = e, r = vh();
  process.env.NODE_ENV !== "production" && r === null && typeof n == "function" && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const i = w.useMemo(() => {
    const a = r === null ? {
      ...n
    } : $j(r, n);
    return a != null && (a[jj] = r !== null), a;
  }, [n, r]);
  return /* @__PURE__ */ x.jsx(bh.Provider, {
    value: i,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (wu.propTypes = {
  /**
   * Your component tree.
   */
  children: o.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: o.oneOfType([o.object, o.func]).isRequired
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (wu.propTypes = sd(wu.propTypes));
const B1 = /* @__PURE__ */ w.createContext();
function V1({
  value: e,
  ...t
}) {
  return /* @__PURE__ */ x.jsx(B1.Provider, {
    value: e ?? !0,
    ...t
  });
}
process.env.NODE_ENV !== "production" && (V1.propTypes = {
  children: o.node,
  value: o.bool
});
const eo = () => w.useContext(B1) ?? !1, z1 = /* @__PURE__ */ w.createContext(void 0);
function W1({
  value: e,
  children: t
}) {
  return /* @__PURE__ */ x.jsx(z1.Provider, {
    value: e,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (W1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: o.node,
  /**
   * @ignore
   */
  value: o.object
});
function Aj(e) {
  const {
    theme: t,
    name: n,
    props: r
  } = e;
  if (!t || !t.components || !t.components[n])
    return r;
  const i = t.components[n];
  return i.defaultProps ? dl(i.defaultProps, r) : !i.styleOverrides && !i.variants ? dl(i, r) : r;
}
function Nj({
  props: e,
  name: t
}) {
  const n = w.useContext(z1);
  return Aj({
    props: e,
    name: t,
    theme: {
      components: n
    }
  });
}
const Wv = {};
function qv(e, t, n, r = !1) {
  return w.useMemo(() => {
    const i = e && t[e] || t;
    if (typeof n == "function") {
      const a = n(i), l = e ? {
        ...t,
        [e]: a
      } : a;
      return r ? () => l : l;
    }
    return e ? {
      ...t,
      [e]: n
    } : {
      ...t,
      ...n
    };
  }, [e, t, n, r]);
}
function pl(e) {
  const {
    children: t,
    theme: n,
    themeId: r
  } = e, i = fh(Wv), a = vh() || Wv;
  process.env.NODE_ENV !== "production" && (i === null && typeof n == "function" || r && i && !i[r] && typeof n == "function") && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const l = qv(r, i, n), u = qv(r, a, n, !0), d = (r ? l[r] : l).direction === "rtl";
  return /* @__PURE__ */ x.jsx(wu, {
    theme: u,
    children: /* @__PURE__ */ x.jsx(Dl.Provider, {
      value: l,
      children: /* @__PURE__ */ x.jsx(V1, {
        value: d,
        children: /* @__PURE__ */ x.jsx(W1, {
          value: r ? l[r].components : l.components,
          children: t
        })
      })
    })
  });
}
process.env.NODE_ENV !== "production" && (pl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Your component tree.
   */
  children: o.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: o.oneOfType([o.func, o.object]).isRequired,
  /**
   * The design system's unique id for getting the corresponded theme when there are multiple design systems.
   */
  themeId: o.string
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (pl.propTypes = sd(pl.propTypes));
const Hv = {
  theme: void 0
};
function Fj(e) {
  let t, n;
  return function(i) {
    let a = t;
    return (a === void 0 || i.theme !== n) && (Hv.theme = i.theme, a = S1(e(Hv)), t = a, n = i.theme), a;
  };
}
const xh = "mode", wh = "color-scheme", Lj = "data-color-scheme";
function Bj(e) {
  const {
    defaultMode: t = "system",
    defaultLightColorScheme: n = "light",
    defaultDarkColorScheme: r = "dark",
    modeStorageKey: i = xh,
    colorSchemeStorageKey: a = wh,
    attribute: l = Lj,
    colorSchemeNode: u = "document.documentElement",
    nonce: d
  } = e || {};
  let p = "", m = l;
  if (l === "class" && (m = ".%s"), l === "data" && (m = "[data-%s]"), m.startsWith(".")) {
    const g = m.substring(1);
    p += `${u}.classList.remove('${g}'.replace('%s', light), '${g}'.replace('%s', dark));
      ${u}.classList.add('${g}'.replace('%s', colorScheme));`;
  }
  const h = m.match(/\[([^\]]+)\]/);
  if (h) {
    const [g, v] = h[1].split("=");
    v || (p += `${u}.removeAttribute('${g}'.replace('%s', light));
      ${u}.removeAttribute('${g}'.replace('%s', dark));`), p += `
      ${u}.setAttribute('${g}'.replace('%s', colorScheme), ${v ? `${v}.replace('%s', colorScheme)` : '""'});`;
  } else
    p += `${u}.setAttribute('${m}', colorScheme);`;
  return /* @__PURE__ */ x.jsx("script", {
    suppressHydrationWarning: !0,
    nonce: typeof window > "u" ? d : "",
    dangerouslySetInnerHTML: {
      __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${i}') || '${t}';
  const dark = localStorage.getItem('${a}-dark') || '${r}';
  const light = localStorage.getItem('${a}-light') || '${n}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${p}
  }
} catch(e){}})();`
    }
  }, "mui-color-scheme-init");
}
function Uv(e) {
  if (typeof window < "u" && typeof window.matchMedia == "function" && e === "system")
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
function q1(e, t) {
  if (e.mode === "light" || e.mode === "system" && e.systemMode === "light")
    return t("light");
  if (e.mode === "dark" || e.mode === "system" && e.systemMode === "dark")
    return t("dark");
}
function Vj(e) {
  return q1(e, (t) => {
    if (t === "light")
      return e.lightColorScheme;
    if (t === "dark")
      return e.darkColorScheme;
  });
}
function lf(e, t) {
  if (typeof window > "u")
    return;
  let n;
  try {
    n = localStorage.getItem(e) || void 0, n || localStorage.setItem(e, t);
  } catch {
  }
  return n || t;
}
function zj(e) {
  const {
    defaultMode: t = "light",
    defaultLightColorScheme: n,
    defaultDarkColorScheme: r,
    supportedColorSchemes: i = [],
    modeStorageKey: a = xh,
    colorSchemeStorageKey: l = wh,
    storageWindow: u = typeof window > "u" ? void 0 : window,
    noSsr: d = !1
  } = e, p = i.join(","), m = i.length > 1, [h, g] = w.useState(() => {
    const R = lf(a, t), E = lf(`${l}-light`, n), M = lf(`${l}-dark`, r);
    return {
      mode: R,
      systemMode: Uv(R),
      lightColorScheme: E,
      darkColorScheme: M
    };
  }), [v, b] = w.useState(d || !m);
  w.useEffect(() => {
    b(!0);
  }, []);
  const y = Vj(h), S = w.useCallback((R) => {
    g((E) => {
      if (R === E.mode)
        return E;
      const M = R ?? t;
      try {
        localStorage.setItem(a, M);
      } catch {
      }
      return {
        ...E,
        mode: M,
        systemMode: Uv(M)
      };
    });
  }, [a, t]), O = w.useCallback((R) => {
    R ? typeof R == "string" ? R && !p.includes(R) ? console.error(`\`${R}\` does not exist in \`theme.colorSchemes\`.`) : g((E) => {
      const M = {
        ...E
      };
      return q1(E, (_) => {
        try {
          localStorage.setItem(`${l}-${_}`, R);
        } catch {
        }
        _ === "light" && (M.lightColorScheme = R), _ === "dark" && (M.darkColorScheme = R);
      }), M;
    }) : g((E) => {
      const M = {
        ...E
      }, _ = R.light === null ? n : R.light, I = R.dark === null ? r : R.dark;
      if (_)
        if (!p.includes(_))
          console.error(`\`${_}\` does not exist in \`theme.colorSchemes\`.`);
        else {
          M.lightColorScheme = _;
          try {
            localStorage.setItem(`${l}-light`, _);
          } catch {
          }
        }
      if (I)
        if (!p.includes(I))
          console.error(`\`${I}\` does not exist in \`theme.colorSchemes\`.`);
        else {
          M.darkColorScheme = I;
          try {
            localStorage.setItem(`${l}-dark`, I);
          } catch {
          }
        }
      return M;
    }) : g((E) => {
      try {
        localStorage.setItem(`${l}-light`, n), localStorage.setItem(`${l}-dark`, r);
      } catch {
      }
      return {
        ...E,
        lightColorScheme: n,
        darkColorScheme: r
      };
    });
  }, [p, l, n, r]), P = w.useCallback((R) => {
    h.mode === "system" && g((E) => {
      const M = R != null && R.matches ? "dark" : "light";
      return E.systemMode === M ? E : {
        ...E,
        systemMode: M
      };
    });
  }, [h.mode]), k = w.useRef(P);
  return k.current = P, w.useEffect(() => {
    if (typeof window.matchMedia != "function" || !m)
      return;
    const R = (...M) => k.current(...M), E = window.matchMedia("(prefers-color-scheme: dark)");
    return E.addListener(R), R(E), () => {
      E.removeListener(R);
    };
  }, [m]), w.useEffect(() => {
    if (u && m) {
      const R = (E) => {
        const M = E.newValue;
        typeof E.key == "string" && E.key.startsWith(l) && (!M || p.match(M)) && (E.key.endsWith("light") && O({
          light: M
        }), E.key.endsWith("dark") && O({
          dark: M
        })), E.key === a && (!M || ["light", "dark", "system"].includes(M)) && S(M || t);
      };
      return u.addEventListener("storage", R), () => {
        u.removeEventListener("storage", R);
      };
    }
  }, [O, S, a, l, p, t, u, m]), {
    ...h,
    mode: v ? h.mode : void 0,
    systemMode: v ? h.systemMode : void 0,
    colorScheme: v ? y : void 0,
    setMode: S,
    setColorScheme: O
  };
}
const Wj = "*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}";
function qj(e) {
  const {
    themeId: t,
    /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */
    theme: n = {},
    modeStorageKey: r = xh,
    colorSchemeStorageKey: i = wh,
    disableTransitionOnChange: a = !1,
    defaultColorScheme: l,
    resolveTheme: u
  } = e, d = {
    allColorSchemes: [],
    colorScheme: void 0,
    darkColorScheme: void 0,
    lightColorScheme: void 0,
    mode: void 0,
    setColorScheme: () => {
    },
    setMode: () => {
    },
    systemMode: void 0
  }, p = /* @__PURE__ */ w.createContext(void 0);
  process.env.NODE_ENV !== "production" && (p.displayName = "ColorSchemeContext");
  const m = () => w.useContext(p) || d, h = {}, g = {};
  function v(O) {
    var Dt, Re, $e, dt;
    const {
      children: P,
      theme: k,
      modeStorageKey: R = r,
      colorSchemeStorageKey: E = i,
      disableTransitionOnChange: M = a,
      storageWindow: _ = typeof window > "u" ? void 0 : window,
      documentNode: I = typeof document > "u" ? void 0 : document,
      colorSchemeNode: F = typeof document > "u" ? void 0 : document.documentElement,
      disableNestedContext: T = !1,
      disableStyleSheetGeneration: $ = !1,
      defaultMode: N = "system",
      noSsr: W
    } = O, L = w.useRef(!1), V = vh(), z = w.useContext(p), X = !!z && !T, le = w.useMemo(() => k || (typeof n == "function" ? n() : n), [k]), ne = le[t], G = ne || le, {
      colorSchemes: Q = h,
      components: be = g,
      cssVarPrefix: we
    } = G, se = Object.keys(Q).filter((He) => !!Q[He]).join(","), U = w.useMemo(() => se.split(","), [se]), de = typeof l == "string" ? l : l.light, ce = typeof l == "string" ? l : l.dark, K = Q[de] && Q[ce] ? N : ((Re = (Dt = Q[G.defaultColorScheme]) == null ? void 0 : Dt.palette) == null ? void 0 : Re.mode) || (($e = G.palette) == null ? void 0 : $e.mode), {
      mode: Z,
      setMode: ue,
      systemMode: he,
      lightColorScheme: B,
      darkColorScheme: ee,
      colorScheme: ie,
      setColorScheme: ge
    } = zj({
      supportedColorSchemes: U,
      defaultLightColorScheme: de,
      defaultDarkColorScheme: ce,
      modeStorageKey: R,
      colorSchemeStorageKey: E,
      defaultMode: K,
      storageWindow: _,
      noSsr: W
    });
    let xe = Z, pe = ie;
    X && (xe = z.mode, pe = z.colorScheme);
    const Ee = w.useMemo(() => {
      var nt;
      const He = pe || G.defaultColorScheme, Je = ((nt = G.generateThemeVars) == null ? void 0 : nt.call(G)) || G.vars, Ze = {
        ...G,
        components: be,
        colorSchemes: Q,
        cssVarPrefix: we,
        vars: Je
      };
      if (typeof Ze.generateSpacing == "function" && (Ze.spacing = Ze.generateSpacing()), He) {
        const Ne = Q[He];
        Ne && typeof Ne == "object" && Object.keys(Ne).forEach((Ct) => {
          Ne[Ct] && typeof Ne[Ct] == "object" ? Ze[Ct] = {
            ...Ze[Ct],
            ...Ne[Ct]
          } : Ze[Ct] = Ne[Ct];
        });
      }
      return u ? u(Ze) : Ze;
    }, [G, pe, be, Q, we]), Pe = G.colorSchemeSelector;
    An(() => {
      if (pe && F && Pe && Pe !== "media") {
        const He = Pe;
        let Je = Pe;
        if (He === "class" && (Je = ".%s"), He === "data" && (Je = "[data-%s]"), He != null && He.startsWith("data-") && !He.includes("%s") && (Je = `[${He}="%s"]`), Je.startsWith("."))
          F.classList.remove(...U.map((Ze) => Je.substring(1).replace("%s", Ze))), F.classList.add(Je.substring(1).replace("%s", pe));
        else {
          const Ze = Je.replace("%s", pe).match(/\[([^\]]+)\]/);
          if (Ze) {
            const [nt, Ne] = Ze[1].split("=");
            Ne || U.forEach((Ct) => {
              F.removeAttribute(nt.replace(pe, Ct));
            }), F.setAttribute(nt, Ne ? Ne.replace(/"|'/g, "") : "");
          } else
            F.setAttribute(Je, pe);
        }
      }
    }, [pe, Pe, F, U]), w.useEffect(() => {
      let He;
      if (M && L.current && I) {
        const Je = I.createElement("style");
        Je.appendChild(I.createTextNode(Wj)), I.head.appendChild(Je), window.getComputedStyle(I.body), He = setTimeout(() => {
          I.head.removeChild(Je);
        }, 1);
      }
      return () => {
        clearTimeout(He);
      };
    }, [pe, M, I]), w.useEffect(() => (L.current = !0, () => {
      L.current = !1;
    }), []);
    const Be = w.useMemo(() => ({
      allColorSchemes: U,
      colorScheme: pe,
      darkColorScheme: ee,
      lightColorScheme: B,
      mode: xe,
      setColorScheme: ge,
      setMode: process.env.NODE_ENV === "production" ? ue : (He) => {
        Ee.colorSchemeSelector === "media" && console.error(["MUI: The `setMode` function has no effect if `colorSchemeSelector` is `media` (`media` is the default value).", "To toggle the mode manually, please configure `colorSchemeSelector` to use a class or data attribute.", "To learn more, visit https://mui.com/material-ui/customization/css-theme-variables/configuration/#toggling-dark-mode-manually"].join(`
`)), ue(He);
      },
      systemMode: he
    }), [U, pe, ee, B, xe, ge, ue, he, Ee.colorSchemeSelector]);
    let Ge = !0;
    ($ || G.cssVariables === !1 || X && (V == null ? void 0 : V.cssVarPrefix) === we) && (Ge = !1);
    const Ie = /* @__PURE__ */ x.jsxs(w.Fragment, {
      children: [/* @__PURE__ */ x.jsx(pl, {
        themeId: ne ? t : void 0,
        theme: Ee,
        children: P
      }), Ge && /* @__PURE__ */ x.jsx(dh, {
        styles: ((dt = Ee.generateStyleSheets) == null ? void 0 : dt.call(Ee)) || []
      })]
    });
    return X ? Ie : /* @__PURE__ */ x.jsx(p.Provider, {
      value: Be,
      children: Ie
    });
  }
  process.env.NODE_ENV !== "production" && (v.propTypes = {
    /**
     * The component tree.
     */
    children: o.node,
    /**
     * The node used to attach the color-scheme attribute
     */
    colorSchemeNode: o.any,
    /**
     * localStorage key used to store `colorScheme`
     */
    colorSchemeStorageKey: o.string,
    /**
     * The default mode when the storage is empty,
     * require the theme to have `colorSchemes` with light and dark.
     */
    defaultMode: o.string,
    /**
     * If `true`, the provider creates its own context and generate stylesheet as if it is a root `CssVarsProvider`.
     */
    disableNestedContext: o.bool,
    /**
     * If `true`, the style sheet won't be generated.
     *
     * This is useful for controlling nested CssVarsProvider behavior.
     */
    disableStyleSheetGeneration: o.bool,
    /**
     * Disable CSS transitions when switching between modes or color schemes.
     */
    disableTransitionOnChange: o.bool,
    /**
     * The document to attach the attribute to.
     */
    documentNode: o.any,
    /**
     * The key in the local storage used to store current color scheme.
     */
    modeStorageKey: o.string,
    /**
     * If `true`, the mode will be the same value as the storage without an extra rerendering after the hydration.
     * You should use this option in conjuction with `InitColorSchemeScript` component.
     */
    noSsr: o.bool,
    /**
     * The window that attaches the 'storage' event listener.
     * @default window
     */
    storageWindow: o.any,
    /**
     * The calculated theme object that will be passed through context.
     */
    theme: o.object
  });
  const b = typeof l == "string" ? l : l.light, y = typeof l == "string" ? l : l.dark;
  return {
    CssVarsProvider: v,
    useColorScheme: m,
    getInitColorSchemeScript: (O) => Bj({
      colorSchemeStorageKey: i,
      defaultLightColorScheme: b,
      defaultDarkColorScheme: y,
      modeStorageKey: r,
      ...O
    })
  };
}
function Hj(e = "") {
  function t(...r) {
    if (!r.length)
      return "";
    const i = r[0];
    return typeof i == "string" && !i.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/) ? `, var(--${e ? `${e}-` : ""}${i}${t(...r.slice(1))})` : `, ${i}`;
  }
  return (r, ...i) => `var(--${e ? `${e}-` : ""}${r}${t(...i)})`;
}
const Yv = (e, t, n, r = []) => {
  let i = e;
  t.forEach((a, l) => {
    l === t.length - 1 ? Array.isArray(i) ? i[Number(a)] = n : i && typeof i == "object" && (i[a] = n) : i && typeof i == "object" && (i[a] || (i[a] = r.includes(a) ? [] : {}), i = i[a]);
  });
}, Uj = (e, t, n) => {
  function r(i, a = [], l = []) {
    Object.entries(i).forEach(([u, d]) => {
      (!n || n && !n([...a, u])) && d != null && (typeof d == "object" && Object.keys(d).length > 0 ? r(d, [...a, u], Array.isArray(d) ? [...l, u] : l) : t([...a, u], d, l));
    });
  }
  r(e);
}, Yj = (e, t) => typeof t == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((r) => e.includes(r)) || e[e.length - 1].toLowerCase().includes("opacity") ? t : `${t}px` : t;
function cf(e, t) {
  const {
    prefix: n,
    shouldSkipGeneratingVar: r
  } = t || {}, i = {}, a = {}, l = {};
  return Uj(
    e,
    (u, d, p) => {
      if ((typeof d == "string" || typeof d == "number") && (!r || !r(u, d))) {
        const m = `--${n ? `${n}-` : ""}${u.join("-")}`, h = Yj(u, d);
        Object.assign(i, {
          [m]: h
        }), Yv(a, u, `var(${m})`, p), Yv(l, u, `var(${m}, ${h})`, p);
      }
    },
    (u) => u[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: i,
    vars: a,
    varsWithDefaults: l
  };
}
function Gj(e, t = {}) {
  const {
    getSelector: n = S,
    disableCssColorScheme: r,
    colorSchemeSelector: i
  } = t, {
    colorSchemes: a = {},
    components: l,
    defaultColorScheme: u = "light",
    ...d
  } = e, {
    vars: p,
    css: m,
    varsWithDefaults: h
  } = cf(d, t);
  let g = h;
  const v = {}, {
    [u]: b,
    ...y
  } = a;
  if (Object.entries(y || {}).forEach(([k, R]) => {
    const {
      vars: E,
      css: M,
      varsWithDefaults: _
    } = cf(R, t);
    g = Bn(g, _), v[k] = {
      css: M,
      vars: E
    };
  }), b) {
    const {
      css: k,
      vars: R,
      varsWithDefaults: E
    } = cf(b, t);
    g = Bn(g, E), v[u] = {
      css: k,
      vars: R
    };
  }
  function S(k, R) {
    var M, _;
    let E = i;
    if (i === "class" && (E = ".%s"), i === "data" && (E = "[data-%s]"), i != null && i.startsWith("data-") && !i.includes("%s") && (E = `[${i}="%s"]`), k) {
      if (E === "media")
        return e.defaultColorScheme === k ? ":root" : {
          [`@media (prefers-color-scheme: ${((_ = (M = a[k]) == null ? void 0 : M.palette) == null ? void 0 : _.mode) || k})`]: {
            ":root": R
          }
        };
      if (E)
        return e.defaultColorScheme === k ? `:root, ${E.replace("%s", String(k))}` : E.replace("%s", String(k));
    }
    return ":root";
  }
  return {
    vars: g,
    generateThemeVars: () => {
      let k = {
        ...p
      };
      return Object.entries(v).forEach(([, {
        vars: R
      }]) => {
        k = Bn(k, R);
      }), k;
    },
    generateStyleSheets: () => {
      var I, F;
      const k = [], R = e.defaultColorScheme || "light";
      function E(T, $) {
        Object.keys($).length && k.push(typeof T == "string" ? {
          [T]: {
            ...$
          }
        } : T);
      }
      E(n(void 0, {
        ...m
      }), m);
      const {
        [R]: M,
        ..._
      } = v;
      if (M) {
        const {
          css: T
        } = M, $ = (F = (I = a[R]) == null ? void 0 : I.palette) == null ? void 0 : F.mode, N = !r && $ ? {
          colorScheme: $,
          ...T
        } : {
          ...T
        };
        E(n(R, {
          ...N
        }), N);
      }
      return Object.entries(_).forEach(([T, {
        css: $
      }]) => {
        var L, V;
        const N = (V = (L = a[T]) == null ? void 0 : L.palette) == null ? void 0 : V.mode, W = !r && N ? {
          colorScheme: N,
          ...$
        } : {
          ...$
        };
        E(n(T, {
          ...W
        }), W);
      }), k;
    }
  };
}
function Kj(e) {
  return function(n) {
    return e === "media" ? (process.env.NODE_ENV !== "production" && n !== "light" && n !== "dark" && console.error(`MUI: @media (prefers-color-scheme) supports only 'light' or 'dark', but receive '${n}'.`), `@media (prefers-color-scheme: ${n})`) : e ? e.startsWith("data-") && !e.includes("%s") ? `[${e}="${n}"] &` : e === "class" ? `.${n} &` : e === "data" ? `[data-${n}] &` : `${e.replace("%s", n)} &` : "&";
  };
}
const Xj = (e, t) => e.filter((n) => t.includes(n)), ds = (e, t, n) => {
  const r = e.keys[0];
  Array.isArray(t) ? t.forEach((i, a) => {
    n((l, u) => {
      a <= e.keys.length - 1 && (a === 0 ? Object.assign(l, u) : l[e.up(e.keys[a])] = u);
    }, i);
  }) : t && typeof t == "object" ? (Object.keys(t).length > e.keys.length ? e.keys : Xj(e.keys, Object.keys(t))).forEach((a) => {
    if (e.keys.includes(a)) {
      const l = t[a];
      l !== void 0 && n((u, d) => {
        r === a ? Object.assign(u, d) : u[e.up(a)] = d;
      }, l);
    }
  }) : (typeof t == "number" || typeof t == "string") && n((i, a) => {
    Object.assign(i, a);
  }, t);
};
function Cu(e) {
  return `--Grid-${e}Spacing`;
}
function ud(e) {
  return `--Grid-parent-${e}Spacing`;
}
const Gv = "--Grid-columns", Ya = "--Grid-parent-columns", Qj = ({
  theme: e,
  ownerState: t
}) => {
  const n = {};
  return ds(e.breakpoints, t.size, (r, i) => {
    let a = {};
    i === "grow" && (a = {
      flexBasis: 0,
      flexGrow: 1,
      maxWidth: "100%"
    }), i === "auto" && (a = {
      flexBasis: "auto",
      flexGrow: 0,
      flexShrink: 0,
      maxWidth: "none",
      width: "auto"
    }), typeof i == "number" && (a = {
      flexGrow: 0,
      flexBasis: "auto",
      width: `calc(100% * ${i} / var(${Ya}) - (var(${Ya}) - ${i}) * (var(${ud("column")}) / var(${Ya})))`
    }), r(n, a);
  }), n;
}, Zj = ({
  theme: e,
  ownerState: t
}) => {
  const n = {};
  return ds(e.breakpoints, t.offset, (r, i) => {
    let a = {};
    i === "auto" && (a = {
      marginLeft: "auto"
    }), typeof i == "number" && (a = {
      marginLeft: i === 0 ? "0px" : `calc(100% * ${i} / var(${Ya}) + var(${ud("column")}) * ${i} / var(${Ya}))`
    }), r(n, a);
  }), n;
}, Jj = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {
    [Gv]: 12
  };
  return ds(e.breakpoints, t.columns, (r, i) => {
    const a = i ?? 12;
    r(n, {
      [Gv]: a,
      "> *": {
        [Ya]: a
      }
    });
  }), n;
}, e$ = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {};
  return ds(e.breakpoints, t.rowSpacing, (r, i) => {
    var l;
    const a = typeof i == "string" ? i : (l = e.spacing) == null ? void 0 : l.call(e, i);
    r(n, {
      [Cu("row")]: a,
      "> *": {
        [ud("row")]: a
      }
    });
  }), n;
}, t$ = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {};
  return ds(e.breakpoints, t.columnSpacing, (r, i) => {
    var l;
    const a = typeof i == "string" ? i : (l = e.spacing) == null ? void 0 : l.call(e, i);
    r(n, {
      [Cu("column")]: a,
      "> *": {
        [ud("column")]: a
      }
    });
  }), n;
}, n$ = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {};
  return ds(e.breakpoints, t.direction, (r, i) => {
    r(n, {
      flexDirection: i
    });
  }), n;
}, r$ = ({
  ownerState: e
}) => ({
  minWidth: 0,
  boxSizing: "border-box",
  ...e.container && {
    display: "flex",
    flexWrap: "wrap",
    ...e.wrap && e.wrap !== "wrap" && {
      flexWrap: e.wrap
    },
    gap: `var(${Cu("row")}) var(${Cu("column")})`
  }
}), o$ = (e) => {
  const t = [];
  return Object.entries(e).forEach(([n, r]) => {
    r !== !1 && r !== void 0 && t.push(`grid-${n}-${String(r)}`);
  }), t;
}, i$ = (e, t = "xs") => {
  function n(r) {
    return r === void 0 ? !1 : typeof r == "string" && !Number.isNaN(Number(r)) || typeof r == "number" && r > 0;
  }
  if (n(e))
    return [`spacing-${t}-${String(e)}`];
  if (typeof e == "object" && !Array.isArray(e)) {
    const r = [];
    return Object.entries(e).forEach(([i, a]) => {
      n(a) && r.push(`spacing-${i}-${String(a)}`);
    }), r;
  }
  return [];
}, a$ = (e) => e === void 0 ? [] : typeof e == "object" ? Object.entries(e).map(([t, n]) => `direction-${t}-${n}`) : [`direction-xs-${String(e)}`], s$ = jl(), l$ = R1("div", {
  name: "MuiGrid",
  slot: "Root",
  overridesResolver: (e, t) => t.root
});
function c$(e) {
  return mh({
    props: e,
    name: "MuiGrid",
    defaultTheme: s$
  });
}
function u$(e = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: t = l$,
    useThemeProps: n = c$,
    useTheme: r = $l,
    componentName: i = "MuiGrid"
  } = e, a = (p, m) => {
    const {
      container: h,
      direction: g,
      spacing: v,
      wrap: b,
      size: y
    } = p, S = {
      root: ["root", h && "container", b !== "wrap" && `wrap-xs-${String(b)}`, ...a$(g), ...o$(y), ...h ? i$(v, m.breakpoints.keys[0]) : []]
    };
    return We(S, (O) => ze(i, O), {});
  };
  function l(p, m, h = () => !0) {
    const g = {};
    return p === null || (Array.isArray(p) ? p.forEach((v, b) => {
      v !== null && h(v) && m.keys[b] && (g[m.keys[b]] = v);
    }) : typeof p == "object" ? Object.keys(p).forEach((v) => {
      const b = p[v];
      b != null && h(b) && (g[v] = b);
    }) : g[m.keys[0]] = p), g;
  }
  const u = t(Jj, t$, e$, Qj, n$, r$, Zj), d = /* @__PURE__ */ w.forwardRef(function(m, h) {
    const g = r(), v = n(m), b = nd(v), {
      className: y,
      children: S,
      columns: O = 12,
      container: P = !1,
      component: k = "div",
      direction: R = "row",
      wrap: E = "wrap",
      size: M = {},
      offset: _ = {},
      spacing: I = 0,
      rowSpacing: F = I,
      columnSpacing: T = I,
      unstable_level: $ = 0,
      ...N
    } = b, W = l(M, g.breakpoints, (Q) => Q !== !1), L = l(_, g.breakpoints), V = m.columns ?? ($ ? void 0 : O), z = m.spacing ?? ($ ? void 0 : I), X = m.rowSpacing ?? m.spacing ?? ($ ? void 0 : F), le = m.columnSpacing ?? m.spacing ?? ($ ? void 0 : T), ne = {
      ...b,
      level: $,
      columns: V,
      container: P,
      direction: R,
      wrap: E,
      spacing: z,
      rowSpacing: X,
      columnSpacing: le,
      size: W,
      offset: L
    }, G = a(ne, g);
    return /* @__PURE__ */ x.jsx(u, {
      ref: h,
      as: k,
      ownerState: ne,
      className: Me(G.root, y),
      ...N,
      children: w.Children.map(S, (Q) => {
        var be;
        return /* @__PURE__ */ w.isValidElement(Q) && Ua(Q, ["Grid"]) && P && Q.props.container ? /* @__PURE__ */ w.cloneElement(Q, {
          unstable_level: ((be = Q.props) == null ? void 0 : be.unstable_level) ?? $ + 1
        }) : Q;
      })
    });
  });
  return process.env.NODE_ENV !== "production" && (d.propTypes = {
    children: o.node,
    className: o.string,
    columns: o.oneOfType([o.arrayOf(o.number), o.number, o.object]),
    columnSpacing: o.oneOfType([o.arrayOf(o.oneOfType([o.number, o.string])), o.number, o.object, o.string]),
    component: o.elementType,
    container: o.bool,
    direction: o.oneOfType([o.oneOf(["column-reverse", "column", "row-reverse", "row"]), o.arrayOf(o.oneOf(["column-reverse", "column", "row-reverse", "row"])), o.object]),
    offset: o.oneOfType([o.string, o.number, o.arrayOf(o.oneOfType([o.string, o.number])), o.object]),
    rowSpacing: o.oneOfType([o.arrayOf(o.oneOfType([o.number, o.string])), o.number, o.object, o.string]),
    size: o.oneOfType([o.string, o.bool, o.number, o.arrayOf(o.oneOfType([o.string, o.bool, o.number])), o.object]),
    spacing: o.oneOfType([o.arrayOf(o.oneOfType([o.number, o.string])), o.number, o.object, o.string]),
    sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
    wrap: o.oneOf(["nowrap", "wrap-reverse", "wrap"])
  }), d.muiName = "Grid", d;
}
const d$ = jl(), p$ = R1("div", {
  name: "MuiStack",
  slot: "Root",
  overridesResolver: (e, t) => t.root
});
function f$(e) {
  return mh({
    props: e,
    name: "MuiStack",
    defaultTheme: d$
  });
}
function m$(e, t) {
  const n = w.Children.toArray(e).filter(Boolean);
  return n.reduce((r, i, a) => (r.push(i), a < n.length - 1 && r.push(/* @__PURE__ */ w.cloneElement(t, {
    key: `separator-${a}`
  })), r), []);
}
const h$ = (e) => ({
  row: "Left",
  "row-reverse": "Right",
  column: "Top",
  "column-reverse": "Bottom"
})[e], g$ = ({
  ownerState: e,
  theme: t
}) => {
  let n = {
    display: "flex",
    flexDirection: "column",
    ...po({
      theme: t
    }, sf({
      values: e.direction,
      breakpoints: t.breakpoints.values
    }), (r) => ({
      flexDirection: r
    }))
  };
  if (e.spacing) {
    const r = Xu(t), i = Object.keys(t.breakpoints.values).reduce((d, p) => ((typeof e.spacing == "object" && e.spacing[p] != null || typeof e.direction == "object" && e.direction[p] != null) && (d[p] = !0), d), {}), a = sf({
      values: e.direction,
      base: i
    }), l = sf({
      values: e.spacing,
      base: i
    });
    typeof a == "object" && Object.keys(a).forEach((d, p, m) => {
      if (!a[d]) {
        const g = p > 0 ? a[m[p - 1]] : "column";
        a[d] = g;
      }
    }), n = Bn(n, po({
      theme: t
    }, l, (d, p) => e.useFlexGap ? {
      gap: da(r, d)
    } : {
      // The useFlexGap={false} implement relies on each child to give up control of the margin.
      // We need to reset the margin to avoid double spacing.
      "& > :not(style):not(style)": {
        margin: 0
      },
      "& > :not(style) ~ :not(style)": {
        [`margin${h$(p ? a[p] : e.direction)}`]: da(r, d)
      }
    }));
  }
  return n = cI(t.breakpoints, n), n;
};
function y$(e = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: t = p$,
    useThemeProps: n = f$,
    componentName: r = "MuiStack"
  } = e, i = () => We({
    root: ["root"]
  }, (d) => ze(r, d), {}), a = t(g$), l = /* @__PURE__ */ w.forwardRef(function(d, p) {
    const m = n(d), h = nd(m), {
      component: g = "div",
      direction: v = "column",
      spacing: b = 0,
      divider: y,
      children: S,
      className: O,
      useFlexGap: P = !1,
      ...k
    } = h, R = {
      direction: v,
      spacing: b,
      useFlexGap: P
    }, E = i();
    return /* @__PURE__ */ x.jsx(a, {
      as: g,
      ownerState: R,
      ref: p,
      className: Me(E.root, O),
      ...k,
      children: y ? m$(S, y) : S
    });
  });
  return process.env.NODE_ENV !== "production" && (l.propTypes = {
    children: o.node,
    direction: o.oneOfType([o.oneOf(["column-reverse", "column", "row-reverse", "row"]), o.arrayOf(o.oneOf(["column-reverse", "column", "row-reverse", "row"])), o.object]),
    divider: o.node,
    spacing: o.oneOfType([o.arrayOf(o.oneOfType([o.number, o.string])), o.number, o.object, o.string]),
    sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
  }), l;
}
const fl = {
  black: "#000",
  white: "#fff"
}, dd = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, Ia = {
  50: "#f3e5f5",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  700: "#7b1fa2"
}, Ko = {
  50: "#ffebee",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  700: "#d32f2f",
  800: "#c62828"
}, aa = {
  50: "#fff3e0",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  700: "#f57c00",
  900: "#e65100"
}, ja = {
  50: "#e3f2fd",
  200: "#90caf9",
  400: "#42a5f5",
  700: "#1976d2",
  800: "#1565c0"
}, $a = {
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  700: "#0288d1",
  900: "#01579b"
}, Xo = {
  50: "#e8f5e9",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20"
};
function H1() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: fl.white,
      default: fl.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
const b$ = H1();
function U1() {
  return {
    text: {
      primary: fl.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: fl.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
const Kv = U1();
function Xv(e, t, n, r) {
  const i = r.light || r, a = r.dark || r * 1.5;
  e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : t === "light" ? e.light = id(e.main, i) : t === "dark" && (e.dark = od(e.main, a)));
}
function v$(e = "light") {
  return e === "dark" ? {
    main: ja[200],
    light: ja[50],
    dark: ja[400]
  } : {
    main: ja[700],
    light: ja[400],
    dark: ja[800]
  };
}
function x$(e = "light") {
  return e === "dark" ? {
    main: Ia[200],
    light: Ia[50],
    dark: Ia[400]
  } : {
    main: Ia[500],
    light: Ia[300],
    dark: Ia[700]
  };
}
function w$(e = "light") {
  return e === "dark" ? {
    main: Ko[500],
    light: Ko[300],
    dark: Ko[700]
  } : {
    main: Ko[700],
    light: Ko[400],
    dark: Ko[800]
  };
}
function C$(e = "light") {
  return e === "dark" ? {
    main: $a[400],
    light: $a[300],
    dark: $a[700]
  } : {
    main: $a[700],
    light: $a[500],
    dark: $a[900]
  };
}
function S$(e = "light") {
  return e === "dark" ? {
    main: Xo[400],
    light: Xo[300],
    dark: Xo[700]
  } : {
    main: Xo[800],
    light: Xo[500],
    dark: Xo[900]
  };
}
function O$(e = "light") {
  return e === "dark" ? {
    main: aa[400],
    light: aa[300],
    dark: aa[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: aa[500],
    dark: aa[900]
  };
}
function Ch(e) {
  const {
    mode: t = "light",
    contrastThreshold: n = 3,
    tonalOffset: r = 0.2,
    ...i
  } = e, a = e.primary || v$(t), l = e.secondary || x$(t), u = e.error || w$(t), d = e.info || C$(t), p = e.success || S$(t), m = e.warning || O$(t);
  function h(y) {
    const S = Fv(y, Kv.text.primary) >= n ? Kv.text.primary : b$.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const O = Fv(y, S);
      O < 3 && console.error([`MUI: The contrast ratio of ${O}:1 for ${S} on ${y}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return S;
  }
  const g = ({
    color: y,
    name: S,
    mainShade: O = 500,
    lightShade: P = 300,
    darkShade: k = 700
  }) => {
    if (y = {
      ...y
    }, !y.main && y[O] && (y.main = y[O]), !y.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${S ? ` (${S})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${O}\` property.` : _o(11, S ? ` (${S})` : "", O));
    if (typeof y.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${S ? ` (${S})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(y.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : _o(12, S ? ` (${S})` : "", JSON.stringify(y.main)));
    return Xv(y, "light", P, r), Xv(y, "dark", k, r), y.contrastText || (y.contrastText = h(y.main)), y;
  };
  let v;
  return t === "light" ? v = H1() : t === "dark" && (v = U1()), process.env.NODE_ENV !== "production" && (v || console.error(`MUI: The palette mode \`${t}\` is not supported.`)), Bn({
    // A collection of common colors.
    common: {
      ...fl
    },
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: g({
      color: a,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: g({
      color: l,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: g({
      color: u,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: g({
      color: m,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: g({
      color: d,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: g({
      color: p,
      name: "success"
    }),
    // The grey colors.
    grey: dd,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: n,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: h,
    // Generate a rich color object.
    augmentColor: g,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: r,
    // The light and dark mode object.
    ...v
  }, i);
}
function T$(e) {
  const t = {};
  return Object.entries(e).forEach((r) => {
    const [i, a] = r;
    typeof a == "object" && (t[i] = `${a.fontStyle ? `${a.fontStyle} ` : ""}${a.fontVariant ? `${a.fontVariant} ` : ""}${a.fontWeight ? `${a.fontWeight} ` : ""}${a.fontStretch ? `${a.fontStretch} ` : ""}${a.fontSize || ""}${a.lineHeight ? `/${a.lineHeight} ` : ""}${a.fontFamily || ""}`);
  }), t;
}
function E$(e, t) {
  return {
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    },
    ...t
  };
}
function R$(e) {
  return Math.round(e * 1e5) / 1e5;
}
const Qv = {
  textTransform: "uppercase"
}, Zv = '"Roboto", "Helvetica", "Arial", sans-serif';
function Y1(e, t) {
  const {
    fontFamily: n = Zv,
    // The default font size of the Material Specification.
    fontSize: r = 14,
    // px
    fontWeightLight: i = 300,
    fontWeightRegular: a = 400,
    fontWeightMedium: l = 500,
    fontWeightBold: u = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: d = 16,
    // Apply the CSS properties to all the variants.
    allVariants: p,
    pxToRem: m,
    ...h
  } = typeof t == "function" ? t(e) : t;
  process.env.NODE_ENV !== "production" && (typeof r != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof d != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const g = r / 14, v = m || ((S) => `${S / d * g}rem`), b = (S, O, P, k, R) => ({
    fontFamily: n,
    fontWeight: S,
    fontSize: v(O),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: P,
    // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
    // across font-families can cause issues with the kerning.
    ...n === Zv ? {
      letterSpacing: `${R$(k / O)}em`
    } : {},
    ...R,
    ...p
  }), y = {
    h1: b(i, 96, 1.167, -1.5),
    h2: b(i, 60, 1.2, -0.5),
    h3: b(a, 48, 1.167, 0),
    h4: b(a, 34, 1.235, 0.25),
    h5: b(a, 24, 1.334, 0),
    h6: b(l, 20, 1.6, 0.15),
    subtitle1: b(a, 16, 1.75, 0.15),
    subtitle2: b(l, 14, 1.57, 0.1),
    body1: b(a, 16, 1.5, 0.15),
    body2: b(a, 14, 1.43, 0.15),
    button: b(l, 14, 1.75, 0.4, Qv),
    caption: b(a, 12, 1.66, 0.4),
    overline: b(a, 12, 2.66, 1, Qv),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return Bn({
    htmlFontSize: d,
    pxToRem: v,
    fontFamily: n,
    fontSize: r,
    fontWeightLight: i,
    fontWeightRegular: a,
    fontWeightMedium: l,
    fontWeightBold: u,
    ...y
  }, h, {
    clone: !1
    // No need to clone deep
  });
}
const k$ = 0.2, P$ = 0.14, D$ = 0.12;
function pn(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${k$})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${P$})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${D$})`].join(",");
}
const M$ = ["none", pn(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), pn(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), pn(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), pn(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), pn(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), pn(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), pn(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), pn(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), pn(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), pn(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), pn(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), pn(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), pn(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), pn(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), pn(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), pn(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), pn(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), pn(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), pn(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), pn(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), pn(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), pn(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), pn(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), pn(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], _$ = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, I$ = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function Jv(e) {
  return `${Math.round(e)}ms`;
}
function j$(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.min(Math.round((4 + 15 * t ** 0.25 + t / 5) * 10), 3e3);
}
function $$(e) {
  const t = {
    ..._$,
    ...e.easing
  }, n = {
    ...I$,
    ...e.duration
  };
  return {
    getAutoHeightDuration: j$,
    create: (i = ["all"], a = {}) => {
      const {
        duration: l = n.standard,
        easing: u = t.easeInOut,
        delay: d = 0,
        ...p
      } = a;
      if (process.env.NODE_ENV !== "production") {
        const m = (g) => typeof g == "string", h = (g) => !Number.isNaN(parseFloat(g));
        !m(i) && !Array.isArray(i) && console.error('MUI: Argument "props" must be a string or Array.'), !h(l) && !m(l) && console.error(`MUI: Argument "duration" must be a number or a string but found ${l}.`), m(u) || console.error('MUI: Argument "easing" must be a string.'), !h(d) && !m(d) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof a != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(p).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(p).join(",")}].`);
      }
      return (Array.isArray(i) ? i : [i]).map((m) => `${m} ${typeof l == "string" ? l : Jv(l)} ${u} ${typeof d == "string" ? d : Jv(d)}`).join(",");
    },
    ...e,
    easing: t,
    duration: n
  };
}
const A$ = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function N$(e) {
  return Eo(e) || typeof e > "u" || typeof e == "string" || typeof e == "boolean" || typeof e == "number" || Array.isArray(e);
}
function G1(e = {}) {
  const t = {
    ...e
  };
  function n(r) {
    const i = Object.entries(r);
    for (let a = 0; a < i.length; a++) {
      const [l, u] = i[a];
      !N$(u) || l.startsWith("unstable_") ? delete r[l] : Eo(u) && (r[l] = {
        ...u
      }, n(r[l]));
    }
  }
  return n(t), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(t, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
function _m(e = {}, ...t) {
  const {
    breakpoints: n,
    mixins: r = {},
    spacing: i,
    palette: a = {},
    transitions: l = {},
    typography: u = {},
    shape: d,
    ...p
  } = e;
  if (e.vars)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : _o(20));
  const m = Ch(a), h = jl(e);
  let g = Bn(h, {
    mixins: E$(h.breakpoints, r),
    palette: m,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: M$.slice(),
    typography: Y1(m, u),
    transitions: $$(l),
    zIndex: {
      ...A$
    }
  });
  if (g = Bn(g, p), g = t.reduce((v, b) => Bn(v, b), g), process.env.NODE_ENV !== "production") {
    const v = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], b = (y, S) => {
      let O;
      for (O in y) {
        const P = y[O];
        if (v.includes(O) && Object.keys(P).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const k = ze("", O);
            console.error([`MUI: The \`${S}\` component increases the CSS specificity of the \`${O}\` internal state.`, "You can not override it like this: ", JSON.stringify(y, null, 2), "", `Instead, you need to use the '&.${k}' syntax:`, JSON.stringify({
              root: {
                [`&.${k}`]: P
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          y[O] = {};
        }
      }
    };
    Object.keys(g.components).forEach((y) => {
      const S = g.components[y].styleOverrides;
      S && y.startsWith("Mui") && b(S, y);
    });
  }
  return g.unstable_sxConfig = {
    ...Il,
    ...p == null ? void 0 : p.unstable_sxConfig
  }, g.unstable_sx = function(b) {
    return Pi({
      sx: b,
      theme: this
    });
  }, g.toRuntimeSource = G1, g;
}
function Im(e) {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, Math.round(t * 10) / 1e3;
}
const F$ = [...Array(25)].map((e, t) => {
  if (t === 0)
    return "none";
  const n = Im(t);
  return `linear-gradient(rgba(255 255 255 / ${n}), rgba(255 255 255 / ${n}))`;
});
function K1(e) {
  return {
    inputPlaceholder: e === "dark" ? 0.5 : 0.42,
    inputUnderline: e === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: e === "dark" ? 0.2 : 0.12,
    switchTrack: e === "dark" ? 0.3 : 0.38
  };
}
function X1(e) {
  return e === "dark" ? F$ : [];
}
function L$(e) {
  const {
    palette: t = {
      mode: "light"
    },
    // need to cast to avoid module augmentation test
    opacity: n,
    overlays: r,
    ...i
  } = e, a = Ch(t);
  return {
    palette: a,
    opacity: {
      ...K1(a.mode),
      ...n
    },
    overlays: r || X1(a.mode),
    ...i
  };
}
function B$(e) {
  var t;
  return !!e[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!e[0].match(/sxConfig$/) || // ends with sxConfig
  e[0] === "palette" && !!((t = e[1]) != null && t.match(/(mode|contrastThreshold|tonalOffset)/));
}
const V$ = (e) => [...[...Array(25)].map((t, n) => `--${e ? `${e}-` : ""}overlays-${n}`), `--${e ? `${e}-` : ""}palette-AppBar-darkBg`, `--${e ? `${e}-` : ""}palette-AppBar-darkColor`], z$ = (e) => (t, n) => {
  const r = e.rootSelector || ":root", i = e.colorSchemeSelector;
  let a = i;
  if (i === "class" && (a = ".%s"), i === "data" && (a = "[data-%s]"), i != null && i.startsWith("data-") && !i.includes("%s") && (a = `[${i}="%s"]`), e.defaultColorScheme === t) {
    if (t === "dark") {
      const l = {};
      return V$(e.cssVarPrefix).forEach((u) => {
        l[u] = n[u], delete n[u];
      }), a === "media" ? {
        [r]: n,
        "@media (prefers-color-scheme: dark)": {
          [r]: l
        }
      } : a ? {
        [a.replace("%s", t)]: l,
        [`${r}, ${a.replace("%s", t)}`]: n
      } : {
        [r]: {
          ...n,
          ...l
        }
      };
    }
    if (a && a !== "media")
      return `${r}, ${a.replace("%s", String(t))}`;
  } else if (t) {
    if (a === "media")
      return {
        [`@media (prefers-color-scheme: ${String(t)})`]: {
          [r]: n
        }
      };
    if (a)
      return a.replace("%s", String(t));
  }
  return r;
};
function W$(e, t) {
  t.forEach((n) => {
    e[n] || (e[n] = {});
  });
}
function ye(e, t, n) {
  !e[t] && n && (e[t] = n);
}
function Qs(e) {
  return typeof e != "string" || !e.startsWith("hsl") ? e : M1(e);
}
function Uo(e, t) {
  `${t}Channel` in e || (e[`${t}Channel`] = Xs(Qs(e[t]), `MUI: Can't create \`palette.${t}Channel\` because \`palette.${t}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().
To suppress this warning, you need to explicitly provide the \`palette.${t}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`));
}
function q$(e) {
  return typeof e == "number" ? `${e}px` : typeof e == "string" || typeof e == "function" || Array.isArray(e) ? e : "8px";
}
const xo = (e) => {
  try {
    return e();
  } catch {
  }
}, H$ = (e = "mui") => Hj(e);
function uf(e, t, n, r) {
  if (!t)
    return;
  t = t === !0 ? {} : t;
  const i = r === "dark" ? "dark" : "light";
  if (!n) {
    e[r] = L$({
      ...t,
      palette: {
        mode: i,
        ...t == null ? void 0 : t.palette
      }
    });
    return;
  }
  const {
    palette: a,
    ...l
  } = _m({
    ...n,
    palette: {
      mode: i,
      ...t == null ? void 0 : t.palette
    }
  });
  return e[r] = {
    ...t,
    palette: a,
    opacity: {
      ...K1(i),
      ...t == null ? void 0 : t.opacity
    },
    overlays: (t == null ? void 0 : t.overlays) || X1(i)
  }, l;
}
function U$(e = {}, ...t) {
  const {
    colorSchemes: n = {
      light: !0
    },
    defaultColorScheme: r,
    disableCssColorScheme: i = !1,
    cssVarPrefix: a = "mui",
    shouldSkipGeneratingVar: l = B$,
    colorSchemeSelector: u = n.light && n.dark ? "media" : void 0,
    rootSelector: d = ":root",
    ...p
  } = e, m = Object.keys(n)[0], h = r || (n.light && m !== "light" ? "light" : m), g = H$(a), {
    [h]: v,
    light: b,
    dark: y,
    ...S
  } = n, O = {
    ...S
  };
  let P = v;
  if ((h === "dark" && !("dark" in n) || h === "light" && !("light" in n)) && (P = !0), !P)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The \`colorSchemes.${h}\` option is either missing or invalid.` : _o(21, h));
  const k = uf(O, P, p, h);
  b && !O.light && uf(O, b, void 0, "light"), y && !O.dark && uf(O, y, void 0, "dark");
  let R = {
    defaultColorScheme: h,
    ...k,
    cssVarPrefix: a,
    colorSchemeSelector: u,
    rootSelector: d,
    getCssVar: g,
    colorSchemes: O,
    font: {
      ...T$(k.typography),
      ...k.font
    },
    spacing: q$(p.spacing)
  };
  Object.keys(R.colorSchemes).forEach((F) => {
    const T = R.colorSchemes[F].palette, $ = (N) => {
      const W = N.split("-"), L = W[1], V = W[2];
      return g(N, T[L][V]);
    };
    if (T.mode === "light" && (ye(T.common, "background", "#fff"), ye(T.common, "onBackground", "#000")), T.mode === "dark" && (ye(T.common, "background", "#000"), ye(T.common, "onBackground", "#fff")), W$(T, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]), T.mode === "light") {
      ye(T.Alert, "errorColor", tn(T.error.light, 0.6)), ye(T.Alert, "infoColor", tn(T.info.light, 0.6)), ye(T.Alert, "successColor", tn(T.success.light, 0.6)), ye(T.Alert, "warningColor", tn(T.warning.light, 0.6)), ye(T.Alert, "errorFilledBg", $("palette-error-main")), ye(T.Alert, "infoFilledBg", $("palette-info-main")), ye(T.Alert, "successFilledBg", $("palette-success-main")), ye(T.Alert, "warningFilledBg", $("palette-warning-main")), ye(T.Alert, "errorFilledColor", xo(() => T.getContrastText(T.error.main))), ye(T.Alert, "infoFilledColor", xo(() => T.getContrastText(T.info.main))), ye(T.Alert, "successFilledColor", xo(() => T.getContrastText(T.success.main))), ye(T.Alert, "warningFilledColor", xo(() => T.getContrastText(T.warning.main))), ye(T.Alert, "errorStandardBg", nn(T.error.light, 0.9)), ye(T.Alert, "infoStandardBg", nn(T.info.light, 0.9)), ye(T.Alert, "successStandardBg", nn(T.success.light, 0.9)), ye(T.Alert, "warningStandardBg", nn(T.warning.light, 0.9)), ye(T.Alert, "errorIconColor", $("palette-error-main")), ye(T.Alert, "infoIconColor", $("palette-info-main")), ye(T.Alert, "successIconColor", $("palette-success-main")), ye(T.Alert, "warningIconColor", $("palette-warning-main")), ye(T.AppBar, "defaultBg", $("palette-grey-100")), ye(T.Avatar, "defaultBg", $("palette-grey-400")), ye(T.Button, "inheritContainedBg", $("palette-grey-300")), ye(T.Button, "inheritContainedHoverBg", $("palette-grey-A100")), ye(T.Chip, "defaultBorder", $("palette-grey-400")), ye(T.Chip, "defaultAvatarColor", $("palette-grey-700")), ye(T.Chip, "defaultIconColor", $("palette-grey-700")), ye(T.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), ye(T.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), ye(T.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), ye(T.LinearProgress, "primaryBg", nn(T.primary.main, 0.62)), ye(T.LinearProgress, "secondaryBg", nn(T.secondary.main, 0.62)), ye(T.LinearProgress, "errorBg", nn(T.error.main, 0.62)), ye(T.LinearProgress, "infoBg", nn(T.info.main, 0.62)), ye(T.LinearProgress, "successBg", nn(T.success.main, 0.62)), ye(T.LinearProgress, "warningBg", nn(T.warning.main, 0.62)), ye(T.Skeleton, "bg", `rgba(${$("palette-text-primaryChannel")} / 0.11)`), ye(T.Slider, "primaryTrack", nn(T.primary.main, 0.62)), ye(T.Slider, "secondaryTrack", nn(T.secondary.main, 0.62)), ye(T.Slider, "errorTrack", nn(T.error.main, 0.62)), ye(T.Slider, "infoTrack", nn(T.info.main, 0.62)), ye(T.Slider, "successTrack", nn(T.success.main, 0.62)), ye(T.Slider, "warningTrack", nn(T.warning.main, 0.62));
      const N = Wc(T.background.default, 0.8);
      ye(T.SnackbarContent, "bg", N), ye(T.SnackbarContent, "color", xo(() => T.getContrastText(N))), ye(T.SpeedDialAction, "fabHoverBg", Wc(T.background.paper, 0.15)), ye(T.StepConnector, "border", $("palette-grey-400")), ye(T.StepContent, "border", $("palette-grey-400")), ye(T.Switch, "defaultColor", $("palette-common-white")), ye(T.Switch, "defaultDisabledColor", $("palette-grey-100")), ye(T.Switch, "primaryDisabledColor", nn(T.primary.main, 0.62)), ye(T.Switch, "secondaryDisabledColor", nn(T.secondary.main, 0.62)), ye(T.Switch, "errorDisabledColor", nn(T.error.main, 0.62)), ye(T.Switch, "infoDisabledColor", nn(T.info.main, 0.62)), ye(T.Switch, "successDisabledColor", nn(T.success.main, 0.62)), ye(T.Switch, "warningDisabledColor", nn(T.warning.main, 0.62)), ye(T.TableCell, "border", nn(zc(T.divider, 1), 0.88)), ye(T.Tooltip, "bg", zc(T.grey[700], 0.92));
    }
    if (T.mode === "dark") {
      ye(T.Alert, "errorColor", nn(T.error.light, 0.6)), ye(T.Alert, "infoColor", nn(T.info.light, 0.6)), ye(T.Alert, "successColor", nn(T.success.light, 0.6)), ye(T.Alert, "warningColor", nn(T.warning.light, 0.6)), ye(T.Alert, "errorFilledBg", $("palette-error-dark")), ye(T.Alert, "infoFilledBg", $("palette-info-dark")), ye(T.Alert, "successFilledBg", $("palette-success-dark")), ye(T.Alert, "warningFilledBg", $("palette-warning-dark")), ye(T.Alert, "errorFilledColor", xo(() => T.getContrastText(T.error.dark))), ye(T.Alert, "infoFilledColor", xo(() => T.getContrastText(T.info.dark))), ye(T.Alert, "successFilledColor", xo(() => T.getContrastText(T.success.dark))), ye(T.Alert, "warningFilledColor", xo(() => T.getContrastText(T.warning.dark))), ye(T.Alert, "errorStandardBg", tn(T.error.light, 0.9)), ye(T.Alert, "infoStandardBg", tn(T.info.light, 0.9)), ye(T.Alert, "successStandardBg", tn(T.success.light, 0.9)), ye(T.Alert, "warningStandardBg", tn(T.warning.light, 0.9)), ye(T.Alert, "errorIconColor", $("palette-error-main")), ye(T.Alert, "infoIconColor", $("palette-info-main")), ye(T.Alert, "successIconColor", $("palette-success-main")), ye(T.Alert, "warningIconColor", $("palette-warning-main")), ye(T.AppBar, "defaultBg", $("palette-grey-900")), ye(T.AppBar, "darkBg", $("palette-background-paper")), ye(T.AppBar, "darkColor", $("palette-text-primary")), ye(T.Avatar, "defaultBg", $("palette-grey-600")), ye(T.Button, "inheritContainedBg", $("palette-grey-800")), ye(T.Button, "inheritContainedHoverBg", $("palette-grey-700")), ye(T.Chip, "defaultBorder", $("palette-grey-700")), ye(T.Chip, "defaultAvatarColor", $("palette-grey-300")), ye(T.Chip, "defaultIconColor", $("palette-grey-300")), ye(T.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), ye(T.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), ye(T.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), ye(T.LinearProgress, "primaryBg", tn(T.primary.main, 0.5)), ye(T.LinearProgress, "secondaryBg", tn(T.secondary.main, 0.5)), ye(T.LinearProgress, "errorBg", tn(T.error.main, 0.5)), ye(T.LinearProgress, "infoBg", tn(T.info.main, 0.5)), ye(T.LinearProgress, "successBg", tn(T.success.main, 0.5)), ye(T.LinearProgress, "warningBg", tn(T.warning.main, 0.5)), ye(T.Skeleton, "bg", `rgba(${$("palette-text-primaryChannel")} / 0.13)`), ye(T.Slider, "primaryTrack", tn(T.primary.main, 0.5)), ye(T.Slider, "secondaryTrack", tn(T.secondary.main, 0.5)), ye(T.Slider, "errorTrack", tn(T.error.main, 0.5)), ye(T.Slider, "infoTrack", tn(T.info.main, 0.5)), ye(T.Slider, "successTrack", tn(T.success.main, 0.5)), ye(T.Slider, "warningTrack", tn(T.warning.main, 0.5));
      const N = Wc(T.background.default, 0.98);
      ye(T.SnackbarContent, "bg", N), ye(T.SnackbarContent, "color", xo(() => T.getContrastText(N))), ye(T.SpeedDialAction, "fabHoverBg", Wc(T.background.paper, 0.15)), ye(T.StepConnector, "border", $("palette-grey-600")), ye(T.StepContent, "border", $("palette-grey-600")), ye(T.Switch, "defaultColor", $("palette-grey-300")), ye(T.Switch, "defaultDisabledColor", $("palette-grey-600")), ye(T.Switch, "primaryDisabledColor", tn(T.primary.main, 0.55)), ye(T.Switch, "secondaryDisabledColor", tn(T.secondary.main, 0.55)), ye(T.Switch, "errorDisabledColor", tn(T.error.main, 0.55)), ye(T.Switch, "infoDisabledColor", tn(T.info.main, 0.55)), ye(T.Switch, "successDisabledColor", tn(T.success.main, 0.55)), ye(T.Switch, "warningDisabledColor", tn(T.warning.main, 0.55)), ye(T.TableCell, "border", tn(zc(T.divider, 1), 0.68)), ye(T.Tooltip, "bg", zc(T.grey[700], 0.92));
    }
    Uo(T.background, "default"), Uo(T.background, "paper"), Uo(T.common, "background"), Uo(T.common, "onBackground"), Uo(T, "divider"), Object.keys(T).forEach((N) => {
      const W = T[N];
      N !== "tonalOffset" && W && typeof W == "object" && (W.main && ye(T[N], "mainChannel", Xs(Qs(W.main))), W.light && ye(T[N], "lightChannel", Xs(Qs(W.light))), W.dark && ye(T[N], "darkChannel", Xs(Qs(W.dark))), W.contrastText && ye(T[N], "contrastTextChannel", Xs(Qs(W.contrastText))), N === "text" && (Uo(T[N], "primary"), Uo(T[N], "secondary")), N === "action" && (W.active && Uo(T[N], "active"), W.selected && Uo(T[N], "selected")));
    });
  }), R = t.reduce((F, T) => Bn(F, T), R);
  const E = {
    prefix: a,
    disableCssColorScheme: i,
    shouldSkipGeneratingVar: l,
    getSelector: z$(R)
  }, {
    vars: M,
    generateThemeVars: _,
    generateStyleSheets: I
  } = Gj(R, E);
  return R.vars = M, Object.entries(R.colorSchemes[R.defaultColorScheme]).forEach(([F, T]) => {
    R[F] = T;
  }), R.generateThemeVars = _, R.generateStyleSheets = I, R.generateSpacing = function() {
    return b1(p.spacing, Xu(this));
  }, R.getColorSchemeSelector = Kj(u), R.spacing = R.generateSpacing(), R.shouldSkipGeneratingVar = l, R.unstable_sxConfig = {
    ...Il,
    ...p == null ? void 0 : p.unstable_sxConfig
  }, R.unstable_sx = function(T) {
    return Pi({
      sx: T,
      theme: this
    });
  }, R.toRuntimeSource = G1, R;
}
function ex(e, t, n) {
  e.colorSchemes && n && (e.colorSchemes[t] = {
    ...n !== !0 && n,
    palette: Ch({
      ...n === !0 ? {} : n.palette,
      mode: t
    })
    // cast type to skip module augmentation test
  });
}
function Al(e = {}, ...t) {
  const {
    palette: n,
    cssVariables: r = !1,
    colorSchemes: i = n ? void 0 : {
      light: !0
    },
    defaultColorScheme: a = n == null ? void 0 : n.mode,
    ...l
  } = e, u = a || "light", d = i == null ? void 0 : i[u], p = {
    ...i,
    ...n ? {
      [u]: {
        ...typeof d != "boolean" && d,
        palette: n
      }
    } : void 0
  };
  if (r === !1) {
    if (!("colorSchemes" in e))
      return _m(e, ...t);
    let m = n;
    "palette" in e || p[u] && (p[u] !== !0 ? m = p[u].palette : u === "dark" && (m = {
      mode: "dark"
    }));
    const h = _m({
      ...e,
      palette: m
    }, ...t);
    return h.defaultColorScheme = u, h.colorSchemes = p, h.palette.mode === "light" && (h.colorSchemes.light = {
      ...p.light !== !0 && p.light,
      palette: h.palette
    }, ex(h, "dark", p.dark)), h.palette.mode === "dark" && (h.colorSchemes.dark = {
      ...p.dark !== !0 && p.dark,
      palette: h.palette
    }, ex(h, "light", p.light)), h;
  }
  return !n && !("light" in p) && u === "light" && (p.light = !0), U$({
    ...l,
    colorSchemes: p,
    defaultColorScheme: u,
    ...typeof r != "boolean" && r
  }, ...t);
}
const pd = Al();
function ir() {
  const e = $l(pd);
  return process.env.NODE_ENV !== "production" && w.useDebugValue(e), e[Gr] || e;
}
function cn({
  props: e,
  name: t
}) {
  return mh({
    props: e,
    name: t,
    defaultTheme: pd,
    themeId: Gr
  });
}
function Q1(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const Zn = (e) => Q1(e) && e !== "classes", ae = T1({
  themeId: Gr,
  defaultTheme: pd,
  rootShouldForwardProp: Zn
});
function tx({
  theme: e,
  ...t
}) {
  const n = Gr in e ? e[Gr] : void 0;
  return /* @__PURE__ */ x.jsx(pl, {
    ...t,
    themeId: n ? Gr : void 0,
    theme: n || e
  });
}
const qc = {
  colorSchemeStorageKey: "mui-color-scheme",
  defaultLightColorScheme: "light",
  defaultDarkColorScheme: "dark",
  modeStorageKey: "mui-mode"
}, {
  CssVarsProvider: Y$
} = qj({
  themeId: Gr,
  // @ts-ignore ignore module augmentation tests
  theme: () => Al({
    cssVariables: !0
  }),
  colorSchemeStorageKey: qc.colorSchemeStorageKey,
  modeStorageKey: qc.modeStorageKey,
  defaultColorScheme: {
    light: qc.defaultLightColorScheme,
    dark: qc.defaultDarkColorScheme
  },
  resolveTheme: (e) => {
    const t = {
      ...e,
      typography: Y1(e.palette, e.typography)
    };
    return t.unstable_sx = function(r) {
      return Pi({
        sx: r,
        theme: this
      });
    }, t;
  }
}), G$ = Y$;
function Z1({
  theme: e,
  ...t
}) {
  return typeof e == "function" ? /* @__PURE__ */ x.jsx(tx, {
    theme: e,
    ...t
  }) : "colorSchemes" in (Gr in e ? e[Gr] : e) ? /* @__PURE__ */ x.jsx(G$, {
    theme: e,
    ...t
  }) : /* @__PURE__ */ x.jsx(tx, {
    theme: e,
    ...t
  });
}
function J1(e) {
  return /* @__PURE__ */ x.jsx(v1, {
    ...e,
    defaultTheme: pd,
    themeId: Gr
  });
}
process.env.NODE_ENV !== "production" && (J1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The styles you want to apply globally.
   */
  styles: o.oneOfType([o.array, o.func, o.number, o.object, o.string, o.bool])
});
function K$(e) {
  return function(n) {
    return (
      // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
      /* @__PURE__ */ x.jsx(J1, {
        styles: typeof e == "function" ? (r) => e({
          theme: r,
          ...n
        }) : e
      })
    );
  };
}
function X$() {
  return nd;
}
const ct = Fj;
process.env.NODE_ENV !== "production" && (o.node, o.object.isRequired);
function ut(e) {
  return Nj(e);
}
function Q$(e) {
  return ze("MuiSvgIcon", e);
}
Ve("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const Z$ = (e) => {
  const {
    color: t,
    fontSize: n,
    classes: r
  } = e, i = {
    root: ["root", t !== "inherit" && `color${ke(t)}`, `fontSize${ke(n)}`]
  };
  return We(i, Q$, r);
}, J$ = ae("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "inherit" && t[`color${ke(n.color)}`], t[`fontSize${ke(n.fontSize)}`]];
  }
})(ct(({
  theme: e
}) => {
  var t, n, r, i, a, l, u, d, p, m, h, g, v, b;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    flexShrink: 0,
    transition: (i = (t = e.transitions) == null ? void 0 : t.create) == null ? void 0 : i.call(t, "fill", {
      duration: (r = (n = (e.vars ?? e).transitions) == null ? void 0 : n.duration) == null ? void 0 : r.shorter
    }),
    variants: [
      {
        props: (y) => !y.hasSvgAsChild,
        style: {
          // the <svg> will define the property that has `currentColor`
          // for example heroicons uses fill="none" and stroke="currentColor"
          fill: "currentColor"
        }
      },
      {
        props: {
          fontSize: "inherit"
        },
        style: {
          fontSize: "inherit"
        }
      },
      {
        props: {
          fontSize: "small"
        },
        style: {
          fontSize: ((l = (a = e.typography) == null ? void 0 : a.pxToRem) == null ? void 0 : l.call(a, 20)) || "1.25rem"
        }
      },
      {
        props: {
          fontSize: "medium"
        },
        style: {
          fontSize: ((d = (u = e.typography) == null ? void 0 : u.pxToRem) == null ? void 0 : d.call(u, 24)) || "1.5rem"
        }
      },
      {
        props: {
          fontSize: "large"
        },
        style: {
          fontSize: ((m = (p = e.typography) == null ? void 0 : p.pxToRem) == null ? void 0 : m.call(p, 35)) || "2.1875rem"
        }
      },
      // TODO v5 deprecate color prop, v6 remove for sx
      ...Object.entries((e.vars ?? e).palette).filter(([, y]) => y && y.main).map(([y]) => {
        var S, O;
        return {
          props: {
            color: y
          },
          style: {
            color: (O = (S = (e.vars ?? e).palette) == null ? void 0 : S[y]) == null ? void 0 : O.main
          }
        };
      }),
      {
        props: {
          color: "action"
        },
        style: {
          color: (g = (h = (e.vars ?? e).palette) == null ? void 0 : h.action) == null ? void 0 : g.active
        }
      },
      {
        props: {
          color: "disabled"
        },
        style: {
          color: (b = (v = (e.vars ?? e).palette) == null ? void 0 : v.action) == null ? void 0 : b.disabled
        }
      },
      {
        props: {
          color: "inherit"
        },
        style: {
          color: void 0
        }
      }
    ]
  };
})), Su = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: i,
    className: a,
    color: l = "inherit",
    component: u = "svg",
    fontSize: d = "medium",
    htmlColor: p,
    inheritViewBox: m = !1,
    titleAccess: h,
    viewBox: g = "0 0 24 24",
    ...v
  } = r, b = /* @__PURE__ */ w.isValidElement(i) && i.type === "svg", y = {
    ...r,
    color: l,
    component: u,
    fontSize: d,
    instanceFontSize: t.fontSize,
    inheritViewBox: m,
    viewBox: g,
    hasSvgAsChild: b
  }, S = {};
  m || (S.viewBox = g);
  const O = Z$(y);
  return /* @__PURE__ */ x.jsxs(J$, {
    as: u,
    className: Me(O.root, a),
    focusable: "false",
    color: p,
    "aria-hidden": h ? void 0 : !0,
    role: h ? "img" : void 0,
    ref: n,
    ...S,
    ...v,
    ...b && i.props,
    ownerState: y,
    children: [b ? i.props.children : i, h ? /* @__PURE__ */ x.jsx("title", {
      children: h
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (Su.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: o.oneOfType([o.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), o.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: o.oneOfType([o.oneOf(["inherit", "large", "medium", "small"]), o.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: o.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: o.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: o.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: o.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: o.string
});
Su.muiName = "SvgIcon";
function rn(e, t) {
  function n(r, i) {
    return /* @__PURE__ */ x.jsx(Su, {
      "data-testid": `${t}Icon`,
      ref: i,
      ...r,
      children: e
    });
  }
  return process.env.NODE_ENV !== "production" && (n.displayName = `${t}Icon`), n.muiName = Su.muiName, /* @__PURE__ */ w.memo(/* @__PURE__ */ w.forwardRef(n));
}
function ht(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.indexOf(r) !== -1) continue;
    n[r] = e[r];
  }
  return n;
}
function jm(e, t) {
  return jm = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, jm(e, t);
}
function Sh(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, jm(e, t);
}
function eA(e, t) {
  return e.classList ? !!t && e.classList.contains(t) : (" " + (e.className.baseVal || e.className) + " ").indexOf(" " + t + " ") !== -1;
}
function tA(e, t) {
  e.classList ? e.classList.add(t) : eA(e, t) || (typeof e.className == "string" ? e.className = e.className + " " + t : e.setAttribute("class", (e.className && e.className.baseVal || "") + " " + t));
}
function nx(e, t) {
  return e.replace(new RegExp("(^|\\s)" + t + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function nA(e, t) {
  e.classList ? e.classList.remove(t) : typeof e.className == "string" ? e.className = nx(e.className, t) : e.setAttribute("class", nx(e.className && e.className.baseVal || "", t));
}
const rx = {
  disabled: !1
};
var rA = process.env.NODE_ENV !== "production" ? o.oneOfType([o.number, o.shape({
  enter: o.number,
  exit: o.number,
  appear: o.number
}).isRequired]) : null, oA = process.env.NODE_ENV !== "production" ? o.oneOfType([o.string, o.shape({
  enter: o.string,
  exit: o.string,
  active: o.string
}), o.shape({
  enter: o.string,
  enterDone: o.string,
  enterActive: o.string,
  exit: o.string,
  exitDone: o.string,
  exitActive: o.string
})]) : null;
const Ou = Ae.createContext(null);
var eC = function(t) {
  return t.scrollTop;
}, Zs = "unmounted", na = "exited", ra = "entering", Va = "entered", $m = "exiting", to = /* @__PURE__ */ function(e) {
  Sh(t, e);
  function t(r, i) {
    var a;
    a = e.call(this, r, i) || this;
    var l = i, u = l && !l.isMounting ? r.enter : r.appear, d;
    return a.appearStatus = null, r.in ? u ? (d = na, a.appearStatus = ra) : d = Va : r.unmountOnExit || r.mountOnEnter ? d = Zs : d = na, a.state = {
      status: d
    }, a.nextCallback = null, a;
  }
  t.getDerivedStateFromProps = function(i, a) {
    var l = i.in;
    return l && a.status === Zs ? {
      status: na
    } : null;
  };
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, n.componentDidUpdate = function(i) {
    var a = null;
    if (i !== this.props) {
      var l = this.state.status;
      this.props.in ? l !== ra && l !== Va && (a = ra) : (l === ra || l === Va) && (a = $m);
    }
    this.updateStatus(!1, a);
  }, n.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, n.getTimeouts = function() {
    var i = this.props.timeout, a, l, u;
    return a = l = u = i, i != null && typeof i != "number" && (a = i.exit, l = i.enter, u = i.appear !== void 0 ? i.appear : l), {
      exit: a,
      enter: l,
      appear: u
    };
  }, n.updateStatus = function(i, a) {
    if (i === void 0 && (i = !1), a !== null)
      if (this.cancelNextCallback(), a === ra) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var l = this.props.nodeRef ? this.props.nodeRef.current : $c.findDOMNode(this);
          l && eC(l);
        }
        this.performEnter(i);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === na && this.setState({
      status: Zs
    });
  }, n.performEnter = function(i) {
    var a = this, l = this.props.enter, u = this.context ? this.context.isMounting : i, d = this.props.nodeRef ? [u] : [$c.findDOMNode(this), u], p = d[0], m = d[1], h = this.getTimeouts(), g = u ? h.appear : h.enter;
    if (!i && !l || rx.disabled) {
      this.safeSetState({
        status: Va
      }, function() {
        a.props.onEntered(p);
      });
      return;
    }
    this.props.onEnter(p, m), this.safeSetState({
      status: ra
    }, function() {
      a.props.onEntering(p, m), a.onTransitionEnd(g, function() {
        a.safeSetState({
          status: Va
        }, function() {
          a.props.onEntered(p, m);
        });
      });
    });
  }, n.performExit = function() {
    var i = this, a = this.props.exit, l = this.getTimeouts(), u = this.props.nodeRef ? void 0 : $c.findDOMNode(this);
    if (!a || rx.disabled) {
      this.safeSetState({
        status: na
      }, function() {
        i.props.onExited(u);
      });
      return;
    }
    this.props.onExit(u), this.safeSetState({
      status: $m
    }, function() {
      i.props.onExiting(u), i.onTransitionEnd(l.exit, function() {
        i.safeSetState({
          status: na
        }, function() {
          i.props.onExited(u);
        });
      });
    });
  }, n.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, n.safeSetState = function(i, a) {
    a = this.setNextCallback(a), this.setState(i, a);
  }, n.setNextCallback = function(i) {
    var a = this, l = !0;
    return this.nextCallback = function(u) {
      l && (l = !1, a.nextCallback = null, i(u));
    }, this.nextCallback.cancel = function() {
      l = !1;
    }, this.nextCallback;
  }, n.onTransitionEnd = function(i, a) {
    this.setNextCallback(a);
    var l = this.props.nodeRef ? this.props.nodeRef.current : $c.findDOMNode(this), u = i == null && !this.props.addEndListener;
    if (!l || u) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var d = this.props.nodeRef ? [this.nextCallback] : [l, this.nextCallback], p = d[0], m = d[1];
      this.props.addEndListener(p, m);
    }
    i != null && setTimeout(this.nextCallback, i);
  }, n.render = function() {
    var i = this.state.status;
    if (i === Zs)
      return null;
    var a = this.props, l = a.children;
    a.in, a.mountOnEnter, a.unmountOnExit, a.appear, a.enter, a.exit, a.timeout, a.addEndListener, a.onEnter, a.onEntering, a.onEntered, a.onExit, a.onExiting, a.onExited, a.nodeRef;
    var u = ht(a, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ Ae.createElement(Ou.Provider, {
        value: null
      }, typeof l == "function" ? l(i, u) : Ae.cloneElement(Ae.Children.only(l), u))
    );
  }, t;
}(Ae.Component);
to.contextType = Ou;
to.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: o.shape({
    current: typeof Element > "u" ? o.any : function(e, t, n, r, i, a) {
      var l = e[t];
      return o.instanceOf(l && "ownerDocument" in l ? l.ownerDocument.defaultView.Element : Element)(e, t, n, r, i, a);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: o.oneOfType([o.func.isRequired, o.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: o.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: o.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: o.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: o.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: o.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: o.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(t) {
    var n = rA;
    t.addEndListener || (n = n.isRequired);
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      i[a - 1] = arguments[a];
    return n.apply(void 0, [t].concat(i));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: o.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: o.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: o.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: o.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: o.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: o.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: o.func
} : {};
function Aa() {
}
to.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: Aa,
  onEntering: Aa,
  onEntered: Aa,
  onExit: Aa,
  onExiting: Aa,
  onExited: Aa
};
to.UNMOUNTED = Zs;
to.EXITED = na;
to.ENTERING = ra;
to.ENTERED = Va;
to.EXITING = $m;
var iA = function(t, n) {
  return t && n && n.split(" ").forEach(function(r) {
    return tA(t, r);
  });
}, df = function(t, n) {
  return t && n && n.split(" ").forEach(function(r) {
    return nA(t, r);
  });
}, Oh = /* @__PURE__ */ function(e) {
  Sh(t, e);
  function t() {
    for (var r, i = arguments.length, a = new Array(i), l = 0; l < i; l++)
      a[l] = arguments[l];
    return r = e.call.apply(e, [this].concat(a)) || this, r.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    }, r.onEnter = function(u, d) {
      var p = r.resolveArguments(u, d), m = p[0], h = p[1];
      r.removeClasses(m, "exit"), r.addClass(m, h ? "appear" : "enter", "base"), r.props.onEnter && r.props.onEnter(u, d);
    }, r.onEntering = function(u, d) {
      var p = r.resolveArguments(u, d), m = p[0], h = p[1], g = h ? "appear" : "enter";
      r.addClass(m, g, "active"), r.props.onEntering && r.props.onEntering(u, d);
    }, r.onEntered = function(u, d) {
      var p = r.resolveArguments(u, d), m = p[0], h = p[1], g = h ? "appear" : "enter";
      r.removeClasses(m, g), r.addClass(m, g, "done"), r.props.onEntered && r.props.onEntered(u, d);
    }, r.onExit = function(u) {
      var d = r.resolveArguments(u), p = d[0];
      r.removeClasses(p, "appear"), r.removeClasses(p, "enter"), r.addClass(p, "exit", "base"), r.props.onExit && r.props.onExit(u);
    }, r.onExiting = function(u) {
      var d = r.resolveArguments(u), p = d[0];
      r.addClass(p, "exit", "active"), r.props.onExiting && r.props.onExiting(u);
    }, r.onExited = function(u) {
      var d = r.resolveArguments(u), p = d[0];
      r.removeClasses(p, "exit"), r.addClass(p, "exit", "done"), r.props.onExited && r.props.onExited(u);
    }, r.resolveArguments = function(u, d) {
      return r.props.nodeRef ? [r.props.nodeRef.current, u] : [u, d];
    }, r.getClassNames = function(u) {
      var d = r.props.classNames, p = typeof d == "string", m = p && d ? d + "-" : "", h = p ? "" + m + u : d[u], g = p ? h + "-active" : d[u + "Active"], v = p ? h + "-done" : d[u + "Done"];
      return {
        baseClassName: h,
        activeClassName: g,
        doneClassName: v
      };
    }, r;
  }
  var n = t.prototype;
  return n.addClass = function(i, a, l) {
    var u = this.getClassNames(a)[l + "ClassName"], d = this.getClassNames("enter"), p = d.doneClassName;
    a === "appear" && l === "done" && p && (u += " " + p), l === "active" && i && eC(i), u && (this.appliedClasses[a][l] = u, iA(i, u));
  }, n.removeClasses = function(i, a) {
    var l = this.appliedClasses[a], u = l.base, d = l.active, p = l.done;
    this.appliedClasses[a] = {}, u && df(i, u), d && df(i, d), p && df(i, p);
  }, n.render = function() {
    var i = this.props;
    i.classNames;
    var a = ht(i, ["classNames"]);
    return /* @__PURE__ */ Ae.createElement(to, J({}, a, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  }, t;
}(Ae.Component);
Oh.defaultProps = {
  classNames: ""
};
Oh.propTypes = process.env.NODE_ENV !== "production" ? J({}, to.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: oA,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: o.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: o.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: o.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: o.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: o.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: o.func
}) : {};
function aA(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Th(e, t) {
  var n = function(a) {
    return t && ou(a) ? t(a) : a;
  }, r = /* @__PURE__ */ Object.create(null);
  return e && Q0.map(e, function(i) {
    return i;
  }).forEach(function(i) {
    r[i.key] = n(i);
  }), r;
}
function sA(e, t) {
  e = e || {}, t = t || {};
  function n(m) {
    return m in t ? t[m] : e[m];
  }
  var r = /* @__PURE__ */ Object.create(null), i = [];
  for (var a in e)
    a in t ? i.length && (r[a] = i, i = []) : i.push(a);
  var l, u = {};
  for (var d in t) {
    if (r[d])
      for (l = 0; l < r[d].length; l++) {
        var p = r[d][l];
        u[r[d][l]] = n(p);
      }
    u[d] = n(d);
  }
  for (l = 0; l < i.length; l++)
    u[i[l]] = n(i[l]);
  return u;
}
function la(e, t, n) {
  return n[t] != null ? n[t] : e.props[t];
}
function lA(e, t) {
  return Th(e.children, function(n) {
    return iu(n, {
      onExited: t.bind(null, n),
      in: !0,
      appear: la(n, "appear", e),
      enter: la(n, "enter", e),
      exit: la(n, "exit", e)
    });
  });
}
function cA(e, t, n) {
  var r = Th(e.children), i = sA(t, r);
  return Object.keys(i).forEach(function(a) {
    var l = i[a];
    if (ou(l)) {
      var u = a in t, d = a in r, p = t[a], m = ou(p) && !p.props.in;
      d && (!u || m) ? i[a] = iu(l, {
        onExited: n.bind(null, l),
        in: !0,
        exit: la(l, "exit", e),
        enter: la(l, "enter", e)
      }) : !d && u && !m ? i[a] = iu(l, {
        in: !1
      }) : d && u && ou(p) && (i[a] = iu(l, {
        onExited: n.bind(null, l),
        in: p.props.in,
        exit: la(l, "exit", e),
        enter: la(l, "enter", e)
      }));
    }
  }), i;
}
var uA = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, dA = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, Nl = /* @__PURE__ */ function(e) {
  Sh(t, e);
  function t(r, i) {
    var a;
    a = e.call(this, r, i) || this;
    var l = a.handleExited.bind(aA(a));
    return a.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: l,
      firstRender: !0
    }, a;
  }
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, n.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(i, a) {
    var l = a.children, u = a.handleExited, d = a.firstRender;
    return {
      children: d ? lA(i, u) : cA(i, l, u),
      firstRender: !1
    };
  }, n.handleExited = function(i, a) {
    var l = Th(this.props.children);
    i.key in l || (i.props.onExited && i.props.onExited(a), this.mounted && this.setState(function(u) {
      var d = J({}, u.children);
      return delete d[i.key], {
        children: d
      };
    }));
  }, n.render = function() {
    var i = this.props, a = i.component, l = i.childFactory, u = ht(i, ["component", "childFactory"]), d = this.state.contextValue, p = uA(this.state.children).map(l);
    return delete u.appear, delete u.enter, delete u.exit, a === null ? /* @__PURE__ */ Ae.createElement(Ou.Provider, {
      value: d
    }, p) : /* @__PURE__ */ Ae.createElement(Ou.Provider, {
      value: d
    }, /* @__PURE__ */ Ae.createElement(a, u, p));
  }, t;
}(Ae.Component);
Nl.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: o.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: o.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: o.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: o.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: o.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: o.func
} : {};
Nl.defaultProps = dA;
const tC = (e) => e.scrollTop;
function Tu(e, t) {
  const {
    timeout: n,
    easing: r,
    style: i = {}
  } = e;
  return {
    duration: i.transitionDuration ?? (typeof n == "number" ? n : n[t.mode] || 0),
    easing: i.transitionTimingFunction ?? (typeof r == "object" ? r[t.mode] : r),
    delay: i.transitionDelay
  };
}
function pA(e) {
  return ze("MuiPaper", e);
}
Ve("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const fA = (e) => {
  const {
    square: t,
    elevation: n,
    variant: r,
    classes: i
  } = e, a = {
    root: ["root", r, !t && "rounded", r === "elevation" && `elevation${n}`]
  };
  return We(a, pA, i);
}, mA = ae("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], !n.square && t.rounded, n.variant === "elevation" && t[`elevation${n.elevation}`]];
  }
})(ct(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  color: (e.vars || e).palette.text.primary,
  transition: e.transitions.create("box-shadow"),
  variants: [{
    props: ({
      ownerState: t
    }) => !t.square,
    style: {
      borderRadius: e.shape.borderRadius
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      border: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: {
      variant: "elevation"
    },
    style: {
      boxShadow: "var(--Paper-shadow)",
      backgroundImage: "var(--Paper-overlay)"
    }
  }]
}))), $i = /* @__PURE__ */ w.forwardRef(function(t, n) {
  var v;
  const r = ut({
    props: t,
    name: "MuiPaper"
  }), i = ir(), {
    className: a,
    component: l = "div",
    elevation: u = 1,
    square: d = !1,
    variant: p = "elevation",
    ...m
  } = r, h = {
    ...r,
    component: l,
    elevation: u,
    square: d,
    variant: p
  }, g = fA(h);
  return process.env.NODE_ENV !== "production" && i.shadows[u] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${u}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${u}]\` is defined.`].join(`
`)), /* @__PURE__ */ x.jsx(mA, {
    as: l,
    ownerState: h,
    className: Me(g.root, a),
    ref: n,
    ...m,
    style: {
      ...p === "elevation" && {
        "--Paper-shadow": (i.vars || i).shadows[u],
        ...i.vars && {
          "--Paper-overlay": (v = i.vars.overlays) == null ? void 0 : v[u]
        },
        ...!i.vars && i.palette.mode === "dark" && {
          "--Paper-overlay": `linear-gradient(${mt("#fff", Im(u))}, ${mt("#fff", Im(u))})`
        }
      },
      ...m.style
    }
  });
});
process.env.NODE_ENV !== "production" && ($i.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: fo(yh, (e) => {
    const {
      elevation: t,
      variant: n
    } = e;
    return t > 0 && n === "outlined" ? new Error(`MUI: Combining \`elevation={${t}}\` with \`variant="${n}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: o.bool,
  /**
   * @ignore
   */
  style: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: o.oneOfType([o.oneOf(["elevation", "outlined"]), o.string])
});
function fn(e, t) {
  const {
    className: n,
    elementType: r,
    ownerState: i,
    externalForwardedProps: a,
    internalForwardedProps: l,
    shouldForwardComponentProp: u = !1,
    ...d
  } = t, {
    component: p,
    slots: m = {
      [e]: void 0
    },
    slotProps: h = {
      [e]: void 0
    },
    ...g
  } = a, v = m[e] || r, b = cd(h[e], i), {
    props: {
      component: y,
      ...S
    },
    internalRef: O
  } = L1({
    className: n,
    ...d,
    externalForwardedProps: e === "root" ? g : void 0,
    externalSlotProps: b
  }), P = It(O, b == null ? void 0 : b.ref, t.ref), k = e === "root" ? y || p : y, R = N1(v, {
    ...e === "root" && !p && !m[e] && l,
    ...e !== "root" && !m[e] && l,
    ...S,
    ...k && !u && {
      as: k
    },
    ...k && u && {
      component: k
    },
    ref: P
  }, i);
  return [v, R];
}
class Eu {
  constructor() {
    qe(this, "mountEffect", () => {
      this.shouldMount && !this.didMount && this.ref.current !== null && (this.didMount = !0, this.mounted.resolve());
    });
    this.ref = {
      current: null
    }, this.mounted = null, this.didMount = !1, this.shouldMount = !1, this.setShouldMount = null;
  }
  /** React ref to the ripple instance */
  /** If the ripple component should be mounted */
  /** Promise that resolves when the ripple component is mounted */
  /** If the ripple component has been mounted */
  /** React state hook setter */
  static create() {
    return new Eu();
  }
  static use() {
    const t = I1(Eu.create).current, [n, r] = w.useState(!1);
    return t.shouldMount = n, t.setShouldMount = r, w.useEffect(t.mountEffect, [n]), t;
  }
  mount() {
    return this.mounted || (this.mounted = gA(), this.shouldMount = !0, this.setShouldMount(this.shouldMount)), this.mounted;
  }
  /* Ripple API */
  start(...t) {
    this.mount().then(() => {
      var n;
      return (n = this.ref.current) == null ? void 0 : n.start(...t);
    });
  }
  stop(...t) {
    this.mount().then(() => {
      var n;
      return (n = this.ref.current) == null ? void 0 : n.stop(...t);
    });
  }
  pulsate(...t) {
    this.mount().then(() => {
      var n;
      return (n = this.ref.current) == null ? void 0 : n.pulsate(...t);
    });
  }
}
function hA() {
  return Eu.use();
}
function gA() {
  let e, t;
  const n = new Promise((r, i) => {
    e = r, t = i;
  });
  return n.resolve = e, n.reject = t, n;
}
function nC(e) {
  const {
    className: t,
    classes: n,
    pulsate: r = !1,
    rippleX: i,
    rippleY: a,
    rippleSize: l,
    in: u,
    onExited: d,
    timeout: p
  } = e, [m, h] = w.useState(!1), g = Me(t, n.ripple, n.rippleVisible, r && n.ripplePulsate), v = {
    width: l,
    height: l,
    top: -(l / 2) + a,
    left: -(l / 2) + i
  }, b = Me(n.child, m && n.childLeaving, r && n.childPulsate);
  return !u && !m && h(!0), w.useEffect(() => {
    if (!u && d != null) {
      const y = setTimeout(d, p);
      return () => {
        clearTimeout(y);
      };
    }
  }, [d, u, p]), /* @__PURE__ */ x.jsx("span", {
    className: g,
    style: v,
    children: /* @__PURE__ */ x.jsx("span", {
      className: b
    })
  });
}
process.env.NODE_ENV !== "production" && (nC.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object.isRequired,
  className: o.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: o.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: o.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: o.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: o.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: o.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: o.number,
  /**
   * exit delay
   */
  timeout: o.number.isRequired
});
const Ur = Ve("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), Am = 550, yA = 80, bA = Ml`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`, vA = Ml`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`, xA = Ml`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`, wA = ae("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), CA = ae(nC, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})`
  opacity: 0;
  position: absolute;

  &.${Ur.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${bA};
    animation-duration: ${Am}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  &.${Ur.ripplePulsate} {
    animation-duration: ${({
  theme: e
}) => e.transitions.duration.shorter}ms;
  }

  & .${Ur.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${Ur.childLeaving} {
    opacity: 0;
    animation-name: ${vA};
    animation-duration: ${Am}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  & .${Ur.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${xA};
    animation-duration: 2500ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`, rC = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: i = !1,
    classes: a = {},
    className: l,
    ...u
  } = r, [d, p] = w.useState([]), m = w.useRef(0), h = w.useRef(null);
  w.useEffect(() => {
    h.current && (h.current(), h.current = null);
  }, [d]);
  const g = w.useRef(!1), v = za(), b = w.useRef(null), y = w.useRef(null), S = w.useCallback((R) => {
    const {
      pulsate: E,
      rippleX: M,
      rippleY: _,
      rippleSize: I,
      cb: F
    } = R;
    p((T) => [...T, /* @__PURE__ */ x.jsx(CA, {
      classes: {
        ripple: Me(a.ripple, Ur.ripple),
        rippleVisible: Me(a.rippleVisible, Ur.rippleVisible),
        ripplePulsate: Me(a.ripplePulsate, Ur.ripplePulsate),
        child: Me(a.child, Ur.child),
        childLeaving: Me(a.childLeaving, Ur.childLeaving),
        childPulsate: Me(a.childPulsate, Ur.childPulsate)
      },
      timeout: Am,
      pulsate: E,
      rippleX: M,
      rippleY: _,
      rippleSize: I
    }, m.current)]), m.current += 1, h.current = F;
  }, [a]), O = w.useCallback((R = {}, E = {}, M = () => {
  }) => {
    const {
      pulsate: _ = !1,
      center: I = i || E.pulsate,
      fakeElement: F = !1
      // For test purposes
    } = E;
    if ((R == null ? void 0 : R.type) === "mousedown" && g.current) {
      g.current = !1;
      return;
    }
    (R == null ? void 0 : R.type) === "touchstart" && (g.current = !0);
    const T = F ? null : y.current, $ = T ? T.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let N, W, L;
    if (I || R === void 0 || R.clientX === 0 && R.clientY === 0 || !R.clientX && !R.touches)
      N = Math.round($.width / 2), W = Math.round($.height / 2);
    else {
      const {
        clientX: V,
        clientY: z
      } = R.touches && R.touches.length > 0 ? R.touches[0] : R;
      N = Math.round(V - $.left), W = Math.round(z - $.top);
    }
    if (I)
      L = Math.sqrt((2 * $.width ** 2 + $.height ** 2) / 3), L % 2 === 0 && (L += 1);
    else {
      const V = Math.max(Math.abs((T ? T.clientWidth : 0) - N), N) * 2 + 2, z = Math.max(Math.abs((T ? T.clientHeight : 0) - W), W) * 2 + 2;
      L = Math.sqrt(V ** 2 + z ** 2);
    }
    R != null && R.touches ? b.current === null && (b.current = () => {
      S({
        pulsate: _,
        rippleX: N,
        rippleY: W,
        rippleSize: L,
        cb: M
      });
    }, v.start(yA, () => {
      b.current && (b.current(), b.current = null);
    })) : S({
      pulsate: _,
      rippleX: N,
      rippleY: W,
      rippleSize: L,
      cb: M
    });
  }, [i, S, v]), P = w.useCallback(() => {
    O({}, {
      pulsate: !0
    });
  }, [O]), k = w.useCallback((R, E) => {
    if (v.clear(), (R == null ? void 0 : R.type) === "touchend" && b.current) {
      b.current(), b.current = null, v.start(0, () => {
        k(R, E);
      });
      return;
    }
    b.current = null, p((M) => M.length > 0 ? M.slice(1) : M), h.current = E;
  }, [v]);
  return w.useImperativeHandle(n, () => ({
    pulsate: P,
    start: O,
    stop: k
  }), [P, O, k]), /* @__PURE__ */ x.jsx(wA, {
    className: Me(Ur.root, a.root, l),
    ref: y,
    ...u,
    children: /* @__PURE__ */ x.jsx(Nl, {
      component: null,
      exit: !0,
      children: d
    })
  });
});
process.env.NODE_ENV !== "production" && (rC.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: o.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string
});
function SA(e) {
  return ze("MuiButtonBase", e);
}
const OA = Ve("MuiButtonBase", ["root", "disabled", "focusVisible"]), TA = (e) => {
  const {
    disabled: t,
    focusVisible: n,
    focusVisibleClassName: r,
    classes: i
  } = e, l = We({
    root: ["root", t && "disabled", n && "focusVisible"]
  }, SA, i);
  return n && r && (l.root += ` ${r}`), l;
}, EA = ae("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${OA.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), Io = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: i,
    centerRipple: a = !1,
    children: l,
    className: u,
    component: d = "button",
    disabled: p = !1,
    disableRipple: m = !1,
    disableTouchRipple: h = !1,
    focusRipple: g = !1,
    focusVisibleClassName: v,
    LinkComponent: b = "a",
    onBlur: y,
    onClick: S,
    onContextMenu: O,
    onDragLeave: P,
    onFocus: k,
    onFocusVisible: R,
    onKeyDown: E,
    onKeyUp: M,
    onMouseDown: _,
    onMouseLeave: I,
    onMouseUp: F,
    onTouchEnd: T,
    onTouchMove: $,
    onTouchStart: N,
    tabIndex: W = 0,
    TouchRippleProps: L,
    touchRippleRef: V,
    type: z,
    ...X
  } = r, le = w.useRef(null), ne = hA(), G = It(ne.ref, V), [Q, be] = w.useState(!1);
  p && Q && be(!1), w.useImperativeHandle(i, () => ({
    focusVisible: () => {
      be(!0), le.current.focus();
    }
  }), []);
  const we = ne.shouldMount && !m && !p;
  w.useEffect(() => {
    Q && g && !m && ne.pulsate();
  }, [m, g, Q, ne]);
  const se = Yo(ne, "start", _, h), U = Yo(ne, "stop", O, h), de = Yo(ne, "stop", P, h), ce = Yo(ne, "stop", F, h), K = Yo(ne, "stop", (Ie) => {
    Q && Ie.preventDefault(), I && I(Ie);
  }, h), Z = Yo(ne, "start", N, h), ue = Yo(ne, "stop", T, h), he = Yo(ne, "stop", $, h), B = Yo(ne, "stop", (Ie) => {
    xu(Ie.target) || be(!1), y && y(Ie);
  }, !1), ee = Le((Ie) => {
    le.current || (le.current = Ie.currentTarget), xu(Ie.target) && (be(!0), R && R(Ie)), k && k(Ie);
  }), ie = () => {
    const Ie = le.current;
    return d && d !== "button" && !(Ie.tagName === "A" && Ie.href);
  }, ge = Le((Ie) => {
    g && !Ie.repeat && Q && Ie.key === " " && ne.stop(Ie, () => {
      ne.start(Ie);
    }), Ie.target === Ie.currentTarget && ie() && Ie.key === " " && Ie.preventDefault(), E && E(Ie), Ie.target === Ie.currentTarget && ie() && Ie.key === "Enter" && !p && (Ie.preventDefault(), S && S(Ie));
  }), xe = Le((Ie) => {
    g && Ie.key === " " && Q && !Ie.defaultPrevented && ne.stop(Ie, () => {
      ne.pulsate(Ie);
    }), M && M(Ie), S && Ie.target === Ie.currentTarget && ie() && Ie.key === " " && !Ie.defaultPrevented && S(Ie);
  });
  let pe = d;
  pe === "button" && (X.href || X.to) && (pe = b);
  const Ee = {};
  pe === "button" ? (Ee.type = z === void 0 ? "button" : z, Ee.disabled = p) : (!X.href && !X.to && (Ee.role = "button"), p && (Ee["aria-disabled"] = p));
  const Pe = It(n, le), Be = {
    ...r,
    centerRipple: a,
    component: d,
    disabled: p,
    disableRipple: m,
    disableTouchRipple: h,
    focusRipple: g,
    tabIndex: W,
    focusVisible: Q
  }, Ge = TA(Be);
  return /* @__PURE__ */ x.jsxs(EA, {
    as: pe,
    className: Me(Ge.root, u),
    ownerState: Be,
    onBlur: B,
    onClick: S,
    onContextMenu: U,
    onFocus: ee,
    onKeyDown: ge,
    onKeyUp: xe,
    onMouseDown: se,
    onMouseLeave: K,
    onMouseUp: ce,
    onDragLeave: de,
    onTouchEnd: ue,
    onTouchMove: he,
    onTouchStart: Z,
    ref: Pe,
    tabIndex: p ? -1 : W,
    type: z,
    ...Ee,
    ...X,
    children: [l, we ? /* @__PURE__ */ x.jsx(rC, {
      ref: G,
      center: a,
      ...L
    }) : null]
  });
});
function Yo(e, t, n, r = !1) {
  return Le((i) => (n && n(i), r || e[t](i), !0));
}
process.env.NODE_ENV !== "production" && (Io.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: gn,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: o.bool,
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: ad,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: o.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: o.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: o.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: o.string,
  /**
   * @ignore
   */
  href: o.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: o.elementType,
  /**
   * @ignore
   */
  onBlur: o.func,
  /**
   * @ignore
   */
  onClick: o.func,
  /**
   * @ignore
   */
  onContextMenu: o.func,
  /**
   * @ignore
   */
  onDragLeave: o.func,
  /**
   * @ignore
   */
  onFocus: o.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: o.func,
  /**
   * @ignore
   */
  onKeyDown: o.func,
  /**
   * @ignore
   */
  onKeyUp: o.func,
  /**
   * @ignore
   */
  onMouseDown: o.func,
  /**
   * @ignore
   */
  onMouseLeave: o.func,
  /**
   * @ignore
   */
  onMouseUp: o.func,
  /**
   * @ignore
   */
  onTouchEnd: o.func,
  /**
   * @ignore
   */
  onTouchMove: o.func,
  /**
   * @ignore
   */
  onTouchStart: o.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * @default 0
   */
  tabIndex: o.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: o.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: o.oneOfType([o.func, o.shape({
    current: o.shape({
      pulsate: o.func.isRequired,
      start: o.func.isRequired,
      stop: o.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: o.oneOfType([o.oneOf(["button", "reset", "submit"]), o.string])
});
function RA(e) {
  return typeof e.main == "string";
}
function kA(e, t = []) {
  if (!RA(e))
    return !1;
  for (const n of t)
    if (!e.hasOwnProperty(n) || typeof e[n] != "string")
      return !1;
  return !0;
}
function qn(e = []) {
  return ([, t]) => t && kA(t, e);
}
function PA(e) {
  return ze("MuiCircularProgress", e);
}
const DA = Ve("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]), xi = 44, Nm = Ml`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`, Fm = Ml`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`, MA = typeof Nm != "string" ? ch`
        animation: ${Nm} 1.4s linear infinite;
      ` : null, _A = typeof Fm != "string" ? ch`
        animation: ${Fm} 1.4s ease-in-out infinite;
      ` : null, IA = (e) => {
  const {
    classes: t,
    variant: n,
    color: r,
    disableShrink: i
  } = e, a = {
    root: ["root", n, `color${ke(r)}`],
    svg: ["svg"],
    circle: ["circle", `circle${ke(n)}`, i && "circleDisableShrink"]
  };
  return We(a, PA, t);
}, jA = ae("span", {
  name: "MuiCircularProgress",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`color${ke(n.color)}`]];
  }
})(ct(({
  theme: e
}) => ({
  display: "inline-block",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("transform")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: MA || {
      animation: `${Nm} 1.4s linear infinite`
    }
  }, ...Object.entries(e.palette).filter(qn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  }))]
}))), $A = ae("svg", {
  name: "MuiCircularProgress",
  slot: "Svg",
  overridesResolver: (e, t) => t.svg
})({
  display: "block"
  // Keeps the progress centered
}), AA = ae("circle", {
  name: "MuiCircularProgress",
  slot: "Circle",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.circle, t[`circle${ke(n.variant)}`], n.disableShrink && t.circleDisableShrink];
  }
})(ct(({
  theme: e
}) => ({
  stroke: "currentColor",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("stroke-dashoffset")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: {
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: "80px, 200px",
      strokeDashoffset: 0
      // Add the unit to fix a Edge 16 and below bug.
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" && !t.disableShrink,
    style: _A || {
      // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
      animation: `${Fm} 1.4s ease-in-out infinite`
    }
  }]
}))), Mi = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiCircularProgress"
  }), {
    className: i,
    color: a = "primary",
    disableShrink: l = !1,
    size: u = 40,
    style: d,
    thickness: p = 3.6,
    value: m = 0,
    variant: h = "indeterminate",
    ...g
  } = r, v = {
    ...r,
    color: a,
    disableShrink: l,
    size: u,
    thickness: p,
    value: m,
    variant: h
  }, b = IA(v), y = {}, S = {}, O = {};
  if (h === "determinate") {
    const P = 2 * Math.PI * ((xi - p) / 2);
    y.strokeDasharray = P.toFixed(3), O["aria-valuenow"] = Math.round(m), y.strokeDashoffset = `${((100 - m) / 100 * P).toFixed(3)}px`, S.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ x.jsx(jA, {
    className: Me(b.root, i),
    style: {
      width: u,
      height: u,
      ...S,
      ...d
    },
    ownerState: v,
    ref: n,
    role: "progressbar",
    ...O,
    ...g,
    children: /* @__PURE__ */ x.jsx($A, {
      className: b.svg,
      ownerState: v,
      viewBox: `${xi / 2} ${xi / 2} ${xi} ${xi}`,
      children: /* @__PURE__ */ x.jsx(AA, {
        className: b.circle,
        style: y,
        ownerState: v,
        cx: xi,
        cy: xi,
        r: (xi - p) / 2,
        fill: "none",
        strokeWidth: p
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (Mi.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: o.oneOfType([o.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), o.string]),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */
  disableShrink: fo(o.bool, (e) => e.disableShrink && e.variant && e.variant !== "indeterminate" ? new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.") : null),
  /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, for example '3rem'.
   * @default 40
   */
  size: o.oneOfType([o.number, o.string]),
  /**
   * @ignore
   */
  style: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The thickness of the circle.
   * @default 3.6
   */
  thickness: o.number,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: o.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */
  variant: o.oneOf(["determinate", "indeterminate"])
});
function NA(e) {
  return ze("MuiIconButton", e);
}
const ox = Ve("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge", "loading", "loadingIndicator", "loadingWrapper"]), FA = (e) => {
  const {
    classes: t,
    disabled: n,
    color: r,
    edge: i,
    size: a,
    loading: l
  } = e, u = {
    root: ["root", l && "loading", n && "disabled", r !== "default" && `color${ke(r)}`, i && `edge${ke(i)}`, `size${ke(a)}`],
    loadingIndicator: ["loadingIndicator"],
    loadingWrapper: ["loadingWrapper"]
  };
  return We(u, NA, t);
}, LA = ae(Io, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.loading && t.loading, n.color !== "default" && t[`color${ke(n.color)}`], n.edge && t[`edge${ke(n.edge)}`], t[`size${ke(n.size)}`]];
  }
})(ct(({
  theme: e
}) => ({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: e.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  color: (e.vars || e).palette.action.active,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  variants: [{
    props: (t) => !t.disableRipple,
    style: {
      "--IconButton-hoverBg": e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : mt(e.palette.action.active, e.palette.action.hoverOpacity),
      "&:hover": {
        backgroundColor: "var(--IconButton-hoverBg)",
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }]
})), ct(({
  theme: e
}) => ({
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, ...Object.entries(e.palette).filter(qn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  })), ...Object.entries(e.palette).filter(qn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      "--IconButton-hoverBg": e.vars ? `rgba(${(e.vars || e).palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : mt((e.vars || e).palette[t].main, e.palette.action.hoverOpacity)
    }
  })), {
    props: {
      size: "small"
    },
    style: {
      padding: 5,
      fontSize: e.typography.pxToRem(18)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      padding: 12,
      fontSize: e.typography.pxToRem(28)
    }
  }],
  [`&.${ox.disabled}`]: {
    backgroundColor: "transparent",
    color: (e.vars || e).palette.action.disabled
  },
  [`&.${ox.loading}`]: {
    color: "transparent"
  }
}))), BA = ae("span", {
  name: "MuiIconButton",
  slot: "LoadingIndicator",
  overridesResolver: (e, t) => t.loadingIndicator
})(({
  theme: e
}) => ({
  display: "none",
  position: "absolute",
  visibility: "visible",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  color: (e.vars || e).palette.action.disabled,
  variants: [{
    props: {
      loading: !0
    },
    style: {
      display: "flex"
    }
  }]
})), Ai = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiIconButton"
  }), {
    edge: i = !1,
    children: a,
    className: l,
    color: u = "default",
    disabled: d = !1,
    disableFocusRipple: p = !1,
    size: m = "medium",
    id: h,
    loading: g = null,
    loadingIndicator: v,
    ...b
  } = r, y = Ir(h), S = v ?? /* @__PURE__ */ x.jsx(Mi, {
    "aria-labelledby": y,
    color: "inherit",
    size: 16
  }), O = {
    ...r,
    edge: i,
    color: u,
    disabled: d,
    disableFocusRipple: p,
    loading: g,
    loadingIndicator: S,
    size: m
  }, P = FA(O);
  return /* @__PURE__ */ x.jsxs(LA, {
    id: g ? y : h,
    className: Me(P.root, l),
    centerRipple: !0,
    focusRipple: !p,
    disabled: d || g,
    ref: n,
    ...b,
    ownerState: O,
    children: [typeof g == "boolean" && // use plain HTML span to minimize the runtime overhead
    /* @__PURE__ */ x.jsx("span", {
      className: P.loadingWrapper,
      style: {
        display: "contents"
      },
      children: /* @__PURE__ */ x.jsx(BA, {
        className: P.loadingIndicator,
        ownerState: O,
        children: g && S
      })
    }), a]
  });
});
process.env.NODE_ENV !== "production" && (Ai.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: fo(o.node, (e) => w.Children.toArray(e.children).some((n) => /* @__PURE__ */ w.isValidElement(n) && n.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: o.oneOfType([o.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), o.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: o.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: o.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: o.oneOf(["end", "start", !1]),
  /**
   * @ignore
   */
  id: o.string,
  /**
   * If `true`, the loading indicator is visible and the button is disabled.
   * If `true | false`, the loading wrapper is always rendered before the children to prevent [Google Translation Crash](https://github.com/mui/material-ui/issues/27853).
   * @default null
   */
  loading: o.bool,
  /**
   * Element placed before the children if the button is in loading state.
   * The node should contain an element with `role="progressbar"` with an accessible name.
   * By default, it renders a `CircularProgress` that is labeled by the button itself.
   * @default <CircularProgress color="inherit" size={16} />
   */
  loadingIndicator: o.node,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: o.oneOfType([o.oneOf(["small", "medium", "large"]), o.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
const VA = rn(/* @__PURE__ */ x.jsx("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
function zA(e) {
  return ze("MuiTypography", e);
}
Ve("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]);
const WA = {
  primary: !0,
  secondary: !0,
  error: !0,
  info: !0,
  success: !0,
  warning: !0,
  textPrimary: !0,
  textSecondary: !0,
  textDisabled: !0
}, qA = X$(), HA = (e) => {
  const {
    align: t,
    gutterBottom: n,
    noWrap: r,
    paragraph: i,
    variant: a,
    classes: l
  } = e, u = {
    root: ["root", a, e.align !== "inherit" && `align${ke(t)}`, n && "gutterBottom", r && "noWrap", i && "paragraph"]
  };
  return We(u, zA, l);
}, UA = ae("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.variant && t[n.variant], n.align !== "inherit" && t[`align${ke(n.align)}`], n.noWrap && t.noWrap, n.gutterBottom && t.gutterBottom, n.paragraph && t.paragraph];
  }
})(ct(({
  theme: e
}) => {
  var t;
  return {
    margin: 0,
    variants: [{
      props: {
        variant: "inherit"
      },
      style: {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit",
        lineHeight: "inherit",
        letterSpacing: "inherit"
      }
    }, ...Object.entries(e.typography).filter(([n, r]) => n !== "inherit" && r && typeof r == "object").map(([n, r]) => ({
      props: {
        variant: n
      },
      style: r
    })), ...Object.entries(e.palette).filter(qn()).map(([n]) => ({
      props: {
        color: n
      },
      style: {
        color: (e.vars || e).palette[n].main
      }
    })), ...Object.entries(((t = e.palette) == null ? void 0 : t.text) || {}).filter(([, n]) => typeof n == "string").map(([n]) => ({
      props: {
        color: `text${ke(n)}`
      },
      style: {
        color: (e.vars || e).palette.text[n]
      }
    })), {
      props: ({
        ownerState: n
      }) => n.align !== "inherit",
      style: {
        textAlign: "var(--Typography-textAlign)"
      }
    }, {
      props: ({
        ownerState: n
      }) => n.noWrap,
      style: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    }, {
      props: ({
        ownerState: n
      }) => n.gutterBottom,
      style: {
        marginBottom: "0.35em"
      }
    }, {
      props: ({
        ownerState: n
      }) => n.paragraph,
      style: {
        marginBottom: 16
      }
    }]
  };
})), ix = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, at = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const {
    color: r,
    ...i
  } = ut({
    props: t,
    name: "MuiTypography"
  }), a = !WA[r], l = qA({
    ...i,
    ...a && {
      color: r
    }
  }), {
    align: u = "inherit",
    className: d,
    component: p,
    gutterBottom: m = !1,
    noWrap: h = !1,
    paragraph: g = !1,
    variant: v = "body1",
    variantMapping: b = ix,
    ...y
  } = l, S = {
    ...l,
    align: u,
    color: r,
    className: d,
    component: p,
    gutterBottom: m,
    noWrap: h,
    paragraph: g,
    variant: v,
    variantMapping: b
  }, O = p || (g ? "p" : b[v] || ix[v]) || "span", P = HA(S);
  return /* @__PURE__ */ x.jsx(UA, {
    as: O,
    ref: n,
    className: Me(P.root, d),
    ...y,
    ownerState: S,
    style: {
      ...u !== "inherit" && {
        "--Typography-textAlign": u
      },
      ...y.style
    }
  });
});
process.env.NODE_ENV !== "production" && (at.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: o.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: o.oneOfType([o.oneOf(["primary", "secondary", "success", "error", "info", "warning", "textPrimary", "textSecondary", "textDisabled"]), o.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: o.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: o.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   * @deprecated Use the `component` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  paragraph: o.bool,
  /**
   * @ignore
   */
  style: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: o.oneOfType([o.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), o.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: o.object
});
function ax(e) {
  return e.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
function YA(e = {}) {
  const {
    ignoreAccents: t = !0,
    ignoreCase: n = !0,
    limit: r,
    matchFrom: i = "any",
    stringify: a,
    trim: l = !1
  } = e;
  return (u, {
    inputValue: d,
    getOptionLabel: p
  }) => {
    let m = l ? d.trim() : d;
    n && (m = m.toLowerCase()), t && (m = ax(m));
    const h = m ? u.filter((g) => {
      let v = (a || p)(g);
      return n && (v = v.toLowerCase()), t && (v = ax(v)), i === "start" ? v.startsWith(m) : v.includes(m);
    }) : u;
    return typeof r == "number" ? h.slice(0, r) : h;
  };
}
const GA = YA(), KA = 5, XA = (e) => {
  var t;
  return e.current !== null && ((t = e.current.parentElement) == null ? void 0 : t.contains(document.activeElement));
}, QA = [];
function sx(e, t, n) {
  if (t || e == null)
    return "";
  const r = n(e);
  return typeof r == "string" ? r : "";
}
function ZA(e) {
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox: t = XA,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix: n = "Mui",
    autoComplete: r = !1,
    autoHighlight: i = !1,
    autoSelect: a = !1,
    blurOnSelect: l = !1,
    clearOnBlur: u = !e.freeSolo,
    clearOnEscape: d = !1,
    componentName: p = "useAutocomplete",
    defaultValue: m = e.multiple ? QA : null,
    disableClearable: h = !1,
    disableCloseOnSelect: g = !1,
    disabled: v,
    disabledItemsFocusable: b = !1,
    disableListWrap: y = !1,
    filterOptions: S = GA,
    filterSelectedOptions: O = !1,
    freeSolo: P = !1,
    getOptionDisabled: k,
    getOptionKey: R,
    getOptionLabel: E = (fe) => fe.label ?? fe,
    groupBy: M,
    handleHomeEndKeys: _ = !e.freeSolo,
    id: I,
    includeInputInList: F = !1,
    inputValue: T,
    isOptionEqualToValue: $ = (fe, oe) => fe === oe,
    multiple: N = !1,
    onChange: W,
    onClose: L,
    onHighlightChange: V,
    onInputChange: z,
    onOpen: X,
    open: le,
    openOnFocus: ne = !1,
    options: G,
    readOnly: Q = !1,
    selectOnFocus: be = !e.freeSolo,
    value: we
  } = e, se = Ir(I);
  let U = E;
  U = (fe) => {
    const oe = E(fe);
    if (typeof oe != "string") {
      if (process.env.NODE_ENV !== "production") {
        const Te = oe === void 0 ? "undefined" : `${typeof oe} (${oe})`;
        console.error(`MUI: The \`getOptionLabel\` method of ${p} returned ${Te} instead of a string for ${JSON.stringify(fe)}.`);
      }
      return String(oe);
    }
    return oe;
  };
  const de = w.useRef(!1), ce = w.useRef(!0), K = w.useRef(null), Z = w.useRef(null), [ue, he] = w.useState(null), [B, ee] = w.useState(-1), ie = i ? 0 : -1, ge = w.useRef(ie), xe = w.useRef(sx(m, N, U)).current, [pe, Ee] = or({
    controlled: we,
    default: m,
    name: p
  }), [Pe, Be] = or({
    controlled: T,
    default: xe,
    name: p,
    state: "inputValue"
  }), [Ge, Ie] = w.useState(!1), Dt = w.useCallback((fe, oe, Te) => {
    if (!(N ? pe.length < oe.length : oe !== null) && !u)
      return;
    const Ye = sx(oe, N, U);
    Pe !== Ye && (Be(Ye), z && z(fe, Ye, Te));
  }, [U, Pe, N, z, Be, u, pe]), [Re, $e] = or({
    controlled: le,
    default: !1,
    name: p,
    state: "open"
  }), [dt, He] = w.useState(!0), Je = !N && pe != null && Pe === U(pe), Ze = Re && !Q, nt = Ze ? S(
    G.filter((fe) => !(O && (N ? pe : [pe]).some((oe) => oe !== null && $(fe, oe)))),
    // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
      inputValue: Je && dt ? "" : Pe,
      getOptionLabel: U
    }
  ) : [], Ne = Pj({
    filteredOptions: nt,
    value: pe,
    inputValue: Pe
  });
  w.useEffect(() => {
    const fe = pe !== Ne.value;
    Ge && !fe || P && !fe || Dt(null, pe, "reset");
  }, [pe, Dt, Ge, Ne.value, P]);
  const Ct = Re && nt.length > 0 && !Q, Rt = Le((fe) => {
    fe === -1 ? K.current.focus() : ue.querySelector(`[data-tag-index="${fe}"]`).focus();
  });
  w.useEffect(() => {
    N && B > pe.length - 1 && (ee(-1), Rt(-1));
  }, [pe, N, B, Rt]);
  function At(fe, oe) {
    if (!Z.current || fe < 0 || fe >= nt.length)
      return -1;
    let Te = fe;
    for (; ; ) {
      const Ke = Z.current.querySelector(`[data-option-index="${Te}"]`), Ye = b ? !1 : !Ke || Ke.disabled || Ke.getAttribute("aria-disabled") === "true";
      if (Ke && Ke.hasAttribute("tabindex") && !Ye)
        return Te;
      if (oe === "next" ? Te = (Te + 1) % nt.length : Te = (Te - 1 + nt.length) % nt.length, Te === fe)
        return -1;
    }
  }
  const Xt = Le(({
    event: fe,
    index: oe,
    reason: Te = "auto"
  }) => {
    if (ge.current = oe, oe === -1 ? K.current.removeAttribute("aria-activedescendant") : K.current.setAttribute("aria-activedescendant", `${se}-option-${oe}`), V && V(fe, oe === -1 ? null : nt[oe], Te), !Z.current)
      return;
    const Ke = Z.current.querySelector(`[role="option"].${n}-focused`);
    Ke && (Ke.classList.remove(`${n}-focused`), Ke.classList.remove(`${n}-focusVisible`));
    let Ye = Z.current;
    if (Z.current.getAttribute("role") !== "listbox" && (Ye = Z.current.parentElement.querySelector('[role="listbox"]')), !Ye)
      return;
    if (oe === -1) {
      Ye.scrollTop = 0;
      return;
    }
    const tt = Z.current.querySelector(`[data-option-index="${oe}"]`);
    if (tt && (tt.classList.add(`${n}-focused`), Te === "keyboard" && tt.classList.add(`${n}-focusVisible`), Ye.scrollHeight > Ye.clientHeight && Te !== "mouse" && Te !== "touch")) {
      const Mt = tt, Jt = Ye.clientHeight + Ye.scrollTop, Jn = Mt.offsetTop + Mt.offsetHeight;
      Jn > Jt ? Ye.scrollTop = Jn - Ye.clientHeight : Mt.offsetTop - Mt.offsetHeight * (M ? 1.3 : 0) < Ye.scrollTop && (Ye.scrollTop = Mt.offsetTop - Mt.offsetHeight * (M ? 1.3 : 0));
    }
  }), je = Le(({
    event: fe,
    diff: oe,
    direction: Te = "next",
    reason: Ke = "auto"
  }) => {
    if (!Ze)
      return;
    const tt = At((() => {
      const Mt = nt.length - 1;
      if (oe === "reset")
        return ie;
      if (oe === "start")
        return 0;
      if (oe === "end")
        return Mt;
      const Jt = ge.current + oe;
      return Jt < 0 ? Jt === -1 && F ? -1 : y && ge.current !== -1 || Math.abs(oe) > 1 ? 0 : Mt : Jt > Mt ? Jt === Mt + 1 && F ? -1 : y || Math.abs(oe) > 1 ? Mt : 0 : Jt;
    })(), Te);
    if (Xt({
      index: tt,
      reason: Ke,
      event: fe
    }), r && oe !== "reset")
      if (tt === -1)
        K.current.value = Pe;
      else {
        const Mt = U(nt[tt]);
        K.current.value = Mt, Mt.toLowerCase().indexOf(Pe.toLowerCase()) === 0 && Pe.length > 0 && K.current.setSelectionRange(Pe.length, Mt.length);
      }
  }), ot = () => {
    const fe = (oe, Te) => {
      const Ke = oe ? U(oe) : "", Ye = Te ? U(Te) : "";
      return Ke === Ye;
    };
    if (ge.current !== -1 && Ne.filteredOptions && Ne.filteredOptions.length !== nt.length && Ne.inputValue === Pe && (N ? pe.length === Ne.value.length && Ne.value.every((oe, Te) => U(pe[Te]) === U(oe)) : fe(Ne.value, pe))) {
      const oe = Ne.filteredOptions[ge.current];
      if (oe)
        return nt.findIndex((Te) => U(Te) === U(oe));
    }
    return -1;
  }, vt = w.useCallback(() => {
    if (!Ze)
      return;
    const fe = ot();
    if (fe !== -1) {
      ge.current = fe;
      return;
    }
    const oe = N ? pe[0] : pe;
    if (nt.length === 0 || oe == null) {
      je({
        diff: "reset"
      });
      return;
    }
    if (Z.current) {
      if (oe != null) {
        const Te = nt[ge.current];
        if (N && Te && pe.findIndex((Ye) => $(Te, Ye)) !== -1)
          return;
        const Ke = nt.findIndex((Ye) => $(Ye, oe));
        Ke === -1 ? je({
          diff: "reset"
        }) : Xt({
          index: Ke
        });
        return;
      }
      if (ge.current >= nt.length - 1) {
        Xt({
          index: nt.length - 1
        });
        return;
      }
      Xt({
        index: ge.current
      });
    }
  }, [
    // Only sync the highlighted index when the option switch between empty and not
    nt.length,
    // Don't sync the highlighted index with the value when multiple
    // eslint-disable-next-line react-hooks/exhaustive-deps
    N ? !1 : pe,
    O,
    je,
    Xt,
    Ze,
    Pe,
    N
  ]), gt = Le((fe) => {
    vu(Z, fe), fe && vt();
  });
  process.env.NODE_ENV !== "production" && w.useEffect(() => {
    (!K.current || K.current.nodeName !== "INPUT") && (K.current && K.current.nodeName === "TEXTAREA" ? console.warn([`A textarea element was provided to ${p} where input was expected.`, "This is not a supported scenario but it may work under certain conditions.", "A textarea keyboard navigation may conflict with Autocomplete controls (for example enter and arrow keys).", "Make sure to test keyboard navigation and add custom event handlers if necessary."].join(`
`)) : console.error([`MUI: Unable to find the input element. It was resolved to ${K.current} while an HTMLInputElement was expected.`, `Instead, ${p} expects an input element.`, "", p === "useAutocomplete" ? "Make sure you have bound getInputProps correctly and that the normal ref/effect resolutions order is guaranteed." : "Make sure you have customized the input component correctly."].join(`
`)));
  }, [p]), w.useEffect(() => {
    vt();
  }, [vt]);
  const kt = (fe) => {
    Re || ($e(!0), He(!0), X && X(fe));
  }, xn = (fe, oe) => {
    Re && ($e(!1), L && L(fe, oe));
  }, on = (fe, oe, Te, Ke) => {
    if (N) {
      if (pe.length === oe.length && pe.every((Ye, tt) => Ye === oe[tt]))
        return;
    } else if (pe === oe)
      return;
    W && W(fe, oe, Te, Ke), Ee(oe);
  }, br = w.useRef(!1), Un = (fe, oe, Te = "selectOption", Ke = "options") => {
    let Ye = Te, tt = oe;
    if (N) {
      if (tt = Array.isArray(pe) ? pe.slice() : [], process.env.NODE_ENV !== "production") {
        const Jt = tt.filter((Jn) => $(oe, Jn));
        Jt.length > 1 && console.error([`MUI: The \`isOptionEqualToValue\` method of ${p} does not handle the arguments correctly.`, `The component expects a single value to match a given option but found ${Jt.length} matches.`].join(`
`));
      }
      const Mt = tt.findIndex((Jt) => $(oe, Jt));
      Mt === -1 ? tt.push(oe) : Ke !== "freeSolo" && (tt.splice(Mt, 1), Ye = "removeOption");
    }
    Dt(fe, tt, Ye), on(fe, tt, Ye, {
      option: oe
    }), !g && (!fe || !fe.ctrlKey && !fe.metaKey) && xn(fe, Ye), (l === !0 || l === "touch" && br.current || l === "mouse" && !br.current) && K.current.blur();
  };
  function no(fe, oe) {
    if (fe === -1)
      return -1;
    let Te = fe;
    for (; ; ) {
      if (oe === "next" && Te === pe.length || oe === "previous" && Te === -1)
        return -1;
      const Ke = ue.querySelector(`[data-tag-index="${Te}"]`);
      if (!Ke || !Ke.hasAttribute("tabindex") || Ke.disabled || Ke.getAttribute("aria-disabled") === "true")
        Te += oe === "next" ? 1 : -1;
      else
        return Te;
    }
  }
  const mo = (fe, oe) => {
    if (!N)
      return;
    Pe === "" && xn(fe, "toggleInput");
    let Te = B;
    B === -1 ? Pe === "" && oe === "previous" && (Te = pe.length - 1) : (Te += oe === "next" ? 1 : -1, Te < 0 && (Te = 0), Te === pe.length && (Te = -1)), Te = no(Te, oe), ee(Te), Rt(Te);
  }, et = (fe) => {
    de.current = !0, Be(""), z && z(fe, "", "clear"), on(fe, N ? [] : null, "clear");
  }, jn = (fe) => (oe) => {
    if (fe.onKeyDown && fe.onKeyDown(oe), !oe.defaultMuiPrevented && (B !== -1 && !["ArrowLeft", "ArrowRight"].includes(oe.key) && (ee(-1), Rt(-1)), oe.which !== 229))
      switch (oe.key) {
        case "Home":
          Ze && _ && (oe.preventDefault(), je({
            diff: "start",
            direction: "next",
            reason: "keyboard",
            event: oe
          }));
          break;
        case "End":
          Ze && _ && (oe.preventDefault(), je({
            diff: "end",
            direction: "previous",
            reason: "keyboard",
            event: oe
          }));
          break;
        case "PageUp":
          oe.preventDefault(), je({
            diff: -5,
            direction: "previous",
            reason: "keyboard",
            event: oe
          }), kt(oe);
          break;
        case "PageDown":
          oe.preventDefault(), je({
            diff: KA,
            direction: "next",
            reason: "keyboard",
            event: oe
          }), kt(oe);
          break;
        case "ArrowDown":
          oe.preventDefault(), je({
            diff: 1,
            direction: "next",
            reason: "keyboard",
            event: oe
          }), kt(oe);
          break;
        case "ArrowUp":
          oe.preventDefault(), je({
            diff: -1,
            direction: "previous",
            reason: "keyboard",
            event: oe
          }), kt(oe);
          break;
        case "ArrowLeft":
          mo(oe, "previous");
          break;
        case "ArrowRight":
          mo(oe, "next");
          break;
        case "Enter":
          if (ge.current !== -1 && Ze) {
            const Te = nt[ge.current], Ke = k ? k(Te) : !1;
            if (oe.preventDefault(), Ke)
              return;
            Un(oe, Te, "selectOption"), r && K.current.setSelectionRange(K.current.value.length, K.current.value.length);
          } else P && Pe !== "" && Je === !1 && (N && oe.preventDefault(), Un(oe, Pe, "createOption", "freeSolo"));
          break;
        case "Escape":
          Ze ? (oe.preventDefault(), oe.stopPropagation(), xn(oe, "escape")) : d && (Pe !== "" || N && pe.length > 0) && (oe.preventDefault(), oe.stopPropagation(), et(oe));
          break;
        case "Backspace":
          if (N && !Q && Pe === "" && pe.length > 0) {
            const Te = B === -1 ? pe.length - 1 : B, Ke = pe.slice();
            Ke.splice(Te, 1), on(oe, Ke, "removeOption", {
              option: pe[Te]
            });
          }
          break;
        case "Delete":
          if (N && !Q && Pe === "" && pe.length > 0 && B !== -1) {
            const Te = B, Ke = pe.slice();
            Ke.splice(Te, 1), on(oe, Ke, "removeOption", {
              option: pe[Te]
            });
          }
          break;
      }
  }, ho = (fe) => {
    Ie(!0), ne && !de.current && kt(fe);
  }, ro = (fe) => {
    if (t(Z)) {
      K.current.focus();
      return;
    }
    Ie(!1), ce.current = !0, de.current = !1, a && ge.current !== -1 && Ze ? Un(fe, nt[ge.current], "blur") : a && P && Pe !== "" ? Un(fe, Pe, "blur", "freeSolo") : u && Dt(fe, pe, "blur"), xn(fe, "blur");
  }, $r = (fe) => {
    const oe = fe.target.value;
    Pe !== oe && (Be(oe), He(!1), z && z(fe, oe, "input")), oe === "" ? !h && !N && on(fe, null, "clear") : kt(fe);
  }, go = (fe) => {
    const oe = Number(fe.currentTarget.getAttribute("data-option-index"));
    ge.current !== oe && Xt({
      event: fe,
      index: oe,
      reason: "mouse"
    });
  }, Ao = (fe) => {
    Xt({
      event: fe,
      index: Number(fe.currentTarget.getAttribute("data-option-index")),
      reason: "touch"
    }), br.current = !0;
  }, Li = (fe) => {
    const oe = Number(fe.currentTarget.getAttribute("data-option-index"));
    Un(fe, nt[oe], "selectOption"), br.current = !1;
  }, Bi = (fe) => (oe) => {
    const Te = pe.slice();
    Te.splice(fe, 1), on(oe, Te, "removeOption", {
      option: pe[fe]
    });
  }, Vi = (fe) => {
    Re ? xn(fe, "toggleInput") : kt(fe);
  }, H = (fe) => {
    fe.currentTarget.contains(fe.target) && fe.target.getAttribute("id") !== se && fe.preventDefault();
  }, Se = (fe) => {
    fe.currentTarget.contains(fe.target) && (K.current.focus(), be && ce.current && K.current.selectionEnd - K.current.selectionStart === 0 && K.current.select(), ce.current = !1);
  }, _e = (fe) => {
    !v && (Pe === "" || !Re) && Vi(fe);
  };
  let Qe = P && Pe.length > 0;
  Qe = Qe || (N ? pe.length > 0 : pe !== null);
  let Ot = nt;
  if (M) {
    const fe = /* @__PURE__ */ new Map();
    let oe = !1;
    Ot = nt.reduce((Te, Ke, Ye) => {
      const tt = M(Ke);
      return Te.length > 0 && Te[Te.length - 1].group === tt ? Te[Te.length - 1].options.push(Ke) : (process.env.NODE_ENV !== "production" && (fe.get(tt) && !oe && (console.warn(`MUI: The options provided combined with the \`groupBy\` method of ${p} returns duplicated headers.`, "You can solve the issue by sorting the options with the output of `groupBy`."), oe = !0), fe.set(tt, !0)), Te.push({
        key: Ye,
        index: Ye,
        group: tt,
        options: [Ke]
      })), Te;
    }, []);
  }
  return v && Ge && ro(), {
    getRootProps: (fe = {}) => ({
      ...fe,
      onKeyDown: jn(fe),
      onMouseDown: H,
      onClick: Se
    }),
    getInputLabelProps: () => ({
      id: `${se}-label`,
      htmlFor: se
    }),
    getInputProps: () => ({
      id: se,
      value: Pe,
      onBlur: ro,
      onFocus: ho,
      onChange: $r,
      onMouseDown: _e,
      // if open then this is handled imperatively so don't let react override
      // only have an opinion about this when closed
      "aria-activedescendant": Ze ? "" : null,
      "aria-autocomplete": r ? "both" : "list",
      "aria-controls": Ct ? `${se}-listbox` : void 0,
      "aria-expanded": Ct,
      // Disable browser's suggestion that might overlap with the popup.
      // Handle autocomplete but not autofill.
      autoComplete: "off",
      ref: K,
      autoCapitalize: "none",
      spellCheck: "false",
      role: "combobox",
      disabled: v
    }),
    getClearProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: et
    }),
    getPopupIndicatorProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: Vi
    }),
    getTagProps: ({
      index: fe
    }) => ({
      key: fe,
      "data-tag-index": fe,
      tabIndex: -1,
      ...!Q && {
        onDelete: Bi(fe)
      }
    }),
    getListboxProps: () => ({
      role: "listbox",
      id: `${se}-listbox`,
      "aria-labelledby": `${se}-label`,
      ref: gt,
      onMouseDown: (fe) => {
        fe.preventDefault();
      }
    }),
    getOptionProps: ({
      index: fe,
      option: oe
    }) => {
      const Te = (N ? pe : [pe]).some((Ye) => Ye != null && $(oe, Ye)), Ke = k ? k(oe) : !1;
      return {
        key: (R == null ? void 0 : R(oe)) ?? U(oe),
        tabIndex: -1,
        role: "option",
        id: `${se}-option-${fe}`,
        onMouseMove: go,
        onClick: Li,
        onTouchStart: Ao,
        "data-option-index": fe,
        "aria-disabled": Ke,
        "aria-selected": Te
      };
    },
    id: se,
    inputValue: Pe,
    value: pe,
    dirty: Qe,
    expanded: Ze && ue,
    popupOpen: Ze,
    focused: Ge || B !== -1,
    anchorEl: ue,
    setAnchorEl: he,
    focusedTag: B,
    groupedOptions: Ot
  };
}
var hr = "top", Xr = "bottom", Qr = "right", gr = "left", Eh = "auto", Fl = [hr, Xr, Qr, gr], Ja = "start", ml = "end", JA = "clippingParents", oC = "viewport", $s = "popper", eN = "reference", lx = /* @__PURE__ */ Fl.reduce(function(e, t) {
  return e.concat([t + "-" + Ja, t + "-" + ml]);
}, []), iC = /* @__PURE__ */ [].concat(Fl, [Eh]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Ja, t + "-" + ml]);
}, []), tN = "beforeRead", nN = "read", rN = "afterRead", oN = "beforeMain", iN = "main", aN = "afterMain", sN = "beforeWrite", lN = "write", cN = "afterWrite", uN = [tN, nN, rN, oN, iN, aN, sN, lN, cN];
function jo(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function _r(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function pa(e) {
  var t = _r(e).Element;
  return e instanceof t || e instanceof Element;
}
function Kr(e) {
  var t = _r(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Rh(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = _r(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function dN(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, i = t.attributes[n] || {}, a = t.elements[n];
    !Kr(a) || !jo(a) || (Object.assign(a.style, r), Object.keys(i).forEach(function(l) {
      var u = i[l];
      u === !1 ? a.removeAttribute(l) : a.setAttribute(l, u === !0 ? "" : u);
    }));
  });
}
function pN(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var i = t.elements[r], a = t.attributes[r] || {}, l = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), u = l.reduce(function(d, p) {
        return d[p] = "", d;
      }, {});
      !Kr(i) || !jo(i) || (Object.assign(i.style, u), Object.keys(a).forEach(function(d) {
        i.removeAttribute(d);
      }));
    });
  };
}
const fN = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: dN,
  effect: pN,
  requires: ["computeStyles"]
};
function Do(e) {
  return e.split("-")[0];
}
var ca = Math.max, Ru = Math.min, es = Math.round;
function Lm() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function aC() {
  return !/^((?!chrome|android).)*safari/i.test(Lm());
}
function ts(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), i = 1, a = 1;
  t && Kr(e) && (i = e.offsetWidth > 0 && es(r.width) / e.offsetWidth || 1, a = e.offsetHeight > 0 && es(r.height) / e.offsetHeight || 1);
  var l = pa(e) ? _r(e) : window, u = l.visualViewport, d = !aC() && n, p = (r.left + (d && u ? u.offsetLeft : 0)) / i, m = (r.top + (d && u ? u.offsetTop : 0)) / a, h = r.width / i, g = r.height / a;
  return {
    width: h,
    height: g,
    top: m,
    right: p + h,
    bottom: m + g,
    left: p,
    x: p,
    y: m
  };
}
function kh(e) {
  var t = ts(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function sC(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && Rh(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function ni(e) {
  return _r(e).getComputedStyle(e);
}
function mN(e) {
  return ["table", "td", "th"].indexOf(jo(e)) >= 0;
}
function Ni(e) {
  return ((pa(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function fd(e) {
  return jo(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Rh(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Ni(e)
  );
}
function cx(e) {
  return !Kr(e) || // https://github.com/popperjs/popper-core/issues/837
  ni(e).position === "fixed" ? null : e.offsetParent;
}
function hN(e) {
  var t = /firefox/i.test(Lm()), n = /Trident/i.test(Lm());
  if (n && Kr(e)) {
    var r = ni(e);
    if (r.position === "fixed")
      return null;
  }
  var i = fd(e);
  for (Rh(i) && (i = i.host); Kr(i) && ["html", "body"].indexOf(jo(i)) < 0; ) {
    var a = ni(i);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || t && a.willChange === "filter" || t && a.filter && a.filter !== "none")
      return i;
    i = i.parentNode;
  }
  return null;
}
function Ll(e) {
  for (var t = _r(e), n = cx(e); n && mN(n) && ni(n).position === "static"; )
    n = cx(n);
  return n && (jo(n) === "html" || jo(n) === "body" && ni(n).position === "static") ? t : n || hN(e) || t;
}
function Ph(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function nl(e, t, n) {
  return ca(e, Ru(t, n));
}
function gN(e, t, n) {
  var r = nl(e, t, n);
  return r > n ? n : r;
}
function lC() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function cC(e) {
  return Object.assign({}, lC(), e);
}
function uC(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var yN = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, cC(typeof t != "number" ? t : uC(t, Fl));
};
function bN(e) {
  var t, n = e.state, r = e.name, i = e.options, a = n.elements.arrow, l = n.modifiersData.popperOffsets, u = Do(n.placement), d = Ph(u), p = [gr, Qr].indexOf(u) >= 0, m = p ? "height" : "width";
  if (!(!a || !l)) {
    var h = yN(i.padding, n), g = kh(a), v = d === "y" ? hr : gr, b = d === "y" ? Xr : Qr, y = n.rects.reference[m] + n.rects.reference[d] - l[d] - n.rects.popper[m], S = l[d] - n.rects.reference[d], O = Ll(a), P = O ? d === "y" ? O.clientHeight || 0 : O.clientWidth || 0 : 0, k = y / 2 - S / 2, R = h[v], E = P - g[m] - h[b], M = P / 2 - g[m] / 2 + k, _ = nl(R, M, E), I = d;
    n.modifiersData[r] = (t = {}, t[I] = _, t.centerOffset = _ - M, t);
  }
}
function vN(e) {
  var t = e.state, n = e.options, r = n.element, i = r === void 0 ? "[data-popper-arrow]" : r;
  i != null && (typeof i == "string" && (i = t.elements.popper.querySelector(i), !i) || sC(t.elements.popper, i) && (t.elements.arrow = i));
}
const xN = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: bN,
  effect: vN,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function ns(e) {
  return e.split("-")[1];
}
var wN = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function CN(e, t) {
  var n = e.x, r = e.y, i = t.devicePixelRatio || 1;
  return {
    x: es(n * i) / i || 0,
    y: es(r * i) / i || 0
  };
}
function ux(e) {
  var t, n = e.popper, r = e.popperRect, i = e.placement, a = e.variation, l = e.offsets, u = e.position, d = e.gpuAcceleration, p = e.adaptive, m = e.roundOffsets, h = e.isFixed, g = l.x, v = g === void 0 ? 0 : g, b = l.y, y = b === void 0 ? 0 : b, S = typeof m == "function" ? m({
    x: v,
    y
  }) : {
    x: v,
    y
  };
  v = S.x, y = S.y;
  var O = l.hasOwnProperty("x"), P = l.hasOwnProperty("y"), k = gr, R = hr, E = window;
  if (p) {
    var M = Ll(n), _ = "clientHeight", I = "clientWidth";
    if (M === _r(n) && (M = Ni(n), ni(M).position !== "static" && u === "absolute" && (_ = "scrollHeight", I = "scrollWidth")), M = M, i === hr || (i === gr || i === Qr) && a === ml) {
      R = Xr;
      var F = h && M === E && E.visualViewport ? E.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        M[_]
      );
      y -= F - r.height, y *= d ? 1 : -1;
    }
    if (i === gr || (i === hr || i === Xr) && a === ml) {
      k = Qr;
      var T = h && M === E && E.visualViewport ? E.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        M[I]
      );
      v -= T - r.width, v *= d ? 1 : -1;
    }
  }
  var $ = Object.assign({
    position: u
  }, p && wN), N = m === !0 ? CN({
    x: v,
    y
  }, _r(n)) : {
    x: v,
    y
  };
  if (v = N.x, y = N.y, d) {
    var W;
    return Object.assign({}, $, (W = {}, W[R] = P ? "0" : "", W[k] = O ? "0" : "", W.transform = (E.devicePixelRatio || 1) <= 1 ? "translate(" + v + "px, " + y + "px)" : "translate3d(" + v + "px, " + y + "px, 0)", W));
  }
  return Object.assign({}, $, (t = {}, t[R] = P ? y + "px" : "", t[k] = O ? v + "px" : "", t.transform = "", t));
}
function SN(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, i = r === void 0 ? !0 : r, a = n.adaptive, l = a === void 0 ? !0 : a, u = n.roundOffsets, d = u === void 0 ? !0 : u, p = {
    placement: Do(t.placement),
    variation: ns(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: i,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, ux(Object.assign({}, p, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: l,
    roundOffsets: d
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, ux(Object.assign({}, p, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: d
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const ON = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: SN,
  data: {}
};
var Hc = {
  passive: !0
};
function TN(e) {
  var t = e.state, n = e.instance, r = e.options, i = r.scroll, a = i === void 0 ? !0 : i, l = r.resize, u = l === void 0 ? !0 : l, d = _r(t.elements.popper), p = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return a && p.forEach(function(m) {
    m.addEventListener("scroll", n.update, Hc);
  }), u && d.addEventListener("resize", n.update, Hc), function() {
    a && p.forEach(function(m) {
      m.removeEventListener("scroll", n.update, Hc);
    }), u && d.removeEventListener("resize", n.update, Hc);
  };
}
const EN = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: TN,
  data: {}
};
var RN = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function du(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return RN[t];
  });
}
var kN = {
  start: "end",
  end: "start"
};
function dx(e) {
  return e.replace(/start|end/g, function(t) {
    return kN[t];
  });
}
function Dh(e) {
  var t = _r(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function Mh(e) {
  return ts(Ni(e)).left + Dh(e).scrollLeft;
}
function PN(e, t) {
  var n = _r(e), r = Ni(e), i = n.visualViewport, a = r.clientWidth, l = r.clientHeight, u = 0, d = 0;
  if (i) {
    a = i.width, l = i.height;
    var p = aC();
    (p || !p && t === "fixed") && (u = i.offsetLeft, d = i.offsetTop);
  }
  return {
    width: a,
    height: l,
    x: u + Mh(e),
    y: d
  };
}
function DN(e) {
  var t, n = Ni(e), r = Dh(e), i = (t = e.ownerDocument) == null ? void 0 : t.body, a = ca(n.scrollWidth, n.clientWidth, i ? i.scrollWidth : 0, i ? i.clientWidth : 0), l = ca(n.scrollHeight, n.clientHeight, i ? i.scrollHeight : 0, i ? i.clientHeight : 0), u = -r.scrollLeft + Mh(e), d = -r.scrollTop;
  return ni(i || n).direction === "rtl" && (u += ca(n.clientWidth, i ? i.clientWidth : 0) - a), {
    width: a,
    height: l,
    x: u,
    y: d
  };
}
function _h(e) {
  var t = ni(e), n = t.overflow, r = t.overflowX, i = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + i + r);
}
function dC(e) {
  return ["html", "body", "#document"].indexOf(jo(e)) >= 0 ? e.ownerDocument.body : Kr(e) && _h(e) ? e : dC(fd(e));
}
function rl(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = dC(e), i = r === ((n = e.ownerDocument) == null ? void 0 : n.body), a = _r(r), l = i ? [a].concat(a.visualViewport || [], _h(r) ? r : []) : r, u = t.concat(l);
  return i ? u : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    u.concat(rl(fd(l)))
  );
}
function Bm(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function MN(e, t) {
  var n = ts(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function px(e, t, n) {
  return t === oC ? Bm(PN(e, n)) : pa(t) ? MN(t, n) : Bm(DN(Ni(e)));
}
function _N(e) {
  var t = rl(fd(e)), n = ["absolute", "fixed"].indexOf(ni(e).position) >= 0, r = n && Kr(e) ? Ll(e) : e;
  return pa(r) ? t.filter(function(i) {
    return pa(i) && sC(i, r) && jo(i) !== "body";
  }) : [];
}
function IN(e, t, n, r) {
  var i = t === "clippingParents" ? _N(e) : [].concat(t), a = [].concat(i, [n]), l = a[0], u = a.reduce(function(d, p) {
    var m = px(e, p, r);
    return d.top = ca(m.top, d.top), d.right = Ru(m.right, d.right), d.bottom = Ru(m.bottom, d.bottom), d.left = ca(m.left, d.left), d;
  }, px(e, l, r));
  return u.width = u.right - u.left, u.height = u.bottom - u.top, u.x = u.left, u.y = u.top, u;
}
function pC(e) {
  var t = e.reference, n = e.element, r = e.placement, i = r ? Do(r) : null, a = r ? ns(r) : null, l = t.x + t.width / 2 - n.width / 2, u = t.y + t.height / 2 - n.height / 2, d;
  switch (i) {
    case hr:
      d = {
        x: l,
        y: t.y - n.height
      };
      break;
    case Xr:
      d = {
        x: l,
        y: t.y + t.height
      };
      break;
    case Qr:
      d = {
        x: t.x + t.width,
        y: u
      };
      break;
    case gr:
      d = {
        x: t.x - n.width,
        y: u
      };
      break;
    default:
      d = {
        x: t.x,
        y: t.y
      };
  }
  var p = i ? Ph(i) : null;
  if (p != null) {
    var m = p === "y" ? "height" : "width";
    switch (a) {
      case Ja:
        d[p] = d[p] - (t[m] / 2 - n[m] / 2);
        break;
      case ml:
        d[p] = d[p] + (t[m] / 2 - n[m] / 2);
        break;
    }
  }
  return d;
}
function hl(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, i = r === void 0 ? e.placement : r, a = n.strategy, l = a === void 0 ? e.strategy : a, u = n.boundary, d = u === void 0 ? JA : u, p = n.rootBoundary, m = p === void 0 ? oC : p, h = n.elementContext, g = h === void 0 ? $s : h, v = n.altBoundary, b = v === void 0 ? !1 : v, y = n.padding, S = y === void 0 ? 0 : y, O = cC(typeof S != "number" ? S : uC(S, Fl)), P = g === $s ? eN : $s, k = e.rects.popper, R = e.elements[b ? P : g], E = IN(pa(R) ? R : R.contextElement || Ni(e.elements.popper), d, m, l), M = ts(e.elements.reference), _ = pC({
    reference: M,
    element: k,
    placement: i
  }), I = Bm(Object.assign({}, k, _)), F = g === $s ? I : M, T = {
    top: E.top - F.top + O.top,
    bottom: F.bottom - E.bottom + O.bottom,
    left: E.left - F.left + O.left,
    right: F.right - E.right + O.right
  }, $ = e.modifiersData.offset;
  if (g === $s && $) {
    var N = $[i];
    Object.keys(T).forEach(function(W) {
      var L = [Qr, Xr].indexOf(W) >= 0 ? 1 : -1, V = [hr, Xr].indexOf(W) >= 0 ? "y" : "x";
      T[W] += N[V] * L;
    });
  }
  return T;
}
function jN(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, i = n.boundary, a = n.rootBoundary, l = n.padding, u = n.flipVariations, d = n.allowedAutoPlacements, p = d === void 0 ? iC : d, m = ns(r), h = m ? u ? lx : lx.filter(function(b) {
    return ns(b) === m;
  }) : Fl, g = h.filter(function(b) {
    return p.indexOf(b) >= 0;
  });
  g.length === 0 && (g = h);
  var v = g.reduce(function(b, y) {
    return b[y] = hl(e, {
      placement: y,
      boundary: i,
      rootBoundary: a,
      padding: l
    })[Do(y)], b;
  }, {});
  return Object.keys(v).sort(function(b, y) {
    return v[b] - v[y];
  });
}
function $N(e) {
  if (Do(e) === Eh)
    return [];
  var t = du(e);
  return [dx(e), t, dx(t)];
}
function AN(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var i = n.mainAxis, a = i === void 0 ? !0 : i, l = n.altAxis, u = l === void 0 ? !0 : l, d = n.fallbackPlacements, p = n.padding, m = n.boundary, h = n.rootBoundary, g = n.altBoundary, v = n.flipVariations, b = v === void 0 ? !0 : v, y = n.allowedAutoPlacements, S = t.options.placement, O = Do(S), P = O === S, k = d || (P || !b ? [du(S)] : $N(S)), R = [S].concat(k).reduce(function(se, U) {
      return se.concat(Do(U) === Eh ? jN(t, {
        placement: U,
        boundary: m,
        rootBoundary: h,
        padding: p,
        flipVariations: b,
        allowedAutoPlacements: y
      }) : U);
    }, []), E = t.rects.reference, M = t.rects.popper, _ = /* @__PURE__ */ new Map(), I = !0, F = R[0], T = 0; T < R.length; T++) {
      var $ = R[T], N = Do($), W = ns($) === Ja, L = [hr, Xr].indexOf(N) >= 0, V = L ? "width" : "height", z = hl(t, {
        placement: $,
        boundary: m,
        rootBoundary: h,
        altBoundary: g,
        padding: p
      }), X = L ? W ? Qr : gr : W ? Xr : hr;
      E[V] > M[V] && (X = du(X));
      var le = du(X), ne = [];
      if (a && ne.push(z[N] <= 0), u && ne.push(z[X] <= 0, z[le] <= 0), ne.every(function(se) {
        return se;
      })) {
        F = $, I = !1;
        break;
      }
      _.set($, ne);
    }
    if (I)
      for (var G = b ? 3 : 1, Q = function(U) {
        var de = R.find(function(ce) {
          var K = _.get(ce);
          if (K)
            return K.slice(0, U).every(function(Z) {
              return Z;
            });
        });
        if (de)
          return F = de, "break";
      }, be = G; be > 0; be--) {
        var we = Q(be);
        if (we === "break") break;
      }
    t.placement !== F && (t.modifiersData[r]._skip = !0, t.placement = F, t.reset = !0);
  }
}
const NN = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: AN,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function fx(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function mx(e) {
  return [hr, Qr, Xr, gr].some(function(t) {
    return e[t] >= 0;
  });
}
function FN(e) {
  var t = e.state, n = e.name, r = t.rects.reference, i = t.rects.popper, a = t.modifiersData.preventOverflow, l = hl(t, {
    elementContext: "reference"
  }), u = hl(t, {
    altBoundary: !0
  }), d = fx(l, r), p = fx(u, i, a), m = mx(d), h = mx(p);
  t.modifiersData[n] = {
    referenceClippingOffsets: d,
    popperEscapeOffsets: p,
    isReferenceHidden: m,
    hasPopperEscaped: h
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": m,
    "data-popper-escaped": h
  });
}
const LN = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: FN
};
function BN(e, t, n) {
  var r = Do(e), i = [gr, hr].indexOf(r) >= 0 ? -1 : 1, a = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, l = a[0], u = a[1];
  return l = l || 0, u = (u || 0) * i, [gr, Qr].indexOf(r) >= 0 ? {
    x: u,
    y: l
  } : {
    x: l,
    y: u
  };
}
function VN(e) {
  var t = e.state, n = e.options, r = e.name, i = n.offset, a = i === void 0 ? [0, 0] : i, l = iC.reduce(function(m, h) {
    return m[h] = BN(h, t.rects, a), m;
  }, {}), u = l[t.placement], d = u.x, p = u.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += d, t.modifiersData.popperOffsets.y += p), t.modifiersData[r] = l;
}
const zN = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: VN
};
function WN(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = pC({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const qN = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: WN,
  data: {}
};
function HN(e) {
  return e === "x" ? "y" : "x";
}
function UN(e) {
  var t = e.state, n = e.options, r = e.name, i = n.mainAxis, a = i === void 0 ? !0 : i, l = n.altAxis, u = l === void 0 ? !1 : l, d = n.boundary, p = n.rootBoundary, m = n.altBoundary, h = n.padding, g = n.tether, v = g === void 0 ? !0 : g, b = n.tetherOffset, y = b === void 0 ? 0 : b, S = hl(t, {
    boundary: d,
    rootBoundary: p,
    padding: h,
    altBoundary: m
  }), O = Do(t.placement), P = ns(t.placement), k = !P, R = Ph(O), E = HN(R), M = t.modifiersData.popperOffsets, _ = t.rects.reference, I = t.rects.popper, F = typeof y == "function" ? y(Object.assign({}, t.rects, {
    placement: t.placement
  })) : y, T = typeof F == "number" ? {
    mainAxis: F,
    altAxis: F
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, F), $ = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, N = {
    x: 0,
    y: 0
  };
  if (M) {
    if (a) {
      var W, L = R === "y" ? hr : gr, V = R === "y" ? Xr : Qr, z = R === "y" ? "height" : "width", X = M[R], le = X + S[L], ne = X - S[V], G = v ? -I[z] / 2 : 0, Q = P === Ja ? _[z] : I[z], be = P === Ja ? -I[z] : -_[z], we = t.elements.arrow, se = v && we ? kh(we) : {
        width: 0,
        height: 0
      }, U = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : lC(), de = U[L], ce = U[V], K = nl(0, _[z], se[z]), Z = k ? _[z] / 2 - G - K - de - T.mainAxis : Q - K - de - T.mainAxis, ue = k ? -_[z] / 2 + G + K + ce + T.mainAxis : be + K + ce + T.mainAxis, he = t.elements.arrow && Ll(t.elements.arrow), B = he ? R === "y" ? he.clientTop || 0 : he.clientLeft || 0 : 0, ee = (W = $ == null ? void 0 : $[R]) != null ? W : 0, ie = X + Z - ee - B, ge = X + ue - ee, xe = nl(v ? Ru(le, ie) : le, X, v ? ca(ne, ge) : ne);
      M[R] = xe, N[R] = xe - X;
    }
    if (u) {
      var pe, Ee = R === "x" ? hr : gr, Pe = R === "x" ? Xr : Qr, Be = M[E], Ge = E === "y" ? "height" : "width", Ie = Be + S[Ee], Dt = Be - S[Pe], Re = [hr, gr].indexOf(O) !== -1, $e = (pe = $ == null ? void 0 : $[E]) != null ? pe : 0, dt = Re ? Ie : Be - _[Ge] - I[Ge] - $e + T.altAxis, He = Re ? Be + _[Ge] + I[Ge] - $e - T.altAxis : Dt, Je = v && Re ? gN(dt, Be, He) : nl(v ? dt : Ie, Be, v ? He : Dt);
      M[E] = Je, N[E] = Je - Be;
    }
    t.modifiersData[r] = N;
  }
}
const YN = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: UN,
  requiresIfExists: ["offset"]
};
function GN(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function KN(e) {
  return e === _r(e) || !Kr(e) ? Dh(e) : GN(e);
}
function XN(e) {
  var t = e.getBoundingClientRect(), n = es(t.width) / e.offsetWidth || 1, r = es(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function QN(e, t, n) {
  n === void 0 && (n = !1);
  var r = Kr(t), i = Kr(t) && XN(t), a = Ni(t), l = ts(e, i, n), u = {
    scrollLeft: 0,
    scrollTop: 0
  }, d = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((jo(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  _h(a)) && (u = KN(t)), Kr(t) ? (d = ts(t, !0), d.x += t.clientLeft, d.y += t.clientTop) : a && (d.x = Mh(a))), {
    x: l.left + u.scrollLeft - d.x,
    y: l.top + u.scrollTop - d.y,
    width: l.width,
    height: l.height
  };
}
function ZN(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(a) {
    t.set(a.name, a);
  });
  function i(a) {
    n.add(a.name);
    var l = [].concat(a.requires || [], a.requiresIfExists || []);
    l.forEach(function(u) {
      if (!n.has(u)) {
        var d = t.get(u);
        d && i(d);
      }
    }), r.push(a);
  }
  return e.forEach(function(a) {
    n.has(a.name) || i(a);
  }), r;
}
function JN(e) {
  var t = ZN(e);
  return uN.reduce(function(n, r) {
    return n.concat(t.filter(function(i) {
      return i.phase === r;
    }));
  }, []);
}
function e2(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function t2(e) {
  var t = e.reduce(function(n, r) {
    var i = n[r.name];
    return n[r.name] = i ? Object.assign({}, i, r, {
      options: Object.assign({}, i.options, r.options),
      data: Object.assign({}, i.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var hx = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function gx() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function n2(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, i = t.defaultOptions, a = i === void 0 ? hx : i;
  return function(u, d, p) {
    p === void 0 && (p = a);
    var m = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, hx, a),
      modifiersData: {},
      elements: {
        reference: u,
        popper: d
      },
      attributes: {},
      styles: {}
    }, h = [], g = !1, v = {
      state: m,
      setOptions: function(O) {
        var P = typeof O == "function" ? O(m.options) : O;
        y(), m.options = Object.assign({}, a, m.options, P), m.scrollParents = {
          reference: pa(u) ? rl(u) : u.contextElement ? rl(u.contextElement) : [],
          popper: rl(d)
        };
        var k = JN(t2([].concat(r, m.options.modifiers)));
        return m.orderedModifiers = k.filter(function(R) {
          return R.enabled;
        }), b(), v.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!g) {
          var O = m.elements, P = O.reference, k = O.popper;
          if (gx(P, k)) {
            m.rects = {
              reference: QN(P, Ll(k), m.options.strategy === "fixed"),
              popper: kh(k)
            }, m.reset = !1, m.placement = m.options.placement, m.orderedModifiers.forEach(function(T) {
              return m.modifiersData[T.name] = Object.assign({}, T.data);
            });
            for (var R = 0; R < m.orderedModifiers.length; R++) {
              if (m.reset === !0) {
                m.reset = !1, R = -1;
                continue;
              }
              var E = m.orderedModifiers[R], M = E.fn, _ = E.options, I = _ === void 0 ? {} : _, F = E.name;
              typeof M == "function" && (m = M({
                state: m,
                options: I,
                name: F,
                instance: v
              }) || m);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: e2(function() {
        return new Promise(function(S) {
          v.forceUpdate(), S(m);
        });
      }),
      destroy: function() {
        y(), g = !0;
      }
    };
    if (!gx(u, d))
      return v;
    v.setOptions(p).then(function(S) {
      !g && p.onFirstUpdate && p.onFirstUpdate(S);
    });
    function b() {
      m.orderedModifiers.forEach(function(S) {
        var O = S.name, P = S.options, k = P === void 0 ? {} : P, R = S.effect;
        if (typeof R == "function") {
          var E = R({
            state: m,
            name: O,
            instance: v,
            options: k
          }), M = function() {
          };
          h.push(E || M);
        }
      });
    }
    function y() {
      h.forEach(function(S) {
        return S();
      }), h = [];
    }
    return v;
  };
}
var r2 = [EN, qN, ON, fN, zN, NN, YN, xN, LN], o2 = /* @__PURE__ */ n2({
  defaultModifiers: r2
});
function i2(e) {
  return typeof e == "function" ? e() : e;
}
const gl = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const {
    children: r,
    container: i,
    disablePortal: a = !1
  } = t, [l, u] = w.useState(null), d = It(/* @__PURE__ */ w.isValidElement(r) ? us(r) : null, n);
  if (An(() => {
    a || u(i2(i) || document.body);
  }, [i, a]), An(() => {
    if (l && !a)
      return vu(n, l), () => {
        vu(n, null);
      };
  }, [n, l, a]), a) {
    if (/* @__PURE__ */ w.isValidElement(r)) {
      const p = {
        ref: d
      };
      return /* @__PURE__ */ w.cloneElement(r, p);
    }
    return r;
  }
  return l && /* @__PURE__ */ LM.createPortal(r, l);
});
process.env.NODE_ENV !== "production" && (gl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: o.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: o.oneOfType([ei, o.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: o.bool
});
process.env.NODE_ENV !== "production" && (gl.propTypes = sd(gl.propTypes));
function a2(e) {
  return ze("MuiPopper", e);
}
Ve("MuiPopper", ["root"]);
function s2(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function ku(e) {
  return typeof e == "function" ? e() : e;
}
function md(e) {
  return e.nodeType !== void 0;
}
function l2(e) {
  return !md(e);
}
const c2 = (e) => {
  const {
    classes: t
  } = e;
  return We({
    root: ["root"]
  }, a2, t);
}, u2 = {}, d2 = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const {
    anchorEl: r,
    children: i,
    direction: a,
    disablePortal: l,
    modifiers: u,
    open: d,
    placement: p,
    popperOptions: m,
    popperRef: h,
    slotProps: g = {},
    slots: v = {},
    TransitionProps: b,
    // @ts-ignore internal logic
    ownerState: y,
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...S
  } = t, O = w.useRef(null), P = It(O, n), k = w.useRef(null), R = It(k, h), E = w.useRef(R);
  An(() => {
    E.current = R;
  }, [R]), w.useImperativeHandle(h, () => k.current, []);
  const M = s2(p, a), [_, I] = w.useState(M), [F, T] = w.useState(ku(r));
  w.useEffect(() => {
    k.current && k.current.forceUpdate();
  }), w.useEffect(() => {
    r && T(ku(r));
  }, [r]), An(() => {
    if (!F || !d)
      return;
    const V = (le) => {
      I(le.placement);
    };
    if (process.env.NODE_ENV !== "production" && F && md(F) && F.nodeType === 1) {
      const le = F.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && le.top === 0 && le.left === 0 && le.right === 0 && le.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let z = [{
      name: "preventOverflow",
      options: {
        altBoundary: l
      }
    }, {
      name: "flip",
      options: {
        altBoundary: l
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: le
      }) => {
        V(le);
      }
    }];
    u != null && (z = z.concat(u)), m && m.modifiers != null && (z = z.concat(m.modifiers));
    const X = o2(F, O.current, {
      placement: M,
      ...m,
      modifiers: z
    });
    return E.current(X), () => {
      X.destroy(), E.current(null);
    };
  }, [F, l, u, d, m, M]);
  const $ = {
    placement: _
  };
  b !== null && ($.TransitionProps = b);
  const N = c2(t), W = v.root ?? "div", L = Nt({
    elementType: W,
    externalSlotProps: g.root,
    externalForwardedProps: S,
    additionalProps: {
      role: "tooltip",
      ref: P
    },
    ownerState: t,
    className: N.root
  });
  return /* @__PURE__ */ x.jsx(W, {
    ...L,
    children: typeof i == "function" ? i($) : i
  });
}), fC = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const {
    anchorEl: r,
    children: i,
    container: a,
    direction: l = "ltr",
    disablePortal: u = !1,
    keepMounted: d = !1,
    modifiers: p,
    open: m,
    placement: h = "bottom",
    popperOptions: g = u2,
    popperRef: v,
    style: b,
    transition: y = !1,
    slotProps: S = {},
    slots: O = {},
    ...P
  } = t, [k, R] = w.useState(!0), E = () => {
    R(!1);
  }, M = () => {
    R(!0);
  };
  if (!d && !m && (!y || k))
    return null;
  let _;
  if (a)
    _ = a;
  else if (r) {
    const T = ku(r);
    _ = T && md(T) ? Qn(T).body : Qn(null).body;
  }
  const I = !m && d && (!y || k) ? "none" : void 0, F = y ? {
    in: m,
    onEnter: E,
    onExited: M
  } : void 0;
  return /* @__PURE__ */ x.jsx(gl, {
    disablePortal: u,
    container: _,
    children: /* @__PURE__ */ x.jsx(d2, {
      anchorEl: r,
      direction: l,
      disablePortal: u,
      modifiers: p,
      ref: n,
      open: y ? !k : m,
      placement: h,
      popperOptions: g,
      popperRef: v,
      slotProps: S,
      slots: O,
      ...P,
      style: {
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: I,
        ...b
      },
      TransitionProps: F,
      children: i
    })
  });
});
process.env.NODE_ENV !== "production" && (fC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: fo(o.oneOfType([ei, o.object, o.func]), (e) => {
    if (e.open) {
      const t = ku(e.anchorEl);
      if (t && md(t) && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || l2(t) && t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: o.oneOfType([o.node, o.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: o.oneOfType([ei, o.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: o.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: o.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: o.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: o.arrayOf(o.shape({
    data: o.object,
    effect: o.func,
    enabled: o.bool,
    fn: o.func,
    name: o.any,
    options: o.object,
    phase: o.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: o.arrayOf(o.string),
    requiresIfExists: o.arrayOf(o.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: o.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: o.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: o.shape({
    modifiers: o.array,
    onFirstUpdate: o.func,
    placement: o.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: o.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: gn,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: o.shape({
    root: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: o.shape({
    root: o.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: o.bool
});
const p2 = ae(fC, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), ps = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = eo(), i = ut({
    props: t,
    name: "MuiPopper"
  }), {
    anchorEl: a,
    component: l,
    components: u,
    componentsProps: d,
    container: p,
    disablePortal: m,
    keepMounted: h,
    modifiers: g,
    open: v,
    placement: b,
    popperOptions: y,
    popperRef: S,
    transition: O,
    slots: P,
    slotProps: k,
    ...R
  } = i, E = (P == null ? void 0 : P.root) ?? (u == null ? void 0 : u.Root), M = {
    anchorEl: a,
    container: p,
    disablePortal: m,
    keepMounted: h,
    modifiers: g,
    open: v,
    placement: b,
    popperOptions: y,
    popperRef: S,
    transition: O,
    ...R
  };
  return /* @__PURE__ */ x.jsx(p2, {
    as: l,
    direction: r ? "rtl" : "ltr",
    slots: {
      root: E
    },
    slotProps: k ?? d,
    ...M,
    ref: n
  });
});
process.env.NODE_ENV !== "production" && (ps.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: o.oneOfType([ei, o.object, o.func]),
  /**
   * Popper render function or node.
   */
  children: o.oneOfType([o.node, o.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  components: o.shape({
    Root: o.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  componentsProps: o.shape({
    root: o.oneOfType([o.func, o.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: o.oneOfType([ei, o.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: o.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: o.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: o.arrayOf(o.shape({
    data: o.object,
    effect: o.func,
    enabled: o.bool,
    fn: o.func,
    name: o.any,
    options: o.object,
    phase: o.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: o.arrayOf(o.string),
    requiresIfExists: o.arrayOf(o.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: o.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: o.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: o.shape({
    modifiers: o.array,
    onFirstUpdate: o.func,
    placement: o.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: o.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: gn,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: o.shape({
    root: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: o.shape({
    root: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: o.bool
});
function f2(e) {
  return ze("MuiListSubheader", e);
}
Ve("MuiListSubheader", ["root", "colorPrimary", "colorInherit", "gutters", "inset", "sticky"]);
const m2 = (e) => {
  const {
    classes: t,
    color: n,
    disableGutters: r,
    inset: i,
    disableSticky: a
  } = e, l = {
    root: ["root", n !== "default" && `color${ke(n)}`, !r && "gutters", i && "inset", !a && "sticky"]
  };
  return We(l, f2, t);
}, h2 = ae("li", {
  name: "MuiListSubheader",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "default" && t[`color${ke(n.color)}`], !n.disableGutters && t.gutters, n.inset && t.inset, !n.disableSticky && t.sticky];
  }
})(ct(({
  theme: e
}) => ({
  boxSizing: "border-box",
  lineHeight: "48px",
  listStyle: "none",
  color: (e.vars || e).palette.text.secondary,
  fontFamily: e.typography.fontFamily,
  fontWeight: e.typography.fontWeightMedium,
  fontSize: e.typography.pxToRem(14),
  variants: [{
    props: {
      color: "primary"
    },
    style: {
      color: (e.vars || e).palette.primary.main
    }
  }, {
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => t.inset,
    style: {
      paddingLeft: 72
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableSticky,
    style: {
      position: "sticky",
      top: 0,
      zIndex: 1,
      backgroundColor: (e.vars || e).palette.background.paper
    }
  }]
}))), Pu = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiListSubheader"
  }), {
    className: i,
    color: a = "default",
    component: l = "li",
    disableGutters: u = !1,
    disableSticky: d = !1,
    inset: p = !1,
    ...m
  } = r, h = {
    ...r,
    color: a,
    component: l,
    disableGutters: u,
    disableSticky: d,
    inset: p
  }, g = m2(h);
  return /* @__PURE__ */ x.jsx(h2, {
    as: l,
    className: Me(g.root, i),
    ref: n,
    ownerState: h,
    ...m
  });
});
Pu && (Pu.muiSkipListHighlight = !0);
process.env.NODE_ENV !== "production" && (Pu.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * @default 'default'
   */
  color: o.oneOf(["default", "inherit", "primary"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If `true`, the List Subheader will not have gutters.
   * @default false
   */
  disableGutters: o.bool,
  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   * @default false
   */
  disableSticky: o.bool,
  /**
   * If `true`, the List Subheader is indented.
   * @default false
   */
  inset: o.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
const g2 = rn(/* @__PURE__ */ x.jsx("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
function y2(e) {
  return ze("MuiChip", e);
}
const Et = Ve("MuiChip", ["root", "sizeSmall", "sizeMedium", "colorDefault", "colorError", "colorInfo", "colorPrimary", "colorSecondary", "colorSuccess", "colorWarning", "disabled", "clickable", "clickableColorPrimary", "clickableColorSecondary", "deletable", "deletableColorPrimary", "deletableColorSecondary", "outlined", "filled", "outlinedPrimary", "outlinedSecondary", "filledPrimary", "filledSecondary", "avatar", "avatarSmall", "avatarMedium", "avatarColorPrimary", "avatarColorSecondary", "icon", "iconSmall", "iconMedium", "iconColorPrimary", "iconColorSecondary", "label", "labelSmall", "labelMedium", "deleteIcon", "deleteIconSmall", "deleteIconMedium", "deleteIconColorPrimary", "deleteIconColorSecondary", "deleteIconOutlinedColorPrimary", "deleteIconOutlinedColorSecondary", "deleteIconFilledColorPrimary", "deleteIconFilledColorSecondary", "focusVisible"]), b2 = (e) => {
  const {
    classes: t,
    disabled: n,
    size: r,
    color: i,
    iconColor: a,
    onDelete: l,
    clickable: u,
    variant: d
  } = e, p = {
    root: ["root", d, n && "disabled", `size${ke(r)}`, `color${ke(i)}`, u && "clickable", u && `clickableColor${ke(i)}`, l && "deletable", l && `deletableColor${ke(i)}`, `${d}${ke(i)}`],
    label: ["label", `label${ke(r)}`],
    avatar: ["avatar", `avatar${ke(r)}`, `avatarColor${ke(i)}`],
    icon: ["icon", `icon${ke(r)}`, `iconColor${ke(a)}`],
    deleteIcon: ["deleteIcon", `deleteIcon${ke(r)}`, `deleteIconColor${ke(i)}`, `deleteIcon${ke(d)}Color${ke(i)}`]
  };
  return We(p, y2, t);
}, v2 = ae("div", {
  name: "MuiChip",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      color: r,
      iconColor: i,
      clickable: a,
      onDelete: l,
      size: u,
      variant: d
    } = n;
    return [{
      [`& .${Et.avatar}`]: t.avatar
    }, {
      [`& .${Et.avatar}`]: t[`avatar${ke(u)}`]
    }, {
      [`& .${Et.avatar}`]: t[`avatarColor${ke(r)}`]
    }, {
      [`& .${Et.icon}`]: t.icon
    }, {
      [`& .${Et.icon}`]: t[`icon${ke(u)}`]
    }, {
      [`& .${Et.icon}`]: t[`iconColor${ke(i)}`]
    }, {
      [`& .${Et.deleteIcon}`]: t.deleteIcon
    }, {
      [`& .${Et.deleteIcon}`]: t[`deleteIcon${ke(u)}`]
    }, {
      [`& .${Et.deleteIcon}`]: t[`deleteIconColor${ke(r)}`]
    }, {
      [`& .${Et.deleteIcon}`]: t[`deleteIcon${ke(d)}Color${ke(r)}`]
    }, t.root, t[`size${ke(u)}`], t[`color${ke(r)}`], a && t.clickable, a && r !== "default" && t[`clickableColor${ke(r)})`], l && t.deletable, l && r !== "default" && t[`deletableColor${ke(r)}`], t[d], t[`${d}${ke(r)}`]];
  }
})(ct(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? e.palette.grey[700] : e.palette.grey[300];
  return {
    maxWidth: "100%",
    fontFamily: e.typography.fontFamily,
    fontSize: e.typography.pxToRem(13),
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 32,
    color: (e.vars || e).palette.text.primary,
    backgroundColor: (e.vars || e).palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: "nowrap",
    transition: e.transitions.create(["background-color", "box-shadow"]),
    // reset cursor explicitly in case ButtonBase is used
    cursor: "unset",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: "none",
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: "middle",
    boxSizing: "border-box",
    [`&.${Et.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`& .${Et.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: e.vars ? e.vars.palette.Chip.defaultAvatarColor : t,
      fontSize: e.typography.pxToRem(12)
    },
    [`& .${Et.avatarColorPrimary}`]: {
      color: (e.vars || e).palette.primary.contrastText,
      backgroundColor: (e.vars || e).palette.primary.dark
    },
    [`& .${Et.avatarColorSecondary}`]: {
      color: (e.vars || e).palette.secondary.contrastText,
      backgroundColor: (e.vars || e).palette.secondary.dark
    },
    [`& .${Et.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: e.typography.pxToRem(10)
    },
    [`& .${Et.icon}`]: {
      marginLeft: 5,
      marginRight: -6
    },
    [`& .${Et.deleteIcon}`]: {
      WebkitTapHighlightColor: "transparent",
      color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.26)` : mt(e.palette.text.primary, 0.26),
      fontSize: 22,
      cursor: "pointer",
      margin: "0 5px 0 -6px",
      "&:hover": {
        color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.4)` : mt(e.palette.text.primary, 0.4)
      }
    },
    variants: [{
      props: {
        size: "small"
      },
      style: {
        height: 24,
        [`& .${Et.icon}`]: {
          fontSize: 18,
          marginLeft: 4,
          marginRight: -4
        },
        [`& .${Et.deleteIcon}`]: {
          fontSize: 16,
          marginRight: 4,
          marginLeft: -4
        }
      }
    }, ...Object.entries(e.palette).filter(qn(["contrastText"])).map(([n]) => ({
      props: {
        color: n
      },
      style: {
        backgroundColor: (e.vars || e).palette[n].main,
        color: (e.vars || e).palette[n].contrastText,
        [`& .${Et.deleteIcon}`]: {
          color: e.vars ? `rgba(${e.vars.palette[n].contrastTextChannel} / 0.7)` : mt(e.palette[n].contrastText, 0.7),
          "&:hover, &:active": {
            color: (e.vars || e).palette[n].contrastText
          }
        }
      }
    })), {
      props: (n) => n.iconColor === n.color,
      style: {
        [`& .${Et.icon}`]: {
          color: e.vars ? e.vars.palette.Chip.defaultIconColor : t
        }
      }
    }, {
      props: (n) => n.iconColor === n.color && n.color !== "default",
      style: {
        [`& .${Et.icon}`]: {
          color: "inherit"
        }
      }
    }, {
      props: {
        onDelete: !0
      },
      style: {
        [`&.${Et.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : mt(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
        }
      }
    }, ...Object.entries(e.palette).filter(qn(["dark"])).map(([n]) => ({
      props: {
        color: n,
        onDelete: !0
      },
      style: {
        [`&.${Et.focusVisible}`]: {
          background: (e.vars || e).palette[n].dark
        }
      }
    })), {
      props: {
        clickable: !0
      },
      style: {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : mt(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
        },
        [`&.${Et.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : mt(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
        },
        "&:active": {
          boxShadow: (e.vars || e).shadows[1]
        }
      }
    }, ...Object.entries(e.palette).filter(qn(["dark"])).map(([n]) => ({
      props: {
        color: n,
        clickable: !0
      },
      style: {
        [`&:hover, &.${Et.focusVisible}`]: {
          backgroundColor: (e.vars || e).palette[n].dark
        }
      }
    })), {
      props: {
        variant: "outlined"
      },
      style: {
        backgroundColor: "transparent",
        border: e.vars ? `1px solid ${e.vars.palette.Chip.defaultBorder}` : `1px solid ${e.palette.mode === "light" ? e.palette.grey[400] : e.palette.grey[700]}`,
        [`&.${Et.clickable}:hover`]: {
          backgroundColor: (e.vars || e).palette.action.hover
        },
        [`&.${Et.focusVisible}`]: {
          backgroundColor: (e.vars || e).palette.action.focus
        },
        [`& .${Et.avatar}`]: {
          marginLeft: 4
        },
        [`& .${Et.avatarSmall}`]: {
          marginLeft: 2
        },
        [`& .${Et.icon}`]: {
          marginLeft: 4
        },
        [`& .${Et.iconSmall}`]: {
          marginLeft: 2
        },
        [`& .${Et.deleteIcon}`]: {
          marginRight: 5
        },
        [`& .${Et.deleteIconSmall}`]: {
          marginRight: 3
        }
      }
    }, ...Object.entries(e.palette).filter(qn()).map(([n]) => ({
      props: {
        variant: "outlined",
        color: n
      },
      style: {
        color: (e.vars || e).palette[n].main,
        border: `1px solid ${e.vars ? `rgba(${e.vars.palette[n].mainChannel} / 0.7)` : mt(e.palette[n].main, 0.7)}`,
        [`&.${Et.clickable}:hover`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[n].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : mt(e.palette[n].main, e.palette.action.hoverOpacity)
        },
        [`&.${Et.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[n].mainChannel} / ${e.vars.palette.action.focusOpacity})` : mt(e.palette[n].main, e.palette.action.focusOpacity)
        },
        [`& .${Et.deleteIcon}`]: {
          color: e.vars ? `rgba(${e.vars.palette[n].mainChannel} / 0.7)` : mt(e.palette[n].main, 0.7),
          "&:hover, &:active": {
            color: (e.vars || e).palette[n].main
          }
        }
      }
    }))]
  };
})), x2 = ae("span", {
  name: "MuiChip",
  slot: "Label",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      size: r
    } = n;
    return [t.label, t[`label${ke(r)}`]];
  }
})({
  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: "nowrap",
  variants: [{
    props: {
      variant: "outlined"
    },
    style: {
      paddingLeft: 11,
      paddingRight: 11
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      paddingLeft: 8,
      paddingRight: 8
    }
  }, {
    props: {
      size: "small",
      variant: "outlined"
    },
    style: {
      paddingLeft: 7,
      paddingRight: 7
    }
  }]
});
function yx(e) {
  return e.key === "Backspace" || e.key === "Delete";
}
const hd = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiChip"
  }), {
    avatar: i,
    className: a,
    clickable: l,
    color: u = "default",
    component: d,
    deleteIcon: p,
    disabled: m = !1,
    icon: h,
    label: g,
    onClick: v,
    onDelete: b,
    onKeyDown: y,
    onKeyUp: S,
    size: O = "medium",
    variant: P = "filled",
    tabIndex: k,
    skipFocusWhenDisabled: R = !1,
    // TODO v6: Rename to `focusableWhenDisabled`.
    ...E
  } = r, M = w.useRef(null), _ = It(M, n), I = (ne) => {
    ne.stopPropagation(), b && b(ne);
  }, F = (ne) => {
    ne.currentTarget === ne.target && yx(ne) && ne.preventDefault(), y && y(ne);
  }, T = (ne) => {
    ne.currentTarget === ne.target && b && yx(ne) && b(ne), S && S(ne);
  }, $ = l !== !1 && v ? !0 : l, N = $ || b ? Io : d || "div", W = {
    ...r,
    component: N,
    disabled: m,
    size: O,
    color: u,
    iconColor: /* @__PURE__ */ w.isValidElement(h) && h.props.color || u,
    onDelete: !!b,
    clickable: $,
    variant: P
  }, L = b2(W), V = N === Io ? {
    component: d || "div",
    focusVisibleClassName: L.focusVisible,
    ...b && {
      disableRipple: !0
    }
  } : {};
  let z = null;
  b && (z = p && /* @__PURE__ */ w.isValidElement(p) ? /* @__PURE__ */ w.cloneElement(p, {
    className: Me(p.props.className, L.deleteIcon),
    onClick: I
  }) : /* @__PURE__ */ x.jsx(g2, {
    className: Me(L.deleteIcon),
    onClick: I
  }));
  let X = null;
  i && /* @__PURE__ */ w.isValidElement(i) && (X = /* @__PURE__ */ w.cloneElement(i, {
    className: Me(L.avatar, i.props.className)
  }));
  let le = null;
  return h && /* @__PURE__ */ w.isValidElement(h) && (le = /* @__PURE__ */ w.cloneElement(h, {
    className: Me(L.icon, h.props.className)
  })), process.env.NODE_ENV !== "production" && X && le && console.error("MUI: The Chip component can not handle the avatar and the icon prop at the same time. Pick one."), /* @__PURE__ */ x.jsxs(v2, {
    as: N,
    className: Me(L.root, a),
    disabled: $ && m ? !0 : void 0,
    onClick: v,
    onKeyDown: F,
    onKeyUp: T,
    ref: _,
    tabIndex: R && m ? -1 : k,
    ownerState: W,
    ...V,
    ...E,
    children: [X || le, /* @__PURE__ */ x.jsx(x2, {
      className: Me(L.label),
      ownerState: W,
      children: g
    }), z]
  });
});
process.env.NODE_ENV !== "production" && (hd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Avatar element to display.
   */
  avatar: o.element,
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: Ej,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */
  clickable: o.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: o.oneOfType([o.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), o.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: o.element,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * Icon element.
   */
  icon: o.element,
  /**
   * The content of the component.
   */
  label: o.node,
  /**
   * @ignore
   */
  onClick: o.func,
  /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: o.func,
  /**
   * @ignore
   */
  onKeyDown: o.func,
  /**
   * @ignore
   */
  onKeyUp: o.func,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: o.oneOfType([o.oneOf(["medium", "small"]), o.string]),
  /**
   * If `true`, allows the disabled chip to escape focus.
   * If `false`, allows the disabled chip to receive focus.
   * @default false
   */
  skipFocusWhenDisabled: o.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * @ignore
   */
  tabIndex: o.number,
  /**
   * The variant to use.
   * @default 'filled'
   */
  variant: o.oneOfType([o.oneOf(["filled", "outlined"]), o.string])
});
function Uc(e) {
  return parseInt(e, 10) || 0;
}
const w2 = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function C2(e) {
  for (const t in e)
    return !1;
  return !0;
}
function S2(e) {
  return C2(e) || e.outerHeightStyle === 0 && !e.overflowing;
}
const mC = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const {
    onChange: r,
    maxRows: i,
    minRows: a = 1,
    style: l,
    value: u,
    ...d
  } = t, {
    current: p
  } = w.useRef(u != null), m = w.useRef(null), h = It(n, m), g = w.useRef(null), v = w.useRef(null), b = w.useCallback(() => {
    const P = m.current, k = v.current;
    if (!P || !k)
      return;
    const E = ti(P).getComputedStyle(P);
    if (E.width === "0px")
      return {
        outerHeightStyle: 0,
        overflowing: !1
      };
    k.style.width = E.width, k.value = P.value || t.placeholder || "x", k.value.slice(-1) === `
` && (k.value += " ");
    const M = E.boxSizing, _ = Uc(E.paddingBottom) + Uc(E.paddingTop), I = Uc(E.borderBottomWidth) + Uc(E.borderTopWidth), F = k.scrollHeight;
    k.value = "x";
    const T = k.scrollHeight;
    let $ = F;
    a && ($ = Math.max(Number(a) * T, $)), i && ($ = Math.min(Number(i) * T, $)), $ = Math.max($, T);
    const N = $ + (M === "border-box" ? _ + I : 0), W = Math.abs($ - F) <= 1;
    return {
      outerHeightStyle: N,
      overflowing: W
    };
  }, [i, a, t.placeholder]), y = w.useCallback(() => {
    const P = m.current, k = b();
    if (!P || !k || S2(k))
      return;
    const R = k.outerHeightStyle;
    g.current !== R && (g.current = R, P.style.height = `${R}px`), P.style.overflow = k.overflowing ? "hidden" : "";
  }, [b]), S = w.useRef(-1);
  An(() => {
    const P = gh(() => y()), k = m == null ? void 0 : m.current;
    if (!k)
      return;
    const R = ti(k);
    R.addEventListener("resize", P);
    let E;
    return typeof ResizeObserver < "u" && (E = new ResizeObserver(() => {
      E.unobserve(k), cancelAnimationFrame(S.current), y(), S.current = requestAnimationFrame(() => {
        E.observe(k);
      });
    }), E.observe(k)), () => {
      P.clear(), cancelAnimationFrame(S.current), R.removeEventListener("resize", P), E && E.disconnect();
    };
  }, [b, y]), An(() => {
    y();
  });
  const O = (P) => {
    p || y(), r && r(P);
  };
  return /* @__PURE__ */ x.jsxs(w.Fragment, {
    children: [/* @__PURE__ */ x.jsx("textarea", {
      value: u,
      onChange: O,
      ref: h,
      rows: a,
      style: l,
      ...d
    }), /* @__PURE__ */ x.jsx("textarea", {
      "aria-hidden": !0,
      className: t.className,
      readOnly: !0,
      ref: v,
      tabIndex: -1,
      style: {
        ...w2.shadow,
        ...l,
        paddingTop: 0,
        paddingBottom: 0
      }
    })]
  });
});
process.env.NODE_ENV !== "production" && (mC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  className: o.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: o.oneOfType([o.number, o.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: o.oneOfType([o.number, o.string]),
  /**
   * @ignore
   */
  onChange: o.func,
  /**
   * @ignore
   */
  placeholder: o.string,
  /**
   * @ignore
   */
  style: o.object,
  /**
   * @ignore
   */
  value: o.oneOfType([o.arrayOf(o.string), o.number, o.string])
});
function yl(e) {
  return typeof e == "string";
}
function Fi({
  props: e,
  states: t,
  muiFormControl: n
}) {
  return t.reduce((r, i) => (r[i] = e[i], n && typeof e[i] > "u" && (r[i] = n[i]), r), {});
}
const Bl = /* @__PURE__ */ w.createContext(void 0);
process.env.NODE_ENV !== "production" && (Bl.displayName = "FormControlContext");
function ar() {
  return w.useContext(Bl);
}
function bx(e) {
  return e != null && !(Array.isArray(e) && e.length === 0);
}
function Du(e, t = !1) {
  return e && (bx(e.value) && e.value !== "" || t && bx(e.defaultValue) && e.defaultValue !== "");
}
function O2(e) {
  return e.startAdornment;
}
function T2(e) {
  return ze("MuiInputBase", e);
}
const Rr = Ve("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]);
var vx;
const gd = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.formControl && t.formControl, n.startAdornment && t.adornedStart, n.endAdornment && t.adornedEnd, n.error && t.error, n.size === "small" && t.sizeSmall, n.multiline && t.multiline, n.color && t[`color${ke(n.color)}`], n.fullWidth && t.fullWidth, n.hiddenLabel && t.hiddenLabel];
}, yd = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.input, n.size === "small" && t.inputSizeSmall, n.multiline && t.inputMultiline, n.type === "search" && t.inputTypeSearch, n.startAdornment && t.inputAdornedStart, n.endAdornment && t.inputAdornedEnd, n.hiddenLabel && t.inputHiddenLabel];
}, E2 = (e) => {
  const {
    classes: t,
    color: n,
    disabled: r,
    error: i,
    endAdornment: a,
    focused: l,
    formControl: u,
    fullWidth: d,
    hiddenLabel: p,
    multiline: m,
    readOnly: h,
    size: g,
    startAdornment: v,
    type: b
  } = e, y = {
    root: ["root", `color${ke(n)}`, r && "disabled", i && "error", d && "fullWidth", l && "focused", u && "formControl", g && g !== "medium" && `size${ke(g)}`, m && "multiline", v && "adornedStart", a && "adornedEnd", p && "hiddenLabel", h && "readOnly"],
    input: ["input", r && "disabled", b === "search" && "inputTypeSearch", m && "inputMultiline", g === "small" && "inputSizeSmall", p && "inputHiddenLabel", v && "inputAdornedStart", a && "inputAdornedEnd", h && "readOnly"]
  };
  return We(y, T2, t);
}, bd = ae("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: gd
})(ct(({
  theme: e
}) => ({
  ...e.typography.body1,
  color: (e.vars || e).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${Rr.disabled}`]: {
    color: (e.vars || e).palette.text.disabled,
    cursor: "default"
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      padding: "4px 0 5px"
    }
  }, {
    props: ({
      ownerState: t,
      size: n
    }) => t.multiline && n === "small",
    style: {
      paddingTop: 1
    }
  }, {
    props: ({
      ownerState: t
    }) => t.fullWidth,
    style: {
      width: "100%"
    }
  }]
}))), vd = ae("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: yd
})(ct(({
  theme: e
}) => {
  const t = e.palette.mode === "light", n = {
    color: "currentColor",
    ...e.vars ? {
      opacity: e.vars.opacity.inputPlaceholder
    } : {
      opacity: t ? 0.42 : 0.5
    },
    transition: e.transitions.create("opacity", {
      duration: e.transitions.duration.shorter
    })
  }, r = {
    opacity: "0 !important"
  }, i = e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: t ? 0.42 : 0.5
  };
  return {
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    "&::-webkit-input-placeholder": n,
    "&::-moz-placeholder": n,
    // Firefox 19+
    "&::-ms-input-placeholder": n,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${Rr.formControl} &`]: {
      "&::-webkit-input-placeholder": r,
      "&::-moz-placeholder": r,
      // Firefox 19+
      "&::-ms-input-placeholder": r,
      // Edge
      "&:focus::-webkit-input-placeholder": i,
      "&:focus::-moz-placeholder": i,
      // Firefox 19+
      "&:focus::-ms-input-placeholder": i
      // Edge
    },
    [`&.${Rr.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (e.vars || e).palette.text.disabled
      // Fix opacity Safari bug
    },
    variants: [{
      props: ({
        ownerState: a
      }) => !a.disableInjectingGlobalStyles,
      style: {
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&:-webkit-autofill": {
          animationDuration: "5000s",
          animationName: "mui-auto-fill"
        }
      }
    }, {
      props: {
        size: "small"
      },
      style: {
        paddingTop: 1
      }
    }, {
      props: ({
        ownerState: a
      }) => a.multiline,
      style: {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
      }
    }, {
      props: {
        type: "search"
      },
      style: {
        MozAppearance: "textfield"
        // Improve type search style.
      }
    }]
  };
})), xx = K$({
  "@keyframes mui-auto-fill": {
    from: {
      display: "block"
    }
  },
  "@keyframes mui-auto-fill-cancel": {
    from: {
      display: "block"
    }
  }
}), xd = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiInputBase"
  }), {
    "aria-describedby": i,
    autoComplete: a,
    autoFocus: l,
    className: u,
    color: d,
    components: p = {},
    componentsProps: m = {},
    defaultValue: h,
    disabled: g,
    disableInjectingGlobalStyles: v,
    endAdornment: b,
    error: y,
    fullWidth: S = !1,
    id: O,
    inputComponent: P = "input",
    inputProps: k = {},
    inputRef: R,
    margin: E,
    maxRows: M,
    minRows: _,
    multiline: I = !1,
    name: F,
    onBlur: T,
    onChange: $,
    onClick: N,
    onFocus: W,
    onKeyDown: L,
    onKeyUp: V,
    placeholder: z,
    readOnly: X,
    renderSuffix: le,
    rows: ne,
    size: G,
    slotProps: Q = {},
    slots: be = {},
    startAdornment: we,
    type: se = "text",
    value: U,
    ...de
  } = r, ce = k.value != null ? k.value : U, {
    current: K
  } = w.useRef(ce != null), Z = w.useRef(), ue = w.useCallback((Ne) => {
    process.env.NODE_ENV !== "production" && Ne && Ne.nodeName !== "INPUT" && !Ne.focus && console.error(["MUI: You have provided a `inputComponent` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join(`
`));
  }, []), he = It(Z, R, k.ref, ue), [B, ee] = w.useState(!1), ie = ar();
  process.env.NODE_ENV !== "production" && w.useEffect(() => {
    if (ie)
      return ie.registerEffect();
  }, [ie]);
  const ge = Fi({
    props: r,
    muiFormControl: ie,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  ge.focused = ie ? ie.focused : B, w.useEffect(() => {
    !ie && g && B && (ee(!1), T && T());
  }, [ie, g, B, T]);
  const xe = ie && ie.onFilled, pe = ie && ie.onEmpty, Ee = w.useCallback((Ne) => {
    Du(Ne) ? xe && xe() : pe && pe();
  }, [xe, pe]);
  An(() => {
    K && Ee({
      value: ce
    });
  }, [ce, Ee, K]);
  const Pe = (Ne) => {
    W && W(Ne), k.onFocus && k.onFocus(Ne), ie && ie.onFocus ? ie.onFocus(Ne) : ee(!0);
  }, Be = (Ne) => {
    T && T(Ne), k.onBlur && k.onBlur(Ne), ie && ie.onBlur ? ie.onBlur(Ne) : ee(!1);
  }, Ge = (Ne, ...Ct) => {
    if (!K) {
      const Rt = Ne.target || Z.current;
      if (Rt == null)
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : _o(1));
      Ee({
        value: Rt.value
      });
    }
    k.onChange && k.onChange(Ne, ...Ct), $ && $(Ne, ...Ct);
  };
  w.useEffect(() => {
    Ee(Z.current);
  }, []);
  const Ie = (Ne) => {
    Z.current && Ne.currentTarget === Ne.target && Z.current.focus(), N && N(Ne);
  };
  let Dt = P, Re = k;
  I && Dt === "input" && (ne ? (process.env.NODE_ENV !== "production" && (_ || M) && console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set."), Re = {
    type: void 0,
    minRows: ne,
    maxRows: ne,
    ...Re
  }) : Re = {
    type: void 0,
    maxRows: M,
    minRows: _,
    ...Re
  }, Dt = mC);
  const $e = (Ne) => {
    Ee(Ne.animationName === "mui-auto-fill-cancel" ? Z.current : {
      value: "x"
    });
  };
  w.useEffect(() => {
    ie && ie.setAdornedStart(!!we);
  }, [ie, we]);
  const dt = {
    ...r,
    color: ge.color || "primary",
    disabled: ge.disabled,
    endAdornment: b,
    error: ge.error,
    focused: ge.focused,
    formControl: ie,
    fullWidth: S,
    hiddenLabel: ge.hiddenLabel,
    multiline: I,
    size: ge.size,
    startAdornment: we,
    type: se
  }, He = E2(dt), Je = be.root || p.Root || bd, Ze = Q.root || m.root || {}, nt = be.input || p.Input || vd;
  return Re = {
    ...Re,
    ...Q.input ?? m.input
  }, /* @__PURE__ */ x.jsxs(w.Fragment, {
    children: [!v && typeof xx == "function" && // For Emotion/Styled-components, InputGlobalStyles will be a function
    // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
    (vx || (vx = /* @__PURE__ */ x.jsx(xx, {}))), /* @__PURE__ */ x.jsxs(Je, {
      ...Ze,
      ref: n,
      onClick: Ie,
      ...de,
      ...!yl(Je) && {
        ownerState: {
          ...dt,
          ...Ze.ownerState
        }
      },
      className: Me(He.root, Ze.className, u, X && "MuiInputBase-readOnly"),
      children: [we, /* @__PURE__ */ x.jsx(Bl.Provider, {
        value: null,
        children: /* @__PURE__ */ x.jsx(nt, {
          "aria-invalid": ge.error,
          "aria-describedby": i,
          autoComplete: a,
          autoFocus: l,
          defaultValue: h,
          disabled: ge.disabled,
          id: O,
          onAnimationStart: $e,
          name: F,
          placeholder: z,
          readOnly: X,
          required: ge.required,
          rows: ne,
          value: ce,
          onKeyDown: L,
          onKeyUp: V,
          type: se,
          ...Re,
          ...!yl(nt) && {
            as: Dt,
            ownerState: {
              ...dt,
              ...Re.ownerState
            }
          },
          ref: he,
          className: Me(He.input, Re.className, X && "MuiInputBase-readOnly"),
          onBlur: Be,
          onChange: Ge,
          onFocus: Pe
        })
      }), b, le ? le({
        ...ge,
        startAdornment: we
      }) : null]
    })]
  });
});
process.env.NODE_ENV !== "production" && (xd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  "aria-describedby": o.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: o.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: o.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: o.oneOfType([o.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), o.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: o.shape({
    Input: o.elementType,
    Root: o.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: o.shape({
    input: o.object,
    root: o.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: o.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: o.bool,
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: o.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: o.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: o.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: o.bool,
  /**
   * The id of the `input` element.
   */
  id: o.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: ad,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: o.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: gn,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: o.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: o.oneOfType([o.number, o.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: o.oneOfType([o.number, o.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: o.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: o.string,
  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: o.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: o.func,
  /**
   * @ignore
   */
  onClick: o.func,
  /**
   * @ignore
   */
  onFocus: o.func,
  /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */
  onInvalid: o.func,
  /**
   * @ignore
   */
  onKeyDown: o.func,
  /**
   * @ignore
   */
  onKeyUp: o.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: o.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: o.bool,
  /**
   * @ignore
   */
  renderSuffix: o.func,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: o.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: o.oneOfType([o.number, o.string]),
  /**
   * The size of the component.
   */
  size: o.oneOfType([o.oneOf(["medium", "small"]), o.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: o.shape({
    input: o.object,
    root: o.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: o.shape({
    input: o.elementType,
    root: o.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: o.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: o.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: o.any
});
function R2(e) {
  return ze("MuiInput", e);
}
const Oi = {
  ...Rr,
  ...Ve("MuiInput", ["root", "underline", "input"])
};
function k2(e) {
  return ze("MuiOutlinedInput", e);
}
const Hr = {
  ...Rr,
  ...Ve("MuiOutlinedInput", ["root", "notchedOutline", "input"])
};
function P2(e) {
  return ze("MuiFilledInput", e);
}
const kr = {
  ...Rr,
  ...Ve("MuiFilledInput", ["root", "underline", "input", "adornedStart", "adornedEnd", "sizeSmall", "multiline", "hiddenLabel"])
}, hC = rn(/* @__PURE__ */ x.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
function D2(e) {
  return ze("MuiAutocomplete", e);
}
const wt = Ve("MuiAutocomplete", ["root", "expanded", "fullWidth", "focused", "focusVisible", "tag", "tagSizeSmall", "tagSizeMedium", "hasPopupIcon", "hasClearIcon", "inputRoot", "input", "inputFocused", "endAdornment", "clearIndicator", "popupIndicator", "popupIndicatorOpen", "popper", "popperDisablePortal", "paper", "listbox", "loading", "noOptions", "option", "groupLabel", "groupUl"]);
var wx, Cx;
const M2 = (e) => {
  const {
    classes: t,
    disablePortal: n,
    expanded: r,
    focused: i,
    fullWidth: a,
    hasClearIcon: l,
    hasPopupIcon: u,
    inputFocused: d,
    popupOpen: p,
    size: m
  } = e, h = {
    root: ["root", r && "expanded", i && "focused", a && "fullWidth", l && "hasClearIcon", u && "hasPopupIcon"],
    inputRoot: ["inputRoot"],
    input: ["input", d && "inputFocused"],
    tag: ["tag", `tagSize${ke(m)}`],
    endAdornment: ["endAdornment"],
    clearIndicator: ["clearIndicator"],
    popupIndicator: ["popupIndicator", p && "popupIndicatorOpen"],
    popper: ["popper", n && "popperDisablePortal"],
    paper: ["paper"],
    listbox: ["listbox"],
    loading: ["loading"],
    noOptions: ["noOptions"],
    option: ["option"],
    groupLabel: ["groupLabel"],
    groupUl: ["groupUl"]
  };
  return We(h, D2, t);
}, _2 = ae("div", {
  name: "MuiAutocomplete",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      fullWidth: r,
      hasClearIcon: i,
      hasPopupIcon: a,
      inputFocused: l,
      size: u
    } = n;
    return [{
      [`& .${wt.tag}`]: t.tag
    }, {
      [`& .${wt.tag}`]: t[`tagSize${ke(u)}`]
    }, {
      [`& .${wt.inputRoot}`]: t.inputRoot
    }, {
      [`& .${wt.input}`]: t.input
    }, {
      [`& .${wt.input}`]: l && t.inputFocused
    }, t.root, r && t.fullWidth, a && t.hasPopupIcon, i && t.hasClearIcon];
  }
})({
  [`&.${wt.focused} .${wt.clearIndicator}`]: {
    visibility: "visible"
  },
  /* Avoid double tap issue on iOS */
  "@media (pointer: fine)": {
    [`&:hover .${wt.clearIndicator}`]: {
      visibility: "visible"
    }
  },
  [`& .${wt.tag}`]: {
    margin: 3,
    maxWidth: "calc(100% - 6px)"
  },
  [`& .${wt.inputRoot}`]: {
    [`.${wt.hasPopupIcon}&, .${wt.hasClearIcon}&`]: {
      paddingRight: 30
    },
    [`.${wt.hasPopupIcon}.${wt.hasClearIcon}&`]: {
      paddingRight: 56
    },
    [`& .${wt.input}`]: {
      width: 0,
      minWidth: 30
    }
  },
  [`& .${Oi.root}`]: {
    paddingBottom: 1,
    "& .MuiInput-input": {
      padding: "4px 4px 4px 0px"
    }
  },
  [`& .${Oi.root}.${Rr.sizeSmall}`]: {
    [`& .${Oi.input}`]: {
      padding: "2px 4px 3px 0"
    }
  },
  [`& .${Hr.root}`]: {
    padding: 9,
    [`.${wt.hasPopupIcon}&, .${wt.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${wt.hasPopupIcon}.${wt.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${wt.input}`]: {
      padding: "7.5px 4px 7.5px 5px"
    },
    [`& .${wt.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${Hr.root}.${Rr.sizeSmall}`]: {
    // Don't specify paddingRight, as it overrides the default value set when there is only
    // one of the popup or clear icon as the specificity is equal so the latter one wins
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 6,
    [`& .${wt.input}`]: {
      padding: "2.5px 4px 2.5px 8px"
    }
  },
  [`& .${kr.root}`]: {
    paddingTop: 19,
    paddingLeft: 8,
    [`.${wt.hasPopupIcon}&, .${wt.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${wt.hasPopupIcon}.${wt.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${kr.input}`]: {
      padding: "7px 4px"
    },
    [`& .${wt.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${kr.root}.${Rr.sizeSmall}`]: {
    paddingBottom: 1,
    [`& .${kr.input}`]: {
      padding: "2.5px 4px"
    }
  },
  [`& .${Rr.hiddenLabel}`]: {
    paddingTop: 8
  },
  [`& .${kr.root}.${Rr.hiddenLabel}`]: {
    paddingTop: 0,
    paddingBottom: 0,
    [`& .${wt.input}`]: {
      paddingTop: 16,
      paddingBottom: 17
    }
  },
  [`& .${kr.root}.${Rr.hiddenLabel}.${Rr.sizeSmall}`]: {
    [`& .${wt.input}`]: {
      paddingTop: 8,
      paddingBottom: 9
    }
  },
  [`& .${wt.input}`]: {
    flexGrow: 1,
    textOverflow: "ellipsis",
    opacity: 0
  },
  variants: [{
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      [`& .${wt.tag}`]: {
        margin: 2,
        maxWidth: "calc(100% - 4px)"
      }
    }
  }, {
    props: {
      inputFocused: !0
    },
    style: {
      [`& .${wt.input}`]: {
        opacity: 1
      }
    }
  }, {
    props: {
      multiple: !0
    },
    style: {
      [`& .${wt.inputRoot}`]: {
        flexWrap: "wrap"
      }
    }
  }]
}), I2 = ae("div", {
  name: "MuiAutocomplete",
  slot: "EndAdornment",
  overridesResolver: (e, t) => t.endAdornment
})({
  // We use a position absolute to support wrapping tags.
  position: "absolute",
  right: 0,
  top: "50%",
  transform: "translate(0, -50%)"
}), j2 = ae(Ai, {
  name: "MuiAutocomplete",
  slot: "ClearIndicator",
  overridesResolver: (e, t) => t.clearIndicator
})({
  marginRight: -2,
  padding: 4,
  visibility: "hidden"
}), $2 = ae(Ai, {
  name: "MuiAutocomplete",
  slot: "PopupIndicator",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.popupIndicator, n.popupOpen && t.popupIndicatorOpen];
  }
})({
  padding: 2,
  marginRight: -2,
  variants: [{
    props: {
      popupOpen: !0
    },
    style: {
      transform: "rotate(180deg)"
    }
  }]
}), A2 = ae(ps, {
  name: "MuiAutocomplete",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${wt.option}`]: t.option
    }, t.popper, n.disablePortal && t.popperDisablePortal];
  }
})(ct(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.modal,
  variants: [{
    props: {
      disablePortal: !0
    },
    style: {
      position: "absolute"
    }
  }]
}))), N2 = ae($i, {
  name: "MuiAutocomplete",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})(ct(({
  theme: e
}) => ({
  ...e.typography.body1,
  overflow: "auto"
}))), F2 = ae("div", {
  name: "MuiAutocomplete",
  slot: "Loading",
  overridesResolver: (e, t) => t.loading
})(ct(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
}))), L2 = ae("div", {
  name: "MuiAutocomplete",
  slot: "NoOptions",
  overridesResolver: (e, t) => t.noOptions
})(ct(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
}))), B2 = ae("ul", {
  name: "MuiAutocomplete",
  slot: "Listbox",
  overridesResolver: (e, t) => t.listbox
})(ct(({
  theme: e
}) => ({
  listStyle: "none",
  margin: 0,
  padding: "8px 0",
  maxHeight: "40vh",
  overflow: "auto",
  position: "relative",
  [`& .${wt.option}`]: {
    minHeight: 48,
    display: "flex",
    overflow: "hidden",
    justifyContent: "flex-start",
    alignItems: "center",
    cursor: "pointer",
    paddingTop: 6,
    boxSizing: "border-box",
    outline: "0",
    WebkitTapHighlightColor: "transparent",
    paddingBottom: 6,
    paddingLeft: 16,
    paddingRight: 16,
    [e.breakpoints.up("sm")]: {
      minHeight: "auto"
    },
    [`&.${wt.focused}`]: {
      backgroundColor: (e.vars || e).palette.action.hover,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    '&[aria-disabled="true"]': {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`&.${wt.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    '&[aria-selected="true"]': {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : mt(e.palette.primary.main, e.palette.action.selectedOpacity),
      [`&.${wt.focused}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : mt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: (e.vars || e).palette.action.selected
        }
      },
      [`&.${wt.focusVisible}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : mt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
      }
    }
  }
}))), V2 = ae(Pu, {
  name: "MuiAutocomplete",
  slot: "GroupLabel",
  overridesResolver: (e, t) => t.groupLabel
})(ct(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  top: -8
}))), z2 = ae("ul", {
  name: "MuiAutocomplete",
  slot: "GroupUl",
  overridesResolver: (e, t) => t.groupUl
})({
  padding: 0,
  [`& .${wt.option}`]: {
    paddingLeft: 24
  }
}), wd = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiAutocomplete"
  }), {
    autoComplete: i = !1,
    autoHighlight: a = !1,
    autoSelect: l = !1,
    blurOnSelect: u = !1,
    ChipProps: d,
    className: p,
    clearIcon: m = wx || (wx = /* @__PURE__ */ x.jsx(VA, {
      fontSize: "small"
    })),
    clearOnBlur: h = !r.freeSolo,
    clearOnEscape: g = !1,
    clearText: v = "Clear",
    closeText: b = "Close",
    componentsProps: y,
    defaultValue: S = r.multiple ? [] : null,
    disableClearable: O = !1,
    disableCloseOnSelect: P = !1,
    disabled: k = !1,
    disabledItemsFocusable: R = !1,
    disableListWrap: E = !1,
    disablePortal: M = !1,
    filterOptions: _,
    filterSelectedOptions: I = !1,
    forcePopupIcon: F = "auto",
    freeSolo: T = !1,
    fullWidth: $ = !1,
    getLimitTagsText: N = (jt) => `+${jt}`,
    getOptionDisabled: W,
    getOptionKey: L,
    getOptionLabel: V,
    isOptionEqualToValue: z,
    groupBy: X,
    handleHomeEndKeys: le = !r.freeSolo,
    id: ne,
    includeInputInList: G = !1,
    inputValue: Q,
    limitTags: be = -1,
    ListboxComponent: we,
    ListboxProps: se,
    loading: U = !1,
    loadingText: de = "Loading…",
    multiple: ce = !1,
    noOptionsText: K = "No options",
    onChange: Z,
    onClose: ue,
    onHighlightChange: he,
    onInputChange: B,
    onOpen: ee,
    open: ie,
    openOnFocus: ge = !1,
    openText: xe = "Open",
    options: pe,
    PaperComponent: Ee,
    PopperComponent: Pe,
    popupIcon: Be = Cx || (Cx = /* @__PURE__ */ x.jsx(hC, {})),
    readOnly: Ge = !1,
    renderGroup: Ie,
    renderInput: Dt,
    renderOption: Re,
    renderTags: $e,
    selectOnFocus: dt = !r.freeSolo,
    size: He = "medium",
    slots: Je = {},
    slotProps: Ze = {},
    value: nt,
    ...Ne
  } = r, {
    getRootProps: Ct,
    getInputProps: Rt,
    getInputLabelProps: At,
    getPopupIndicatorProps: Xt,
    getClearProps: je,
    getTagProps: ot,
    getListboxProps: vt,
    getOptionProps: gt,
    value: kt,
    dirty: xn,
    expanded: on,
    id: br,
    popupOpen: Un,
    focused: no,
    focusedTag: mo,
    anchorEl: et,
    setAnchorEl: jn,
    inputValue: ho,
    groupedOptions: ro
  } = ZA({
    ...r,
    componentName: "Autocomplete"
  }), $r = !O && !k && xn && !Ge, go = (!T || F === !0) && F !== !1, {
    onMouseDown: Ao
  } = Rt(), {
    ref: Li,
    ...Bi
  } = vt(), H = V || ((jt) => jt.label ?? jt), Se = {
    ...r,
    disablePortal: M,
    expanded: on,
    focused: no,
    fullWidth: $,
    getOptionLabel: H,
    hasClearIcon: $r,
    hasPopupIcon: go,
    inputFocused: mo === -1,
    popupOpen: Un,
    size: He
  }, _e = M2(Se), Qe = {
    slots: {
      paper: Ee,
      popper: Pe,
      ...Je
    },
    slotProps: {
      chip: d,
      listbox: se,
      ...y,
      ...Ze
    }
  }, [Ot, fe] = fn("listbox", {
    elementType: B2,
    externalForwardedProps: Qe,
    ownerState: Se,
    className: _e.listbox,
    additionalProps: Bi,
    ref: Li
  }), [oe, Te] = fn("paper", {
    elementType: $i,
    externalForwardedProps: Qe,
    ownerState: Se,
    className: _e.paper
  }), [Ke, Ye] = fn("popper", {
    elementType: ps,
    externalForwardedProps: Qe,
    ownerState: Se,
    className: _e.popper,
    additionalProps: {
      disablePortal: M,
      style: {
        width: et ? et.clientWidth : null
      },
      role: "presentation",
      anchorEl: et,
      open: Un
    }
  });
  let tt;
  if (ce && kt.length > 0) {
    const jt = (vr) => ({
      className: _e.tag,
      disabled: k,
      ...ot(vr)
    });
    $e ? tt = $e(kt, jt, Se) : tt = kt.map((vr, oo) => {
      const {
        key: zi,
        ...Vd
      } = jt({
        index: oo
      });
      return /* @__PURE__ */ x.jsx(hd, {
        label: H(vr),
        size: He,
        ...Vd,
        ...Qe.slotProps.chip
      }, zi);
    });
  }
  if (be > -1 && Array.isArray(tt)) {
    const jt = tt.length - be;
    !no && jt > 0 && (tt = tt.splice(0, be), tt.push(/* @__PURE__ */ x.jsx("span", {
      className: _e.tag,
      children: N(jt)
    }, tt.length)));
  }
  const Jt = Ie || ((jt) => /* @__PURE__ */ x.jsxs("li", {
    children: [/* @__PURE__ */ x.jsx(V2, {
      className: _e.groupLabel,
      ownerState: Se,
      component: "div",
      children: jt.group
    }), /* @__PURE__ */ x.jsx(z2, {
      className: _e.groupUl,
      ownerState: Se,
      children: jt.children
    })]
  }, jt.key)), kn = Re || ((jt, vr) => {
    const {
      key: oo,
      ...zi
    } = jt;
    return /* @__PURE__ */ x.jsx("li", {
      ...zi,
      children: H(vr)
    }, oo);
  }), li = (jt, vr) => {
    const oo = gt({
      option: jt,
      index: vr
    });
    return kn({
      ...oo,
      className: _e.option
    }, jt, {
      selected: oo["aria-selected"],
      index: vr,
      inputValue: ho
    }, Se);
  }, ci = Qe.slotProps.clearIndicator, ui = Qe.slotProps.popupIndicator;
  return /* @__PURE__ */ x.jsxs(w.Fragment, {
    children: [/* @__PURE__ */ x.jsx(_2, {
      ref: n,
      className: Me(_e.root, p),
      ownerState: Se,
      ...Ct(Ne),
      children: Dt({
        id: br,
        disabled: k,
        fullWidth: !0,
        size: He === "small" ? "small" : void 0,
        InputLabelProps: At(),
        InputProps: {
          ref: jn,
          className: _e.inputRoot,
          startAdornment: tt,
          onMouseDown: (jt) => {
            jt.target === jt.currentTarget && Ao(jt);
          },
          ...($r || go) && {
            endAdornment: /* @__PURE__ */ x.jsxs(I2, {
              className: _e.endAdornment,
              ownerState: Se,
              children: [$r ? /* @__PURE__ */ x.jsx(j2, {
                ...je(),
                "aria-label": v,
                title: v,
                ownerState: Se,
                ...ci,
                className: Me(_e.clearIndicator, ci == null ? void 0 : ci.className),
                children: m
              }) : null, go ? /* @__PURE__ */ x.jsx($2, {
                ...Xt(),
                disabled: k,
                "aria-label": Un ? b : xe,
                title: Un ? b : xe,
                ownerState: Se,
                ...ui,
                className: Me(_e.popupIndicator, ui == null ? void 0 : ui.className),
                children: Be
              }) : null]
            })
          }
        },
        inputProps: {
          className: _e.input,
          disabled: k,
          readOnly: Ge,
          ...Rt()
        }
      })
    }), et ? /* @__PURE__ */ x.jsx(A2, {
      as: Ke,
      ...Ye,
      children: /* @__PURE__ */ x.jsxs(N2, {
        as: oe,
        ...Te,
        children: [U && ro.length === 0 ? /* @__PURE__ */ x.jsx(F2, {
          className: _e.loading,
          ownerState: Se,
          children: de
        }) : null, ro.length === 0 && !T && !U ? /* @__PURE__ */ x.jsx(L2, {
          className: _e.noOptions,
          ownerState: Se,
          role: "presentation",
          onMouseDown: (jt) => {
            jt.preventDefault();
          },
          children: K
        }) : null, ro.length > 0 ? /* @__PURE__ */ x.jsx(Ot, {
          as: we,
          ...fe,
          children: ro.map((jt, vr) => X ? Jt({
            key: jt.key,
            group: jt.group,
            children: jt.options.map((oo, zi) => li(oo, jt.index + zi))
          }) : li(jt, vr))
        }) : null]
      })
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (wd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the portion of the selected suggestion that the user hasn't typed,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   * @default false
   */
  autoComplete: o.bool,
  /**
   * If `true`, the first option is automatically highlighted.
   * @default false
   */
  autoHighlight: o.bool,
  /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   *
   * When using the `freeSolo` mode, the typed value will be the input value
   * if the Autocomplete loses focus without highlighting an option.
   * @default false
   */
  autoSelect: o.bool,
  /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   * @default false
   */
  blurOnSelect: o.oneOfType([o.oneOf(["mouse", "touch"]), o.bool]),
  /**
   * Props applied to the [`Chip`](https://mui.com/material-ui/api/chip/) element.
   * @deprecated Use `slotProps.chip` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ChipProps: o.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The icon to display in place of the default clear icon.
   * @default <ClearIcon fontSize="small" />
   */
  clearIcon: o.node,
  /**
   * If `true`, the input's text is cleared on blur if no value is selected.
   *
   * Set it to `true` if you want to help the user enter a new value.
   * Set it to `false` if you want to help the user resume their search.
   * @default !props.freeSolo
   */
  clearOnBlur: o.bool,
  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   * @default false
   */
  clearOnEscape: o.bool,
  /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Clear'
   */
  clearText: o.string,
  /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: o.string,
  /**
   * The props used for each slot inside.
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  componentsProps: o.shape({
    clearIndicator: o.object,
    paper: o.object,
    popper: o.object,
    popupIndicator: o.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   * @default props.multiple ? [] : null
   */
  defaultValue: fo(o.any, (e) => e.multiple && e.defaultValue !== void 0 && !Array.isArray(e.defaultValue) ? new Error(["MUI: The Autocomplete expects the `defaultValue` prop to be an array when `multiple={true}` or undefined.", `However, ${e.defaultValue} was provided.`].join(`
`)) : null),
  /**
   * If `true`, the input can't be cleared.
   * @default false
   */
  disableClearable: o.bool,
  /**
   * If `true`, the popup won't close when a value is selected.
   * @default false
   */
  disableCloseOnSelect: o.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: o.bool,
  /**
   * If `true`, the list box in the popup will not wrap focus.
   * @default false
   */
  disableListWrap: o.bool,
  /**
   * If `true`, the `Popper` content will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: o.bool,
  /**
   * A function that determines the filtered options to be rendered on search.
   *
   * @default createFilterOptions()
   * @param {Value[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {Value[]}
   */
  filterOptions: o.func,
  /**
   * If `true`, hide the selected options from the list box.
   * @default false
   */
  filterSelectedOptions: o.bool,
  /**
   * Force the visibility display of the popup icon.
   * @default 'auto'
   */
  forcePopupIcon: o.oneOfType([o.oneOf(["auto"]), o.bool]),
  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   * @default false
   */
  freeSolo: o.bool,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: o.bool,
  /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   * @default (more) => `+${more}`
   */
  getLimitTagsText: o.func,
  /**
   * Used to determine the disabled state for a given option.
   *
   * @param {Value} option The option to test.
   * @returns {boolean}
   */
  getOptionDisabled: o.func,
  /**
   * Used to determine the key for a given option.
   * This can be useful when the labels of options are not unique (since labels are used as keys by default).
   *
   * @param {Value} option The option to get the key for.
   * @returns {string | number}
   */
  getOptionKey: o.func,
  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * If used in free solo mode, it must accept both the type of the options and a string.
   *
   * @param {Value} option
   * @returns {string}
   * @default (option) => option.label ?? option
   */
  getOptionLabel: o.func,
  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {Value} option The Autocomplete option.
   * @returns {string}
   */
  groupBy: o.func,
  /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   * @default !props.freeSolo
   */
  handleHomeEndKeys: o.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide an id it will fall back to a randomly generated one.
   */
  id: o.string,
  /**
   * If `true`, the highlight can move to the input.
   * @default false
   */
  includeInputInList: o.bool,
  /**
   * The input value.
   */
  inputValue: o.string,
  /**
   * Used to determine if the option represents the given value.
   * Uses strict equality by default.
   * ⚠️ Both arguments need to be handled, an option can only match with one value.
   *
   * @param {Value} option The option to test.
   * @param {Value} value The value to test against.
   * @returns {boolean}
   */
  isOptionEqualToValue: o.func,
  /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   * @default -1
   */
  limitTags: yh,
  /**
   * The component used to render the listbox.
   * @default 'ul'
   * @deprecated Use `slotProps.listbox.component` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ListboxComponent: o.elementType,
  /**
   * Props applied to the Listbox element.
   * @deprecated Use `slotProps.listbox` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ListboxProps: o.object,
  /**
   * If `true`, the component is in a loading state.
   * This shows the `loadingText` in place of suggestions (only if there are no suggestions to show, for example `options` are empty).
   * @default false
   */
  loading: o.bool,
  /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Loading…'
   */
  loadingText: o.node,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: o.bool,
  /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'No options'
   */
  noOptionsText: o.node,
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value|Value[]} value The new value of the component.
   * @param {string} reason One of "createOption", "selectOption", "removeOption", "blur" or "clear".
   * @param {string} [details]
   */
  onChange: o.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"selectOption"`, `"removeOption"`, `"blur"`.
   */
  onClose: o.func,
  /**
   * Callback fired when the highlight option changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"auto"`, `"mouse"`, `"touch"`.
   */
  onHighlightChange: o.func,
  /**
   * Callback fired when the input value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`, `"blur"`, `"selectOption"`, `"removeOption"`
   */
  onInputChange: o.func,
  /**
   * @ignore
   */
  onKeyDown: o.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: o.func,
  /**
   * If `true`, the component is shown.
   */
  open: o.bool,
  /**
   * If `true`, the popup will open on input focus.
   * @default false
   */
  openOnFocus: o.bool,
  /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Open'
   */
  openText: o.string,
  /**
   * A list of options that will be shown in the Autocomplete.
   */
  options: o.array.isRequired,
  /**
   * The component used to render the body of the popup.
   * @default Paper
   * @deprecated Use `slots.paper` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PaperComponent: o.elementType,
  /**
   * The component used to position the popup.
   * @default Popper
   * @deprecated Use `slots.popper` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PopperComponent: o.elementType,
  /**
   * The icon to display in place of the default popup icon.
   * @default <ArrowDropDownIcon />
   */
  popupIcon: o.node,
  /**
   * If `true`, the component becomes readonly. It is also supported for multiple tags where the tag cannot be deleted.
   * @default false
   */
  readOnly: o.bool,
  /**
   * Render the group.
   *
   * @param {AutocompleteRenderGroupParams} params The group to render.
   * @returns {ReactNode}
   */
  renderGroup: o.func,
  /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */
  renderInput: o.func.isRequired,
  /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {object} props The props to apply on the li element.
   * @param {Value} option The option to render.
   * @param {object} state The state of each option.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderOption: o.func,
  /**
   * Render the selected value.
   *
   * @param {Value[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderTags: o.func,
  /**
   * If `true`, the input's text is selected on focus.
   * It helps the user clear the selected value.
   * @default !props.freeSolo
   */
  selectOnFocus: o.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: o.oneOfType([o.oneOf(["small", "medium"]), o.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: o.shape({
    chip: o.oneOfType([o.func, o.object]),
    clearIndicator: o.oneOfType([o.func, o.object]),
    listbox: o.oneOfType([o.func, o.object]),
    paper: o.oneOfType([o.func, o.object]),
    popper: o.oneOfType([o.func, o.object]),
    popupIndicator: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: o.shape({
    listbox: o.elementType,
    paper: o.elementType,
    popper: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `isOptionEqualToValue` prop.
   */
  value: fo(o.any, (e) => e.multiple && e.value !== void 0 && !Array.isArray(e.value) ? new Error(["MUI: The Autocomplete expects the `value` prop to be an array when `multiple={true}` or undefined.", `However, ${e.value} was provided.`].join(`
`)) : null)
});
const W2 = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, _i = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ir(), i = {
    enter: r.transitions.duration.enteringScreen,
    exit: r.transitions.duration.leavingScreen
  }, {
    addEndListener: a,
    appear: l = !0,
    children: u,
    easing: d,
    in: p,
    onEnter: m,
    onEntered: h,
    onEntering: g,
    onExit: v,
    onExited: b,
    onExiting: y,
    style: S,
    timeout: O = i,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: P = to,
    ...k
  } = t, R = w.useRef(null), E = It(R, us(u), n), M = (L) => (V) => {
    if (L) {
      const z = R.current;
      V === void 0 ? L(z) : L(z, V);
    }
  }, _ = M(g), I = M((L, V) => {
    tC(L);
    const z = Tu({
      style: S,
      timeout: O,
      easing: d
    }, {
      mode: "enter"
    });
    L.style.webkitTransition = r.transitions.create("opacity", z), L.style.transition = r.transitions.create("opacity", z), m && m(L, V);
  }), F = M(h), T = M(y), $ = M((L) => {
    const V = Tu({
      style: S,
      timeout: O,
      easing: d
    }, {
      mode: "exit"
    });
    L.style.webkitTransition = r.transitions.create("opacity", V), L.style.transition = r.transitions.create("opacity", V), v && v(L);
  }), N = M(b), W = (L) => {
    a && a(R.current, L);
  };
  return /* @__PURE__ */ x.jsx(P, {
    appear: l,
    in: p,
    nodeRef: R,
    onEnter: I,
    onEntered: F,
    onEntering: _,
    onExit: $,
    onExited: N,
    onExiting: T,
    addEndListener: W,
    timeout: O,
    ...k,
    children: (L, {
      ownerState: V,
      ...z
    }) => /* @__PURE__ */ w.cloneElement(u, {
      style: {
        opacity: 0,
        visibility: L === "exited" && !p ? "hidden" : void 0,
        ...W2[L],
        ...S,
        ...u.props.style
      },
      ref: E,
      ...z
    })
  });
});
process.env.NODE_ENV !== "production" && (_i.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: o.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: o.bool,
  /**
   * A single child content element.
   */
  children: cs.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: o.oneOfType([o.shape({
    enter: o.string,
    exit: o.string
  }), o.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: o.bool,
  /**
   * @ignore
   */
  onEnter: o.func,
  /**
   * @ignore
   */
  onEntered: o.func,
  /**
   * @ignore
   */
  onEntering: o.func,
  /**
   * @ignore
   */
  onExit: o.func,
  /**
   * @ignore
   */
  onExited: o.func,
  /**
   * @ignore
   */
  onExiting: o.func,
  /**
   * @ignore
   */
  style: o.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: o.oneOfType([o.number, o.shape({
    appear: o.number,
    enter: o.number,
    exit: o.number
  })])
});
function q2(e) {
  return ze("MuiBackdrop", e);
}
Ve("MuiBackdrop", ["root", "invisible"]);
const H2 = (e) => {
  const {
    classes: t,
    invisible: n
  } = e;
  return We({
    root: ["root", n && "invisible"]
  }, q2, t);
}, U2 = ae("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.invisible && t.invisible];
  }
})({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent",
  variants: [{
    props: {
      invisible: !0
    },
    style: {
      backgroundColor: "transparent"
    }
  }]
}), Ih = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiBackdrop"
  }), {
    children: i,
    className: a,
    component: l = "div",
    invisible: u = !1,
    open: d,
    components: p = {},
    componentsProps: m = {},
    slotProps: h = {},
    slots: g = {},
    TransitionComponent: v,
    transitionDuration: b,
    ...y
  } = r, S = {
    ...r,
    component: l,
    invisible: u
  }, O = H2(S), P = {
    transition: v,
    root: p.Root,
    ...g
  }, k = {
    ...m,
    ...h
  }, R = {
    slots: P,
    slotProps: k
  }, [E, M] = fn("root", {
    elementType: U2,
    externalForwardedProps: R,
    className: Me(O.root, a),
    ownerState: S
  }), [_, I] = fn("transition", {
    elementType: _i,
    externalForwardedProps: R,
    ownerState: S
  });
  return /* @__PURE__ */ x.jsx(_, {
    in: d,
    timeout: b,
    ...y,
    ...I,
    children: /* @__PURE__ */ x.jsx(E, {
      "aria-hidden": !0,
      ...M,
      classes: O,
      ref: n,
      children: i
    })
  });
});
process.env.NODE_ENV !== "production" && (Ih.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: o.shape({
    Root: o.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: o.shape({
    root: o.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: o.bool,
  /**
   * If `true`, the component is shown.
   */
  open: o.bool.isRequired,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: o.shape({
    root: o.oneOfType([o.func, o.object]),
    transition: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: o.shape({
    root: o.elementType,
    transition: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: o.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: o.oneOfType([o.number, o.shape({
    appear: o.number,
    enter: o.number,
    exit: o.number
  })])
});
const Y2 = Ve("MuiBox", ["root"]), G2 = Al(), Mr = nj({
  themeId: Gr,
  defaultTheme: G2,
  defaultClassName: Y2.root,
  generateClassName: x1.generate
});
process.env.NODE_ENV !== "production" && (Mr.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: o.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
function K2(e) {
  return ze("MuiButton", e);
}
const Zi = Ve("MuiButton", ["root", "text", "textInherit", "textPrimary", "textSecondary", "textSuccess", "textError", "textInfo", "textWarning", "outlined", "outlinedInherit", "outlinedPrimary", "outlinedSecondary", "outlinedSuccess", "outlinedError", "outlinedInfo", "outlinedWarning", "contained", "containedInherit", "containedPrimary", "containedSecondary", "containedSuccess", "containedError", "containedInfo", "containedWarning", "disableElevation", "focusVisible", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorSuccess", "colorError", "colorInfo", "colorWarning", "textSizeSmall", "textSizeMedium", "textSizeLarge", "outlinedSizeSmall", "outlinedSizeMedium", "outlinedSizeLarge", "containedSizeSmall", "containedSizeMedium", "containedSizeLarge", "sizeMedium", "sizeSmall", "sizeLarge", "fullWidth", "startIcon", "endIcon", "icon", "iconSizeSmall", "iconSizeMedium", "iconSizeLarge", "loading", "loadingWrapper", "loadingIconPlaceholder", "loadingIndicator", "loadingPositionCenter", "loadingPositionStart", "loadingPositionEnd"]), gC = /* @__PURE__ */ w.createContext({});
process.env.NODE_ENV !== "production" && (gC.displayName = "ButtonGroupContext");
const yC = /* @__PURE__ */ w.createContext(void 0);
process.env.NODE_ENV !== "production" && (yC.displayName = "ButtonGroupButtonContext");
const X2 = (e) => {
  const {
    color: t,
    disableElevation: n,
    fullWidth: r,
    size: i,
    variant: a,
    loading: l,
    loadingPosition: u,
    classes: d
  } = e, p = {
    root: ["root", l && "loading", a, `${a}${ke(t)}`, `size${ke(i)}`, `${a}Size${ke(i)}`, `color${ke(t)}`, n && "disableElevation", r && "fullWidth", l && `loadingPosition${ke(u)}`],
    startIcon: ["icon", "startIcon", `iconSize${ke(i)}`],
    endIcon: ["icon", "endIcon", `iconSize${ke(i)}`],
    loadingIndicator: ["loadingIndicator"],
    loadingWrapper: ["loadingWrapper"]
  }, m = We(p, K2, d);
  return {
    ...d,
    // forward the focused, disabled, etc. classes to the ButtonBase
    ...m
  };
}, bC = [{
  props: {
    size: "small"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 18
    }
  }
}, {
  props: {
    size: "medium"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 20
    }
  }
}, {
  props: {
    size: "large"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 22
    }
  }
}], Q2 = ae(Io, {
  shouldForwardProp: (e) => Zn(e) || e === "classes",
  name: "MuiButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`${n.variant}${ke(n.color)}`], t[`size${ke(n.size)}`], t[`${n.variant}Size${ke(n.size)}`], n.color === "inherit" && t.colorInherit, n.disableElevation && t.disableElevation, n.fullWidth && t.fullWidth, n.loading && t.loading];
  }
})(ct(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? e.palette.grey[300] : e.palette.grey[800], n = e.palette.mode === "light" ? e.palette.grey.A100 : e.palette.grey[700];
  return {
    ...e.typography.button,
    minWidth: 64,
    padding: "6px 16px",
    border: 0,
    borderRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create(["background-color", "box-shadow", "border-color", "color"], {
      duration: e.transitions.duration.short
    }),
    "&:hover": {
      textDecoration: "none"
    },
    [`&.${Zi.disabled}`]: {
      color: (e.vars || e).palette.action.disabled
    },
    variants: [{
      props: {
        variant: "contained"
      },
      style: {
        color: "var(--variant-containedColor)",
        backgroundColor: "var(--variant-containedBg)",
        boxShadow: (e.vars || e).shadows[2],
        "&:hover": {
          boxShadow: (e.vars || e).shadows[4],
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            boxShadow: (e.vars || e).shadows[2]
          }
        },
        "&:active": {
          boxShadow: (e.vars || e).shadows[8]
        },
        [`&.${Zi.focusVisible}`]: {
          boxShadow: (e.vars || e).shadows[6]
        },
        [`&.${Zi.disabled}`]: {
          color: (e.vars || e).palette.action.disabled,
          boxShadow: (e.vars || e).shadows[0],
          backgroundColor: (e.vars || e).palette.action.disabledBackground
        }
      }
    }, {
      props: {
        variant: "outlined"
      },
      style: {
        padding: "5px 15px",
        border: "1px solid currentColor",
        borderColor: "var(--variant-outlinedBorder, currentColor)",
        backgroundColor: "var(--variant-outlinedBg)",
        color: "var(--variant-outlinedColor)",
        [`&.${Zi.disabled}`]: {
          border: `1px solid ${(e.vars || e).palette.action.disabledBackground}`
        }
      }
    }, {
      props: {
        variant: "text"
      },
      style: {
        padding: "6px 8px",
        color: "var(--variant-textColor)",
        backgroundColor: "var(--variant-textBg)"
      }
    }, ...Object.entries(e.palette).filter(qn()).map(([r]) => ({
      props: {
        color: r
      },
      style: {
        "--variant-textColor": (e.vars || e).palette[r].main,
        "--variant-outlinedColor": (e.vars || e).palette[r].main,
        "--variant-outlinedBorder": e.vars ? `rgba(${e.vars.palette[r].mainChannel} / 0.5)` : mt(e.palette[r].main, 0.5),
        "--variant-containedColor": (e.vars || e).palette[r].contrastText,
        "--variant-containedBg": (e.vars || e).palette[r].main,
        "@media (hover: hover)": {
          "&:hover": {
            "--variant-containedBg": (e.vars || e).palette[r].dark,
            "--variant-textBg": e.vars ? `rgba(${e.vars.palette[r].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : mt(e.palette[r].main, e.palette.action.hoverOpacity),
            "--variant-outlinedBorder": (e.vars || e).palette[r].main,
            "--variant-outlinedBg": e.vars ? `rgba(${e.vars.palette[r].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : mt(e.palette[r].main, e.palette.action.hoverOpacity)
          }
        }
      }
    })), {
      props: {
        color: "inherit"
      },
      style: {
        color: "inherit",
        borderColor: "currentColor",
        "--variant-containedBg": e.vars ? e.vars.palette.Button.inheritContainedBg : t,
        "@media (hover: hover)": {
          "&:hover": {
            "--variant-containedBg": e.vars ? e.vars.palette.Button.inheritContainedHoverBg : n,
            "--variant-textBg": e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : mt(e.palette.text.primary, e.palette.action.hoverOpacity),
            "--variant-outlinedBg": e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : mt(e.palette.text.primary, e.palette.action.hoverOpacity)
          }
        }
      }
    }, {
      props: {
        size: "small",
        variant: "text"
      },
      style: {
        padding: "4px 5px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "text"
      },
      style: {
        padding: "8px 11px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        size: "small",
        variant: "outlined"
      },
      style: {
        padding: "3px 9px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "outlined"
      },
      style: {
        padding: "7px 21px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        size: "small",
        variant: "contained"
      },
      style: {
        padding: "4px 10px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "contained"
      },
      style: {
        padding: "8px 22px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        disableElevation: !0
      },
      style: {
        boxShadow: "none",
        "&:hover": {
          boxShadow: "none"
        },
        [`&.${Zi.focusVisible}`]: {
          boxShadow: "none"
        },
        "&:active": {
          boxShadow: "none"
        },
        [`&.${Zi.disabled}`]: {
          boxShadow: "none"
        }
      }
    }, {
      props: {
        fullWidth: !0
      },
      style: {
        width: "100%"
      }
    }, {
      props: {
        loadingPosition: "center"
      },
      style: {
        transition: e.transitions.create(["background-color", "box-shadow", "border-color"], {
          duration: e.transitions.duration.short
        }),
        [`&.${Zi.loading}`]: {
          color: "transparent"
        }
      }
    }]
  };
})), Z2 = ae("span", {
  name: "MuiButton",
  slot: "StartIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.startIcon, n.loading && t.startIconLoadingStart, t[`iconSize${ke(n.size)}`]];
  }
})(({
  theme: e
}) => ({
  display: "inherit",
  marginRight: 8,
  marginLeft: -4,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginLeft: -2
    }
  }, {
    props: {
      loadingPosition: "start",
      loading: !0
    },
    style: {
      transition: e.transitions.create(["opacity"], {
        duration: e.transitions.duration.short
      }),
      opacity: 0
    }
  }, {
    props: {
      loadingPosition: "start",
      loading: !0,
      fullWidth: !0
    },
    style: {
      marginRight: -8
    }
  }, ...bC]
})), J2 = ae("span", {
  name: "MuiButton",
  slot: "EndIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.endIcon, n.loading && t.endIconLoadingEnd, t[`iconSize${ke(n.size)}`]];
  }
})(({
  theme: e
}) => ({
  display: "inherit",
  marginRight: -4,
  marginLeft: 8,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginRight: -2
    }
  }, {
    props: {
      loadingPosition: "end",
      loading: !0
    },
    style: {
      transition: e.transitions.create(["opacity"], {
        duration: e.transitions.duration.short
      }),
      opacity: 0
    }
  }, {
    props: {
      loadingPosition: "end",
      loading: !0,
      fullWidth: !0
    },
    style: {
      marginLeft: -8
    }
  }, ...bC]
})), eF = ae("span", {
  name: "MuiButton",
  slot: "LoadingIndicator",
  overridesResolver: (e, t) => t.loadingIndicator
})(({
  theme: e
}) => ({
  display: "none",
  position: "absolute",
  visibility: "visible",
  variants: [{
    props: {
      loading: !0
    },
    style: {
      display: "flex"
    }
  }, {
    props: {
      loadingPosition: "start"
    },
    style: {
      left: 14
    }
  }, {
    props: {
      loadingPosition: "start",
      size: "small"
    },
    style: {
      left: 10
    }
  }, {
    props: {
      variant: "text",
      loadingPosition: "start"
    },
    style: {
      left: 6
    }
  }, {
    props: {
      loadingPosition: "center"
    },
    style: {
      left: "50%",
      transform: "translate(-50%)",
      color: (e.vars || e).palette.action.disabled
    }
  }, {
    props: {
      loadingPosition: "end"
    },
    style: {
      right: 14
    }
  }, {
    props: {
      loadingPosition: "end",
      size: "small"
    },
    style: {
      right: 10
    }
  }, {
    props: {
      variant: "text",
      loadingPosition: "end"
    },
    style: {
      right: 6
    }
  }, {
    props: {
      loadingPosition: "start",
      fullWidth: !0
    },
    style: {
      position: "relative",
      left: -10
    }
  }, {
    props: {
      loadingPosition: "end",
      fullWidth: !0
    },
    style: {
      position: "relative",
      right: -10
    }
  }]
})), Sx = ae("span", {
  name: "MuiButton",
  slot: "LoadingIconPlaceholder",
  overridesResolver: (e, t) => t.loadingIconPlaceholder
})({
  display: "inline-block",
  width: "1em",
  height: "1em"
}), En = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = w.useContext(gC), i = w.useContext(yC), a = dl(r, t), l = ut({
    props: a,
    name: "MuiButton"
  }), {
    children: u,
    color: d = "primary",
    component: p = "button",
    className: m,
    disabled: h = !1,
    disableElevation: g = !1,
    disableFocusRipple: v = !1,
    endIcon: b,
    focusVisibleClassName: y,
    fullWidth: S = !1,
    id: O,
    loading: P = null,
    loadingIndicator: k,
    loadingPosition: R = "center",
    size: E = "medium",
    startIcon: M,
    type: _,
    variant: I = "text",
    ...F
  } = l, T = Ir(O), $ = k ?? /* @__PURE__ */ x.jsx(Mi, {
    "aria-labelledby": T,
    color: "inherit",
    size: 16
  }), N = {
    ...l,
    color: d,
    component: p,
    disabled: h,
    disableElevation: g,
    disableFocusRipple: v,
    fullWidth: S,
    loading: P,
    loadingIndicator: $,
    loadingPosition: R,
    size: E,
    type: _,
    variant: I
  }, W = X2(N), L = (M || P && R === "start") && /* @__PURE__ */ x.jsx(Z2, {
    className: W.startIcon,
    ownerState: N,
    children: M || /* @__PURE__ */ x.jsx(Sx, {
      className: W.loadingIconPlaceholder,
      ownerState: N
    })
  }), V = (b || P && R === "end") && /* @__PURE__ */ x.jsx(J2, {
    className: W.endIcon,
    ownerState: N,
    children: b || /* @__PURE__ */ x.jsx(Sx, {
      className: W.loadingIconPlaceholder,
      ownerState: N
    })
  }), z = i || "", X = typeof P == "boolean" ? (
    // use plain HTML span to minimize the runtime overhead
    /* @__PURE__ */ x.jsx("span", {
      className: W.loadingWrapper,
      style: {
        display: "contents"
      },
      children: P && /* @__PURE__ */ x.jsx(eF, {
        className: W.loadingIndicator,
        ownerState: N,
        children: $
      })
    })
  ) : null;
  return /* @__PURE__ */ x.jsxs(Q2, {
    ownerState: N,
    className: Me(r.className, W.root, m, z),
    component: p,
    disabled: h || P,
    focusRipple: !v,
    focusVisibleClassName: Me(W.focusVisible, y),
    ref: n,
    type: _,
    id: P ? T : O,
    ...F,
    classes: W,
    children: [L, R !== "end" && X, u, R === "end" && X, V]
  });
});
process.env.NODE_ENV !== "production" && (En.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: o.oneOfType([o.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning"]), o.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: o.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: o.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: o.bool,
  /**
   * Element placed after the children.
   */
  endIcon: o.node,
  /**
   * @ignore
   */
  focusVisibleClassName: o.string,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: o.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: o.string,
  /**
   * @ignore
   */
  id: o.string,
  /**
   * If `true`, the loading indicator is visible and the button is disabled.
   * If `true | false`, the loading wrapper is always rendered before the children to prevent [Google Translation Crash](https://github.com/mui/material-ui/issues/27853).
   * @default null
   */
  loading: o.bool,
  /**
   * Element placed before the children if the button is in loading state.
   * The node should contain an element with `role="progressbar"` with an accessible name.
   * By default, it renders a `CircularProgress` that is labeled by the button itself.
   * @default <CircularProgress color="inherit" size={16} />
   */
  loadingIndicator: o.node,
  /**
   * The loading indicator can be positioned on the start, end, or the center of the button.
   * @default 'center'
   */
  loadingPosition: o.oneOf(["center", "end", "start"]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: o.oneOfType([o.oneOf(["small", "medium", "large"]), o.string]),
  /**
   * Element placed before the children.
   */
  startIcon: o.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * @ignore
   */
  type: o.oneOfType([o.oneOf(["button", "reset", "submit"]), o.string]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: o.oneOfType([o.oneOf(["contained", "outlined", "text"]), o.string])
});
function tF(e) {
  return ze("PrivateSwitchBase", e);
}
Ve("PrivateSwitchBase", ["root", "checked", "disabled", "input", "edgeStart", "edgeEnd"]);
const nF = (e) => {
  const {
    classes: t,
    checked: n,
    disabled: r,
    edge: i
  } = e, a = {
    root: ["root", n && "checked", r && "disabled", i && `edge${ke(i)}`],
    input: ["input"]
  };
  return We(a, tF, t);
}, rF = ae(Io)({
  padding: 9,
  borderRadius: "50%",
  variants: [{
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: ({
      edge: e,
      ownerState: t
    }) => e === "start" && t.size !== "small",
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }, {
    props: ({
      edge: e,
      ownerState: t
    }) => e === "end" && t.size !== "small",
    style: {
      marginRight: -12
    }
  }]
}), oF = ae("input", {
  shouldForwardProp: Zn
})({
  cursor: "inherit",
  position: "absolute",
  opacity: 0,
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
}), jh = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const {
    autoFocus: r,
    checked: i,
    checkedIcon: a,
    className: l,
    defaultChecked: u,
    disabled: d,
    disableFocusRipple: p = !1,
    edge: m = !1,
    icon: h,
    id: g,
    inputProps: v,
    inputRef: b,
    name: y,
    onBlur: S,
    onChange: O,
    onFocus: P,
    readOnly: k,
    required: R = !1,
    tabIndex: E,
    type: M,
    value: _,
    ...I
  } = t, [F, T] = or({
    controlled: i,
    default: !!u,
    name: "SwitchBase",
    state: "checked"
  }), $ = ar(), N = (ne) => {
    P && P(ne), $ && $.onFocus && $.onFocus(ne);
  }, W = (ne) => {
    S && S(ne), $ && $.onBlur && $.onBlur(ne);
  }, L = (ne) => {
    if (ne.nativeEvent.defaultPrevented)
      return;
    const G = ne.target.checked;
    T(G), O && O(ne, G);
  };
  let V = d;
  $ && typeof V > "u" && (V = $.disabled);
  const z = M === "checkbox" || M === "radio", X = {
    ...t,
    checked: F,
    disabled: V,
    disableFocusRipple: p,
    edge: m
  }, le = nF(X);
  return /* @__PURE__ */ x.jsxs(rF, {
    component: "span",
    className: Me(le.root, l),
    centerRipple: !0,
    focusRipple: !p,
    disabled: V,
    tabIndex: null,
    role: void 0,
    onFocus: N,
    onBlur: W,
    ownerState: X,
    ref: n,
    ...I,
    children: [/* @__PURE__ */ x.jsx(oF, {
      autoFocus: r,
      checked: i,
      defaultChecked: u,
      className: le.input,
      disabled: V,
      id: z ? g : void 0,
      name: y,
      onChange: L,
      readOnly: k,
      ref: b,
      required: R,
      ownerState: X,
      tabIndex: E,
      type: M,
      ...M === "checkbox" && _ === void 0 ? {} : {
        value: _
      },
      ...v
    }), F ? a : h]
  });
});
process.env.NODE_ENV !== "production" && (jh.propTypes = {
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: o.bool,
  /**
   * If `true`, the component is checked.
   */
  checked: o.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: o.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * @ignore
   */
  defaultChecked: o.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: o.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: o.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: o.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: o.node.isRequired,
  /**
   * The id of the `input` element.
   */
  id: o.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: o.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: gn,
  /*
   * @ignore
   */
  name: o.string,
  /**
   * @ignore
   */
  onBlur: o.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: o.func,
  /**
   * @ignore
   */
  onFocus: o.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: o.bool,
  /**
   * If `true`, the `input` element is required.
   */
  required: o.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.object,
  /**
   * @ignore
   */
  tabIndex: o.oneOfType([o.number, o.string]),
  /**
   * The input component prop `type`.
   */
  type: o.string.isRequired,
  /**
   * The value of the component.
   */
  value: o.any
});
const iF = rn(/* @__PURE__ */ x.jsx("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank"), aF = rn(/* @__PURE__ */ x.jsx("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox"), sF = rn(/* @__PURE__ */ x.jsx("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");
function lF(e) {
  return ze("MuiCheckbox", e);
}
const pf = Ve("MuiCheckbox", ["root", "checked", "disabled", "indeterminate", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium"]), cF = (e) => {
  const {
    classes: t,
    indeterminate: n,
    color: r,
    size: i
  } = e, a = {
    root: ["root", n && "indeterminate", `color${ke(r)}`, `size${ke(i)}`]
  }, l = We(a, lF, t);
  return {
    ...t,
    // forward the disabled and checked classes to the SwitchBase
    ...l
  };
}, uF = ae(jh, {
  shouldForwardProp: (e) => Zn(e) || e === "classes",
  name: "MuiCheckbox",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.indeterminate && t.indeterminate, t[`size${ke(n.size)}`], n.color !== "default" && t[`color${ke(n.color)}`]];
  }
})(ct(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  variants: [{
    props: {
      color: "default",
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : mt(e.palette.action.active, e.palette.action.hoverOpacity)
      }
    }
  }, ...Object.entries(e.palette).filter(qn()).map(([t]) => ({
    props: {
      color: t,
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : mt(e.palette[t].main, e.palette.action.hoverOpacity)
      }
    }
  })), ...Object.entries(e.palette).filter(qn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${pf.checked}, &.${pf.indeterminate}`]: {
        color: (e.vars || e).palette[t].main
      },
      [`&.${pf.disabled}`]: {
        color: (e.vars || e).palette.action.disabled
      }
    }
  })), {
    // Should be last to override other colors
    props: {
      disableRipple: !1
    },
    style: {
      // Reset on touch devices, it doesn't add specificity
      "&:hover": {
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }]
}))), dF = /* @__PURE__ */ x.jsx(aF, {}), pF = /* @__PURE__ */ x.jsx(iF, {}), fF = /* @__PURE__ */ x.jsx(sF, {}), $h = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiCheckbox"
  }), {
    checkedIcon: i = dF,
    color: a = "primary",
    icon: l = pF,
    indeterminate: u = !1,
    indeterminateIcon: d = fF,
    inputProps: p,
    size: m = "medium",
    disableRipple: h = !1,
    className: g,
    ...v
  } = r, b = u ? d : l, y = u ? d : i, S = {
    ...r,
    disableRipple: h,
    color: a,
    indeterminate: u,
    size: m
  }, O = cF(S);
  return /* @__PURE__ */ x.jsx(uF, {
    type: "checkbox",
    inputProps: {
      "data-indeterminate": u,
      ...p
    },
    icon: /* @__PURE__ */ w.cloneElement(b, {
      fontSize: b.props.fontSize ?? m
    }),
    checkedIcon: /* @__PURE__ */ w.cloneElement(y, {
      fontSize: y.props.fontSize ?? m
    }),
    ownerState: S,
    ref: n,
    className: Me(O.root, g),
    disableRipple: h,
    ...v,
    classes: O
  });
});
process.env.NODE_ENV !== "production" && ($h.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: o.bool,
  /**
   * The icon to display when the component is checked.
   * @default <CheckBoxIcon />
   */
  checkedIcon: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: o.oneOfType([o.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), o.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: o.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: o.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <CheckBoxOutlineBlankIcon />
   */
  icon: o.node,
  /**
   * The id of the `input` element.
   */
  id: o.string,
  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the `input`.
   * @default false
   */
  indeterminate: o.bool,
  /**
   * The icon to display when the component is indeterminate.
   * @default <IndeterminateCheckBoxIcon />
   */
  indeterminateIcon: o.node,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: o.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: gn,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: o.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: o.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense checkbox styling.
   * @default 'medium'
   */
  size: o.oneOfType([o.oneOf(["medium", "small"]), o.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: o.any
});
function mF(e) {
  const t = Qn(e);
  return t.body === e ? ti(e).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
function ol(e, t) {
  t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
function Ox(e) {
  return parseInt(ti(e).getComputedStyle(e).paddingRight, 10) || 0;
}
function hF(e) {
  const n = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].includes(e.tagName), r = e.tagName === "INPUT" && e.getAttribute("type") === "hidden";
  return n || r;
}
function Tx(e, t, n, r, i) {
  const a = [t, n, ...r];
  [].forEach.call(e.children, (l) => {
    const u = !a.includes(l), d = !hF(l);
    u && d && ol(l, i);
  });
}
function ff(e, t) {
  let n = -1;
  return e.some((r, i) => t(r) ? (n = i, !0) : !1), n;
}
function gF(e, t) {
  const n = [], r = e.container;
  if (!t.disableScrollLock) {
    if (mF(r)) {
      const l = j1(ti(r));
      n.push({
        value: r.style.paddingRight,
        property: "padding-right",
        el: r
      }), r.style.paddingRight = `${Ox(r) + l}px`;
      const u = Qn(r).querySelectorAll(".mui-fixed");
      [].forEach.call(u, (d) => {
        n.push({
          value: d.style.paddingRight,
          property: "padding-right",
          el: d
        }), d.style.paddingRight = `${Ox(d) + l}px`;
      });
    }
    let a;
    if (r.parentNode instanceof DocumentFragment)
      a = Qn(r).body;
    else {
      const l = r.parentElement, u = ti(r);
      a = (l == null ? void 0 : l.nodeName) === "HTML" && u.getComputedStyle(l).overflowY === "scroll" ? l : r;
    }
    n.push({
      value: a.style.overflow,
      property: "overflow",
      el: a
    }, {
      value: a.style.overflowX,
      property: "overflow-x",
      el: a
    }, {
      value: a.style.overflowY,
      property: "overflow-y",
      el: a
    }), a.style.overflow = "hidden";
  }
  return () => {
    n.forEach(({
      value: a,
      el: l,
      property: u
    }) => {
      a ? l.style.setProperty(u, a) : l.style.removeProperty(u);
    });
  };
}
function yF(e) {
  const t = [];
  return [].forEach.call(e.children, (n) => {
    n.getAttribute("aria-hidden") === "true" && t.push(n);
  }), t;
}
class bF {
  constructor() {
    this.modals = [], this.containers = [];
  }
  add(t, n) {
    let r = this.modals.indexOf(t);
    if (r !== -1)
      return r;
    r = this.modals.length, this.modals.push(t), t.modalRef && ol(t.modalRef, !1);
    const i = yF(n);
    Tx(n, t.mount, t.modalRef, i, !0);
    const a = ff(this.containers, (l) => l.container === n);
    return a !== -1 ? (this.containers[a].modals.push(t), r) : (this.containers.push({
      modals: [t],
      container: n,
      restore: null,
      hiddenSiblings: i
    }), r);
  }
  mount(t, n) {
    const r = ff(this.containers, (a) => a.modals.includes(t)), i = this.containers[r];
    i.restore || (i.restore = gF(i, n));
  }
  remove(t, n = !0) {
    const r = this.modals.indexOf(t);
    if (r === -1)
      return r;
    const i = ff(this.containers, (l) => l.modals.includes(t)), a = this.containers[i];
    if (a.modals.splice(a.modals.indexOf(t), 1), this.modals.splice(r, 1), a.modals.length === 0)
      a.restore && a.restore(), t.modalRef && ol(t.modalRef, n), Tx(a.container, t.mount, t.modalRef, a.hiddenSiblings, !1), this.containers.splice(i, 1);
    else {
      const l = a.modals[a.modals.length - 1];
      l.modalRef && ol(l.modalRef, !1);
    }
    return r;
  }
  isTopModal(t) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === t;
  }
}
const vF = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function xF(e) {
  const t = parseInt(e.getAttribute("tabindex") || "", 10);
  return Number.isNaN(t) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : t;
}
function wF(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const t = (r) => e.ownerDocument.querySelector(`input[type="radio"]${r}`);
  let n = t(`[name="${e.name}"]:checked`);
  return n || (n = t(`[name="${e.name}"]`)), n !== e;
}
function CF(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || wF(e));
}
function SF(e) {
  const t = [], n = [];
  return Array.from(e.querySelectorAll(vF)).forEach((r, i) => {
    const a = xF(r);
    a === -1 || !CF(r) || (a === 0 ? t.push(r) : n.push({
      documentOrder: i,
      tabIndex: a,
      node: r
    }));
  }), n.sort((r, i) => r.tabIndex === i.tabIndex ? r.documentOrder - i.documentOrder : r.tabIndex - i.tabIndex).map((r) => r.node).concat(t);
}
function OF() {
  return !0;
}
function bl(e) {
  const {
    children: t,
    disableAutoFocus: n = !1,
    disableEnforceFocus: r = !1,
    disableRestoreFocus: i = !1,
    getTabbable: a = SF,
    isEnabled: l = OF,
    open: u
  } = e, d = w.useRef(!1), p = w.useRef(null), m = w.useRef(null), h = w.useRef(null), g = w.useRef(null), v = w.useRef(!1), b = w.useRef(null), y = It(us(t), b), S = w.useRef(null);
  w.useEffect(() => {
    !u || !b.current || (v.current = !n);
  }, [n, u]), w.useEffect(() => {
    if (!u || !b.current)
      return;
    const k = Qn(b.current);
    return b.current.contains(k.activeElement) || (b.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), b.current.setAttribute("tabIndex", "-1")), v.current && b.current.focus()), () => {
      i || (h.current && h.current.focus && (d.current = !0, h.current.focus()), h.current = null);
    };
  }, [u]), w.useEffect(() => {
    if (!u || !b.current)
      return;
    const k = Qn(b.current), R = (_) => {
      S.current = _, !(r || !l() || _.key !== "Tab") && k.activeElement === b.current && _.shiftKey && (d.current = !0, m.current && m.current.focus());
    }, E = () => {
      var F, T;
      const _ = b.current;
      if (_ === null)
        return;
      if (!k.hasFocus() || !l() || d.current) {
        d.current = !1;
        return;
      }
      if (_.contains(k.activeElement) || r && k.activeElement !== p.current && k.activeElement !== m.current)
        return;
      if (k.activeElement !== g.current)
        g.current = null;
      else if (g.current !== null)
        return;
      if (!v.current)
        return;
      let I = [];
      if ((k.activeElement === p.current || k.activeElement === m.current) && (I = a(b.current)), I.length > 0) {
        const $ = !!((F = S.current) != null && F.shiftKey && ((T = S.current) == null ? void 0 : T.key) === "Tab"), N = I[0], W = I[I.length - 1];
        typeof N != "string" && typeof W != "string" && ($ ? W.focus() : N.focus());
      } else
        _.focus();
    };
    k.addEventListener("focusin", E), k.addEventListener("keydown", R, !0);
    const M = setInterval(() => {
      k.activeElement && k.activeElement.tagName === "BODY" && E();
    }, 50);
    return () => {
      clearInterval(M), k.removeEventListener("focusin", E), k.removeEventListener("keydown", R, !0);
    };
  }, [n, r, i, l, u, a]);
  const O = (k) => {
    h.current === null && (h.current = k.relatedTarget), v.current = !0, g.current = k.target;
    const R = t.props.onFocus;
    R && R(k);
  }, P = (k) => {
    h.current === null && (h.current = k.relatedTarget), v.current = !0;
  };
  return /* @__PURE__ */ x.jsxs(w.Fragment, {
    children: [/* @__PURE__ */ x.jsx("div", {
      tabIndex: u ? 0 : -1,
      onFocus: P,
      ref: p,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ w.cloneElement(t, {
      ref: y,
      onFocus: O
    }), /* @__PURE__ */ x.jsx("div", {
      tabIndex: u ? 0 : -1,
      onFocus: P,
      ref: m,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (bl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: cs,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: o.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: o.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: o.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: o.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: o.func,
  /**
   * If `true`, focus is locked.
   */
  open: o.bool.isRequired
});
process.env.NODE_ENV !== "production" && (bl.propTypes = sd(bl.propTypes));
function TF(e) {
  return typeof e == "function" ? e() : e;
}
function EF(e) {
  return e ? e.props.hasOwnProperty("in") : !1;
}
const Ex = () => {
}, Yc = new bF();
function RF(e) {
  const {
    container: t,
    disableEscapeKeyDown: n = !1,
    disableScrollLock: r = !1,
    closeAfterTransition: i = !1,
    onTransitionEnter: a,
    onTransitionExited: l,
    children: u,
    onClose: d,
    open: p,
    rootRef: m
  } = e, h = w.useRef({}), g = w.useRef(null), v = w.useRef(null), b = It(v, m), [y, S] = w.useState(!p), O = EF(u);
  let P = !0;
  (e["aria-hidden"] === "false" || e["aria-hidden"] === !1) && (P = !1);
  const k = () => Qn(g.current), R = () => (h.current.modalRef = v.current, h.current.mount = g.current, h.current), E = () => {
    Yc.mount(R(), {
      disableScrollLock: r
    }), v.current && (v.current.scrollTop = 0);
  }, M = Le(() => {
    const V = TF(t) || k().body;
    Yc.add(R(), V), v.current && E();
  }), _ = () => Yc.isTopModal(R()), I = Le((V) => {
    g.current = V, V && (p && _() ? E() : v.current && ol(v.current, P));
  }), F = w.useCallback(() => {
    Yc.remove(R(), P);
  }, [P]);
  w.useEffect(() => () => {
    F();
  }, [F]), w.useEffect(() => {
    p ? M() : (!O || !i) && F();
  }, [p, F, O, i, M]);
  const T = (V) => (z) => {
    var X;
    (X = V.onKeyDown) == null || X.call(V, z), !(z.key !== "Escape" || z.which === 229 || // Wait until IME is settled.
    !_()) && (n || (z.stopPropagation(), d && d(z, "escapeKeyDown")));
  }, $ = (V) => (z) => {
    var X;
    (X = V.onClick) == null || X.call(V, z), z.target === z.currentTarget && d && d(z, "backdropClick");
  };
  return {
    getRootProps: (V = {}) => {
      const z = F1(e);
      delete z.onTransitionEnter, delete z.onTransitionExited;
      const X = {
        ...z,
        ...V
      };
      return {
        /*
         * Marking an element with the role presentation indicates to assistive technology
         * that this element should be ignored; it exists to support the web application and
         * is not meant for humans to interact with directly.
         * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
         */
        role: "presentation",
        ...X,
        onKeyDown: T(X),
        ref: b
      };
    },
    getBackdropProps: (V = {}) => {
      const z = V;
      return {
        "aria-hidden": !0,
        ...z,
        onClick: $(z),
        open: p
      };
    },
    getTransitionProps: () => {
      const V = () => {
        S(!1), a && a();
      }, z = () => {
        S(!0), l && l(), i && F();
      };
      return {
        onEnter: Dm(V, (u == null ? void 0 : u.props.onEnter) ?? Ex),
        onExited: Dm(z, (u == null ? void 0 : u.props.onExited) ?? Ex)
      };
    },
    rootRef: b,
    portalRef: I,
    isTopModal: _,
    exited: y,
    hasTransition: O
  };
}
function kF(e) {
  return ze("MuiModal", e);
}
Ve("MuiModal", ["root", "hidden", "backdrop"]);
const PF = (e) => {
  const {
    open: t,
    exited: n,
    classes: r
  } = e;
  return We({
    root: ["root", !t && n && "hidden"],
    backdrop: ["backdrop"]
  }, kF, r);
}, DF = ae("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.open && n.exited && t.hidden];
  }
})(ct(({
  theme: e
}) => ({
  position: "fixed",
  zIndex: (e.vars || e).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  variants: [{
    props: ({
      ownerState: t
    }) => !t.open && t.exited,
    style: {
      visibility: "hidden"
    }
  }]
}))), MF = ae(Ih, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (e, t) => t.backdrop
})({
  zIndex: -1
}), Ah = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    name: "MuiModal",
    props: t
  }), {
    BackdropComponent: i = MF,
    BackdropProps: a,
    classes: l,
    className: u,
    closeAfterTransition: d = !1,
    children: p,
    container: m,
    component: h,
    components: g = {},
    componentsProps: v = {},
    disableAutoFocus: b = !1,
    disableEnforceFocus: y = !1,
    disableEscapeKeyDown: S = !1,
    disablePortal: O = !1,
    disableRestoreFocus: P = !1,
    disableScrollLock: k = !1,
    hideBackdrop: R = !1,
    keepMounted: E = !1,
    onBackdropClick: M,
    onClose: _,
    onTransitionEnter: I,
    onTransitionExited: F,
    open: T,
    slotProps: $ = {},
    slots: N = {},
    // eslint-disable-next-line react/prop-types
    theme: W,
    ...L
  } = r, V = {
    ...r,
    closeAfterTransition: d,
    disableAutoFocus: b,
    disableEnforceFocus: y,
    disableEscapeKeyDown: S,
    disablePortal: O,
    disableRestoreFocus: P,
    disableScrollLock: k,
    hideBackdrop: R,
    keepMounted: E
  }, {
    getRootProps: z,
    getBackdropProps: X,
    getTransitionProps: le,
    portalRef: ne,
    isTopModal: G,
    exited: Q,
    hasTransition: be
  } = RF({
    ...V,
    rootRef: n
  }), we = {
    ...V,
    exited: Q
  }, se = PF(we), U = {};
  if (p.props.tabIndex === void 0 && (U.tabIndex = "-1"), be) {
    const {
      onEnter: B,
      onExited: ee
    } = le();
    U.onEnter = B, U.onExited = ee;
  }
  const de = {
    ...L,
    slots: {
      root: g.Root,
      backdrop: g.Backdrop,
      ...N
    },
    slotProps: {
      ...v,
      ...$
    }
  }, [ce, K] = fn("root", {
    elementType: DF,
    externalForwardedProps: de,
    getSlotProps: z,
    additionalProps: {
      ref: n,
      as: h
    },
    ownerState: we,
    className: Me(u, se == null ? void 0 : se.root, !we.open && we.exited && (se == null ? void 0 : se.hidden))
  }), [Z, ue] = fn("backdrop", {
    elementType: i,
    externalForwardedProps: de,
    additionalProps: a,
    getSlotProps: (B) => X({
      ...B,
      onClick: (ee) => {
        M && M(ee), B != null && B.onClick && B.onClick(ee);
      }
    }),
    className: Me(a == null ? void 0 : a.className, se == null ? void 0 : se.backdrop),
    ownerState: we
  }), he = It(a == null ? void 0 : a.ref, ue.ref);
  return !E && !T && (!be || Q) ? null : /* @__PURE__ */ x.jsx(gl, {
    ref: ne,
    container: m,
    disablePortal: O,
    children: /* @__PURE__ */ x.jsxs(ce, {
      ...K,
      children: [!R && i ? /* @__PURE__ */ x.jsx(Z, {
        ...ue,
        ref: he
      }) : null, /* @__PURE__ */ x.jsx(bl, {
        disableEnforceFocus: y,
        disableAutoFocus: b,
        disableRestoreFocus: P,
        isEnabled: G,
        open: T,
        children: /* @__PURE__ */ w.cloneElement(p, U)
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (Ah.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: o.elementType,
  /**
   * Props applied to the [`Backdrop`](https://mui.com/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: o.object,
  /**
   * A single child content element.
   */
  children: cs.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: o.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: o.shape({
    Backdrop: o.elementType,
    Root: o.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: o.shape({
    backdrop: o.oneOfType([o.func, o.object]),
    root: o.oneOfType([o.func, o.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: o.oneOfType([ei, o.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: o.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: o.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: o.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: o.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: o.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: o.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: o.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: o.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: o.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: o.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: o.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: o.func,
  /**
   * If `true`, the component is shown.
   */
  open: o.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: o.shape({
    backdrop: o.oneOfType([o.func, o.object]),
    root: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: o.shape({
    backdrop: o.elementType,
    root: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
function _F(e) {
  return ze("MuiDialog", e);
}
const il = Ve("MuiDialog", ["root", "scrollPaper", "scrollBody", "container", "paper", "paperScrollPaper", "paperScrollBody", "paperWidthFalse", "paperWidthXs", "paperWidthSm", "paperWidthMd", "paperWidthLg", "paperWidthXl", "paperFullWidth", "paperFullScreen"]), Nh = /* @__PURE__ */ w.createContext({});
process.env.NODE_ENV !== "production" && (Nh.displayName = "DialogContext");
const IF = ae(Ih, {
  name: "MuiDialog",
  slot: "Backdrop",
  overrides: (e, t) => t.backdrop
})({
  // Improve scrollable dialog support.
  zIndex: -1
}), jF = (e) => {
  const {
    classes: t,
    scroll: n,
    maxWidth: r,
    fullWidth: i,
    fullScreen: a
  } = e, l = {
    root: ["root"],
    container: ["container", `scroll${ke(n)}`],
    paper: ["paper", `paperScroll${ke(n)}`, `paperWidth${ke(String(r))}`, i && "paperFullWidth", a && "paperFullScreen"]
  };
  return We(l, _F, t);
}, $F = ae(Ah, {
  name: "MuiDialog",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  "@media print": {
    // Use !important to override the Modal inline-style.
    position: "absolute !important"
  }
}), AF = ae("div", {
  name: "MuiDialog",
  slot: "Container",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.container, t[`scroll${ke(n.scroll)}`]];
  }
})({
  height: "100%",
  "@media print": {
    height: "auto"
  },
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  variants: [{
    props: {
      scroll: "paper"
    },
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  }, {
    props: {
      scroll: "body"
    },
    style: {
      overflowY: "auto",
      overflowX: "hidden",
      textAlign: "center",
      "&::after": {
        content: '""',
        display: "inline-block",
        verticalAlign: "middle",
        height: "100%",
        width: "0"
      }
    }
  }]
}), NF = ae($i, {
  name: "MuiDialog",
  slot: "Paper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.paper, t[`scrollPaper${ke(n.scroll)}`], t[`paperWidth${ke(String(n.maxWidth))}`], n.fullWidth && t.paperFullWidth, n.fullScreen && t.paperFullScreen];
  }
})(ct(({
  theme: e
}) => ({
  margin: 32,
  position: "relative",
  overflowY: "auto",
  "@media print": {
    overflowY: "visible",
    boxShadow: "none"
  },
  variants: [{
    props: {
      scroll: "paper"
    },
    style: {
      display: "flex",
      flexDirection: "column",
      maxHeight: "calc(100% - 64px)"
    }
  }, {
    props: {
      scroll: "body"
    },
    style: {
      display: "inline-block",
      verticalAlign: "middle",
      textAlign: "initial"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.maxWidth,
    style: {
      maxWidth: "calc(100% - 64px)"
    }
  }, {
    props: {
      maxWidth: "xs"
    },
    style: {
      maxWidth: e.breakpoints.unit === "px" ? Math.max(e.breakpoints.values.xs, 444) : `max(${e.breakpoints.values.xs}${e.breakpoints.unit}, 444px)`,
      [`&.${il.paperScrollBody}`]: {
        [e.breakpoints.down(Math.max(e.breakpoints.values.xs, 444) + 32 * 2)]: {
          maxWidth: "calc(100% - 64px)"
        }
      }
    }
  }, ...Object.keys(e.breakpoints.values).filter((t) => t !== "xs").map((t) => ({
    props: {
      maxWidth: t
    },
    style: {
      maxWidth: `${e.breakpoints.values[t]}${e.breakpoints.unit}`,
      [`&.${il.paperScrollBody}`]: {
        [e.breakpoints.down(e.breakpoints.values[t] + 32 * 2)]: {
          maxWidth: "calc(100% - 64px)"
        }
      }
    }
  })), {
    props: ({
      ownerState: t
    }) => t.fullWidth,
    style: {
      width: "calc(100% - 64px)"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.fullScreen,
    style: {
      margin: 0,
      width: "100%",
      maxWidth: "100%",
      height: "100%",
      maxHeight: "none",
      borderRadius: 0,
      [`&.${il.paperScrollBody}`]: {
        margin: 0,
        maxWidth: "100%"
      }
    }
  }]
}))), fs = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiDialog"
  }), i = ir(), a = {
    enter: i.transitions.duration.enteringScreen,
    exit: i.transitions.duration.leavingScreen
  }, {
    "aria-describedby": l,
    "aria-labelledby": u,
    "aria-modal": d = !0,
    BackdropComponent: p,
    BackdropProps: m,
    children: h,
    className: g,
    disableEscapeKeyDown: v = !1,
    fullScreen: b = !1,
    fullWidth: y = !1,
    maxWidth: S = "sm",
    onBackdropClick: O,
    onClick: P,
    onClose: k,
    open: R,
    PaperComponent: E = $i,
    PaperProps: M = {},
    scroll: _ = "paper",
    slots: I = {},
    slotProps: F = {},
    TransitionComponent: T = _i,
    transitionDuration: $ = a,
    TransitionProps: N,
    ...W
  } = r, L = {
    ...r,
    disableEscapeKeyDown: v,
    fullScreen: b,
    fullWidth: y,
    maxWidth: S,
    scroll: _
  }, V = jF(L), z = w.useRef(), X = (ie) => {
    z.current = ie.target === ie.currentTarget;
  }, le = (ie) => {
    P && P(ie), z.current && (z.current = null, O && O(ie), k && k(ie, "backdropClick"));
  }, ne = Ir(u), G = w.useMemo(() => ({
    titleId: ne
  }), [ne]), Q = {
    transition: T,
    ...I
  }, be = {
    transition: N,
    paper: M,
    backdrop: m,
    ...F
  }, we = {
    slots: Q,
    slotProps: be
  }, [se, U] = fn("root", {
    elementType: $F,
    shouldForwardComponentProp: !0,
    externalForwardedProps: we,
    ownerState: L,
    className: Me(V.root, g),
    ref: n
  }), [de, ce] = fn("backdrop", {
    elementType: IF,
    shouldForwardComponentProp: !0,
    externalForwardedProps: we,
    ownerState: L
  }), [K, Z] = fn("paper", {
    elementType: NF,
    shouldForwardComponentProp: !0,
    externalForwardedProps: we,
    ownerState: L,
    className: Me(V.paper, M.className)
  }), [ue, he] = fn("container", {
    elementType: AF,
    externalForwardedProps: we,
    ownerState: L,
    className: Me(V.container)
  }), [B, ee] = fn("transition", {
    elementType: _i,
    externalForwardedProps: we,
    ownerState: L,
    additionalProps: {
      appear: !0,
      in: R,
      timeout: $,
      role: "presentation"
    }
  });
  return /* @__PURE__ */ x.jsx(se, {
    closeAfterTransition: !0,
    slots: {
      backdrop: de
    },
    slotProps: {
      backdrop: {
        transitionDuration: $,
        as: p,
        ...ce
      }
    },
    disableEscapeKeyDown: v,
    onClose: k,
    open: R,
    onClick: le,
    ...U,
    ...W,
    children: /* @__PURE__ */ x.jsx(B, {
      ...ee,
      children: /* @__PURE__ */ x.jsx(ue, {
        onMouseDown: X,
        ...he,
        children: /* @__PURE__ */ x.jsx(K, {
          as: E,
          elevation: 24,
          role: "dialog",
          "aria-describedby": l,
          "aria-labelledby": ne,
          "aria-modal": d,
          ...Z,
          children: /* @__PURE__ */ x.jsx(Nh.Provider, {
            value: G,
            children: h
          })
        })
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (fs.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The id(s) of the element(s) that describe the dialog.
   */
  "aria-describedby": o.string,
  /**
   * The id(s) of the element(s) that label the dialog.
   */
  "aria-labelledby": o.string,
  /**
   * Informs assistive technologies that the element is modal.
   * It's added on the element with role="dialog".
   * @default true
   */
  "aria-modal": o.oneOfType([o.oneOf(["false", "true"]), o.bool]),
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: o.elementType,
  /**
   * @ignore
   */
  BackdropProps: o.object,
  /**
   * Dialog children, usually the included sub-components.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: o.bool,
  /**
   * If `true`, the dialog is full-screen.
   * @default false
   */
  fullScreen: o.bool,
  /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   * @default false
   */
  fullWidth: o.bool,
  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'sm'
   */
  maxWidth: o.oneOfType([o.oneOf(["xs", "sm", "md", "lg", "xl", !1]), o.string]),
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: o.func,
  /**
   * @ignore
   */
  onClick: o.func,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: o.func,
  /**
   * If `true`, the component is shown.
   */
  open: o.bool.isRequired,
  /**
   * The component used to render the body of the dialog.
   * @default Paper
   */
  PaperComponent: o.elementType,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   * @default {}
   * @deprecated Use `slotProps.paper` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PaperProps: o.object,
  /**
   * Determine the container for scrolling the dialog.
   * @default 'paper'
   */
  scroll: o.oneOf(["body", "paper"]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: o.shape({
    backdrop: o.oneOfType([o.func, o.object]),
    container: o.oneOfType([o.func, o.object]),
    paper: o.oneOfType([o.func, o.object]),
    root: o.oneOfType([o.func, o.object]),
    transition: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: o.shape({
    backdrop: o.elementType,
    container: o.elementType,
    paper: o.elementType,
    root: o.elementType,
    transition: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: o.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: o.oneOfType([o.number, o.shape({
    appear: o.number,
    enter: o.number,
    exit: o.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionProps: o.object
});
function FF(e) {
  return ze("MuiDialogActions", e);
}
Ve("MuiDialogActions", ["root", "spacing"]);
const LF = (e) => {
  const {
    classes: t,
    disableSpacing: n
  } = e;
  return We({
    root: ["root", !n && "spacing"]
  }, FF, t);
}, BF = ae("div", {
  name: "MuiDialogActions",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disableSpacing && t.spacing];
  }
})({
  display: "flex",
  alignItems: "center",
  padding: 8,
  justifyContent: "flex-end",
  flex: "0 0 auto",
  variants: [{
    props: ({
      ownerState: e
    }) => !e.disableSpacing,
    style: {
      "& > :not(style) ~ :not(style)": {
        marginLeft: 8
      }
    }
  }]
}), Ri = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiDialogActions"
  }), {
    className: i,
    disableSpacing: a = !1,
    ...l
  } = r, u = {
    ...r,
    disableSpacing: a
  }, d = LF(u);
  return /* @__PURE__ */ x.jsx(BF, {
    className: Me(d.root, i),
    ownerState: u,
    ref: n,
    ...l
  });
});
process.env.NODE_ENV !== "production" && (Ri.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: o.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
function VF(e) {
  return ze("MuiDialogContent", e);
}
Ve("MuiDialogContent", ["root", "dividers"]);
function zF(e) {
  return ze("MuiDialogTitle", e);
}
const WF = Ve("MuiDialogTitle", ["root"]), qF = (e) => {
  const {
    classes: t,
    dividers: n
  } = e;
  return We({
    root: ["root", n && "dividers"]
  }, VF, t);
}, HF = ae("div", {
  name: "MuiDialogContent",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.dividers && t.dividers];
  }
})(ct(({
  theme: e
}) => ({
  flex: "1 1 auto",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  overflowY: "auto",
  padding: "20px 24px",
  variants: [{
    props: ({
      ownerState: t
    }) => t.dividers,
    style: {
      padding: "16px 24px",
      borderTop: `1px solid ${(e.vars || e).palette.divider}`,
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.dividers,
    style: {
      [`.${WF.root} + &`]: {
        paddingTop: 0
      }
    }
  }]
}))), Fh = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiDialogContent"
  }), {
    className: i,
    dividers: a = !1,
    ...l
  } = r, u = {
    ...r,
    dividers: a
  }, d = qF(u);
  return /* @__PURE__ */ x.jsx(HF, {
    className: Me(d.root, i),
    ownerState: u,
    ref: n,
    ...l
  });
});
process.env.NODE_ENV !== "production" && (Fh.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * Display the top and bottom dividers.
   * @default false
   */
  dividers: o.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
const UF = (e) => {
  const {
    classes: t
  } = e;
  return We({
    root: ["root"]
  }, zF, t);
}, YF = ae(at, {
  name: "MuiDialogTitle",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  padding: "16px 24px",
  flex: "0 0 auto"
}), rs = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiDialogTitle"
  }), {
    className: i,
    id: a,
    ...l
  } = r, u = r, d = UF(u), {
    titleId: p = a
  } = w.useContext(Nh);
  return /* @__PURE__ */ x.jsx(YF, {
    component: "h2",
    className: Me(d.root, i),
    ownerState: u,
    ref: n,
    variant: "h6",
    id: a ?? p,
    ...l
  });
});
process.env.NODE_ENV !== "production" && (rs.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * @ignore
   */
  id: o.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
function GF(e) {
  return ze("MuiDivider", e);
}
const Rx = Ve("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), KF = (e) => {
  const {
    absolute: t,
    children: n,
    classes: r,
    flexItem: i,
    light: a,
    orientation: l,
    textAlign: u,
    variant: d
  } = e;
  return We({
    root: ["root", t && "absolute", d, a && "light", l === "vertical" && "vertical", i && "flexItem", n && "withChildren", n && l === "vertical" && "withChildrenVertical", u === "right" && l !== "vertical" && "textAlignRight", u === "left" && l !== "vertical" && "textAlignLeft"],
    wrapper: ["wrapper", l === "vertical" && "wrapperVertical"]
  }, GF, r);
}, XF = ae("div", {
  name: "MuiDivider",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.absolute && t.absolute, t[n.variant], n.light && t.light, n.orientation === "vertical" && t.vertical, n.flexItem && t.flexItem, n.children && t.withChildren, n.children && n.orientation === "vertical" && t.withChildrenVertical, n.textAlign === "right" && n.orientation !== "vertical" && t.textAlignRight, n.textAlign === "left" && n.orientation !== "vertical" && t.textAlignLeft];
  }
})(ct(({
  theme: e
}) => ({
  margin: 0,
  // Reset browser default style.
  flexShrink: 0,
  borderWidth: 0,
  borderStyle: "solid",
  borderColor: (e.vars || e).palette.divider,
  borderBottomWidth: "thin",
  variants: [{
    props: {
      absolute: !0
    },
    style: {
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "100%"
    }
  }, {
    props: {
      light: !0
    },
    style: {
      borderColor: e.vars ? `rgba(${e.vars.palette.dividerChannel} / 0.08)` : mt(e.palette.divider, 0.08)
    }
  }, {
    props: {
      variant: "inset"
    },
    style: {
      marginLeft: 72
    }
  }, {
    props: {
      variant: "middle",
      orientation: "horizontal"
    },
    style: {
      marginLeft: e.spacing(2),
      marginRight: e.spacing(2)
    }
  }, {
    props: {
      variant: "middle",
      orientation: "vertical"
    },
    style: {
      marginTop: e.spacing(1),
      marginBottom: e.spacing(1)
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      height: "100%",
      borderBottomWidth: 0,
      borderRightWidth: "thin"
    }
  }, {
    props: {
      flexItem: !0
    },
    style: {
      alignSelf: "stretch",
      height: "auto"
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.children,
    style: {
      display: "flex",
      textAlign: "center",
      border: 0,
      borderTopStyle: "solid",
      borderLeftStyle: "solid",
      "&::before, &::after": {
        content: '""',
        alignSelf: "center"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.children && t.orientation !== "vertical",
    style: {
      "&::before, &::after": {
        width: "100%",
        borderTop: `thin solid ${(e.vars || e).palette.divider}`,
        borderTopStyle: "inherit"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.orientation === "vertical" && t.children,
    style: {
      flexDirection: "column",
      "&::before, &::after": {
        height: "100%",
        borderLeft: `thin solid ${(e.vars || e).palette.divider}`,
        borderLeftStyle: "inherit"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.textAlign === "right" && t.orientation !== "vertical",
    style: {
      "&::before": {
        width: "90%"
      },
      "&::after": {
        width: "10%"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.textAlign === "left" && t.orientation !== "vertical",
    style: {
      "&::before": {
        width: "10%"
      },
      "&::after": {
        width: "90%"
      }
    }
  }]
}))), QF = ae("span", {
  name: "MuiDivider",
  slot: "Wrapper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.wrapper, n.orientation === "vertical" && t.wrapperVertical];
  }
})(ct(({
  theme: e
}) => ({
  display: "inline-block",
  paddingLeft: `calc(${e.spacing(1)} * 1.2)`,
  paddingRight: `calc(${e.spacing(1)} * 1.2)`,
  whiteSpace: "nowrap",
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      paddingTop: `calc(${e.spacing(1)} * 1.2)`,
      paddingBottom: `calc(${e.spacing(1)} * 1.2)`
    }
  }]
}))), vl = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiDivider"
  }), {
    absolute: i = !1,
    children: a,
    className: l,
    orientation: u = "horizontal",
    component: d = a || u === "vertical" ? "div" : "hr",
    flexItem: p = !1,
    light: m = !1,
    role: h = d !== "hr" ? "separator" : void 0,
    textAlign: g = "center",
    variant: v = "fullWidth",
    ...b
  } = r, y = {
    ...r,
    absolute: i,
    component: d,
    flexItem: p,
    light: m,
    orientation: u,
    role: h,
    textAlign: g,
    variant: v
  }, S = KF(y);
  return /* @__PURE__ */ x.jsx(XF, {
    as: d,
    className: Me(S.root, l),
    role: h,
    ref: n,
    ownerState: y,
    "aria-orientation": h === "separator" && (d !== "hr" || u === "vertical") ? u : void 0,
    ...b,
    children: a ? /* @__PURE__ */ x.jsx(QF, {
      className: S.wrapper,
      ownerState: y,
      children: a
    }) : null
  });
});
vl && (vl.muiSkipListHighlight = !0);
process.env.NODE_ENV !== "production" && (vl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Absolutely position the element.
   * @default false
   */
  absolute: o.bool,
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   * @default false
   */
  flexItem: o.bool,
  /**
   * If `true`, the divider will have a lighter color.
   * @default false
   * @deprecated Use <Divider sx={{ opacity: 0.6 }} /> (or any opacity or color) instead. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  light: o.bool,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: o.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  role: o.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The text alignment.
   * @default 'center'
   */
  textAlign: o.oneOf(["center", "left", "right"]),
  /**
   * The variant to use.
   * @default 'fullWidth'
   */
  variant: o.oneOfType([o.oneOf(["fullWidth", "inset", "middle"]), o.string])
});
const ZF = (e) => {
  const {
    classes: t,
    disableUnderline: n,
    startAdornment: r,
    endAdornment: i,
    size: a,
    hiddenLabel: l,
    multiline: u
  } = e, d = {
    root: ["root", !n && "underline", r && "adornedStart", i && "adornedEnd", a === "small" && `size${ke(a)}`, l && "hiddenLabel", u && "multiline"],
    input: ["input"]
  }, p = We(d, P2, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...p
  };
}, JF = ae(bd, {
  shouldForwardProp: (e) => Zn(e) || e === "classes",
  name: "MuiFilledInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [...gd(e, t), !n.disableUnderline && t.underline];
  }
})(ct(({
  theme: e
}) => {
  const t = e.palette.mode === "light", n = t ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", r = t ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", i = t ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", a = t ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return {
    position: "relative",
    backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r,
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.shorter,
      easing: e.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.hoverBg : i,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r
      }
    },
    [`&.${kr.focused}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r
    },
    [`&.${kr.disabled}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.disabledBg : a
    },
    variants: [{
      props: ({
        ownerState: l
      }) => !l.disableUnderline,
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${kr.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${kr.error}`]: {
          "&::before, &::after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})` : n}`,
          left: 0,
          bottom: 0,
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${kr.disabled}, .${kr.error}):before`]: {
          borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`
        },
        [`&.${kr.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, ...Object.entries(e.palette).filter(qn()).map(([l]) => {
      var u;
      return {
        props: {
          disableUnderline: !1,
          color: l
        },
        style: {
          "&::after": {
            borderBottom: `2px solid ${(u = (e.vars || e).palette[l]) == null ? void 0 : u.main}`
          }
        }
      };
    }), {
      props: ({
        ownerState: l
      }) => l.startAdornment,
      style: {
        paddingLeft: 12
      }
    }, {
      props: ({
        ownerState: l
      }) => l.endAdornment,
      style: {
        paddingRight: 12
      }
    }, {
      props: ({
        ownerState: l
      }) => l.multiline,
      style: {
        padding: "25px 12px 8px"
      }
    }, {
      props: ({
        ownerState: l,
        size: u
      }) => l.multiline && u === "small",
      style: {
        paddingTop: 21,
        paddingBottom: 4
      }
    }, {
      props: ({
        ownerState: l
      }) => l.multiline && l.hiddenLabel,
      style: {
        paddingTop: 16,
        paddingBottom: 17
      }
    }, {
      props: ({
        ownerState: l
      }) => l.multiline && l.hiddenLabel && l.size === "small",
      style: {
        paddingTop: 8,
        paddingBottom: 9
      }
    }]
  };
})), eL = ae(vd, {
  name: "MuiFilledInput",
  slot: "Input",
  overridesResolver: yd
})(ct(({
  theme: e
}) => ({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12,
  ...!e.vars && {
    "&:-webkit-autofill": {
      WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
      WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
      caretColor: e.palette.mode === "light" ? null : "#fff",
      borderTopLeftRadius: "inherit",
      borderTopRightRadius: "inherit"
    }
  },
  ...e.vars && {
    "&:-webkit-autofill": {
      borderTopLeftRadius: "inherit",
      borderTopRightRadius: "inherit"
    },
    [e.getColorSchemeSelector("dark")]: {
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 100px #266798 inset",
        WebkitTextFillColor: "#fff",
        caretColor: "#fff"
      }
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      paddingTop: 21,
      paddingBottom: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hiddenLabel,
    style: {
      paddingTop: 16,
      paddingBottom: 17
    }
  }, {
    props: ({
      ownerState: t
    }) => t.startAdornment,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.endAdornment,
    style: {
      paddingRight: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hiddenLabel && t.size === "small",
    style: {
      paddingTop: 8,
      paddingBottom: 9
    }
  }, {
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    }
  }]
}))), Cd = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiFilledInput"
  }), {
    disableUnderline: i = !1,
    components: a = {},
    componentsProps: l,
    fullWidth: u = !1,
    hiddenLabel: d,
    // declare here to prevent spreading to DOM
    inputComponent: p = "input",
    multiline: m = !1,
    slotProps: h,
    slots: g = {},
    type: v = "text",
    ...b
  } = r, y = {
    ...r,
    disableUnderline: i,
    fullWidth: u,
    inputComponent: p,
    multiline: m,
    type: v
  }, S = ZF(r), O = {
    root: {
      ownerState: y
    },
    input: {
      ownerState: y
    }
  }, P = h ?? l ? Bn(O, h ?? l) : O, k = g.root ?? a.Root ?? JF, R = g.input ?? a.Input ?? eL;
  return /* @__PURE__ */ x.jsx(xd, {
    slots: {
      root: k,
      input: R
    },
    slotProps: P,
    fullWidth: u,
    inputComponent: p,
    multiline: m,
    ref: n,
    type: v,
    ...b,
    classes: S
  });
});
process.env.NODE_ENV !== "production" && (Cd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: o.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: o.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: o.oneOfType([o.oneOf(["primary", "secondary"]), o.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: o.shape({
    Input: o.elementType,
    Root: o.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: o.shape({
    input: o.object,
    root: o.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: o.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: o.bool,
  /**
   * If `true`, the input will not have an underline.
   * @default false
   */
  disableUnderline: o.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: o.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: o.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: o.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: o.bool,
  /**
   * The id of the `input` element.
   */
  id: o.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: o.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: o.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: gn,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: o.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: o.oneOfType([o.number, o.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: o.oneOfType([o.number, o.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: o.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: o.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: o.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: o.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: o.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: o.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: o.oneOfType([o.number, o.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: o.shape({
    input: o.object,
    root: o.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: o.shape({
    input: o.elementType,
    root: o.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: o.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: o.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: o.any
});
Cd.muiName = "Input";
function tL(e) {
  return ze("MuiFormControl", e);
}
Ve("MuiFormControl", ["root", "marginNone", "marginNormal", "marginDense", "fullWidth", "disabled"]);
const nL = (e) => {
  const {
    classes: t,
    margin: n,
    fullWidth: r
  } = e, i = {
    root: ["root", n !== "none" && `margin${ke(n)}`, r && "fullWidth"]
  };
  return We(i, tL, t);
}, rL = ae("div", {
  name: "MuiFormControl",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`margin${ke(n.margin)}`], n.fullWidth && t.fullWidth];
  }
})({
  display: "inline-flex",
  flexDirection: "column",
  position: "relative",
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: "top",
  // Fix alignment issue on Safari.
  variants: [{
    props: {
      margin: "normal"
    },
    style: {
      marginTop: 16,
      marginBottom: 8
    }
  }, {
    props: {
      margin: "dense"
    },
    style: {
      marginTop: 8,
      marginBottom: 4
    }
  }, {
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }]
}), sr = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiFormControl"
  }), {
    children: i,
    className: a,
    color: l = "primary",
    component: u = "div",
    disabled: d = !1,
    error: p = !1,
    focused: m,
    fullWidth: h = !1,
    hiddenLabel: g = !1,
    margin: v = "none",
    required: b = !1,
    size: y = "medium",
    variant: S = "outlined",
    ...O
  } = r, P = {
    ...r,
    color: l,
    component: u,
    disabled: d,
    error: p,
    fullWidth: h,
    hiddenLabel: g,
    margin: v,
    required: b,
    size: y,
    variant: S
  }, k = nL(P), [R, E] = w.useState(() => {
    let z = !1;
    return i && w.Children.forEach(i, (X) => {
      if (!Ua(X, ["Input", "Select"]))
        return;
      const le = Ua(X, ["Select"]) ? X.props.input : X;
      le && O2(le.props) && (z = !0);
    }), z;
  }), [M, _] = w.useState(() => {
    let z = !1;
    return i && w.Children.forEach(i, (X) => {
      Ua(X, ["Input", "Select"]) && (Du(X.props, !0) || Du(X.props.inputProps, !0)) && (z = !0);
    }), z;
  }), [I, F] = w.useState(!1);
  d && I && F(!1);
  const T = m !== void 0 && !d ? m : I;
  let $;
  const N = w.useRef(!1);
  process.env.NODE_ENV !== "production" && ($ = () => (N.current && console.error(["MUI: There are multiple `InputBase` components inside a FormControl.", "This creates visual inconsistencies, only use one `InputBase`."].join(`
`)), N.current = !0, () => {
    N.current = !1;
  }));
  const W = w.useCallback(() => {
    _(!0);
  }, []), L = w.useCallback(() => {
    _(!1);
  }, []), V = w.useMemo(() => ({
    adornedStart: R,
    setAdornedStart: E,
    color: l,
    disabled: d,
    error: p,
    filled: M,
    focused: T,
    fullWidth: h,
    hiddenLabel: g,
    size: y,
    onBlur: () => {
      F(!1);
    },
    onFocus: () => {
      F(!0);
    },
    onEmpty: L,
    onFilled: W,
    registerEffect: $,
    required: b,
    variant: S
  }), [R, l, d, p, M, T, h, g, $, L, W, b, y, S]);
  return /* @__PURE__ */ x.jsx(Bl.Provider, {
    value: V,
    children: /* @__PURE__ */ x.jsx(rL, {
      as: u,
      ownerState: P,
      className: Me(k.root, a),
      ref: n,
      ...O,
      children: i
    })
  });
});
process.env.NODE_ENV !== "production" && (sr.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: o.oneOfType([o.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), o.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */
  disabled: o.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: o.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: o.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */
  fullWidth: o.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: o.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: o.oneOf(["dense", "none", "normal"]),
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: o.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: o.oneOfType([o.oneOf(["medium", "small"]), o.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: o.oneOf(["filled", "outlined", "standard"])
});
function oL(e) {
  return ze("MuiFormControlLabel", e);
}
const Js = Ve("MuiFormControlLabel", ["root", "labelPlacementStart", "labelPlacementTop", "labelPlacementBottom", "disabled", "label", "error", "required", "asterisk"]), iL = (e) => {
  const {
    classes: t,
    disabled: n,
    labelPlacement: r,
    error: i,
    required: a
  } = e, l = {
    root: ["root", n && "disabled", `labelPlacement${ke(r)}`, i && "error", a && "required"],
    label: ["label", n && "disabled"],
    asterisk: ["asterisk", i && "error"]
  };
  return We(l, oL, t);
}, aL = ae("label", {
  name: "MuiFormControlLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${Js.label}`]: t.label
    }, t.root, t[`labelPlacement${ke(n.labelPlacement)}`]];
  }
})(ct(({
  theme: e
}) => ({
  display: "inline-flex",
  alignItems: "center",
  cursor: "pointer",
  // For correct alignment with the text.
  verticalAlign: "middle",
  WebkitTapHighlightColor: "transparent",
  marginLeft: -11,
  marginRight: 16,
  // used for row presentation of radio/checkbox
  [`&.${Js.disabled}`]: {
    cursor: "default"
  },
  [`& .${Js.label}`]: {
    [`&.${Js.disabled}`]: {
      color: (e.vars || e).palette.text.disabled
    }
  },
  variants: [{
    props: {
      labelPlacement: "start"
    },
    style: {
      flexDirection: "row-reverse",
      marginRight: -11
    }
  }, {
    props: {
      labelPlacement: "top"
    },
    style: {
      flexDirection: "column-reverse"
    }
  }, {
    props: {
      labelPlacement: "bottom"
    },
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      labelPlacement: t
    }) => t === "start" || t === "top" || t === "bottom",
    style: {
      marginLeft: 16
      // used for row presentation of radio/checkbox
    }
  }]
}))), sL = ae("span", {
  name: "MuiFormControlLabel",
  slot: "Asterisk",
  overridesResolver: (e, t) => t.asterisk
})(ct(({
  theme: e
}) => ({
  [`&.${Js.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}))), Sd = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiFormControlLabel"
  }), {
    checked: i,
    className: a,
    componentsProps: l = {},
    control: u,
    disabled: d,
    disableTypography: p,
    inputRef: m,
    label: h,
    labelPlacement: g = "end",
    name: v,
    onChange: b,
    required: y,
    slots: S = {},
    slotProps: O = {},
    value: P,
    ...k
  } = r, R = ar(), E = d ?? u.props.disabled ?? (R == null ? void 0 : R.disabled), M = y ?? u.props.required, _ = {
    disabled: E,
    required: M
  };
  ["checked", "name", "onChange", "value", "inputRef"].forEach((V) => {
    typeof u.props[V] > "u" && typeof r[V] < "u" && (_[V] = r[V]);
  });
  const I = Fi({
    props: r,
    muiFormControl: R,
    states: ["error"]
  }), F = {
    ...r,
    disabled: E,
    labelPlacement: g,
    required: M,
    error: I.error
  }, T = iL(F), $ = {
    slots: S,
    slotProps: {
      ...l,
      ...O
    }
  }, [N, W] = fn("typography", {
    elementType: at,
    externalForwardedProps: $,
    ownerState: F
  });
  let L = h;
  return L != null && L.type !== at && !p && (L = /* @__PURE__ */ x.jsx(N, {
    component: "span",
    ...W,
    className: Me(T.label, W == null ? void 0 : W.className),
    children: L
  })), /* @__PURE__ */ x.jsxs(aL, {
    className: Me(T.root, a),
    ownerState: F,
    ref: n,
    ...k,
    children: [/* @__PURE__ */ w.cloneElement(u, _), M ? /* @__PURE__ */ x.jsxs("div", {
      children: [L, /* @__PURE__ */ x.jsxs(sL, {
        ownerState: F,
        "aria-hidden": !0,
        className: T.asterisk,
        children: [" ", "*"]
      })]
    }) : L]
  });
});
process.env.NODE_ENV !== "production" && (Sd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component appears selected.
   */
  checked: o.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The props used for each slot inside.
   * @default {}
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  componentsProps: o.shape({
    typography: o.object
  }),
  /**
   * A control element. For instance, it can be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: o.element.isRequired,
  /**
   * If `true`, the control is disabled.
   */
  disabled: o.bool,
  /**
   * If `true`, the label is rendered as it is passed without an additional typography node.
   */
  disableTypography: o.bool,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: gn,
  /**
   * A text or an element to be used in an enclosing label element.
   */
  label: o.node,
  /**
   * The position of the label.
   * @default 'end'
   */
  labelPlacement: o.oneOf(["bottom", "end", "start", "top"]),
  /**
   * @ignore
   */
  name: o.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: o.func,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: o.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: o.shape({
    typography: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: o.shape({
    typography: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The value of the component.
   */
  value: o.any
});
function lL(e) {
  return ze("MuiFormGroup", e);
}
Ve("MuiFormGroup", ["root", "row", "error"]);
const cL = (e) => {
  const {
    classes: t,
    row: n,
    error: r
  } = e;
  return We({
    root: ["root", n && "row", r && "error"]
  }, lL, t);
}, uL = ae("div", {
  name: "MuiFormGroup",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.row && t.row];
  }
})({
  display: "flex",
  flexDirection: "column",
  flexWrap: "wrap",
  variants: [{
    props: {
      row: !0
    },
    style: {
      flexDirection: "row"
    }
  }]
}), Lh = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiFormGroup"
  }), {
    className: i,
    row: a = !1,
    ...l
  } = r, u = ar(), d = Fi({
    props: r,
    muiFormControl: u,
    states: ["error"]
  }), p = {
    ...r,
    row: a,
    error: d.error
  }, m = cL(p);
  return /* @__PURE__ */ x.jsx(uL, {
    className: Me(m.root, i),
    ownerState: p,
    ref: n,
    ...l
  });
});
process.env.NODE_ENV !== "production" && (Lh.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * Display group of elements in a compact row.
   * @default false
   */
  row: o.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
function dL(e) {
  return ze("MuiFormHelperText", e);
}
const kx = Ve("MuiFormHelperText", ["root", "error", "disabled", "sizeSmall", "sizeMedium", "contained", "focused", "filled", "required"]);
var Px;
const pL = (e) => {
  const {
    classes: t,
    contained: n,
    size: r,
    disabled: i,
    error: a,
    filled: l,
    focused: u,
    required: d
  } = e, p = {
    root: ["root", i && "disabled", a && "error", r && `size${ke(r)}`, n && "contained", u && "focused", l && "filled", d && "required"]
  };
  return We(p, dL, t);
}, fL = ae("p", {
  name: "MuiFormHelperText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.size && t[`size${ke(n.size)}`], n.contained && t.contained, n.filled && t.filled];
  }
})(ct(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  ...e.typography.caption,
  textAlign: "left",
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${kx.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${kx.error}`]: {
    color: (e.vars || e).palette.error.main
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginTop: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => t.contained,
    style: {
      marginLeft: 14,
      marginRight: 14
    }
  }]
}))), Bh = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiFormHelperText"
  }), {
    children: i,
    className: a,
    component: l = "p",
    disabled: u,
    error: d,
    filled: p,
    focused: m,
    margin: h,
    required: g,
    variant: v,
    ...b
  } = r, y = ar(), S = Fi({
    props: r,
    muiFormControl: y,
    states: ["variant", "size", "disabled", "error", "filled", "focused", "required"]
  }), O = {
    ...r,
    component: l,
    contained: S.variant === "filled" || S.variant === "outlined",
    variant: S.variant,
    size: S.size,
    disabled: S.disabled,
    error: S.error,
    filled: S.filled,
    focused: S.focused,
    required: S.required
  };
  delete O.ownerState;
  const P = pL(O);
  return /* @__PURE__ */ x.jsx(fL, {
    as: l,
    className: Me(P.root, a),
    ref: n,
    ...b,
    ownerState: O,
    children: i === " " ? (
      // notranslate needed while Google Translate will not fix zero-width space issue
      Px || (Px = /* @__PURE__ */ x.jsx("span", {
        className: "notranslate",
        "aria-hidden": !0,
        children: "​"
      }))
    ) : i
  });
});
process.env.NODE_ENV !== "production" && (Bh.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: o.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: o.bool,
  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: o.bool,
  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: o.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: o.oneOf(["dense"]),
  /**
   * If `true`, the helper text should use required classes key.
   */
  required: o.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The variant to use.
   */
  variant: o.oneOfType([o.oneOf(["filled", "outlined", "standard"]), o.string])
});
function mL(e) {
  return ze("MuiFormLabel", e);
}
const al = Ve("MuiFormLabel", ["root", "colorSecondary", "focused", "disabled", "error", "filled", "required", "asterisk"]), hL = (e) => {
  const {
    classes: t,
    color: n,
    focused: r,
    disabled: i,
    error: a,
    filled: l,
    required: u
  } = e, d = {
    root: ["root", `color${ke(n)}`, i && "disabled", a && "error", l && "filled", r && "focused", u && "required"],
    asterisk: ["asterisk", a && "error"]
  };
  return We(d, mL, t);
}, gL = ae("label", {
  name: "MuiFormLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color === "secondary" && t.colorSecondary, n.filled && t.filled];
  }
})(ct(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  ...e.typography.body1,
  lineHeight: "1.4375em",
  padding: 0,
  position: "relative",
  variants: [...Object.entries(e.palette).filter(qn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${al.focused}`]: {
        color: (e.vars || e).palette[t].main
      }
    }
  })), {
    props: {},
    style: {
      [`&.${al.disabled}`]: {
        color: (e.vars || e).palette.text.disabled
      },
      [`&.${al.error}`]: {
        color: (e.vars || e).palette.error.main
      }
    }
  }]
}))), yL = ae("span", {
  name: "MuiFormLabel",
  slot: "Asterisk",
  overridesResolver: (e, t) => t.asterisk
})(ct(({
  theme: e
}) => ({
  [`&.${al.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}))), jr = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiFormLabel"
  }), {
    children: i,
    className: a,
    color: l,
    component: u = "label",
    disabled: d,
    error: p,
    filled: m,
    focused: h,
    required: g,
    ...v
  } = r, b = ar(), y = Fi({
    props: r,
    muiFormControl: b,
    states: ["color", "required", "focused", "disabled", "error", "filled"]
  }), S = {
    ...r,
    color: y.color || "primary",
    component: u,
    disabled: y.disabled,
    error: y.error,
    filled: y.filled,
    focused: y.focused,
    required: y.required
  }, O = hL(S);
  return /* @__PURE__ */ x.jsxs(gL, {
    as: u,
    ownerState: S,
    className: Me(O.root, a),
    ref: n,
    ...v,
    children: [i, y.required && /* @__PURE__ */ x.jsxs(yL, {
      ownerState: S,
      "aria-hidden": !0,
      className: O.asterisk,
      children: [" ", "*"]
    })]
  });
});
process.env.NODE_ENV !== "production" && (jr.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: o.oneOfType([o.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), o.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: o.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: o.bool,
  /**
   * If `true`, the label should use filled classes key.
   */
  filled: o.bool,
  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: o.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: o.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
const Xn = u$({
  createStyledComponent: ae("div", {
    name: "MuiGrid2",
    slot: "Root",
    overridesResolver: (e, t) => {
      const {
        ownerState: n
      } = e;
      return [t.root, n.container && t.container];
    }
  }),
  componentName: "MuiGrid2",
  useThemeProps: (e) => ut({
    props: e,
    name: "MuiGrid2"
  }),
  useTheme: ir
});
process.env.NODE_ENV !== "production" && (Xn.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * The number of columns.
   * @default 12
   */
  columns: o.oneOfType([o.arrayOf(o.number), o.number, o.object]),
  /**
   * Defines the horizontal space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  columnSpacing: o.oneOfType([o.arrayOf(o.oneOfType([o.number, o.string])), o.number, o.object, o.string]),
  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  container: o.bool,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'row'
   */
  direction: o.oneOfType([o.oneOf(["column-reverse", "column", "row-reverse", "row"]), o.arrayOf(o.oneOf(["column-reverse", "column", "row-reverse", "row"])), o.object]),
  /**
   * Defines the offset value for the type `item` components.
   */
  offset: o.oneOfType([o.string, o.number, o.arrayOf(o.oneOfType([o.string, o.number])), o.object]),
  /**
   * Defines the vertical space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  rowSpacing: o.oneOfType([o.arrayOf(o.oneOfType([o.number, o.string])), o.number, o.object, o.string]),
  /**
   * Defines the size of the the type `item` components.
   */
  size: o.oneOfType([o.string, o.bool, o.number, o.arrayOf(o.oneOfType([o.string, o.bool, o.number])), o.object]),
  /**
   * Defines the space between the type `item` components.
   * It can only be used on a type `container` component.
   * @default 0
   */
  spacing: o.oneOfType([o.arrayOf(o.oneOfType([o.number, o.string])), o.number, o.object, o.string]),
  /**
   * @ignore
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * @internal
   * The level of the grid starts from `0` and increases when the grid nests
   * inside another grid. Nesting is defined as a container Grid being a direct
   * child of a container Grid.
   *
   * ```js
   * <Grid container> // level 0
   *   <Grid container> // level 1
   *     <Grid container> // level 2
   * ```
   *
   * Only consecutive grid is considered nesting. A grid container will start at
   * `0` if there are non-Grid container element above it.
   *
   * ```js
   * <Grid container> // level 0
   *   <div>
   *     <Grid container> // level 0
   * ```
   *
   * ```js
   * <Grid container> // level 0
   *   <Grid>
   *     <Grid container> // level 0
   * ```
   */
  unstable_level: o.number,
  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   * @default 'wrap'
   */
  wrap: o.oneOf(["nowrap", "wrap-reverse", "wrap"])
});
if (process.env.NODE_ENV !== "production") {
  const e = Xn, t = Sj("Grid2", e);
  e.propTypes = {
    // eslint-disable-next-line react/forbid-foreign-prop-types
    ...e.propTypes,
    direction: t("container"),
    spacing: t("container"),
    wrap: t("container")
  };
}
function Vm(e) {
  return `scale(${e}, ${e ** 2})`;
}
const bL = {
  entering: {
    opacity: 1,
    transform: Vm(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, mf = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), os = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const {
    addEndListener: r,
    appear: i = !0,
    children: a,
    easing: l,
    in: u,
    onEnter: d,
    onEntered: p,
    onEntering: m,
    onExit: h,
    onExited: g,
    onExiting: v,
    style: b,
    timeout: y = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: S = to,
    ...O
  } = t, P = za(), k = w.useRef(), R = ir(), E = w.useRef(null), M = It(E, us(a), n), _ = (V) => (z) => {
    if (V) {
      const X = E.current;
      z === void 0 ? V(X) : V(X, z);
    }
  }, I = _(m), F = _((V, z) => {
    tC(V);
    const {
      duration: X,
      delay: le,
      easing: ne
    } = Tu({
      style: b,
      timeout: y,
      easing: l
    }, {
      mode: "enter"
    });
    let G;
    y === "auto" ? (G = R.transitions.getAutoHeightDuration(V.clientHeight), k.current = G) : G = X, V.style.transition = [R.transitions.create("opacity", {
      duration: G,
      delay: le
    }), R.transitions.create("transform", {
      duration: mf ? G : G * 0.666,
      delay: le,
      easing: ne
    })].join(","), d && d(V, z);
  }), T = _(p), $ = _(v), N = _((V) => {
    const {
      duration: z,
      delay: X,
      easing: le
    } = Tu({
      style: b,
      timeout: y,
      easing: l
    }, {
      mode: "exit"
    });
    let ne;
    y === "auto" ? (ne = R.transitions.getAutoHeightDuration(V.clientHeight), k.current = ne) : ne = z, V.style.transition = [R.transitions.create("opacity", {
      duration: ne,
      delay: X
    }), R.transitions.create("transform", {
      duration: mf ? ne : ne * 0.666,
      delay: mf ? X : X || ne * 0.333,
      easing: le
    })].join(","), V.style.opacity = 0, V.style.transform = Vm(0.75), h && h(V);
  }), W = _(g), L = (V) => {
    y === "auto" && P.start(k.current || 0, V), r && r(E.current, V);
  };
  return /* @__PURE__ */ x.jsx(S, {
    appear: i,
    in: u,
    nodeRef: E,
    onEnter: F,
    onEntered: T,
    onEntering: I,
    onExit: N,
    onExited: W,
    onExiting: $,
    addEndListener: L,
    timeout: y === "auto" ? null : y,
    ...O,
    children: (V, {
      ownerState: z,
      ...X
    }) => /* @__PURE__ */ w.cloneElement(a, {
      style: {
        opacity: 0,
        transform: Vm(0.75),
        visibility: V === "exited" && !u ? "hidden" : void 0,
        ...bL[V],
        ...b,
        ...a.props.style
      },
      ref: M,
      ...X
    })
  });
});
process.env.NODE_ENV !== "production" && (os.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: o.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: o.bool,
  /**
   * A single child content element.
   */
  children: cs.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: o.oneOfType([o.shape({
    enter: o.string,
    exit: o.string
  }), o.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: o.bool,
  /**
   * @ignore
   */
  onEnter: o.func,
  /**
   * @ignore
   */
  onEntered: o.func,
  /**
   * @ignore
   */
  onEntering: o.func,
  /**
   * @ignore
   */
  onExit: o.func,
  /**
   * @ignore
   */
  onExited: o.func,
  /**
   * @ignore
   */
  onExiting: o.func,
  /**
   * @ignore
   */
  style: o.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: o.oneOfType([o.oneOf(["auto"]), o.number, o.shape({
    appear: o.number,
    enter: o.number,
    exit: o.number
  })])
});
os && (os.muiSupportAuto = !0);
const vC = D1({
  themeId: Gr
}), vL = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, i = We({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, R2, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...i
  };
}, xL = ae(bd, {
  shouldForwardProp: (e) => Zn(e) || e === "classes",
  name: "MuiInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [...gd(e, t), !n.disableUnderline && t.underline];
  }
})(ct(({
  theme: e
}) => {
  let n = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return e.vars && (n = `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`), {
    position: "relative",
    variants: [{
      props: ({
        ownerState: r
      }) => r.formControl,
      style: {
        "label + &": {
          marginTop: 16
        }
      }
    }, {
      props: ({
        ownerState: r
      }) => !r.disableUnderline,
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${Oi.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${Oi.error}`]: {
          "&::before, &::after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${n}`,
          left: 0,
          bottom: 0,
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${Oi.disabled}, .${Oi.error}):before`]: {
          borderBottom: `2px solid ${(e.vars || e).palette.text.primary}`,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            borderBottom: `1px solid ${n}`
          }
        },
        [`&.${Oi.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, ...Object.entries(e.palette).filter(qn()).map(([r]) => ({
      props: {
        color: r,
        disableUnderline: !1
      },
      style: {
        "&::after": {
          borderBottom: `2px solid ${(e.vars || e).palette[r].main}`
        }
      }
    }))]
  };
})), wL = ae(vd, {
  name: "MuiInput",
  slot: "Input",
  overridesResolver: yd
})({}), Od = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiInput"
  }), {
    disableUnderline: i = !1,
    components: a = {},
    componentsProps: l,
    fullWidth: u = !1,
    inputComponent: d = "input",
    multiline: p = !1,
    slotProps: m,
    slots: h = {},
    type: g = "text",
    ...v
  } = r, b = vL(r), S = {
    root: {
      ownerState: {
        disableUnderline: i
      }
    }
  }, O = m ?? l ? Bn(m ?? l, S) : S, P = h.root ?? a.Root ?? xL, k = h.input ?? a.Input ?? wL;
  return /* @__PURE__ */ x.jsx(xd, {
    slots: {
      root: P,
      input: k
    },
    slotProps: O,
    fullWidth: u,
    inputComponent: d,
    multiline: p,
    ref: n,
    type: g,
    ...v,
    classes: b
  });
});
process.env.NODE_ENV !== "production" && (Od.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: o.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: o.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: o.oneOfType([o.oneOf(["primary", "secondary"]), o.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: o.shape({
    Input: o.elementType,
    Root: o.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: o.shape({
    input: o.object,
    root: o.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: o.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: o.bool,
  /**
   * If `true`, the `input` will not have an underline.
   * @default false
   */
  disableUnderline: o.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: o.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: o.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: o.bool,
  /**
   * The id of the `input` element.
   */
  id: o.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: o.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: o.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: gn,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: o.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: o.oneOfType([o.number, o.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: o.oneOfType([o.number, o.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: o.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: o.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: o.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: o.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: o.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: o.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: o.oneOfType([o.number, o.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: o.shape({
    input: o.object,
    root: o.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: o.shape({
    input: o.elementType,
    root: o.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: o.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: o.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: o.any
});
Od.muiName = "Input";
function CL(e) {
  return ze("MuiInputAdornment", e);
}
const Dx = Ve("MuiInputAdornment", ["root", "filled", "standard", "outlined", "positionStart", "positionEnd", "disablePointerEvents", "hiddenLabel", "sizeSmall"]);
var Mx;
const SL = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, t[`position${ke(n.position)}`], n.disablePointerEvents === !0 && t.disablePointerEvents, t[n.variant]];
}, OL = (e) => {
  const {
    classes: t,
    disablePointerEvents: n,
    hiddenLabel: r,
    position: i,
    size: a,
    variant: l
  } = e, u = {
    root: ["root", n && "disablePointerEvents", i && `position${ke(i)}`, l, r && "hiddenLabel", a && `size${ke(a)}`]
  };
  return We(u, CL, t);
}, TL = ae("div", {
  name: "MuiInputAdornment",
  slot: "Root",
  overridesResolver: SL
})(ct(({
  theme: e
}) => ({
  display: "flex",
  maxHeight: "2em",
  alignItems: "center",
  whiteSpace: "nowrap",
  color: (e.vars || e).palette.action.active,
  variants: [{
    props: {
      variant: "filled"
    },
    style: {
      [`&.${Dx.positionStart}&:not(.${Dx.hiddenLabel})`]: {
        marginTop: 16
      }
    }
  }, {
    props: {
      position: "start"
    },
    style: {
      marginRight: 8
    }
  }, {
    props: {
      position: "end"
    },
    style: {
      marginLeft: 8
    }
  }, {
    props: {
      disablePointerEvents: !0
    },
    style: {
      pointerEvents: "none"
    }
  }]
}))), Vl = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiInputAdornment"
  }), {
    children: i,
    className: a,
    component: l = "div",
    disablePointerEvents: u = !1,
    disableTypography: d = !1,
    position: p,
    variant: m,
    ...h
  } = r, g = ar() || {};
  let v = m;
  m && g.variant && process.env.NODE_ENV !== "production" && m === g.variant && console.error("MUI: The `InputAdornment` variant infers the variant prop you do not have to provide one."), g && !v && (v = g.variant);
  const b = {
    ...r,
    hiddenLabel: g.hiddenLabel,
    size: g.size,
    disablePointerEvents: u,
    position: p,
    variant: v
  }, y = OL(b);
  return /* @__PURE__ */ x.jsx(Bl.Provider, {
    value: null,
    children: /* @__PURE__ */ x.jsx(TL, {
      as: l,
      ownerState: b,
      className: Me(y.root, a),
      ref: n,
      ...h,
      children: typeof i == "string" && !d ? /* @__PURE__ */ x.jsx(at, {
        color: "textSecondary",
        children: i
      }) : /* @__PURE__ */ x.jsxs(w.Fragment, {
        children: [p === "start" ? (
          /* notranslate needed while Google Translate will not fix zero-width space issue */
          Mx || (Mx = /* @__PURE__ */ x.jsx("span", {
            className: "notranslate",
            "aria-hidden": !0,
            children: "​"
          }))
        ) : null, i]
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (Vl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the `input` on click.
   * @default false
   */
  disablePointerEvents: o.bool,
  /**
   * If children is a string then disable wrapping in a Typography component.
   * @default false
   */
  disableTypography: o.bool,
  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: o.oneOf(["end", "start"]).isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: o.oneOf(["filled", "outlined", "standard"])
});
function EL(e) {
  return ze("MuiInputLabel", e);
}
Ve("MuiInputLabel", ["root", "focused", "disabled", "error", "required", "asterisk", "formControl", "sizeSmall", "shrink", "animated", "standard", "filled", "outlined"]);
const RL = (e) => {
  const {
    classes: t,
    formControl: n,
    size: r,
    shrink: i,
    disableAnimation: a,
    variant: l,
    required: u
  } = e, d = {
    root: ["root", n && "formControl", !a && "animated", i && "shrink", r && r !== "normal" && `size${ke(r)}`, l],
    asterisk: [u && "asterisk"]
  }, p = We(d, EL, t);
  return {
    ...t,
    // forward the focused, disabled, etc. classes to the FormLabel
    ...p
  };
}, kL = ae(jr, {
  shouldForwardProp: (e) => Zn(e) || e === "classes",
  name: "MuiInputLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${al.asterisk}`]: t.asterisk
    }, t.root, n.formControl && t.formControl, n.size === "small" && t.sizeSmall, n.shrink && t.shrink, !n.disableAnimation && t.animated, n.focused && t.focused, t[n.variant]];
  }
})(ct(({
  theme: e
}) => ({
  display: "block",
  transformOrigin: "top left",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%",
  variants: [{
    props: ({
      ownerState: t
    }) => t.formControl,
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: "translate(0, 20px) scale(1)"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      // Compensation for the `Input.inputSizeSmall` style.
      transform: "translate(0, 17px) scale(1)"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.shrink,
    style: {
      transform: "translate(0, -1.5px) scale(0.75)",
      transformOrigin: "top left",
      maxWidth: "133%"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableAnimation,
    style: {
      transition: e.transitions.create(["color", "transform", "max-width"], {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      })
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      // Chrome's autofill feature gives the input field a yellow background.
      // Since the input field is behind the label in the HTML tree,
      // the input field is drawn last and hides the label with an opaque background color.
      // zIndex: 1 will raise the label above opaque background-colors of input.
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(12px, 16px) scale(1)",
      maxWidth: "calc(100% - 24px)"
    }
  }, {
    props: {
      variant: "filled",
      size: "small"
    },
    style: {
      transform: "translate(12px, 13px) scale(1)"
    }
  }, {
    props: ({
      variant: t,
      ownerState: n
    }) => t === "filled" && n.shrink,
    style: {
      userSelect: "none",
      pointerEvents: "auto",
      transform: "translate(12px, 7px) scale(0.75)",
      maxWidth: "calc(133% - 24px)"
    }
  }, {
    props: ({
      variant: t,
      ownerState: n,
      size: r
    }) => t === "filled" && n.shrink && r === "small",
    style: {
      transform: "translate(12px, 4px) scale(0.75)"
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      // see comment above on filled.zIndex
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(14px, 16px) scale(1)",
      maxWidth: "calc(100% - 24px)"
    }
  }, {
    props: {
      variant: "outlined",
      size: "small"
    },
    style: {
      transform: "translate(14px, 9px) scale(1)"
    }
  }, {
    props: ({
      variant: t,
      ownerState: n
    }) => t === "outlined" && n.shrink,
    style: {
      userSelect: "none",
      pointerEvents: "auto",
      // Theoretically, we should have (8+5)*2/0.75 = 34px
      // but it feels a better when it bleeds a bit on the left, so 32px.
      maxWidth: "calc(133% - 32px)",
      transform: "translate(14px, -9px) scale(0.75)"
    }
  }]
}))), Vh = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    name: "MuiInputLabel",
    props: t
  }), {
    disableAnimation: i = !1,
    margin: a,
    shrink: l,
    variant: u,
    className: d,
    ...p
  } = r, m = ar();
  let h = l;
  typeof h > "u" && m && (h = m.filled || m.focused || m.adornedStart);
  const g = Fi({
    props: r,
    muiFormControl: m,
    states: ["size", "variant", "required", "focused"]
  }), v = {
    ...r,
    disableAnimation: i,
    formControl: m,
    shrink: h,
    size: g.size,
    variant: g.variant,
    required: g.required,
    focused: g.focused
  }, b = RL(v);
  return /* @__PURE__ */ x.jsx(kL, {
    "data-shrink": h,
    ref: n,
    className: Me(b.root, d),
    ...p,
    ownerState: v,
    classes: b
  });
});
process.env.NODE_ENV !== "production" && (Vh.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: o.oneOfType([o.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), o.string]),
  /**
   * If `true`, the transition animation is disabled.
   * @default false
   */
  disableAnimation: o.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: o.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: o.bool,
  /**
   * If `true`, the `input` of this label is focused.
   */
  focused: o.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: o.oneOf(["dense"]),
  /**
   * if `true`, the label will indicate that the `input` is required.
   */
  required: o.bool,
  /**
   * If `true`, the label is shrunk.
   */
  shrink: o.bool,
  /**
   * The size of the component.
   * @default 'normal'
   */
  size: o.oneOfType([o.oneOf(["normal", "small"]), o.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The variant to use.
   */
  variant: o.oneOf(["filled", "outlined", "standard"])
});
const ki = /* @__PURE__ */ w.createContext({});
process.env.NODE_ENV !== "production" && (ki.displayName = "ListContext");
function PL(e) {
  return ze("MuiList", e);
}
Ve("MuiList", ["root", "padding", "dense", "subheader"]);
const DL = (e) => {
  const {
    classes: t,
    disablePadding: n,
    dense: r,
    subheader: i
  } = e;
  return We({
    root: ["root", !n && "padding", r && "dense", i && "subheader"]
  }, PL, t);
}, ML = ae("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disablePadding && t.padding, n.dense && t.dense, n.subheader && t.subheader];
  }
})({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative",
  variants: [{
    props: ({
      ownerState: e
    }) => !e.disablePadding,
    style: {
      paddingTop: 8,
      paddingBottom: 8
    }
  }, {
    props: ({
      ownerState: e
    }) => e.subheader,
    style: {
      paddingTop: 0
    }
  }]
}), zl = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiList"
  }), {
    children: i,
    className: a,
    component: l = "ul",
    dense: u = !1,
    disablePadding: d = !1,
    subheader: p,
    ...m
  } = r, h = w.useMemo(() => ({
    dense: u
  }), [u]), g = {
    ...r,
    component: l,
    dense: u,
    disablePadding: d
  }, v = DL(g);
  return /* @__PURE__ */ x.jsx(ki.Provider, {
    value: h,
    children: /* @__PURE__ */ x.jsxs(ML, {
      as: l,
      className: Me(v.root, a),
      ref: n,
      ownerState: g,
      ...m,
      children: [p, i]
    })
  });
});
process.env.NODE_ENV !== "production" && (zl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: o.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: o.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: o.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
function _L(e) {
  return ze("MuiListItem", e);
}
Ve("MuiListItem", ["root", "container", "dense", "alignItemsFlexStart", "divider", "gutters", "padding", "secondaryAction"]);
const IL = Ve("MuiListItemButton", ["root", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "selected"]);
function jL(e) {
  return ze("MuiListItemSecondaryAction", e);
}
Ve("MuiListItemSecondaryAction", ["root", "disableGutters"]);
const $L = (e) => {
  const {
    disableGutters: t,
    classes: n
  } = e;
  return We({
    root: ["root", t && "disableGutters"]
  }, jL, n);
}, AL = ae("div", {
  name: "MuiListItemSecondaryAction",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.disableGutters && t.disableGutters];
  }
})({
  position: "absolute",
  right: 16,
  top: "50%",
  transform: "translateY(-50%)",
  variants: [{
    props: ({
      ownerState: e
    }) => e.disableGutters,
    style: {
      right: 0
    }
  }]
}), zh = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiListItemSecondaryAction"
  }), {
    className: i,
    ...a
  } = r, l = w.useContext(ki), u = {
    ...r,
    disableGutters: l.disableGutters
  }, d = $L(u);
  return /* @__PURE__ */ x.jsx(AL, {
    className: Me(d.root, i),
    ownerState: u,
    ref: n,
    ...a
  });
});
process.env.NODE_ENV !== "production" && (zh.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
zh.muiName = "ListItemSecondaryAction";
const NL = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.alignItems === "flex-start" && t.alignItemsFlexStart, n.divider && t.divider, !n.disableGutters && t.gutters, !n.disablePadding && t.padding, n.hasSecondaryAction && t.secondaryAction];
}, FL = (e) => {
  const {
    alignItems: t,
    classes: n,
    dense: r,
    disableGutters: i,
    disablePadding: a,
    divider: l,
    hasSecondaryAction: u
  } = e;
  return We({
    root: ["root", r && "dense", !i && "gutters", !a && "padding", l && "divider", t === "flex-start" && "alignItemsFlexStart", u && "secondaryAction"],
    container: ["container"]
  }, _L, n);
}, LL = ae("div", {
  name: "MuiListItem",
  slot: "Root",
  overridesResolver: NL
})(ct(({
  theme: e
}) => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  width: "100%",
  boxSizing: "border-box",
  textAlign: "left",
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disablePadding,
    style: {
      paddingTop: 8,
      paddingBottom: 8
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && t.dense,
    style: {
      paddingTop: 4,
      paddingBottom: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && !!t.secondaryAction,
    style: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.secondaryAction,
    style: {
      [`& > .${IL.root}`]: {
        paddingRight: 48
      }
    }
  }, {
    props: {
      alignItems: "flex-start"
    },
    style: {
      alignItems: "flex-start"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.divider,
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.button,
    style: {
      transition: e.transitions.create("background-color", {
        duration: e.transitions.duration.shortest
      }),
      "&:hover": {
        textDecoration: "none",
        backgroundColor: (e.vars || e).palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hasSecondaryAction,
    style: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    }
  }]
}))), BL = ae("li", {
  name: "MuiListItem",
  slot: "Container",
  overridesResolver: (e, t) => t.container
})({
  position: "relative"
}), xC = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiListItem"
  }), {
    alignItems: i = "center",
    children: a,
    className: l,
    component: u,
    components: d = {},
    componentsProps: p = {},
    ContainerComponent: m = "li",
    ContainerProps: {
      className: h,
      ...g
    } = {},
    dense: v = !1,
    disableGutters: b = !1,
    disablePadding: y = !1,
    divider: S = !1,
    secondaryAction: O,
    slotProps: P = {},
    slots: k = {},
    ...R
  } = r, E = w.useContext(ki), M = w.useMemo(() => ({
    dense: v || E.dense || !1,
    alignItems: i,
    disableGutters: b
  }), [i, E.dense, v, b]), _ = w.useRef(null), I = w.Children.toArray(a), F = I.length && Ua(I[I.length - 1], ["ListItemSecondaryAction"]), T = {
    ...r,
    alignItems: i,
    dense: M.dense,
    disableGutters: b,
    disablePadding: y,
    divider: S,
    hasSecondaryAction: F
  }, $ = FL(T), N = It(_, n), W = k.root || d.Root || LL, L = P.root || p.root || {}, V = {
    className: Me($.root, L.className, l),
    ...R
  };
  let z = u || "li";
  return F ? (z = !V.component && !u ? "div" : z, m === "li" && (z === "li" ? z = "div" : V.component === "li" && (V.component = "div")), /* @__PURE__ */ x.jsx(ki.Provider, {
    value: M,
    children: /* @__PURE__ */ x.jsxs(BL, {
      as: m,
      className: Me($.container, h),
      ref: N,
      ownerState: T,
      ...g,
      children: [/* @__PURE__ */ x.jsx(W, {
        ...L,
        ...!yl(W) && {
          as: z,
          ownerState: {
            ...T,
            ...L.ownerState
          }
        },
        ...V,
        children: I
      }), I.pop()]
    })
  })) : /* @__PURE__ */ x.jsx(ki.Provider, {
    value: M,
    children: /* @__PURE__ */ x.jsxs(W, {
      ...L,
      as: z,
      ref: N,
      ...!yl(W) && {
        ownerState: {
          ...T,
          ...L.ownerState
        }
      },
      ...V,
      children: [I, O && /* @__PURE__ */ x.jsx(zh, {
        children: O
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (xC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: o.oneOf(["center", "flex-start"]),
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: fo(o.node, (e) => {
    const t = w.Children.toArray(e.children);
    let n = -1;
    for (let r = t.length - 1; r >= 0; r -= 1) {
      const i = t[r];
      if (Ua(i, ["ListItemSecondaryAction"])) {
        n = r;
        break;
      }
    }
    return n !== -1 && n !== t.length - 1 ? new Error("MUI: You used an element after ListItemSecondaryAction. For ListItem to detect that it has a secondary action you must pass it as the last child to ListItem.") : null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  components: o.shape({
    Root: o.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  componentsProps: o.shape({
    root: o.object
  }),
  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   * @default 'li'
   * @deprecated Use the `component` or `slots.root` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ContainerComponent: ad,
  /**
   * Props applied to the container component if used.
   * @default {}
   * @deprecated Use the `slotProps.root` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ContainerProps: o.object,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: o.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: o.bool,
  /**
   * If `true`, all padding is removed.
   * @default false
   */
  disablePadding: o.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: o.bool,
  /**
   * The element to display at the end of ListItem.
   */
  secondaryAction: o.node,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: o.shape({
    root: o.object
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: o.shape({
    root: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
const _x = Ve("MuiListItemIcon", ["root", "alignItemsFlexStart"]), Ix = Ve("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]);
function hf(e, t, n) {
  return e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : n ? null : e.firstChild;
}
function jx(e, t, n) {
  return e === t ? n ? e.firstChild : e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : n ? null : e.lastChild;
}
function wC(e, t) {
  if (t === void 0)
    return !0;
  let n = e.innerText;
  return n === void 0 && (n = e.textContent), n = n.trim().toLowerCase(), n.length === 0 ? !1 : t.repeating ? n[0] === t.keys[0] : n.startsWith(t.keys.join(""));
}
function As(e, t, n, r, i, a) {
  let l = !1, u = i(e, t, t ? n : !1);
  for (; u; ) {
    if (u === e.firstChild) {
      if (l)
        return !1;
      l = !0;
    }
    const d = r ? !1 : u.disabled || u.getAttribute("aria-disabled") === "true";
    if (!u.hasAttribute("tabindex") || !wC(u, a) || d)
      u = i(e, u, n);
    else
      return u.focus(), !0;
  }
  return !1;
}
const CC = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: r,
    autoFocus: i = !1,
    autoFocusItem: a = !1,
    children: l,
    className: u,
    disabledItemsFocusable: d = !1,
    disableListWrap: p = !1,
    onKeyDown: m,
    variant: h = "selectedMenu",
    ...g
  } = t, v = w.useRef(null), b = w.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  An(() => {
    i && v.current.focus();
  }, [i]), w.useImperativeHandle(r, () => ({
    adjustStyleForScrollbar: (k, {
      direction: R
    }) => {
      const E = !v.current.style.width;
      if (k.clientHeight < v.current.clientHeight && E) {
        const M = `${j1(ti(k))}px`;
        v.current.style[R === "rtl" ? "paddingLeft" : "paddingRight"] = M, v.current.style.width = `calc(100% + ${M})`;
      }
      return v.current;
    }
  }), []);
  const y = (k) => {
    const R = v.current, E = k.key;
    if (k.ctrlKey || k.metaKey || k.altKey) {
      m && m(k);
      return;
    }
    const _ = Qn(R).activeElement;
    if (E === "ArrowDown")
      k.preventDefault(), As(R, _, p, d, hf);
    else if (E === "ArrowUp")
      k.preventDefault(), As(R, _, p, d, jx);
    else if (E === "Home")
      k.preventDefault(), As(R, null, p, d, hf);
    else if (E === "End")
      k.preventDefault(), As(R, null, p, d, jx);
    else if (E.length === 1) {
      const I = b.current, F = E.toLowerCase(), T = performance.now();
      I.keys.length > 0 && (T - I.lastTime > 500 ? (I.keys = [], I.repeating = !0, I.previousKeyMatched = !0) : I.repeating && F !== I.keys[0] && (I.repeating = !1)), I.lastTime = T, I.keys.push(F);
      const $ = _ && !I.repeating && wC(_, I);
      I.previousKeyMatched && ($ || As(R, _, !1, d, hf, I)) ? k.preventDefault() : I.previousKeyMatched = !1;
    }
    m && m(k);
  }, S = It(v, n);
  let O = -1;
  w.Children.forEach(l, (k, R) => {
    if (!/* @__PURE__ */ w.isValidElement(k)) {
      O === R && (O += 1, O >= l.length && (O = -1));
      return;
    }
    process.env.NODE_ENV !== "production" && ua.isFragment(k) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), k.props.disabled || (h === "selectedMenu" && k.props.selected || O === -1) && (O = R), O === R && (k.props.disabled || k.props.muiSkipListHighlight || k.type.muiSkipListHighlight) && (O += 1, O >= l.length && (O = -1));
  });
  const P = w.Children.map(l, (k, R) => {
    if (R === O) {
      const E = {};
      return a && (E.autoFocus = !0), k.props.tabIndex === void 0 && h === "selectedMenu" && (E.tabIndex = 0), /* @__PURE__ */ w.cloneElement(k, E);
    }
    return k;
  });
  return /* @__PURE__ */ x.jsx(zl, {
    role: "menu",
    ref: S,
    className: u,
    onKeyDown: y,
    tabIndex: i ? 0 : -1,
    ...g,
    children: P
  });
});
process.env.NODE_ENV !== "production" && (CC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: o.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: o.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: o.node,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: o.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: o.bool,
  /**
   * @ignore
   */
  onKeyDown: o.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: o.oneOf(["menu", "selectedMenu"])
});
function VL(e) {
  return ze("MuiPopover", e);
}
Ve("MuiPopover", ["root", "paper"]);
function $x(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.height / 2 : t === "bottom" && (n = e.height), n;
}
function Ax(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.width / 2 : t === "right" && (n = e.width), n;
}
function Nx(e) {
  return [e.horizontal, e.vertical].map((t) => typeof t == "number" ? `${t}px` : t).join(" ");
}
function pu(e) {
  return typeof e == "function" ? e() : e;
}
const zL = (e) => {
  const {
    classes: t
  } = e;
  return We({
    root: ["root"],
    paper: ["paper"]
  }, VL, t);
}, WL = ae(Ah, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), SC = ae($i, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), OC = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiPopover"
  }), {
    action: i,
    anchorEl: a,
    anchorOrigin: l = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: u,
    anchorReference: d = "anchorEl",
    children: p,
    className: m,
    container: h,
    elevation: g = 8,
    marginThreshold: v = 16,
    open: b,
    PaperProps: y = {},
    slots: S = {},
    slotProps: O = {},
    transformOrigin: P = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: k = os,
    transitionDuration: R = "auto",
    TransitionProps: {
      onEntering: E,
      ...M
    } = {},
    disableScrollLock: _ = !1,
    ...I
  } = r, F = (O == null ? void 0 : O.paper) ?? y, T = w.useRef(), $ = {
    ...r,
    anchorOrigin: l,
    anchorReference: d,
    elevation: g,
    marginThreshold: v,
    externalPaperSlotProps: F,
    transformOrigin: P,
    TransitionComponent: k,
    transitionDuration: R,
    TransitionProps: M
  }, N = zL($), W = w.useCallback(() => {
    if (d === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (u || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), u;
    const ue = pu(a), he = ue && ue.nodeType === 1 ? ue : Qn(T.current).body, B = he.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const ee = he.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && ee.top === 0 && ee.left === 0 && ee.right === 0 && ee.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: B.top + $x(B, l.vertical),
      left: B.left + Ax(B, l.horizontal)
    };
  }, [a, l.horizontal, l.vertical, u, d]), L = w.useCallback((ue) => ({
    vertical: $x(ue, P.vertical),
    horizontal: Ax(ue, P.horizontal)
  }), [P.horizontal, P.vertical]), V = w.useCallback((ue) => {
    const he = {
      width: ue.offsetWidth,
      height: ue.offsetHeight
    }, B = L(he);
    if (d === "none")
      return {
        top: null,
        left: null,
        transformOrigin: Nx(B)
      };
    const ee = W();
    let ie = ee.top - B.vertical, ge = ee.left - B.horizontal;
    const xe = ie + he.height, pe = ge + he.width, Ee = ti(pu(a)), Pe = Ee.innerHeight - v, Be = Ee.innerWidth - v;
    if (v !== null && ie < v) {
      const Ge = ie - v;
      ie -= Ge, B.vertical += Ge;
    } else if (v !== null && xe > Pe) {
      const Ge = xe - Pe;
      ie -= Ge, B.vertical += Ge;
    }
    if (process.env.NODE_ENV !== "production" && he.height > Pe && he.height && Pe && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${he.height - Pe}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), v !== null && ge < v) {
      const Ge = ge - v;
      ge -= Ge, B.horizontal += Ge;
    } else if (pe > Be) {
      const Ge = pe - Be;
      ge -= Ge, B.horizontal += Ge;
    }
    return {
      top: `${Math.round(ie)}px`,
      left: `${Math.round(ge)}px`,
      transformOrigin: Nx(B)
    };
  }, [a, d, W, L, v]), [z, X] = w.useState(b), le = w.useCallback(() => {
    const ue = T.current;
    if (!ue)
      return;
    const he = V(ue);
    he.top !== null && ue.style.setProperty("top", he.top), he.left !== null && (ue.style.left = he.left), ue.style.transformOrigin = he.transformOrigin, X(!0);
  }, [V]);
  w.useEffect(() => (_ && window.addEventListener("scroll", le), () => window.removeEventListener("scroll", le)), [a, _, le]);
  const ne = (ue, he) => {
    E && E(ue, he), le();
  }, G = () => {
    X(!1);
  };
  w.useEffect(() => {
    b && le();
  }), w.useImperativeHandle(i, () => b ? {
    updatePosition: () => {
      le();
    }
  } : null, [b, le]), w.useEffect(() => {
    if (!b)
      return;
    const ue = gh(() => {
      le();
    }), he = ti(a);
    return he.addEventListener("resize", ue), () => {
      ue.clear(), he.removeEventListener("resize", ue);
    };
  }, [a, b, le]);
  let Q = R;
  R === "auto" && !k.muiSupportAuto && (Q = void 0);
  const be = h || (a ? Qn(pu(a)).body : void 0), we = {
    slots: S,
    slotProps: {
      ...O,
      paper: F
    }
  }, [se, U] = fn("paper", {
    elementType: SC,
    externalForwardedProps: we,
    additionalProps: {
      elevation: g,
      className: Me(N.paper, F == null ? void 0 : F.className),
      style: z ? F.style : {
        ...F.style,
        opacity: 0
      }
    },
    ownerState: $
  }), [de, {
    slotProps: ce,
    ...K
  }] = fn("root", {
    elementType: WL,
    externalForwardedProps: we,
    additionalProps: {
      slotProps: {
        backdrop: {
          invisible: !0
        }
      },
      container: be,
      open: b
    },
    ownerState: $,
    className: Me(N.root, m)
  }), Z = It(T, U.ref);
  return /* @__PURE__ */ x.jsx(de, {
    ...K,
    ...!yl(de) && {
      slotProps: ce,
      disableScrollLock: _
    },
    ...I,
    ref: n,
    children: /* @__PURE__ */ x.jsx(k, {
      appear: !0,
      in: b,
      onEntering: ne,
      onExited: G,
      timeout: Q,
      ...M,
      children: /* @__PURE__ */ x.jsx(se, {
        ...U,
        ref: Z,
        children: p
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (OC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: gn,
  /**
   * An HTML element, [PopoverVirtualElement](https://mui.com/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: fo(o.oneOfType([ei, o.func]), (e) => {
    if (e.open && (!e.anchorReference || e.anchorReference === "anchorEl")) {
      const t = pu(e.anchorEl);
      if (t && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${t}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: o.shape({
    horizontal: o.oneOfType([o.oneOf(["center", "left", "right"]), o.number]).isRequired,
    vertical: o.oneOfType([o.oneOf(["bottom", "center", "top"]), o.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: o.shape({
    left: o.number.isRequired,
    top: o.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: o.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slotProps.root.slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slotProps.root.slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: o.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.root.slotProps.backdrop` instead.
   */
  BackdropProps: o.object,
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: o.oneOfType([ei, o.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: o.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: yh,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: o.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: o.func,
  /**
   * If `true`, the component is shown.
   */
  open: o.bool.isRequired,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: o.shape({
    component: ad
  }),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: o.shape({
    paper: o.oneOfType([o.func, o.object]),
    root: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: o.shape({
    paper: o.elementType,
    root: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: o.shape({
    horizontal: o.oneOfType([o.oneOf(["center", "left", "right"]), o.number]).isRequired,
    vertical: o.oneOfType([o.oneOf(["bottom", "center", "top"]), o.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: o.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: o.oneOfType([o.oneOf(["auto"]), o.number, o.shape({
    appear: o.number,
    enter: o.number,
    exit: o.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: o.object
});
function qL(e) {
  return ze("MuiMenu", e);
}
Ve("MuiMenu", ["root", "paper", "list"]);
const HL = {
  vertical: "top",
  horizontal: "right"
}, UL = {
  vertical: "top",
  horizontal: "left"
}, YL = (e) => {
  const {
    classes: t
  } = e;
  return We({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, qL, t);
}, GL = ae(OC, {
  shouldForwardProp: (e) => Zn(e) || e === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), KL = ae(SC, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), XL = ae(CC, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (e, t) => t.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), TC = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiMenu"
  }), {
    autoFocus: i = !0,
    children: a,
    className: l,
    disableAutoFocusItem: u = !1,
    MenuListProps: d = {},
    onClose: p,
    open: m,
    PaperProps: h = {},
    PopoverClasses: g,
    transitionDuration: v = "auto",
    TransitionProps: {
      onEntering: b,
      ...y
    } = {},
    variant: S = "selectedMenu",
    slots: O = {},
    slotProps: P = {},
    ...k
  } = r, R = eo(), E = {
    ...r,
    autoFocus: i,
    disableAutoFocusItem: u,
    MenuListProps: d,
    onEntering: b,
    PaperProps: h,
    transitionDuration: v,
    TransitionProps: y,
    variant: S
  }, M = YL(E), _ = i && !u && m, I = w.useRef(null), F = (z, X) => {
    I.current && I.current.adjustStyleForScrollbar(z, {
      direction: R ? "rtl" : "ltr"
    }), b && b(z, X);
  }, T = (z) => {
    z.key === "Tab" && (z.preventDefault(), p && p(z, "tabKeyDown"));
  };
  let $ = -1;
  w.Children.map(a, (z, X) => {
    /* @__PURE__ */ w.isValidElement(z) && (process.env.NODE_ENV !== "production" && ua.isFragment(z) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), z.props.disabled || (S === "selectedMenu" && z.props.selected || $ === -1) && ($ = X));
  });
  const N = O.paper ?? KL, W = P.paper ?? h, L = Nt({
    elementType: O.root,
    externalSlotProps: P.root,
    ownerState: E,
    className: [M.root, l]
  }), V = Nt({
    elementType: N,
    externalSlotProps: W,
    ownerState: E,
    className: M.paper
  });
  return /* @__PURE__ */ x.jsx(GL, {
    onClose: p,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: R ? "right" : "left"
    },
    transformOrigin: R ? HL : UL,
    slots: {
      paper: N,
      root: O.root
    },
    slotProps: {
      root: L,
      paper: V
    },
    open: m,
    ref: n,
    transitionDuration: v,
    TransitionProps: {
      onEntering: F,
      ...y
    },
    ownerState: E,
    ...k,
    classes: g,
    children: /* @__PURE__ */ x.jsx(XL, {
      onKeyDown: T,
      actions: I,
      autoFocus: i && ($ === -1 || u),
      autoFocusItem: _,
      variant: S,
      ...d,
      className: Me(M.list, d.className),
      children: a
    })
  });
});
process.env.NODE_ENV !== "production" && (TC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: o.oneOfType([ei, o.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: o.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: o.bool,
  /**
   * Props applied to the [`MenuList`](https://mui.com/material-ui/api/menu-list/) element.
   * @default {}
   */
  MenuListProps: o.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: o.func,
  /**
   * If `true`, the component is shown.
   */
  open: o.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: o.object,
  /**
   * `classes` prop applied to the [`Popover`](https://mui.com/material-ui/api/popover/) element.
   */
  PopoverClasses: o.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: o.shape({
    paper: o.oneOfType([o.func, o.object]),
    root: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: o.shape({
    paper: o.elementType,
    root: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: o.oneOfType([o.oneOf(["auto"]), o.number, o.shape({
    appear: o.number,
    enter: o.number,
    exit: o.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: o.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: o.oneOf(["menu", "selectedMenu"])
});
function QL(e) {
  return ze("MuiMenuItem", e);
}
const Ns = Ve("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), ZL = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.divider && t.divider, !n.disableGutters && t.gutters];
}, JL = (e) => {
  const {
    disabled: t,
    dense: n,
    divider: r,
    disableGutters: i,
    selected: a,
    classes: l
  } = e, d = We({
    root: ["root", n && "dense", t && "disabled", !i && "gutters", r && "divider", a && "selected"]
  }, QL, l);
  return {
    ...l,
    ...d
  };
}, eB = ae(Io, {
  shouldForwardProp: (e) => Zn(e) || e === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: ZL
})(ct(({
  theme: e
}) => ({
  ...e.typography.body1,
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap",
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${Ns.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : mt(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${Ns.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : mt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${Ns.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : mt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : mt(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${Ns.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${Ns.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  [`& + .${Rx.root}`]: {
    marginTop: e.spacing(1),
    marginBottom: e.spacing(1)
  },
  [`& + .${Rx.inset}`]: {
    marginLeft: 52
  },
  [`& .${Ix.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${Ix.inset}`]: {
    paddingLeft: 36
  },
  [`& .${_x.root}`]: {
    minWidth: 36
  },
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => t.divider,
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.dense,
    style: {
      [e.breakpoints.up("sm")]: {
        minHeight: "auto"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.dense,
    style: {
      minHeight: 32,
      // https://m2.material.io/components/menus#specs > Dense
      paddingTop: 4,
      paddingBottom: 4,
      ...e.typography.body2,
      [`& .${_x.root} svg`]: {
        fontSize: "1.25rem"
      }
    }
  }]
}))), zm = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiMenuItem"
  }), {
    autoFocus: i = !1,
    component: a = "li",
    dense: l = !1,
    divider: u = !1,
    disableGutters: d = !1,
    focusVisibleClassName: p,
    role: m = "menuitem",
    tabIndex: h,
    className: g,
    ...v
  } = r, b = w.useContext(ki), y = w.useMemo(() => ({
    dense: l || b.dense || !1,
    disableGutters: d
  }), [b.dense, l, d]), S = w.useRef(null);
  An(() => {
    i && (S.current ? S.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [i]);
  const O = {
    ...r,
    dense: y.dense,
    divider: u,
    disableGutters: d
  }, P = JL(r), k = It(S, n);
  let R;
  return r.disabled || (R = h !== void 0 ? h : -1), /* @__PURE__ */ x.jsx(ki.Provider, {
    value: y,
    children: /* @__PURE__ */ x.jsx(eB, {
      ref: k,
      role: m,
      tabIndex: R,
      component: a,
      focusVisibleClassName: Me(P.focusVisible, p),
      className: Me(P.root, g),
      ...v,
      ownerState: O,
      classes: P
    })
  });
});
process.env.NODE_ENV !== "production" && (zm.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: o.bool,
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: o.bool,
  /**
   * @ignore
   */
  disabled: o.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: o.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: o.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: o.string,
  /**
   * @ignore
   */
  role: o.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: o.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * @default 0
   */
  tabIndex: o.number
});
function tB(e) {
  return ze("MuiNativeSelect", e);
}
const Wh = Ve("MuiNativeSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), nB = (e) => {
  const {
    classes: t,
    variant: n,
    disabled: r,
    multiple: i,
    open: a,
    error: l
  } = e, u = {
    select: ["select", n, r && "disabled", i && "multiple", l && "error"],
    icon: ["icon", `icon${ke(n)}`, a && "iconOpen", r && "disabled"]
  };
  return We(u, tB, t);
}, EC = ae("select")(({
  theme: e
}) => ({
  // Reset
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: "none",
  // Reset
  borderRadius: 0,
  cursor: "pointer",
  "&:focus": {
    // Reset Chrome style
    borderRadius: 0
  },
  [`&.${Wh.disabled}`]: {
    cursor: "default"
  },
  "&[multiple]": {
    height: "auto"
  },
  "&:not([multiple]) option, &:not([multiple]) optgroup": {
    backgroundColor: (e.vars || e).palette.background.paper
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.variant !== "filled" && t.variant !== "outlined",
    style: {
      // Bump specificity to allow extending custom inputs
      "&&&": {
        paddingRight: 24,
        minWidth: 16
        // So it doesn't collapse.
      }
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      "&&&": {
        paddingRight: 32
      }
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      borderRadius: (e.vars || e).shape.borderRadius,
      "&:focus": {
        borderRadius: (e.vars || e).shape.borderRadius
        // Reset the reset for Chrome style
      },
      "&&&": {
        paddingRight: 32
      }
    }
  }]
})), rB = ae(EC, {
  name: "MuiNativeSelect",
  slot: "Select",
  shouldForwardProp: Zn,
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.select, t[n.variant], n.error && t.error, {
      [`&.${Wh.multiple}`]: t.multiple
    }];
  }
})({}), RC = ae("svg")(({
  theme: e
}) => ({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: "absolute",
  right: 0,
  // Center vertically, height is 1em
  top: "calc(50% - .5em)",
  // Don't block pointer events on the select under the icon.
  pointerEvents: "none",
  color: (e.vars || e).palette.action.active,
  [`&.${Wh.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.open,
    style: {
      transform: "rotate(180deg)"
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      right: 7
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      right: 7
    }
  }]
})), oB = ae(RC, {
  name: "MuiNativeSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${ke(n.variant)}`], n.open && t.iconOpen];
  }
})({}), kC = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const {
    className: r,
    disabled: i,
    error: a,
    IconComponent: l,
    inputRef: u,
    variant: d = "standard",
    ...p
  } = t, m = {
    ...t,
    disabled: i,
    variant: d,
    error: a
  }, h = nB(m);
  return /* @__PURE__ */ x.jsxs(w.Fragment, {
    children: [/* @__PURE__ */ x.jsx(rB, {
      ownerState: m,
      className: Me(h.select, r),
      disabled: i,
      ref: u || n,
      ...p
    }), t.multiple ? null : /* @__PURE__ */ x.jsx(oB, {
      as: l,
      ownerState: m,
      className: h.icon
    })]
  });
});
process.env.NODE_ENV !== "production" && (kC.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * The CSS class name of the select element.
   */
  className: o.string,
  /**
   * If `true`, the select is disabled.
   */
  disabled: o.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: o.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: o.elementType.isRequired,
  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: gn,
  /**
   * @ignore
   */
  multiple: o.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: o.string,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: o.func,
  /**
   * The input value.
   */
  value: o.any,
  /**
   * The variant to use.
   */
  variant: o.oneOf(["standard", "outlined", "filled"])
});
var Fx;
const iB = ae("fieldset", {
  shouldForwardProp: Zn
})({
  textAlign: "left",
  position: "absolute",
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: "0 8px",
  pointerEvents: "none",
  borderRadius: "inherit",
  borderStyle: "solid",
  borderWidth: 1,
  overflow: "hidden",
  minWidth: "0%"
}), aB = ae("legend", {
  shouldForwardProp: Zn
})(ct(({
  theme: e
}) => ({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden",
  // Fix Horizontal scroll when label too long
  variants: [{
    props: ({
      ownerState: t
    }) => !t.withLabel,
    style: {
      padding: 0,
      lineHeight: "11px",
      // sync with `height` in `legend` styles
      transition: e.transitions.create("width", {
        duration: 150,
        easing: e.transitions.easing.easeOut
      })
    }
  }, {
    props: ({
      ownerState: t
    }) => t.withLabel,
    style: {
      display: "block",
      // Fix conflict with normalize.css and sanitize.css
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: "0.75em",
      visibility: "hidden",
      maxWidth: 0.01,
      transition: e.transitions.create("max-width", {
        duration: 50,
        easing: e.transitions.easing.easeOut
      }),
      whiteSpace: "nowrap",
      "& > span": {
        paddingLeft: 5,
        paddingRight: 5,
        display: "inline-block",
        opacity: 0,
        visibility: "visible"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.withLabel && t.notched,
    style: {
      maxWidth: "100%",
      transition: e.transitions.create("max-width", {
        duration: 100,
        easing: e.transitions.easing.easeOut,
        delay: 50
      })
    }
  }]
})));
function PC(e) {
  const {
    children: t,
    classes: n,
    className: r,
    label: i,
    notched: a,
    ...l
  } = e, u = i != null && i !== "", d = {
    ...e,
    notched: a,
    withLabel: u
  };
  return /* @__PURE__ */ x.jsx(iB, {
    "aria-hidden": !0,
    className: r,
    ownerState: d,
    ...l,
    children: /* @__PURE__ */ x.jsx(aB, {
      ownerState: d,
      children: u ? /* @__PURE__ */ x.jsx("span", {
        children: i
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        Fx || (Fx = /* @__PURE__ */ x.jsx("span", {
          className: "notranslate",
          "aria-hidden": !0,
          children: "​"
        }))
      )
    })
  });
}
process.env.NODE_ENV !== "production" && (PC.propTypes = {
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The label.
   */
  label: o.node,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: o.bool.isRequired,
  /**
   * @ignore
   */
  style: o.object
});
const sB = (e) => {
  const {
    classes: t
  } = e, r = We({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, k2, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...r
  };
}, lB = ae(bd, {
  shouldForwardProp: (e) => Zn(e) || e === "classes",
  name: "MuiOutlinedInput",
  slot: "Root",
  overridesResolver: gd
})(ct(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    position: "relative",
    borderRadius: (e.vars || e).shape.borderRadius,
    [`&:hover .${Hr.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${Hr.notchedOutline}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
      }
    },
    [`&.${Hr.focused} .${Hr.notchedOutline}`]: {
      borderWidth: 2
    },
    variants: [...Object.entries(e.palette).filter(qn()).map(([n]) => ({
      props: {
        color: n
      },
      style: {
        [`&.${Hr.focused} .${Hr.notchedOutline}`]: {
          borderColor: (e.vars || e).palette[n].main
        }
      }
    })), {
      props: {},
      // to overide the above style
      style: {
        [`&.${Hr.error} .${Hr.notchedOutline}`]: {
          borderColor: (e.vars || e).palette.error.main
        },
        [`&.${Hr.disabled} .${Hr.notchedOutline}`]: {
          borderColor: (e.vars || e).palette.action.disabled
        }
      }
    }, {
      props: ({
        ownerState: n
      }) => n.startAdornment,
      style: {
        paddingLeft: 14
      }
    }, {
      props: ({
        ownerState: n
      }) => n.endAdornment,
      style: {
        paddingRight: 14
      }
    }, {
      props: ({
        ownerState: n
      }) => n.multiline,
      style: {
        padding: "16.5px 14px"
      }
    }, {
      props: ({
        ownerState: n,
        size: r
      }) => n.multiline && r === "small",
      style: {
        padding: "8.5px 14px"
      }
    }]
  };
})), cB = ae(PC, {
  name: "MuiOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (e, t) => t.notchedOutline
})(ct(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
  };
})), uB = ae(vd, {
  name: "MuiOutlinedInput",
  slot: "Input",
  overridesResolver: yd
})(ct(({
  theme: e
}) => ({
  padding: "16.5px 14px",
  ...!e.vars && {
    "&:-webkit-autofill": {
      WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
      WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
      caretColor: e.palette.mode === "light" ? null : "#fff",
      borderRadius: "inherit"
    }
  },
  ...e.vars && {
    "&:-webkit-autofill": {
      borderRadius: "inherit"
    },
    [e.getColorSchemeSelector("dark")]: {
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 100px #266798 inset",
        WebkitTextFillColor: "#fff",
        caretColor: "#fff"
      }
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      padding: "8.5px 14px"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      padding: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.startAdornment,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.endAdornment,
    style: {
      paddingRight: 0
    }
  }]
}))), Td = /* @__PURE__ */ w.forwardRef(function(t, n) {
  var r;
  const i = ut({
    props: t,
    name: "MuiOutlinedInput"
  }), {
    components: a = {},
    fullWidth: l = !1,
    inputComponent: u = "input",
    label: d,
    multiline: p = !1,
    notched: m,
    slots: h = {},
    type: g = "text",
    ...v
  } = i, b = sB(i), y = ar(), S = Fi({
    props: i,
    muiFormControl: y,
    states: ["color", "disabled", "error", "focused", "hiddenLabel", "size", "required"]
  }), O = {
    ...i,
    color: S.color || "primary",
    disabled: S.disabled,
    error: S.error,
    focused: S.focused,
    formControl: y,
    fullWidth: l,
    hiddenLabel: S.hiddenLabel,
    multiline: p,
    size: S.size,
    type: g
  }, P = h.root ?? a.Root ?? lB, k = h.input ?? a.Input ?? uB;
  return /* @__PURE__ */ x.jsx(xd, {
    slots: {
      root: P,
      input: k
    },
    renderSuffix: (R) => /* @__PURE__ */ x.jsx(cB, {
      ownerState: O,
      className: b.notchedOutline,
      label: d != null && d !== "" && S.required ? r || (r = /* @__PURE__ */ x.jsxs(w.Fragment, {
        children: [d, " ", "*"]
      })) : d,
      notched: typeof m < "u" ? m : !!(R.startAdornment || R.filled || R.focused)
    }),
    fullWidth: l,
    inputComponent: u,
    multiline: p,
    ref: n,
    type: g,
    ...v,
    classes: {
      ...b,
      notchedOutline: null
    }
  });
});
process.env.NODE_ENV !== "production" && (Td.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: o.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: o.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: o.oneOfType([o.oneOf(["primary", "secondary"]), o.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: o.shape({
    Input: o.elementType,
    Root: o.elementType
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: o.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: o.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: o.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: o.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: o.bool,
  /**
   * The id of the `input` element.
   */
  id: o.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: o.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: o.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: gn,
  /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */
  label: o.node,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: o.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: o.oneOfType([o.number, o.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: o.oneOfType([o.number, o.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: o.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: o.string,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: o.bool,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: o.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: o.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: o.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: o.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: o.oneOfType([o.number, o.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: o.shape({
    input: o.elementType,
    root: o.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: o.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: o.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: o.any
});
Td.muiName = "Input";
const dB = rn(/* @__PURE__ */ x.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked"), pB = rn(/* @__PURE__ */ x.jsx("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked"), fB = ae("span", {
  shouldForwardProp: Zn
})({
  position: "relative",
  display: "flex"
}), mB = ae(dB)({
  // Scale applied to prevent dot misalignment in Safari
  transform: "scale(1)"
}), hB = ae(pB)(ct(({
  theme: e
}) => ({
  left: 0,
  position: "absolute",
  transform: "scale(0)",
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeIn,
    duration: e.transitions.duration.shortest
  }),
  variants: [{
    props: {
      checked: !0
    },
    style: {
      transform: "scale(1)",
      transition: e.transitions.create("transform", {
        easing: e.transitions.easing.easeOut,
        duration: e.transitions.duration.shortest
      })
    }
  }]
})));
function qh(e) {
  const {
    checked: t = !1,
    classes: n = {},
    fontSize: r
  } = e, i = {
    ...e,
    checked: t
  };
  return /* @__PURE__ */ x.jsxs(fB, {
    className: n.root,
    ownerState: i,
    children: [/* @__PURE__ */ x.jsx(mB, {
      fontSize: r,
      className: n.background,
      ownerState: i
    }), /* @__PURE__ */ x.jsx(hB, {
      fontSize: r,
      className: n.dot,
      ownerState: i
    })]
  });
}
process.env.NODE_ENV !== "production" && (qh.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: o.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   */
  fontSize: o.oneOf(["small", "medium"])
});
const Hh = /* @__PURE__ */ w.createContext(void 0);
process.env.NODE_ENV !== "production" && (Hh.displayName = "RadioGroupContext");
function gB() {
  return w.useContext(Hh);
}
function yB(e) {
  return ze("MuiRadio", e);
}
const Lx = Ve("MuiRadio", ["root", "checked", "disabled", "colorPrimary", "colorSecondary", "sizeSmall"]), bB = (e) => {
  const {
    classes: t,
    color: n,
    size: r
  } = e, i = {
    root: ["root", `color${ke(n)}`, r !== "medium" && `size${ke(r)}`]
  };
  return {
    ...t,
    ...We(i, yB, t)
  };
}, vB = ae(jh, {
  shouldForwardProp: (e) => Zn(e) || e === "classes",
  name: "MuiRadio",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.size !== "medium" && t[`size${ke(n.size)}`], t[`color${ke(n.color)}`]];
  }
})(ct(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  [`&.${Lx.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  },
  variants: [{
    props: {
      color: "default",
      disabled: !1,
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : mt(e.palette.action.active, e.palette.action.hoverOpacity)
      }
    }
  }, ...Object.entries(e.palette).filter(qn()).map(([t]) => ({
    props: {
      color: t,
      disabled: !1,
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : mt(e.palette[t].main, e.palette.action.hoverOpacity)
      }
    }
  })), ...Object.entries(e.palette).filter(qn()).map(([t]) => ({
    props: {
      color: t,
      disabled: !1
    },
    style: {
      [`&.${Lx.checked}`]: {
        color: (e.vars || e).palette[t].main
      }
    }
  })), {
    // Should be last to override other colors
    props: {
      disableRipple: !1
    },
    style: {
      // Reset on touch devices, it doesn't add specificity
      "&:hover": {
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }]
})));
function xB(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
const Bx = /* @__PURE__ */ x.jsx(qh, {
  checked: !0
}), Vx = /* @__PURE__ */ x.jsx(qh, {}), Uh = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiRadio"
  }), {
    checked: i,
    checkedIcon: a = Bx,
    color: l = "primary",
    icon: u = Vx,
    name: d,
    onChange: p,
    size: m = "medium",
    className: h,
    disabled: g,
    disableRipple: v = !1,
    ...b
  } = r, y = ar();
  let S = g;
  y && typeof S > "u" && (S = y.disabled), S ?? (S = !1);
  const O = {
    ...r,
    disabled: S,
    disableRipple: v,
    color: l,
    size: m
  }, P = bB(O), k = gB();
  let R = i;
  const E = Dm(p, k && k.onChange);
  let M = d;
  return k && (typeof R > "u" && (R = xB(k.value, r.value)), typeof M > "u" && (M = k.name)), /* @__PURE__ */ x.jsx(vB, {
    type: "radio",
    icon: /* @__PURE__ */ w.cloneElement(u, {
      fontSize: Vx.props.fontSize ?? m
    }),
    checkedIcon: /* @__PURE__ */ w.cloneElement(a, {
      fontSize: Bx.props.fontSize ?? m
    }),
    disabled: S,
    ownerState: O,
    classes: P,
    name: M,
    checked: R,
    onChange: E,
    ref: n,
    className: Me(P.root, h),
    ...b
  });
});
process.env.NODE_ENV !== "production" && (Uh.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: o.bool,
  /**
   * The icon to display when the component is checked.
   * @default <RadioButtonIcon checked />
   */
  checkedIcon: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: o.oneOfType([o.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), o.string]),
  /**
   * If `true`, the component is disabled.
   */
  disabled: o.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: o.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <RadioButtonIcon />
   */
  icon: o.node,
  /**
   * The id of the `input` element.
   */
  id: o.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: o.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: gn,
  /**
   * Name attribute of the `input` element.
   */
  name: o.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: o.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: o.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   * @default 'medium'
   */
  size: o.oneOfType([o.oneOf(["medium", "small"]), o.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   */
  value: o.any
});
function wB(e) {
  return ze("MuiRadioGroup", e);
}
Ve("MuiRadioGroup", ["root", "row", "error"]);
const CB = (e) => {
  const {
    classes: t,
    row: n,
    error: r
  } = e;
  return We({
    root: ["root", n && "row", r && "error"]
  }, wB, t);
}, DC = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: r,
    children: i,
    className: a,
    defaultValue: l,
    name: u,
    onChange: d,
    value: p,
    ...m
  } = t, h = w.useRef(null), g = CB(t), [v, b] = or({
    controlled: p,
    default: l,
    name: "RadioGroup"
  });
  w.useImperativeHandle(r, () => ({
    focus: () => {
      let P = h.current.querySelector("input:not(:disabled):checked");
      P || (P = h.current.querySelector("input:not(:disabled)")), P && P.focus();
    }
  }), []);
  const y = It(n, h), S = Ir(u), O = w.useMemo(() => ({
    name: S,
    onChange(P) {
      b(P.target.value), d && d(P, P.target.value);
    },
    value: v
  }), [S, d, b, v]);
  return /* @__PURE__ */ x.jsx(Hh.Provider, {
    value: O,
    children: /* @__PURE__ */ x.jsx(Lh, {
      role: "radiogroup",
      ref: y,
      className: Me(g.root, a),
      ...m,
      children: i
    })
  });
});
process.env.NODE_ENV !== "production" && (DC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: o.any,
  /**
   * The name used to reference the value of the control.
   * If you don't provide this prop, it falls back to a randomly generated name.
   */
  name: o.string,
  /**
   * Callback fired when a radio button is selected.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {string} value The value of the selected radio button.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: o.func,
  /**
   * Value of the selected radio button. The DOM API casts this to a string.
   */
  value: o.any
});
function MC(e) {
  return ze("MuiSelect", e);
}
const Fs = Ve("MuiSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "focused", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]);
var zx;
const SB = ae(EC, {
  name: "MuiSelect",
  slot: "Select",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [
      // Win specificity over the input base
      {
        [`&.${Fs.select}`]: t.select
      },
      {
        [`&.${Fs.select}`]: t[n.variant]
      },
      {
        [`&.${Fs.error}`]: t.error
      },
      {
        [`&.${Fs.multiple}`]: t.multiple
      }
    ];
  }
})({
  // Win specificity over the input base
  [`&.${Fs.select}`]: {
    height: "auto",
    // Resets for multiple select with chips
    minHeight: "1.4375em",
    // Required for select\text-field height consistency
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
}), OB = ae(RC, {
  name: "MuiSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${ke(n.variant)}`], n.open && t.iconOpen];
  }
})({}), TB = ae("input", {
  shouldForwardProp: (e) => Q1(e) && e !== "classes",
  name: "MuiSelect",
  slot: "NativeInput",
  overridesResolver: (e, t) => t.nativeInput
})({
  bottom: 0,
  left: 0,
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
  width: "100%",
  boxSizing: "border-box"
});
function Wx(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
function EB(e) {
  return e == null || typeof e == "string" && !e.trim();
}
const RB = (e) => {
  const {
    classes: t,
    variant: n,
    disabled: r,
    multiple: i,
    open: a,
    error: l
  } = e, u = {
    select: ["select", n, r && "disabled", i && "multiple", l && "error"],
    icon: ["icon", `icon${ke(n)}`, a && "iconOpen", r && "disabled"],
    nativeInput: ["nativeInput"]
  };
  return We(u, MC, t);
}, _C = /* @__PURE__ */ w.forwardRef(function(t, n) {
  var Xt;
  const {
    "aria-describedby": r,
    "aria-label": i,
    autoFocus: a,
    autoWidth: l,
    children: u,
    className: d,
    defaultOpen: p,
    defaultValue: m,
    disabled: h,
    displayEmpty: g,
    error: v = !1,
    IconComponent: b,
    inputRef: y,
    labelId: S,
    MenuProps: O = {},
    multiple: P,
    name: k,
    onBlur: R,
    onChange: E,
    onClose: M,
    onFocus: _,
    onOpen: I,
    open: F,
    readOnly: T,
    renderValue: $,
    required: N,
    SelectDisplayProps: W = {},
    tabIndex: L,
    // catching `type` from Input which makes no sense for SelectInput
    type: V,
    value: z,
    variant: X = "standard",
    ...le
  } = t, [ne, G] = or({
    controlled: z,
    default: m,
    name: "Select"
  }), [Q, be] = or({
    controlled: F,
    default: p,
    name: "Select"
  }), we = w.useRef(null), se = w.useRef(null), [U, de] = w.useState(null), {
    current: ce
  } = w.useRef(F != null), [K, Z] = w.useState(), ue = It(n, y), he = w.useCallback((je) => {
    se.current = je, je && de(je);
  }, []), B = U == null ? void 0 : U.parentNode;
  w.useImperativeHandle(ue, () => ({
    focus: () => {
      se.current.focus();
    },
    node: we.current,
    value: ne
  }), [ne]), w.useEffect(() => {
    p && Q && U && !ce && (Z(l ? null : B.clientWidth), se.current.focus());
  }, [U, l]), w.useEffect(() => {
    a && se.current.focus();
  }, [a]), w.useEffect(() => {
    if (!S)
      return;
    const je = Qn(se.current).getElementById(S);
    if (je) {
      const ot = () => {
        getSelection().isCollapsed && se.current.focus();
      };
      return je.addEventListener("click", ot), () => {
        je.removeEventListener("click", ot);
      };
    }
  }, [S]);
  const ee = (je, ot) => {
    je ? I && I(ot) : M && M(ot), ce || (Z(l ? null : B.clientWidth), be(je));
  }, ie = (je) => {
    je.button === 0 && (je.preventDefault(), se.current.focus(), ee(!0, je));
  }, ge = (je) => {
    ee(!1, je);
  }, xe = w.Children.toArray(u), pe = (je) => {
    const ot = xe.find((vt) => vt.props.value === je.target.value);
    ot !== void 0 && (G(ot.props.value), E && E(je, ot));
  }, Ee = (je) => (ot) => {
    let vt;
    if (ot.currentTarget.hasAttribute("tabindex")) {
      if (P) {
        vt = Array.isArray(ne) ? ne.slice() : [];
        const gt = ne.indexOf(je.props.value);
        gt === -1 ? vt.push(je.props.value) : vt.splice(gt, 1);
      } else
        vt = je.props.value;
      if (je.props.onClick && je.props.onClick(ot), ne !== vt && (G(vt), E)) {
        const gt = ot.nativeEvent || ot, kt = new gt.constructor(gt.type, gt);
        Object.defineProperty(kt, "target", {
          writable: !0,
          value: {
            value: vt,
            name: k
          }
        }), E(kt, je);
      }
      P || ee(!1, ot);
    }
  }, Pe = (je) => {
    T || [
      " ",
      "ArrowUp",
      "ArrowDown",
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      "Enter"
    ].includes(je.key) && (je.preventDefault(), ee(!0, je));
  }, Be = U !== null && Q, Ge = (je) => {
    !Be && R && (Object.defineProperty(je, "target", {
      writable: !0,
      value: {
        value: ne,
        name: k
      }
    }), R(je));
  };
  delete le["aria-invalid"];
  let Ie, Dt;
  const Re = [];
  let $e = !1, dt = !1;
  (Du({
    value: ne
  }) || g) && ($ ? Ie = $(ne) : $e = !0);
  const He = xe.map((je) => {
    if (!/* @__PURE__ */ w.isValidElement(je))
      return null;
    process.env.NODE_ENV !== "production" && ua.isFragment(je) && console.error(["MUI: The Select component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    let ot;
    if (P) {
      if (!Array.isArray(ne))
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: The `value` prop must be an array when using the `Select` component with `multiple`." : _o(2));
      ot = ne.some((vt) => Wx(vt, je.props.value)), ot && $e && Re.push(je.props.children);
    } else
      ot = Wx(ne, je.props.value), ot && $e && (Dt = je.props.children);
    return ot && (dt = !0), /* @__PURE__ */ w.cloneElement(je, {
      "aria-selected": ot ? "true" : "false",
      onClick: Ee(je),
      onKeyUp: (vt) => {
        vt.key === " " && vt.preventDefault(), je.props.onKeyUp && je.props.onKeyUp(vt);
      },
      role: "option",
      selected: ot,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": je.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  process.env.NODE_ENV !== "production" && w.useEffect(() => {
    if (!dt && !P && ne !== "") {
      const je = xe.map((ot) => ot.props.value);
      console.warn([`MUI: You have provided an out-of-range value \`${ne}\` for the select ${k ? `(name="${k}") ` : ""}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${je.filter((ot) => ot != null).map((ot) => `\`${ot}\``).join(", ") || '""'}.`].join(`
`));
    }
  }, [dt, xe, P, k, ne]), $e && (P ? Re.length === 0 ? Ie = null : Ie = Re.reduce((je, ot, vt) => (je.push(ot), vt < Re.length - 1 && je.push(", "), je), []) : Ie = Dt);
  let Je = K;
  !l && ce && U && (Je = B.clientWidth);
  let Ze;
  typeof L < "u" ? Ze = L : Ze = h ? null : 0;
  const nt = W.id || (k ? `mui-component-select-${k}` : void 0), Ne = {
    ...t,
    variant: X,
    value: ne,
    open: Be,
    error: v
  }, Ct = RB(Ne), Rt = {
    ...O.PaperProps,
    ...(Xt = O.slotProps) == null ? void 0 : Xt.paper
  }, At = Ir();
  return /* @__PURE__ */ x.jsxs(w.Fragment, {
    children: [/* @__PURE__ */ x.jsx(SB, {
      as: "div",
      ref: he,
      tabIndex: Ze,
      role: "combobox",
      "aria-controls": Be ? At : void 0,
      "aria-disabled": h ? "true" : void 0,
      "aria-expanded": Be ? "true" : "false",
      "aria-haspopup": "listbox",
      "aria-label": i,
      "aria-labelledby": [S, nt].filter(Boolean).join(" ") || void 0,
      "aria-describedby": r,
      "aria-required": N ? "true" : void 0,
      "aria-invalid": v ? "true" : void 0,
      onKeyDown: Pe,
      onMouseDown: h || T ? null : ie,
      onBlur: Ge,
      onFocus: _,
      ...W,
      ownerState: Ne,
      className: Me(W.className, Ct.select, d),
      id: nt,
      children: EB(Ie) ? (
        // notranslate needed while Google Translate will not fix zero-width space issue
        zx || (zx = /* @__PURE__ */ x.jsx("span", {
          className: "notranslate",
          "aria-hidden": !0,
          children: "​"
        }))
      ) : Ie
    }), /* @__PURE__ */ x.jsx(TB, {
      "aria-invalid": v,
      value: Array.isArray(ne) ? ne.join(",") : ne,
      name: k,
      ref: we,
      "aria-hidden": !0,
      onChange: pe,
      tabIndex: -1,
      disabled: h,
      className: Ct.nativeInput,
      autoFocus: a,
      required: N,
      ...le,
      ownerState: Ne
    }), /* @__PURE__ */ x.jsx(OB, {
      as: b,
      className: Ct.icon,
      ownerState: Ne
    }), /* @__PURE__ */ x.jsx(TC, {
      id: `menu-${k || ""}`,
      anchorEl: B,
      open: Be,
      onClose: ge,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      },
      ...O,
      MenuListProps: {
        "aria-labelledby": S,
        role: "listbox",
        "aria-multiselectable": P ? "true" : void 0,
        disableListWrap: !0,
        id: At,
        ...O.MenuListProps
      },
      slotProps: {
        ...O.slotProps,
        paper: {
          ...Rt,
          style: {
            minWidth: Je,
            ...Rt != null ? Rt.style : null
          }
        }
      },
      children: He
    })]
  });
});
process.env.NODE_ENV !== "production" && (_C.propTypes = {
  /**
   * @ignore
   */
  "aria-describedby": o.string,
  /**
   * @ignore
   */
  "aria-label": o.string,
  /**
   * @ignore
   */
  autoFocus: o.bool,
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: o.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * The CSS class name of the select element.
   */
  className: o.string,
  /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */
  defaultOpen: o.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: o.any,
  /**
   * If `true`, the select is disabled.
   */
  disabled: o.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: o.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: o.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: o.elementType.isRequired,
  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: gn,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: o.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: o.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: o.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: o.string,
  /**
   * @ignore
   */
  onBlur: o.func,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: o.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: o.func,
  /**
   * @ignore
   */
  onFocus: o.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: o.func,
  /**
   * If `true`, the component is shown.
   */
  open: o.bool,
  /**
   * @ignore
   */
  readOnly: o.bool,
  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: o.func,
  /**
   * If `true`, the component is required.
   */
  required: o.bool,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: o.object,
  /**
   * @ignore
   */
  tabIndex: o.oneOfType([o.number, o.string]),
  /**
   * @ignore
   */
  type: o.any,
  /**
   * The input value.
   */
  value: o.any,
  /**
   * The variant to use.
   */
  variant: o.oneOf(["standard", "outlined", "filled"])
});
const kB = (e) => {
  const {
    classes: t
  } = e, r = We({
    root: ["root"]
  }, MC, t);
  return {
    ...t,
    ...r
  };
}, Yh = {
  name: "MuiSelect",
  overridesResolver: (e, t) => t.root,
  shouldForwardProp: (e) => Zn(e) && e !== "variant",
  slot: "Root"
}, PB = ae(Od, Yh)(""), DB = ae(Td, Yh)(""), MB = ae(Cd, Yh)(""), Ed = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    name: "MuiSelect",
    props: t
  }), {
    autoWidth: i = !1,
    children: a,
    classes: l = {},
    className: u,
    defaultOpen: d = !1,
    displayEmpty: p = !1,
    IconComponent: m = hC,
    id: h,
    input: g,
    inputProps: v,
    label: b,
    labelId: y,
    MenuProps: S,
    multiple: O = !1,
    native: P = !1,
    onClose: k,
    onOpen: R,
    open: E,
    renderValue: M,
    SelectDisplayProps: _,
    variant: I = "outlined",
    ...F
  } = r, T = P ? kC : _C, $ = ar(), N = Fi({
    props: r,
    muiFormControl: $,
    states: ["variant", "error"]
  }), W = N.variant || I, L = {
    ...r,
    variant: W,
    classes: l
  }, V = kB(L), {
    root: z,
    ...X
  } = V, le = g || {
    standard: /* @__PURE__ */ x.jsx(PB, {
      ownerState: L
    }),
    outlined: /* @__PURE__ */ x.jsx(DB, {
      label: b,
      ownerState: L
    }),
    filled: /* @__PURE__ */ x.jsx(MB, {
      ownerState: L
    })
  }[W], ne = It(n, us(le));
  return /* @__PURE__ */ x.jsx(w.Fragment, {
    children: /* @__PURE__ */ w.cloneElement(le, {
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: T,
      inputProps: {
        children: a,
        error: N.error,
        IconComponent: m,
        variant: W,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple: O,
        ...P ? {
          id: h
        } : {
          autoWidth: i,
          defaultOpen: d,
          displayEmpty: p,
          labelId: y,
          MenuProps: S,
          onClose: k,
          onOpen: R,
          open: E,
          renderValue: M,
          SelectDisplayProps: {
            id: h,
            ..._
          }
        },
        ...v,
        classes: v ? Bn(X, v.classes) : X,
        ...g ? g.props.inputProps : {}
      },
      ...(O && P || p) && W === "outlined" ? {
        notched: !0
      } : {},
      ref: ne,
      className: Me(le.props.className, u, V.root),
      // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
      ...!g && {
        variant: W
      },
      ...F
    })
  });
});
process.env.NODE_ENV !== "production" && (Ed.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */
  autoWidth: o.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */
  defaultOpen: o.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: o.any,
  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */
  displayEmpty: o.bool,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: o.elementType,
  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: o.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: o.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: o.object,
  /**
   * See [OutlinedInput#label](https://mui.com/material-ui/api/outlined-input/#props)
   */
  label: o.node,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: o.string,
  /**
   * Props applied to the [`Menu`](https://mui.com/material-ui/api/menu/) element.
   */
  MenuProps: o.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: o.bool,
  /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */
  native: o.bool,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: o.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: o.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: o.func,
  /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: o.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: o.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: o.oneOfType([o.oneOf([""]), o.any]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: o.oneOf(["filled", "outlined", "standard"])
});
Ed.muiName = "Select";
function _B(e) {
  return ze("MuiTooltip", e);
}
const On = Ve("MuiTooltip", ["popper", "popperInteractive", "popperArrow", "popperClose", "tooltip", "tooltipArrow", "touch", "tooltipPlacementLeft", "tooltipPlacementRight", "tooltipPlacementTop", "tooltipPlacementBottom", "arrow"]);
function IB(e) {
  return Math.round(e * 1e5) / 1e5;
}
const jB = (e) => {
  const {
    classes: t,
    disableInteractive: n,
    arrow: r,
    touch: i,
    placement: a
  } = e, l = {
    popper: ["popper", !n && "popperInteractive", r && "popperArrow"],
    tooltip: ["tooltip", r && "tooltipArrow", i && "touch", `tooltipPlacement${ke(a.split("-")[0])}`],
    arrow: ["arrow"]
  };
  return We(l, _B, t);
}, $B = ae(ps, {
  name: "MuiTooltip",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.popper, !n.disableInteractive && t.popperInteractive, n.arrow && t.popperArrow, !n.open && t.popperClose];
  }
})(ct(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.tooltip,
  pointerEvents: "none",
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disableInteractive,
    style: {
      pointerEvents: "auto"
    }
  }, {
    props: ({
      open: t
    }) => !t,
    style: {
      pointerEvents: "none"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow,
    style: {
      [`&[data-popper-placement*="bottom"] .${On.arrow}`]: {
        top: 0,
        marginTop: "-0.71em",
        "&::before": {
          transformOrigin: "0 100%"
        }
      },
      [`&[data-popper-placement*="top"] .${On.arrow}`]: {
        bottom: 0,
        marginBottom: "-0.71em",
        "&::before": {
          transformOrigin: "100% 0"
        }
      },
      [`&[data-popper-placement*="right"] .${On.arrow}`]: {
        height: "1em",
        width: "0.71em",
        "&::before": {
          transformOrigin: "100% 100%"
        }
      },
      [`&[data-popper-placement*="left"] .${On.arrow}`]: {
        height: "1em",
        width: "0.71em",
        "&::before": {
          transformOrigin: "0 0"
        }
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !t.isRtl,
    style: {
      [`&[data-popper-placement*="right"] .${On.arrow}`]: {
        left: 0,
        marginLeft: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !!t.isRtl,
    style: {
      [`&[data-popper-placement*="right"] .${On.arrow}`]: {
        right: 0,
        marginRight: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !t.isRtl,
    style: {
      [`&[data-popper-placement*="left"] .${On.arrow}`]: {
        right: 0,
        marginRight: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !!t.isRtl,
    style: {
      [`&[data-popper-placement*="left"] .${On.arrow}`]: {
        left: 0,
        marginLeft: "-0.71em"
      }
    }
  }]
}))), AB = ae("div", {
  name: "MuiTooltip",
  slot: "Tooltip",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.tooltip, n.touch && t.touch, n.arrow && t.tooltipArrow, t[`tooltipPlacement${ke(n.placement.split("-")[0])}`]];
  }
})(ct(({
  theme: e
}) => ({
  backgroundColor: e.vars ? e.vars.palette.Tooltip.bg : mt(e.palette.grey[700], 0.92),
  borderRadius: (e.vars || e).shape.borderRadius,
  color: (e.vars || e).palette.common.white,
  fontFamily: e.typography.fontFamily,
  padding: "4px 8px",
  fontSize: e.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: "break-word",
  fontWeight: e.typography.fontWeightMedium,
  [`.${On.popper}[data-popper-placement*="left"] &`]: {
    transformOrigin: "right center"
  },
  [`.${On.popper}[data-popper-placement*="right"] &`]: {
    transformOrigin: "left center"
  },
  [`.${On.popper}[data-popper-placement*="top"] &`]: {
    transformOrigin: "center bottom",
    marginBottom: "14px"
  },
  [`.${On.popper}[data-popper-placement*="bottom"] &`]: {
    transformOrigin: "center top",
    marginTop: "14px"
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.arrow,
    style: {
      position: "relative",
      margin: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.touch,
    style: {
      padding: "8px 16px",
      fontSize: e.typography.pxToRem(14),
      lineHeight: `${IB(16 / 14)}em`,
      fontWeight: e.typography.fontWeightRegular
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.isRtl,
    style: {
      [`.${On.popper}[data-popper-placement*="left"] &`]: {
        marginRight: "14px"
      },
      [`.${On.popper}[data-popper-placement*="right"] &`]: {
        marginLeft: "14px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.isRtl && t.touch,
    style: {
      [`.${On.popper}[data-popper-placement*="left"] &`]: {
        marginRight: "24px"
      },
      [`.${On.popper}[data-popper-placement*="right"] &`]: {
        marginLeft: "24px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.isRtl,
    style: {
      [`.${On.popper}[data-popper-placement*="left"] &`]: {
        marginLeft: "14px"
      },
      [`.${On.popper}[data-popper-placement*="right"] &`]: {
        marginRight: "14px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.isRtl && t.touch,
    style: {
      [`.${On.popper}[data-popper-placement*="left"] &`]: {
        marginLeft: "24px"
      },
      [`.${On.popper}[data-popper-placement*="right"] &`]: {
        marginRight: "24px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.touch,
    style: {
      [`.${On.popper}[data-popper-placement*="top"] &`]: {
        marginBottom: "24px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.touch,
    style: {
      [`.${On.popper}[data-popper-placement*="bottom"] &`]: {
        marginTop: "24px"
      }
    }
  }]
}))), NB = ae("span", {
  name: "MuiTooltip",
  slot: "Arrow",
  overridesResolver: (e, t) => t.arrow
})(ct(({
  theme: e
}) => ({
  overflow: "hidden",
  position: "absolute",
  width: "1em",
  height: "0.71em",
  boxSizing: "border-box",
  color: e.vars ? e.vars.palette.Tooltip.bg : mt(e.palette.grey[700], 0.9),
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: "currentColor",
    transform: "rotate(45deg)"
  }
})));
let Gc = !1;
const qx = new ld();
let Ls = {
  x: 0,
  y: 0
};
function Kc(e, t) {
  return (n, ...r) => {
    t && t(n, ...r), e(n, ...r);
  };
}
const Zo = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiTooltip"
  }), {
    arrow: i = !1,
    children: a,
    classes: l,
    components: u = {},
    componentsProps: d = {},
    describeChild: p = !1,
    disableFocusListener: m = !1,
    disableHoverListener: h = !1,
    disableInteractive: g = !1,
    disableTouchListener: v = !1,
    enterDelay: b = 100,
    enterNextDelay: y = 0,
    enterTouchDelay: S = 700,
    followCursor: O = !1,
    id: P,
    leaveDelay: k = 0,
    leaveTouchDelay: R = 1500,
    onClose: E,
    onOpen: M,
    open: _,
    placement: I = "bottom",
    PopperComponent: F,
    PopperProps: T = {},
    slotProps: $ = {},
    slots: N = {},
    title: W,
    TransitionComponent: L,
    TransitionProps: V,
    ...z
  } = r, X = /* @__PURE__ */ w.isValidElement(a) ? a : /* @__PURE__ */ x.jsx("span", {
    children: a
  }), le = ir(), ne = eo(), [G, Q] = w.useState(), [be, we] = w.useState(null), se = w.useRef(!1), U = g || O, de = za(), ce = za(), K = za(), Z = za(), [ue, he] = or({
    controlled: _,
    default: !1,
    name: "Tooltip",
    state: "open"
  });
  let B = ue;
  if (process.env.NODE_ENV !== "production") {
    const {
      current: et
    } = w.useRef(_ !== void 0);
    w.useEffect(() => {
      G && G.disabled && !et && W !== "" && G.tagName.toLowerCase() === "button" && console.warn(["MUI: You are providing a disabled `button` child to the Tooltip component.", "A disabled element does not fire events.", "Tooltip needs to listen to the child element's events to display the title.", "", "Add a simple wrapper element, such as a `span`."].join(`
`));
    }, [W, G, et]);
  }
  const ee = Ir(P), ie = w.useRef(), ge = Le(() => {
    ie.current !== void 0 && (document.body.style.WebkitUserSelect = ie.current, ie.current = void 0), Z.clear();
  });
  w.useEffect(() => ge, [ge]);
  const xe = (et) => {
    qx.clear(), Gc = !0, he(!0), M && !B && M(et);
  }, pe = Le(
    /**
     * @param {React.SyntheticEvent | Event} event
     */
    (et) => {
      qx.start(800 + k, () => {
        Gc = !1;
      }), he(!1), E && B && E(et), de.start(le.transitions.duration.shortest, () => {
        se.current = !1;
      });
    }
  ), Ee = (et) => {
    se.current && et.type !== "touchstart" || (G && G.removeAttribute("title"), ce.clear(), K.clear(), b || Gc && y ? ce.start(Gc ? y : b, () => {
      xe(et);
    }) : xe(et));
  }, Pe = (et) => {
    ce.clear(), K.start(k, () => {
      pe(et);
    });
  }, [, Be] = w.useState(!1), Ge = (et) => {
    xu(et.target) || (Be(!1), Pe(et));
  }, Ie = (et) => {
    G || Q(et.currentTarget), xu(et.target) && (Be(!0), Ee(et));
  }, Dt = (et) => {
    se.current = !0;
    const jn = X.props;
    jn.onTouchStart && jn.onTouchStart(et);
  }, Re = (et) => {
    Dt(et), K.clear(), de.clear(), ge(), ie.current = document.body.style.WebkitUserSelect, document.body.style.WebkitUserSelect = "none", Z.start(S, () => {
      document.body.style.WebkitUserSelect = ie.current, Ee(et);
    });
  }, $e = (et) => {
    X.props.onTouchEnd && X.props.onTouchEnd(et), ge(), K.start(R, () => {
      pe(et);
    });
  };
  w.useEffect(() => {
    if (!B)
      return;
    function et(jn) {
      jn.key === "Escape" && pe(jn);
    }
    return document.addEventListener("keydown", et), () => {
      document.removeEventListener("keydown", et);
    };
  }, [pe, B]);
  const dt = It(us(X), Q, n);
  !W && W !== 0 && (B = !1);
  const He = w.useRef(), Je = (et) => {
    const jn = X.props;
    jn.onMouseMove && jn.onMouseMove(et), Ls = {
      x: et.clientX,
      y: et.clientY
    }, He.current && He.current.update();
  }, Ze = {}, nt = typeof W == "string";
  p ? (Ze.title = !B && nt && !h ? W : null, Ze["aria-describedby"] = B ? ee : null) : (Ze["aria-label"] = nt ? W : null, Ze["aria-labelledby"] = B && !nt ? ee : null);
  const Ne = {
    ...Ze,
    ...z,
    ...X.props,
    className: Me(z.className, X.props.className),
    onTouchStart: Dt,
    ref: dt,
    ...O ? {
      onMouseMove: Je
    } : {}
  };
  process.env.NODE_ENV !== "production" && (Ne["data-mui-internal-clone-element"] = !0, w.useEffect(() => {
    G && !G.getAttribute("data-mui-internal-clone-element") && console.error(["MUI: The `children` component of the Tooltip is not forwarding its props correctly.", "Please make sure that props are spread on the same element that the ref is applied to."].join(`
`));
  }, [G]));
  const Ct = {};
  v || (Ne.onTouchStart = Re, Ne.onTouchEnd = $e), h || (Ne.onMouseOver = Kc(Ee, Ne.onMouseOver), Ne.onMouseLeave = Kc(Pe, Ne.onMouseLeave), U || (Ct.onMouseOver = Ee, Ct.onMouseLeave = Pe)), m || (Ne.onFocus = Kc(Ie, Ne.onFocus), Ne.onBlur = Kc(Ge, Ne.onBlur), U || (Ct.onFocus = Ie, Ct.onBlur = Ge)), process.env.NODE_ENV !== "production" && X.props.title && console.error(["MUI: You have provided a `title` prop to the child of <Tooltip />.", `Remove this title prop \`${X.props.title}\` or the Tooltip component.`].join(`
`));
  const Rt = {
    ...r,
    isRtl: ne,
    arrow: i,
    disableInteractive: U,
    placement: I,
    PopperComponentProp: F,
    touch: se.current
  }, At = typeof $.popper == "function" ? $.popper(Rt) : $.popper, Xt = w.useMemo(() => {
    var jn, ho;
    let et = [{
      name: "arrow",
      enabled: !!be,
      options: {
        element: be,
        padding: 4
      }
    }];
    return (jn = T.popperOptions) != null && jn.modifiers && (et = et.concat(T.popperOptions.modifiers)), (ho = At == null ? void 0 : At.popperOptions) != null && ho.modifiers && (et = et.concat(At.popperOptions.modifiers)), {
      ...T.popperOptions,
      ...At == null ? void 0 : At.popperOptions,
      modifiers: et
    };
  }, [be, T.popperOptions, At == null ? void 0 : At.popperOptions]), je = jB(Rt), ot = typeof $.transition == "function" ? $.transition(Rt) : $.transition, vt = {
    slots: {
      popper: u.Popper,
      transition: u.Transition ?? L,
      tooltip: u.Tooltip,
      arrow: u.Arrow,
      ...N
    },
    slotProps: {
      arrow: $.arrow ?? d.arrow,
      popper: {
        ...T,
        ...At ?? d.popper
      },
      // resolvedPopperProps can be spread because it's already an object
      tooltip: $.tooltip ?? d.tooltip,
      transition: {
        ...V,
        ...ot ?? d.transition
      }
    }
  }, [gt, kt] = fn("popper", {
    elementType: $B,
    externalForwardedProps: vt,
    ownerState: Rt,
    className: Me(je.popper, T == null ? void 0 : T.className)
  }), [xn, on] = fn("transition", {
    elementType: os,
    externalForwardedProps: vt,
    ownerState: Rt
  }), [br, Un] = fn("tooltip", {
    elementType: AB,
    className: je.tooltip,
    externalForwardedProps: vt,
    ownerState: Rt
  }), [no, mo] = fn("arrow", {
    elementType: NB,
    className: je.arrow,
    externalForwardedProps: vt,
    ownerState: Rt,
    ref: we
  });
  return /* @__PURE__ */ x.jsxs(w.Fragment, {
    children: [/* @__PURE__ */ w.cloneElement(X, Ne), /* @__PURE__ */ x.jsx(gt, {
      as: F ?? ps,
      placement: I,
      anchorEl: O ? {
        getBoundingClientRect: () => ({
          top: Ls.y,
          left: Ls.x,
          right: Ls.x,
          bottom: Ls.y,
          width: 0,
          height: 0
        })
      } : G,
      popperRef: He,
      open: G ? B : !1,
      id: ee,
      transition: !0,
      ...Ct,
      ...kt,
      popperOptions: Xt,
      children: ({
        TransitionProps: et
      }) => /* @__PURE__ */ x.jsx(xn, {
        timeout: le.transitions.duration.shorter,
        ...et,
        ...on,
        children: /* @__PURE__ */ x.jsxs(br, {
          ...Un,
          children: [W, i ? /* @__PURE__ */ x.jsx(no, {
            ...mo
          }) : null]
        })
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (Zo.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */
  arrow: o.bool,
  /**
   * Tooltip reference element.
   */
  children: cs.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: o.shape({
    Arrow: o.elementType,
    Popper: o.elementType,
    Tooltip: o.elementType,
    Transition: o.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: o.shape({
    arrow: o.object,
    popper: o.object,
    tooltip: o.object,
    transition: o.object
  }),
  /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */
  describeChild: o.bool,
  /**
   * Do not respond to focus-visible events.
   * @default false
   */
  disableFocusListener: o.bool,
  /**
   * Do not respond to hover events.
   * @default false
   */
  disableHoverListener: o.bool,
  /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */
  disableInteractive: o.bool,
  /**
   * Do not respond to long press touch events.
   * @default false
   */
  disableTouchListener: o.bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */
  enterDelay: o.number,
  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */
  enterNextDelay: o.number,
  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */
  enterTouchDelay: o.number,
  /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */
  followCursor: o.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: o.string,
  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */
  leaveDelay: o.number,
  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */
  leaveTouchDelay: o.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: o.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: o.func,
  /**
   * If `true`, the component is shown.
   */
  open: o.bool,
  /**
   * Tooltip placement.
   * @default 'bottom'
   */
  placement: o.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The component used for the popper.
   * @deprecated use the `slots.popper` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PopperComponent: o.elementType,
  /**
   * Props applied to the [`Popper`](https://mui.com/material-ui/api/popper/) element.
   * @deprecated use the `slotProps.popper` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  PopperProps: o.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: o.shape({
    arrow: o.oneOfType([o.func, o.object]),
    popper: o.oneOfType([o.func, o.object]),
    tooltip: o.oneOfType([o.func, o.object]),
    transition: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: o.shape({
    arrow: o.elementType,
    popper: o.elementType,
    tooltip: o.elementType,
    transition: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */
  title: o.node,
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated use the `slots.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: o.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: o.object
});
const sn = y$({
  createStyledComponent: ae("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (e, t) => t.root
  }),
  useThemeProps: (e) => ut({
    props: e,
    name: "MuiStack"
  })
});
process.env.NODE_ENV !== "production" && (sn.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'column'
   */
  direction: o.oneOfType([o.oneOf(["column-reverse", "column", "row-reverse", "row"]), o.arrayOf(o.oneOf(["column-reverse", "column", "row-reverse", "row"])), o.object]),
  /**
   * Add an element between each child.
   */
  divider: o.node,
  /**
   * Defines the space between immediate children.
   * @default 0
   */
  spacing: o.oneOfType([o.arrayOf(o.oneOfType([o.number, o.string])), o.number, o.object, o.string]),
  /**
   * The system prop, which allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * If `true`, the CSS flexbox `gap` is used instead of applying `margin` to children.
   *
   * While CSS `gap` removes the [known limitations](https://mui.com/joy-ui/react-stack/#limitations),
   * it is not fully supported in some browsers. We recommend checking https://caniuse.com/?search=flex%20gap before using this flag.
   *
   * To enable this flag globally, follow the [theme's default props](https://mui.com/material-ui/customization/theme-components/#default-props) configuration.
   * @default false
   */
  useFlexGap: o.bool
});
const Gh = /* @__PURE__ */ w.createContext();
process.env.NODE_ENV !== "production" && (Gh.displayName = "TableContext");
function FB(e) {
  return ze("MuiTable", e);
}
Ve("MuiTable", ["root", "stickyHeader"]);
const LB = (e) => {
  const {
    classes: t,
    stickyHeader: n
  } = e;
  return We({
    root: ["root", n && "stickyHeader"]
  }, FB, t);
}, BB = ae("table", {
  name: "MuiTable",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.stickyHeader && t.stickyHeader];
  }
})(ct(({
  theme: e
}) => ({
  display: "table",
  width: "100%",
  borderCollapse: "collapse",
  borderSpacing: 0,
  "& caption": {
    ...e.typography.body2,
    padding: e.spacing(2),
    color: (e.vars || e).palette.text.secondary,
    textAlign: "left",
    captionSide: "bottom"
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.stickyHeader,
    style: {
      borderCollapse: "separate"
    }
  }]
}))), Hx = "table", IC = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiTable"
  }), {
    className: i,
    component: a = Hx,
    padding: l = "normal",
    size: u = "medium",
    stickyHeader: d = !1,
    ...p
  } = r, m = {
    ...r,
    component: a,
    padding: l,
    size: u,
    stickyHeader: d
  }, h = LB(m), g = w.useMemo(() => ({
    padding: l,
    size: u,
    stickyHeader: d
  }), [l, u, d]);
  return /* @__PURE__ */ x.jsx(Gh.Provider, {
    value: g,
    children: /* @__PURE__ */ x.jsx(BB, {
      as: a,
      role: a === Hx ? null : "table",
      ref: n,
      className: Me(h.root, i),
      ownerState: m,
      ...p
    })
  });
});
process.env.NODE_ENV !== "production" && (IC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the table, normally `TableHead` and `TableBody`.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * Allows TableCells to inherit padding of the Table.
   * @default 'normal'
   */
  padding: o.oneOf(["checkbox", "none", "normal"]),
  /**
   * Allows TableCells to inherit size of the Table.
   * @default 'medium'
   */
  size: o.oneOfType([o.oneOf(["medium", "small"]), o.string]),
  /**
   * Set the header sticky.
   * @default false
   */
  stickyHeader: o.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
const Wl = /* @__PURE__ */ w.createContext();
process.env.NODE_ENV !== "production" && (Wl.displayName = "Tablelvl2Context");
function VB(e) {
  return ze("MuiTableBody", e);
}
Ve("MuiTableBody", ["root"]);
const zB = (e) => {
  const {
    classes: t
  } = e;
  return We({
    root: ["root"]
  }, VB, t);
}, WB = ae("tbody", {
  name: "MuiTableBody",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "table-row-group"
}), qB = {
  variant: "body"
}, Ux = "tbody", jC = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiTableBody"
  }), {
    className: i,
    component: a = Ux,
    ...l
  } = r, u = {
    ...r,
    component: a
  }, d = zB(u);
  return /* @__PURE__ */ x.jsx(Wl.Provider, {
    value: qB,
    children: /* @__PURE__ */ x.jsx(WB, {
      className: Me(d.root, i),
      as: a,
      ref: n,
      role: a === Ux ? null : "rowgroup",
      ownerState: u,
      ...l
    })
  });
});
process.env.NODE_ENV !== "production" && (jC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `TableRow`.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
function HB(e) {
  return ze("MuiTableCell", e);
}
const UB = Ve("MuiTableCell", ["root", "head", "body", "footer", "sizeSmall", "sizeMedium", "paddingCheckbox", "paddingNone", "alignLeft", "alignCenter", "alignRight", "alignJustify", "stickyHeader"]), YB = (e) => {
  const {
    classes: t,
    variant: n,
    align: r,
    padding: i,
    size: a,
    stickyHeader: l
  } = e, u = {
    root: ["root", n, l && "stickyHeader", r !== "inherit" && `align${ke(r)}`, i !== "normal" && `padding${ke(i)}`, `size${ke(a)}`]
  };
  return We(u, HB, t);
}, GB = ae("td", {
  name: "MuiTableCell",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`size${ke(n.size)}`], n.padding !== "normal" && t[`padding${ke(n.padding)}`], n.align !== "inherit" && t[`align${ke(n.align)}`], n.stickyHeader && t.stickyHeader];
  }
})(ct(({
  theme: e
}) => ({
  ...e.typography.body2,
  display: "table-cell",
  verticalAlign: "inherit",
  // Workaround for a rendering bug with spanned columns in Chrome 62.0.
  // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
  borderBottom: e.vars ? `1px solid ${e.vars.palette.TableCell.border}` : `1px solid
    ${e.palette.mode === "light" ? id(mt(e.palette.divider, 1), 0.88) : od(mt(e.palette.divider, 1), 0.68)}`,
  textAlign: "left",
  padding: 16,
  variants: [{
    props: {
      variant: "head"
    },
    style: {
      color: (e.vars || e).palette.text.primary,
      lineHeight: e.typography.pxToRem(24),
      fontWeight: e.typography.fontWeightMedium
    }
  }, {
    props: {
      variant: "body"
    },
    style: {
      color: (e.vars || e).palette.text.primary
    }
  }, {
    props: {
      variant: "footer"
    },
    style: {
      color: (e.vars || e).palette.text.secondary,
      lineHeight: e.typography.pxToRem(21),
      fontSize: e.typography.pxToRem(12)
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      padding: "6px 16px",
      [`&.${UB.paddingCheckbox}`]: {
        width: 24,
        // prevent the checkbox column from growing
        padding: "0 12px 0 16px",
        "& > *": {
          padding: 0
        }
      }
    }
  }, {
    props: {
      padding: "checkbox"
    },
    style: {
      width: 48,
      // prevent the checkbox column from growing
      padding: "0 0 0 4px"
    }
  }, {
    props: {
      padding: "none"
    },
    style: {
      padding: 0
    }
  }, {
    props: {
      align: "left"
    },
    style: {
      textAlign: "left"
    }
  }, {
    props: {
      align: "center"
    },
    style: {
      textAlign: "center"
    }
  }, {
    props: {
      align: "right"
    },
    style: {
      textAlign: "right",
      flexDirection: "row-reverse"
    }
  }, {
    props: {
      align: "justify"
    },
    style: {
      textAlign: "justify"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.stickyHeader,
    style: {
      position: "sticky",
      top: 0,
      zIndex: 2,
      backgroundColor: (e.vars || e).palette.background.default
    }
  }]
}))), oa = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiTableCell"
  }), {
    align: i = "inherit",
    className: a,
    component: l,
    padding: u,
    scope: d,
    size: p,
    sortDirection: m,
    variant: h,
    ...g
  } = r, v = w.useContext(Gh), b = w.useContext(Wl), y = b && b.variant === "head";
  let S;
  l ? S = l : S = y ? "th" : "td";
  let O = d;
  S === "td" ? O = void 0 : !O && y && (O = "col");
  const P = h || b && b.variant, k = {
    ...r,
    align: i,
    component: S,
    padding: u || (v && v.padding ? v.padding : "normal"),
    size: p || (v && v.size ? v.size : "medium"),
    sortDirection: m,
    stickyHeader: P === "head" && v && v.stickyHeader,
    variant: P
  }, R = YB(k);
  let E = null;
  return m && (E = m === "asc" ? "ascending" : "descending"), /* @__PURE__ */ x.jsx(GB, {
    as: S,
    ref: n,
    className: Me(R.root, a),
    "aria-sort": E,
    scope: O,
    ownerState: k,
    ...g
  });
});
process.env.NODE_ENV !== "production" && (oa.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   * @default 'inherit'
   */
  align: o.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * Sets the padding applied to the cell.
   * The prop defaults to the value (`'default'`) inherited from the parent Table component.
   */
  padding: o.oneOf(["checkbox", "none", "normal"]),
  /**
   * Set scope attribute.
   */
  scope: o.string,
  /**
   * Specify the size of the cell.
   * The prop defaults to the value (`'medium'`) inherited from the parent Table component.
   */
  size: o.oneOfType([o.oneOf(["medium", "small"]), o.string]),
  /**
   * Set aria-sort direction.
   */
  sortDirection: o.oneOf(["asc", "desc", !1]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Specify the cell type.
   * The prop defaults to the value inherited from the parent TableHead, TableBody, or TableFooter components.
   */
  variant: o.oneOfType([o.oneOf(["body", "footer", "head"]), o.string])
});
function KB(e) {
  return ze("MuiTableHead", e);
}
Ve("MuiTableHead", ["root"]);
const XB = (e) => {
  const {
    classes: t
  } = e;
  return We({
    root: ["root"]
  }, KB, t);
}, QB = ae("thead", {
  name: "MuiTableHead",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "table-header-group"
}), ZB = {
  variant: "head"
}, Yx = "thead", $C = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiTableHead"
  }), {
    className: i,
    component: a = Yx,
    ...l
  } = r, u = {
    ...r,
    component: a
  }, d = XB(u);
  return /* @__PURE__ */ x.jsx(Wl.Provider, {
    value: ZB,
    children: /* @__PURE__ */ x.jsx(QB, {
      as: a,
      className: Me(d.root, i),
      ref: n,
      role: a === Yx ? null : "rowgroup",
      ownerState: u,
      ...l
    })
  });
});
process.env.NODE_ENV !== "production" && ($C.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `TableRow`.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
function JB(e) {
  return ze("MuiTableRow", e);
}
const Gx = Ve("MuiTableRow", ["root", "selected", "hover", "head", "footer"]), eV = (e) => {
  const {
    classes: t,
    selected: n,
    hover: r,
    head: i,
    footer: a
  } = e;
  return We({
    root: ["root", n && "selected", r && "hover", i && "head", a && "footer"]
  }, JB, t);
}, tV = ae("tr", {
  name: "MuiTableRow",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.head && t.head, n.footer && t.footer];
  }
})(ct(({
  theme: e
}) => ({
  color: "inherit",
  display: "table-row",
  verticalAlign: "middle",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  [`&.${Gx.hover}:hover`]: {
    backgroundColor: (e.vars || e).palette.action.hover
  },
  [`&.${Gx.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : mt(e.palette.primary.main, e.palette.action.selectedOpacity),
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : mt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
    }
  }
}))), Kx = "tr", Wm = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiTableRow"
  }), {
    className: i,
    component: a = Kx,
    hover: l = !1,
    selected: u = !1,
    ...d
  } = r, p = w.useContext(Wl), m = {
    ...r,
    component: a,
    hover: l,
    selected: u,
    head: p && p.variant === "head",
    footer: p && p.variant === "footer"
  }, h = eV(m);
  return /* @__PURE__ */ x.jsx(tV, {
    as: a,
    ref: n,
    className: Me(h.root, i),
    role: a === Kx ? null : "row",
    ownerState: m,
    ...d
  });
});
process.env.NODE_ENV !== "production" && (Wm.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Should be valid `<tr>` children such as `TableCell`.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If `true`, the table row will shade on hover.
   * @default false
   */
  hover: o.bool,
  /**
   * If `true`, the table row will have the selected shading.
   * @default false
   */
  selected: o.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
function nV(e) {
  return ze("MuiTextField", e);
}
Ve("MuiTextField", ["root"]);
const rV = {
  standard: Od,
  filled: Cd,
  outlined: Td
}, oV = (e) => {
  const {
    classes: t
  } = e;
  return We({
    root: ["root"]
  }, nV, t);
}, iV = ae(sr, {
  name: "MuiTextField",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), ms = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = ut({
    props: t,
    name: "MuiTextField"
  }), {
    autoComplete: i,
    autoFocus: a = !1,
    children: l,
    className: u,
    color: d = "primary",
    defaultValue: p,
    disabled: m = !1,
    error: h = !1,
    FormHelperTextProps: g,
    fullWidth: v = !1,
    helperText: b,
    id: y,
    InputLabelProps: S,
    inputProps: O,
    InputProps: P,
    inputRef: k,
    label: R,
    maxRows: E,
    minRows: M,
    multiline: _ = !1,
    name: I,
    onBlur: F,
    onChange: T,
    onFocus: $,
    placeholder: N,
    required: W = !1,
    rows: L,
    select: V = !1,
    SelectProps: z,
    slots: X = {},
    slotProps: le = {},
    type: ne,
    value: G,
    variant: Q = "outlined",
    ...be
  } = r, we = {
    ...r,
    autoFocus: a,
    color: d,
    disabled: m,
    error: h,
    fullWidth: v,
    multiline: _,
    required: W,
    select: V,
    variant: Q
  }, se = oV(we);
  process.env.NODE_ENV !== "production" && V && !l && console.error("MUI: `children` must be passed when using the `TextField` component with `select`.");
  const U = Ir(y), de = b && U ? `${U}-helper-text` : void 0, ce = R && U ? `${U}-label` : void 0, K = rV[Q], Z = {
    slots: X,
    slotProps: {
      input: P,
      inputLabel: S,
      htmlInput: O,
      formHelperText: g,
      select: z,
      ...le
    }
  }, ue = {}, he = Z.slotProps.inputLabel;
  Q === "outlined" && (he && typeof he.shrink < "u" && (ue.notched = he.shrink), ue.label = R), V && ((!z || !z.native) && (ue.id = void 0), ue["aria-describedby"] = void 0);
  const [B, ee] = fn("input", {
    elementType: K,
    externalForwardedProps: Z,
    additionalProps: ue,
    ownerState: we
  }), [ie, ge] = fn("inputLabel", {
    elementType: Vh,
    externalForwardedProps: Z,
    ownerState: we
  }), [xe, pe] = fn("htmlInput", {
    elementType: "input",
    externalForwardedProps: Z,
    ownerState: we
  }), [Ee, Pe] = fn("formHelperText", {
    elementType: Bh,
    externalForwardedProps: Z,
    ownerState: we
  }), [Be, Ge] = fn("select", {
    elementType: Ed,
    externalForwardedProps: Z,
    ownerState: we
  }), Ie = /* @__PURE__ */ x.jsx(B, {
    "aria-describedby": de,
    autoComplete: i,
    autoFocus: a,
    defaultValue: p,
    fullWidth: v,
    multiline: _,
    name: I,
    rows: L,
    maxRows: E,
    minRows: M,
    type: ne,
    value: G,
    id: U,
    inputRef: k,
    onBlur: F,
    onChange: T,
    onFocus: $,
    placeholder: N,
    inputProps: pe,
    slots: {
      input: X.htmlInput ? xe : void 0
    },
    ...ee
  });
  return /* @__PURE__ */ x.jsxs(iV, {
    className: Me(se.root, u),
    disabled: m,
    error: h,
    fullWidth: v,
    ref: n,
    required: W,
    color: d,
    variant: Q,
    ownerState: we,
    ...be,
    children: [R != null && R !== "" && /* @__PURE__ */ x.jsx(ie, {
      htmlFor: U,
      id: ce,
      ...ge,
      children: R
    }), V ? /* @__PURE__ */ x.jsx(Be, {
      "aria-describedby": de,
      id: U,
      labelId: ce,
      value: G,
      input: Ie,
      ...Ge,
      children: l
    }) : Ie, b && /* @__PURE__ */ x.jsx(Ee, {
      id: de,
      ...Pe,
      children: b
    })]
  });
});
process.env.NODE_ENV !== "production" && (ms.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: o.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: o.bool,
  /**
   * @ignore
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: o.oneOfType([o.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), o.string]),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: o.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: o.bool,
  /**
   * Props applied to the [`FormHelperText`](https://mui.com/material-ui/api/form-helper-text/) element.
   * @deprecated Use `slotProps.formHelperText` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  FormHelperTextProps: o.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: o.bool,
  /**
   * The helper text content.
   */
  helperText: o.node,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: o.string,
  /**
   * Props applied to the [`InputLabel`](https://mui.com/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   * @deprecated Use `slotProps.inputLabel` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  InputLabelProps: o.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @deprecated Use `slotProps.htmlInput` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputProps: o.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](https://mui.com/material-ui/api/filled-input/),
   * [`OutlinedInput`](https://mui.com/material-ui/api/outlined-input/) or [`Input`](https://mui.com/material-ui/api/input/)
   * component depending on the `variant` prop value.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  InputProps: o.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: gn,
  /**
   * The label content.
   */
  label: o.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: o.oneOf(["dense", "none", "normal"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: o.oneOfType([o.number, o.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: o.oneOfType([o.number, o.string]),
  /**
   * If `true`, a `textarea` element is rendered instead of an input.
   * @default false
   */
  multiline: o.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: o.string,
  /**
   * @ignore
   */
  onBlur: o.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: o.func,
  /**
   * @ignore
   */
  onFocus: o.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: o.string,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: o.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: o.oneOfType([o.number, o.string]),
  /**
   * Render a [`Select`](https://mui.com/material-ui/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   * @default false
   */
  select: o.bool,
  /**
   * Props applied to the [`Select`](https://mui.com/material-ui/api/select/) element.
   * @deprecated Use `slotProps.select` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  SelectProps: o.object,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: o.oneOfType([o.oneOf(["medium", "small"]), o.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: o.shape({
    formHelperText: o.oneOfType([o.func, o.object]),
    htmlInput: o.oneOfType([o.func, o.object]),
    input: o.oneOfType([o.func, o.object]),
    inputLabel: o.oneOfType([o.func, o.object]),
    select: o.oneOfType([o.func, o.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: o.shape({
    formHelperText: o.elementType,
    htmlInput: o.elementType,
    input: o.elementType,
    inputLabel: o.elementType,
    select: o.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: o.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: o.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: o.oneOf(["filled", "outlined", "standard"])
});
const gf = rn(/* @__PURE__ */ x.jsx("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore");
var Bs = {}, Xx;
function aV() {
  if (Xx) return Bs;
  Xx = 1, Object.defineProperty(Bs, "__esModule", { value: !0 }), Bs.parse = l, Bs.serialize = p;
  const e = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/, t = /^[\u0021-\u003A\u003C-\u007E]*$/, n = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i, r = /^[\u0020-\u003A\u003D-\u007E]*$/, i = Object.prototype.toString, a = /* @__PURE__ */ (() => {
    const g = function() {
    };
    return g.prototype = /* @__PURE__ */ Object.create(null), g;
  })();
  function l(g, v) {
    const b = new a(), y = g.length;
    if (y < 2)
      return b;
    const S = (v == null ? void 0 : v.decode) || m;
    let O = 0;
    do {
      const P = g.indexOf("=", O);
      if (P === -1)
        break;
      const k = g.indexOf(";", O), R = k === -1 ? y : k;
      if (P > R) {
        O = g.lastIndexOf(";", P - 1) + 1;
        continue;
      }
      const E = u(g, O, P), M = d(g, P, E), _ = g.slice(E, M);
      if (b[_] === void 0) {
        let I = u(g, P + 1, R), F = d(g, R, I);
        const T = S(g.slice(I, F));
        b[_] = T;
      }
      O = R + 1;
    } while (O < y);
    return b;
  }
  function u(g, v, b) {
    do {
      const y = g.charCodeAt(v);
      if (y !== 32 && y !== 9)
        return v;
    } while (++v < b);
    return b;
  }
  function d(g, v, b) {
    for (; v > b; ) {
      const y = g.charCodeAt(--v);
      if (y !== 32 && y !== 9)
        return v + 1;
    }
    return b;
  }
  function p(g, v, b) {
    const y = (b == null ? void 0 : b.encode) || encodeURIComponent;
    if (!e.test(g))
      throw new TypeError(`argument name is invalid: ${g}`);
    const S = y(v);
    if (!t.test(S))
      throw new TypeError(`argument val is invalid: ${v}`);
    let O = g + "=" + S;
    if (!b)
      return O;
    if (b.maxAge !== void 0) {
      if (!Number.isInteger(b.maxAge))
        throw new TypeError(`option maxAge is invalid: ${b.maxAge}`);
      O += "; Max-Age=" + b.maxAge;
    }
    if (b.domain) {
      if (!n.test(b.domain))
        throw new TypeError(`option domain is invalid: ${b.domain}`);
      O += "; Domain=" + b.domain;
    }
    if (b.path) {
      if (!r.test(b.path))
        throw new TypeError(`option path is invalid: ${b.path}`);
      O += "; Path=" + b.path;
    }
    if (b.expires) {
      if (!h(b.expires) || !Number.isFinite(b.expires.valueOf()))
        throw new TypeError(`option expires is invalid: ${b.expires}`);
      O += "; Expires=" + b.expires.toUTCString();
    }
    if (b.httpOnly && (O += "; HttpOnly"), b.secure && (O += "; Secure"), b.partitioned && (O += "; Partitioned"), b.priority)
      switch (typeof b.priority == "string" ? b.priority.toLowerCase() : void 0) {
        case "low":
          O += "; Priority=Low";
          break;
        case "medium":
          O += "; Priority=Medium";
          break;
        case "high":
          O += "; Priority=High";
          break;
        default:
          throw new TypeError(`option priority is invalid: ${b.priority}`);
      }
    if (b.sameSite)
      switch (typeof b.sameSite == "string" ? b.sameSite.toLowerCase() : b.sameSite) {
        case !0:
        case "strict":
          O += "; SameSite=Strict";
          break;
        case "lax":
          O += "; SameSite=Lax";
          break;
        case "none":
          O += "; SameSite=None";
          break;
        default:
          throw new TypeError(`option sameSite is invalid: ${b.sameSite}`);
      }
    return O;
  }
  function m(g) {
    if (g.indexOf("%") === -1)
      return g;
    try {
      return decodeURIComponent(g);
    } catch {
      return g;
    }
  }
  function h(g) {
    return i.call(g) === "[object Date]";
  }
  return Bs;
}
aV();
/**
 * react-router v7.2.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function Hn(e, t) {
  if (e === !1 || e === null || typeof e > "u")
    throw new Error(t);
}
function ri(e, t) {
  if (!e) {
    typeof console < "u" && console.warn(t);
    try {
      throw new Error(t);
    } catch {
    }
  }
}
function qm({
  pathname: e = "/",
  search: t = "",
  hash: n = ""
}) {
  return t && t !== "?" && (e += t.charAt(0) === "?" ? t : "?" + t), n && n !== "#" && (e += n.charAt(0) === "#" ? n : "#" + n), e;
}
function Kh(e) {
  let t = {};
  if (e) {
    let n = e.indexOf("#");
    n >= 0 && (t.hash = e.substring(n), e = e.substring(0, n));
    let r = e.indexOf("?");
    r >= 0 && (t.search = e.substring(r), e = e.substring(0, r)), e && (t.pathname = e);
  }
  return t;
}
function AC(e, t, n = "/") {
  return sV(e, t, n, !1);
}
function sV(e, t, n, r) {
  let i = typeof t == "string" ? Kh(t) : t, a = fa(i.pathname || "/", n);
  if (a == null)
    return null;
  let l = NC(e);
  lV(l);
  let u = null;
  for (let d = 0; u == null && d < l.length; ++d) {
    let p = vV(a);
    u = yV(
      l[d],
      p,
      r
    );
  }
  return u;
}
function NC(e, t = [], n = [], r = "") {
  let i = (a, l, u) => {
    let d = {
      relativePath: u === void 0 ? a.path || "" : u,
      caseSensitive: a.caseSensitive === !0,
      childrenIndex: l,
      route: a
    };
    d.relativePath.startsWith("/") && (Hn(
      d.relativePath.startsWith(r),
      `Absolute route path "${d.relativePath}" nested under path "${r}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`
    ), d.relativePath = d.relativePath.slice(r.length));
    let p = Jo([r, d.relativePath]), m = n.concat(d);
    a.children && a.children.length > 0 && (Hn(
      // Our types know better, but runtime JS may not!
      // @ts-expect-error
      a.index !== !0,
      `Index routes must not have child routes. Please remove all child routes from route path "${p}".`
    ), NC(a.children, t, m, p)), !(a.path == null && !a.index) && t.push({
      path: p,
      score: hV(p, a.index),
      routesMeta: m
    });
  };
  return e.forEach((a, l) => {
    var u;
    if (a.path === "" || !((u = a.path) != null && u.includes("?")))
      i(a, l);
    else
      for (let d of FC(a.path))
        i(a, l, d);
  }), t;
}
function FC(e) {
  let t = e.split("/");
  if (t.length === 0) return [];
  let [n, ...r] = t, i = n.endsWith("?"), a = n.replace(/\?$/, "");
  if (r.length === 0)
    return i ? [a, ""] : [a];
  let l = FC(r.join("/")), u = [];
  return u.push(
    ...l.map(
      (d) => d === "" ? a : [a, d].join("/")
    )
  ), i && u.push(...l), u.map(
    (d) => e.startsWith("/") && d === "" ? "/" : d
  );
}
function lV(e) {
  e.sort(
    (t, n) => t.score !== n.score ? n.score - t.score : gV(
      t.routesMeta.map((r) => r.childrenIndex),
      n.routesMeta.map((r) => r.childrenIndex)
    )
  );
}
var cV = /^:[\w-]+$/, uV = 3, dV = 2, pV = 1, fV = 10, mV = -2, Qx = (e) => e === "*";
function hV(e, t) {
  let n = e.split("/"), r = n.length;
  return n.some(Qx) && (r += mV), t && (r += dV), n.filter((i) => !Qx(i)).reduce(
    (i, a) => i + (cV.test(a) ? uV : a === "" ? pV : fV),
    r
  );
}
function gV(e, t) {
  return e.length === t.length && e.slice(0, -1).every((r, i) => r === t[i]) ? (
    // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    e[e.length - 1] - t[t.length - 1]
  ) : (
    // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0
  );
}
function yV(e, t, n = !1) {
  let { routesMeta: r } = e, i = {}, a = "/", l = [];
  for (let u = 0; u < r.length; ++u) {
    let d = r[u], p = u === r.length - 1, m = a === "/" ? t : t.slice(a.length) || "/", h = Mu(
      { path: d.relativePath, caseSensitive: d.caseSensitive, end: p },
      m
    ), g = d.route;
    if (!h && p && n && !r[r.length - 1].route.index && (h = Mu(
      {
        path: d.relativePath,
        caseSensitive: d.caseSensitive,
        end: !1
      },
      m
    )), !h)
      return null;
    Object.assign(i, h.params), l.push({
      // TODO: Can this as be avoided?
      params: i,
      pathname: Jo([a, h.pathname]),
      pathnameBase: SV(
        Jo([a, h.pathnameBase])
      ),
      route: g
    }), h.pathnameBase !== "/" && (a = Jo([a, h.pathnameBase]));
  }
  return l;
}
function Mu(e, t) {
  typeof e == "string" && (e = { path: e, caseSensitive: !1, end: !0 });
  let [n, r] = bV(
    e.path,
    e.caseSensitive,
    e.end
  ), i = t.match(n);
  if (!i) return null;
  let a = i[0], l = a.replace(/(.)\/+$/, "$1"), u = i.slice(1);
  return {
    params: r.reduce(
      (p, { paramName: m, isOptional: h }, g) => {
        if (m === "*") {
          let b = u[g] || "";
          l = a.slice(0, a.length - b.length).replace(/(.)\/+$/, "$1");
        }
        const v = u[g];
        return h && !v ? p[m] = void 0 : p[m] = (v || "").replace(/%2F/g, "/"), p;
      },
      {}
    ),
    pathname: a,
    pathnameBase: l,
    pattern: e
  };
}
function bV(e, t = !1, n = !0) {
  ri(
    e === "*" || !e.endsWith("*") || e.endsWith("/*"),
    `Route path "${e}" will be treated as if it were "${e.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${e.replace(/\*$/, "/*")}".`
  );
  let r = [], i = "^" + e.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(
    /\/:([\w-]+)(\?)?/g,
    (l, u, d) => (r.push({ paramName: u, isOptional: d != null }), d ? "/?([^\\/]+)?" : "/([^\\/]+)")
  );
  return e.endsWith("*") ? (r.push({ paramName: "*" }), i += e === "*" || e === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$") : n ? i += "\\/*$" : e !== "" && e !== "/" && (i += "(?:(?=\\/|$))"), [new RegExp(i, t ? void 0 : "i"), r];
}
function vV(e) {
  try {
    return e.split("/").map((t) => decodeURIComponent(t).replace(/\//g, "%2F")).join("/");
  } catch (t) {
    return ri(
      !1,
      `The URL path "${e}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${t}).`
    ), e;
  }
}
function fa(e, t) {
  if (t === "/") return e;
  if (!e.toLowerCase().startsWith(t.toLowerCase()))
    return null;
  let n = t.endsWith("/") ? t.length - 1 : t.length, r = e.charAt(n);
  return r && r !== "/" ? null : e.slice(n) || "/";
}
function xV(e, t = "/") {
  let {
    pathname: n,
    search: r = "",
    hash: i = ""
  } = typeof e == "string" ? Kh(e) : e;
  return {
    pathname: n ? n.startsWith("/") ? n : wV(n, t) : t,
    search: OV(r),
    hash: TV(i)
  };
}
function wV(e, t) {
  let n = t.replace(/\/+$/, "").split("/");
  return e.split("/").forEach((i) => {
    i === ".." ? n.length > 1 && n.pop() : i !== "." && n.push(i);
  }), n.length > 1 ? n.join("/") : "/";
}
function yf(e, t, n, r) {
  return `Cannot include a '${e}' character in a manually specified \`to.${t}\` field [${JSON.stringify(
    r
  )}].  Please separate it out to the \`to.${n}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function CV(e) {
  return e.filter(
    (t, n) => n === 0 || t.route.path && t.route.path.length > 0
  );
}
function LC(e) {
  let t = CV(e);
  return t.map(
    (n, r) => r === t.length - 1 ? n.pathname : n.pathnameBase
  );
}
function BC(e, t, n, r = !1) {
  let i;
  typeof e == "string" ? i = Kh(e) : (i = { ...e }, Hn(
    !i.pathname || !i.pathname.includes("?"),
    yf("?", "pathname", "search", i)
  ), Hn(
    !i.pathname || !i.pathname.includes("#"),
    yf("#", "pathname", "hash", i)
  ), Hn(
    !i.search || !i.search.includes("#"),
    yf("#", "search", "hash", i)
  ));
  let a = e === "" || i.pathname === "", l = a ? "/" : i.pathname, u;
  if (l == null)
    u = n;
  else {
    let h = t.length - 1;
    if (!r && l.startsWith("..")) {
      let g = l.split("/");
      for (; g[0] === ".."; )
        g.shift(), h -= 1;
      i.pathname = g.join("/");
    }
    u = h >= 0 ? t[h] : "/";
  }
  let d = xV(i, u), p = l && l !== "/" && l.endsWith("/"), m = (a || l === ".") && n.endsWith("/");
  return !d.pathname.endsWith("/") && (p || m) && (d.pathname += "/"), d;
}
var Jo = (e) => e.join("/").replace(/\/\/+/g, "/"), SV = (e) => e.replace(/\/+$/, "").replace(/^\/*/, "/"), OV = (e) => !e || e === "?" ? "" : e.startsWith("?") ? e : "?" + e, TV = (e) => !e || e === "#" ? "" : e.startsWith("#") ? e : "#" + e;
function EV(e) {
  return e != null && typeof e.status == "number" && typeof e.statusText == "string" && typeof e.internal == "boolean" && "data" in e;
}
var VC = [
  "POST",
  "PUT",
  "PATCH",
  "DELETE"
];
new Set(
  VC
);
var RV = [
  "GET",
  ...VC
];
new Set(RV);
var hs = w.createContext(null);
hs.displayName = "DataRouter";
var Rd = w.createContext(null);
Rd.displayName = "DataRouterState";
var zC = w.createContext({
  isTransitioning: !1
});
zC.displayName = "ViewTransition";
var kV = w.createContext(
  /* @__PURE__ */ new Map()
);
kV.displayName = "Fetchers";
var PV = w.createContext(null);
PV.displayName = "Await";
var ii = w.createContext(
  null
);
ii.displayName = "Navigation";
var Xh = w.createContext(
  null
);
Xh.displayName = "Location";
var ai = w.createContext({
  outlet: null,
  matches: [],
  isDataRoute: !1
});
ai.displayName = "Route";
var Qh = w.createContext(null);
Qh.displayName = "RouteError";
function DV(e, { relative: t } = {}) {
  Hn(
    kd(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component."
  );
  let { basename: n, navigator: r } = w.useContext(ii), { hash: i, pathname: a, search: l } = ql(e, { relative: t }), u = a;
  return n !== "/" && (u = a === "/" ? n : Jo([n, a])), r.createHref({ pathname: u, search: l, hash: i });
}
function kd() {
  return w.useContext(Xh) != null;
}
function ha() {
  return Hn(
    kd(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component."
  ), w.useContext(Xh).location;
}
var WC = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
function qC(e) {
  w.useContext(ii).static || w.useLayoutEffect(e);
}
function MV() {
  let { isDataRoute: e } = w.useContext(ai);
  return e ? qV() : _V();
}
function _V() {
  Hn(
    kd(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component."
  );
  let e = w.useContext(hs), { basename: t, navigator: n } = w.useContext(ii), { matches: r } = w.useContext(ai), { pathname: i } = ha(), a = JSON.stringify(LC(r)), l = w.useRef(!1);
  return qC(() => {
    l.current = !0;
  }), w.useCallback(
    (d, p = {}) => {
      if (ri(l.current, WC), !l.current) return;
      if (typeof d == "number") {
        n.go(d);
        return;
      }
      let m = BC(
        d,
        JSON.parse(a),
        i,
        p.relative === "path"
      );
      e == null && t !== "/" && (m.pathname = m.pathname === "/" ? t : Jo([t, m.pathname])), (p.replace ? n.replace : n.push)(
        m,
        p.state,
        p
      );
    },
    [
      t,
      n,
      a,
      i,
      e
    ]
  );
}
w.createContext(null);
function ql(e, { relative: t } = {}) {
  let { matches: n } = w.useContext(ai), { pathname: r } = ha(), i = JSON.stringify(LC(n));
  return w.useMemo(
    () => BC(
      e,
      JSON.parse(i),
      r,
      t === "path"
    ),
    [e, i, r, t]
  );
}
function IV(e, t, n, r) {
  Hn(
    kd(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useRoutes() may be used only in the context of a <Router> component."
  );
  let { navigator: i, static: a } = w.useContext(ii), { matches: l } = w.useContext(ai), u = l[l.length - 1], d = u ? u.params : {}, p = u ? u.pathname : "/", m = u ? u.pathnameBase : "/", h = u && u.route;
  {
    let P = h && h.path || "";
    HC(
      p,
      !h || P.endsWith("*") || P.endsWith("*?"),
      `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${p}" (under <Route path="${P}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${P}"> to <Route path="${P === "/" ? "*" : `${P}/*`}">.`
    );
  }
  let g = ha(), v;
  v = g;
  let b = v.pathname || "/", y = b;
  if (m !== "/") {
    let P = m.replace(/^\//, "").split("/");
    y = "/" + b.replace(/^\//, "").split("/").slice(P.length).join("/");
  }
  let S = !a && n && n.matches && n.matches.length > 0 ? n.matches : AC(e, { pathname: y });
  return ri(
    h || S != null,
    `No routes matched location "${v.pathname}${v.search}${v.hash}" `
  ), ri(
    S == null || S[S.length - 1].route.element !== void 0 || S[S.length - 1].route.Component !== void 0 || S[S.length - 1].route.lazy !== void 0,
    `Matched leaf route at location "${v.pathname}${v.search}${v.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`
  ), FV(
    S && S.map(
      (P) => Object.assign({}, P, {
        params: Object.assign({}, d, P.params),
        pathname: Jo([
          m,
          // Re-encode pathnames that were decoded inside matchRoutes
          i.encodeLocation ? i.encodeLocation(P.pathname).pathname : P.pathname
        ]),
        pathnameBase: P.pathnameBase === "/" ? m : Jo([
          m,
          // Re-encode pathnames that were decoded inside matchRoutes
          i.encodeLocation ? i.encodeLocation(P.pathnameBase).pathname : P.pathnameBase
        ])
      })
    ),
    l,
    n,
    r
  );
}
function jV() {
  let e = WV(), t = EV(e) ? `${e.status} ${e.statusText}` : e instanceof Error ? e.message : JSON.stringify(e), n = e instanceof Error ? e.stack : null, r = "rgba(200,200,200, 0.5)", i = { padding: "0.5rem", backgroundColor: r }, a = { padding: "2px 4px", backgroundColor: r }, l = null;
  return console.error(
    "Error handled by React Router default ErrorBoundary:",
    e
  ), l = /* @__PURE__ */ w.createElement(w.Fragment, null, /* @__PURE__ */ w.createElement("p", null, "💿 Hey developer 👋"), /* @__PURE__ */ w.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ w.createElement("code", { style: a }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ w.createElement("code", { style: a }, "errorElement"), " prop on your route.")), /* @__PURE__ */ w.createElement(w.Fragment, null, /* @__PURE__ */ w.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ w.createElement("h3", { style: { fontStyle: "italic" } }, t), n ? /* @__PURE__ */ w.createElement("pre", { style: i }, n) : null, l);
}
var $V = /* @__PURE__ */ w.createElement(jV, null), AV = class extends w.Component {
  constructor(e) {
    super(e), this.state = {
      location: e.location,
      revalidation: e.revalidation,
      error: e.error
    };
  }
  static getDerivedStateFromError(e) {
    return { error: e };
  }
  static getDerivedStateFromProps(e, t) {
    return t.location !== e.location || t.revalidation !== "idle" && e.revalidation === "idle" ? {
      error: e.error,
      location: e.location,
      revalidation: e.revalidation
    } : {
      error: e.error !== void 0 ? e.error : t.error,
      location: t.location,
      revalidation: e.revalidation || t.revalidation
    };
  }
  componentDidCatch(e, t) {
    console.error(
      "React Router caught the following error during render",
      e,
      t
    );
  }
  render() {
    return this.state.error !== void 0 ? /* @__PURE__ */ w.createElement(ai.Provider, { value: this.props.routeContext }, /* @__PURE__ */ w.createElement(
      Qh.Provider,
      {
        value: this.state.error,
        children: this.props.component
      }
    )) : this.props.children;
  }
};
function NV({ routeContext: e, match: t, children: n }) {
  let r = w.useContext(hs);
  return r && r.static && r.staticContext && (t.route.errorElement || t.route.ErrorBoundary) && (r.staticContext._deepestRenderedBoundaryId = t.route.id), /* @__PURE__ */ w.createElement(ai.Provider, { value: e }, n);
}
function FV(e, t = [], n = null, r = null) {
  if (e == null) {
    if (!n)
      return null;
    if (n.errors)
      e = n.matches;
    else if (t.length === 0 && !n.initialized && n.matches.length > 0)
      e = n.matches;
    else
      return null;
  }
  let i = e, a = n == null ? void 0 : n.errors;
  if (a != null) {
    let d = i.findIndex(
      (p) => p.route.id && (a == null ? void 0 : a[p.route.id]) !== void 0
    );
    Hn(
      d >= 0,
      `Could not find a matching route for errors on route IDs: ${Object.keys(
        a
      ).join(",")}`
    ), i = i.slice(
      0,
      Math.min(i.length, d + 1)
    );
  }
  let l = !1, u = -1;
  if (n)
    for (let d = 0; d < i.length; d++) {
      let p = i[d];
      if ((p.route.HydrateFallback || p.route.hydrateFallbackElement) && (u = d), p.route.id) {
        let { loaderData: m, errors: h } = n, g = p.route.loader && !m.hasOwnProperty(p.route.id) && (!h || h[p.route.id] === void 0);
        if (p.route.lazy || g) {
          l = !0, u >= 0 ? i = i.slice(0, u + 1) : i = [i[0]];
          break;
        }
      }
    }
  return i.reduceRight((d, p, m) => {
    let h, g = !1, v = null, b = null;
    n && (h = a && p.route.id ? a[p.route.id] : void 0, v = p.route.errorElement || $V, l && (u < 0 && m === 0 ? (HC(
      "route-fallback",
      !1,
      "No `HydrateFallback` element provided to render during initial hydration"
    ), g = !0, b = null) : u === m && (g = !0, b = p.route.hydrateFallbackElement || null)));
    let y = t.concat(i.slice(0, m + 1)), S = () => {
      let O;
      return h ? O = v : g ? O = b : p.route.Component ? O = /* @__PURE__ */ w.createElement(p.route.Component, null) : p.route.element ? O = p.route.element : O = d, /* @__PURE__ */ w.createElement(
        NV,
        {
          match: p,
          routeContext: {
            outlet: d,
            matches: y,
            isDataRoute: n != null
          },
          children: O
        }
      );
    };
    return n && (p.route.ErrorBoundary || p.route.errorElement || m === 0) ? /* @__PURE__ */ w.createElement(
      AV,
      {
        location: n.location,
        revalidation: n.revalidation,
        component: v,
        error: h,
        children: S(),
        routeContext: { outlet: null, matches: y, isDataRoute: !0 }
      }
    ) : S();
  }, null);
}
function Zh(e) {
  return `${e} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function LV(e) {
  let t = w.useContext(hs);
  return Hn(t, Zh(e)), t;
}
function BV(e) {
  let t = w.useContext(Rd);
  return Hn(t, Zh(e)), t;
}
function VV(e) {
  let t = w.useContext(ai);
  return Hn(t, Zh(e)), t;
}
function Jh(e) {
  let t = VV(e), n = t.matches[t.matches.length - 1];
  return Hn(
    n.route.id,
    `${e} can only be used on routes that contain a unique "id"`
  ), n.route.id;
}
function zV() {
  return Jh(
    "useRouteId"
    /* UseRouteId */
  );
}
function WV() {
  var r;
  let e = w.useContext(Qh), t = BV(
    "useRouteError"
    /* UseRouteError */
  ), n = Jh(
    "useRouteError"
    /* UseRouteError */
  );
  return e !== void 0 ? e : (r = t.errors) == null ? void 0 : r[n];
}
function qV() {
  let { router: e } = LV(
    "useNavigate"
    /* UseNavigateStable */
  ), t = Jh(
    "useNavigate"
    /* UseNavigateStable */
  ), n = w.useRef(!1);
  return qC(() => {
    n.current = !0;
  }), w.useCallback(
    async (i, a = {}) => {
      ri(n.current, WC), n.current && (typeof i == "number" ? e.navigate(i) : await e.navigate(i, { fromRouteId: t, ...a }));
    },
    [e, t]
  );
}
var Zx = {};
function HC(e, t, n) {
  !t && !Zx[e] && (Zx[e] = !0, ri(!1, n));
}
w.memo(HV);
function HV({
  routes: e,
  future: t,
  state: n
}) {
  return IV(e, void 0, n, t);
}
var fu = "get", mu = "application/x-www-form-urlencoded";
function Pd(e) {
  return e != null && typeof e.tagName == "string";
}
function UV(e) {
  return Pd(e) && e.tagName.toLowerCase() === "button";
}
function YV(e) {
  return Pd(e) && e.tagName.toLowerCase() === "form";
}
function GV(e) {
  return Pd(e) && e.tagName.toLowerCase() === "input";
}
function KV(e) {
  return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}
function XV(e, t) {
  return e.button === 0 && // Ignore everything but left clicks
  (!t || t === "_self") && // Let browser handle "target=_blank" etc.
  !KV(e);
}
var Xc = null;
function QV() {
  if (Xc === null)
    try {
      new FormData(
        document.createElement("form"),
        // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0
      ), Xc = !1;
    } catch {
      Xc = !0;
    }
  return Xc;
}
var ZV = /* @__PURE__ */ new Set([
  "application/x-www-form-urlencoded",
  "multipart/form-data",
  "text/plain"
]);
function bf(e) {
  return e != null && !ZV.has(e) ? (ri(
    !1,
    `"${e}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${mu}"`
  ), null) : e;
}
function JV(e, t) {
  let n, r, i, a, l;
  if (YV(e)) {
    let u = e.getAttribute("action");
    r = u ? fa(u, t) : null, n = e.getAttribute("method") || fu, i = bf(e.getAttribute("enctype")) || mu, a = new FormData(e);
  } else if (UV(e) || GV(e) && (e.type === "submit" || e.type === "image")) {
    let u = e.form;
    if (u == null)
      throw new Error(
        'Cannot submit a <button> or <input type="submit"> without a <form>'
      );
    let d = e.getAttribute("formaction") || u.getAttribute("action");
    if (r = d ? fa(d, t) : null, n = e.getAttribute("formmethod") || u.getAttribute("method") || fu, i = bf(e.getAttribute("formenctype")) || bf(u.getAttribute("enctype")) || mu, a = new FormData(u, e), !QV()) {
      let { name: p, type: m, value: h } = e;
      if (m === "image") {
        let g = p ? `${p}.` : "";
        a.append(`${g}x`, "0"), a.append(`${g}y`, "0");
      } else p && a.append(p, h);
    }
  } else {
    if (Pd(e))
      throw new Error(
        'Cannot submit element that is not <form>, <button>, or <input type="submit|image">'
      );
    n = fu, r = null, i = mu, l = e;
  }
  return a && i === "text/plain" && (l = a, a = void 0), { action: r, method: n.toLowerCase(), encType: i, formData: a, body: l };
}
function eg(e, t) {
  if (e === !1 || e === null || typeof e > "u")
    throw new Error(t);
}
async function ez(e, t) {
  if (e.id in t)
    return t[e.id];
  try {
    let n = await import(
      /* @vite-ignore */
      /* webpackIgnore: true */
      e.module
    );
    return t[e.id] = n, n;
  } catch (n) {
    return console.error(
      `Error loading route module \`${e.module}\`, reloading page...`
    ), console.error(n), window.__reactRouterContext && window.__reactRouterContext.isSpaMode, window.location.reload(), new Promise(() => {
    });
  }
}
function tz(e) {
  return e == null ? !1 : e.href == null ? e.rel === "preload" && typeof e.imageSrcSet == "string" && typeof e.imageSizes == "string" : typeof e.rel == "string" && typeof e.href == "string";
}
async function nz(e, t, n) {
  let r = await Promise.all(
    e.map(async (i) => {
      let a = t.routes[i.route.id];
      if (a) {
        let l = await ez(a, n);
        return l.links ? l.links() : [];
      }
      return [];
    })
  );
  return az(
    r.flat(1).filter(tz).filter((i) => i.rel === "stylesheet" || i.rel === "preload").map(
      (i) => i.rel === "stylesheet" ? { ...i, rel: "prefetch", as: "style" } : { ...i, rel: "prefetch" }
    )
  );
}
function Jx(e, t, n, r, i, a) {
  let l = (d, p) => n[p] ? d.route.id !== n[p].route.id : !0, u = (d, p) => {
    var m;
    return (
      // param change, /users/123 -> /users/456
      n[p].pathname !== d.pathname || // splat param changed, which is not present in match.path
      // e.g. /files/images/avatar.jpg -> files/finances.xls
      ((m = n[p].route.path) == null ? void 0 : m.endsWith("*")) && n[p].params["*"] !== d.params["*"]
    );
  };
  return a === "assets" ? t.filter(
    (d, p) => l(d, p) || u(d, p)
  ) : a === "data" ? t.filter((d, p) => {
    var h;
    let m = r.routes[d.route.id];
    if (!m || !m.hasLoader)
      return !1;
    if (l(d, p) || u(d, p))
      return !0;
    if (d.route.shouldRevalidate) {
      let g = d.route.shouldRevalidate({
        currentUrl: new URL(
          i.pathname + i.search + i.hash,
          window.origin
        ),
        currentParams: ((h = n[0]) == null ? void 0 : h.params) || {},
        nextUrl: new URL(e, window.origin),
        nextParams: d.params,
        defaultShouldRevalidate: !0
      });
      if (typeof g == "boolean")
        return g;
    }
    return !0;
  }) : [];
}
function rz(e, t, { includeHydrateFallback: n } = {}) {
  return oz(
    e.map((r) => {
      let i = t.routes[r.route.id];
      if (!i) return [];
      let a = [i.module];
      return i.clientActionModule && (a = a.concat(i.clientActionModule)), i.clientLoaderModule && (a = a.concat(i.clientLoaderModule)), n && i.hydrateFallbackModule && (a = a.concat(i.hydrateFallbackModule)), i.imports && (a = a.concat(i.imports)), a;
    }).flat(1)
  );
}
function oz(e) {
  return [...new Set(e)];
}
function iz(e) {
  let t = {}, n = Object.keys(e).sort();
  for (let r of n)
    t[r] = e[r];
  return t;
}
function az(e, t) {
  let n = /* @__PURE__ */ new Set();
  return new Set(t), e.reduce((r, i) => {
    let a = JSON.stringify(iz(i));
    return n.has(a) || (n.add(a), r.push({ key: a, link: i })), r;
  }, []);
}
function sz(e) {
  let t = typeof e == "string" ? new URL(
    e,
    // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window > "u" ? "server://singlefetch/" : window.location.origin
  ) : e;
  return t.pathname === "/" ? t.pathname = "_root.data" : t.pathname = `${t.pathname.replace(/\/$/, "")}.data`, t;
}
function lz() {
  let e = w.useContext(hs);
  return eg(
    e,
    "You must render this element inside a <DataRouterContext.Provider> element"
  ), e;
}
function cz() {
  let e = w.useContext(Rd);
  return eg(
    e,
    "You must render this element inside a <DataRouterStateContext.Provider> element"
  ), e;
}
var tg = w.createContext(void 0);
tg.displayName = "FrameworkContext";
function UC() {
  let e = w.useContext(tg);
  return eg(
    e,
    "You must render this element inside a <HydratedRouter> element"
  ), e;
}
function uz(e, t) {
  let n = w.useContext(tg), [r, i] = w.useState(!1), [a, l] = w.useState(!1), { onFocus: u, onBlur: d, onMouseEnter: p, onMouseLeave: m, onTouchStart: h } = t, g = w.useRef(null);
  w.useEffect(() => {
    if (e === "render" && l(!0), e === "viewport") {
      let y = (O) => {
        O.forEach((P) => {
          l(P.isIntersecting);
        });
      }, S = new IntersectionObserver(y, { threshold: 0.5 });
      return g.current && S.observe(g.current), () => {
        S.disconnect();
      };
    }
  }, [e]), w.useEffect(() => {
    if (r) {
      let y = setTimeout(() => {
        l(!0);
      }, 100);
      return () => {
        clearTimeout(y);
      };
    }
  }, [r]);
  let v = () => {
    i(!0);
  }, b = () => {
    i(!1), l(!1);
  };
  return n ? e !== "intent" ? [a, g, {}] : [
    a,
    g,
    {
      onFocus: Vs(u, v),
      onBlur: Vs(d, b),
      onMouseEnter: Vs(p, v),
      onMouseLeave: Vs(m, b),
      onTouchStart: Vs(h, v)
    }
  ] : [!1, g, {}];
}
function Vs(e, t) {
  return (n) => {
    e && e(n), n.defaultPrevented || t(n);
  };
}
function dz({
  page: e,
  ...t
}) {
  let { router: n } = lz(), r = w.useMemo(
    () => AC(n.routes, e, n.basename),
    [n.routes, e, n.basename]
  );
  return r ? /* @__PURE__ */ w.createElement(fz, { page: e, matches: r, ...t }) : null;
}
function pz(e) {
  let { manifest: t, routeModules: n } = UC(), [r, i] = w.useState([]);
  return w.useEffect(() => {
    let a = !1;
    return nz(e, t, n).then(
      (l) => {
        a || i(l);
      }
    ), () => {
      a = !0;
    };
  }, [e, t, n]), r;
}
function fz({
  page: e,
  matches: t,
  ...n
}) {
  let r = ha(), { manifest: i, routeModules: a } = UC(), { loaderData: l, matches: u } = cz(), d = w.useMemo(
    () => Jx(
      e,
      t,
      u,
      i,
      r,
      "data"
    ),
    [e, t, u, i, r]
  ), p = w.useMemo(
    () => Jx(
      e,
      t,
      u,
      i,
      r,
      "assets"
    ),
    [e, t, u, i, r]
  ), m = w.useMemo(() => {
    if (e === r.pathname + r.search + r.hash)
      return [];
    let v = /* @__PURE__ */ new Set(), b = !1;
    if (t.forEach((S) => {
      var P;
      let O = i.routes[S.route.id];
      !O || !O.hasLoader || (!d.some((k) => k.route.id === S.route.id) && S.route.id in l && ((P = a[S.route.id]) != null && P.shouldRevalidate) || O.hasClientLoader ? b = !0 : v.add(S.route.id));
    }), v.size === 0)
      return [];
    let y = sz(e);
    return b && v.size > 0 && y.searchParams.set(
      "_routes",
      t.filter((S) => v.has(S.route.id)).map((S) => S.route.id).join(",")
    ), [y.pathname + y.search];
  }, [
    l,
    r,
    i,
    d,
    t,
    e,
    a
  ]), h = w.useMemo(
    () => rz(p, i),
    [p, i]
  ), g = pz(p);
  return /* @__PURE__ */ w.createElement(w.Fragment, null, m.map((v) => /* @__PURE__ */ w.createElement("link", { key: v, rel: "prefetch", as: "fetch", href: v, ...n })), h.map((v) => /* @__PURE__ */ w.createElement("link", { key: v, rel: "modulepreload", href: v, ...n })), g.map(({ key: v, link: b }) => (
    // these don't spread `linkProps` because they are full link descriptors
    // already with their own props
    /* @__PURE__ */ w.createElement("link", { key: v, ...b })
  )));
}
function mz(...e) {
  return (t) => {
    e.forEach((n) => {
      typeof n == "function" ? n(t) : n != null && (n.current = t);
    });
  };
}
var YC = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
try {
  YC && (window.__reactRouterVersion = "7.2.0");
} catch {
}
var GC = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i, ng = w.forwardRef(
  function({
    onClick: t,
    discover: n = "render",
    prefetch: r = "none",
    relative: i,
    reloadDocument: a,
    replace: l,
    state: u,
    target: d,
    to: p,
    preventScrollReset: m,
    viewTransition: h,
    ...g
  }, v) {
    let { basename: b } = w.useContext(ii), y = typeof p == "string" && GC.test(p), S, O = !1;
    if (typeof p == "string" && y && (S = p, YC))
      try {
        let F = new URL(window.location.href), T = p.startsWith("//") ? new URL(F.protocol + p) : new URL(p), $ = fa(T.pathname, b);
        T.origin === F.origin && $ != null ? p = $ + T.search + T.hash : O = !0;
      } catch {
        ri(
          !1,
          `<Link to="${p}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`
        );
      }
    let P = DV(p, { relative: i }), [k, R, E] = uz(
      r,
      g
    ), M = bz(p, {
      replace: l,
      state: u,
      target: d,
      preventScrollReset: m,
      relative: i,
      viewTransition: h
    });
    function _(F) {
      t && t(F), F.defaultPrevented || M(F);
    }
    let I = (
      // eslint-disable-next-line jsx-a11y/anchor-has-content
      /* @__PURE__ */ w.createElement(
        "a",
        {
          ...g,
          ...E,
          href: S || P,
          onClick: O || a ? t : _,
          ref: mz(v, R),
          target: d,
          "data-discover": !y && n === "render" ? "true" : void 0
        }
      )
    );
    return k && !y ? /* @__PURE__ */ w.createElement(w.Fragment, null, I, /* @__PURE__ */ w.createElement(dz, { page: P })) : I;
  }
);
ng.displayName = "Link";
var hz = w.forwardRef(
  function({
    "aria-current": t = "page",
    caseSensitive: n = !1,
    className: r = "",
    end: i = !1,
    style: a,
    to: l,
    viewTransition: u,
    children: d,
    ...p
  }, m) {
    let h = ql(l, { relative: p.relative }), g = ha(), v = w.useContext(Rd), { navigator: b, basename: y } = w.useContext(ii), S = v != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    Sz(h) && u === !0, O = b.encodeLocation ? b.encodeLocation(h).pathname : h.pathname, P = g.pathname, k = v && v.navigation && v.navigation.location ? v.navigation.location.pathname : null;
    n || (P = P.toLowerCase(), k = k ? k.toLowerCase() : null, O = O.toLowerCase()), k && y && (k = fa(k, y) || k);
    const R = O !== "/" && O.endsWith("/") ? O.length - 1 : O.length;
    let E = P === O || !i && P.startsWith(O) && P.charAt(R) === "/", M = k != null && (k === O || !i && k.startsWith(O) && k.charAt(O.length) === "/"), _ = {
      isActive: E,
      isPending: M,
      isTransitioning: S
    }, I = E ? t : void 0, F;
    typeof r == "function" ? F = r(_) : F = [
      r,
      E ? "active" : null,
      M ? "pending" : null,
      S ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let T = typeof a == "function" ? a(_) : a;
    return /* @__PURE__ */ w.createElement(
      ng,
      {
        ...p,
        "aria-current": I,
        className: F,
        ref: m,
        style: T,
        to: l,
        viewTransition: u
      },
      typeof d == "function" ? d(_) : d
    );
  }
);
hz.displayName = "NavLink";
var gz = w.forwardRef(
  ({
    discover: e = "render",
    fetcherKey: t,
    navigate: n,
    reloadDocument: r,
    replace: i,
    state: a,
    method: l = fu,
    action: u,
    onSubmit: d,
    relative: p,
    preventScrollReset: m,
    viewTransition: h,
    ...g
  }, v) => {
    let b = wz(), y = Cz(u, { relative: p }), S = l.toLowerCase() === "get" ? "get" : "post", O = typeof u == "string" && GC.test(u), P = (k) => {
      if (d && d(k), k.defaultPrevented) return;
      k.preventDefault();
      let R = k.nativeEvent.submitter, E = (R == null ? void 0 : R.getAttribute("formmethod")) || l;
      b(R || k.currentTarget, {
        fetcherKey: t,
        method: E,
        navigate: n,
        replace: i,
        state: a,
        relative: p,
        preventScrollReset: m,
        viewTransition: h
      });
    };
    return /* @__PURE__ */ w.createElement(
      "form",
      {
        ref: v,
        method: S,
        action: y,
        onSubmit: r ? d : P,
        ...g,
        "data-discover": !O && e === "render" ? "true" : void 0
      }
    );
  }
);
gz.displayName = "Form";
function yz(e) {
  return `${e} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function KC(e) {
  let t = w.useContext(hs);
  return Hn(t, yz(e)), t;
}
function bz(e, {
  target: t,
  replace: n,
  state: r,
  preventScrollReset: i,
  relative: a,
  viewTransition: l
} = {}) {
  let u = MV(), d = ha(), p = ql(e, { relative: a });
  return w.useCallback(
    (m) => {
      if (XV(m, t)) {
        m.preventDefault();
        let h = n !== void 0 ? n : qm(d) === qm(p);
        u(e, {
          replace: h,
          state: r,
          preventScrollReset: i,
          relative: a,
          viewTransition: l
        });
      }
    },
    [
      d,
      u,
      p,
      n,
      r,
      t,
      e,
      i,
      a,
      l
    ]
  );
}
var vz = 0, xz = () => `__${String(++vz)}__`;
function wz() {
  let { router: e } = KC(
    "useSubmit"
    /* UseSubmit */
  ), { basename: t } = w.useContext(ii), n = zV();
  return w.useCallback(
    async (r, i = {}) => {
      let { action: a, method: l, encType: u, formData: d, body: p } = JV(
        r,
        t
      );
      if (i.navigate === !1) {
        let m = i.fetcherKey || xz();
        await e.fetch(m, n, i.action || a, {
          preventScrollReset: i.preventScrollReset,
          formData: d,
          body: p,
          formMethod: i.method || l,
          formEncType: i.encType || u,
          flushSync: i.flushSync
        });
      } else
        await e.navigate(i.action || a, {
          preventScrollReset: i.preventScrollReset,
          formData: d,
          body: p,
          formMethod: i.method || l,
          formEncType: i.encType || u,
          replace: i.replace,
          state: i.state,
          fromRouteId: n,
          flushSync: i.flushSync,
          viewTransition: i.viewTransition
        });
    },
    [e, t, n]
  );
}
function Cz(e, { relative: t } = {}) {
  let { basename: n } = w.useContext(ii), r = w.useContext(ai);
  Hn(r, "useFormAction must be used inside a RouteContext");
  let [i] = r.matches.slice(-1), a = { ...ql(e || ".", { relative: t }) }, l = ha();
  if (e == null) {
    a.search = l.search;
    let u = new URLSearchParams(a.search), d = u.getAll("index");
    if (d.some((m) => m === "")) {
      u.delete("index"), d.filter((h) => h).forEach((h) => u.append("index", h));
      let m = u.toString();
      a.search = m ? `?${m}` : "";
    }
  }
  return (!e || e === ".") && i.route.index && (a.search = a.search ? a.search.replace(/^\?/, "?index&") : "?index"), n !== "/" && (a.pathname = a.pathname === "/" ? n : Jo([n, a.pathname])), qm(a);
}
function Sz(e, t = {}) {
  let n = w.useContext(zC);
  Hn(
    n != null,
    "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?"
  );
  let { basename: r } = KC(
    "useViewTransitionState"
    /* useViewTransitionState */
  ), i = ql(e, { relative: t.relative });
  if (!n.isTransitioning)
    return !1;
  let a = fa(n.currentLocation.pathname, r) || n.currentLocation.pathname, l = fa(n.nextLocation.pathname, r) || n.nextLocation.pathname;
  return Mu(i.pathname, l) != null || Mu(i.pathname, a) != null;
}
new TextEncoder();
const ew = El((e, t) => {
  const { href: n, ...r } = e;
  return /* @__PURE__ */ x.jsx(ng, { ref: t, to: n, ...r });
}), Go = {
  fontFamily: "Lato, sans-serif",
  paletteOptions: {
    primary: {
      contrastText: "#ffffff",
      25: "E8F3D9",
      50: "#D8EBBF",
      100: "#C9E4A6",
      200: "#C9DC8C",
      300: "#A9D472",
      400: "#9ACD59",
      500: "#8AC53F",
      600: "#74A535",
      700: "#577B27",
      800: "#486620",
      900: "#324716",
      950: "#1C270C"
    },
    grey: {
      25: "#FBFBFB",
      50: "#F3F3F3",
      100: "#E1E1E2",
      200: "#D4D5D5",
      300: "#AEAEAF",
      400: "#878889",
      500: "#6D6E70",
      600: "#5E5F60",
      700: "#4F4F50",
      800: "#3F4041",
      900: "#303031",
      950: "#212121"
    }
  }
}, pt = Al({
  typography: {
    // text size reset
    fontSize: 24,
    fontFamily: Go.fontFamily,
    button: {
      textTransform: "none"
    },
    h1: {
      fontSize: "4.8rem"
    }
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          position: "initial",
          boxShadow: "none"
        }
      }
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: !0,
        LinkComponent: ew
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          fontSize: "1.8rem"
        }
      }
    },
    MuiCheckbox: {
      defaultProps: {
        disableRipple: !0
      }
    },
    MuiLink: {
      defaultProps: {
        component: ew
      },
      styleOverrides: {
        root: {
          textDecoration: "none",
          ":hover": {
            color: "inherit",
            textDecoration: "none"
          }
        }
      }
    }
  },
  palette: {
    primary: {
      main: Go.paletteOptions.primary[700],
      light: Go.paletteOptions.primary[600],
      dark: Go.paletteOptions.primary[800],
      ...Go.paletteOptions.primary
    },
    secondary: {
      main: Go.paletteOptions.grey[500],
      light: Go.paletteOptions.grey[200],
      dark: Go.paletteOptions.grey[700]
    },
    text: {
      primary: "#000000"
    },
    background: {
      default: dd[100]
    },
    success: {
      main: Xo[500],
      light: Xo[50],
      dark: Xo[800]
    },
    warning: {
      main: "#EF6C00",
      light: aa[50],
      dark: aa[700]
    },
    error: {
      main: Ko[500],
      light: Ko[50],
      dark: Ko[700]
    },
    info: {
      main: "#00A9E0",
      light: "#E5F7FC",
      dark: "#014361"
    },
    shadows: {
      light: "#10182808",
      dark: "#10182814"
    },
    grey: Go.paletteOptions.grey
  }
}), Er = pt.spacing(1), Oz = {
  borderRadius: Er,
  boxShadow: `0px 2px 4px -2px ${pt.palette.shadows.light}, 0px 4px 8px -2px ${pt.palette.shadows.dark}`,
  border: `1px solid ${pt.palette.grey[100]}`,
  marginTop: pt.spacing(0.5)
}, Qc = (e) => ({
  backgroundColor: pt.palette[e].light,
  borderColor: pt.palette[e].main,
  color: pt.palette[e].dark
}), zs = (e, t) => {
  switch (t) {
    case "outlined":
      return e === "primary" ? {
        borderWidth: "2px",
        backgroundColor: "#ffffff",
        borderColor: pt.palette.primary[400],
        color: pt.palette.primary[700],
        "&:hover": {
          backgroundColor: pt.palette.primary[25],
          borderColor: pt.palette.primary[100]
        }
      } : {
        backgroundColor: "#ffffff",
        borderColor: pt.palette.grey[200],
        color: pt.palette.grey[500],
        "&:hover": {
          backgroundColor: pt.palette.grey[50],
          borderColor: pt.palette.grey[400]
        }
      };
    case "contained":
      return e === "primary" ? {
        border: `1px solid ${pt.palette.primary[700]}`,
        color: "white",
        backgroundColor: pt.palette.primary[700],
        "&:hover": {
          border: `1px solid ${pt.palette.primary[300]}`,
          backgroundColor: pt.palette.primary[900]
        }
      } : {};
    default:
      return {};
  }
}, XC = Al(pt, {
  mixins: {
    // App toolbar height should be controlled from here so useAppBarHeight can pick it up
    toolbar: {
      minHeight: 80,
      "@media (min-width:600px)": { minHeight: 80 },
      "@media (min-width:0px) and (orientation: landscape)": { minHeight: 80 }
    },
    modalStyle: {
      position: "absolute",
      top: "50%",
      left: "50%",
      maxHeight: "75vh",
      display: "flex",
      transform: "translate(-50%, -50%)",
      width: 400,
      bgcolor: "background.paper",
      borderRadius: Er,
      border: "none",
      outline: "none",
      p: 3
    },
    activeButton: {
      border: `2px solid ${pt.palette.primary[500]} !important`,
      boxShadow: `0px 0px 0px 4px ${pt.palette.primary[50]}`,
      "&:hover": { backgroundColor: "white !important" }
    },
    roundedIconButton: {
      borderWidth: "1px",
      borderRadius: pt.spacing(1),
      borderStyle: "solid"
    }
  },
  components: {
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          height: 4
        }
      }
    },
    MuiAvatar: {
      styleOverrides: {
        rounded: {
          borderRadius: Er
        }
      }
    },
    MuiPaper: { styleOverrides: { root: Oz } },
    MuiFormControl: {
      styleOverrides: {
        root: {
          gap: 2
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontSize: "14px",
          color: pt.palette.grey[700]
        }
      }
    },
    MuiSelect: {
      defaultProps: {
        IconComponent: gf
      }
    },
    MuiAutocomplete: {
      defaultProps: {
        popupIcon: /* @__PURE__ */ x.jsx(gf, {})
      }
    },
    MuiPickersCalendarHeader: {
      defaultProps: {
        slots: {
          switchViewIcon: gf
        }
      }
    },
    MuiList: {
      styleOverrides: {
        root: {
          "& .MuiMenuItem-root + .MuiDivider-root": {
            marginTop: 0,
            marginBottom: 0
          }
        }
      }
    },
    MuiDivider: {
      defaultProps: {
        variant: "middle"
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&, input, fieldset": {
            borderRadius: Er,
            borderColor: pt.palette.grey[300]
          },
          "&:not(:is(:focus, .Mui-disabled)):hover fieldset.MuiOutlinedInput-notchedOutline": {
            borderColor: pt.palette.primary.light,
            borderWidth: "2px",
            textDecoration: "none"
          },
          "&:is(.Mui-focused, :focus) fieldset.MuiOutlinedInput-notchedOutline": {
            borderColor: `${pt.palette.primary.main} !important`,
            boxShadow: `0px 0px 0px 4px ${pt.palette.primary.light}7A`
          },
          "&:is(.Mui-disabled)": {
            backgroundColor: `${pt.palette.grey[50]}`
          }
        }
      }
    },
    MuiTable: {
      styleOverrides: {
        root: {
          boxShadow: `0px 1px 3px 0px ${pt.palette.shadows.light}, 0px 1px 2px 0px ${pt.palette.shadows.dark}`,
          borderRadius: Er,
          borderCollapse: "separate",
          border: `1px solid ${pt.palette.grey[50]}`
        }
      }
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: pt.palette.grey[50],
          fontWeight: 500,
          "& th:first-of-type": {
            borderTopLeftRadius: Er
          },
          "& th:last-of-type": {
            borderTopRightRadius: Er
          }
        }
      }
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          "& tr:last-of-type": {
            // Remove bottom border from last row
            "& td": {
              borderBottom: "none"
            },
            "& td:first-of-type": {
              borderBottomLeftRadius: Er
            },
            "td:last-of-type": {
              borderBottomRightRadius: Er
            }
          }
        }
      }
    },
    MuiMultiSectionDigitalClock: {
      styleOverrides: {
        root: {
          "& .MuiButtonBase-root": {
            borderRadius: Er
          }
        }
      }
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          borderRadius: Er,
          "&.MuiAlert-outlinedInfo": Qc("info"),
          "&.MuiAlert-outlinedError": Qc("error"),
          "&.MuiAlert-outlinedSuccess": Qc("success"),
          "&.MuiAlert-outlinedWarning": Qc("warning"),
          // Used to style alert content when it's an HTML string
          "& .MuiAlert-message *": {
            color: "inherit",
            margin: 0
          }
        }
      }
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          boxShadow: `0px 1px 2px 0px ${pt.palette.grey[700]}, 0px 1px 3px 0px ${pt.palette.grey[300]}`
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          padding: `${pt.spacing(1)} ${pt.spacing(1.5)}`,
          borderRadius: Er,
          fontSize: "14px",
          // Styles for outlined buttons
          "&.MuiButton-outlined:not(.Mui-disabled)": {
            "&.MuiButton-colorSecondary": zs("secondary", "outlined"),
            "&.MuiButton-colorPrimary": zs("primary", "outlined")
          },
          // Styles for contained buttons
          "&.MuiButton-contained:not(.Mui-disabled)": {
            boxShadow: "none",
            "&.MuiButton-colorPrimary": zs("primary", "contained")
          },
          // Used for buttons that render as a link
          "&.MuiButton-containedPrimary[href]:hover": {
            color: pt.palette.primary.contrastText
          },
          "&.Mui-disabled": {
            backgroundColor: pt.palette.grey[50],
            color: pt.palette.grey[400],
            border: `1px solid ${pt.palette.grey[200]}`
          }
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          "&:not(.Mui-disabled)": {
            "&.MuiIconButton-colorSecondary": zs("secondary", "outlined"),
            "&.MuiIconButton-colorPrimary": zs("primary", "outlined")
          },
          "&.Mui-disabled": {
            backgroundColor: pt.palette.grey[50],
            color: pt.palette.grey[400],
            border: `1px solid ${pt.palette.grey[200]}`
          },
          "&.openDatePickerIconButton.Mui-disabled": {
            border: "none"
          }
        }
      }
    },
    MuiSkeleton: {
      styleOverrides: {
        rounded: {
          borderRadius: Er
        }
      }
    }
  }
}), rg = (e) => (t) => /* @__PURE__ */ x.jsx(Z1, { theme: XC, children: /* @__PURE__ */ x.jsx(e, { ...t }) }), QC = ({ label: e, disabled: t, value: n, onChange: r, error: i, name: a, options: l, readOnly: u = !1, placeholderValue: d }) => {
  const p = d ?? "Select option";
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsxs(sr, { fullWidth: !0, size: "small", children: [
      e && /* @__PURE__ */ x.jsx(jr, { id: `${a}-label`, disabled: t, children: e }),
      /* @__PURE__ */ x.jsxs(
        Ed,
        {
          displayEmpty: !0,
          size: "small",
          value: n,
          name: a,
          error: !!i,
          labelId: `${a}-label`,
          disabled: t,
          onChange: (m) => r(m.target.value),
          readOnly: u,
          renderValue: (m) => !m || m.length === 0 ? /* @__PURE__ */ x.jsx(at, { variant: "inherit", color: "secondary", children: p }) : m,
          children: [
            /* @__PURE__ */ x.jsx(zm, { value: "", children: /* @__PURE__ */ x.jsx("em", { children: p }) }),
            l.map((m) => /* @__PURE__ */ x.jsx(zm, { value: m.value, children: m.label || m.value }, m.value))
          ]
        }
      )
    ] }),
    i && /* @__PURE__ */ x.jsx(at, { variant: "caption", color: "error", children: i.message })
  ] });
}, ZC = ({ color: e, IconComponent: t }) => /* @__PURE__ */ x.jsx(
  sn,
  {
    alignItems: "center",
    justifyContent: "center",
    flexShrink: "0",
    borderRadius: "24px",
    bgcolor: (n) => `${n.palette[e].light}33`,
    sx: { width: "48px", height: "48px" },
    children: /* @__PURE__ */ x.jsx(
      sn,
      {
        alignItems: "center",
        justifyContent: "center",
        flexShrink: "0",
        borderRadius: "24px",
        bgcolor: (n) => `${n.palette[e].light}33`,
        sx: { width: "36px", height: "36px" },
        children: /* @__PURE__ */ x.jsx(t, { opacity: 0.6, color: "secondary" })
      }
    )
  }
);
var Tn = /* @__PURE__ */ ((e) => (e.ID = "id", e.firstName = "First_Name", e.lastName = "Last_Name", e.preferredName = "Preferred_Name", e.gender = "Gender", e.dateOfBirth = "Date_of_Birth", e.cityOfBirth = "birth_city", e.occupation = "Occupation", e.age = "Age", e.countryOfBirth = "birth_country", e.residence = "permanent_residence", e.citizenship = "citizenship", e.email = "Email", e.mobile = "Mobile", e.homePhone = "home_number", e.workPhone = "Work_Phone", e.phone = "Phone", e.addressLine1 = "street", e.addressLine2 = "Address_Line_2", e.city = "city", e.postalCode = "postal_code", e.country = "country", e.state = "State", e.emergencyContactName = "Emergency_Contact", e.emergencyContactRelation = "EC_Relation_to_applicant_father_mother_friend_etc", e.emergencyContactPhoneNumber = "EC_Phone_Number", e.relationship = "Relationship", e.parentStatus = "Life_Status", e.isLegalGuardian = "Is_a_legal_guardian", e.contactClassification = "Contact_Classification", e.studentFamilyLookup = "Account_Name", e))(Tn || {}), Tz = /* @__PURE__ */ ((e) => (e.guardian = "Parent/Guardian", e.familyMember = "Student Family Member", e.friendsAndRelatives = "Friends / Relatives in the U.S.", e.student = "Student", e))(Tz || {}), Ez = /* @__PURE__ */ ((e) => (e.ID = "id", e.mostFavoriteActivity = "Most_Favorite_Activity", e.typeOfSchool = "Type_of_school_you_attend", e.typeOfSchoolOther = "If_other_please_explain", e.gradeLevel = "Current_grade_level", e.highestGradLevelSchool = "Highest_grade_level_in_your_secondary_high_school", e.graduationSituation = "Graduation_before_or_after_program", e.graduationDate = "High_School_Graduation_Date", e.yearsOfEnglish = "Years_of_English", e.nativeLanguage = "What_is_your_native_language", e.languageListGET = "Student_Language_Level__r", e.youngChildrenFeelings = "Young_Children_Feelings", e.attendReligiousServices = "Attend_Religious_Services", e.willAttendWithHostFamily = "Will_attend_with_host_family", e.religiousPreference = "Religious_Preference", e.religiousPreferenceOther = "If_other_Religious_Preference_please_explain", e.understandNoSmoking = "Understand_No_Smoking", e.adjustToSmokers = "Adjust_To_Smokers", e.doNotOwnPets = "I_do_not_own_any_pets", e.petsListGET = "Pets__r", e.adjustToIndoorPet = "Adjust_To_Indoor_Pet", e.noIndoorPetExplanation = "No_indoor_pet_explanation", e.afraidOfPets = "Afraid_Of_Pets", e.afraidOfPetExplanation = "Afraid_of_pet_explanation", e.acceptDoublePlacement = "Accept_Double_Placement", e.acceptSingleHost = "Accept_single_host", e.acceptSameSexCouple = "Accept_same_sex_couple", e.acceptSmallSchool = "Accept_Small_School", e.dietRestricted = "Diet_Restricted", e.prepareOwnMeals = "Prepare_Own_Meals", e.adjustToVegetarian = "Adjust_To_Vegetarian", e.allergicToAnimals = "Allergic_to_Animals", e.allergyDogReaction = "Allergy_Dog_Reaction", e.allergyCatReaction = "Allergy_Cat_Reaction", e.allergyHorseReaction = "Allergy_Horse_Reaction", e.allergyOtherAnimal = "Other_Allergy_Animal", e.allergyOtherAnimalExplanation = "Other_allergy_animal_explanation", e.nonAllergicDogBreeds = "Breeds_that_are_non_allergic", e.dogIndoorsNotInRoom = "Dog_indoors_but_not_in_room", e.dogOnlyAtNight = "A_dog_that_is_only_in_the_home_at_night", e.dogOccasionallyIndoors = "A_dog_that_is_only_occasionally_in_the_home", e.dogOutsideOnly = "A_dog_that_is_kept_exclusively_outside", e.catIndoorsNotInRoom = "Cat_indoors_but_not_in_room", e.catOnlyAtNight = "A_cat_that_is_only_in_the_home_at_night", e.catOccasionallyIndoors = "A_cat_that_is_only_occasionally_in_the_home", e.catOutsideOnly = "A_cat_that_is_kept_exclusively_outside", e.allergicToDust = "Are_you_allergic_to_dust", e.cannotLiveWithCarpet = "Can_t_live_in_home_with_carpet", e.allergicToFood = "Are_you_allergic_to_any_food_products", e.listFoodAllergies = "Please_list_any_foods_to_which_you_are_allergic", e.specialMeals = "Special_Meals", e.makeSpecialMeals = "Make_Special_Meals", e.allergicToPollen = "Are_you_allergic_to_pollen", e.wearsGlassesOrContacts = "Glasses_or_contacts", e.studentFamily = "Student_Family", e))(Ez || {}), Rz = /* @__PURE__ */ ((e) => (e.languageListPUT = "Student_Language_Level", e))(Rz || {}), kz = /* @__PURE__ */ ((e) => (e.id = "id", e.name = "Name", e.type = "Type_of_Animal", e.size = "Relative_Size_of_Animal", e))(kz || {}), Pz = /* @__PURE__ */ ((e) => (e.id = "id", e.language = "Language", e.numberOfYears = "No_of_Years", e))(Pz || {}), Dz = /* @__PURE__ */ ((e) => (e.programType = "Program_Type", e.ID = "id", e))(Dz || {}), Mz = /* @__PURE__ */ ((e) => (e.ID = "id", e.maritalStatus = "Are_your_parents", e.houseType = "Do_you_live_in", e.otherMaritalStatus = "If_other_please_explain", e.contactListGet = "Contacts__r", e))(Mz || {}), pr = /* @__PURE__ */ ((e) => (e.Text = "text", e.Date = "date", e.Radio = "radio", e.Dropdown = "dropdown", e.Checkbox = "checkbox", e.Checkboxset = "checkboxset", e.TagsAutocomplete = "tags-autocomplete", e.PictureUploader = "pictureuploader", e.FileUploader = "fileuploader", e.AddressAutocomplete = "address-autocomplete", e.SelectionRangeTable = "selection-range-table", e.Number = "number", e.Autocomplete = "autocomplete", e))(pr || {}), vf, tw;
function og() {
  if (tw) return vf;
  tw = 1;
  var e = Array.isArray;
  return vf = e, vf;
}
var xf, nw;
function _z() {
  if (nw) return xf;
  nw = 1;
  var e = typeof Ei == "object" && Ei && Ei.Object === Object && Ei;
  return xf = e, xf;
}
var wf, rw;
function ig() {
  if (rw) return wf;
  rw = 1;
  var e = _z(), t = typeof self == "object" && self && self.Object === Object && self, n = e || t || Function("return this")();
  return wf = n, wf;
}
var Cf, ow;
function ag() {
  if (ow) return Cf;
  ow = 1;
  var e = ig(), t = e.Symbol;
  return Cf = t, Cf;
}
var Sf, iw;
function Iz() {
  if (iw) return Sf;
  iw = 1;
  var e = ag(), t = Object.prototype, n = t.hasOwnProperty, r = t.toString, i = e ? e.toStringTag : void 0;
  function a(l) {
    var u = n.call(l, i), d = l[i];
    try {
      l[i] = void 0;
      var p = !0;
    } catch {
    }
    var m = r.call(l);
    return p && (u ? l[i] = d : delete l[i]), m;
  }
  return Sf = a, Sf;
}
var Of, aw;
function jz() {
  if (aw) return Of;
  aw = 1;
  var e = Object.prototype, t = e.toString;
  function n(r) {
    return t.call(r);
  }
  return Of = n, Of;
}
var Tf, sw;
function JC() {
  if (sw) return Tf;
  sw = 1;
  var e = ag(), t = Iz(), n = jz(), r = "[object Null]", i = "[object Undefined]", a = e ? e.toStringTag : void 0;
  function l(u) {
    return u == null ? u === void 0 ? i : r : a && a in Object(u) ? t(u) : n(u);
  }
  return Tf = l, Tf;
}
var Ef, lw;
function $z() {
  if (lw) return Ef;
  lw = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return Ef = e, Ef;
}
var Rf, cw;
function sg() {
  if (cw) return Rf;
  cw = 1;
  var e = JC(), t = $z(), n = "[object Symbol]";
  function r(i) {
    return typeof i == "symbol" || t(i) && e(i) == n;
  }
  return Rf = r, Rf;
}
var kf, uw;
function Az() {
  if (uw) return kf;
  uw = 1;
  var e = og(), t = sg(), n = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, r = /^\w*$/;
  function i(a, l) {
    if (e(a))
      return !1;
    var u = typeof a;
    return u == "number" || u == "symbol" || u == "boolean" || a == null || t(a) ? !0 : r.test(a) || !n.test(a) || l != null && a in Object(l);
  }
  return kf = i, kf;
}
var Pf, dw;
function eS() {
  if (dw) return Pf;
  dw = 1;
  function e(t) {
    var n = typeof t;
    return t != null && (n == "object" || n == "function");
  }
  return Pf = e, Pf;
}
var Df, pw;
function Nz() {
  if (pw) return Df;
  pw = 1;
  var e = JC(), t = eS(), n = "[object AsyncFunction]", r = "[object Function]", i = "[object GeneratorFunction]", a = "[object Proxy]";
  function l(u) {
    if (!t(u))
      return !1;
    var d = e(u);
    return d == r || d == i || d == n || d == a;
  }
  return Df = l, Df;
}
var Mf, fw;
function Fz() {
  if (fw) return Mf;
  fw = 1;
  var e = ig(), t = e["__core-js_shared__"];
  return Mf = t, Mf;
}
var _f, mw;
function Lz() {
  if (mw) return _f;
  mw = 1;
  var e = Fz(), t = function() {
    var r = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return r ? "Symbol(src)_1." + r : "";
  }();
  function n(r) {
    return !!t && t in r;
  }
  return _f = n, _f;
}
var If, hw;
function Bz() {
  if (hw) return If;
  hw = 1;
  var e = Function.prototype, t = e.toString;
  function n(r) {
    if (r != null) {
      try {
        return t.call(r);
      } catch {
      }
      try {
        return r + "";
      } catch {
      }
    }
    return "";
  }
  return If = n, If;
}
var jf, gw;
function Vz() {
  if (gw) return jf;
  gw = 1;
  var e = Nz(), t = Lz(), n = eS(), r = Bz(), i = /[\\^$.*+?()[\]{}|]/g, a = /^\[object .+?Constructor\]$/, l = Function.prototype, u = Object.prototype, d = l.toString, p = u.hasOwnProperty, m = RegExp(
    "^" + d.call(p).replace(i, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function h(g) {
    if (!n(g) || t(g))
      return !1;
    var v = e(g) ? m : a;
    return v.test(r(g));
  }
  return jf = h, jf;
}
var $f, yw;
function zz() {
  if (yw) return $f;
  yw = 1;
  function e(t, n) {
    return t == null ? void 0 : t[n];
  }
  return $f = e, $f;
}
var Af, bw;
function tS() {
  if (bw) return Af;
  bw = 1;
  var e = Vz(), t = zz();
  function n(r, i) {
    var a = t(r, i);
    return e(a) ? a : void 0;
  }
  return Af = n, Af;
}
var Nf, vw;
function Dd() {
  if (vw) return Nf;
  vw = 1;
  var e = tS(), t = e(Object, "create");
  return Nf = t, Nf;
}
var Ff, xw;
function Wz() {
  if (xw) return Ff;
  xw = 1;
  var e = Dd();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Ff = t, Ff;
}
var Lf, ww;
function qz() {
  if (ww) return Lf;
  ww = 1;
  function e(t) {
    var n = this.has(t) && delete this.__data__[t];
    return this.size -= n ? 1 : 0, n;
  }
  return Lf = e, Lf;
}
var Bf, Cw;
function Hz() {
  if (Cw) return Bf;
  Cw = 1;
  var e = Dd(), t = "__lodash_hash_undefined__", n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var l = this.__data__;
    if (e) {
      var u = l[a];
      return u === t ? void 0 : u;
    }
    return r.call(l, a) ? l[a] : void 0;
  }
  return Bf = i, Bf;
}
var Vf, Sw;
function Uz() {
  if (Sw) return Vf;
  Sw = 1;
  var e = Dd(), t = Object.prototype, n = t.hasOwnProperty;
  function r(i) {
    var a = this.__data__;
    return e ? a[i] !== void 0 : n.call(a, i);
  }
  return Vf = r, Vf;
}
var zf, Ow;
function Yz() {
  if (Ow) return zf;
  Ow = 1;
  var e = Dd(), t = "__lodash_hash_undefined__";
  function n(r, i) {
    var a = this.__data__;
    return this.size += this.has(r) ? 0 : 1, a[r] = e && i === void 0 ? t : i, this;
  }
  return zf = n, zf;
}
var Wf, Tw;
function Gz() {
  if (Tw) return Wf;
  Tw = 1;
  var e = Wz(), t = qz(), n = Hz(), r = Uz(), i = Yz();
  function a(l) {
    var u = -1, d = l == null ? 0 : l.length;
    for (this.clear(); ++u < d; ) {
      var p = l[u];
      this.set(p[0], p[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = n, a.prototype.has = r, a.prototype.set = i, Wf = a, Wf;
}
var qf, Ew;
function Kz() {
  if (Ew) return qf;
  Ew = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return qf = e, qf;
}
var Hf, Rw;
function Xz() {
  if (Rw) return Hf;
  Rw = 1;
  function e(t, n) {
    return t === n || t !== t && n !== n;
  }
  return Hf = e, Hf;
}
var Uf, kw;
function Md() {
  if (kw) return Uf;
  kw = 1;
  var e = Xz();
  function t(n, r) {
    for (var i = n.length; i--; )
      if (e(n[i][0], r))
        return i;
    return -1;
  }
  return Uf = t, Uf;
}
var Yf, Pw;
function Qz() {
  if (Pw) return Yf;
  Pw = 1;
  var e = Md(), t = Array.prototype, n = t.splice;
  function r(i) {
    var a = this.__data__, l = e(a, i);
    if (l < 0)
      return !1;
    var u = a.length - 1;
    return l == u ? a.pop() : n.call(a, l, 1), --this.size, !0;
  }
  return Yf = r, Yf;
}
var Gf, Dw;
function Zz() {
  if (Dw) return Gf;
  Dw = 1;
  var e = Md();
  function t(n) {
    var r = this.__data__, i = e(r, n);
    return i < 0 ? void 0 : r[i][1];
  }
  return Gf = t, Gf;
}
var Kf, Mw;
function Jz() {
  if (Mw) return Kf;
  Mw = 1;
  var e = Md();
  function t(n) {
    return e(this.__data__, n) > -1;
  }
  return Kf = t, Kf;
}
var Xf, _w;
function e5() {
  if (_w) return Xf;
  _w = 1;
  var e = Md();
  function t(n, r) {
    var i = this.__data__, a = e(i, n);
    return a < 0 ? (++this.size, i.push([n, r])) : i[a][1] = r, this;
  }
  return Xf = t, Xf;
}
var Qf, Iw;
function t5() {
  if (Iw) return Qf;
  Iw = 1;
  var e = Kz(), t = Qz(), n = Zz(), r = Jz(), i = e5();
  function a(l) {
    var u = -1, d = l == null ? 0 : l.length;
    for (this.clear(); ++u < d; ) {
      var p = l[u];
      this.set(p[0], p[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = n, a.prototype.has = r, a.prototype.set = i, Qf = a, Qf;
}
var Zf, jw;
function n5() {
  if (jw) return Zf;
  jw = 1;
  var e = tS(), t = ig(), n = e(t, "Map");
  return Zf = n, Zf;
}
var Jf, $w;
function r5() {
  if ($w) return Jf;
  $w = 1;
  var e = Gz(), t = t5(), n = n5();
  function r() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (n || t)(),
      string: new e()
    };
  }
  return Jf = r, Jf;
}
var em, Aw;
function o5() {
  if (Aw) return em;
  Aw = 1;
  function e(t) {
    var n = typeof t;
    return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? t !== "__proto__" : t === null;
  }
  return em = e, em;
}
var tm, Nw;
function _d() {
  if (Nw) return tm;
  Nw = 1;
  var e = o5();
  function t(n, r) {
    var i = n.__data__;
    return e(r) ? i[typeof r == "string" ? "string" : "hash"] : i.map;
  }
  return tm = t, tm;
}
var nm, Fw;
function i5() {
  if (Fw) return nm;
  Fw = 1;
  var e = _d();
  function t(n) {
    var r = e(this, n).delete(n);
    return this.size -= r ? 1 : 0, r;
  }
  return nm = t, nm;
}
var rm, Lw;
function a5() {
  if (Lw) return rm;
  Lw = 1;
  var e = _d();
  function t(n) {
    return e(this, n).get(n);
  }
  return rm = t, rm;
}
var om, Bw;
function s5() {
  if (Bw) return om;
  Bw = 1;
  var e = _d();
  function t(n) {
    return e(this, n).has(n);
  }
  return om = t, om;
}
var im, Vw;
function l5() {
  if (Vw) return im;
  Vw = 1;
  var e = _d();
  function t(n, r) {
    var i = e(this, n), a = i.size;
    return i.set(n, r), this.size += i.size == a ? 0 : 1, this;
  }
  return im = t, im;
}
var am, zw;
function c5() {
  if (zw) return am;
  zw = 1;
  var e = r5(), t = i5(), n = a5(), r = s5(), i = l5();
  function a(l) {
    var u = -1, d = l == null ? 0 : l.length;
    for (this.clear(); ++u < d; ) {
      var p = l[u];
      this.set(p[0], p[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = n, a.prototype.has = r, a.prototype.set = i, am = a, am;
}
var sm, Ww;
function u5() {
  if (Ww) return sm;
  Ww = 1;
  var e = c5(), t = "Expected a function";
  function n(r, i) {
    if (typeof r != "function" || i != null && typeof i != "function")
      throw new TypeError(t);
    var a = function() {
      var l = arguments, u = i ? i.apply(this, l) : l[0], d = a.cache;
      if (d.has(u))
        return d.get(u);
      var p = r.apply(this, l);
      return a.cache = d.set(u, p) || d, p;
    };
    return a.cache = new (n.Cache || e)(), a;
  }
  return n.Cache = e, sm = n, sm;
}
var lm, qw;
function d5() {
  if (qw) return lm;
  qw = 1;
  var e = u5(), t = 500;
  function n(r) {
    var i = e(r, function(l) {
      return a.size === t && a.clear(), l;
    }), a = i.cache;
    return i;
  }
  return lm = n, lm;
}
var cm, Hw;
function p5() {
  if (Hw) return cm;
  Hw = 1;
  var e = d5(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, n = /\\(\\)?/g, r = e(function(i) {
    var a = [];
    return i.charCodeAt(0) === 46 && a.push(""), i.replace(t, function(l, u, d, p) {
      a.push(d ? p.replace(n, "$1") : u || l);
    }), a;
  });
  return cm = r, cm;
}
var um, Uw;
function f5() {
  if (Uw) return um;
  Uw = 1;
  function e(t, n) {
    for (var r = -1, i = t == null ? 0 : t.length, a = Array(i); ++r < i; )
      a[r] = n(t[r], r, t);
    return a;
  }
  return um = e, um;
}
var dm, Yw;
function m5() {
  if (Yw) return dm;
  Yw = 1;
  var e = ag(), t = f5(), n = og(), r = sg(), i = e ? e.prototype : void 0, a = i ? i.toString : void 0;
  function l(u) {
    if (typeof u == "string")
      return u;
    if (n(u))
      return t(u, l) + "";
    if (r(u))
      return a ? a.call(u) : "";
    var d = u + "";
    return d == "0" && 1 / u == -1 / 0 ? "-0" : d;
  }
  return dm = l, dm;
}
var pm, Gw;
function h5() {
  if (Gw) return pm;
  Gw = 1;
  var e = m5();
  function t(n) {
    return n == null ? "" : e(n);
  }
  return pm = t, pm;
}
var fm, Kw;
function g5() {
  if (Kw) return fm;
  Kw = 1;
  var e = og(), t = Az(), n = p5(), r = h5();
  function i(a, l) {
    return e(a) ? a : t(a, l) ? [a] : n(r(a));
  }
  return fm = i, fm;
}
var mm, Xw;
function y5() {
  if (Xw) return mm;
  Xw = 1;
  var e = sg();
  function t(n) {
    if (typeof n == "string" || e(n))
      return n;
    var r = n + "";
    return r == "0" && 1 / n == -1 / 0 ? "-0" : r;
  }
  return mm = t, mm;
}
var hm, Qw;
function b5() {
  if (Qw) return hm;
  Qw = 1;
  var e = g5(), t = y5();
  function n(r, i) {
    i = e(i, r);
    for (var a = 0, l = i.length; r != null && a < l; )
      r = r[t(i[a++])];
    return a && a == l ? r : void 0;
  }
  return hm = n, hm;
}
var gm, Zw;
function v5() {
  if (Zw) return gm;
  Zw = 1;
  var e = b5();
  function t(n, r, i) {
    var a = n == null ? void 0 : e(n, r);
    return a === void 0 ? i : a;
  }
  return gm = t, gm;
}
var x5 = v5();
const w5 = /* @__PURE__ */ Rl(x5);
var C5 = (e) => e.type === "checkbox", S5 = (e) => e instanceof Date, nS = (e) => e == null;
const O5 = (e) => typeof e == "object";
var gs = (e) => !nS(e) && !Array.isArray(e) && O5(e) && !S5(e), T5 = (e) => gs(e) && e.target ? C5(e.target) ? e.target.checked : e.target.value : e, E5 = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, R5 = (e, t) => e.has(E5(t)), k5 = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return gs(t) && t.hasOwnProperty("isPrototypeOf");
}, P5 = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function lg(e) {
  let t;
  const n = Array.isArray(e), r = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    t = new Date(e);
  else if (e instanceof Set)
    t = new Set(e);
  else if (!(P5 && (e instanceof Blob || r)) && (n || gs(e)))
    if (t = n ? [] : {}, !n && !k5(e))
      t = e;
    else
      for (const i in e)
        e.hasOwnProperty(i) && (t[i] = lg(e[i]));
  else
    return e;
  return t;
}
var rS = (e) => Array.isArray(e) ? e.filter(Boolean) : [], Hm = (e) => e === void 0, fr = (e, t, n) => {
  if (!t || !gs(e))
    return n;
  const r = rS(t.split(/[,[\].]+?/)).reduce((i, a) => nS(i) ? i : i[a], e);
  return Hm(r) || r === e ? Hm(e[t]) ? n : e[t] : r;
}, Jw = (e) => typeof e == "boolean", D5 = (e) => /^\w*$/.test(e), M5 = (e) => rS(e.replace(/["|']|\]/g, "").split(/\.|\[/)), e0 = (e, t, n) => {
  let r = -1;
  const i = D5(t) ? [t] : M5(t), a = i.length, l = a - 1;
  for (; ++r < a; ) {
    const u = i[r];
    let d = n;
    if (r !== l) {
      const p = e[u];
      d = gs(p) || Array.isArray(p) ? p : isNaN(+i[r + 1]) ? {} : [];
    }
    if (u === "__proto__" || u === "constructor" || u === "prototype")
      return;
    e[u] = d, e = e[u];
  }
  return e;
};
const t0 = {
  BLUR: "blur",
  CHANGE: "change"
}, n0 = {
  all: "all"
}, _5 = Ae.createContext(null), cg = () => Ae.useContext(_5);
var I5 = (e, t, n, r = !0) => {
  const i = {
    defaultValues: t._defaultValues
  };
  for (const a in e)
    Object.defineProperty(i, a, {
      get: () => {
        const l = a;
        return t._proxyFormState[l] !== n0.all && (t._proxyFormState[l] = !r || n0.all), n && (n[l] = !0), e[l];
      }
    });
  return i;
}, j5 = (e) => gs(e) && !Object.keys(e).length, $5 = (e, t, n, r) => {
  n(e);
  const { name: i, ...a } = e;
  return j5(a) || Object.keys(a).length >= Object.keys(t).length || Object.keys(a).find((l) => t[l] === !0);
}, A5 = (e) => Array.isArray(e) ? e : [e], oS = (e, t, n) => !e || !t || e === t || A5(e).some((r) => r && (n ? r === t : r.startsWith(t) || t.startsWith(r)));
function iS(e) {
  const t = Ae.useRef(e);
  t.current = e, Ae.useEffect(() => {
    const n = !e.disabled && t.current.subject && t.current.subject.subscribe({
      next: t.current.next
    });
    return () => {
      n && n.unsubscribe();
    };
  }, [e.disabled]);
}
function N5(e) {
  const t = cg(), { control: n = t.control, disabled: r, name: i, exact: a } = e || {}, [l, u] = Ae.useState(n._formState), d = Ae.useRef(!0), p = Ae.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Ae.useRef(i);
  return m.current = i, iS({
    disabled: r,
    next: (h) => d.current && oS(m.current, h.name, a) && $5(h, p.current, n._updateFormState) && u({
      ...n._formState,
      ...h
    }),
    subject: n._subjects.state
  }), Ae.useEffect(() => (d.current = !0, p.current.isValid && n._updateValid(!0), () => {
    d.current = !1;
  }), [n]), Ae.useMemo(() => I5(l, n, p.current, !1), [l, n]);
}
var F5 = (e) => typeof e == "string", L5 = (e, t, n, r, i) => F5(e) ? fr(n, e, i) : Array.isArray(e) ? e.map((a) => fr(n, a)) : n;
function aS(e) {
  const t = cg(), { control: n = t.control, name: r, defaultValue: i, disabled: a, exact: l } = e || {}, u = Ae.useRef(r);
  u.current = r, iS({
    disabled: a,
    subject: n._subjects.values,
    next: (m) => {
      oS(u.current, m.name, l) && p(lg(L5(u.current, n._names, m.values || n._formValues, !1, i)));
    }
  });
  const [d, p] = Ae.useState(n._getWatch(r, i));
  return Ae.useEffect(() => n._removeUnmounted()), d;
}
function sS(e) {
  const t = cg(), { name: n, disabled: r, control: i = t.control, shouldUnregister: a } = e, l = R5(i._names.array, n), u = aS({
    control: i,
    name: n,
    defaultValue: fr(i._formValues, n, fr(i._defaultValues, n, e.defaultValue)),
    exact: !0
  }), d = N5({
    control: i,
    name: n,
    exact: !0
  }), p = Ae.useRef(i.register(n, {
    ...e.rules,
    value: u,
    ...Jw(e.disabled) ? { disabled: e.disabled } : {}
  })), m = Ae.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!fr(d.errors, n)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!fr(d.dirtyFields, n)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!fr(d.touchedFields, n)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!fr(d.validatingFields, n)
    },
    error: {
      enumerable: !0,
      get: () => fr(d.errors, n)
    }
  }), [d, n]), h = Ae.useMemo(() => ({
    name: n,
    value: u,
    ...Jw(r) || d.disabled ? { disabled: d.disabled || r } : {},
    onChange: (g) => p.current.onChange({
      target: {
        value: T5(g),
        name: n
      },
      type: t0.CHANGE
    }),
    onBlur: () => p.current.onBlur({
      target: {
        value: fr(i._formValues, n),
        name: n
      },
      type: t0.BLUR
    }),
    ref: (g) => {
      const v = fr(i._fields, n);
      v && g && (v._f.ref = {
        focus: () => g.focus(),
        select: () => g.select(),
        setCustomValidity: (b) => g.setCustomValidity(b),
        reportValidity: () => g.reportValidity()
      });
    }
  }), [
    n,
    i._formValues,
    r,
    d.disabled,
    u,
    i._fields
  ]);
  return Ae.useEffect(() => {
    const g = i._options.shouldUnregister || a, v = (b, y) => {
      const S = fr(i._fields, b);
      S && S._f && (S._f.mount = y);
    };
    if (v(n, !0), g) {
      const b = lg(fr(i._options.defaultValues, n));
      e0(i._defaultValues, n, b), Hm(fr(i._formValues, n)) && e0(i._formValues, n, b);
    }
    return !l && i.register(n), () => {
      (l ? g && !i._state.action : g) ? i.unregister(n) : v(n, !1);
    };
  }, [n, i, l, a]), Ae.useEffect(() => {
    i._updateDisabledField({
      disabled: r,
      fields: i._fields,
      name: n
    });
  }, [r, n, i]), Ae.useMemo(() => ({
    field: h,
    formState: d,
    fieldState: m
  }), [h, d, m]);
}
const Id = ({
  name: e,
  label: t,
  disabled: n = !1,
  value: r,
  onChange: i,
  error: a,
  readOnly: l = !1,
  multiline: u = !1,
  rows: d = 1,
  textSuffix: p,
  fullWidth: m = !0,
  helperText: h,
  maxLength: g,
  slotProps: v,
  placeholder: b,
  maxWords: y
}) => {
  const S = p && /* @__PURE__ */ x.jsx(Vl, { position: "end", children: /* @__PURE__ */ x.jsx(at, { variant: "caption", children: p }) }), O = $t(
    (_) => {
      if (!_) return { remainingWords: y || 0, words: [] };
      const I = _.split(/\s+/).filter((T) => T.length !== 0);
      return { remainingWords: y && y - I.length || 0, words: I };
    },
    [y]
  ), [P, k] = Kt(O(r)), R = rr(() => {
    if (!g) return;
    const _ = r ? g - r.length : g;
    return `${_} ${_ === 1 ? "character" : "characters"} remaining`;
  }, [r, g]), E = $t(
    (_) => {
      if (y && i) {
        _.preventDefault();
        const I = _.clipboardData.getData("text/plain"), { remainingWords: F, words: T } = O(I);
        if (F < 0) {
          const $ = T.slice(0, F).join(" ").length;
          i(I.slice(0, $)), k({ remainingWords: 0, words: T.slice(0, F) });
        } else
          i(I), k({ remainingWords: F, words: T });
      }
    },
    [i, y, O]
  ), M = $t(
    (_) => {
      if (i)
        if (y) {
          const { remainingWords: I, words: F } = O(_.target.value);
          I >= 0 && (i(I === 0 ? _.target.value.trimEnd() : _.target.value), k({ remainingWords: I, words: F }));
        } else
          i(_.target.value);
    },
    [i, y, k, O]
  );
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsxs(sr, { fullWidth: m, size: "small", children: [
      /* @__PURE__ */ x.jsx(jr, { id: `${e}-label`, disabled: n, children: t }),
      /* @__PURE__ */ x.jsx(
        ms,
        {
          size: "small",
          "aria-labelledby": `${e}-label`,
          value: r,
          error: !!a,
          disabled: n,
          onPaste: E,
          onChange: M,
          slotProps: {
            ...v,
            input: { ...v == null ? void 0 : v.input, endAdornment: S },
            htmlInput: {
              ...v == null ? void 0 : v.htmlInput,
              readOnly: l,
              ...g && { maxLength: g }
            }
          },
          multiline: u,
          rows: d,
          placeholder: b,
          helperText: h,
          "data-testid": `${e}-input`
        }
      )
    ] }),
    (g || y) && /* @__PURE__ */ x.jsxs(at, { pl: 1.5, variant: "caption", sx: (_) => ({ color: n ? _.palette.grey[300] : _.palette.grey[500] }), children: [
      g && R,
      y && `${P.remainingWords} ${P.remainingWords === 1 ? "word" : "words"} remaining to be written`
    ] }),
    a && /* @__PURE__ */ x.jsx(at, { variant: "caption", color: "error", children: a.message })
  ] });
}, lS = (e) => {
  try {
    const t = "àáäâãåăæçèéëêǵḧìíïîḿńǹñòóöôœøṕŕßśșțùúüûǘẃẍÿź·/_,:;", n = "aaaaaaaaceeeeghiiiimnnnooooooprssstuuuuuwxyz------", r = new RegExp(t.split("").join("|"), "g");
    return e.toLowerCase().replace(/\s+/g, "-").replace(r, (i) => n.charAt(t.indexOf(i))).replace(/&/g, "-and-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
  } catch (t) {
    throw new TypeError(t);
  }
};
var el = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var B5 = el.exports, r0;
function V5() {
  return r0 || (r0 = 1, function(e, t) {
    (function() {
      var n, r = "4.17.21", i = 200, a = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", l = "Expected a function", u = "Invalid `variable` option passed into `_.template`", d = "__lodash_hash_undefined__", p = 500, m = "__lodash_placeholder__", h = 1, g = 2, v = 4, b = 1, y = 2, S = 1, O = 2, P = 4, k = 8, R = 16, E = 32, M = 64, _ = 128, I = 256, F = 512, T = 30, $ = "...", N = 800, W = 16, L = 1, V = 2, z = 3, X = 1 / 0, le = 9007199254740991, ne = 17976931348623157e292, G = NaN, Q = 4294967295, be = Q - 1, we = Q >>> 1, se = [
        ["ary", _],
        ["bind", S],
        ["bindKey", O],
        ["curry", k],
        ["curryRight", R],
        ["flip", F],
        ["partial", E],
        ["partialRight", M],
        ["rearg", I]
      ], U = "[object Arguments]", de = "[object Array]", ce = "[object AsyncFunction]", K = "[object Boolean]", Z = "[object Date]", ue = "[object DOMException]", he = "[object Error]", B = "[object Function]", ee = "[object GeneratorFunction]", ie = "[object Map]", ge = "[object Number]", xe = "[object Null]", pe = "[object Object]", Ee = "[object Promise]", Pe = "[object Proxy]", Be = "[object RegExp]", Ge = "[object Set]", Ie = "[object String]", Dt = "[object Symbol]", Re = "[object Undefined]", $e = "[object WeakMap]", dt = "[object WeakSet]", He = "[object ArrayBuffer]", Je = "[object DataView]", Ze = "[object Float32Array]", nt = "[object Float64Array]", Ne = "[object Int8Array]", Ct = "[object Int16Array]", Rt = "[object Int32Array]", At = "[object Uint8Array]", Xt = "[object Uint8ClampedArray]", je = "[object Uint16Array]", ot = "[object Uint32Array]", vt = /\b__p \+= '';/g, gt = /\b(__p \+=) '' \+/g, kt = /(__e\(.*?\)|\b__t\)) \+\n'';/g, xn = /&(?:amp|lt|gt|quot|#39);/g, on = /[&<>"']/g, br = RegExp(xn.source), Un = RegExp(on.source), no = /<%-([\s\S]+?)%>/g, mo = /<%([\s\S]+?)%>/g, et = /<%=([\s\S]+?)%>/g, jn = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, ho = /^\w*$/, ro = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, $r = /[\\^$.*+?()[\]{}|]/g, go = RegExp($r.source), Ao = /^\s+/, Li = /\s/, Bi = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Vi = /\{\n\/\* \[wrapped with (.+)\] \*/, H = /,? & /, Se = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, _e = /[()=,{}\[\]\/\s]/, Qe = /\\(\\)?/g, Ot = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, fe = /\w*$/, oe = /^[-+]0x[0-9a-f]+$/i, Te = /^0b[01]+$/i, Ke = /^\[object .+?Constructor\]$/, Ye = /^0o[0-7]+$/i, tt = /^(?:0|[1-9]\d*)$/, Mt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Jt = /($^)/, Jn = /['\n\r\u2028\u2029\\]/g, kn = "\\ud800-\\udfff", li = "\\u0300-\\u036f", ci = "\\ufe20-\\ufe2f", ui = "\\u20d0-\\u20ff", jt = li + ci + ui, vr = "\\u2700-\\u27bf", oo = "a-z\\xdf-\\xf6\\xf8-\\xff", zi = "\\xac\\xb1\\xd7\\xf7", Vd = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", _O = "\\u2000-\\u206f", IO = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Ig = "A-Z\\xc0-\\xd6\\xd8-\\xde", jg = "\\ufe0e\\ufe0f", $g = zi + Vd + _O + IO, zd = "['’]", jO = "[" + kn + "]", Ag = "[" + $g + "]", Kl = "[" + jt + "]", Ng = "\\d+", $O = "[" + vr + "]", Fg = "[" + oo + "]", Lg = "[^" + kn + $g + Ng + vr + oo + Ig + "]", Wd = "\\ud83c[\\udffb-\\udfff]", AO = "(?:" + Kl + "|" + Wd + ")", Bg = "[^" + kn + "]", qd = "(?:\\ud83c[\\udde6-\\uddff]){2}", Hd = "[\\ud800-\\udbff][\\udc00-\\udfff]", va = "[" + Ig + "]", Vg = "\\u200d", zg = "(?:" + Fg + "|" + Lg + ")", NO = "(?:" + va + "|" + Lg + ")", Wg = "(?:" + zd + "(?:d|ll|m|re|s|t|ve))?", qg = "(?:" + zd + "(?:D|LL|M|RE|S|T|VE))?", Hg = AO + "?", Ug = "[" + jg + "]?", FO = "(?:" + Vg + "(?:" + [Bg, qd, Hd].join("|") + ")" + Ug + Hg + ")*", LO = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", BO = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Yg = Ug + Hg + FO, VO = "(?:" + [$O, qd, Hd].join("|") + ")" + Yg, zO = "(?:" + [Bg + Kl + "?", Kl, qd, Hd, jO].join("|") + ")", WO = RegExp(zd, "g"), qO = RegExp(Kl, "g"), Ud = RegExp(Wd + "(?=" + Wd + ")|" + zO + Yg, "g"), HO = RegExp([
        va + "?" + Fg + "+" + Wg + "(?=" + [Ag, va, "$"].join("|") + ")",
        NO + "+" + qg + "(?=" + [Ag, va + zg, "$"].join("|") + ")",
        va + "?" + zg + "+" + Wg,
        va + "+" + qg,
        BO,
        LO,
        Ng,
        VO
      ].join("|"), "g"), UO = RegExp("[" + Vg + kn + jt + jg + "]"), YO = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, GO = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], KO = -1, ln = {};
      ln[Ze] = ln[nt] = ln[Ne] = ln[Ct] = ln[Rt] = ln[At] = ln[Xt] = ln[je] = ln[ot] = !0, ln[U] = ln[de] = ln[He] = ln[K] = ln[Je] = ln[Z] = ln[he] = ln[B] = ln[ie] = ln[ge] = ln[pe] = ln[Be] = ln[Ge] = ln[Ie] = ln[$e] = !1;
      var an = {};
      an[U] = an[de] = an[He] = an[Je] = an[K] = an[Z] = an[Ze] = an[nt] = an[Ne] = an[Ct] = an[Rt] = an[ie] = an[ge] = an[pe] = an[Be] = an[Ge] = an[Ie] = an[Dt] = an[At] = an[Xt] = an[je] = an[ot] = !0, an[he] = an[B] = an[$e] = !1;
      var XO = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, QO = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, ZO = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, JO = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, eT = parseFloat, tT = parseInt, Gg = typeof Ei == "object" && Ei && Ei.Object === Object && Ei, nT = typeof self == "object" && self && self.Object === Object && self, Vn = Gg || nT || Function("return this")(), Yd = t && !t.nodeType && t, Wi = Yd && !0 && e && !e.nodeType && e, Kg = Wi && Wi.exports === Yd, Gd = Kg && Gg.process, Ar = function() {
        try {
          var te = Wi && Wi.require && Wi.require("util").types;
          return te || Gd && Gd.binding && Gd.binding("util");
        } catch {
        }
      }(), Xg = Ar && Ar.isArrayBuffer, Qg = Ar && Ar.isDate, Zg = Ar && Ar.isMap, Jg = Ar && Ar.isRegExp, ey = Ar && Ar.isSet, ty = Ar && Ar.isTypedArray;
      function xr(te, ve, me) {
        switch (me.length) {
          case 0:
            return te.call(ve);
          case 1:
            return te.call(ve, me[0]);
          case 2:
            return te.call(ve, me[0], me[1]);
          case 3:
            return te.call(ve, me[0], me[1], me[2]);
        }
        return te.apply(ve, me);
      }
      function rT(te, ve, me, Ue) {
        for (var ft = -1, Ft = te == null ? 0 : te.length; ++ft < Ft; ) {
          var Nn = te[ft];
          ve(Ue, Nn, me(Nn), te);
        }
        return Ue;
      }
      function Nr(te, ve) {
        for (var me = -1, Ue = te == null ? 0 : te.length; ++me < Ue && ve(te[me], me, te) !== !1; )
          ;
        return te;
      }
      function oT(te, ve) {
        for (var me = te == null ? 0 : te.length; me-- && ve(te[me], me, te) !== !1; )
          ;
        return te;
      }
      function ny(te, ve) {
        for (var me = -1, Ue = te == null ? 0 : te.length; ++me < Ue; )
          if (!ve(te[me], me, te))
            return !1;
        return !0;
      }
      function di(te, ve) {
        for (var me = -1, Ue = te == null ? 0 : te.length, ft = 0, Ft = []; ++me < Ue; ) {
          var Nn = te[me];
          ve(Nn, me, te) && (Ft[ft++] = Nn);
        }
        return Ft;
      }
      function Xl(te, ve) {
        var me = te == null ? 0 : te.length;
        return !!me && xa(te, ve, 0) > -1;
      }
      function Kd(te, ve, me) {
        for (var Ue = -1, ft = te == null ? 0 : te.length; ++Ue < ft; )
          if (me(ve, te[Ue]))
            return !0;
        return !1;
      }
      function dn(te, ve) {
        for (var me = -1, Ue = te == null ? 0 : te.length, ft = Array(Ue); ++me < Ue; )
          ft[me] = ve(te[me], me, te);
        return ft;
      }
      function pi(te, ve) {
        for (var me = -1, Ue = ve.length, ft = te.length; ++me < Ue; )
          te[ft + me] = ve[me];
        return te;
      }
      function Xd(te, ve, me, Ue) {
        var ft = -1, Ft = te == null ? 0 : te.length;
        for (Ue && Ft && (me = te[++ft]); ++ft < Ft; )
          me = ve(me, te[ft], ft, te);
        return me;
      }
      function iT(te, ve, me, Ue) {
        var ft = te == null ? 0 : te.length;
        for (Ue && ft && (me = te[--ft]); ft--; )
          me = ve(me, te[ft], ft, te);
        return me;
      }
      function Qd(te, ve) {
        for (var me = -1, Ue = te == null ? 0 : te.length; ++me < Ue; )
          if (ve(te[me], me, te))
            return !0;
        return !1;
      }
      var aT = Zd("length");
      function sT(te) {
        return te.split("");
      }
      function lT(te) {
        return te.match(Se) || [];
      }
      function ry(te, ve, me) {
        var Ue;
        return me(te, function(ft, Ft, Nn) {
          if (ve(ft, Ft, Nn))
            return Ue = Ft, !1;
        }), Ue;
      }
      function Ql(te, ve, me, Ue) {
        for (var ft = te.length, Ft = me + (Ue ? 1 : -1); Ue ? Ft-- : ++Ft < ft; )
          if (ve(te[Ft], Ft, te))
            return Ft;
        return -1;
      }
      function xa(te, ve, me) {
        return ve === ve ? xT(te, ve, me) : Ql(te, oy, me);
      }
      function cT(te, ve, me, Ue) {
        for (var ft = me - 1, Ft = te.length; ++ft < Ft; )
          if (Ue(te[ft], ve))
            return ft;
        return -1;
      }
      function oy(te) {
        return te !== te;
      }
      function iy(te, ve) {
        var me = te == null ? 0 : te.length;
        return me ? ep(te, ve) / me : G;
      }
      function Zd(te) {
        return function(ve) {
          return ve == null ? n : ve[te];
        };
      }
      function Jd(te) {
        return function(ve) {
          return te == null ? n : te[ve];
        };
      }
      function ay(te, ve, me, Ue, ft) {
        return ft(te, function(Ft, Nn, en) {
          me = Ue ? (Ue = !1, Ft) : ve(me, Ft, Nn, en);
        }), me;
      }
      function uT(te, ve) {
        var me = te.length;
        for (te.sort(ve); me--; )
          te[me] = te[me].value;
        return te;
      }
      function ep(te, ve) {
        for (var me, Ue = -1, ft = te.length; ++Ue < ft; ) {
          var Ft = ve(te[Ue]);
          Ft !== n && (me = me === n ? Ft : me + Ft);
        }
        return me;
      }
      function tp(te, ve) {
        for (var me = -1, Ue = Array(te); ++me < te; )
          Ue[me] = ve(me);
        return Ue;
      }
      function dT(te, ve) {
        return dn(ve, function(me) {
          return [me, te[me]];
        });
      }
      function sy(te) {
        return te && te.slice(0, dy(te) + 1).replace(Ao, "");
      }
      function wr(te) {
        return function(ve) {
          return te(ve);
        };
      }
      function np(te, ve) {
        return dn(ve, function(me) {
          return te[me];
        });
      }
      function ys(te, ve) {
        return te.has(ve);
      }
      function ly(te, ve) {
        for (var me = -1, Ue = te.length; ++me < Ue && xa(ve, te[me], 0) > -1; )
          ;
        return me;
      }
      function cy(te, ve) {
        for (var me = te.length; me-- && xa(ve, te[me], 0) > -1; )
          ;
        return me;
      }
      function pT(te, ve) {
        for (var me = te.length, Ue = 0; me--; )
          te[me] === ve && ++Ue;
        return Ue;
      }
      var fT = Jd(XO), mT = Jd(QO);
      function hT(te) {
        return "\\" + JO[te];
      }
      function gT(te, ve) {
        return te == null ? n : te[ve];
      }
      function wa(te) {
        return UO.test(te);
      }
      function yT(te) {
        return YO.test(te);
      }
      function bT(te) {
        for (var ve, me = []; !(ve = te.next()).done; )
          me.push(ve.value);
        return me;
      }
      function rp(te) {
        var ve = -1, me = Array(te.size);
        return te.forEach(function(Ue, ft) {
          me[++ve] = [ft, Ue];
        }), me;
      }
      function uy(te, ve) {
        return function(me) {
          return te(ve(me));
        };
      }
      function fi(te, ve) {
        for (var me = -1, Ue = te.length, ft = 0, Ft = []; ++me < Ue; ) {
          var Nn = te[me];
          (Nn === ve || Nn === m) && (te[me] = m, Ft[ft++] = me);
        }
        return Ft;
      }
      function Zl(te) {
        var ve = -1, me = Array(te.size);
        return te.forEach(function(Ue) {
          me[++ve] = Ue;
        }), me;
      }
      function vT(te) {
        var ve = -1, me = Array(te.size);
        return te.forEach(function(Ue) {
          me[++ve] = [Ue, Ue];
        }), me;
      }
      function xT(te, ve, me) {
        for (var Ue = me - 1, ft = te.length; ++Ue < ft; )
          if (te[Ue] === ve)
            return Ue;
        return -1;
      }
      function wT(te, ve, me) {
        for (var Ue = me + 1; Ue--; )
          if (te[Ue] === ve)
            return Ue;
        return Ue;
      }
      function Ca(te) {
        return wa(te) ? ST(te) : aT(te);
      }
      function io(te) {
        return wa(te) ? OT(te) : sT(te);
      }
      function dy(te) {
        for (var ve = te.length; ve-- && Li.test(te.charAt(ve)); )
          ;
        return ve;
      }
      var CT = Jd(ZO);
      function ST(te) {
        for (var ve = Ud.lastIndex = 0; Ud.test(te); )
          ++ve;
        return ve;
      }
      function OT(te) {
        return te.match(Ud) || [];
      }
      function TT(te) {
        return te.match(HO) || [];
      }
      var ET = function te(ve) {
        ve = ve == null ? Vn : Sa.defaults(Vn.Object(), ve, Sa.pick(Vn, GO));
        var me = ve.Array, Ue = ve.Date, ft = ve.Error, Ft = ve.Function, Nn = ve.Math, en = ve.Object, op = ve.RegExp, RT = ve.String, Fr = ve.TypeError, Jl = me.prototype, kT = Ft.prototype, Oa = en.prototype, ec = ve["__core-js_shared__"], tc = kT.toString, Yt = Oa.hasOwnProperty, PT = 0, py = function() {
          var s = /[^.]+$/.exec(ec && ec.keys && ec.keys.IE_PROTO || "");
          return s ? "Symbol(src)_1." + s : "";
        }(), nc = Oa.toString, DT = tc.call(en), MT = Vn._, _T = op(
          "^" + tc.call(Yt).replace($r, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), rc = Kg ? ve.Buffer : n, mi = ve.Symbol, oc = ve.Uint8Array, fy = rc ? rc.allocUnsafe : n, ic = uy(en.getPrototypeOf, en), my = en.create, hy = Oa.propertyIsEnumerable, ac = Jl.splice, gy = mi ? mi.isConcatSpreadable : n, bs = mi ? mi.iterator : n, qi = mi ? mi.toStringTag : n, sc = function() {
          try {
            var s = Ki(en, "defineProperty");
            return s({}, "", {}), s;
          } catch {
          }
        }(), IT = ve.clearTimeout !== Vn.clearTimeout && ve.clearTimeout, jT = Ue && Ue.now !== Vn.Date.now && Ue.now, $T = ve.setTimeout !== Vn.setTimeout && ve.setTimeout, lc = Nn.ceil, cc = Nn.floor, ip = en.getOwnPropertySymbols, AT = rc ? rc.isBuffer : n, yy = ve.isFinite, NT = Jl.join, FT = uy(en.keys, en), Fn = Nn.max, Yn = Nn.min, LT = Ue.now, BT = ve.parseInt, by = Nn.random, VT = Jl.reverse, ap = Ki(ve, "DataView"), vs = Ki(ve, "Map"), sp = Ki(ve, "Promise"), Ta = Ki(ve, "Set"), xs = Ki(ve, "WeakMap"), ws = Ki(en, "create"), uc = xs && new xs(), Ea = {}, zT = Xi(ap), WT = Xi(vs), qT = Xi(sp), HT = Xi(Ta), UT = Xi(xs), dc = mi ? mi.prototype : n, Cs = dc ? dc.valueOf : n, vy = dc ? dc.toString : n;
        function j(s) {
          if (wn(s) && !yt(s) && !(s instanceof Pt)) {
            if (s instanceof Lr)
              return s;
            if (Yt.call(s, "__wrapped__"))
              return xb(s);
          }
          return new Lr(s);
        }
        var Ra = /* @__PURE__ */ function() {
          function s() {
          }
          return function(c) {
            if (!yn(c))
              return {};
            if (my)
              return my(c);
            s.prototype = c;
            var f = new s();
            return s.prototype = n, f;
          };
        }();
        function pc() {
        }
        function Lr(s, c) {
          this.__wrapped__ = s, this.__actions__ = [], this.__chain__ = !!c, this.__index__ = 0, this.__values__ = n;
        }
        j.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: no,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: mo,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: et,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: j
          }
        }, j.prototype = pc.prototype, j.prototype.constructor = j, Lr.prototype = Ra(pc.prototype), Lr.prototype.constructor = Lr;
        function Pt(s) {
          this.__wrapped__ = s, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Q, this.__views__ = [];
        }
        function YT() {
          var s = new Pt(this.__wrapped__);
          return s.__actions__ = lr(this.__actions__), s.__dir__ = this.__dir__, s.__filtered__ = this.__filtered__, s.__iteratees__ = lr(this.__iteratees__), s.__takeCount__ = this.__takeCount__, s.__views__ = lr(this.__views__), s;
        }
        function GT() {
          if (this.__filtered__) {
            var s = new Pt(this);
            s.__dir__ = -1, s.__filtered__ = !0;
          } else
            s = this.clone(), s.__dir__ *= -1;
          return s;
        }
        function KT() {
          var s = this.__wrapped__.value(), c = this.__dir__, f = yt(s), C = c < 0, D = f ? s.length : 0, A = sR(0, D, this.__views__), q = A.start, Y = A.end, re = Y - q, Ce = C ? Y : q - 1, Oe = this.__iteratees__, De = Oe.length, Fe = 0, Xe = Yn(re, this.__takeCount__);
          if (!f || !C && D == re && Xe == re)
            return Wy(s, this.__actions__);
          var st = [];
          e:
            for (; re-- && Fe < Xe; ) {
              Ce += c;
              for (var xt = -1, lt = s[Ce]; ++xt < De; ) {
                var Tt = Oe[xt], _t = Tt.iteratee, Or = Tt.type, nr = _t(lt);
                if (Or == V)
                  lt = nr;
                else if (!nr) {
                  if (Or == L)
                    continue e;
                  break e;
                }
              }
              st[Fe++] = lt;
            }
          return st;
        }
        Pt.prototype = Ra(pc.prototype), Pt.prototype.constructor = Pt;
        function Hi(s) {
          var c = -1, f = s == null ? 0 : s.length;
          for (this.clear(); ++c < f; ) {
            var C = s[c];
            this.set(C[0], C[1]);
          }
        }
        function XT() {
          this.__data__ = ws ? ws(null) : {}, this.size = 0;
        }
        function QT(s) {
          var c = this.has(s) && delete this.__data__[s];
          return this.size -= c ? 1 : 0, c;
        }
        function ZT(s) {
          var c = this.__data__;
          if (ws) {
            var f = c[s];
            return f === d ? n : f;
          }
          return Yt.call(c, s) ? c[s] : n;
        }
        function JT(s) {
          var c = this.__data__;
          return ws ? c[s] !== n : Yt.call(c, s);
        }
        function eE(s, c) {
          var f = this.__data__;
          return this.size += this.has(s) ? 0 : 1, f[s] = ws && c === n ? d : c, this;
        }
        Hi.prototype.clear = XT, Hi.prototype.delete = QT, Hi.prototype.get = ZT, Hi.prototype.has = JT, Hi.prototype.set = eE;
        function No(s) {
          var c = -1, f = s == null ? 0 : s.length;
          for (this.clear(); ++c < f; ) {
            var C = s[c];
            this.set(C[0], C[1]);
          }
        }
        function tE() {
          this.__data__ = [], this.size = 0;
        }
        function nE(s) {
          var c = this.__data__, f = fc(c, s);
          if (f < 0)
            return !1;
          var C = c.length - 1;
          return f == C ? c.pop() : ac.call(c, f, 1), --this.size, !0;
        }
        function rE(s) {
          var c = this.__data__, f = fc(c, s);
          return f < 0 ? n : c[f][1];
        }
        function oE(s) {
          return fc(this.__data__, s) > -1;
        }
        function iE(s, c) {
          var f = this.__data__, C = fc(f, s);
          return C < 0 ? (++this.size, f.push([s, c])) : f[C][1] = c, this;
        }
        No.prototype.clear = tE, No.prototype.delete = nE, No.prototype.get = rE, No.prototype.has = oE, No.prototype.set = iE;
        function Fo(s) {
          var c = -1, f = s == null ? 0 : s.length;
          for (this.clear(); ++c < f; ) {
            var C = s[c];
            this.set(C[0], C[1]);
          }
        }
        function aE() {
          this.size = 0, this.__data__ = {
            hash: new Hi(),
            map: new (vs || No)(),
            string: new Hi()
          };
        }
        function sE(s) {
          var c = Tc(this, s).delete(s);
          return this.size -= c ? 1 : 0, c;
        }
        function lE(s) {
          return Tc(this, s).get(s);
        }
        function cE(s) {
          return Tc(this, s).has(s);
        }
        function uE(s, c) {
          var f = Tc(this, s), C = f.size;
          return f.set(s, c), this.size += f.size == C ? 0 : 1, this;
        }
        Fo.prototype.clear = aE, Fo.prototype.delete = sE, Fo.prototype.get = lE, Fo.prototype.has = cE, Fo.prototype.set = uE;
        function Ui(s) {
          var c = -1, f = s == null ? 0 : s.length;
          for (this.__data__ = new Fo(); ++c < f; )
            this.add(s[c]);
        }
        function dE(s) {
          return this.__data__.set(s, d), this;
        }
        function pE(s) {
          return this.__data__.has(s);
        }
        Ui.prototype.add = Ui.prototype.push = dE, Ui.prototype.has = pE;
        function ao(s) {
          var c = this.__data__ = new No(s);
          this.size = c.size;
        }
        function fE() {
          this.__data__ = new No(), this.size = 0;
        }
        function mE(s) {
          var c = this.__data__, f = c.delete(s);
          return this.size = c.size, f;
        }
        function hE(s) {
          return this.__data__.get(s);
        }
        function gE(s) {
          return this.__data__.has(s);
        }
        function yE(s, c) {
          var f = this.__data__;
          if (f instanceof No) {
            var C = f.__data__;
            if (!vs || C.length < i - 1)
              return C.push([s, c]), this.size = ++f.size, this;
            f = this.__data__ = new Fo(C);
          }
          return f.set(s, c), this.size = f.size, this;
        }
        ao.prototype.clear = fE, ao.prototype.delete = mE, ao.prototype.get = hE, ao.prototype.has = gE, ao.prototype.set = yE;
        function xy(s, c) {
          var f = yt(s), C = !f && Qi(s), D = !f && !C && vi(s), A = !f && !C && !D && Ma(s), q = f || C || D || A, Y = q ? tp(s.length, RT) : [], re = Y.length;
          for (var Ce in s)
            (c || Yt.call(s, Ce)) && !(q && // Safari 9 has enumerable `arguments.length` in strict mode.
            (Ce == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            D && (Ce == "offset" || Ce == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            A && (Ce == "buffer" || Ce == "byteLength" || Ce == "byteOffset") || // Skip index properties.
            zo(Ce, re))) && Y.push(Ce);
          return Y;
        }
        function wy(s) {
          var c = s.length;
          return c ? s[bp(0, c - 1)] : n;
        }
        function bE(s, c) {
          return Ec(lr(s), Yi(c, 0, s.length));
        }
        function vE(s) {
          return Ec(lr(s));
        }
        function lp(s, c, f) {
          (f !== n && !so(s[c], f) || f === n && !(c in s)) && Lo(s, c, f);
        }
        function Ss(s, c, f) {
          var C = s[c];
          (!(Yt.call(s, c) && so(C, f)) || f === n && !(c in s)) && Lo(s, c, f);
        }
        function fc(s, c) {
          for (var f = s.length; f--; )
            if (so(s[f][0], c))
              return f;
          return -1;
        }
        function xE(s, c, f, C) {
          return hi(s, function(D, A, q) {
            c(C, D, f(D), q);
          }), C;
        }
        function Cy(s, c) {
          return s && bo(c, Ln(c), s);
        }
        function wE(s, c) {
          return s && bo(c, ur(c), s);
        }
        function Lo(s, c, f) {
          c == "__proto__" && sc ? sc(s, c, {
            configurable: !0,
            enumerable: !0,
            value: f,
            writable: !0
          }) : s[c] = f;
        }
        function cp(s, c) {
          for (var f = -1, C = c.length, D = me(C), A = s == null; ++f < C; )
            D[f] = A ? n : Wp(s, c[f]);
          return D;
        }
        function Yi(s, c, f) {
          return s === s && (f !== n && (s = s <= f ? s : f), c !== n && (s = s >= c ? s : c)), s;
        }
        function Br(s, c, f, C, D, A) {
          var q, Y = c & h, re = c & g, Ce = c & v;
          if (f && (q = D ? f(s, C, D, A) : f(s)), q !== n)
            return q;
          if (!yn(s))
            return s;
          var Oe = yt(s);
          if (Oe) {
            if (q = cR(s), !Y)
              return lr(s, q);
          } else {
            var De = Gn(s), Fe = De == B || De == ee;
            if (vi(s))
              return Uy(s, Y);
            if (De == pe || De == U || Fe && !D) {
              if (q = re || Fe ? {} : db(s), !Y)
                return re ? ZE(s, wE(q, s)) : QE(s, Cy(q, s));
            } else {
              if (!an[De])
                return D ? s : {};
              q = uR(s, De, Y);
            }
          }
          A || (A = new ao());
          var Xe = A.get(s);
          if (Xe)
            return Xe;
          A.set(s, q), Bb(s) ? s.forEach(function(lt) {
            q.add(Br(lt, c, f, lt, s, A));
          }) : Fb(s) && s.forEach(function(lt, Tt) {
            q.set(Tt, Br(lt, c, f, Tt, s, A));
          });
          var st = Ce ? re ? Pp : kp : re ? ur : Ln, xt = Oe ? n : st(s);
          return Nr(xt || s, function(lt, Tt) {
            xt && (Tt = lt, lt = s[Tt]), Ss(q, Tt, Br(lt, c, f, Tt, s, A));
          }), q;
        }
        function CE(s) {
          var c = Ln(s);
          return function(f) {
            return Sy(f, s, c);
          };
        }
        function Sy(s, c, f) {
          var C = f.length;
          if (s == null)
            return !C;
          for (s = en(s); C--; ) {
            var D = f[C], A = c[D], q = s[D];
            if (q === n && !(D in s) || !A(q))
              return !1;
          }
          return !0;
        }
        function Oy(s, c, f) {
          if (typeof s != "function")
            throw new Fr(l);
          return Ds(function() {
            s.apply(n, f);
          }, c);
        }
        function Os(s, c, f, C) {
          var D = -1, A = Xl, q = !0, Y = s.length, re = [], Ce = c.length;
          if (!Y)
            return re;
          f && (c = dn(c, wr(f))), C ? (A = Kd, q = !1) : c.length >= i && (A = ys, q = !1, c = new Ui(c));
          e:
            for (; ++D < Y; ) {
              var Oe = s[D], De = f == null ? Oe : f(Oe);
              if (Oe = C || Oe !== 0 ? Oe : 0, q && De === De) {
                for (var Fe = Ce; Fe--; )
                  if (c[Fe] === De)
                    continue e;
                re.push(Oe);
              } else A(c, De, C) || re.push(Oe);
            }
          return re;
        }
        var hi = Qy(yo), Ty = Qy(dp, !0);
        function SE(s, c) {
          var f = !0;
          return hi(s, function(C, D, A) {
            return f = !!c(C, D, A), f;
          }), f;
        }
        function mc(s, c, f) {
          for (var C = -1, D = s.length; ++C < D; ) {
            var A = s[C], q = c(A);
            if (q != null && (Y === n ? q === q && !Sr(q) : f(q, Y)))
              var Y = q, re = A;
          }
          return re;
        }
        function OE(s, c, f, C) {
          var D = s.length;
          for (f = bt(f), f < 0 && (f = -f > D ? 0 : D + f), C = C === n || C > D ? D : bt(C), C < 0 && (C += D), C = f > C ? 0 : zb(C); f < C; )
            s[f++] = c;
          return s;
        }
        function Ey(s, c) {
          var f = [];
          return hi(s, function(C, D, A) {
            c(C, D, A) && f.push(C);
          }), f;
        }
        function zn(s, c, f, C, D) {
          var A = -1, q = s.length;
          for (f || (f = pR), D || (D = []); ++A < q; ) {
            var Y = s[A];
            c > 0 && f(Y) ? c > 1 ? zn(Y, c - 1, f, C, D) : pi(D, Y) : C || (D[D.length] = Y);
          }
          return D;
        }
        var up = Zy(), Ry = Zy(!0);
        function yo(s, c) {
          return s && up(s, c, Ln);
        }
        function dp(s, c) {
          return s && Ry(s, c, Ln);
        }
        function hc(s, c) {
          return di(c, function(f) {
            return Wo(s[f]);
          });
        }
        function Gi(s, c) {
          c = yi(c, s);
          for (var f = 0, C = c.length; s != null && f < C; )
            s = s[vo(c[f++])];
          return f && f == C ? s : n;
        }
        function ky(s, c, f) {
          var C = c(s);
          return yt(s) ? C : pi(C, f(s));
        }
        function er(s) {
          return s == null ? s === n ? Re : xe : qi && qi in en(s) ? aR(s) : vR(s);
        }
        function pp(s, c) {
          return s > c;
        }
        function TE(s, c) {
          return s != null && Yt.call(s, c);
        }
        function EE(s, c) {
          return s != null && c in en(s);
        }
        function RE(s, c, f) {
          return s >= Yn(c, f) && s < Fn(c, f);
        }
        function fp(s, c, f) {
          for (var C = f ? Kd : Xl, D = s[0].length, A = s.length, q = A, Y = me(A), re = 1 / 0, Ce = []; q--; ) {
            var Oe = s[q];
            q && c && (Oe = dn(Oe, wr(c))), re = Yn(Oe.length, re), Y[q] = !f && (c || D >= 120 && Oe.length >= 120) ? new Ui(q && Oe) : n;
          }
          Oe = s[0];
          var De = -1, Fe = Y[0];
          e:
            for (; ++De < D && Ce.length < re; ) {
              var Xe = Oe[De], st = c ? c(Xe) : Xe;
              if (Xe = f || Xe !== 0 ? Xe : 0, !(Fe ? ys(Fe, st) : C(Ce, st, f))) {
                for (q = A; --q; ) {
                  var xt = Y[q];
                  if (!(xt ? ys(xt, st) : C(s[q], st, f)))
                    continue e;
                }
                Fe && Fe.push(st), Ce.push(Xe);
              }
            }
          return Ce;
        }
        function kE(s, c, f, C) {
          return yo(s, function(D, A, q) {
            c(C, f(D), A, q);
          }), C;
        }
        function Ts(s, c, f) {
          c = yi(c, s), s = hb(s, c);
          var C = s == null ? s : s[vo(zr(c))];
          return C == null ? n : xr(C, s, f);
        }
        function Py(s) {
          return wn(s) && er(s) == U;
        }
        function PE(s) {
          return wn(s) && er(s) == He;
        }
        function DE(s) {
          return wn(s) && er(s) == Z;
        }
        function Es(s, c, f, C, D) {
          return s === c ? !0 : s == null || c == null || !wn(s) && !wn(c) ? s !== s && c !== c : ME(s, c, f, C, Es, D);
        }
        function ME(s, c, f, C, D, A) {
          var q = yt(s), Y = yt(c), re = q ? de : Gn(s), Ce = Y ? de : Gn(c);
          re = re == U ? pe : re, Ce = Ce == U ? pe : Ce;
          var Oe = re == pe, De = Ce == pe, Fe = re == Ce;
          if (Fe && vi(s)) {
            if (!vi(c))
              return !1;
            q = !0, Oe = !1;
          }
          if (Fe && !Oe)
            return A || (A = new ao()), q || Ma(s) ? lb(s, c, f, C, D, A) : oR(s, c, re, f, C, D, A);
          if (!(f & b)) {
            var Xe = Oe && Yt.call(s, "__wrapped__"), st = De && Yt.call(c, "__wrapped__");
            if (Xe || st) {
              var xt = Xe ? s.value() : s, lt = st ? c.value() : c;
              return A || (A = new ao()), D(xt, lt, f, C, A);
            }
          }
          return Fe ? (A || (A = new ao()), iR(s, c, f, C, D, A)) : !1;
        }
        function _E(s) {
          return wn(s) && Gn(s) == ie;
        }
        function mp(s, c, f, C) {
          var D = f.length, A = D, q = !C;
          if (s == null)
            return !A;
          for (s = en(s); D--; ) {
            var Y = f[D];
            if (q && Y[2] ? Y[1] !== s[Y[0]] : !(Y[0] in s))
              return !1;
          }
          for (; ++D < A; ) {
            Y = f[D];
            var re = Y[0], Ce = s[re], Oe = Y[1];
            if (q && Y[2]) {
              if (Ce === n && !(re in s))
                return !1;
            } else {
              var De = new ao();
              if (C)
                var Fe = C(Ce, Oe, re, s, c, De);
              if (!(Fe === n ? Es(Oe, Ce, b | y, C, De) : Fe))
                return !1;
            }
          }
          return !0;
        }
        function Dy(s) {
          if (!yn(s) || mR(s))
            return !1;
          var c = Wo(s) ? _T : Ke;
          return c.test(Xi(s));
        }
        function IE(s) {
          return wn(s) && er(s) == Be;
        }
        function jE(s) {
          return wn(s) && Gn(s) == Ge;
        }
        function $E(s) {
          return wn(s) && _c(s.length) && !!ln[er(s)];
        }
        function My(s) {
          return typeof s == "function" ? s : s == null ? dr : typeof s == "object" ? yt(s) ? jy(s[0], s[1]) : Iy(s) : Jb(s);
        }
        function hp(s) {
          if (!Ps(s))
            return FT(s);
          var c = [];
          for (var f in en(s))
            Yt.call(s, f) && f != "constructor" && c.push(f);
          return c;
        }
        function AE(s) {
          if (!yn(s))
            return bR(s);
          var c = Ps(s), f = [];
          for (var C in s)
            C == "constructor" && (c || !Yt.call(s, C)) || f.push(C);
          return f;
        }
        function gp(s, c) {
          return s < c;
        }
        function _y(s, c) {
          var f = -1, C = cr(s) ? me(s.length) : [];
          return hi(s, function(D, A, q) {
            C[++f] = c(D, A, q);
          }), C;
        }
        function Iy(s) {
          var c = Mp(s);
          return c.length == 1 && c[0][2] ? fb(c[0][0], c[0][1]) : function(f) {
            return f === s || mp(f, s, c);
          };
        }
        function jy(s, c) {
          return Ip(s) && pb(c) ? fb(vo(s), c) : function(f) {
            var C = Wp(f, s);
            return C === n && C === c ? qp(f, s) : Es(c, C, b | y);
          };
        }
        function gc(s, c, f, C, D) {
          s !== c && up(c, function(A, q) {
            if (D || (D = new ao()), yn(A))
              NE(s, c, q, f, gc, C, D);
            else {
              var Y = C ? C($p(s, q), A, q + "", s, c, D) : n;
              Y === n && (Y = A), lp(s, q, Y);
            }
          }, ur);
        }
        function NE(s, c, f, C, D, A, q) {
          var Y = $p(s, f), re = $p(c, f), Ce = q.get(re);
          if (Ce) {
            lp(s, f, Ce);
            return;
          }
          var Oe = A ? A(Y, re, f + "", s, c, q) : n, De = Oe === n;
          if (De) {
            var Fe = yt(re), Xe = !Fe && vi(re), st = !Fe && !Xe && Ma(re);
            Oe = re, Fe || Xe || st ? yt(Y) ? Oe = Y : Pn(Y) ? Oe = lr(Y) : Xe ? (De = !1, Oe = Uy(re, !0)) : st ? (De = !1, Oe = Yy(re, !0)) : Oe = [] : Ms(re) || Qi(re) ? (Oe = Y, Qi(Y) ? Oe = Wb(Y) : (!yn(Y) || Wo(Y)) && (Oe = db(re))) : De = !1;
          }
          De && (q.set(re, Oe), D(Oe, re, C, A, q), q.delete(re)), lp(s, f, Oe);
        }
        function $y(s, c) {
          var f = s.length;
          if (f)
            return c += c < 0 ? f : 0, zo(c, f) ? s[c] : n;
        }
        function Ay(s, c, f) {
          c.length ? c = dn(c, function(A) {
            return yt(A) ? function(q) {
              return Gi(q, A.length === 1 ? A[0] : A);
            } : A;
          }) : c = [dr];
          var C = -1;
          c = dn(c, wr(it()));
          var D = _y(s, function(A, q, Y) {
            var re = dn(c, function(Ce) {
              return Ce(A);
            });
            return { criteria: re, index: ++C, value: A };
          });
          return uT(D, function(A, q) {
            return XE(A, q, f);
          });
        }
        function FE(s, c) {
          return Ny(s, c, function(f, C) {
            return qp(s, C);
          });
        }
        function Ny(s, c, f) {
          for (var C = -1, D = c.length, A = {}; ++C < D; ) {
            var q = c[C], Y = Gi(s, q);
            f(Y, q) && Rs(A, yi(q, s), Y);
          }
          return A;
        }
        function LE(s) {
          return function(c) {
            return Gi(c, s);
          };
        }
        function yp(s, c, f, C) {
          var D = C ? cT : xa, A = -1, q = c.length, Y = s;
          for (s === c && (c = lr(c)), f && (Y = dn(s, wr(f))); ++A < q; )
            for (var re = 0, Ce = c[A], Oe = f ? f(Ce) : Ce; (re = D(Y, Oe, re, C)) > -1; )
              Y !== s && ac.call(Y, re, 1), ac.call(s, re, 1);
          return s;
        }
        function Fy(s, c) {
          for (var f = s ? c.length : 0, C = f - 1; f--; ) {
            var D = c[f];
            if (f == C || D !== A) {
              var A = D;
              zo(D) ? ac.call(s, D, 1) : wp(s, D);
            }
          }
          return s;
        }
        function bp(s, c) {
          return s + cc(by() * (c - s + 1));
        }
        function BE(s, c, f, C) {
          for (var D = -1, A = Fn(lc((c - s) / (f || 1)), 0), q = me(A); A--; )
            q[C ? A : ++D] = s, s += f;
          return q;
        }
        function vp(s, c) {
          var f = "";
          if (!s || c < 1 || c > le)
            return f;
          do
            c % 2 && (f += s), c = cc(c / 2), c && (s += s);
          while (c);
          return f;
        }
        function St(s, c) {
          return Ap(mb(s, c, dr), s + "");
        }
        function VE(s) {
          return wy(_a(s));
        }
        function zE(s, c) {
          var f = _a(s);
          return Ec(f, Yi(c, 0, f.length));
        }
        function Rs(s, c, f, C) {
          if (!yn(s))
            return s;
          c = yi(c, s);
          for (var D = -1, A = c.length, q = A - 1, Y = s; Y != null && ++D < A; ) {
            var re = vo(c[D]), Ce = f;
            if (re === "__proto__" || re === "constructor" || re === "prototype")
              return s;
            if (D != q) {
              var Oe = Y[re];
              Ce = C ? C(Oe, re, Y) : n, Ce === n && (Ce = yn(Oe) ? Oe : zo(c[D + 1]) ? [] : {});
            }
            Ss(Y, re, Ce), Y = Y[re];
          }
          return s;
        }
        var Ly = uc ? function(s, c) {
          return uc.set(s, c), s;
        } : dr, WE = sc ? function(s, c) {
          return sc(s, "toString", {
            configurable: !0,
            enumerable: !1,
            value: Up(c),
            writable: !0
          });
        } : dr;
        function qE(s) {
          return Ec(_a(s));
        }
        function Vr(s, c, f) {
          var C = -1, D = s.length;
          c < 0 && (c = -c > D ? 0 : D + c), f = f > D ? D : f, f < 0 && (f += D), D = c > f ? 0 : f - c >>> 0, c >>>= 0;
          for (var A = me(D); ++C < D; )
            A[C] = s[C + c];
          return A;
        }
        function HE(s, c) {
          var f;
          return hi(s, function(C, D, A) {
            return f = c(C, D, A), !f;
          }), !!f;
        }
        function yc(s, c, f) {
          var C = 0, D = s == null ? C : s.length;
          if (typeof c == "number" && c === c && D <= we) {
            for (; C < D; ) {
              var A = C + D >>> 1, q = s[A];
              q !== null && !Sr(q) && (f ? q <= c : q < c) ? C = A + 1 : D = A;
            }
            return D;
          }
          return xp(s, c, dr, f);
        }
        function xp(s, c, f, C) {
          var D = 0, A = s == null ? 0 : s.length;
          if (A === 0)
            return 0;
          c = f(c);
          for (var q = c !== c, Y = c === null, re = Sr(c), Ce = c === n; D < A; ) {
            var Oe = cc((D + A) / 2), De = f(s[Oe]), Fe = De !== n, Xe = De === null, st = De === De, xt = Sr(De);
            if (q)
              var lt = C || st;
            else Ce ? lt = st && (C || Fe) : Y ? lt = st && Fe && (C || !Xe) : re ? lt = st && Fe && !Xe && (C || !xt) : Xe || xt ? lt = !1 : lt = C ? De <= c : De < c;
            lt ? D = Oe + 1 : A = Oe;
          }
          return Yn(A, be);
        }
        function By(s, c) {
          for (var f = -1, C = s.length, D = 0, A = []; ++f < C; ) {
            var q = s[f], Y = c ? c(q) : q;
            if (!f || !so(Y, re)) {
              var re = Y;
              A[D++] = q === 0 ? 0 : q;
            }
          }
          return A;
        }
        function Vy(s) {
          return typeof s == "number" ? s : Sr(s) ? G : +s;
        }
        function Cr(s) {
          if (typeof s == "string")
            return s;
          if (yt(s))
            return dn(s, Cr) + "";
          if (Sr(s))
            return vy ? vy.call(s) : "";
          var c = s + "";
          return c == "0" && 1 / s == -1 / 0 ? "-0" : c;
        }
        function gi(s, c, f) {
          var C = -1, D = Xl, A = s.length, q = !0, Y = [], re = Y;
          if (f)
            q = !1, D = Kd;
          else if (A >= i) {
            var Ce = c ? null : nR(s);
            if (Ce)
              return Zl(Ce);
            q = !1, D = ys, re = new Ui();
          } else
            re = c ? [] : Y;
          e:
            for (; ++C < A; ) {
              var Oe = s[C], De = c ? c(Oe) : Oe;
              if (Oe = f || Oe !== 0 ? Oe : 0, q && De === De) {
                for (var Fe = re.length; Fe--; )
                  if (re[Fe] === De)
                    continue e;
                c && re.push(De), Y.push(Oe);
              } else D(re, De, f) || (re !== Y && re.push(De), Y.push(Oe));
            }
          return Y;
        }
        function wp(s, c) {
          return c = yi(c, s), s = hb(s, c), s == null || delete s[vo(zr(c))];
        }
        function zy(s, c, f, C) {
          return Rs(s, c, f(Gi(s, c)), C);
        }
        function bc(s, c, f, C) {
          for (var D = s.length, A = C ? D : -1; (C ? A-- : ++A < D) && c(s[A], A, s); )
            ;
          return f ? Vr(s, C ? 0 : A, C ? A + 1 : D) : Vr(s, C ? A + 1 : 0, C ? D : A);
        }
        function Wy(s, c) {
          var f = s;
          return f instanceof Pt && (f = f.value()), Xd(c, function(C, D) {
            return D.func.apply(D.thisArg, pi([C], D.args));
          }, f);
        }
        function Cp(s, c, f) {
          var C = s.length;
          if (C < 2)
            return C ? gi(s[0]) : [];
          for (var D = -1, A = me(C); ++D < C; )
            for (var q = s[D], Y = -1; ++Y < C; )
              Y != D && (A[D] = Os(A[D] || q, s[Y], c, f));
          return gi(zn(A, 1), c, f);
        }
        function qy(s, c, f) {
          for (var C = -1, D = s.length, A = c.length, q = {}; ++C < D; ) {
            var Y = C < A ? c[C] : n;
            f(q, s[C], Y);
          }
          return q;
        }
        function Sp(s) {
          return Pn(s) ? s : [];
        }
        function Op(s) {
          return typeof s == "function" ? s : dr;
        }
        function yi(s, c) {
          return yt(s) ? s : Ip(s, c) ? [s] : vb(zt(s));
        }
        var UE = St;
        function bi(s, c, f) {
          var C = s.length;
          return f = f === n ? C : f, !c && f >= C ? s : Vr(s, c, f);
        }
        var Hy = IT || function(s) {
          return Vn.clearTimeout(s);
        };
        function Uy(s, c) {
          if (c)
            return s.slice();
          var f = s.length, C = fy ? fy(f) : new s.constructor(f);
          return s.copy(C), C;
        }
        function Tp(s) {
          var c = new s.constructor(s.byteLength);
          return new oc(c).set(new oc(s)), c;
        }
        function YE(s, c) {
          var f = c ? Tp(s.buffer) : s.buffer;
          return new s.constructor(f, s.byteOffset, s.byteLength);
        }
        function GE(s) {
          var c = new s.constructor(s.source, fe.exec(s));
          return c.lastIndex = s.lastIndex, c;
        }
        function KE(s) {
          return Cs ? en(Cs.call(s)) : {};
        }
        function Yy(s, c) {
          var f = c ? Tp(s.buffer) : s.buffer;
          return new s.constructor(f, s.byteOffset, s.length);
        }
        function Gy(s, c) {
          if (s !== c) {
            var f = s !== n, C = s === null, D = s === s, A = Sr(s), q = c !== n, Y = c === null, re = c === c, Ce = Sr(c);
            if (!Y && !Ce && !A && s > c || A && q && re && !Y && !Ce || C && q && re || !f && re || !D)
              return 1;
            if (!C && !A && !Ce && s < c || Ce && f && D && !C && !A || Y && f && D || !q && D || !re)
              return -1;
          }
          return 0;
        }
        function XE(s, c, f) {
          for (var C = -1, D = s.criteria, A = c.criteria, q = D.length, Y = f.length; ++C < q; ) {
            var re = Gy(D[C], A[C]);
            if (re) {
              if (C >= Y)
                return re;
              var Ce = f[C];
              return re * (Ce == "desc" ? -1 : 1);
            }
          }
          return s.index - c.index;
        }
        function Ky(s, c, f, C) {
          for (var D = -1, A = s.length, q = f.length, Y = -1, re = c.length, Ce = Fn(A - q, 0), Oe = me(re + Ce), De = !C; ++Y < re; )
            Oe[Y] = c[Y];
          for (; ++D < q; )
            (De || D < A) && (Oe[f[D]] = s[D]);
          for (; Ce--; )
            Oe[Y++] = s[D++];
          return Oe;
        }
        function Xy(s, c, f, C) {
          for (var D = -1, A = s.length, q = -1, Y = f.length, re = -1, Ce = c.length, Oe = Fn(A - Y, 0), De = me(Oe + Ce), Fe = !C; ++D < Oe; )
            De[D] = s[D];
          for (var Xe = D; ++re < Ce; )
            De[Xe + re] = c[re];
          for (; ++q < Y; )
            (Fe || D < A) && (De[Xe + f[q]] = s[D++]);
          return De;
        }
        function lr(s, c) {
          var f = -1, C = s.length;
          for (c || (c = me(C)); ++f < C; )
            c[f] = s[f];
          return c;
        }
        function bo(s, c, f, C) {
          var D = !f;
          f || (f = {});
          for (var A = -1, q = c.length; ++A < q; ) {
            var Y = c[A], re = C ? C(f[Y], s[Y], Y, f, s) : n;
            re === n && (re = s[Y]), D ? Lo(f, Y, re) : Ss(f, Y, re);
          }
          return f;
        }
        function QE(s, c) {
          return bo(s, _p(s), c);
        }
        function ZE(s, c) {
          return bo(s, cb(s), c);
        }
        function vc(s, c) {
          return function(f, C) {
            var D = yt(f) ? rT : xE, A = c ? c() : {};
            return D(f, s, it(C, 2), A);
          };
        }
        function ka(s) {
          return St(function(c, f) {
            var C = -1, D = f.length, A = D > 1 ? f[D - 1] : n, q = D > 2 ? f[2] : n;
            for (A = s.length > 3 && typeof A == "function" ? (D--, A) : n, q && tr(f[0], f[1], q) && (A = D < 3 ? n : A, D = 1), c = en(c); ++C < D; ) {
              var Y = f[C];
              Y && s(c, Y, C, A);
            }
            return c;
          });
        }
        function Qy(s, c) {
          return function(f, C) {
            if (f == null)
              return f;
            if (!cr(f))
              return s(f, C);
            for (var D = f.length, A = c ? D : -1, q = en(f); (c ? A-- : ++A < D) && C(q[A], A, q) !== !1; )
              ;
            return f;
          };
        }
        function Zy(s) {
          return function(c, f, C) {
            for (var D = -1, A = en(c), q = C(c), Y = q.length; Y--; ) {
              var re = q[s ? Y : ++D];
              if (f(A[re], re, A) === !1)
                break;
            }
            return c;
          };
        }
        function JE(s, c, f) {
          var C = c & S, D = ks(s);
          function A() {
            var q = this && this !== Vn && this instanceof A ? D : s;
            return q.apply(C ? f : this, arguments);
          }
          return A;
        }
        function Jy(s) {
          return function(c) {
            c = zt(c);
            var f = wa(c) ? io(c) : n, C = f ? f[0] : c.charAt(0), D = f ? bi(f, 1).join("") : c.slice(1);
            return C[s]() + D;
          };
        }
        function Pa(s) {
          return function(c) {
            return Xd(Qb(Xb(c).replace(WO, "")), s, "");
          };
        }
        function ks(s) {
          return function() {
            var c = arguments;
            switch (c.length) {
              case 0:
                return new s();
              case 1:
                return new s(c[0]);
              case 2:
                return new s(c[0], c[1]);
              case 3:
                return new s(c[0], c[1], c[2]);
              case 4:
                return new s(c[0], c[1], c[2], c[3]);
              case 5:
                return new s(c[0], c[1], c[2], c[3], c[4]);
              case 6:
                return new s(c[0], c[1], c[2], c[3], c[4], c[5]);
              case 7:
                return new s(c[0], c[1], c[2], c[3], c[4], c[5], c[6]);
            }
            var f = Ra(s.prototype), C = s.apply(f, c);
            return yn(C) ? C : f;
          };
        }
        function eR(s, c, f) {
          var C = ks(s);
          function D() {
            for (var A = arguments.length, q = me(A), Y = A, re = Da(D); Y--; )
              q[Y] = arguments[Y];
            var Ce = A < 3 && q[0] !== re && q[A - 1] !== re ? [] : fi(q, re);
            if (A -= Ce.length, A < f)
              return ob(
                s,
                c,
                xc,
                D.placeholder,
                n,
                q,
                Ce,
                n,
                n,
                f - A
              );
            var Oe = this && this !== Vn && this instanceof D ? C : s;
            return xr(Oe, this, q);
          }
          return D;
        }
        function eb(s) {
          return function(c, f, C) {
            var D = en(c);
            if (!cr(c)) {
              var A = it(f, 3);
              c = Ln(c), f = function(Y) {
                return A(D[Y], Y, D);
              };
            }
            var q = s(c, f, C);
            return q > -1 ? D[A ? c[q] : q] : n;
          };
        }
        function tb(s) {
          return Vo(function(c) {
            var f = c.length, C = f, D = Lr.prototype.thru;
            for (s && c.reverse(); C--; ) {
              var A = c[C];
              if (typeof A != "function")
                throw new Fr(l);
              if (D && !q && Oc(A) == "wrapper")
                var q = new Lr([], !0);
            }
            for (C = q ? C : f; ++C < f; ) {
              A = c[C];
              var Y = Oc(A), re = Y == "wrapper" ? Dp(A) : n;
              re && jp(re[0]) && re[1] == (_ | k | E | I) && !re[4].length && re[9] == 1 ? q = q[Oc(re[0])].apply(q, re[3]) : q = A.length == 1 && jp(A) ? q[Y]() : q.thru(A);
            }
            return function() {
              var Ce = arguments, Oe = Ce[0];
              if (q && Ce.length == 1 && yt(Oe))
                return q.plant(Oe).value();
              for (var De = 0, Fe = f ? c[De].apply(this, Ce) : Oe; ++De < f; )
                Fe = c[De].call(this, Fe);
              return Fe;
            };
          });
        }
        function xc(s, c, f, C, D, A, q, Y, re, Ce) {
          var Oe = c & _, De = c & S, Fe = c & O, Xe = c & (k | R), st = c & F, xt = Fe ? n : ks(s);
          function lt() {
            for (var Tt = arguments.length, _t = me(Tt), Or = Tt; Or--; )
              _t[Or] = arguments[Or];
            if (Xe)
              var nr = Da(lt), Tr = pT(_t, nr);
            if (C && (_t = Ky(_t, C, D, Xe)), A && (_t = Xy(_t, A, q, Xe)), Tt -= Tr, Xe && Tt < Ce) {
              var Dn = fi(_t, nr);
              return ob(
                s,
                c,
                xc,
                lt.placeholder,
                f,
                _t,
                Dn,
                Y,
                re,
                Ce - Tt
              );
            }
            var lo = De ? f : this, Ho = Fe ? lo[s] : s;
            return Tt = _t.length, Y ? _t = xR(_t, Y) : st && Tt > 1 && _t.reverse(), Oe && re < Tt && (_t.length = re), this && this !== Vn && this instanceof lt && (Ho = xt || ks(Ho)), Ho.apply(lo, _t);
          }
          return lt;
        }
        function nb(s, c) {
          return function(f, C) {
            return kE(f, s, c(C), {});
          };
        }
        function wc(s, c) {
          return function(f, C) {
            var D;
            if (f === n && C === n)
              return c;
            if (f !== n && (D = f), C !== n) {
              if (D === n)
                return C;
              typeof f == "string" || typeof C == "string" ? (f = Cr(f), C = Cr(C)) : (f = Vy(f), C = Vy(C)), D = s(f, C);
            }
            return D;
          };
        }
        function Ep(s) {
          return Vo(function(c) {
            return c = dn(c, wr(it())), St(function(f) {
              var C = this;
              return s(c, function(D) {
                return xr(D, C, f);
              });
            });
          });
        }
        function Cc(s, c) {
          c = c === n ? " " : Cr(c);
          var f = c.length;
          if (f < 2)
            return f ? vp(c, s) : c;
          var C = vp(c, lc(s / Ca(c)));
          return wa(c) ? bi(io(C), 0, s).join("") : C.slice(0, s);
        }
        function tR(s, c, f, C) {
          var D = c & S, A = ks(s);
          function q() {
            for (var Y = -1, re = arguments.length, Ce = -1, Oe = C.length, De = me(Oe + re), Fe = this && this !== Vn && this instanceof q ? A : s; ++Ce < Oe; )
              De[Ce] = C[Ce];
            for (; re--; )
              De[Ce++] = arguments[++Y];
            return xr(Fe, D ? f : this, De);
          }
          return q;
        }
        function rb(s) {
          return function(c, f, C) {
            return C && typeof C != "number" && tr(c, f, C) && (f = C = n), c = qo(c), f === n ? (f = c, c = 0) : f = qo(f), C = C === n ? c < f ? 1 : -1 : qo(C), BE(c, f, C, s);
          };
        }
        function Sc(s) {
          return function(c, f) {
            return typeof c == "string" && typeof f == "string" || (c = Wr(c), f = Wr(f)), s(c, f);
          };
        }
        function ob(s, c, f, C, D, A, q, Y, re, Ce) {
          var Oe = c & k, De = Oe ? q : n, Fe = Oe ? n : q, Xe = Oe ? A : n, st = Oe ? n : A;
          c |= Oe ? E : M, c &= ~(Oe ? M : E), c & P || (c &= -4);
          var xt = [
            s,
            c,
            D,
            Xe,
            De,
            st,
            Fe,
            Y,
            re,
            Ce
          ], lt = f.apply(n, xt);
          return jp(s) && gb(lt, xt), lt.placeholder = C, yb(lt, s, c);
        }
        function Rp(s) {
          var c = Nn[s];
          return function(f, C) {
            if (f = Wr(f), C = C == null ? 0 : Yn(bt(C), 292), C && yy(f)) {
              var D = (zt(f) + "e").split("e"), A = c(D[0] + "e" + (+D[1] + C));
              return D = (zt(A) + "e").split("e"), +(D[0] + "e" + (+D[1] - C));
            }
            return c(f);
          };
        }
        var nR = Ta && 1 / Zl(new Ta([, -0]))[1] == X ? function(s) {
          return new Ta(s);
        } : Kp;
        function ib(s) {
          return function(c) {
            var f = Gn(c);
            return f == ie ? rp(c) : f == Ge ? vT(c) : dT(c, s(c));
          };
        }
        function Bo(s, c, f, C, D, A, q, Y) {
          var re = c & O;
          if (!re && typeof s != "function")
            throw new Fr(l);
          var Ce = C ? C.length : 0;
          if (Ce || (c &= -97, C = D = n), q = q === n ? q : Fn(bt(q), 0), Y = Y === n ? Y : bt(Y), Ce -= D ? D.length : 0, c & M) {
            var Oe = C, De = D;
            C = D = n;
          }
          var Fe = re ? n : Dp(s), Xe = [
            s,
            c,
            f,
            C,
            D,
            Oe,
            De,
            A,
            q,
            Y
          ];
          if (Fe && yR(Xe, Fe), s = Xe[0], c = Xe[1], f = Xe[2], C = Xe[3], D = Xe[4], Y = Xe[9] = Xe[9] === n ? re ? 0 : s.length : Fn(Xe[9] - Ce, 0), !Y && c & (k | R) && (c &= -25), !c || c == S)
            var st = JE(s, c, f);
          else c == k || c == R ? st = eR(s, c, Y) : (c == E || c == (S | E)) && !D.length ? st = tR(s, c, f, C) : st = xc.apply(n, Xe);
          var xt = Fe ? Ly : gb;
          return yb(xt(st, Xe), s, c);
        }
        function ab(s, c, f, C) {
          return s === n || so(s, Oa[f]) && !Yt.call(C, f) ? c : s;
        }
        function sb(s, c, f, C, D, A) {
          return yn(s) && yn(c) && (A.set(c, s), gc(s, c, n, sb, A), A.delete(c)), s;
        }
        function rR(s) {
          return Ms(s) ? n : s;
        }
        function lb(s, c, f, C, D, A) {
          var q = f & b, Y = s.length, re = c.length;
          if (Y != re && !(q && re > Y))
            return !1;
          var Ce = A.get(s), Oe = A.get(c);
          if (Ce && Oe)
            return Ce == c && Oe == s;
          var De = -1, Fe = !0, Xe = f & y ? new Ui() : n;
          for (A.set(s, c), A.set(c, s); ++De < Y; ) {
            var st = s[De], xt = c[De];
            if (C)
              var lt = q ? C(xt, st, De, c, s, A) : C(st, xt, De, s, c, A);
            if (lt !== n) {
              if (lt)
                continue;
              Fe = !1;
              break;
            }
            if (Xe) {
              if (!Qd(c, function(Tt, _t) {
                if (!ys(Xe, _t) && (st === Tt || D(st, Tt, f, C, A)))
                  return Xe.push(_t);
              })) {
                Fe = !1;
                break;
              }
            } else if (!(st === xt || D(st, xt, f, C, A))) {
              Fe = !1;
              break;
            }
          }
          return A.delete(s), A.delete(c), Fe;
        }
        function oR(s, c, f, C, D, A, q) {
          switch (f) {
            case Je:
              if (s.byteLength != c.byteLength || s.byteOffset != c.byteOffset)
                return !1;
              s = s.buffer, c = c.buffer;
            case He:
              return !(s.byteLength != c.byteLength || !A(new oc(s), new oc(c)));
            case K:
            case Z:
            case ge:
              return so(+s, +c);
            case he:
              return s.name == c.name && s.message == c.message;
            case Be:
            case Ie:
              return s == c + "";
            case ie:
              var Y = rp;
            case Ge:
              var re = C & b;
              if (Y || (Y = Zl), s.size != c.size && !re)
                return !1;
              var Ce = q.get(s);
              if (Ce)
                return Ce == c;
              C |= y, q.set(s, c);
              var Oe = lb(Y(s), Y(c), C, D, A, q);
              return q.delete(s), Oe;
            case Dt:
              if (Cs)
                return Cs.call(s) == Cs.call(c);
          }
          return !1;
        }
        function iR(s, c, f, C, D, A) {
          var q = f & b, Y = kp(s), re = Y.length, Ce = kp(c), Oe = Ce.length;
          if (re != Oe && !q)
            return !1;
          for (var De = re; De--; ) {
            var Fe = Y[De];
            if (!(q ? Fe in c : Yt.call(c, Fe)))
              return !1;
          }
          var Xe = A.get(s), st = A.get(c);
          if (Xe && st)
            return Xe == c && st == s;
          var xt = !0;
          A.set(s, c), A.set(c, s);
          for (var lt = q; ++De < re; ) {
            Fe = Y[De];
            var Tt = s[Fe], _t = c[Fe];
            if (C)
              var Or = q ? C(_t, Tt, Fe, c, s, A) : C(Tt, _t, Fe, s, c, A);
            if (!(Or === n ? Tt === _t || D(Tt, _t, f, C, A) : Or)) {
              xt = !1;
              break;
            }
            lt || (lt = Fe == "constructor");
          }
          if (xt && !lt) {
            var nr = s.constructor, Tr = c.constructor;
            nr != Tr && "constructor" in s && "constructor" in c && !(typeof nr == "function" && nr instanceof nr && typeof Tr == "function" && Tr instanceof Tr) && (xt = !1);
          }
          return A.delete(s), A.delete(c), xt;
        }
        function Vo(s) {
          return Ap(mb(s, n, Sb), s + "");
        }
        function kp(s) {
          return ky(s, Ln, _p);
        }
        function Pp(s) {
          return ky(s, ur, cb);
        }
        var Dp = uc ? function(s) {
          return uc.get(s);
        } : Kp;
        function Oc(s) {
          for (var c = s.name + "", f = Ea[c], C = Yt.call(Ea, c) ? f.length : 0; C--; ) {
            var D = f[C], A = D.func;
            if (A == null || A == s)
              return D.name;
          }
          return c;
        }
        function Da(s) {
          var c = Yt.call(j, "placeholder") ? j : s;
          return c.placeholder;
        }
        function it() {
          var s = j.iteratee || Yp;
          return s = s === Yp ? My : s, arguments.length ? s(arguments[0], arguments[1]) : s;
        }
        function Tc(s, c) {
          var f = s.__data__;
          return fR(c) ? f[typeof c == "string" ? "string" : "hash"] : f.map;
        }
        function Mp(s) {
          for (var c = Ln(s), f = c.length; f--; ) {
            var C = c[f], D = s[C];
            c[f] = [C, D, pb(D)];
          }
          return c;
        }
        function Ki(s, c) {
          var f = gT(s, c);
          return Dy(f) ? f : n;
        }
        function aR(s) {
          var c = Yt.call(s, qi), f = s[qi];
          try {
            s[qi] = n;
            var C = !0;
          } catch {
          }
          var D = nc.call(s);
          return C && (c ? s[qi] = f : delete s[qi]), D;
        }
        var _p = ip ? function(s) {
          return s == null ? [] : (s = en(s), di(ip(s), function(c) {
            return hy.call(s, c);
          }));
        } : Xp, cb = ip ? function(s) {
          for (var c = []; s; )
            pi(c, _p(s)), s = ic(s);
          return c;
        } : Xp, Gn = er;
        (ap && Gn(new ap(new ArrayBuffer(1))) != Je || vs && Gn(new vs()) != ie || sp && Gn(sp.resolve()) != Ee || Ta && Gn(new Ta()) != Ge || xs && Gn(new xs()) != $e) && (Gn = function(s) {
          var c = er(s), f = c == pe ? s.constructor : n, C = f ? Xi(f) : "";
          if (C)
            switch (C) {
              case zT:
                return Je;
              case WT:
                return ie;
              case qT:
                return Ee;
              case HT:
                return Ge;
              case UT:
                return $e;
            }
          return c;
        });
        function sR(s, c, f) {
          for (var C = -1, D = f.length; ++C < D; ) {
            var A = f[C], q = A.size;
            switch (A.type) {
              case "drop":
                s += q;
                break;
              case "dropRight":
                c -= q;
                break;
              case "take":
                c = Yn(c, s + q);
                break;
              case "takeRight":
                s = Fn(s, c - q);
                break;
            }
          }
          return { start: s, end: c };
        }
        function lR(s) {
          var c = s.match(Vi);
          return c ? c[1].split(H) : [];
        }
        function ub(s, c, f) {
          c = yi(c, s);
          for (var C = -1, D = c.length, A = !1; ++C < D; ) {
            var q = vo(c[C]);
            if (!(A = s != null && f(s, q)))
              break;
            s = s[q];
          }
          return A || ++C != D ? A : (D = s == null ? 0 : s.length, !!D && _c(D) && zo(q, D) && (yt(s) || Qi(s)));
        }
        function cR(s) {
          var c = s.length, f = new s.constructor(c);
          return c && typeof s[0] == "string" && Yt.call(s, "index") && (f.index = s.index, f.input = s.input), f;
        }
        function db(s) {
          return typeof s.constructor == "function" && !Ps(s) ? Ra(ic(s)) : {};
        }
        function uR(s, c, f) {
          var C = s.constructor;
          switch (c) {
            case He:
              return Tp(s);
            case K:
            case Z:
              return new C(+s);
            case Je:
              return YE(s, f);
            case Ze:
            case nt:
            case Ne:
            case Ct:
            case Rt:
            case At:
            case Xt:
            case je:
            case ot:
              return Yy(s, f);
            case ie:
              return new C();
            case ge:
            case Ie:
              return new C(s);
            case Be:
              return GE(s);
            case Ge:
              return new C();
            case Dt:
              return KE(s);
          }
        }
        function dR(s, c) {
          var f = c.length;
          if (!f)
            return s;
          var C = f - 1;
          return c[C] = (f > 1 ? "& " : "") + c[C], c = c.join(f > 2 ? ", " : " "), s.replace(Bi, `{
/* [wrapped with ` + c + `] */
`);
        }
        function pR(s) {
          return yt(s) || Qi(s) || !!(gy && s && s[gy]);
        }
        function zo(s, c) {
          var f = typeof s;
          return c = c ?? le, !!c && (f == "number" || f != "symbol" && tt.test(s)) && s > -1 && s % 1 == 0 && s < c;
        }
        function tr(s, c, f) {
          if (!yn(f))
            return !1;
          var C = typeof c;
          return (C == "number" ? cr(f) && zo(c, f.length) : C == "string" && c in f) ? so(f[c], s) : !1;
        }
        function Ip(s, c) {
          if (yt(s))
            return !1;
          var f = typeof s;
          return f == "number" || f == "symbol" || f == "boolean" || s == null || Sr(s) ? !0 : ho.test(s) || !jn.test(s) || c != null && s in en(c);
        }
        function fR(s) {
          var c = typeof s;
          return c == "string" || c == "number" || c == "symbol" || c == "boolean" ? s !== "__proto__" : s === null;
        }
        function jp(s) {
          var c = Oc(s), f = j[c];
          if (typeof f != "function" || !(c in Pt.prototype))
            return !1;
          if (s === f)
            return !0;
          var C = Dp(f);
          return !!C && s === C[0];
        }
        function mR(s) {
          return !!py && py in s;
        }
        var hR = ec ? Wo : Qp;
        function Ps(s) {
          var c = s && s.constructor, f = typeof c == "function" && c.prototype || Oa;
          return s === f;
        }
        function pb(s) {
          return s === s && !yn(s);
        }
        function fb(s, c) {
          return function(f) {
            return f == null ? !1 : f[s] === c && (c !== n || s in en(f));
          };
        }
        function gR(s) {
          var c = Dc(s, function(C) {
            return f.size === p && f.clear(), C;
          }), f = c.cache;
          return c;
        }
        function yR(s, c) {
          var f = s[1], C = c[1], D = f | C, A = D < (S | O | _), q = C == _ && f == k || C == _ && f == I && s[7].length <= c[8] || C == (_ | I) && c[7].length <= c[8] && f == k;
          if (!(A || q))
            return s;
          C & S && (s[2] = c[2], D |= f & S ? 0 : P);
          var Y = c[3];
          if (Y) {
            var re = s[3];
            s[3] = re ? Ky(re, Y, c[4]) : Y, s[4] = re ? fi(s[3], m) : c[4];
          }
          return Y = c[5], Y && (re = s[5], s[5] = re ? Xy(re, Y, c[6]) : Y, s[6] = re ? fi(s[5], m) : c[6]), Y = c[7], Y && (s[7] = Y), C & _ && (s[8] = s[8] == null ? c[8] : Yn(s[8], c[8])), s[9] == null && (s[9] = c[9]), s[0] = c[0], s[1] = D, s;
        }
        function bR(s) {
          var c = [];
          if (s != null)
            for (var f in en(s))
              c.push(f);
          return c;
        }
        function vR(s) {
          return nc.call(s);
        }
        function mb(s, c, f) {
          return c = Fn(c === n ? s.length - 1 : c, 0), function() {
            for (var C = arguments, D = -1, A = Fn(C.length - c, 0), q = me(A); ++D < A; )
              q[D] = C[c + D];
            D = -1;
            for (var Y = me(c + 1); ++D < c; )
              Y[D] = C[D];
            return Y[c] = f(q), xr(s, this, Y);
          };
        }
        function hb(s, c) {
          return c.length < 2 ? s : Gi(s, Vr(c, 0, -1));
        }
        function xR(s, c) {
          for (var f = s.length, C = Yn(c.length, f), D = lr(s); C--; ) {
            var A = c[C];
            s[C] = zo(A, f) ? D[A] : n;
          }
          return s;
        }
        function $p(s, c) {
          if (!(c === "constructor" && typeof s[c] == "function") && c != "__proto__")
            return s[c];
        }
        var gb = bb(Ly), Ds = $T || function(s, c) {
          return Vn.setTimeout(s, c);
        }, Ap = bb(WE);
        function yb(s, c, f) {
          var C = c + "";
          return Ap(s, dR(C, wR(lR(C), f)));
        }
        function bb(s) {
          var c = 0, f = 0;
          return function() {
            var C = LT(), D = W - (C - f);
            if (f = C, D > 0) {
              if (++c >= N)
                return arguments[0];
            } else
              c = 0;
            return s.apply(n, arguments);
          };
        }
        function Ec(s, c) {
          var f = -1, C = s.length, D = C - 1;
          for (c = c === n ? C : c; ++f < c; ) {
            var A = bp(f, D), q = s[A];
            s[A] = s[f], s[f] = q;
          }
          return s.length = c, s;
        }
        var vb = gR(function(s) {
          var c = [];
          return s.charCodeAt(0) === 46 && c.push(""), s.replace(ro, function(f, C, D, A) {
            c.push(D ? A.replace(Qe, "$1") : C || f);
          }), c;
        });
        function vo(s) {
          if (typeof s == "string" || Sr(s))
            return s;
          var c = s + "";
          return c == "0" && 1 / s == -1 / 0 ? "-0" : c;
        }
        function Xi(s) {
          if (s != null) {
            try {
              return tc.call(s);
            } catch {
            }
            try {
              return s + "";
            } catch {
            }
          }
          return "";
        }
        function wR(s, c) {
          return Nr(se, function(f) {
            var C = "_." + f[0];
            c & f[1] && !Xl(s, C) && s.push(C);
          }), s.sort();
        }
        function xb(s) {
          if (s instanceof Pt)
            return s.clone();
          var c = new Lr(s.__wrapped__, s.__chain__);
          return c.__actions__ = lr(s.__actions__), c.__index__ = s.__index__, c.__values__ = s.__values__, c;
        }
        function CR(s, c, f) {
          (f ? tr(s, c, f) : c === n) ? c = 1 : c = Fn(bt(c), 0);
          var C = s == null ? 0 : s.length;
          if (!C || c < 1)
            return [];
          for (var D = 0, A = 0, q = me(lc(C / c)); D < C; )
            q[A++] = Vr(s, D, D += c);
          return q;
        }
        function SR(s) {
          for (var c = -1, f = s == null ? 0 : s.length, C = 0, D = []; ++c < f; ) {
            var A = s[c];
            A && (D[C++] = A);
          }
          return D;
        }
        function OR() {
          var s = arguments.length;
          if (!s)
            return [];
          for (var c = me(s - 1), f = arguments[0], C = s; C--; )
            c[C - 1] = arguments[C];
          return pi(yt(f) ? lr(f) : [f], zn(c, 1));
        }
        var TR = St(function(s, c) {
          return Pn(s) ? Os(s, zn(c, 1, Pn, !0)) : [];
        }), ER = St(function(s, c) {
          var f = zr(c);
          return Pn(f) && (f = n), Pn(s) ? Os(s, zn(c, 1, Pn, !0), it(f, 2)) : [];
        }), RR = St(function(s, c) {
          var f = zr(c);
          return Pn(f) && (f = n), Pn(s) ? Os(s, zn(c, 1, Pn, !0), n, f) : [];
        });
        function kR(s, c, f) {
          var C = s == null ? 0 : s.length;
          return C ? (c = f || c === n ? 1 : bt(c), Vr(s, c < 0 ? 0 : c, C)) : [];
        }
        function PR(s, c, f) {
          var C = s == null ? 0 : s.length;
          return C ? (c = f || c === n ? 1 : bt(c), c = C - c, Vr(s, 0, c < 0 ? 0 : c)) : [];
        }
        function DR(s, c) {
          return s && s.length ? bc(s, it(c, 3), !0, !0) : [];
        }
        function MR(s, c) {
          return s && s.length ? bc(s, it(c, 3), !0) : [];
        }
        function _R(s, c, f, C) {
          var D = s == null ? 0 : s.length;
          return D ? (f && typeof f != "number" && tr(s, c, f) && (f = 0, C = D), OE(s, c, f, C)) : [];
        }
        function wb(s, c, f) {
          var C = s == null ? 0 : s.length;
          if (!C)
            return -1;
          var D = f == null ? 0 : bt(f);
          return D < 0 && (D = Fn(C + D, 0)), Ql(s, it(c, 3), D);
        }
        function Cb(s, c, f) {
          var C = s == null ? 0 : s.length;
          if (!C)
            return -1;
          var D = C - 1;
          return f !== n && (D = bt(f), D = f < 0 ? Fn(C + D, 0) : Yn(D, C - 1)), Ql(s, it(c, 3), D, !0);
        }
        function Sb(s) {
          var c = s == null ? 0 : s.length;
          return c ? zn(s, 1) : [];
        }
        function IR(s) {
          var c = s == null ? 0 : s.length;
          return c ? zn(s, X) : [];
        }
        function jR(s, c) {
          var f = s == null ? 0 : s.length;
          return f ? (c = c === n ? 1 : bt(c), zn(s, c)) : [];
        }
        function $R(s) {
          for (var c = -1, f = s == null ? 0 : s.length, C = {}; ++c < f; ) {
            var D = s[c];
            C[D[0]] = D[1];
          }
          return C;
        }
        function Ob(s) {
          return s && s.length ? s[0] : n;
        }
        function AR(s, c, f) {
          var C = s == null ? 0 : s.length;
          if (!C)
            return -1;
          var D = f == null ? 0 : bt(f);
          return D < 0 && (D = Fn(C + D, 0)), xa(s, c, D);
        }
        function NR(s) {
          var c = s == null ? 0 : s.length;
          return c ? Vr(s, 0, -1) : [];
        }
        var FR = St(function(s) {
          var c = dn(s, Sp);
          return c.length && c[0] === s[0] ? fp(c) : [];
        }), LR = St(function(s) {
          var c = zr(s), f = dn(s, Sp);
          return c === zr(f) ? c = n : f.pop(), f.length && f[0] === s[0] ? fp(f, it(c, 2)) : [];
        }), BR = St(function(s) {
          var c = zr(s), f = dn(s, Sp);
          return c = typeof c == "function" ? c : n, c && f.pop(), f.length && f[0] === s[0] ? fp(f, n, c) : [];
        });
        function VR(s, c) {
          return s == null ? "" : NT.call(s, c);
        }
        function zr(s) {
          var c = s == null ? 0 : s.length;
          return c ? s[c - 1] : n;
        }
        function zR(s, c, f) {
          var C = s == null ? 0 : s.length;
          if (!C)
            return -1;
          var D = C;
          return f !== n && (D = bt(f), D = D < 0 ? Fn(C + D, 0) : Yn(D, C - 1)), c === c ? wT(s, c, D) : Ql(s, oy, D, !0);
        }
        function WR(s, c) {
          return s && s.length ? $y(s, bt(c)) : n;
        }
        var qR = St(Tb);
        function Tb(s, c) {
          return s && s.length && c && c.length ? yp(s, c) : s;
        }
        function HR(s, c, f) {
          return s && s.length && c && c.length ? yp(s, c, it(f, 2)) : s;
        }
        function UR(s, c, f) {
          return s && s.length && c && c.length ? yp(s, c, n, f) : s;
        }
        var YR = Vo(function(s, c) {
          var f = s == null ? 0 : s.length, C = cp(s, c);
          return Fy(s, dn(c, function(D) {
            return zo(D, f) ? +D : D;
          }).sort(Gy)), C;
        });
        function GR(s, c) {
          var f = [];
          if (!(s && s.length))
            return f;
          var C = -1, D = [], A = s.length;
          for (c = it(c, 3); ++C < A; ) {
            var q = s[C];
            c(q, C, s) && (f.push(q), D.push(C));
          }
          return Fy(s, D), f;
        }
        function Np(s) {
          return s == null ? s : VT.call(s);
        }
        function KR(s, c, f) {
          var C = s == null ? 0 : s.length;
          return C ? (f && typeof f != "number" && tr(s, c, f) ? (c = 0, f = C) : (c = c == null ? 0 : bt(c), f = f === n ? C : bt(f)), Vr(s, c, f)) : [];
        }
        function XR(s, c) {
          return yc(s, c);
        }
        function QR(s, c, f) {
          return xp(s, c, it(f, 2));
        }
        function ZR(s, c) {
          var f = s == null ? 0 : s.length;
          if (f) {
            var C = yc(s, c);
            if (C < f && so(s[C], c))
              return C;
          }
          return -1;
        }
        function JR(s, c) {
          return yc(s, c, !0);
        }
        function ek(s, c, f) {
          return xp(s, c, it(f, 2), !0);
        }
        function tk(s, c) {
          var f = s == null ? 0 : s.length;
          if (f) {
            var C = yc(s, c, !0) - 1;
            if (so(s[C], c))
              return C;
          }
          return -1;
        }
        function nk(s) {
          return s && s.length ? By(s) : [];
        }
        function rk(s, c) {
          return s && s.length ? By(s, it(c, 2)) : [];
        }
        function ok(s) {
          var c = s == null ? 0 : s.length;
          return c ? Vr(s, 1, c) : [];
        }
        function ik(s, c, f) {
          return s && s.length ? (c = f || c === n ? 1 : bt(c), Vr(s, 0, c < 0 ? 0 : c)) : [];
        }
        function ak(s, c, f) {
          var C = s == null ? 0 : s.length;
          return C ? (c = f || c === n ? 1 : bt(c), c = C - c, Vr(s, c < 0 ? 0 : c, C)) : [];
        }
        function sk(s, c) {
          return s && s.length ? bc(s, it(c, 3), !1, !0) : [];
        }
        function lk(s, c) {
          return s && s.length ? bc(s, it(c, 3)) : [];
        }
        var ck = St(function(s) {
          return gi(zn(s, 1, Pn, !0));
        }), uk = St(function(s) {
          var c = zr(s);
          return Pn(c) && (c = n), gi(zn(s, 1, Pn, !0), it(c, 2));
        }), dk = St(function(s) {
          var c = zr(s);
          return c = typeof c == "function" ? c : n, gi(zn(s, 1, Pn, !0), n, c);
        });
        function pk(s) {
          return s && s.length ? gi(s) : [];
        }
        function fk(s, c) {
          return s && s.length ? gi(s, it(c, 2)) : [];
        }
        function mk(s, c) {
          return c = typeof c == "function" ? c : n, s && s.length ? gi(s, n, c) : [];
        }
        function Fp(s) {
          if (!(s && s.length))
            return [];
          var c = 0;
          return s = di(s, function(f) {
            if (Pn(f))
              return c = Fn(f.length, c), !0;
          }), tp(c, function(f) {
            return dn(s, Zd(f));
          });
        }
        function Eb(s, c) {
          if (!(s && s.length))
            return [];
          var f = Fp(s);
          return c == null ? f : dn(f, function(C) {
            return xr(c, n, C);
          });
        }
        var hk = St(function(s, c) {
          return Pn(s) ? Os(s, c) : [];
        }), gk = St(function(s) {
          return Cp(di(s, Pn));
        }), yk = St(function(s) {
          var c = zr(s);
          return Pn(c) && (c = n), Cp(di(s, Pn), it(c, 2));
        }), bk = St(function(s) {
          var c = zr(s);
          return c = typeof c == "function" ? c : n, Cp(di(s, Pn), n, c);
        }), vk = St(Fp);
        function xk(s, c) {
          return qy(s || [], c || [], Ss);
        }
        function wk(s, c) {
          return qy(s || [], c || [], Rs);
        }
        var Ck = St(function(s) {
          var c = s.length, f = c > 1 ? s[c - 1] : n;
          return f = typeof f == "function" ? (s.pop(), f) : n, Eb(s, f);
        });
        function Rb(s) {
          var c = j(s);
          return c.__chain__ = !0, c;
        }
        function Sk(s, c) {
          return c(s), s;
        }
        function Rc(s, c) {
          return c(s);
        }
        var Ok = Vo(function(s) {
          var c = s.length, f = c ? s[0] : 0, C = this.__wrapped__, D = function(A) {
            return cp(A, s);
          };
          return c > 1 || this.__actions__.length || !(C instanceof Pt) || !zo(f) ? this.thru(D) : (C = C.slice(f, +f + (c ? 1 : 0)), C.__actions__.push({
            func: Rc,
            args: [D],
            thisArg: n
          }), new Lr(C, this.__chain__).thru(function(A) {
            return c && !A.length && A.push(n), A;
          }));
        });
        function Tk() {
          return Rb(this);
        }
        function Ek() {
          return new Lr(this.value(), this.__chain__);
        }
        function Rk() {
          this.__values__ === n && (this.__values__ = Vb(this.value()));
          var s = this.__index__ >= this.__values__.length, c = s ? n : this.__values__[this.__index__++];
          return { done: s, value: c };
        }
        function kk() {
          return this;
        }
        function Pk(s) {
          for (var c, f = this; f instanceof pc; ) {
            var C = xb(f);
            C.__index__ = 0, C.__values__ = n, c ? D.__wrapped__ = C : c = C;
            var D = C;
            f = f.__wrapped__;
          }
          return D.__wrapped__ = s, c;
        }
        function Dk() {
          var s = this.__wrapped__;
          if (s instanceof Pt) {
            var c = s;
            return this.__actions__.length && (c = new Pt(this)), c = c.reverse(), c.__actions__.push({
              func: Rc,
              args: [Np],
              thisArg: n
            }), new Lr(c, this.__chain__);
          }
          return this.thru(Np);
        }
        function Mk() {
          return Wy(this.__wrapped__, this.__actions__);
        }
        var _k = vc(function(s, c, f) {
          Yt.call(s, f) ? ++s[f] : Lo(s, f, 1);
        });
        function Ik(s, c, f) {
          var C = yt(s) ? ny : SE;
          return f && tr(s, c, f) && (c = n), C(s, it(c, 3));
        }
        function jk(s, c) {
          var f = yt(s) ? di : Ey;
          return f(s, it(c, 3));
        }
        var $k = eb(wb), Ak = eb(Cb);
        function Nk(s, c) {
          return zn(kc(s, c), 1);
        }
        function Fk(s, c) {
          return zn(kc(s, c), X);
        }
        function Lk(s, c, f) {
          return f = f === n ? 1 : bt(f), zn(kc(s, c), f);
        }
        function kb(s, c) {
          var f = yt(s) ? Nr : hi;
          return f(s, it(c, 3));
        }
        function Pb(s, c) {
          var f = yt(s) ? oT : Ty;
          return f(s, it(c, 3));
        }
        var Bk = vc(function(s, c, f) {
          Yt.call(s, f) ? s[f].push(c) : Lo(s, f, [c]);
        });
        function Vk(s, c, f, C) {
          s = cr(s) ? s : _a(s), f = f && !C ? bt(f) : 0;
          var D = s.length;
          return f < 0 && (f = Fn(D + f, 0)), Ic(s) ? f <= D && s.indexOf(c, f) > -1 : !!D && xa(s, c, f) > -1;
        }
        var zk = St(function(s, c, f) {
          var C = -1, D = typeof c == "function", A = cr(s) ? me(s.length) : [];
          return hi(s, function(q) {
            A[++C] = D ? xr(c, q, f) : Ts(q, c, f);
          }), A;
        }), Wk = vc(function(s, c, f) {
          Lo(s, f, c);
        });
        function kc(s, c) {
          var f = yt(s) ? dn : _y;
          return f(s, it(c, 3));
        }
        function qk(s, c, f, C) {
          return s == null ? [] : (yt(c) || (c = c == null ? [] : [c]), f = C ? n : f, yt(f) || (f = f == null ? [] : [f]), Ay(s, c, f));
        }
        var Hk = vc(function(s, c, f) {
          s[f ? 0 : 1].push(c);
        }, function() {
          return [[], []];
        });
        function Uk(s, c, f) {
          var C = yt(s) ? Xd : ay, D = arguments.length < 3;
          return C(s, it(c, 4), f, D, hi);
        }
        function Yk(s, c, f) {
          var C = yt(s) ? iT : ay, D = arguments.length < 3;
          return C(s, it(c, 4), f, D, Ty);
        }
        function Gk(s, c) {
          var f = yt(s) ? di : Ey;
          return f(s, Mc(it(c, 3)));
        }
        function Kk(s) {
          var c = yt(s) ? wy : VE;
          return c(s);
        }
        function Xk(s, c, f) {
          (f ? tr(s, c, f) : c === n) ? c = 1 : c = bt(c);
          var C = yt(s) ? bE : zE;
          return C(s, c);
        }
        function Qk(s) {
          var c = yt(s) ? vE : qE;
          return c(s);
        }
        function Zk(s) {
          if (s == null)
            return 0;
          if (cr(s))
            return Ic(s) ? Ca(s) : s.length;
          var c = Gn(s);
          return c == ie || c == Ge ? s.size : hp(s).length;
        }
        function Jk(s, c, f) {
          var C = yt(s) ? Qd : HE;
          return f && tr(s, c, f) && (c = n), C(s, it(c, 3));
        }
        var eP = St(function(s, c) {
          if (s == null)
            return [];
          var f = c.length;
          return f > 1 && tr(s, c[0], c[1]) ? c = [] : f > 2 && tr(c[0], c[1], c[2]) && (c = [c[0]]), Ay(s, zn(c, 1), []);
        }), Pc = jT || function() {
          return Vn.Date.now();
        };
        function tP(s, c) {
          if (typeof c != "function")
            throw new Fr(l);
          return s = bt(s), function() {
            if (--s < 1)
              return c.apply(this, arguments);
          };
        }
        function Db(s, c, f) {
          return c = f ? n : c, c = s && c == null ? s.length : c, Bo(s, _, n, n, n, n, c);
        }
        function Mb(s, c) {
          var f;
          if (typeof c != "function")
            throw new Fr(l);
          return s = bt(s), function() {
            return --s > 0 && (f = c.apply(this, arguments)), s <= 1 && (c = n), f;
          };
        }
        var Lp = St(function(s, c, f) {
          var C = S;
          if (f.length) {
            var D = fi(f, Da(Lp));
            C |= E;
          }
          return Bo(s, C, c, f, D);
        }), _b = St(function(s, c, f) {
          var C = S | O;
          if (f.length) {
            var D = fi(f, Da(_b));
            C |= E;
          }
          return Bo(c, C, s, f, D);
        });
        function Ib(s, c, f) {
          c = f ? n : c;
          var C = Bo(s, k, n, n, n, n, n, c);
          return C.placeholder = Ib.placeholder, C;
        }
        function jb(s, c, f) {
          c = f ? n : c;
          var C = Bo(s, R, n, n, n, n, n, c);
          return C.placeholder = jb.placeholder, C;
        }
        function $b(s, c, f) {
          var C, D, A, q, Y, re, Ce = 0, Oe = !1, De = !1, Fe = !0;
          if (typeof s != "function")
            throw new Fr(l);
          c = Wr(c) || 0, yn(f) && (Oe = !!f.leading, De = "maxWait" in f, A = De ? Fn(Wr(f.maxWait) || 0, c) : A, Fe = "trailing" in f ? !!f.trailing : Fe);
          function Xe(Dn) {
            var lo = C, Ho = D;
            return C = D = n, Ce = Dn, q = s.apply(Ho, lo), q;
          }
          function st(Dn) {
            return Ce = Dn, Y = Ds(Tt, c), Oe ? Xe(Dn) : q;
          }
          function xt(Dn) {
            var lo = Dn - re, Ho = Dn - Ce, ev = c - lo;
            return De ? Yn(ev, A - Ho) : ev;
          }
          function lt(Dn) {
            var lo = Dn - re, Ho = Dn - Ce;
            return re === n || lo >= c || lo < 0 || De && Ho >= A;
          }
          function Tt() {
            var Dn = Pc();
            if (lt(Dn))
              return _t(Dn);
            Y = Ds(Tt, xt(Dn));
          }
          function _t(Dn) {
            return Y = n, Fe && C ? Xe(Dn) : (C = D = n, q);
          }
          function Or() {
            Y !== n && Hy(Y), Ce = 0, C = re = D = Y = n;
          }
          function nr() {
            return Y === n ? q : _t(Pc());
          }
          function Tr() {
            var Dn = Pc(), lo = lt(Dn);
            if (C = arguments, D = this, re = Dn, lo) {
              if (Y === n)
                return st(re);
              if (De)
                return Hy(Y), Y = Ds(Tt, c), Xe(re);
            }
            return Y === n && (Y = Ds(Tt, c)), q;
          }
          return Tr.cancel = Or, Tr.flush = nr, Tr;
        }
        var nP = St(function(s, c) {
          return Oy(s, 1, c);
        }), rP = St(function(s, c, f) {
          return Oy(s, Wr(c) || 0, f);
        });
        function oP(s) {
          return Bo(s, F);
        }
        function Dc(s, c) {
          if (typeof s != "function" || c != null && typeof c != "function")
            throw new Fr(l);
          var f = function() {
            var C = arguments, D = c ? c.apply(this, C) : C[0], A = f.cache;
            if (A.has(D))
              return A.get(D);
            var q = s.apply(this, C);
            return f.cache = A.set(D, q) || A, q;
          };
          return f.cache = new (Dc.Cache || Fo)(), f;
        }
        Dc.Cache = Fo;
        function Mc(s) {
          if (typeof s != "function")
            throw new Fr(l);
          return function() {
            var c = arguments;
            switch (c.length) {
              case 0:
                return !s.call(this);
              case 1:
                return !s.call(this, c[0]);
              case 2:
                return !s.call(this, c[0], c[1]);
              case 3:
                return !s.call(this, c[0], c[1], c[2]);
            }
            return !s.apply(this, c);
          };
        }
        function iP(s) {
          return Mb(2, s);
        }
        var aP = UE(function(s, c) {
          c = c.length == 1 && yt(c[0]) ? dn(c[0], wr(it())) : dn(zn(c, 1), wr(it()));
          var f = c.length;
          return St(function(C) {
            for (var D = -1, A = Yn(C.length, f); ++D < A; )
              C[D] = c[D].call(this, C[D]);
            return xr(s, this, C);
          });
        }), Bp = St(function(s, c) {
          var f = fi(c, Da(Bp));
          return Bo(s, E, n, c, f);
        }), Ab = St(function(s, c) {
          var f = fi(c, Da(Ab));
          return Bo(s, M, n, c, f);
        }), sP = Vo(function(s, c) {
          return Bo(s, I, n, n, n, c);
        });
        function lP(s, c) {
          if (typeof s != "function")
            throw new Fr(l);
          return c = c === n ? c : bt(c), St(s, c);
        }
        function cP(s, c) {
          if (typeof s != "function")
            throw new Fr(l);
          return c = c == null ? 0 : Fn(bt(c), 0), St(function(f) {
            var C = f[c], D = bi(f, 0, c);
            return C && pi(D, C), xr(s, this, D);
          });
        }
        function uP(s, c, f) {
          var C = !0, D = !0;
          if (typeof s != "function")
            throw new Fr(l);
          return yn(f) && (C = "leading" in f ? !!f.leading : C, D = "trailing" in f ? !!f.trailing : D), $b(s, c, {
            leading: C,
            maxWait: c,
            trailing: D
          });
        }
        function dP(s) {
          return Db(s, 1);
        }
        function pP(s, c) {
          return Bp(Op(c), s);
        }
        function fP() {
          if (!arguments.length)
            return [];
          var s = arguments[0];
          return yt(s) ? s : [s];
        }
        function mP(s) {
          return Br(s, v);
        }
        function hP(s, c) {
          return c = typeof c == "function" ? c : n, Br(s, v, c);
        }
        function gP(s) {
          return Br(s, h | v);
        }
        function yP(s, c) {
          return c = typeof c == "function" ? c : n, Br(s, h | v, c);
        }
        function bP(s, c) {
          return c == null || Sy(s, c, Ln(c));
        }
        function so(s, c) {
          return s === c || s !== s && c !== c;
        }
        var vP = Sc(pp), xP = Sc(function(s, c) {
          return s >= c;
        }), Qi = Py(/* @__PURE__ */ function() {
          return arguments;
        }()) ? Py : function(s) {
          return wn(s) && Yt.call(s, "callee") && !hy.call(s, "callee");
        }, yt = me.isArray, wP = Xg ? wr(Xg) : PE;
        function cr(s) {
          return s != null && _c(s.length) && !Wo(s);
        }
        function Pn(s) {
          return wn(s) && cr(s);
        }
        function CP(s) {
          return s === !0 || s === !1 || wn(s) && er(s) == K;
        }
        var vi = AT || Qp, SP = Qg ? wr(Qg) : DE;
        function OP(s) {
          return wn(s) && s.nodeType === 1 && !Ms(s);
        }
        function TP(s) {
          if (s == null)
            return !0;
          if (cr(s) && (yt(s) || typeof s == "string" || typeof s.splice == "function" || vi(s) || Ma(s) || Qi(s)))
            return !s.length;
          var c = Gn(s);
          if (c == ie || c == Ge)
            return !s.size;
          if (Ps(s))
            return !hp(s).length;
          for (var f in s)
            if (Yt.call(s, f))
              return !1;
          return !0;
        }
        function EP(s, c) {
          return Es(s, c);
        }
        function RP(s, c, f) {
          f = typeof f == "function" ? f : n;
          var C = f ? f(s, c) : n;
          return C === n ? Es(s, c, n, f) : !!C;
        }
        function Vp(s) {
          if (!wn(s))
            return !1;
          var c = er(s);
          return c == he || c == ue || typeof s.message == "string" && typeof s.name == "string" && !Ms(s);
        }
        function kP(s) {
          return typeof s == "number" && yy(s);
        }
        function Wo(s) {
          if (!yn(s))
            return !1;
          var c = er(s);
          return c == B || c == ee || c == ce || c == Pe;
        }
        function Nb(s) {
          return typeof s == "number" && s == bt(s);
        }
        function _c(s) {
          return typeof s == "number" && s > -1 && s % 1 == 0 && s <= le;
        }
        function yn(s) {
          var c = typeof s;
          return s != null && (c == "object" || c == "function");
        }
        function wn(s) {
          return s != null && typeof s == "object";
        }
        var Fb = Zg ? wr(Zg) : _E;
        function PP(s, c) {
          return s === c || mp(s, c, Mp(c));
        }
        function DP(s, c, f) {
          return f = typeof f == "function" ? f : n, mp(s, c, Mp(c), f);
        }
        function MP(s) {
          return Lb(s) && s != +s;
        }
        function _P(s) {
          if (hR(s))
            throw new ft(a);
          return Dy(s);
        }
        function IP(s) {
          return s === null;
        }
        function jP(s) {
          return s == null;
        }
        function Lb(s) {
          return typeof s == "number" || wn(s) && er(s) == ge;
        }
        function Ms(s) {
          if (!wn(s) || er(s) != pe)
            return !1;
          var c = ic(s);
          if (c === null)
            return !0;
          var f = Yt.call(c, "constructor") && c.constructor;
          return typeof f == "function" && f instanceof f && tc.call(f) == DT;
        }
        var zp = Jg ? wr(Jg) : IE;
        function $P(s) {
          return Nb(s) && s >= -9007199254740991 && s <= le;
        }
        var Bb = ey ? wr(ey) : jE;
        function Ic(s) {
          return typeof s == "string" || !yt(s) && wn(s) && er(s) == Ie;
        }
        function Sr(s) {
          return typeof s == "symbol" || wn(s) && er(s) == Dt;
        }
        var Ma = ty ? wr(ty) : $E;
        function AP(s) {
          return s === n;
        }
        function NP(s) {
          return wn(s) && Gn(s) == $e;
        }
        function FP(s) {
          return wn(s) && er(s) == dt;
        }
        var LP = Sc(gp), BP = Sc(function(s, c) {
          return s <= c;
        });
        function Vb(s) {
          if (!s)
            return [];
          if (cr(s))
            return Ic(s) ? io(s) : lr(s);
          if (bs && s[bs])
            return bT(s[bs]());
          var c = Gn(s), f = c == ie ? rp : c == Ge ? Zl : _a;
          return f(s);
        }
        function qo(s) {
          if (!s)
            return s === 0 ? s : 0;
          if (s = Wr(s), s === X || s === -1 / 0) {
            var c = s < 0 ? -1 : 1;
            return c * ne;
          }
          return s === s ? s : 0;
        }
        function bt(s) {
          var c = qo(s), f = c % 1;
          return c === c ? f ? c - f : c : 0;
        }
        function zb(s) {
          return s ? Yi(bt(s), 0, Q) : 0;
        }
        function Wr(s) {
          if (typeof s == "number")
            return s;
          if (Sr(s))
            return G;
          if (yn(s)) {
            var c = typeof s.valueOf == "function" ? s.valueOf() : s;
            s = yn(c) ? c + "" : c;
          }
          if (typeof s != "string")
            return s === 0 ? s : +s;
          s = sy(s);
          var f = Te.test(s);
          return f || Ye.test(s) ? tT(s.slice(2), f ? 2 : 8) : oe.test(s) ? G : +s;
        }
        function Wb(s) {
          return bo(s, ur(s));
        }
        function VP(s) {
          return s ? Yi(bt(s), -9007199254740991, le) : s === 0 ? s : 0;
        }
        function zt(s) {
          return s == null ? "" : Cr(s);
        }
        var zP = ka(function(s, c) {
          if (Ps(c) || cr(c)) {
            bo(c, Ln(c), s);
            return;
          }
          for (var f in c)
            Yt.call(c, f) && Ss(s, f, c[f]);
        }), qb = ka(function(s, c) {
          bo(c, ur(c), s);
        }), jc = ka(function(s, c, f, C) {
          bo(c, ur(c), s, C);
        }), WP = ka(function(s, c, f, C) {
          bo(c, Ln(c), s, C);
        }), qP = Vo(cp);
        function HP(s, c) {
          var f = Ra(s);
          return c == null ? f : Cy(f, c);
        }
        var UP = St(function(s, c) {
          s = en(s);
          var f = -1, C = c.length, D = C > 2 ? c[2] : n;
          for (D && tr(c[0], c[1], D) && (C = 1); ++f < C; )
            for (var A = c[f], q = ur(A), Y = -1, re = q.length; ++Y < re; ) {
              var Ce = q[Y], Oe = s[Ce];
              (Oe === n || so(Oe, Oa[Ce]) && !Yt.call(s, Ce)) && (s[Ce] = A[Ce]);
            }
          return s;
        }), YP = St(function(s) {
          return s.push(n, sb), xr(Hb, n, s);
        });
        function GP(s, c) {
          return ry(s, it(c, 3), yo);
        }
        function KP(s, c) {
          return ry(s, it(c, 3), dp);
        }
        function XP(s, c) {
          return s == null ? s : up(s, it(c, 3), ur);
        }
        function QP(s, c) {
          return s == null ? s : Ry(s, it(c, 3), ur);
        }
        function ZP(s, c) {
          return s && yo(s, it(c, 3));
        }
        function JP(s, c) {
          return s && dp(s, it(c, 3));
        }
        function eD(s) {
          return s == null ? [] : hc(s, Ln(s));
        }
        function tD(s) {
          return s == null ? [] : hc(s, ur(s));
        }
        function Wp(s, c, f) {
          var C = s == null ? n : Gi(s, c);
          return C === n ? f : C;
        }
        function nD(s, c) {
          return s != null && ub(s, c, TE);
        }
        function qp(s, c) {
          return s != null && ub(s, c, EE);
        }
        var rD = nb(function(s, c, f) {
          c != null && typeof c.toString != "function" && (c = nc.call(c)), s[c] = f;
        }, Up(dr)), oD = nb(function(s, c, f) {
          c != null && typeof c.toString != "function" && (c = nc.call(c)), Yt.call(s, c) ? s[c].push(f) : s[c] = [f];
        }, it), iD = St(Ts);
        function Ln(s) {
          return cr(s) ? xy(s) : hp(s);
        }
        function ur(s) {
          return cr(s) ? xy(s, !0) : AE(s);
        }
        function aD(s, c) {
          var f = {};
          return c = it(c, 3), yo(s, function(C, D, A) {
            Lo(f, c(C, D, A), C);
          }), f;
        }
        function sD(s, c) {
          var f = {};
          return c = it(c, 3), yo(s, function(C, D, A) {
            Lo(f, D, c(C, D, A));
          }), f;
        }
        var lD = ka(function(s, c, f) {
          gc(s, c, f);
        }), Hb = ka(function(s, c, f, C) {
          gc(s, c, f, C);
        }), cD = Vo(function(s, c) {
          var f = {};
          if (s == null)
            return f;
          var C = !1;
          c = dn(c, function(A) {
            return A = yi(A, s), C || (C = A.length > 1), A;
          }), bo(s, Pp(s), f), C && (f = Br(f, h | g | v, rR));
          for (var D = c.length; D--; )
            wp(f, c[D]);
          return f;
        });
        function uD(s, c) {
          return Ub(s, Mc(it(c)));
        }
        var dD = Vo(function(s, c) {
          return s == null ? {} : FE(s, c);
        });
        function Ub(s, c) {
          if (s == null)
            return {};
          var f = dn(Pp(s), function(C) {
            return [C];
          });
          return c = it(c), Ny(s, f, function(C, D) {
            return c(C, D[0]);
          });
        }
        function pD(s, c, f) {
          c = yi(c, s);
          var C = -1, D = c.length;
          for (D || (D = 1, s = n); ++C < D; ) {
            var A = s == null ? n : s[vo(c[C])];
            A === n && (C = D, A = f), s = Wo(A) ? A.call(s) : A;
          }
          return s;
        }
        function fD(s, c, f) {
          return s == null ? s : Rs(s, c, f);
        }
        function mD(s, c, f, C) {
          return C = typeof C == "function" ? C : n, s == null ? s : Rs(s, c, f, C);
        }
        var Yb = ib(Ln), Gb = ib(ur);
        function hD(s, c, f) {
          var C = yt(s), D = C || vi(s) || Ma(s);
          if (c = it(c, 4), f == null) {
            var A = s && s.constructor;
            D ? f = C ? new A() : [] : yn(s) ? f = Wo(A) ? Ra(ic(s)) : {} : f = {};
          }
          return (D ? Nr : yo)(s, function(q, Y, re) {
            return c(f, q, Y, re);
          }), f;
        }
        function gD(s, c) {
          return s == null ? !0 : wp(s, c);
        }
        function yD(s, c, f) {
          return s == null ? s : zy(s, c, Op(f));
        }
        function bD(s, c, f, C) {
          return C = typeof C == "function" ? C : n, s == null ? s : zy(s, c, Op(f), C);
        }
        function _a(s) {
          return s == null ? [] : np(s, Ln(s));
        }
        function vD(s) {
          return s == null ? [] : np(s, ur(s));
        }
        function xD(s, c, f) {
          return f === n && (f = c, c = n), f !== n && (f = Wr(f), f = f === f ? f : 0), c !== n && (c = Wr(c), c = c === c ? c : 0), Yi(Wr(s), c, f);
        }
        function wD(s, c, f) {
          return c = qo(c), f === n ? (f = c, c = 0) : f = qo(f), s = Wr(s), RE(s, c, f);
        }
        function CD(s, c, f) {
          if (f && typeof f != "boolean" && tr(s, c, f) && (c = f = n), f === n && (typeof c == "boolean" ? (f = c, c = n) : typeof s == "boolean" && (f = s, s = n)), s === n && c === n ? (s = 0, c = 1) : (s = qo(s), c === n ? (c = s, s = 0) : c = qo(c)), s > c) {
            var C = s;
            s = c, c = C;
          }
          if (f || s % 1 || c % 1) {
            var D = by();
            return Yn(s + D * (c - s + eT("1e-" + ((D + "").length - 1))), c);
          }
          return bp(s, c);
        }
        var SD = Pa(function(s, c, f) {
          return c = c.toLowerCase(), s + (f ? Kb(c) : c);
        });
        function Kb(s) {
          return Hp(zt(s).toLowerCase());
        }
        function Xb(s) {
          return s = zt(s), s && s.replace(Mt, fT).replace(qO, "");
        }
        function OD(s, c, f) {
          s = zt(s), c = Cr(c);
          var C = s.length;
          f = f === n ? C : Yi(bt(f), 0, C);
          var D = f;
          return f -= c.length, f >= 0 && s.slice(f, D) == c;
        }
        function TD(s) {
          return s = zt(s), s && Un.test(s) ? s.replace(on, mT) : s;
        }
        function ED(s) {
          return s = zt(s), s && go.test(s) ? s.replace($r, "\\$&") : s;
        }
        var RD = Pa(function(s, c, f) {
          return s + (f ? "-" : "") + c.toLowerCase();
        }), kD = Pa(function(s, c, f) {
          return s + (f ? " " : "") + c.toLowerCase();
        }), PD = Jy("toLowerCase");
        function DD(s, c, f) {
          s = zt(s), c = bt(c);
          var C = c ? Ca(s) : 0;
          if (!c || C >= c)
            return s;
          var D = (c - C) / 2;
          return Cc(cc(D), f) + s + Cc(lc(D), f);
        }
        function MD(s, c, f) {
          s = zt(s), c = bt(c);
          var C = c ? Ca(s) : 0;
          return c && C < c ? s + Cc(c - C, f) : s;
        }
        function _D(s, c, f) {
          s = zt(s), c = bt(c);
          var C = c ? Ca(s) : 0;
          return c && C < c ? Cc(c - C, f) + s : s;
        }
        function ID(s, c, f) {
          return f || c == null ? c = 0 : c && (c = +c), BT(zt(s).replace(Ao, ""), c || 0);
        }
        function jD(s, c, f) {
          return (f ? tr(s, c, f) : c === n) ? c = 1 : c = bt(c), vp(zt(s), c);
        }
        function $D() {
          var s = arguments, c = zt(s[0]);
          return s.length < 3 ? c : c.replace(s[1], s[2]);
        }
        var AD = Pa(function(s, c, f) {
          return s + (f ? "_" : "") + c.toLowerCase();
        });
        function ND(s, c, f) {
          return f && typeof f != "number" && tr(s, c, f) && (c = f = n), f = f === n ? Q : f >>> 0, f ? (s = zt(s), s && (typeof c == "string" || c != null && !zp(c)) && (c = Cr(c), !c && wa(s)) ? bi(io(s), 0, f) : s.split(c, f)) : [];
        }
        var FD = Pa(function(s, c, f) {
          return s + (f ? " " : "") + Hp(c);
        });
        function LD(s, c, f) {
          return s = zt(s), f = f == null ? 0 : Yi(bt(f), 0, s.length), c = Cr(c), s.slice(f, f + c.length) == c;
        }
        function BD(s, c, f) {
          var C = j.templateSettings;
          f && tr(s, c, f) && (c = n), s = zt(s), c = jc({}, c, C, ab);
          var D = jc({}, c.imports, C.imports, ab), A = Ln(D), q = np(D, A), Y, re, Ce = 0, Oe = c.interpolate || Jt, De = "__p += '", Fe = op(
            (c.escape || Jt).source + "|" + Oe.source + "|" + (Oe === et ? Ot : Jt).source + "|" + (c.evaluate || Jt).source + "|$",
            "g"
          ), Xe = "//# sourceURL=" + (Yt.call(c, "sourceURL") ? (c.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++KO + "]") + `
`;
          s.replace(Fe, function(lt, Tt, _t, Or, nr, Tr) {
            return _t || (_t = Or), De += s.slice(Ce, Tr).replace(Jn, hT), Tt && (Y = !0, De += `' +
__e(` + Tt + `) +
'`), nr && (re = !0, De += `';
` + nr + `;
__p += '`), _t && (De += `' +
((__t = (` + _t + `)) == null ? '' : __t) +
'`), Ce = Tr + lt.length, lt;
          }), De += `';
`;
          var st = Yt.call(c, "variable") && c.variable;
          if (!st)
            De = `with (obj) {
` + De + `
}
`;
          else if (_e.test(st))
            throw new ft(u);
          De = (re ? De.replace(vt, "") : De).replace(gt, "$1").replace(kt, "$1;"), De = "function(" + (st || "obj") + `) {
` + (st ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (Y ? ", __e = _.escape" : "") + (re ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + De + `return __p
}`;
          var xt = Zb(function() {
            return Ft(A, Xe + "return " + De).apply(n, q);
          });
          if (xt.source = De, Vp(xt))
            throw xt;
          return xt;
        }
        function VD(s) {
          return zt(s).toLowerCase();
        }
        function zD(s) {
          return zt(s).toUpperCase();
        }
        function WD(s, c, f) {
          if (s = zt(s), s && (f || c === n))
            return sy(s);
          if (!s || !(c = Cr(c)))
            return s;
          var C = io(s), D = io(c), A = ly(C, D), q = cy(C, D) + 1;
          return bi(C, A, q).join("");
        }
        function qD(s, c, f) {
          if (s = zt(s), s && (f || c === n))
            return s.slice(0, dy(s) + 1);
          if (!s || !(c = Cr(c)))
            return s;
          var C = io(s), D = cy(C, io(c)) + 1;
          return bi(C, 0, D).join("");
        }
        function HD(s, c, f) {
          if (s = zt(s), s && (f || c === n))
            return s.replace(Ao, "");
          if (!s || !(c = Cr(c)))
            return s;
          var C = io(s), D = ly(C, io(c));
          return bi(C, D).join("");
        }
        function UD(s, c) {
          var f = T, C = $;
          if (yn(c)) {
            var D = "separator" in c ? c.separator : D;
            f = "length" in c ? bt(c.length) : f, C = "omission" in c ? Cr(c.omission) : C;
          }
          s = zt(s);
          var A = s.length;
          if (wa(s)) {
            var q = io(s);
            A = q.length;
          }
          if (f >= A)
            return s;
          var Y = f - Ca(C);
          if (Y < 1)
            return C;
          var re = q ? bi(q, 0, Y).join("") : s.slice(0, Y);
          if (D === n)
            return re + C;
          if (q && (Y += re.length - Y), zp(D)) {
            if (s.slice(Y).search(D)) {
              var Ce, Oe = re;
              for (D.global || (D = op(D.source, zt(fe.exec(D)) + "g")), D.lastIndex = 0; Ce = D.exec(Oe); )
                var De = Ce.index;
              re = re.slice(0, De === n ? Y : De);
            }
          } else if (s.indexOf(Cr(D), Y) != Y) {
            var Fe = re.lastIndexOf(D);
            Fe > -1 && (re = re.slice(0, Fe));
          }
          return re + C;
        }
        function YD(s) {
          return s = zt(s), s && br.test(s) ? s.replace(xn, CT) : s;
        }
        var GD = Pa(function(s, c, f) {
          return s + (f ? " " : "") + c.toUpperCase();
        }), Hp = Jy("toUpperCase");
        function Qb(s, c, f) {
          return s = zt(s), c = f ? n : c, c === n ? yT(s) ? TT(s) : lT(s) : s.match(c) || [];
        }
        var Zb = St(function(s, c) {
          try {
            return xr(s, n, c);
          } catch (f) {
            return Vp(f) ? f : new ft(f);
          }
        }), KD = Vo(function(s, c) {
          return Nr(c, function(f) {
            f = vo(f), Lo(s, f, Lp(s[f], s));
          }), s;
        });
        function XD(s) {
          var c = s == null ? 0 : s.length, f = it();
          return s = c ? dn(s, function(C) {
            if (typeof C[1] != "function")
              throw new Fr(l);
            return [f(C[0]), C[1]];
          }) : [], St(function(C) {
            for (var D = -1; ++D < c; ) {
              var A = s[D];
              if (xr(A[0], this, C))
                return xr(A[1], this, C);
            }
          });
        }
        function QD(s) {
          return CE(Br(s, h));
        }
        function Up(s) {
          return function() {
            return s;
          };
        }
        function ZD(s, c) {
          return s == null || s !== s ? c : s;
        }
        var JD = tb(), eM = tb(!0);
        function dr(s) {
          return s;
        }
        function Yp(s) {
          return My(typeof s == "function" ? s : Br(s, h));
        }
        function tM(s) {
          return Iy(Br(s, h));
        }
        function nM(s, c) {
          return jy(s, Br(c, h));
        }
        var rM = St(function(s, c) {
          return function(f) {
            return Ts(f, s, c);
          };
        }), oM = St(function(s, c) {
          return function(f) {
            return Ts(s, f, c);
          };
        });
        function Gp(s, c, f) {
          var C = Ln(c), D = hc(c, C);
          f == null && !(yn(c) && (D.length || !C.length)) && (f = c, c = s, s = this, D = hc(c, Ln(c)));
          var A = !(yn(f) && "chain" in f) || !!f.chain, q = Wo(s);
          return Nr(D, function(Y) {
            var re = c[Y];
            s[Y] = re, q && (s.prototype[Y] = function() {
              var Ce = this.__chain__;
              if (A || Ce) {
                var Oe = s(this.__wrapped__), De = Oe.__actions__ = lr(this.__actions__);
                return De.push({ func: re, args: arguments, thisArg: s }), Oe.__chain__ = Ce, Oe;
              }
              return re.apply(s, pi([this.value()], arguments));
            });
          }), s;
        }
        function iM() {
          return Vn._ === this && (Vn._ = MT), this;
        }
        function Kp() {
        }
        function aM(s) {
          return s = bt(s), St(function(c) {
            return $y(c, s);
          });
        }
        var sM = Ep(dn), lM = Ep(ny), cM = Ep(Qd);
        function Jb(s) {
          return Ip(s) ? Zd(vo(s)) : LE(s);
        }
        function uM(s) {
          return function(c) {
            return s == null ? n : Gi(s, c);
          };
        }
        var dM = rb(), pM = rb(!0);
        function Xp() {
          return [];
        }
        function Qp() {
          return !1;
        }
        function fM() {
          return {};
        }
        function mM() {
          return "";
        }
        function hM() {
          return !0;
        }
        function gM(s, c) {
          if (s = bt(s), s < 1 || s > le)
            return [];
          var f = Q, C = Yn(s, Q);
          c = it(c), s -= Q;
          for (var D = tp(C, c); ++f < s; )
            c(f);
          return D;
        }
        function yM(s) {
          return yt(s) ? dn(s, vo) : Sr(s) ? [s] : lr(vb(zt(s)));
        }
        function bM(s) {
          var c = ++PT;
          return zt(s) + c;
        }
        var vM = wc(function(s, c) {
          return s + c;
        }, 0), xM = Rp("ceil"), wM = wc(function(s, c) {
          return s / c;
        }, 1), CM = Rp("floor");
        function SM(s) {
          return s && s.length ? mc(s, dr, pp) : n;
        }
        function OM(s, c) {
          return s && s.length ? mc(s, it(c, 2), pp) : n;
        }
        function TM(s) {
          return iy(s, dr);
        }
        function EM(s, c) {
          return iy(s, it(c, 2));
        }
        function RM(s) {
          return s && s.length ? mc(s, dr, gp) : n;
        }
        function kM(s, c) {
          return s && s.length ? mc(s, it(c, 2), gp) : n;
        }
        var PM = wc(function(s, c) {
          return s * c;
        }, 1), DM = Rp("round"), MM = wc(function(s, c) {
          return s - c;
        }, 0);
        function _M(s) {
          return s && s.length ? ep(s, dr) : 0;
        }
        function IM(s, c) {
          return s && s.length ? ep(s, it(c, 2)) : 0;
        }
        return j.after = tP, j.ary = Db, j.assign = zP, j.assignIn = qb, j.assignInWith = jc, j.assignWith = WP, j.at = qP, j.before = Mb, j.bind = Lp, j.bindAll = KD, j.bindKey = _b, j.castArray = fP, j.chain = Rb, j.chunk = CR, j.compact = SR, j.concat = OR, j.cond = XD, j.conforms = QD, j.constant = Up, j.countBy = _k, j.create = HP, j.curry = Ib, j.curryRight = jb, j.debounce = $b, j.defaults = UP, j.defaultsDeep = YP, j.defer = nP, j.delay = rP, j.difference = TR, j.differenceBy = ER, j.differenceWith = RR, j.drop = kR, j.dropRight = PR, j.dropRightWhile = DR, j.dropWhile = MR, j.fill = _R, j.filter = jk, j.flatMap = Nk, j.flatMapDeep = Fk, j.flatMapDepth = Lk, j.flatten = Sb, j.flattenDeep = IR, j.flattenDepth = jR, j.flip = oP, j.flow = JD, j.flowRight = eM, j.fromPairs = $R, j.functions = eD, j.functionsIn = tD, j.groupBy = Bk, j.initial = NR, j.intersection = FR, j.intersectionBy = LR, j.intersectionWith = BR, j.invert = rD, j.invertBy = oD, j.invokeMap = zk, j.iteratee = Yp, j.keyBy = Wk, j.keys = Ln, j.keysIn = ur, j.map = kc, j.mapKeys = aD, j.mapValues = sD, j.matches = tM, j.matchesProperty = nM, j.memoize = Dc, j.merge = lD, j.mergeWith = Hb, j.method = rM, j.methodOf = oM, j.mixin = Gp, j.negate = Mc, j.nthArg = aM, j.omit = cD, j.omitBy = uD, j.once = iP, j.orderBy = qk, j.over = sM, j.overArgs = aP, j.overEvery = lM, j.overSome = cM, j.partial = Bp, j.partialRight = Ab, j.partition = Hk, j.pick = dD, j.pickBy = Ub, j.property = Jb, j.propertyOf = uM, j.pull = qR, j.pullAll = Tb, j.pullAllBy = HR, j.pullAllWith = UR, j.pullAt = YR, j.range = dM, j.rangeRight = pM, j.rearg = sP, j.reject = Gk, j.remove = GR, j.rest = lP, j.reverse = Np, j.sampleSize = Xk, j.set = fD, j.setWith = mD, j.shuffle = Qk, j.slice = KR, j.sortBy = eP, j.sortedUniq = nk, j.sortedUniqBy = rk, j.split = ND, j.spread = cP, j.tail = ok, j.take = ik, j.takeRight = ak, j.takeRightWhile = sk, j.takeWhile = lk, j.tap = Sk, j.throttle = uP, j.thru = Rc, j.toArray = Vb, j.toPairs = Yb, j.toPairsIn = Gb, j.toPath = yM, j.toPlainObject = Wb, j.transform = hD, j.unary = dP, j.union = ck, j.unionBy = uk, j.unionWith = dk, j.uniq = pk, j.uniqBy = fk, j.uniqWith = mk, j.unset = gD, j.unzip = Fp, j.unzipWith = Eb, j.update = yD, j.updateWith = bD, j.values = _a, j.valuesIn = vD, j.without = hk, j.words = Qb, j.wrap = pP, j.xor = gk, j.xorBy = yk, j.xorWith = bk, j.zip = vk, j.zipObject = xk, j.zipObjectDeep = wk, j.zipWith = Ck, j.entries = Yb, j.entriesIn = Gb, j.extend = qb, j.extendWith = jc, Gp(j, j), j.add = vM, j.attempt = Zb, j.camelCase = SD, j.capitalize = Kb, j.ceil = xM, j.clamp = xD, j.clone = mP, j.cloneDeep = gP, j.cloneDeepWith = yP, j.cloneWith = hP, j.conformsTo = bP, j.deburr = Xb, j.defaultTo = ZD, j.divide = wM, j.endsWith = OD, j.eq = so, j.escape = TD, j.escapeRegExp = ED, j.every = Ik, j.find = $k, j.findIndex = wb, j.findKey = GP, j.findLast = Ak, j.findLastIndex = Cb, j.findLastKey = KP, j.floor = CM, j.forEach = kb, j.forEachRight = Pb, j.forIn = XP, j.forInRight = QP, j.forOwn = ZP, j.forOwnRight = JP, j.get = Wp, j.gt = vP, j.gte = xP, j.has = nD, j.hasIn = qp, j.head = Ob, j.identity = dr, j.includes = Vk, j.indexOf = AR, j.inRange = wD, j.invoke = iD, j.isArguments = Qi, j.isArray = yt, j.isArrayBuffer = wP, j.isArrayLike = cr, j.isArrayLikeObject = Pn, j.isBoolean = CP, j.isBuffer = vi, j.isDate = SP, j.isElement = OP, j.isEmpty = TP, j.isEqual = EP, j.isEqualWith = RP, j.isError = Vp, j.isFinite = kP, j.isFunction = Wo, j.isInteger = Nb, j.isLength = _c, j.isMap = Fb, j.isMatch = PP, j.isMatchWith = DP, j.isNaN = MP, j.isNative = _P, j.isNil = jP, j.isNull = IP, j.isNumber = Lb, j.isObject = yn, j.isObjectLike = wn, j.isPlainObject = Ms, j.isRegExp = zp, j.isSafeInteger = $P, j.isSet = Bb, j.isString = Ic, j.isSymbol = Sr, j.isTypedArray = Ma, j.isUndefined = AP, j.isWeakMap = NP, j.isWeakSet = FP, j.join = VR, j.kebabCase = RD, j.last = zr, j.lastIndexOf = zR, j.lowerCase = kD, j.lowerFirst = PD, j.lt = LP, j.lte = BP, j.max = SM, j.maxBy = OM, j.mean = TM, j.meanBy = EM, j.min = RM, j.minBy = kM, j.stubArray = Xp, j.stubFalse = Qp, j.stubObject = fM, j.stubString = mM, j.stubTrue = hM, j.multiply = PM, j.nth = WR, j.noConflict = iM, j.noop = Kp, j.now = Pc, j.pad = DD, j.padEnd = MD, j.padStart = _D, j.parseInt = ID, j.random = CD, j.reduce = Uk, j.reduceRight = Yk, j.repeat = jD, j.replace = $D, j.result = pD, j.round = DM, j.runInContext = te, j.sample = Kk, j.size = Zk, j.snakeCase = AD, j.some = Jk, j.sortedIndex = XR, j.sortedIndexBy = QR, j.sortedIndexOf = ZR, j.sortedLastIndex = JR, j.sortedLastIndexBy = ek, j.sortedLastIndexOf = tk, j.startCase = FD, j.startsWith = LD, j.subtract = MM, j.sum = _M, j.sumBy = IM, j.template = BD, j.times = gM, j.toFinite = qo, j.toInteger = bt, j.toLength = zb, j.toLower = VD, j.toNumber = Wr, j.toSafeInteger = VP, j.toString = zt, j.toUpper = zD, j.trim = WD, j.trimEnd = qD, j.trimStart = HD, j.truncate = UD, j.unescape = YD, j.uniqueId = bM, j.upperCase = GD, j.upperFirst = Hp, j.each = kb, j.eachRight = Pb, j.first = Ob, Gp(j, function() {
          var s = {};
          return yo(j, function(c, f) {
            Yt.call(j.prototype, f) || (s[f] = c);
          }), s;
        }(), { chain: !1 }), j.VERSION = r, Nr(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(s) {
          j[s].placeholder = j;
        }), Nr(["drop", "take"], function(s, c) {
          Pt.prototype[s] = function(f) {
            f = f === n ? 1 : Fn(bt(f), 0);
            var C = this.__filtered__ && !c ? new Pt(this) : this.clone();
            return C.__filtered__ ? C.__takeCount__ = Yn(f, C.__takeCount__) : C.__views__.push({
              size: Yn(f, Q),
              type: s + (C.__dir__ < 0 ? "Right" : "")
            }), C;
          }, Pt.prototype[s + "Right"] = function(f) {
            return this.reverse()[s](f).reverse();
          };
        }), Nr(["filter", "map", "takeWhile"], function(s, c) {
          var f = c + 1, C = f == L || f == z;
          Pt.prototype[s] = function(D) {
            var A = this.clone();
            return A.__iteratees__.push({
              iteratee: it(D, 3),
              type: f
            }), A.__filtered__ = A.__filtered__ || C, A;
          };
        }), Nr(["head", "last"], function(s, c) {
          var f = "take" + (c ? "Right" : "");
          Pt.prototype[s] = function() {
            return this[f](1).value()[0];
          };
        }), Nr(["initial", "tail"], function(s, c) {
          var f = "drop" + (c ? "" : "Right");
          Pt.prototype[s] = function() {
            return this.__filtered__ ? new Pt(this) : this[f](1);
          };
        }), Pt.prototype.compact = function() {
          return this.filter(dr);
        }, Pt.prototype.find = function(s) {
          return this.filter(s).head();
        }, Pt.prototype.findLast = function(s) {
          return this.reverse().find(s);
        }, Pt.prototype.invokeMap = St(function(s, c) {
          return typeof s == "function" ? new Pt(this) : this.map(function(f) {
            return Ts(f, s, c);
          });
        }), Pt.prototype.reject = function(s) {
          return this.filter(Mc(it(s)));
        }, Pt.prototype.slice = function(s, c) {
          s = bt(s);
          var f = this;
          return f.__filtered__ && (s > 0 || c < 0) ? new Pt(f) : (s < 0 ? f = f.takeRight(-s) : s && (f = f.drop(s)), c !== n && (c = bt(c), f = c < 0 ? f.dropRight(-c) : f.take(c - s)), f);
        }, Pt.prototype.takeRightWhile = function(s) {
          return this.reverse().takeWhile(s).reverse();
        }, Pt.prototype.toArray = function() {
          return this.take(Q);
        }, yo(Pt.prototype, function(s, c) {
          var f = /^(?:filter|find|map|reject)|While$/.test(c), C = /^(?:head|last)$/.test(c), D = j[C ? "take" + (c == "last" ? "Right" : "") : c], A = C || /^find/.test(c);
          D && (j.prototype[c] = function() {
            var q = this.__wrapped__, Y = C ? [1] : arguments, re = q instanceof Pt, Ce = Y[0], Oe = re || yt(q), De = function(Tt) {
              var _t = D.apply(j, pi([Tt], Y));
              return C && Fe ? _t[0] : _t;
            };
            Oe && f && typeof Ce == "function" && Ce.length != 1 && (re = Oe = !1);
            var Fe = this.__chain__, Xe = !!this.__actions__.length, st = A && !Fe, xt = re && !Xe;
            if (!A && Oe) {
              q = xt ? q : new Pt(this);
              var lt = s.apply(q, Y);
              return lt.__actions__.push({ func: Rc, args: [De], thisArg: n }), new Lr(lt, Fe);
            }
            return st && xt ? s.apply(this, Y) : (lt = this.thru(De), st ? C ? lt.value()[0] : lt.value() : lt);
          });
        }), Nr(["pop", "push", "shift", "sort", "splice", "unshift"], function(s) {
          var c = Jl[s], f = /^(?:push|sort|unshift)$/.test(s) ? "tap" : "thru", C = /^(?:pop|shift)$/.test(s);
          j.prototype[s] = function() {
            var D = arguments;
            if (C && !this.__chain__) {
              var A = this.value();
              return c.apply(yt(A) ? A : [], D);
            }
            return this[f](function(q) {
              return c.apply(yt(q) ? q : [], D);
            });
          };
        }), yo(Pt.prototype, function(s, c) {
          var f = j[c];
          if (f) {
            var C = f.name + "";
            Yt.call(Ea, C) || (Ea[C] = []), Ea[C].push({ name: c, func: f });
          }
        }), Ea[xc(n, O).name] = [{
          name: "wrapper",
          func: n
        }], Pt.prototype.clone = YT, Pt.prototype.reverse = GT, Pt.prototype.value = KT, j.prototype.at = Ok, j.prototype.chain = Tk, j.prototype.commit = Ek, j.prototype.next = Rk, j.prototype.plant = Pk, j.prototype.reverse = Dk, j.prototype.toJSON = j.prototype.valueOf = j.prototype.value = Mk, j.prototype.first = j.prototype.head, bs && (j.prototype[bs] = kk), j;
      }, Sa = ET();
      Wi ? ((Wi.exports = Sa)._ = Sa, Yd._ = Sa) : Vn._ = Sa;
    }).call(B5);
  }(el, el.exports)), el.exports;
}
var z5 = V5();
const cS = ({ control: e, dependsOn: t, textField: n }) => {
  const r = aS({ control: e, name: t.name }), a = W5(r, t.value) || t.disabled, {
    field: { value: l, onChange: u },
    formState: { errors: d }
  } = sS({
    disabled: a,
    name: n.name,
    control: e,
    rules: n == null ? void 0 : n.rules
  });
  return /* @__PURE__ */ x.jsx(Mr, { display: "flex", flexDirection: "column", children: /* @__PURE__ */ x.jsx(Id, { ...n, fullWidth: !1, disabled: a, value: l, onChange: u, error: z5.get(d, n.name) }) });
}, W5 = (e, t) => Array.isArray(e) ? !e.includes(t) : e !== t, q5 = ({
  label: e,
  disabled: t,
  value: n,
  onChange: r,
  error: i,
  name: a,
  readOnly: l = !1,
  options: u,
  direction: d = "horizontal",
  control: p,
  itemWrapperProps: m = {}
}) => /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
  /* @__PURE__ */ x.jsxs(sr, { sx: { pointerEvents: l ? "none" : "auto" }, children: [
    /* @__PURE__ */ x.jsx(jr, { id: `${a}-label`, disabled: t, children: e }),
    /* @__PURE__ */ x.jsx(DC, { "aria-labelledby": `${a}-label`, value: n, onChange: r, children: /* @__PURE__ */ x.jsx(sn, { direction: d === "horizontal" ? "row" : "column", flexWrap: "wrap", columnGap: 3, rowGap: 1, children: u.map((h, g) => {
      const v = lS(h.value), { sx: b = {}, ...y } = m;
      return /* @__PURE__ */ x.jsxs(Mr, { sx: { display: "flex", alignItems: "flex-start", ...b }, ...y, children: [
        /* @__PURE__ */ x.jsx(
          Sd,
          {
            disabled: t,
            value: h.value,
            control: /* @__PURE__ */ x.jsx(Uh, {}),
            checked: n === h.value,
            label: h.label || h.value
          },
          `${a}-radio-${v}`
        ),
        (h == null ? void 0 : h.textField) && /* @__PURE__ */ x.jsx(
          cS,
          {
            dependsOn: {
              name: a,
              disabled: !!(t || l),
              value: h.value
            },
            control: p,
            textField: h.textField
          },
          `${a}-${v}-additional`
        )
      ] }, `${a}-radio-${v}${g}`);
    }) }) })
  ] }),
  i && /* @__PURE__ */ x.jsx(at, { variant: "caption", color: "error", children: i.message })
] }), uS = 6048e5, H5 = 864e5, dS = 6e4, pS = 36e5, U5 = 1e3, o0 = Symbol.for("constructDateFrom");
function hn(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && o0 in e ? e[o0](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function rt(e, t) {
  return hn(t || e, e);
}
function Ii(e, t, n) {
  const r = rt(e, n == null ? void 0 : n.in);
  return isNaN(t) ? hn((n == null ? void 0 : n.in) || e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function xl(e, t, n) {
  const r = rt(e, n == null ? void 0 : n.in);
  if (isNaN(t)) return hn(e, NaN);
  if (!t)
    return r;
  const i = r.getDate(), a = hn(e, r.getTime());
  a.setMonth(r.getMonth() + t + 1, 0);
  const l = a.getDate();
  return i >= l ? a : (r.setFullYear(
    a.getFullYear(),
    a.getMonth(),
    i
  ), r);
}
function fS(e, t, n) {
  return hn(e, +rt(e) + t);
}
function Y5(e, t, n) {
  return fS(e, t * pS);
}
let G5 = {};
function ga() {
  return G5;
}
function oi(e, t) {
  var u, d, p, m;
  const n = ga(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((d = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : d.weekStartsOn) ?? n.weekStartsOn ?? ((m = (p = n.locale) == null ? void 0 : p.options) == null ? void 0 : m.weekStartsOn) ?? 0, i = rt(e, t == null ? void 0 : t.in), a = i.getDay(), l = (a < r ? 7 : 0) + a - r;
  return i.setDate(i.getDate() - l), i.setHours(0, 0, 0, 0), i;
}
function is(e, t) {
  return oi(e, { ...t, weekStartsOn: 1 });
}
function mS(e, t) {
  const n = rt(e, t == null ? void 0 : t.in), r = n.getFullYear(), i = hn(n, 0);
  i.setFullYear(r + 1, 0, 4), i.setHours(0, 0, 0, 0);
  const a = is(i), l = hn(n, 0);
  l.setFullYear(r, 0, 4), l.setHours(0, 0, 0, 0);
  const u = is(l);
  return n.getTime() >= a.getTime() ? r + 1 : n.getTime() >= u.getTime() ? r : r - 1;
}
function _u(e) {
  const t = rt(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function Hl(e, ...t) {
  const n = hn.bind(
    null,
    t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function wl(e, t) {
  const n = rt(e, t == null ? void 0 : t.in);
  return n.setHours(0, 0, 0, 0), n;
}
function K5(e, t, n) {
  const [r, i] = Hl(
    n == null ? void 0 : n.in,
    e,
    t
  ), a = wl(r), l = wl(i), u = +a - _u(a), d = +l - _u(l);
  return Math.round((u - d) / H5);
}
function X5(e, t) {
  const n = mS(e, t), r = hn(e, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), is(r);
}
function Q5(e, t, n) {
  const r = rt(e, n == null ? void 0 : n.in);
  return r.setTime(r.getTime() + t * dS), r;
}
function Z5(e, t, n) {
  return fS(e, t * 1e3);
}
function Iu(e, t, n) {
  return Ii(e, t * 7, n);
}
function ju(e, t, n) {
  return xl(e, t * 12, n);
}
function J5(e, t, n) {
  const [r, i] = Hl(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return +wl(r) == +wl(i);
}
function eW(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function $u(e) {
  return !(!eW(e) && typeof e != "number" || isNaN(+rt(e)));
}
function i0(e, t) {
  const n = rt(e, t == null ? void 0 : t.in);
  return n.setHours(23, 59, 59, 999), n;
}
function tW(e, t) {
  const n = rt(e, t == null ? void 0 : t.in), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function nW(e, t) {
  const n = rt(e, t == null ? void 0 : t.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function a0(e, t) {
  const n = rt(e, t == null ? void 0 : t.in), r = n.getFullYear();
  return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function hS(e, t) {
  const n = rt(e, t == null ? void 0 : t.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function rW(e, t) {
  var u, d, p, m;
  const n = ga(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((d = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : d.weekStartsOn) ?? n.weekStartsOn ?? ((m = (p = n.locale) == null ? void 0 : p.options) == null ? void 0 : m.weekStartsOn) ?? 0, i = rt(e, t == null ? void 0 : t.in), a = i.getDay(), l = (a < r ? -7 : 0) + 6 - (a - r);
  return i.setDate(i.getDate() + l), i.setHours(23, 59, 59, 999), i;
}
const oW = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, iW = (e, t, n) => {
  let r;
  const i = oW[e];
  return typeof i == "string" ? r = i : t === 1 ? r = i.one : r = i.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function ym(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const aW = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, sW = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, lW = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, cW = {
  date: ym({
    formats: aW,
    defaultWidth: "full"
  }),
  time: ym({
    formats: sW,
    defaultWidth: "full"
  }),
  dateTime: ym({
    formats: lW,
    defaultWidth: "full"
  })
}, uW = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, dW = (e, t, n, r) => uW[e];
function Ws(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let i;
    if (r === "formatting" && e.formattingValues) {
      const l = e.defaultFormattingWidth || e.defaultWidth, u = n != null && n.width ? String(n.width) : l;
      i = e.formattingValues[u] || e.formattingValues[l];
    } else {
      const l = e.defaultWidth, u = n != null && n.width ? String(n.width) : e.defaultWidth;
      i = e.values[u] || e.values[l];
    }
    const a = e.argumentCallback ? e.argumentCallback(t) : t;
    return i[a];
  };
}
const pW = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, fW = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, mW = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, hW = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, gW = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, yW = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, bW = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, vW = {
  ordinalNumber: bW,
  era: Ws({
    values: pW,
    defaultWidth: "wide"
  }),
  quarter: Ws({
    values: fW,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ws({
    values: mW,
    defaultWidth: "wide"
  }),
  day: Ws({
    values: hW,
    defaultWidth: "wide"
  }),
  dayPeriod: Ws({
    values: gW,
    defaultWidth: "wide",
    formattingValues: yW,
    defaultFormattingWidth: "wide"
  })
};
function qs(e) {
  return (t, n = {}) => {
    const r = n.width, i = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = t.match(i);
    if (!a)
      return null;
    const l = a[0], u = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], d = Array.isArray(u) ? wW(u, (h) => h.test(l)) : (
      // [TODO] -- I challenge you to fix the type
      xW(u, (h) => h.test(l))
    );
    let p;
    p = e.valueCallback ? e.valueCallback(d) : d, p = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(p)
    ) : p;
    const m = t.slice(l.length);
    return { value: p, rest: m };
  };
}
function xW(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function wW(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function CW(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const i = r[0], a = t.match(e.parsePattern);
    if (!a) return null;
    let l = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    l = n.valueCallback ? n.valueCallback(l) : l;
    const u = t.slice(i.length);
    return { value: l, rest: u };
  };
}
const SW = /^(\d+)(th|st|nd|rd)?/i, OW = /\d+/i, TW = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, EW = {
  any: [/^b/i, /^(a|c)/i]
}, RW = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, kW = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, PW = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, DW = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, MW = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, _W = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, IW = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, jW = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, $W = {
  ordinalNumber: CW({
    matchPattern: SW,
    parsePattern: OW,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: qs({
    matchPatterns: TW,
    defaultMatchWidth: "wide",
    parsePatterns: EW,
    defaultParseWidth: "any"
  }),
  quarter: qs({
    matchPatterns: RW,
    defaultMatchWidth: "wide",
    parsePatterns: kW,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: qs({
    matchPatterns: PW,
    defaultMatchWidth: "wide",
    parsePatterns: DW,
    defaultParseWidth: "any"
  }),
  day: qs({
    matchPatterns: MW,
    defaultMatchWidth: "wide",
    parsePatterns: _W,
    defaultParseWidth: "any"
  }),
  dayPeriod: qs({
    matchPatterns: IW,
    defaultMatchWidth: "any",
    parsePatterns: jW,
    defaultParseWidth: "any"
  })
}, jd = {
  code: "en-US",
  formatDistance: iW,
  formatLong: cW,
  formatRelative: dW,
  localize: vW,
  match: $W,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function AW(e, t) {
  const n = rt(e, t == null ? void 0 : t.in);
  return K5(n, hS(n)) + 1;
}
function gS(e, t) {
  const n = rt(e, t == null ? void 0 : t.in), r = +is(n) - +X5(n);
  return Math.round(r / uS) + 1;
}
function ug(e, t) {
  var m, h, g, v;
  const n = rt(e, t == null ? void 0 : t.in), r = n.getFullYear(), i = ga(), a = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((h = (m = t == null ? void 0 : t.locale) == null ? void 0 : m.options) == null ? void 0 : h.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((v = (g = i.locale) == null ? void 0 : g.options) == null ? void 0 : v.firstWeekContainsDate) ?? 1, l = hn((t == null ? void 0 : t.in) || e, 0);
  l.setFullYear(r + 1, 0, a), l.setHours(0, 0, 0, 0);
  const u = oi(l, t), d = hn((t == null ? void 0 : t.in) || e, 0);
  d.setFullYear(r, 0, a), d.setHours(0, 0, 0, 0);
  const p = oi(d, t);
  return +n >= +u ? r + 1 : +n >= +p ? r : r - 1;
}
function NW(e, t) {
  var u, d, p, m;
  const n = ga(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((d = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((m = (p = n.locale) == null ? void 0 : p.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, i = ug(e, t), a = hn((t == null ? void 0 : t.in) || e, 0);
  return a.setFullYear(i, 0, r), a.setHours(0, 0, 0, 0), oi(a, t);
}
function dg(e, t) {
  const n = rt(e, t == null ? void 0 : t.in), r = +oi(n, t) - +NW(n, t);
  return Math.round(r / uS) + 1;
}
function Gt(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const wi = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return Gt(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : Gt(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return Gt(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return Gt(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return Gt(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return Gt(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return Gt(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), i = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return Gt(i, t.length);
  }
}, Na = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, s0 = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), i = r > 0 ? r : 1 - r;
      return n.ordinalNumber(i, { unit: "year" });
    }
    return wi.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const i = ug(e, r), a = i > 0 ? i : 1 - i;
    if (t === "YY") {
      const l = a % 100;
      return Gt(l, 2);
    }
    return t === "Yo" ? n.ordinalNumber(a, { unit: "year" }) : Gt(a, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = mS(e);
    return Gt(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return Gt(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return Gt(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return Gt(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return wi.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return Gt(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const i = dg(e, r);
    return t === "wo" ? n.ordinalNumber(i, { unit: "week" }) : Gt(i, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = gS(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : Gt(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : wi.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = AW(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : Gt(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const i = e.getDay(), a = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(a);
      // Padded numerical value
      case "ee":
        return Gt(a, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(a, { unit: "day" });
      case "eee":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const i = e.getDay(), a = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(a);
      // Padded numerical value
      case "cc":
        return Gt(a, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return n.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(i, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(i, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), i = r === 0 ? 7 : r;
    switch (t) {
      // 2
      case "i":
        return String(i);
      // 02
      case "ii":
        return Gt(i, t.length);
      // 2nd
      case "io":
        return n.ordinalNumber(i, { unit: "day" });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const i = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let i;
    switch (r === 12 ? i = Na.noon : r === 0 ? i = Na.midnight : i = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let i;
    switch (r >= 17 ? i = Na.evening : r >= 12 ? i = Na.afternoon : r >= 4 ? i = Na.morning : i = Na.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return wi.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : wi.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : Gt(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : Gt(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : wi.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : wi.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return wi.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return c0(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return ia(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return ia(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return c0(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return ia(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return ia(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + l0(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + ia(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + l0(r, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + ia(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(+e / 1e3);
    return Gt(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return Gt(+e, t.length);
  }
};
function l0(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), i = Math.trunc(r / 60), a = r % 60;
  return a === 0 ? n + String(i) : n + String(i) + t + Gt(a, 2);
}
function c0(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Gt(Math.abs(e) / 60, 2) : ia(e, t);
}
function ia(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), i = Gt(Math.trunc(r / 60), 2), a = Gt(r % 60, 2);
  return n + i + t + a;
}
const u0 = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, yS = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, FW = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], i = n[2];
  if (!i)
    return u0(e, t);
  let a;
  switch (r) {
    case "P":
      a = t.dateTime({ width: "short" });
      break;
    case "PP":
      a = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      a = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      a = t.dateTime({ width: "full" });
      break;
  }
  return a.replace("{{date}}", u0(r, t)).replace("{{time}}", yS(i, t));
}, Cl = {
  p: yS,
  P: FW
}, LW = /^D+$/, BW = /^Y+$/, VW = ["D", "DD", "YY", "YYYY"];
function bS(e) {
  return LW.test(e);
}
function vS(e) {
  return BW.test(e);
}
function Um(e, t, n) {
  const r = zW(e, t, n);
  if (console.warn(r), VW.includes(e)) throw new RangeError(r);
}
function zW(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const WW = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, qW = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, HW = /^'([^]*?)'?$/, UW = /''/g, YW = /[a-zA-Z]/;
function GW(e, t, n) {
  var m, h, g, v, b, y, S, O;
  const r = ga(), i = (n == null ? void 0 : n.locale) ?? r.locale ?? jd, a = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((h = (m = n == null ? void 0 : n.locale) == null ? void 0 : m.options) == null ? void 0 : h.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((v = (g = r.locale) == null ? void 0 : g.options) == null ? void 0 : v.firstWeekContainsDate) ?? 1, l = (n == null ? void 0 : n.weekStartsOn) ?? ((y = (b = n == null ? void 0 : n.locale) == null ? void 0 : b.options) == null ? void 0 : y.weekStartsOn) ?? r.weekStartsOn ?? ((O = (S = r.locale) == null ? void 0 : S.options) == null ? void 0 : O.weekStartsOn) ?? 0, u = rt(e, n == null ? void 0 : n.in);
  if (!$u(u))
    throw new RangeError("Invalid time value");
  let d = t.match(qW).map((P) => {
    const k = P[0];
    if (k === "p" || k === "P") {
      const R = Cl[k];
      return R(P, i.formatLong);
    }
    return P;
  }).join("").match(WW).map((P) => {
    if (P === "''")
      return { isToken: !1, value: "'" };
    const k = P[0];
    if (k === "'")
      return { isToken: !1, value: KW(P) };
    if (s0[k])
      return { isToken: !0, value: P };
    if (k.match(YW))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + k + "`"
      );
    return { isToken: !1, value: P };
  });
  i.localize.preprocessor && (d = i.localize.preprocessor(u, d));
  const p = {
    firstWeekContainsDate: a,
    weekStartsOn: l,
    locale: i
  };
  return d.map((P) => {
    if (!P.isToken) return P.value;
    const k = P.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && vS(k) || !(n != null && n.useAdditionalDayOfYearTokens) && bS(k)) && Um(k, t, String(e));
    const R = s0[k[0]];
    return R(u, k, i.localize, p);
  }).join("");
}
function KW(e) {
  const t = e.match(HW);
  return t ? t[1].replace(UW, "'") : e;
}
function XW(e, t) {
  return rt(e, t == null ? void 0 : t.in).getDate();
}
function xS(e, t) {
  const n = rt(e, t == null ? void 0 : t.in), r = n.getFullYear(), i = n.getMonth(), a = hn(n, 0);
  return a.setFullYear(r, i + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
function QW() {
  return Object.assign({}, ga());
}
function ZW(e, t) {
  return rt(e, t == null ? void 0 : t.in).getHours();
}
function JW(e, t) {
  const n = rt(e, t == null ? void 0 : t.in).getDay();
  return n === 0 ? 7 : n;
}
function e4(e) {
  return rt(e).getMilliseconds();
}
function t4(e, t) {
  return rt(e, t == null ? void 0 : t.in).getMinutes();
}
function n4(e, t) {
  return rt(e, t == null ? void 0 : t.in).getMonth();
}
function r4(e) {
  return rt(e).getSeconds();
}
function o4(e, t) {
  return rt(e, t == null ? void 0 : t.in).getFullYear();
}
function bm(e, t) {
  return +rt(e) > +rt(t);
}
function vm(e, t) {
  return +rt(e) < +rt(t);
}
function i4(e, t) {
  return +rt(e) == +rt(t);
}
function a4(e, t) {
  const n = s4(t) ? new t(0) : hn(t, 0);
  return n.setFullYear(e.getFullYear(), e.getMonth(), e.getDate()), n.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), n;
}
function s4(e) {
  var t;
  return typeof e == "function" && ((t = e.prototype) == null ? void 0 : t.constructor) === e;
}
const l4 = 10;
class wS {
  constructor() {
    qe(this, "subPriority", 0);
  }
  validate(t, n) {
    return !0;
  }
}
class c4 extends wS {
  constructor(t, n, r, i, a) {
    super(), this.value = t, this.validateValue = n, this.setValue = r, this.priority = i, a && (this.subPriority = a);
  }
  validate(t, n) {
    return this.validateValue(t, this.value, n);
  }
  set(t, n, r) {
    return this.setValue(t, n, this.value, r);
  }
}
class u4 extends wS {
  constructor(n, r) {
    super();
    qe(this, "priority", l4);
    qe(this, "subPriority", -1);
    this.context = n || ((i) => hn(r, i));
  }
  set(n, r) {
    return r.timestampIsSet ? n : hn(n, a4(n, this.context));
  }
}
class Vt {
  run(t, n, r, i) {
    const a = this.parse(t, n, r, i);
    return a ? {
      setter: new c4(
        a.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: a.rest
    } : null;
  }
  validate(t, n, r) {
    return !0;
  }
}
class d4 extends Vt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 140);
    qe(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(n, r, i) {
    switch (r) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return i.era(n, { width: "abbreviated" }) || i.era(n, { width: "narrow" });
      // A, B
      case "GGGGG":
        return i.era(n, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return i.era(n, { width: "wide" }) || i.era(n, { width: "abbreviated" }) || i.era(n, { width: "narrow" });
    }
  }
  set(n, r, i) {
    return r.era = i, n.setFullYear(i, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
const Mn = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Ro = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function _n(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function vn(e, t) {
  const n = t.match(e);
  return n ? {
    value: parseInt(n[0], 10),
    rest: t.slice(n[0].length)
  } : null;
}
function ko(e, t) {
  const n = t.match(e);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  const r = n[1] === "+" ? 1 : -1, i = n[2] ? parseInt(n[2], 10) : 0, a = n[3] ? parseInt(n[3], 10) : 0, l = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: r * (i * pS + a * dS + l * U5),
    rest: t.slice(n[0].length)
  };
}
function CS(e) {
  return vn(Mn.anyDigitsSigned, e);
}
function Rn(e, t) {
  switch (e) {
    case 1:
      return vn(Mn.singleDigit, t);
    case 2:
      return vn(Mn.twoDigits, t);
    case 3:
      return vn(Mn.threeDigits, t);
    case 4:
      return vn(Mn.fourDigits, t);
    default:
      return vn(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function Au(e, t) {
  switch (e) {
    case 1:
      return vn(Mn.singleDigitSigned, t);
    case 2:
      return vn(Mn.twoDigitsSigned, t);
    case 3:
      return vn(Mn.threeDigitsSigned, t);
    case 4:
      return vn(Mn.fourDigitsSigned, t);
    default:
      return vn(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function pg(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function SS(e, t) {
  const n = t > 0, r = n ? t : 1 - t;
  let i;
  if (r <= 50)
    i = e || 100;
  else {
    const a = r + 50, l = Math.trunc(a / 100) * 100, u = e >= a % 100;
    i = e + l - (u ? 100 : 0);
  }
  return n ? i : 1 - i;
}
function OS(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class p4 extends Vt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 130);
    qe(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, r, i) {
    const a = (l) => ({
      year: l,
      isTwoDigitYear: r === "yy"
    });
    switch (r) {
      case "y":
        return _n(Rn(4, n), a);
      case "yo":
        return _n(
          i.ordinalNumber(n, {
            unit: "year"
          }),
          a
        );
      default:
        return _n(Rn(r.length, n), a);
    }
  }
  validate(n, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(n, r, i) {
    const a = n.getFullYear();
    if (i.isTwoDigitYear) {
      const u = SS(
        i.year,
        a
      );
      return n.setFullYear(u, 0, 1), n.setHours(0, 0, 0, 0), n;
    }
    const l = !("era" in r) || r.era === 1 ? i.year : 1 - i.year;
    return n.setFullYear(l, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class f4 extends Vt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 130);
    qe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, r, i) {
    const a = (l) => ({
      year: l,
      isTwoDigitYear: r === "YY"
    });
    switch (r) {
      case "Y":
        return _n(Rn(4, n), a);
      case "Yo":
        return _n(
          i.ordinalNumber(n, {
            unit: "year"
          }),
          a
        );
      default:
        return _n(Rn(r.length, n), a);
    }
  }
  validate(n, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(n, r, i, a) {
    const l = ug(n, a);
    if (i.isTwoDigitYear) {
      const d = SS(
        i.year,
        l
      );
      return n.setFullYear(
        d,
        0,
        a.firstWeekContainsDate
      ), n.setHours(0, 0, 0, 0), oi(n, a);
    }
    const u = !("era" in r) || r.era === 1 ? i.year : 1 - i.year;
    return n.setFullYear(u, 0, a.firstWeekContainsDate), n.setHours(0, 0, 0, 0), oi(n, a);
  }
}
class m4 extends Vt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 130);
    qe(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r) {
    return Au(r === "R" ? 4 : r.length, n);
  }
  set(n, r, i) {
    const a = hn(n, 0);
    return a.setFullYear(i, 0, 4), a.setHours(0, 0, 0, 0), is(a);
  }
}
class h4 extends Vt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 130);
    qe(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, r) {
    return Au(r === "u" ? 4 : r.length, n);
  }
  set(n, r, i) {
    return n.setFullYear(i, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class g4 extends Vt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 120);
    qe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, i) {
    switch (r) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return Rn(r.length, n);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return i.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return i.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return i.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return i.quarter(n, {
          width: "wide",
          context: "formatting"
        }) || i.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 4;
  }
  set(n, r, i) {
    return n.setMonth((i - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class y4 extends Vt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 120);
    qe(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, i) {
    switch (r) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return Rn(r.length, n);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return i.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return i.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return i.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return i.quarter(n, {
          width: "wide",
          context: "standalone"
        }) || i.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 4;
  }
  set(n, r, i) {
    return n.setMonth((i - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class b4 extends Vt {
  constructor() {
    super(...arguments);
    qe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    qe(this, "priority", 110);
  }
  parse(n, r, i) {
    const a = (l) => l - 1;
    switch (r) {
      // 1, 2, ..., 12
      case "M":
        return _n(
          vn(Mn.month, n),
          a
        );
      // 01, 02, ..., 12
      case "MM":
        return _n(Rn(2, n), a);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return _n(
          i.ordinalNumber(n, {
            unit: "month"
          }),
          a
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return i.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.month(n, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return i.month(n, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return i.month(n, { width: "wide", context: "formatting" }) || i.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.month(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 11;
  }
  set(n, r, i) {
    return n.setMonth(i, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class v4 extends Vt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 110);
    qe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, i) {
    const a = (l) => l - 1;
    switch (r) {
      // 1, 2, ..., 12
      case "L":
        return _n(
          vn(Mn.month, n),
          a
        );
      // 01, 02, ..., 12
      case "LL":
        return _n(Rn(2, n), a);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return _n(
          i.ordinalNumber(n, {
            unit: "month"
          }),
          a
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return i.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.month(n, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return i.month(n, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return i.month(n, { width: "wide", context: "standalone" }) || i.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.month(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 11;
  }
  set(n, r, i) {
    return n.setMonth(i, 1), n.setHours(0, 0, 0, 0), n;
  }
}
function x4(e, t, n) {
  const r = rt(e, n == null ? void 0 : n.in), i = dg(r, n) - t;
  return r.setDate(r.getDate() - i * 7), rt(r, n == null ? void 0 : n.in);
}
class w4 extends Vt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 100);
    qe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, r, i) {
    switch (r) {
      case "w":
        return vn(Mn.week, n);
      case "wo":
        return i.ordinalNumber(n, { unit: "week" });
      default:
        return Rn(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 53;
  }
  set(n, r, i, a) {
    return oi(x4(n, i, a), a);
  }
}
function C4(e, t, n) {
  const r = rt(e, n == null ? void 0 : n.in), i = gS(r, n) - t;
  return r.setDate(r.getDate() - i * 7), r;
}
class S4 extends Vt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 100);
    qe(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, i) {
    switch (r) {
      case "I":
        return vn(Mn.week, n);
      case "Io":
        return i.ordinalNumber(n, { unit: "week" });
      default:
        return Rn(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 53;
  }
  set(n, r, i) {
    return is(C4(n, i));
  }
}
const O4 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], T4 = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class E4 extends Vt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 90);
    qe(this, "subPriority", 1);
    qe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, i) {
    switch (r) {
      case "d":
        return vn(Mn.date, n);
      case "do":
        return i.ordinalNumber(n, { unit: "date" });
      default:
        return Rn(r.length, n);
    }
  }
  validate(n, r) {
    const i = n.getFullYear(), a = OS(i), l = n.getMonth();
    return a ? r >= 1 && r <= T4[l] : r >= 1 && r <= O4[l];
  }
  set(n, r, i) {
    return n.setDate(i), n.setHours(0, 0, 0, 0), n;
  }
}
class R4 extends Vt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 90);
    qe(this, "subpriority", 1);
    qe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, i) {
    switch (r) {
      case "D":
      case "DD":
        return vn(Mn.dayOfYear, n);
      case "Do":
        return i.ordinalNumber(n, { unit: "date" });
      default:
        return Rn(r.length, n);
    }
  }
  validate(n, r) {
    const i = n.getFullYear();
    return OS(i) ? r >= 1 && r <= 366 : r >= 1 && r <= 365;
  }
  set(n, r, i) {
    return n.setMonth(0, i), n.setHours(0, 0, 0, 0), n;
  }
}
function fg(e, t, n) {
  var h, g, v, b;
  const r = ga(), i = (n == null ? void 0 : n.weekStartsOn) ?? ((g = (h = n == null ? void 0 : n.locale) == null ? void 0 : h.options) == null ? void 0 : g.weekStartsOn) ?? r.weekStartsOn ?? ((b = (v = r.locale) == null ? void 0 : v.options) == null ? void 0 : b.weekStartsOn) ?? 0, a = rt(e, n == null ? void 0 : n.in), l = a.getDay(), d = (t % 7 + 7) % 7, p = 7 - i, m = t < 0 || t > 6 ? t - (l + p) % 7 : (d + p) % 7 - (l + p) % 7;
  return Ii(a, m, n);
}
class k4 extends Vt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 90);
    qe(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(n, r, i) {
    switch (r) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return i.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return i.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
      // Tuesday
      case "EEEE":
      default:
        return i.day(n, { width: "wide", context: "formatting" }) || i.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 6;
  }
  set(n, r, i, a) {
    return n = fg(n, i, a), n.setHours(0, 0, 0, 0), n;
  }
}
class P4 extends Vt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 90);
    qe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, i, a) {
    const l = (u) => {
      const d = Math.floor((u - 1) / 7) * 7;
      return (u + a.weekStartsOn + 6) % 7 + d;
    };
    switch (r) {
      // 3
      case "e":
      case "ee":
        return _n(Rn(r.length, n), l);
      // 3rd
      case "eo":
        return _n(
          i.ordinalNumber(n, {
            unit: "day"
          }),
          l
        );
      // Tue
      case "eee":
        return i.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return i.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
      // Tuesday
      case "eeee":
      default:
        return i.day(n, { width: "wide", context: "formatting" }) || i.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(n, { width: "short", context: "formatting" }) || i.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 6;
  }
  set(n, r, i, a) {
    return n = fg(n, i, a), n.setHours(0, 0, 0, 0), n;
  }
}
class D4 extends Vt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 90);
    qe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(n, r, i, a) {
    const l = (u) => {
      const d = Math.floor((u - 1) / 7) * 7;
      return (u + a.weekStartsOn + 6) % 7 + d;
    };
    switch (r) {
      // 3
      case "c":
      case "cc":
        return _n(Rn(r.length, n), l);
      // 3rd
      case "co":
        return _n(
          i.ordinalNumber(n, {
            unit: "day"
          }),
          l
        );
      // Tue
      case "ccc":
        return i.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.day(n, { width: "short", context: "standalone" }) || i.day(n, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return i.day(n, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return i.day(n, { width: "short", context: "standalone" }) || i.day(n, { width: "narrow", context: "standalone" });
      // Tuesday
      case "cccc":
      default:
        return i.day(n, { width: "wide", context: "standalone" }) || i.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || i.day(n, { width: "short", context: "standalone" }) || i.day(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 6;
  }
  set(n, r, i, a) {
    return n = fg(n, i, a), n.setHours(0, 0, 0, 0), n;
  }
}
function M4(e, t, n) {
  const r = rt(e, n == null ? void 0 : n.in), i = JW(r, n), a = t - i;
  return Ii(r, a, n);
}
class _4 extends Vt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 90);
    qe(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, i) {
    const a = (l) => l === 0 ? 7 : l;
    switch (r) {
      // 2
      case "i":
      case "ii":
        return Rn(r.length, n);
      // 2nd
      case "io":
        return i.ordinalNumber(n, { unit: "day" });
      // Tue
      case "iii":
        return _n(
          i.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(n, {
            width: "short",
            context: "formatting"
          }) || i.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      // T
      case "iiiii":
        return _n(
          i.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      // Tu
      case "iiiiii":
        return _n(
          i.day(n, {
            width: "short",
            context: "formatting"
          }) || i.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      // Tuesday
      case "iiii":
      default:
        return _n(
          i.day(n, {
            width: "wide",
            context: "formatting"
          }) || i.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(n, {
            width: "short",
            context: "formatting"
          }) || i.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 7;
  }
  set(n, r, i) {
    return n = M4(n, i), n.setHours(0, 0, 0, 0), n;
  }
}
class I4 extends Vt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 80);
    qe(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(n, r, i) {
    switch (r) {
      case "a":
      case "aa":
      case "aaa":
        return i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return i.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, r, i) {
    return n.setHours(pg(i), 0, 0, 0), n;
  }
}
class j4 extends Vt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 80);
    qe(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(n, r, i) {
    switch (r) {
      case "b":
      case "bb":
      case "bbb":
        return i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return i.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, r, i) {
    return n.setHours(pg(i), 0, 0, 0), n;
  }
}
class $4 extends Vt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 80);
    qe(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(n, r, i) {
    switch (r) {
      case "B":
      case "BB":
      case "BBB":
        return i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return i.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, r, i) {
    return n.setHours(pg(i), 0, 0, 0), n;
  }
}
class A4 extends Vt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 70);
    qe(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(n, r, i) {
    switch (r) {
      case "h":
        return vn(Mn.hour12h, n);
      case "ho":
        return i.ordinalNumber(n, { unit: "hour" });
      default:
        return Rn(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 12;
  }
  set(n, r, i) {
    const a = n.getHours() >= 12;
    return a && i < 12 ? n.setHours(i + 12, 0, 0, 0) : !a && i === 12 ? n.setHours(0, 0, 0, 0) : n.setHours(i, 0, 0, 0), n;
  }
}
class N4 extends Vt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 70);
    qe(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(n, r, i) {
    switch (r) {
      case "H":
        return vn(Mn.hour23h, n);
      case "Ho":
        return i.ordinalNumber(n, { unit: "hour" });
      default:
        return Rn(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 23;
  }
  set(n, r, i) {
    return n.setHours(i, 0, 0, 0), n;
  }
}
class F4 extends Vt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 70);
    qe(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(n, r, i) {
    switch (r) {
      case "K":
        return vn(Mn.hour11h, n);
      case "Ko":
        return i.ordinalNumber(n, { unit: "hour" });
      default:
        return Rn(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 11;
  }
  set(n, r, i) {
    return n.getHours() >= 12 && i < 12 ? n.setHours(i + 12, 0, 0, 0) : n.setHours(i, 0, 0, 0), n;
  }
}
class L4 extends Vt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 70);
    qe(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(n, r, i) {
    switch (r) {
      case "k":
        return vn(Mn.hour24h, n);
      case "ko":
        return i.ordinalNumber(n, { unit: "hour" });
      default:
        return Rn(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 24;
  }
  set(n, r, i) {
    const a = i <= 24 ? i % 24 : i;
    return n.setHours(a, 0, 0, 0), n;
  }
}
class B4 extends Vt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 60);
    qe(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, r, i) {
    switch (r) {
      case "m":
        return vn(Mn.minute, n);
      case "mo":
        return i.ordinalNumber(n, { unit: "minute" });
      default:
        return Rn(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 59;
  }
  set(n, r, i) {
    return n.setMinutes(i, 0, 0), n;
  }
}
class V4 extends Vt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 50);
    qe(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, r, i) {
    switch (r) {
      case "s":
        return vn(Mn.second, n);
      case "so":
        return i.ordinalNumber(n, { unit: "second" });
      default:
        return Rn(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 59;
  }
  set(n, r, i) {
    return n.setSeconds(i, 0), n;
  }
}
class z4 extends Vt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 30);
    qe(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, r) {
    const i = (a) => Math.trunc(a * Math.pow(10, -r.length + 3));
    return _n(Rn(r.length, n), i);
  }
  set(n, r, i) {
    return n.setMilliseconds(i), n;
  }
}
class W4 extends Vt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 10);
    qe(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(n, r) {
    switch (r) {
      case "X":
        return ko(
          Ro.basicOptionalMinutes,
          n
        );
      case "XX":
        return ko(Ro.basic, n);
      case "XXXX":
        return ko(
          Ro.basicOptionalSeconds,
          n
        );
      case "XXXXX":
        return ko(
          Ro.extendedOptionalSeconds,
          n
        );
      case "XXX":
      default:
        return ko(Ro.extended, n);
    }
  }
  set(n, r, i) {
    return r.timestampIsSet ? n : hn(
      n,
      n.getTime() - _u(n) - i
    );
  }
}
class q4 extends Vt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 10);
    qe(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(n, r) {
    switch (r) {
      case "x":
        return ko(
          Ro.basicOptionalMinutes,
          n
        );
      case "xx":
        return ko(Ro.basic, n);
      case "xxxx":
        return ko(
          Ro.basicOptionalSeconds,
          n
        );
      case "xxxxx":
        return ko(
          Ro.extendedOptionalSeconds,
          n
        );
      case "xxx":
      default:
        return ko(Ro.extended, n);
    }
  }
  set(n, r, i) {
    return r.timestampIsSet ? n : hn(
      n,
      n.getTime() - _u(n) - i
    );
  }
}
class H4 extends Vt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 40);
    qe(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return CS(n);
  }
  set(n, r, i) {
    return [hn(n, i * 1e3), { timestampIsSet: !0 }];
  }
}
class U4 extends Vt {
  constructor() {
    super(...arguments);
    qe(this, "priority", 20);
    qe(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return CS(n);
  }
  set(n, r, i) {
    return [hn(n, i), { timestampIsSet: !0 }];
  }
}
const Y4 = {
  G: new d4(),
  y: new p4(),
  Y: new f4(),
  R: new m4(),
  u: new h4(),
  Q: new g4(),
  q: new y4(),
  M: new b4(),
  L: new v4(),
  w: new w4(),
  I: new S4(),
  d: new E4(),
  D: new R4(),
  E: new k4(),
  e: new P4(),
  c: new D4(),
  i: new _4(),
  a: new I4(),
  b: new j4(),
  B: new $4(),
  h: new A4(),
  H: new N4(),
  K: new F4(),
  k: new L4(),
  m: new B4(),
  s: new V4(),
  S: new z4(),
  X: new W4(),
  x: new q4(),
  t: new H4(),
  T: new U4()
}, G4 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, K4 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, X4 = /^'([^]*?)'?$/, Q4 = /''/g, Z4 = /\S/, J4 = /[a-zA-Z]/;
function e3(e, t, n, r) {
  var S, O, P, k, R, E, M, _;
  const i = () => hn((r == null ? void 0 : r.in) || n, NaN), a = QW(), l = (r == null ? void 0 : r.locale) ?? a.locale ?? jd, u = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((O = (S = r == null ? void 0 : r.locale) == null ? void 0 : S.options) == null ? void 0 : O.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((k = (P = a.locale) == null ? void 0 : P.options) == null ? void 0 : k.firstWeekContainsDate) ?? 1, d = (r == null ? void 0 : r.weekStartsOn) ?? ((E = (R = r == null ? void 0 : r.locale) == null ? void 0 : R.options) == null ? void 0 : E.weekStartsOn) ?? a.weekStartsOn ?? ((_ = (M = a.locale) == null ? void 0 : M.options) == null ? void 0 : _.weekStartsOn) ?? 0;
  if (!t)
    return e ? i() : rt(n, r == null ? void 0 : r.in);
  const p = {
    firstWeekContainsDate: u,
    weekStartsOn: d,
    locale: l
  }, m = [new u4(r == null ? void 0 : r.in, n)], h = t.match(K4).map((I) => {
    const F = I[0];
    if (F in Cl) {
      const T = Cl[F];
      return T(I, l.formatLong);
    }
    return I;
  }).join("").match(G4), g = [];
  for (let I of h) {
    !(r != null && r.useAdditionalWeekYearTokens) && vS(I) && Um(I, t, e), !(r != null && r.useAdditionalDayOfYearTokens) && bS(I) && Um(I, t, e);
    const F = I[0], T = Y4[F];
    if (T) {
      const { incompatibleTokens: $ } = T;
      if (Array.isArray($)) {
        const W = g.find(
          (L) => $.includes(L.token) || L.token === F
        );
        if (W)
          throw new RangeError(
            `The format string mustn't contain \`${W.fullToken}\` and \`${I}\` at the same time`
          );
      } else if (T.incompatibleTokens === "*" && g.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${I}\` and any other token at the same time`
        );
      g.push({ token: F, fullToken: I });
      const N = T.run(
        e,
        I,
        l.match,
        p
      );
      if (!N)
        return i();
      m.push(N.setter), e = N.rest;
    } else {
      if (F.match(J4))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + F + "`"
        );
      if (I === "''" ? I = "'" : F === "'" && (I = t3(I)), e.indexOf(I) === 0)
        e = e.slice(I.length);
      else
        return i();
    }
  }
  if (e.length > 0 && Z4.test(e))
    return i();
  const v = m.map((I) => I.priority).sort((I, F) => F - I).filter((I, F, T) => T.indexOf(I) === F).map(
    (I) => m.filter((F) => F.priority === I).sort((F, T) => T.subPriority - F.subPriority)
  ).map((I) => I[0]);
  let b = rt(n, r == null ? void 0 : r.in);
  if (isNaN(+b)) return i();
  const y = {};
  for (const I of v) {
    if (!I.validate(b, p))
      return i();
    const F = I.set(b, y, p);
    Array.isArray(F) ? (b = F[0], Object.assign(y, F[1])) : b = F;
  }
  return b;
}
function t3(e) {
  return e.match(X4)[1].replace(Q4, "'");
}
function d0(e, t) {
  const n = rt(e, t == null ? void 0 : t.in);
  return n.setMinutes(0, 0, 0), n;
}
function n3(e, t, n) {
  const [r, i] = Hl(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return +d0(r) == +d0(i);
}
function r3(e, t, n) {
  const [r, i] = Hl(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === i.getFullYear() && r.getMonth() === i.getMonth();
}
function o3(e, t, n) {
  const [r, i] = Hl(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === i.getFullYear();
}
function i3(e, t, n) {
  const r = +rt(e, n == null ? void 0 : n.in), [i, a] = [
    +rt(t.start, n == null ? void 0 : n.in),
    +rt(t.end, n == null ? void 0 : n.in)
  ].sort((l, u) => l - u);
  return r >= i && r <= a;
}
function p0(e, t, n) {
  return Ii(e, -t, n);
}
function a3(e, t, n) {
  const r = rt(e, n == null ? void 0 : n.in), i = r.getFullYear(), a = r.getDate(), l = hn(e, 0);
  l.setFullYear(i, t, 15), l.setHours(0, 0, 0, 0);
  const u = xS(l);
  return r.setMonth(t, Math.min(a, u)), r;
}
function s3(e, t, n) {
  const r = rt(e, n == null ? void 0 : n.in);
  return r.setDate(t), r;
}
function l3(e, t, n) {
  const r = rt(e, n == null ? void 0 : n.in);
  return r.setHours(t), r;
}
function c3(e, t, n) {
  const r = rt(e, n == null ? void 0 : n.in);
  return r.setMilliseconds(t), r;
}
function u3(e, t, n) {
  const r = rt(e, n == null ? void 0 : n.in);
  return r.setMinutes(t), r;
}
function d3(e, t, n) {
  const r = rt(e, n == null ? void 0 : n.in);
  return r.setSeconds(t), r;
}
function p3(e, t, n) {
  const r = rt(e, n == null ? void 0 : n.in);
  return isNaN(+r) ? hn(e, NaN) : (r.setFullYear(t), r);
}
function f0(e, t, n) {
  return xl(e, -t, n);
}
function m0(e, t, n) {
  return Iu(e, -t, n);
}
function h0(e, t, n) {
  return ju(e, -t, n);
}
const f3 = ["localeText"], Nu = /* @__PURE__ */ w.createContext(null);
process.env.NODE_ENV !== "production" && (Nu.displayName = "MuiPickersAdapterContext");
const mg = function(t) {
  const {
    localeText: n
  } = t, r = ht(t, f3), {
    utils: i,
    localeText: a
  } = w.useContext(Nu) ?? {
    utils: void 0,
    localeText: void 0
  }, l = cn({
    // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
    // We will then merge this theme value with our value manually
    props: r,
    name: "MuiLocalizationProvider"
  }), {
    children: u,
    dateAdapter: d,
    dateFormats: p,
    dateLibInstance: m,
    adapterLocale: h,
    localeText: g
  } = l, v = w.useMemo(() => J({}, g, a, n), [g, a, n]), b = w.useMemo(() => {
    if (!d)
      return i || null;
    const O = new d({
      locale: h,
      formats: p,
      instance: m
    });
    if (!O.isMUIAdapter)
      throw new Error(["MUI X: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`", "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`", "More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation"].join(`
`));
    return O;
  }, [d, h, p, m, i]), y = w.useMemo(() => b ? {
    minDate: b.date("1900-01-01T00:00:00.000"),
    maxDate: b.date("2099-12-31T00:00:00.000")
  } : null, [b]), S = w.useMemo(() => ({
    utils: b,
    defaultDates: y,
    localeText: v
  }), [y, b, v]);
  return /* @__PURE__ */ x.jsx(Nu.Provider, {
    value: S,
    children: u
  });
};
process.env.NODE_ENV !== "production" && (mg.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Locale for the date library you are using
   */
  adapterLocale: o.any,
  children: o.node,
  /**
   * Date library adapter class function.
   * @see See the localization provider {@link https://mui.com/x/react-date-pickers/getting-started/#setup-your-date-library-adapter date adapter setup section} for more details.
   */
  dateAdapter: o.func,
  /**
   * Formats that are used for any child pickers
   */
  dateFormats: o.shape({
    dayOfMonth: o.string,
    dayOfMonthFull: o.string,
    fullDate: o.string,
    fullTime: o.string,
    fullTime12h: o.string,
    fullTime24h: o.string,
    hours12h: o.string,
    hours24h: o.string,
    keyboardDate: o.string,
    keyboardDateTime: o.string,
    keyboardDateTime12h: o.string,
    keyboardDateTime24h: o.string,
    meridiem: o.string,
    minutes: o.string,
    month: o.string,
    monthShort: o.string,
    normalDate: o.string,
    normalDateWithWeekday: o.string,
    seconds: o.string,
    shortDate: o.string,
    weekday: o.string,
    weekdayShort: o.string,
    year: o.string
  }),
  /**
   * Date library instance you are using, if it has some global overrides
   * ```jsx
   * dateLibInstance={momentTimeZone}
   * ```
   */
  dateLibInstance: o.any,
  /**
   * Locale for components texts
   */
  localeText: o.object
});
const m3 = (e) => ({
  components: {
    MuiLocalizationProvider: {
      defaultProps: {
        localeText: J({}, e)
      }
    }
  }
}), TS = (e) => {
  const {
    utils: t,
    formatKey: n,
    contextTranslation: r,
    propsTranslation: i
  } = e;
  return (a) => {
    const l = a !== null && t.isValid(a) ? t.format(a, n) : null;
    return (i ?? r)(a, t, l);
  };
}, ES = {
  // Calendar navigation
  previousMonth: "Previous month",
  nextMonth: "Next month",
  // View navigation
  openPreviousView: "Open previous view",
  openNextView: "Open next view",
  calendarViewSwitchingButtonAriaLabel: (e) => e === "year" ? "year view is open, switch to calendar view" : "calendar view is open, switch to year view",
  // DateRange labels
  start: "Start",
  end: "End",
  startDate: "Start date",
  startTime: "Start time",
  endDate: "End date",
  endTime: "End time",
  // Action bar
  cancelButtonLabel: "Cancel",
  clearButtonLabel: "Clear",
  okButtonLabel: "OK",
  todayButtonLabel: "Today",
  // Toolbar titles
  datePickerToolbarTitle: "Select date",
  dateTimePickerToolbarTitle: "Select date & time",
  timePickerToolbarTitle: "Select time",
  dateRangePickerToolbarTitle: "Select date range",
  // Clock labels
  clockLabelText: (e, t, n, r) => `Select ${e}. ${!r && (t === null || !n.isValid(t)) ? "No time selected" : `Selected time is ${r ?? n.format(t, "fullTime")}`}`,
  hoursClockNumberText: (e) => `${e} hours`,
  minutesClockNumberText: (e) => `${e} minutes`,
  secondsClockNumberText: (e) => `${e} seconds`,
  // Digital clock labels
  selectViewText: (e) => `Select ${e}`,
  // Calendar labels
  calendarWeekNumberHeaderLabel: "Week number",
  calendarWeekNumberHeaderText: "#",
  calendarWeekNumberAriaLabelText: (e) => `Week ${e}`,
  calendarWeekNumberText: (e) => `${e}`,
  // Open picker labels
  openDatePickerDialogue: (e, t, n) => n || e !== null && t.isValid(e) ? `Choose date, selected date is ${n ?? t.format(e, "fullDate")}` : "Choose date",
  openTimePickerDialogue: (e, t, n) => n || e !== null && t.isValid(e) ? `Choose time, selected time is ${n ?? t.format(e, "fullTime")}` : "Choose time",
  fieldClearLabel: "Clear",
  // Table labels
  timeTableLabel: "pick time",
  dateTableLabel: "pick date",
  // Field section placeholders
  fieldYearPlaceholder: (e) => "Y".repeat(e.digitAmount),
  fieldMonthPlaceholder: (e) => e.contentType === "letter" ? "MMMM" : "MM",
  fieldDayPlaceholder: () => "DD",
  fieldWeekDayPlaceholder: (e) => e.contentType === "letter" ? "EEEE" : "EE",
  fieldHoursPlaceholder: () => "hh",
  fieldMinutesPlaceholder: () => "mm",
  fieldSecondsPlaceholder: () => "ss",
  fieldMeridiemPlaceholder: () => "aa",
  // View names
  year: "Year",
  month: "Month",
  day: "Day",
  weekDay: "Week day",
  hours: "Hours",
  minutes: "Minutes",
  seconds: "Seconds",
  meridiem: "Meridiem",
  // Common
  empty: "Empty"
}, h3 = ES;
m3(ES);
const ya = () => {
  const e = w.useContext(Nu);
  if (e === null)
    throw new Error(["MUI X: Can not find the date and time pickers localization context.", "It looks like you forgot to wrap your component in LocalizationProvider.", "This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package"].join(`
`));
  if (e.utils === null)
    throw new Error(["MUI X: Can not find the date and time pickers adapter from its localization context.", "It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider."].join(`
`));
  const t = w.useMemo(() => J({}, h3, e.localeText), [e.localeText]);
  return w.useMemo(() => J({}, e, {
    localeText: t
  }), [e, t]);
}, un = () => ya().utils, Ul = () => ya().defaultDates, $d = (e) => {
  const t = un(), n = w.useRef(void 0);
  return n.current === void 0 && (n.current = t.date(void 0, e)), n.current;
}, si = () => ya().localeText, g3 = rn(/* @__PURE__ */ x.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown"), y3 = rn(/* @__PURE__ */ x.jsx("path", {
  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), "ArrowLeft"), b3 = rn(/* @__PURE__ */ x.jsx("path", {
  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "ArrowRight"), v3 = rn(/* @__PURE__ */ x.jsx("path", {
  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), "Calendar");
rn(/* @__PURE__ */ x.jsxs(w.Fragment, {
  children: [/* @__PURE__ */ x.jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ x.jsx("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Clock");
rn(/* @__PURE__ */ x.jsx("path", {
  d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), "DateRange");
rn(/* @__PURE__ */ x.jsxs(w.Fragment, {
  children: [/* @__PURE__ */ x.jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ x.jsx("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Time");
const x3 = rn(/* @__PURE__ */ x.jsx("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear");
function w3(e) {
  return ze("MuiPickersArrowSwitcher", e);
}
Ve("MuiPickersArrowSwitcher", ["root", "spacer", "button", "previousIconButton", "nextIconButton", "leftArrowIcon", "rightArrowIcon"]);
const C3 = ["children", "className", "slots", "slotProps", "isNextDisabled", "isNextHidden", "onGoToNext", "nextLabel", "isPreviousDisabled", "isPreviousHidden", "onGoToPrevious", "previousLabel", "labelId"], S3 = ["ownerState"], O3 = ["ownerState"], T3 = ae("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex"
}), E3 = ae("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Spacer",
  overridesResolver: (e, t) => t.spacer
})(({
  theme: e
}) => ({
  width: e.spacing(3)
})), g0 = ae(Ai, {
  name: "MuiPickersArrowSwitcher",
  slot: "Button",
  overridesResolver: (e, t) => t.button
})({
  variants: [{
    props: {
      hidden: !0
    },
    style: {
      visibility: "hidden"
    }
  }]
}), R3 = (e) => {
  const {
    classes: t
  } = e;
  return We({
    root: ["root"],
    spacer: ["spacer"],
    button: ["button"],
    previousIconButton: ["previousIconButton"],
    nextIconButton: ["nextIconButton"],
    leftArrowIcon: ["leftArrowIcon"],
    rightArrowIcon: ["rightArrowIcon"]
  }, w3, t);
}, k3 = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = eo(), i = cn({
    props: t,
    name: "MuiPickersArrowSwitcher"
  }), {
    children: a,
    className: l,
    slots: u,
    slotProps: d,
    isNextDisabled: p,
    isNextHidden: m,
    onGoToNext: h,
    nextLabel: g,
    isPreviousDisabled: v,
    isPreviousHidden: b,
    onGoToPrevious: y,
    previousLabel: S,
    labelId: O
  } = i, P = ht(i, C3), k = i, R = R3(k), E = {
    isDisabled: p,
    isHidden: m,
    goTo: h,
    label: g
  }, M = {
    isDisabled: v,
    isHidden: b,
    goTo: y,
    label: S
  }, _ = (u == null ? void 0 : u.previousIconButton) ?? g0, I = Nt({
    elementType: _,
    externalSlotProps: d == null ? void 0 : d.previousIconButton,
    additionalProps: {
      size: "medium",
      title: M.label,
      "aria-label": M.label,
      disabled: M.isDisabled,
      edge: "end",
      onClick: M.goTo
    },
    ownerState: J({}, k, {
      hidden: M.isHidden
    }),
    className: Me(R.button, R.previousIconButton)
  }), F = (u == null ? void 0 : u.nextIconButton) ?? g0, T = Nt({
    elementType: F,
    externalSlotProps: d == null ? void 0 : d.nextIconButton,
    additionalProps: {
      size: "medium",
      title: E.label,
      "aria-label": E.label,
      disabled: E.isDisabled,
      edge: "start",
      onClick: E.goTo
    },
    ownerState: J({}, k, {
      hidden: E.isHidden
    }),
    className: Me(R.button, R.nextIconButton)
  }), $ = (u == null ? void 0 : u.leftArrowIcon) ?? y3, N = Nt({
    elementType: $,
    externalSlotProps: d == null ? void 0 : d.leftArrowIcon,
    additionalProps: {
      fontSize: "inherit"
    },
    ownerState: k,
    className: R.leftArrowIcon
  }), W = ht(N, S3), L = (u == null ? void 0 : u.rightArrowIcon) ?? b3, V = Nt({
    elementType: L,
    externalSlotProps: d == null ? void 0 : d.rightArrowIcon,
    additionalProps: {
      fontSize: "inherit"
    },
    ownerState: k,
    className: R.rightArrowIcon
  }), z = ht(V, O3);
  return /* @__PURE__ */ x.jsxs(T3, J({
    ref: n,
    className: Me(R.root, l),
    ownerState: k
  }, P, {
    children: [/* @__PURE__ */ x.jsx(_, J({}, I, {
      children: r ? /* @__PURE__ */ x.jsx(L, J({}, z)) : /* @__PURE__ */ x.jsx($, J({}, W))
    })), a ? /* @__PURE__ */ x.jsx(at, {
      variant: "subtitle1",
      component: "span",
      id: O,
      children: a
    }) : /* @__PURE__ */ x.jsx(E3, {
      className: R.spacer,
      ownerState: k
    }), /* @__PURE__ */ x.jsx(F, J({}, T, {
      children: r ? /* @__PURE__ */ x.jsx($, J({}, W)) : /* @__PURE__ */ x.jsx(L, J({}, z))
    }))]
  }));
}), Hs = (e, t) => e.length !== t.length ? !1 : t.every((n) => e.includes(n)), P3 = ({
  openTo: e,
  defaultOpenTo: t,
  views: n,
  defaultViews: r
}) => {
  const i = n ?? r;
  let a;
  if (e != null)
    a = e;
  else if (i.includes(t))
    a = t;
  else if (i.length > 0)
    a = i[0];
  else
    throw new Error("MUI X: The `views` prop must contain at least one view.");
  return {
    views: i,
    openTo: a
  };
}, D3 = ["hours", "minutes", "seconds"], M3 = (e) => D3.includes(e), y0 = (e, t) => t.getHours(e) * 3600 + t.getMinutes(e) * 60 + t.getSeconds(e), _3 = (e, t) => (n, r) => e ? t.isAfter(n, r) : y0(n, t) > y0(r, t);
let xm = !1;
function RS({
  onChange: e,
  onViewChange: t,
  openTo: n,
  view: r,
  views: i,
  autoFocus: a,
  focusedView: l,
  onFocusedViewChange: u
}) {
  process.env.NODE_ENV !== "production" && (xm || (r != null && !i.includes(r) && (console.warn(`MUI X: \`view="${r}"\` is not a valid prop.`, `It must be an element of \`views=["${i.join('", "')}"]\`.`), xm = !0), r == null && n != null && !i.includes(n) && (console.warn(`MUI X: \`openTo="${n}"\` is not a valid prop.`, `It must be an element of \`views=["${i.join('", "')}"]\`.`), xm = !0)));
  const d = w.useRef(n), p = w.useRef(i), m = w.useRef(i.includes(n) ? n : i[0]), [h, g] = or({
    name: "useViews",
    state: "view",
    controlled: r,
    default: m.current
  }), v = w.useRef(a ? h : null), [b, y] = or({
    name: "useViews",
    state: "focusedView",
    controlled: l,
    default: v.current
  });
  w.useEffect(() => {
    (d.current && d.current !== n || p.current && p.current.some((_) => !i.includes(_))) && (g(i.includes(n) ? n : i[0]), p.current = i, d.current = n);
  }, [n, g, h, i]);
  const S = i.indexOf(h), O = i[S - 1] ?? null, P = i[S + 1] ?? null, k = Le((_, I) => {
    y(I ? _ : (F) => _ === F ? null : F), u == null || u(_, I);
  }), R = Le((_) => {
    k(_, !0), _ !== h && (g(_), t && t(_));
  }), E = Le(() => {
    P && R(P);
  }), M = Le((_, I, F) => {
    const T = I === "finish", $ = F ? (
      // handles case like `DateTimePicker`, where a view might return a `finish` selection state
      // but when it's not the final view given all `views` -> overall selection state should be `partial`.
      i.indexOf(F) < i.length - 1
    ) : !!P;
    if (e(_, T && $ ? "partial" : I, F), F && F !== h) {
      const W = i[i.indexOf(F) + 1];
      W && R(W);
    } else T && E();
  });
  return {
    view: h,
    setView: R,
    focusedView: b,
    setFocusedView: k,
    nextView: P,
    previousView: O,
    // Always return up-to-date default view instead of the initial one (i.e. defaultView.current)
    defaultView: i.includes(n) ? n : i[0],
    goToNextView: E,
    setValueAndGoToNextView: M
  };
}
function I3(e, {
  disableFuture: t,
  maxDate: n,
  timezone: r
}) {
  const i = un();
  return w.useMemo(() => {
    const a = i.date(void 0, r), l = i.startOfMonth(t && i.isBefore(a, n) ? a : n);
    return !i.isAfter(l, e);
  }, [t, n, e, i, r]);
}
function j3(e, {
  disablePast: t,
  minDate: n,
  timezone: r
}) {
  const i = un();
  return w.useMemo(() => {
    const a = i.date(void 0, r), l = i.startOfMonth(t && i.isAfter(a, n) ? a : n);
    return !i.isBefore(l, e);
  }, [t, n, e, i, r]);
}
const Sl = 36, Ad = 2, Nd = 320, $3 = 280, hg = 336, A3 = ae("div")({
  overflow: "hidden",
  width: Nd,
  maxHeight: hg,
  display: "flex",
  flexDirection: "column",
  margin: "0 auto"
}), Fu = (e, t, n) => {
  let r = t;
  return r = e.setHours(r, e.getHours(n)), r = e.setMinutes(r, e.getMinutes(n)), r = e.setSeconds(r, e.getSeconds(n)), r = e.setMilliseconds(r, e.getMilliseconds(n)), r;
}, sl = ({
  date: e,
  disableFuture: t,
  disablePast: n,
  maxDate: r,
  minDate: i,
  isDateDisabled: a,
  utils: l,
  timezone: u
}) => {
  const d = Fu(l, l.date(void 0, u), e);
  n && l.isBefore(i, d) && (i = d), t && l.isAfter(r, d) && (r = d);
  let p = e, m = e;
  for (l.isBefore(e, i) && (p = i, m = null), l.isAfter(e, r) && (m && (m = r), p = null); p || m; ) {
    if (p && l.isAfter(p, r) && (p = null), m && l.isBefore(m, i) && (m = null), p) {
      if (!a(p))
        return p;
      p = l.addDays(p, 1);
    }
    if (m) {
      if (!a(m))
        return m;
      m = l.addDays(m, -1);
    }
  }
  return null;
}, N3 = (e, t) => t == null || !e.isValid(t) ? null : t, Zr = (e, t, n) => t == null || !e.isValid(t) ? n : t, F3 = (e, t, n) => !e.isValid(t) && t != null && !e.isValid(n) && n != null ? !0 : e.isEqual(t, n), gg = (e, t) => {
  const r = [e.startOfYear(t)];
  for (; r.length < 12; ) {
    const i = r[r.length - 1];
    r.push(e.addMonths(i, 1));
  }
  return r;
}, kS = (e, t, n) => n === "date" ? e.startOfDay(e.date(void 0, t)) : e.date(void 0, t), L3 = ["year", "month", "day"], b0 = (e) => L3.includes(e), yg = (e, {
  format: t,
  views: n
}, r) => {
  if (t != null)
    return t;
  const i = e.formats;
  return Hs(n, ["year"]) ? i.year : Hs(n, ["month"]) ? i.month : Hs(n, ["day"]) ? i.dayOfMonth : Hs(n, ["month", "year"]) ? `${i.month} ${i.year}` : Hs(n, ["day", "month"]) ? `${i.month} ${i.dayOfMonth}` : r ? /en/.test(e.getCurrentLocaleCode()) ? i.normalDateWithWeekday : i.normalDate : i.keyboardDate;
}, B3 = (e, t) => {
  const n = e.startOfWeek(t);
  return [0, 1, 2, 3, 4, 5, 6].map((r) => e.addDays(n, r));
}, bg = ({
  timezone: e,
  value: t,
  defaultValue: n,
  referenceDate: r,
  onChange: i,
  valueManager: a
}) => {
  const l = un(), u = w.useRef(n), d = t ?? u.current ?? a.emptyValue, p = w.useMemo(() => a.getTimezone(l, d), [l, a, d]), m = Le((b) => p == null ? b : a.setTimezone(l, p, b));
  let h;
  e ? h = e : p ? h = p : r ? h = l.getTimezone(r) : h = "default";
  const g = w.useMemo(() => a.setTimezone(l, h, d), [a, l, h, d]), v = Le((b, ...y) => {
    const S = m(b);
    i == null || i(S, ...y);
  });
  return {
    value: g,
    handleValueChange: v,
    timezone: h
  };
}, vg = ({
  name: e,
  timezone: t,
  value: n,
  defaultValue: r,
  referenceDate: i,
  onChange: a,
  valueManager: l
}) => {
  const [u, d] = or({
    name: e,
    state: "value",
    controlled: n,
    default: r ?? l.emptyValue
  }), p = Le((m, ...h) => {
    d(m), a == null || a(m, ...h);
  });
  return bg({
    timezone: t,
    value: u,
    defaultValue: void 0,
    referenceDate: i,
    onChange: p,
    valueManager: l
  });
}, To = {
  year: 1,
  month: 2,
  day: 3,
  hours: 4,
  minutes: 5,
  seconds: 6,
  milliseconds: 7
}, V3 = (e) => Math.max(...e.map((t) => To[t.type] ?? 1)), Us = (e, t, n) => {
  if (t === To.year)
    return e.startOfYear(n);
  if (t === To.month)
    return e.startOfMonth(n);
  if (t === To.day)
    return e.startOfDay(n);
  let r = n;
  return t < To.minutes && (r = e.setMinutes(r, 0)), t < To.seconds && (r = e.setSeconds(r, 0)), t < To.milliseconds && (r = e.setMilliseconds(r, 0)), r;
}, z3 = ({
  props: e,
  utils: t,
  granularity: n,
  timezone: r,
  getTodayDate: i
}) => {
  let a = i ? i() : Us(t, n, kS(t, r));
  e.minDate != null && t.isAfterDay(e.minDate, a) && (a = Us(t, n, e.minDate)), e.maxDate != null && t.isBeforeDay(e.maxDate, a) && (a = Us(t, n, e.maxDate));
  const l = _3(e.disableIgnoringDatePartForTimeValidation ?? !1, t);
  return e.minTime != null && l(e.minTime, a) && (a = Us(t, n, e.disableIgnoringDatePartForTimeValidation ? e.minTime : Fu(t, a, e.minTime))), e.maxTime != null && l(a, e.maxTime) && (a = Us(t, n, e.disableIgnoringDatePartForTimeValidation ? e.maxTime : Fu(t, a, e.maxTime))), a;
}, xg = (e, t) => {
  const n = e.formatTokenMap[t];
  if (n == null)
    throw new Error([`MUI X: The token "${t}" is not supported by the Date and Time Pickers.`, "Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported."].join(`
`));
  return typeof n == "string" ? {
    type: n,
    contentType: n === "meridiem" ? "letter" : "digit",
    maxLength: void 0
  } : {
    type: n.sectionType,
    contentType: n.contentType,
    maxLength: n.maxLength
  };
}, W3 = (e) => {
  switch (e) {
    case "ArrowUp":
      return 1;
    case "ArrowDown":
      return -1;
    case "PageUp":
      return 5;
    case "PageDown":
      return -5;
    default:
      return 0;
  }
}, Fd = (e, t) => {
  const n = [], r = e.date(void 0, "default"), i = e.startOfWeek(r), a = e.endOfWeek(r);
  let l = i;
  for (; e.isBefore(l, a); )
    n.push(l), l = e.addDays(l, 1);
  return n.map((u) => e.formatByString(u, t));
}, PS = (e, t, n, r) => {
  switch (n) {
    case "month":
      return gg(e, e.date(void 0, t)).map((i) => e.formatByString(i, r));
    case "weekDay":
      return Fd(e, r);
    case "meridiem": {
      const i = e.date(void 0, t);
      return [e.startOfDay(i), e.endOfDay(i)].map((a) => e.formatByString(a, r));
    }
    default:
      return [];
  }
}, v0 = "s", q3 = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"], H3 = (e) => {
  const t = e.date(void 0);
  return e.formatByString(e.setSeconds(t, 0), v0) === "0" ? q3 : Array.from({
    length: 10
  }).map((r, i) => e.formatByString(e.setSeconds(t, i), v0));
}, ma = (e, t) => {
  if (t[0] === "0")
    return e;
  const n = [];
  let r = "";
  for (let i = 0; i < e.length; i += 1) {
    r += e[i];
    const a = t.indexOf(r);
    a > -1 && (n.push(a.toString()), r = "");
  }
  return n.join("");
}, wg = (e, t) => t[0] === "0" ? e : e.split("").map((n) => t[Number(n)]).join(""), x0 = (e, t) => {
  const n = ma(e, t);
  return n !== " " && !Number.isNaN(Number(n));
}, DS = (e, t) => {
  let n = e;
  for (n = Number(n).toString(); n.length < t; )
    n = `0${n}`;
  return n;
}, MS = (e, t, n, r, i) => {
  if (process.env.NODE_ENV !== "production" && i.type !== "day" && i.contentType === "digit-with-letter")
    throw new Error([`MUI X: The token "${i.format}" is a digit format with letter in it.'
             This type of format is only supported for 'day' sections`].join(`
`));
  if (i.type === "day" && i.contentType === "digit-with-letter") {
    const l = e.setDate(n.longestMonth, t);
    return e.formatByString(l, i.format);
  }
  let a = t.toString();
  return i.hasLeadingZerosInInput && (a = DS(a, i.maxLength)), wg(a, r);
}, U3 = (e, t, n, r, i, a, l, u) => {
  const d = W3(r), p = r === "Home", m = r === "End", h = n.value === "" || p || m, g = () => {
    const b = i[n.type]({
      currentDate: l,
      format: n.format,
      contentType: n.contentType
    }), y = (k) => MS(e, k, b, a, n), S = n.type === "minutes" && (u != null && u.minutesStep) ? u.minutesStep : 1;
    let P = parseInt(ma(n.value, a), 10) + d * S;
    if (h) {
      if (n.type === "year" && !m && !p)
        return e.formatByString(e.date(void 0, t), n.format);
      d > 0 || p ? P = b.minimum : P = b.maximum;
    }
    return P % S !== 0 && ((d < 0 || p) && (P += S - (S + P) % S), (d > 0 || m) && (P -= P % S)), P > b.maximum ? y(b.minimum + (P - b.maximum - 1) % (b.maximum - b.minimum + 1)) : P < b.minimum ? y(b.maximum - (b.minimum - P - 1) % (b.maximum - b.minimum + 1)) : y(P);
  }, v = () => {
    const b = PS(e, t, n.type, n.format);
    if (b.length === 0)
      return n.value;
    if (h)
      return d > 0 || p ? b[0] : b[b.length - 1];
    const O = ((b.indexOf(n.value) + d) % b.length + b.length) % b.length;
    return b[O];
  };
  return n.contentType === "digit" || n.contentType === "digit-with-letter" ? g() : v();
}, Cg = (e, t, n) => {
  let r = e.value || e.placeholder;
  const i = t === "non-input" ? e.hasLeadingZerosInFormat : e.hasLeadingZerosInInput;
  return t === "non-input" && e.hasLeadingZerosInInput && !e.hasLeadingZerosInFormat && (r = Number(ma(r, n)).toString()), ["input-rtl", "input-ltr"].includes(t) && e.contentType === "digit" && !i && r.length === 1 && (r = `${r}‎`), t === "input-rtl" && (r = `⁨${r}⁩`), r;
}, w0 = (e, t, n, r) => {
  if (process.env.NODE_ENV !== "production" && xg(e, n).type === "weekDay")
    throw new Error("changeSectionValueFormat doesn't support week day formats");
  return e.formatByString(e.parse(t, n), r);
}, _S = (e, t) => e.formatByString(e.date(void 0, "system"), t).length === 4, IS = (e, t, n, r) => {
  if (t !== "digit")
    return !1;
  const i = e.date(void 0, "default");
  switch (n) {
    // We can't use `changeSectionValueFormat`, because  `utils.parse('1', 'YYYY')` returns `1971` instead of `1`.
    case "year":
      return _S(e, r) ? e.formatByString(e.setYear(i, 1), r) === "0001" : e.formatByString(e.setYear(i, 2001), r) === "01";
    case "month":
      return e.formatByString(e.startOfYear(i), r).length > 1;
    case "day":
      return e.formatByString(e.startOfMonth(i), r).length > 1;
    case "weekDay":
      return e.formatByString(e.startOfWeek(i), r).length > 1;
    case "hours":
      return e.formatByString(e.setHours(i, 1), r).length > 1;
    case "minutes":
      return e.formatByString(e.setMinutes(i, 1), r).length > 1;
    case "seconds":
      return e.formatByString(e.setSeconds(i, 1), r).length > 1;
    default:
      throw new Error("Invalid section type");
  }
}, Y3 = (e, t, n) => {
  const r = t.some((d) => d.type === "day"), i = [], a = [];
  for (let d = 0; d < t.length; d += 1) {
    const p = t[d];
    r && p.type === "weekDay" || (i.push(p.format), a.push(Cg(p, "non-input", n)));
  }
  const l = i.join(" "), u = a.join(" ");
  return e.parse(u, l);
}, G3 = (e) => e.map((t) => `${t.startSeparator}${t.value || t.placeholder}${t.endSeparator}`).join(""), K3 = (e, t, n) => {
  const i = e.map((a) => {
    const l = Cg(a, n ? "input-rtl" : "input-ltr", t);
    return `${a.startSeparator}${l}${a.endSeparator}`;
  }).join("");
  return n ? `⁦${i}⁩` : i;
}, X3 = (e, t, n) => {
  const r = e.date(void 0, n), i = e.endOfYear(r), a = e.endOfDay(r), {
    maxDaysInMonth: l,
    longestMonth: u
  } = gg(e, r).reduce((d, p) => {
    const m = e.getDaysInMonth(p);
    return m > d.maxDaysInMonth ? {
      maxDaysInMonth: m,
      longestMonth: p
    } : d;
  }, {
    maxDaysInMonth: 0,
    longestMonth: null
  });
  return {
    year: ({
      format: d
    }) => ({
      minimum: 0,
      maximum: _S(e, d) ? 9999 : 99
    }),
    month: () => ({
      minimum: 1,
      // Assumption: All years have the same amount of months
      maximum: e.getMonth(i) + 1
    }),
    day: ({
      currentDate: d
    }) => ({
      minimum: 1,
      maximum: d != null && e.isValid(d) ? e.getDaysInMonth(d) : l,
      longestMonth: u
    }),
    weekDay: ({
      format: d,
      contentType: p
    }) => {
      if (p === "digit") {
        const m = Fd(e, d).map(Number);
        return {
          minimum: Math.min(...m),
          maximum: Math.max(...m)
        };
      }
      return {
        minimum: 1,
        maximum: 7
      };
    },
    hours: ({
      format: d
    }) => {
      const p = e.getHours(a);
      return ma(e.formatByString(e.endOfDay(r), d), t) !== p.toString() ? {
        minimum: 1,
        maximum: Number(ma(e.formatByString(e.startOfDay(r), d), t))
      } : {
        minimum: 0,
        maximum: p
      };
    },
    minutes: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of minutes
      maximum: e.getMinutes(a)
    }),
    seconds: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of seconds
      maximum: e.getSeconds(a)
    }),
    meridiem: () => ({
      minimum: 0,
      maximum: 1
    }),
    empty: () => ({
      minimum: 0,
      maximum: 0
    })
  };
};
let C0 = !1;
const S0 = (e, t) => {
  if (process.env.NODE_ENV !== "production" && !C0) {
    const n = ["empty"];
    ["date", "date-time"].includes(t) && n.push("weekDay", "day", "month", "year"), ["time", "date-time"].includes(t) && n.push("hours", "minutes", "seconds", "meridiem");
    const r = e.find((i) => !n.includes(i.type));
    r && (console.warn(`MUI X: The field component you are using is not compatible with the "${r.type}" date section.`, `The supported date sections are ["${n.join('", "')}"]\`.`), C0 = !0);
  }
}, Q3 = (e, t, n, r) => {
  switch (t.type) {
    case "year":
      return e.setYear(r, e.getYear(n));
    case "month":
      return e.setMonth(r, e.getMonth(n));
    case "weekDay": {
      const i = Fd(e, t.format), a = e.formatByString(n, t.format), l = i.indexOf(a), d = i.indexOf(t.value) - l;
      return e.addDays(n, d);
    }
    case "day":
      return e.setDate(r, e.getDate(n));
    case "meridiem": {
      const i = e.getHours(n) < 12, a = e.getHours(r);
      return i && a >= 12 ? e.addHours(r, -12) : !i && a < 12 ? e.addHours(r, 12) : r;
    }
    case "hours":
      return e.setHours(r, e.getHours(n));
    case "minutes":
      return e.setMinutes(r, e.getMinutes(n));
    case "seconds":
      return e.setSeconds(r, e.getSeconds(n));
    default:
      return r;
  }
}, O0 = {
  year: 1,
  month: 2,
  day: 3,
  weekDay: 4,
  hours: 5,
  minutes: 6,
  seconds: 7,
  meridiem: 8,
  empty: 9
}, T0 = (e, t, n, r, i) => (
  // cloning sections before sort to avoid mutating it
  [...n].sort((a, l) => O0[a.type] - O0[l.type]).reduce((a, l) => !i || l.modified ? Q3(e, l, t, a) : a, r)
), Z3 = () => navigator.userAgent.toLowerCase().includes("android"), J3 = (e, t) => {
  const n = {};
  if (!t)
    return e.forEach((d, p) => {
      const m = p === 0 ? null : p - 1, h = p === e.length - 1 ? null : p + 1;
      n[p] = {
        leftIndex: m,
        rightIndex: h
      };
    }), {
      neighbors: n,
      startIndex: 0,
      endIndex: e.length - 1
    };
  const r = {}, i = {};
  let a = 0, l = 0, u = e.length - 1;
  for (; u >= 0; ) {
    l = e.findIndex(
      // eslint-disable-next-line @typescript-eslint/no-loop-func
      (d, p) => {
        var m;
        return p >= a && ((m = d.endSeparator) == null ? void 0 : m.includes(" ")) && // Special case where the spaces were not there in the initial input
        d.endSeparator !== " / ";
      }
    ), l === -1 && (l = e.length - 1);
    for (let d = l; d >= a; d -= 1)
      i[d] = u, r[u] = d, u -= 1;
    a = l + 1;
  }
  return e.forEach((d, p) => {
    const m = i[p], h = m === 0 ? null : r[m - 1], g = m === e.length - 1 ? null : r[m + 1];
    n[p] = {
      leftIndex: h,
      rightIndex: g
    };
  }), {
    neighbors: n,
    startIndex: r[0],
    endIndex: r[e.length - 1]
  };
}, Ym = (e, t) => {
  if (e == null)
    return null;
  if (e === "all")
    return "all";
  if (typeof e == "string") {
    const n = t.findIndex((r) => r.type === e);
    return n === -1 ? null : n;
  }
  return e;
}, eq = (e, t) => {
  if (e.value)
    switch (e.type) {
      case "month": {
        if (e.contentType === "digit")
          return t.format(t.setMonth(t.date(), Number(e.value) - 1), "month");
        const n = t.parse(e.value, e.format);
        return n ? t.format(n, "month") : void 0;
      }
      case "day":
        return e.contentType === "digit" ? t.format(t.setDate(t.startOfYear(t.date()), Number(e.value)), "dayOfMonthFull") : e.value;
      case "weekDay":
        return;
      default:
        return;
    }
}, tq = (e, t) => {
  if (e.value)
    switch (e.type) {
      case "weekDay":
        return e.contentType === "letter" ? void 0 : Number(e.value);
      case "meridiem": {
        const n = t.parse(`01:00 ${e.value}`, `${t.formats.hours12h}:${t.formats.minutes} ${e.format}`);
        return n ? t.getHours(n) >= 12 ? 1 : 0 : void 0;
      }
      case "day":
        return e.contentType === "digit-with-letter" ? parseInt(e.value, 10) : Number(e.value);
      case "month": {
        if (e.contentType === "digit")
          return Number(e.value);
        const n = t.parse(e.value, e.format);
        return n ? t.getMonth(n) + 1 : void 0;
      }
      default:
        return e.contentType !== "letter" ? Number(e.value) : void 0;
    }
}, nq = ["value", "referenceDate"], $o = {
  emptyValue: null,
  getTodayValue: kS,
  getInitialReferenceValue: (e) => {
    let {
      value: t,
      referenceDate: n
    } = e, r = ht(e, nq);
    return t != null && r.utils.isValid(t) ? t : n ?? z3(r);
  },
  cleanValue: N3,
  areValuesEqual: F3,
  isSameError: (e, t) => e === t,
  hasError: (e) => e != null,
  defaultErrorState: null,
  getTimezone: (e, t) => t == null || !e.isValid(t) ? null : e.getTimezone(t),
  setTimezone: (e, t, n) => n == null ? null : e.setTimezone(n, t)
}, rq = {
  updateReferenceValue: (e, t, n) => t == null || !e.isValid(t) ? n : t,
  getSectionsFromValue: (e, t, n, r) => !e.isValid(t) && !!n ? n : r(t),
  getV7HiddenInputValueFromSections: G3,
  getV6InputValueFromSections: K3,
  getActiveDateManager: (e, t) => ({
    date: t.value,
    referenceDate: t.referenceValue,
    getSections: (n) => n,
    getNewValuesFromNewActiveDate: (n) => ({
      value: n,
      referenceValue: n == null || !e.isValid(n) ? t.referenceValue : n
    })
  }),
  parseValueStr: (e, t, n) => n(e.trim(), t)
};
function oq(e, t) {
  return Array.isArray(t) ? t.every((n) => e.indexOf(n) !== -1) : e.indexOf(t) !== -1;
}
const iq = (e, t) => (n) => {
  (n.key === "Enter" || n.key === " ") && (e(n), n.preventDefault(), n.stopPropagation());
}, mr = (e = document) => {
  const t = e.activeElement;
  return t ? t.shadowRoot ? mr(t.shadowRoot) : t : null;
}, aq = "@media (pointer: fine)";
function sq(e) {
  return ze("MuiPickersDay", e);
}
const Ji = Ve("MuiPickersDay", ["root", "dayWithMargin", "dayOutsideMonth", "hiddenDaySpacingFiller", "today", "selected", "disabled"]), lq = ["autoFocus", "className", "day", "disabled", "disableHighlightToday", "disableMargin", "hidden", "isAnimating", "onClick", "onDaySelect", "onFocus", "onBlur", "onKeyDown", "onMouseDown", "onMouseEnter", "outsideCurrentMonth", "selected", "showDaysOutsideCurrentMonth", "children", "today", "isFirstVisibleCell", "isLastVisibleCell"], cq = (e) => {
  const {
    selected: t,
    disableMargin: n,
    disableHighlightToday: r,
    today: i,
    disabled: a,
    outsideCurrentMonth: l,
    showDaysOutsideCurrentMonth: u,
    classes: d
  } = e, p = l && !u;
  return We({
    root: ["root", t && !p && "selected", a && "disabled", !n && "dayWithMargin", !r && i && "today", l && u && "dayOutsideMonth", p && "hiddenDaySpacingFiller"],
    hiddenDaySpacingFiller: ["hiddenDaySpacingFiller"]
  }, sq, d);
}, jS = ({
  theme: e
}) => J({}, e.typography.caption, {
  width: Sl,
  height: Sl,
  borderRadius: "50%",
  padding: 0,
  // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
  backgroundColor: "transparent",
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.short
  }),
  color: (e.vars || e).palette.text.primary,
  "@media (pointer: fine)": {
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : mt(e.palette.primary.main, e.palette.action.hoverOpacity)
    }
  },
  "&:focus": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.focusOpacity})` : mt(e.palette.primary.main, e.palette.action.focusOpacity),
    [`&.${Ji.selected}`]: {
      willChange: "background-color",
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  },
  [`&.${Ji.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText,
    backgroundColor: (e.vars || e).palette.primary.main,
    fontWeight: e.typography.fontWeightMedium,
    "&:hover": {
      willChange: "background-color",
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  },
  [`&.${Ji.disabled}:not(.${Ji.selected})`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${Ji.disabled}&.${Ji.selected}`]: {
    opacity: 0.6
  },
  variants: [{
    props: {
      disableMargin: !1
    },
    style: {
      margin: `0 ${Ad}px`
    }
  }, {
    props: {
      outsideCurrentMonth: !0,
      showDaysOutsideCurrentMonth: !0
    },
    style: {
      color: (e.vars || e).palette.text.secondary
    }
  }, {
    props: {
      disableHighlightToday: !1,
      today: !0
    },
    style: {
      [`&:not(.${Ji.selected})`]: {
        border: `1px solid ${(e.vars || e).palette.text.secondary}`
      }
    }
  }]
}), $S = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, !n.disableMargin && t.dayWithMargin, !n.disableHighlightToday && n.today && t.today, !n.outsideCurrentMonth && n.showDaysOutsideCurrentMonth && t.dayOutsideMonth, n.outsideCurrentMonth && !n.showDaysOutsideCurrentMonth && t.hiddenDaySpacingFiller];
}, uq = ae(Io, {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver: $S
})(jS), dq = ae("div", {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver: $S
})(({
  theme: e
}) => J({}, jS({
  theme: e
}), {
  // visibility: 'hidden' does not work here as it hides the element from screen readers as well
  opacity: 0,
  pointerEvents: "none"
})), Ys = () => {
}, AS = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = cn({
    props: t,
    name: "MuiPickersDay"
  }), {
    autoFocus: i = !1,
    className: a,
    day: l,
    disabled: u = !1,
    disableHighlightToday: d = !1,
    disableMargin: p = !1,
    isAnimating: m,
    onClick: h,
    onDaySelect: g,
    onFocus: v = Ys,
    onBlur: b = Ys,
    onKeyDown: y = Ys,
    onMouseDown: S = Ys,
    onMouseEnter: O = Ys,
    outsideCurrentMonth: P,
    selected: k = !1,
    showDaysOutsideCurrentMonth: R = !1,
    children: E,
    today: M = !1
  } = r, _ = ht(r, lq), I = J({}, r, {
    autoFocus: i,
    disabled: u,
    disableHighlightToday: d,
    disableMargin: p,
    selected: k,
    showDaysOutsideCurrentMonth: R,
    today: M
  }), F = cq(I), T = un(), $ = w.useRef(null), N = It($, n);
  An(() => {
    i && !u && !m && !P && $.current.focus();
  }, [i, u, m, P]);
  const W = (V) => {
    S(V), P && V.preventDefault();
  }, L = (V) => {
    u || g(l), P && V.currentTarget.focus(), h && h(V);
  };
  return P && !R ? /* @__PURE__ */ x.jsx(dq, {
    className: Me(F.root, F.hiddenDaySpacingFiller, a),
    ownerState: I,
    role: _.role
  }) : /* @__PURE__ */ x.jsx(uq, J({
    className: Me(F.root, a),
    ref: N,
    centerRipple: !0,
    disabled: u,
    tabIndex: k ? 0 : -1,
    onKeyDown: (V) => y(V, l),
    onFocus: (V) => v(V, l),
    onBlur: (V) => b(V, l),
    onMouseEnter: (V) => O(V, l),
    onClick: L,
    onMouseDown: W
  }, _, {
    ownerState: I,
    children: E || T.format(l, "dayOfMonth")
  }));
});
process.env.NODE_ENV !== "production" && (AS.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: o.oneOfType([o.func, o.shape({
    current: o.shape({
      focusVisible: o.func.isRequired
    })
  })]),
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: o.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  className: o.string,
  component: o.elementType,
  /**
   * The date to show.
   */
  day: o.object.isRequired,
  /**
   * If `true`, renders as disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: o.bool,
  /**
   * If `true`, days are rendering without margin. Useful for displaying linked range of days.
   * @default false
   */
  disableMargin: o.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: o.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: o.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: o.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: o.string,
  isAnimating: o.bool,
  /**
   * If `true`, day is the first visible cell of the month.
   * Either the first day of the month or the first day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isFirstVisibleCell: o.bool.isRequired,
  /**
   * If `true`, day is the last visible cell of the month.
   * Either the last day of the month or the last day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isLastVisibleCell: o.bool.isRequired,
  onBlur: o.func,
  onDaySelect: o.func.isRequired,
  onFocus: o.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: o.func,
  onKeyDown: o.func,
  onMouseEnter: o.func,
  /**
   * If `true`, day is outside of month and will be hidden.
   */
  outsideCurrentMonth: o.bool.isRequired,
  /**
   * If `true`, renders as selected.
   * @default false
   */
  selected: o.bool,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: o.bool,
  style: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * @default 0
   */
  tabIndex: o.number,
  /**
   * If `true`, renders as today date.
   * @default false
   */
  today: o.bool,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: o.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: o.oneOfType([o.func, o.shape({
    current: o.shape({
      pulsate: o.func.isRequired,
      start: o.func.isRequired,
      stop: o.func.isRequired
    })
  })])
});
const pq = /* @__PURE__ */ w.memo(AS), Yl = ({
  props: e,
  value: t,
  timezone: n,
  adapter: r
}) => {
  if (t === null)
    return null;
  const {
    shouldDisableDate: i,
    shouldDisableMonth: a,
    shouldDisableYear: l,
    disablePast: u,
    disableFuture: d
  } = e, p = r.utils.date(void 0, n), m = Zr(r.utils, e.minDate, r.defaultDates.minDate), h = Zr(r.utils, e.maxDate, r.defaultDates.maxDate);
  switch (!0) {
    case !r.utils.isValid(t):
      return "invalidDate";
    case !!(i && i(t)):
      return "shouldDisableDate";
    case !!(a && a(t)):
      return "shouldDisableMonth";
    case !!(l && l(t)):
      return "shouldDisableYear";
    case !!(d && r.utils.isAfterDay(t, p)):
      return "disableFuture";
    case !!(u && r.utils.isBeforeDay(t, p)):
      return "disablePast";
    case !!(m && r.utils.isBeforeDay(t, m)):
      return "minDate";
    case !!(h && r.utils.isAfterDay(t, h)):
      return "maxDate";
    default:
      return null;
  }
};
Yl.valueManager = $o;
const NS = ["disablePast", "disableFuture", "minDate", "maxDate", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear"], fq = ["disablePast", "disableFuture", "minTime", "maxTime", "shouldDisableTime", "minutesStep", "ampm", "disableIgnoringDatePartForTimeValidation"], mq = ["minDateTime", "maxDateTime"], hq = [...NS, ...fq, ...mq], FS = (e) => hq.reduce((t, n) => (e.hasOwnProperty(n) && (t[n] = e[n]), t), {});
function LS(e) {
  const {
    props: t,
    validator: n,
    value: r,
    timezone: i,
    onError: a
  } = e, l = ya(), u = w.useRef(n.valueManager.defaultErrorState), d = n({
    adapter: l,
    value: r,
    timezone: i,
    props: t
  }), p = n.valueManager.hasError(d);
  w.useEffect(() => {
    a && !n.valueManager.isSameError(d, u.current) && a(d, r), u.current = d;
  }, [n, a, d, r]);
  const m = Le((h) => n({
    adapter: l,
    value: h,
    timezone: i,
    props: t
  }));
  return {
    validationError: d,
    hasValidationError: p,
    getValidationErrorForNewValue: m
  };
}
const gq = ({
  utils: e,
  format: t
}) => {
  let n = 10, r = t, i = e.expandFormat(t);
  for (; i !== r; )
    if (r = i, i = e.expandFormat(r), n -= 1, n < 0)
      throw new Error("MUI X: The format expansion seems to be in an infinite loop. Please open an issue with the format passed to the picker component.");
  return i;
}, yq = ({
  utils: e,
  expandedFormat: t
}) => {
  const n = [], {
    start: r,
    end: i
  } = e.escapedCharacters, a = new RegExp(`(\\${r}[^\\${i}]*\\${i})+`, "g");
  let l = null;
  for (; l = a.exec(t); )
    n.push({
      start: l.index,
      end: a.lastIndex - 1
    });
  return n;
}, bq = (e, t, n, r) => {
  switch (n.type) {
    case "year":
      return t.fieldYearPlaceholder({
        digitAmount: e.formatByString(e.date(void 0, "default"), r).length,
        format: r
      });
    case "month":
      return t.fieldMonthPlaceholder({
        contentType: n.contentType,
        format: r
      });
    case "day":
      return t.fieldDayPlaceholder({
        format: r
      });
    case "weekDay":
      return t.fieldWeekDayPlaceholder({
        contentType: n.contentType,
        format: r
      });
    case "hours":
      return t.fieldHoursPlaceholder({
        format: r
      });
    case "minutes":
      return t.fieldMinutesPlaceholder({
        format: r
      });
    case "seconds":
      return t.fieldSecondsPlaceholder({
        format: r
      });
    case "meridiem":
      return t.fieldMeridiemPlaceholder({
        format: r
      });
    default:
      return r;
  }
}, vq = ({
  utils: e,
  date: t,
  shouldRespectLeadingZeros: n,
  localeText: r,
  localizedDigits: i,
  now: a,
  token: l,
  startSeparator: u
}) => {
  if (l === "")
    throw new Error("MUI X: Should not call `commitToken` with an empty token");
  const d = xg(e, l), p = IS(e, d.contentType, d.type, l), m = n ? p : d.contentType === "digit", h = t != null && e.isValid(t);
  let g = h ? e.formatByString(t, l) : "", v = null;
  if (m)
    if (p)
      v = g === "" ? e.formatByString(a, l).length : g.length;
    else {
      if (d.maxLength == null)
        throw new Error(`MUI X: The token ${l} should have a 'maxDigitNumber' property on it's adapter`);
      v = d.maxLength, h && (g = wg(DS(ma(g, i), v), i));
    }
  return J({}, d, {
    format: l,
    maxLength: v,
    value: g,
    placeholder: bq(e, r, d, l),
    hasLeadingZerosInFormat: p,
    hasLeadingZerosInInput: m,
    startSeparator: u,
    endSeparator: "",
    modified: !1
  });
}, xq = (e) => {
  var v;
  const {
    utils: t,
    expandedFormat: n,
    escapedParts: r
  } = e, i = t.date(void 0), a = [];
  let l = "";
  const u = Object.keys(t.formatTokenMap).sort((b, y) => y.length - b.length), d = /^([a-zA-Z]+)/, p = new RegExp(`^(${u.join("|")})*$`), m = new RegExp(`^(${u.join("|")})`), h = (b) => r.find((y) => y.start <= b && y.end >= b);
  let g = 0;
  for (; g < n.length; ) {
    const b = h(g), y = b != null, S = (v = d.exec(n.slice(g))) == null ? void 0 : v[1];
    if (!y && S != null && p.test(S)) {
      let O = S;
      for (; O.length > 0; ) {
        const P = m.exec(O)[1];
        O = O.slice(P.length), a.push(vq(J({}, e, {
          now: i,
          token: P,
          startSeparator: l
        }))), l = "";
      }
      g += S.length;
    } else {
      const O = n[g];
      y && (b == null ? void 0 : b.start) === g || (b == null ? void 0 : b.end) === g || (a.length === 0 ? l += O : a[a.length - 1].endSeparator += O), g += 1;
    }
  }
  return a.length === 0 && l.length > 0 && a.push({
    type: "empty",
    contentType: "letter",
    maxLength: null,
    format: "",
    value: "",
    placeholder: "",
    hasLeadingZerosInFormat: !1,
    hasLeadingZerosInInput: !1,
    startSeparator: l,
    endSeparator: "",
    modified: !1
  }), a;
}, wq = ({
  isRtl: e,
  formatDensity: t,
  sections: n
}) => n.map((r) => {
  const i = (a) => {
    let l = a;
    return e && l !== null && l.includes(" ") && (l = `⁩${l}⁦`), t === "spacious" && ["/", ".", "-"].includes(l) && (l = ` ${l} `), l;
  };
  return r.startSeparator = i(r.startSeparator), r.endSeparator = i(r.endSeparator), r;
}), E0 = (e) => {
  let t = gq(e);
  e.isRtl && e.enableAccessibleFieldDOMStructure && (t = t.split(" ").reverse().join(" "));
  const n = yq(J({}, e, {
    expandedFormat: t
  })), r = xq(J({}, e, {
    expandedFormat: t,
    escapedParts: n
  }));
  return wq(J({}, e, {
    sections: r
  }));
}, Cq = (e) => {
  const t = un(), n = si(), r = ya(), i = eo(), {
    valueManager: a,
    fieldValueManager: l,
    valueType: u,
    validator: d,
    internalProps: p,
    internalProps: {
      value: m,
      defaultValue: h,
      referenceDate: g,
      onChange: v,
      format: b,
      formatDensity: y = "dense",
      selectedSections: S,
      onSelectedSectionsChange: O,
      shouldRespectLeadingZeros: P = !1,
      timezone: k,
      enableAccessibleFieldDOMStructure: R = !1
    }
  } = e, {
    timezone: E,
    value: M,
    handleValueChange: _
  } = bg({
    timezone: k,
    value: m,
    defaultValue: h,
    referenceDate: g,
    onChange: v,
    valueManager: a
  }), I = w.useMemo(() => H3(t), [t]), F = w.useMemo(() => X3(t, I, E), [t, I, E]), T = w.useCallback((U, de = null) => l.getSectionsFromValue(t, U, de, (ce) => E0({
    utils: t,
    localeText: n,
    localizedDigits: I,
    format: b,
    date: ce,
    formatDensity: y,
    shouldRespectLeadingZeros: P,
    enableAccessibleFieldDOMStructure: R,
    isRtl: i
  })), [l, b, n, I, i, P, t, y, R]), [$, N] = w.useState(() => {
    const U = T(M);
    S0(U, u);
    const de = {
      sections: U,
      value: M,
      referenceValue: a.emptyValue,
      tempValueStrAndroid: null
    }, ce = V3(U), K = a.getInitialReferenceValue({
      referenceDate: g,
      value: M,
      utils: t,
      props: p,
      granularity: ce,
      timezone: E
    });
    return J({}, de, {
      referenceValue: K
    });
  }), [W, L] = or({
    controlled: S,
    default: null,
    name: "useField",
    state: "selectedSections"
  }), V = (U) => {
    L(U), O == null || O(U);
  }, z = w.useMemo(() => Ym(W, $.sections), [W, $.sections]), X = z === "all" ? 0 : z, le = ({
    value: U,
    referenceValue: de,
    sections: ce
  }) => {
    if (N((Z) => J({}, Z, {
      sections: ce,
      value: U,
      referenceValue: de,
      tempValueStrAndroid: null
    })), a.areValuesEqual(t, $.value, U))
      return;
    const K = {
      validationError: d({
        adapter: r,
        value: U,
        timezone: E,
        props: p
      })
    };
    _(U, K);
  }, ne = (U, de) => {
    const ce = [...$.sections];
    return ce[U] = J({}, ce[U], {
      value: de,
      modified: !0
    }), ce;
  }, G = () => {
    le({
      value: a.emptyValue,
      referenceValue: $.referenceValue,
      sections: T(a.emptyValue)
    });
  }, Q = () => {
    if (X == null)
      return;
    const U = $.sections[X], de = l.getActiveDateManager(t, $, U), K = de.getSections($.sections).filter((B) => B.value !== "").length === (U.value === "" ? 0 : 1), Z = ne(X, ""), ue = K ? null : t.getInvalidDate(), he = de.getNewValuesFromNewActiveDate(ue);
    le(J({}, he, {
      sections: Z
    }));
  }, be = (U) => {
    const de = (Z, ue) => {
      const he = t.parse(Z, b);
      if (he == null || !t.isValid(he))
        return null;
      const B = E0({
        utils: t,
        localeText: n,
        localizedDigits: I,
        format: b,
        date: he,
        formatDensity: y,
        shouldRespectLeadingZeros: P,
        enableAccessibleFieldDOMStructure: R,
        isRtl: i
      });
      return T0(t, he, B, ue, !1);
    }, ce = l.parseValueStr(U, $.referenceValue, de), K = l.updateReferenceValue(t, ce, $.referenceValue);
    le({
      value: ce,
      referenceValue: K,
      sections: T(ce, $.sections)
    });
  }, we = ({
    activeSection: U,
    newSectionValue: de,
    shouldGoToNextSection: ce
  }) => {
    ce && X < $.sections.length - 1 && V(X + 1);
    const K = l.getActiveDateManager(t, $, U), Z = ne(X, de), ue = K.getSections(Z), he = Y3(t, ue, I);
    let B, ee;
    if (he != null && t.isValid(he)) {
      const ie = T0(t, he, ue, K.referenceDate, !0);
      B = K.getNewValuesFromNewActiveDate(ie), ee = !0;
    } else
      B = K.getNewValuesFromNewActiveDate(he), ee = (he != null && !t.isValid(he)) != (K.date != null && !t.isValid(K.date));
    return ee ? le(J({}, B, {
      sections: Z
    })) : N((ie) => J({}, ie, B, {
      sections: Z,
      tempValueStrAndroid: null
    }));
  }, se = (U) => N((de) => J({}, de, {
    tempValueStrAndroid: U
  }));
  return w.useEffect(() => {
    const U = T($.value);
    S0(U, u), N((de) => J({}, de, {
      sections: U
    }));
  }, [b, t.locale, i]), w.useEffect(() => {
    let U;
    a.areValuesEqual(t, $.value, M) ? U = a.getTimezone(t, $.value) !== a.getTimezone(t, M) : U = !0, U && N((de) => J({}, de, {
      value: M,
      referenceValue: l.updateReferenceValue(t, M, de.referenceValue),
      sections: T(M)
    }));
  }, [M]), {
    state: $,
    activeSectionIndex: X,
    parsedSelectedSections: z,
    setSelectedSections: V,
    clearValue: G,
    clearActiveSection: Q,
    updateSectionValue: we,
    updateValueFromValueStr: be,
    setTempAndroidValueStr: se,
    getSectionsFromValue: T,
    sectionsValueBoundaries: F,
    localizedDigits: I,
    timezone: E
  };
}, Sq = 5e3, Fa = (e) => e.saveQuery != null, Oq = ({
  sections: e,
  updateSectionValue: t,
  sectionsValueBoundaries: n,
  localizedDigits: r,
  setTempAndroidValueStr: i,
  timezone: a
}) => {
  const l = un(), [u, d] = w.useState(null), p = Le(() => d(null));
  w.useEffect(() => {
    var b;
    u != null && ((b = e[u.sectionIndex]) == null ? void 0 : b.type) !== u.sectionType && p();
  }, [e, u, p]), w.useEffect(() => {
    if (u != null) {
      const b = setTimeout(() => p(), Sq);
      return () => {
        clearTimeout(b);
      };
    }
    return () => {
    };
  }, [u, p]);
  const m = ({
    keyPressed: b,
    sectionIndex: y
  }, S, O) => {
    const P = b.toLowerCase(), k = e[y];
    if (u != null && (!O || O(u.value)) && u.sectionIndex === y) {
      const E = `${u.value}${P}`, M = S(E, k);
      if (!Fa(M))
        return d({
          sectionIndex: y,
          value: E,
          sectionType: k.type
        }), M;
    }
    const R = S(P, k);
    return Fa(R) && !R.saveQuery ? (p(), null) : (d({
      sectionIndex: y,
      value: P,
      sectionType: k.type
    }), Fa(R) ? null : R);
  }, h = (b) => {
    const y = (P, k, R) => {
      const E = k.filter((M) => M.toLowerCase().startsWith(R));
      return E.length === 0 ? {
        saveQuery: !1
      } : {
        sectionValue: E[0],
        shouldGoToNextSection: E.length === 1
      };
    }, S = (P, k, R, E) => {
      const M = (_) => PS(l, a, k.type, _);
      if (k.contentType === "letter")
        return y(k.format, M(k.format), P);
      if (R && E != null && xg(l, R).contentType === "letter") {
        const _ = M(R), I = y(R, _, P);
        return Fa(I) ? {
          saveQuery: !1
        } : J({}, I, {
          sectionValue: E(I.sectionValue, _)
        });
      }
      return {
        saveQuery: !1
      };
    };
    return m(b, (P, k) => {
      switch (k.type) {
        case "month": {
          const R = (E) => w0(l, E, l.formats.month, k.format);
          return S(P, k, l.formats.month, R);
        }
        case "weekDay": {
          const R = (E, M) => M.indexOf(E).toString();
          return S(P, k, l.formats.weekday, R);
        }
        case "meridiem":
          return S(P, k);
        default:
          return {
            saveQuery: !1
          };
      }
    });
  }, g = (b) => {
    const y = (O, P) => {
      const k = ma(O, r), R = Number(k), E = n[P.type]({
        currentDate: null,
        format: P.format,
        contentType: P.contentType
      });
      if (R > E.maximum)
        return {
          saveQuery: !1
        };
      if (R < E.minimum)
        return {
          saveQuery: !0
        };
      const M = R * 10 > E.maximum || k.length === E.maximum.toString().length;
      return {
        sectionValue: MS(l, R, E, r, P),
        shouldGoToNextSection: M
      };
    };
    return m(b, (O, P) => {
      if (P.contentType === "digit" || P.contentType === "digit-with-letter")
        return y(O, P);
      if (P.type === "month") {
        IS(l, "digit", "month", "MM");
        const k = y(O, {
          type: P.type,
          format: "MM",
          hasLeadingZerosInInput: !0,
          contentType: "digit",
          maxLength: 2
        });
        if (Fa(k))
          return k;
        const R = w0(l, k.sectionValue, "MM", P.format);
        return J({}, k, {
          sectionValue: R
        });
      }
      if (P.type === "weekDay") {
        const k = y(O, P);
        if (Fa(k))
          return k;
        const R = Fd(l, P.format)[Number(k.sectionValue) - 1];
        return J({}, k, {
          sectionValue: R
        });
      }
      return {
        saveQuery: !1
      };
    }, (O) => x0(O, r));
  };
  return {
    applyCharacterEditing: Le((b) => {
      const y = e[b.sectionIndex], O = x0(b.keyPressed, r) ? g(J({}, b, {
        keyPressed: wg(b.keyPressed, r)
      })) : h(b);
      if (O == null) {
        i(null);
        return;
      }
      t({
        activeSection: y,
        newSectionValue: O.sectionValue,
        shouldGoToNextSection: O.shouldGoToNextSection
      });
    }),
    resetCharacterQuery: p
  };
}, Tq = (e) => {
  const {
    internalProps: {
      disabled: t,
      readOnly: n = !1
    },
    forwardedProps: {
      sectionListRef: r,
      onBlur: i,
      onClick: a,
      onFocus: l,
      onInput: u,
      onPaste: d,
      focused: p,
      autoFocus: m = !1
    },
    fieldValueManager: h,
    applyCharacterEditing: g,
    resetCharacterQuery: v,
    setSelectedSections: b,
    parsedSelectedSections: y,
    state: S,
    clearActiveSection: O,
    clearValue: P,
    updateSectionValue: k,
    updateValueFromValueStr: R,
    sectionOrder: E,
    areAllSectionsEmpty: M,
    sectionsValueBoundaries: _
  } = e, I = w.useRef(null), F = It(r, I), T = si(), $ = un(), N = Ir(), [W, L] = w.useState(!1), V = w.useMemo(() => ({
    syncSelectionToDOM: () => {
      if (!I.current)
        return;
      const ee = document.getSelection();
      if (!ee)
        return;
      if (y == null) {
        ee.rangeCount > 0 && I.current.getRoot().contains(ee.getRangeAt(0).startContainer) && ee.removeAllRanges(), W && I.current.getRoot().blur();
        return;
      }
      if (!I.current.getRoot().contains(mr(document)))
        return;
      const ie = new window.Range();
      let ge;
      y === "all" ? ge = I.current.getRoot() : S.sections[y].type === "empty" ? ge = I.current.getSectionContainer(y) : ge = I.current.getSectionContent(y), ie.selectNodeContents(ge), ge.focus(), ee.removeAllRanges(), ee.addRange(ie);
    },
    getActiveSectionIndexFromDOM: () => {
      const ee = mr(document);
      return !ee || !I.current || !I.current.getRoot().contains(ee) ? null : I.current.getSectionIndexFromDOMElement(ee);
    },
    focusField: (ee = 0) => {
      if (!I.current || // if the field is already focused, we don't need to focus it again
      V.getActiveSectionIndexFromDOM() != null)
        return;
      const ie = Ym(ee, S.sections);
      L(!0), I.current.getSectionContent(ie).focus();
    },
    setSelectedSections: (ee) => {
      if (!I.current)
        return;
      const ie = Ym(ee, S.sections);
      L((ie === "all" ? 0 : ie) !== null), b(ee);
    },
    isFieldFocused: () => {
      const ee = mr(document);
      return !!I.current && I.current.getRoot().contains(ee);
    }
  }), [y, b, S.sections, W]), z = Le((ee) => {
    if (!I.current)
      return;
    const ie = S.sections[ee];
    I.current.getSectionContent(ee).innerHTML = ie.value || ie.placeholder, V.syncSelectionToDOM();
  }), X = Le((ee, ...ie) => {
    ee.isDefaultPrevented() || !I.current || (L(!0), a == null || a(ee, ...ie), y === "all" ? setTimeout(() => {
      const ge = document.getSelection().getRangeAt(0).startOffset;
      if (ge === 0) {
        b(E.startIndex);
        return;
      }
      let xe = 0, pe = 0;
      for (; pe < ge && xe < S.sections.length; ) {
        const Ee = S.sections[xe];
        xe += 1, pe += `${Ee.startSeparator}${Ee.value || Ee.placeholder}${Ee.endSeparator}`.length;
      }
      b(xe - 1);
    }) : W ? I.current.getRoot().contains(ee.target) || b(E.startIndex) : (L(!0), b(E.startIndex)));
  }), le = Le((ee) => {
    if (u == null || u(ee), !I.current || y !== "all")
      return;
    const ge = ee.target.textContent ?? "";
    I.current.getRoot().innerHTML = S.sections.map((xe) => `${xe.startSeparator}${xe.value || xe.placeholder}${xe.endSeparator}`).join(""), V.syncSelectionToDOM(), ge.length === 0 || ge.charCodeAt(0) === 10 ? (v(), P(), b("all")) : ge.length > 1 ? R(ge) : (y === "all" && b(0), g({
      keyPressed: ge,
      sectionIndex: 0
    }));
  }), ne = Le((ee) => {
    if (d == null || d(ee), n || y !== "all") {
      ee.preventDefault();
      return;
    }
    const ie = ee.clipboardData.getData("text");
    ee.preventDefault(), v(), R(ie);
  }), G = Le((...ee) => {
    if (l == null || l(...ee), W || !I.current)
      return;
    L(!0), I.current.getSectionIndexFromDOMElement(mr(document)) != null || b(E.startIndex);
  }), Q = Le((...ee) => {
    i == null || i(...ee), setTimeout(() => {
      if (!I.current)
        return;
      const ie = mr(document);
      !I.current.getRoot().contains(ie) && (L(!1), b(null));
    });
  }), be = Le((ee) => (ie) => {
    ie.isDefaultPrevented() || b(ee);
  }), we = Le((ee) => {
    ee.preventDefault();
  }), se = Le((ee) => () => {
    b(ee);
  }), U = Le((ee) => {
    if (ee.preventDefault(), n || t || typeof y != "number")
      return;
    const ie = S.sections[y], ge = ee.clipboardData.getData("text"), xe = /^[a-zA-Z]+$/.test(ge), pe = /^[0-9]+$/.test(ge), Ee = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(ge);
    ie.contentType === "letter" && xe || ie.contentType === "digit" && pe || ie.contentType === "digit-with-letter" && Ee ? (v(), k({
      activeSection: ie,
      newSectionValue: ge,
      shouldGoToNextSection: !0
    })) : !xe && !pe && (v(), R(ge));
  }), de = Le((ee) => {
    ee.preventDefault(), ee.dataTransfer.dropEffect = "none";
  }), ce = Le((ee) => {
    if (!I.current)
      return;
    const ie = ee.target, ge = ie.textContent ?? "", xe = I.current.getSectionIndexFromDOMElement(ie), pe = S.sections[xe];
    if (n || !I.current) {
      z(xe);
      return;
    }
    if (ge.length === 0) {
      if (pe.value === "") {
        z(xe);
        return;
      }
      const Ee = ee.nativeEvent.inputType;
      if (Ee === "insertParagraph" || Ee === "insertLineBreak") {
        z(xe);
        return;
      }
      v(), O();
      return;
    }
    g({
      keyPressed: ge,
      sectionIndex: xe
    }), z(xe);
  });
  An(() => {
    if (!(!W || !I.current)) {
      if (y === "all")
        I.current.getRoot().focus();
      else if (typeof y == "number") {
        const ee = I.current.getSectionContent(y);
        ee && ee.focus();
      }
    }
  }, [y, W]);
  const K = w.useMemo(() => S.sections.reduce((ee, ie) => (ee[ie.type] = _[ie.type]({
    currentDate: null,
    contentType: ie.contentType,
    format: ie.format
  }), ee), {}), [_, S.sections]), Z = y === "all", ue = w.useMemo(() => S.sections.map((ee, ie) => {
    const ge = !Z && !t && !n;
    return {
      container: {
        "data-sectionindex": ie,
        onClick: be(ie)
      },
      content: {
        tabIndex: Z || ie > 0 ? -1 : 0,
        contentEditable: !Z && !t && !n,
        role: "spinbutton",
        id: `${N}-${ee.type}`,
        "aria-labelledby": `${N}-${ee.type}`,
        "aria-readonly": n,
        "aria-valuenow": tq(ee, $),
        "aria-valuemin": K[ee.type].minimum,
        "aria-valuemax": K[ee.type].maximum,
        "aria-valuetext": ee.value ? eq(ee, $) : T.empty,
        "aria-label": T[ee.type],
        "aria-disabled": t,
        spellCheck: ge ? !1 : void 0,
        autoCapitalize: ge ? "off" : void 0,
        autoCorrect: ge ? "off" : void 0,
        [parseInt(w.version, 10) >= 17 ? "enterKeyHint" : "enterkeyhint"]: ge ? "next" : void 0,
        children: ee.value || ee.placeholder,
        onInput: ce,
        onPaste: U,
        onFocus: se(ie),
        onDragOver: de,
        onMouseUp: we,
        inputMode: ee.contentType === "letter" ? "text" : "numeric"
      },
      before: {
        children: ee.startSeparator
      },
      after: {
        children: ee.endSeparator
      }
    };
  }), [S.sections, se, U, de, ce, be, we, t, n, Z, T, $, K, N]), he = Le((ee) => {
    R(ee.target.value);
  }), B = w.useMemo(() => M ? "" : h.getV7HiddenInputValueFromSections(S.sections), [M, S.sections, h]);
  return w.useEffect(() => {
    if (I.current == null)
      throw new Error(["MUI X: The `sectionListRef` prop has not been initialized by `PickersSectionList`", "You probably tried to pass a component to the `textField` slot that contains an `<input />` element instead of a `PickersSectionList`.", "", "If you want to keep using an `<input />` HTML element for the editing, please remove the `enableAccessibleFieldDOMStructure` prop from your picker or field component:", "", "<DatePicker slots={{ textField: MyCustomTextField }} />", "", "Learn more about the field accessible DOM structure on the MUI documentation: https://mui.com/x/react-date-pickers/fields/#fields-to-edit-a-single-element"].join(`
`));
    m && I.current && I.current.getSectionContent(E.startIndex).focus();
  }, []), {
    interactions: V,
    returnedValue: {
      // Forwarded
      autoFocus: m,
      readOnly: n,
      focused: p ?? W,
      sectionListRef: F,
      onBlur: Q,
      onClick: X,
      onFocus: G,
      onInput: le,
      onPaste: ne,
      // Additional
      enableAccessibleFieldDOMStructure: !0,
      elements: ue,
      // TODO v7: Try to set to undefined when there is a section selected.
      tabIndex: y === 0 ? -1 : 0,
      contentEditable: Z,
      value: B,
      onChange: he,
      areAllSectionsEmpty: M
    }
  };
}, Wa = (e) => e.replace(/[\u2066\u2067\u2068\u2069]/g, ""), Eq = (e, t, n) => {
  let r = 0, i = n ? 1 : 0;
  const a = [];
  for (let l = 0; l < e.length; l += 1) {
    const u = e[l], d = Cg(u, n ? "input-rtl" : "input-ltr", t), p = `${u.startSeparator}${d}${u.endSeparator}`, m = Wa(p).length, h = p.length, g = Wa(d), v = i + (g === "" ? 0 : d.indexOf(g[0])) + u.startSeparator.length, b = v + g.length;
    a.push(J({}, u, {
      start: r,
      end: r + m,
      startInInput: v,
      endInInput: b
    })), r += m, i += h;
  }
  return a;
}, Rq = (e) => {
  const t = eo(), n = w.useRef(void 0), r = w.useRef(void 0), {
    forwardedProps: {
      onFocus: i,
      onClick: a,
      onPaste: l,
      onBlur: u,
      inputRef: d,
      placeholder: p
    },
    internalProps: {
      readOnly: m = !1,
      disabled: h = !1
    },
    parsedSelectedSections: g,
    activeSectionIndex: v,
    state: b,
    fieldValueManager: y,
    valueManager: S,
    applyCharacterEditing: O,
    resetCharacterQuery: P,
    updateSectionValue: k,
    updateValueFromValueStr: R,
    clearActiveSection: E,
    clearValue: M,
    setTempAndroidValueStr: _,
    setSelectedSections: I,
    getSectionsFromValue: F,
    areAllSectionsEmpty: T,
    localizedDigits: $
  } = e, N = w.useRef(null), W = It(d, N), L = w.useMemo(() => Eq(b.sections, $, t), [b.sections, $, t]), V = w.useMemo(() => ({
    syncSelectionToDOM: () => {
      if (!N.current)
        return;
      if (g == null) {
        N.current.scrollLeft && (N.current.scrollLeft = 0);
        return;
      }
      if (N.current !== mr(document))
        return;
      const ce = N.current.scrollTop;
      if (g === "all")
        N.current.select();
      else {
        const K = L[g], Z = K.type === "empty" ? K.startInInput - K.startSeparator.length : K.startInInput, ue = K.type === "empty" ? K.endInInput + K.endSeparator.length : K.endInInput;
        (Z !== N.current.selectionStart || ue !== N.current.selectionEnd) && N.current === mr(document) && N.current.setSelectionRange(Z, ue), clearTimeout(r.current), r.current = setTimeout(() => {
          N.current && N.current === mr(document) && // The section might loose all selection, where `selectionStart === selectionEnd`
          // https://github.com/mui/mui-x/pull/13652
          N.current.selectionStart === N.current.selectionEnd && (N.current.selectionStart !== Z || N.current.selectionEnd !== ue) && V.syncSelectionToDOM();
        });
      }
      N.current.scrollTop = ce;
    },
    getActiveSectionIndexFromDOM: () => {
      const ce = N.current.selectionStart ?? 0, K = N.current.selectionEnd ?? 0;
      if (ce === 0 && K === 0)
        return null;
      const Z = ce <= L[0].startInInput ? 1 : L.findIndex((ue) => ue.startInInput - ue.startSeparator.length > ce);
      return Z === -1 ? L.length - 1 : Z - 1;
    },
    focusField: (ce = 0) => {
      var K;
      mr(document) !== N.current && ((K = N.current) == null || K.focus(), I(ce));
    },
    setSelectedSections: (ce) => I(ce),
    isFieldFocused: () => N.current === mr(document)
  }), [N, g, L, I]), z = () => {
    const ce = N.current.selectionStart ?? 0;
    let K;
    ce <= L[0].startInInput || ce >= L[L.length - 1].endInInput ? K = 1 : K = L.findIndex((ue) => ue.startInInput - ue.startSeparator.length > ce);
    const Z = K === -1 ? L.length - 1 : K - 1;
    I(Z);
  }, X = Le((...ce) => {
    i == null || i(...ce);
    const K = N.current;
    clearTimeout(n.current), n.current = setTimeout(() => {
      !K || K !== N.current || v == null && (// avoid selecting all sections when focusing empty field without value
      K.value.length && Number(K.selectionEnd) - Number(K.selectionStart) === K.value.length ? I("all") : z());
    });
  }), le = Le((ce, ...K) => {
    ce.isDefaultPrevented() || (a == null || a(ce, ...K), z());
  }), ne = Le((ce) => {
    if (l == null || l(ce), ce.preventDefault(), m || h)
      return;
    const K = ce.clipboardData.getData("text");
    if (typeof g == "number") {
      const Z = b.sections[g], ue = /^[a-zA-Z]+$/.test(K), he = /^[0-9]+$/.test(K), B = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(K);
      if (Z.contentType === "letter" && ue || Z.contentType === "digit" && he || Z.contentType === "digit-with-letter" && B) {
        P(), k({
          activeSection: Z,
          newSectionValue: K,
          shouldGoToNextSection: !0
        });
        return;
      }
      if (ue || he)
        return;
    }
    P(), R(K);
  }), G = Le((...ce) => {
    u == null || u(...ce), I(null);
  }), Q = Le((ce) => {
    if (m)
      return;
    const K = ce.target.value;
    if (K === "") {
      P(), M();
      return;
    }
    const Z = ce.nativeEvent.data, ue = Z && Z.length > 1, he = ue ? Z : K, B = Wa(he);
    if (g === "all" && I(v), v == null || ue) {
      R(ue ? Z : B);
      return;
    }
    let ee;
    if (g === "all" && B.length === 1)
      ee = B;
    else {
      const ie = Wa(y.getV6InputValueFromSections(L, $, t));
      let ge = -1, xe = -1;
      for (let Be = 0; Be < ie.length; Be += 1)
        ge === -1 && ie[Be] !== B[Be] && (ge = Be), xe === -1 && ie[ie.length - Be - 1] !== B[B.length - Be - 1] && (xe = Be);
      const pe = L[v];
      if (ge < pe.start || ie.length - xe - 1 > pe.end)
        return;
      const Pe = B.length - ie.length + pe.end - Wa(pe.endSeparator || "").length;
      ee = B.slice(pe.start + Wa(pe.startSeparator || "").length, Pe);
    }
    if (ee.length === 0) {
      Z3() && _(he), P(), E();
      return;
    }
    O({
      keyPressed: ee,
      sectionIndex: v
    });
  }), be = w.useMemo(() => p !== void 0 ? p : y.getV6InputValueFromSections(F(S.emptyValue), $, t), [p, y, F, S.emptyValue, $, t]), we = w.useMemo(() => b.tempValueStrAndroid ?? y.getV6InputValueFromSections(b.sections, $, t), [b.sections, y, b.tempValueStrAndroid, $, t]);
  w.useEffect(() => (N.current && N.current === mr(document) && I("all"), () => {
    clearTimeout(n.current), clearTimeout(r.current);
  }), []);
  const se = w.useMemo(() => v == null || b.sections[v].contentType === "letter" ? "text" : "numeric", [v, b.sections]), de = !(N.current && N.current === mr(document)) && T;
  return {
    interactions: V,
    returnedValue: {
      // Forwarded
      readOnly: m,
      onBlur: G,
      onClick: le,
      onFocus: X,
      onPaste: ne,
      inputRef: W,
      // Additional
      enableAccessibleFieldDOMStructure: !1,
      placeholder: be,
      inputMode: se,
      autoComplete: "off",
      value: de ? "" : we,
      onChange: Q
    }
  };
}, kq = (e) => {
  const t = un(), {
    internalProps: n,
    internalProps: {
      unstableFieldRef: r,
      minutesStep: i,
      enableAccessibleFieldDOMStructure: a = !1,
      disabled: l = !1,
      readOnly: u = !1
    },
    forwardedProps: {
      onKeyDown: d,
      error: p,
      clearable: m,
      onClear: h
    },
    fieldValueManager: g,
    valueManager: v,
    validator: b
  } = e, y = eo(), S = Cq(e), {
    state: O,
    activeSectionIndex: P,
    parsedSelectedSections: k,
    setSelectedSections: R,
    clearValue: E,
    clearActiveSection: M,
    updateSectionValue: _,
    setTempAndroidValueStr: I,
    sectionsValueBoundaries: F,
    localizedDigits: T,
    timezone: $
  } = S, N = Oq({
    sections: O.sections,
    updateSectionValue: _,
    sectionsValueBoundaries: F,
    localizedDigits: T,
    setTempAndroidValueStr: I,
    timezone: $
  }), {
    resetCharacterQuery: W
  } = N, L = v.areValuesEqual(t, O.value, v.emptyValue), V = a ? Tq : Rq, z = w.useMemo(() => J3(O.sections, y && !a), [O.sections, y, a]), {
    returnedValue: X,
    interactions: le
  } = V(J({}, e, S, N, {
    areAllSectionsEmpty: L,
    sectionOrder: z
  })), ne = Le((U) => {
    if (d == null || d(U), !l)
      switch (!0) {
        // Select all
        case ((U.ctrlKey || U.metaKey) && String.fromCharCode(U.keyCode) === "A" && !U.shiftKey && !U.altKey): {
          U.preventDefault(), R("all");
          break;
        }
        // Move selection to next section
        case U.key === "ArrowRight": {
          if (U.preventDefault(), k == null)
            R(z.startIndex);
          else if (k === "all")
            R(z.endIndex);
          else {
            const de = z.neighbors[k].rightIndex;
            de !== null && R(de);
          }
          break;
        }
        // Move selection to previous section
        case U.key === "ArrowLeft": {
          if (U.preventDefault(), k == null)
            R(z.endIndex);
          else if (k === "all")
            R(z.startIndex);
          else {
            const de = z.neighbors[k].leftIndex;
            de !== null && R(de);
          }
          break;
        }
        // Reset the value of the selected section
        case U.key === "Delete": {
          if (U.preventDefault(), u)
            break;
          k == null || k === "all" ? E() : M(), W();
          break;
        }
        // Increment / decrement the selected section value
        case ["ArrowUp", "ArrowDown", "Home", "End", "PageUp", "PageDown"].includes(U.key): {
          if (U.preventDefault(), u || P == null)
            break;
          k === "all" && R(P);
          const de = O.sections[P], ce = g.getActiveDateManager(t, O, de), K = U3(t, $, de, U.key, F, T, ce.date, {
            minutesStep: i
          });
          _({
            activeSection: de,
            newSectionValue: K,
            shouldGoToNextSection: !1
          });
          break;
        }
      }
  });
  An(() => {
    le.syncSelectionToDOM();
  });
  const {
    hasValidationError: G
  } = LS({
    props: n,
    validator: b,
    timezone: $,
    value: O.value,
    onError: n.onError
  }), Q = w.useMemo(() => p !== void 0 ? p : G, [G, p]);
  w.useEffect(() => {
    !Q && P == null && W();
  }, [O.referenceValue, P, Q]), w.useEffect(() => {
    O.tempValueStrAndroid != null && P != null && (W(), M());
  }, [O.sections]), w.useImperativeHandle(r, () => ({
    getSections: () => O.sections,
    getActiveSectionIndex: le.getActiveSectionIndexFromDOM,
    setSelectedSections: le.setSelectedSections,
    focusField: le.focusField,
    isFieldFocused: le.isFieldFocused
  }));
  const be = Le((U, ...de) => {
    U.preventDefault(), h == null || h(U, ...de), E(), le.isFieldFocused() ? R(z.startIndex) : le.focusField(0);
  }), we = {
    onKeyDown: ne,
    onClear: be,
    error: Q,
    clearable: !!(m && !L && !u && !l)
  }, se = {
    disabled: l,
    readOnly: u
  };
  return J({}, e.forwardedProps, we, se, X);
}, Pq = ["clearable", "onClear", "InputProps", "sx", "slots", "slotProps"], Dq = ["ownerState"], Mq = (e) => {
  const t = si(), {
    clearable: n,
    onClear: r,
    InputProps: i,
    sx: a,
    slots: l,
    slotProps: u
  } = e, d = ht(e, Pq), p = (l == null ? void 0 : l.clearButton) ?? Ai, m = Nt({
    elementType: p,
    externalSlotProps: u == null ? void 0 : u.clearButton,
    ownerState: {},
    className: "clearButton",
    additionalProps: {
      title: t.fieldClearLabel
    }
  }), h = ht(m, Dq), g = (l == null ? void 0 : l.clearIcon) ?? x3, v = Nt({
    elementType: g,
    externalSlotProps: u == null ? void 0 : u.clearIcon,
    ownerState: {}
  });
  return J({}, d, {
    InputProps: J({}, i, {
      endAdornment: /* @__PURE__ */ x.jsxs(w.Fragment, {
        children: [n && /* @__PURE__ */ x.jsx(Vl, {
          position: "end",
          sx: {
            marginRight: i != null && i.endAdornment ? -1 : -1.5
          },
          children: /* @__PURE__ */ x.jsx(p, J({}, h, {
            onClick: r,
            children: /* @__PURE__ */ x.jsx(g, J({
              fontSize: "small"
            }, v))
          }))
        }), i == null ? void 0 : i.endAdornment]
      })
    }),
    sx: [{
      "& .clearButton": {
        opacity: 1
      },
      "@media (pointer: fine)": {
        "& .clearButton": {
          opacity: 0
        },
        "&:hover, &:focus-within": {
          ".clearButton": {
            opacity: 1
          }
        }
      }
    }, ...Array.isArray(a) ? a : [a]]
  });
}, _q = ["value", "defaultValue", "referenceDate", "format", "formatDensity", "onChange", "timezone", "onError", "shouldRespectLeadingZeros", "selectedSections", "onSelectedSectionsChange", "unstableFieldRef", "enableAccessibleFieldDOMStructure", "disabled", "readOnly", "dateSeparator"], Iq = (e, t) => w.useMemo(() => {
  const n = J({}, e), r = {}, i = (a) => {
    n.hasOwnProperty(a) && (r[a] = n[a], delete n[a]);
  };
  return _q.forEach(i), NS.forEach(i), {
    forwardedProps: n,
    internalProps: r
  };
}, [e, t]), jq = /* @__PURE__ */ w.createContext(null);
function BS(e) {
  const {
    contextValue: t,
    localeText: n,
    children: r
  } = e;
  return /* @__PURE__ */ x.jsx(jq.Provider, {
    value: t,
    children: /* @__PURE__ */ x.jsx(mg, {
      localeText: n,
      children: r
    })
  });
}
const $q = (e) => {
  const t = un(), n = Ul();
  return J({}, e, {
    disablePast: e.disablePast ?? !1,
    disableFuture: e.disableFuture ?? !1,
    format: e.format ?? t.formats.keyboardDate,
    minDate: Zr(t, e.minDate, n.minDate),
    maxDate: Zr(t, e.maxDate, n.maxDate)
  });
}, Aq = (e) => {
  const t = $q(e), {
    forwardedProps: n,
    internalProps: r
  } = Iq(t, "date");
  return kq({
    forwardedProps: n,
    internalProps: r,
    valueManager: $o,
    fieldValueManager: rq,
    validator: Yl,
    valueType: "date"
  });
};
function Nq(e) {
  return ze("MuiPickersTextField", e);
}
Ve("MuiPickersTextField", ["root", "focused", "disabled", "error", "required"]);
function Fq(e) {
  return ze("MuiPickersInputBase", e);
}
const Ga = Ve("MuiPickersInputBase", ["root", "focused", "disabled", "error", "notchedOutline", "sectionContent", "sectionBefore", "sectionAfter", "adornedStart", "adornedEnd", "input"]);
function Lq(e) {
  return ze("MuiPickersSectionList", e);
}
const Gs = Ve("MuiPickersSectionList", ["root", "section", "sectionContent"]), Bq = ["slots", "slotProps", "elements", "sectionListRef"], VS = ae("div", {
  name: "MuiPickersSectionList",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  direction: "ltr /*! @noflip */",
  outline: "none"
}), zS = ae("span", {
  name: "MuiPickersSectionList",
  slot: "Section",
  overridesResolver: (e, t) => t.section
})({}), WS = ae("span", {
  name: "MuiPickersSectionList",
  slot: "SectionSeparator",
  overridesResolver: (e, t) => t.sectionSeparator
})({
  whiteSpace: "pre"
}), qS = ae("span", {
  name: "MuiPickersSectionList",
  slot: "SectionContent",
  overridesResolver: (e, t) => t.sectionContent
})({
  outline: "none"
}), Vq = (e) => {
  const {
    classes: t
  } = e;
  return We({
    root: ["root"],
    section: ["section"],
    sectionContent: ["sectionContent"]
  }, Lq, t);
};
function HS(e) {
  const {
    slots: t,
    slotProps: n,
    element: r,
    classes: i
  } = e, a = (t == null ? void 0 : t.section) ?? zS, l = Nt({
    elementType: a,
    externalSlotProps: n == null ? void 0 : n.section,
    externalForwardedProps: r.container,
    className: i.section,
    ownerState: {}
  }), u = (t == null ? void 0 : t.sectionContent) ?? qS, d = Nt({
    elementType: u,
    externalSlotProps: n == null ? void 0 : n.sectionContent,
    externalForwardedProps: r.content,
    additionalProps: {
      suppressContentEditableWarning: !0
    },
    className: i.sectionContent,
    ownerState: {}
  }), p = (t == null ? void 0 : t.sectionSeparator) ?? WS, m = Nt({
    elementType: p,
    externalSlotProps: n == null ? void 0 : n.sectionSeparator,
    externalForwardedProps: r.before,
    ownerState: {
      position: "before"
    }
  }), h = Nt({
    elementType: p,
    externalSlotProps: n == null ? void 0 : n.sectionSeparator,
    externalForwardedProps: r.after,
    ownerState: {
      position: "after"
    }
  });
  return /* @__PURE__ */ x.jsxs(a, J({}, l, {
    children: [/* @__PURE__ */ x.jsx(p, J({}, m)), /* @__PURE__ */ x.jsx(u, J({}, d)), /* @__PURE__ */ x.jsx(p, J({}, h))]
  }));
}
process.env.NODE_ENV !== "production" && (HS.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  classes: o.object.isRequired,
  element: o.shape({
    after: o.object.isRequired,
    before: o.object.isRequired,
    container: o.object.isRequired,
    content: o.object.isRequired
  }).isRequired,
  /**
   * The props used for each component slot.
   */
  slotProps: o.object,
  /**
   * Overridable component slots.
   */
  slots: o.object
});
const US = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = cn({
    props: t,
    name: "MuiPickersSectionList"
  }), {
    slots: i,
    slotProps: a,
    elements: l,
    sectionListRef: u
  } = r, d = ht(r, Bq), p = Vq(r), m = w.useRef(null), h = It(n, m), g = (y) => {
    if (!m.current)
      throw new Error(`MUI X: Cannot call sectionListRef.${y} before the mount of the component.`);
    return m.current;
  };
  w.useImperativeHandle(u, () => ({
    getRoot() {
      return g("getRoot");
    },
    getSectionContainer(y) {
      return g("getSectionContainer").querySelector(`.${Gs.section}[data-sectionindex="${y}"]`);
    },
    getSectionContent(y) {
      return g("getSectionContent").querySelector(`.${Gs.section}[data-sectionindex="${y}"] .${Gs.sectionContent}`);
    },
    getSectionIndexFromDOMElement(y) {
      const S = g("getSectionIndexFromDOMElement");
      if (y == null || !S.contains(y))
        return null;
      let O = null;
      return y.classList.contains(Gs.section) ? O = y : y.classList.contains(Gs.sectionContent) && (O = y.parentElement), O == null ? null : Number(O.dataset.sectionindex);
    }
  }));
  const v = (i == null ? void 0 : i.root) ?? VS, b = Nt({
    elementType: v,
    externalSlotProps: a == null ? void 0 : a.root,
    externalForwardedProps: d,
    additionalProps: {
      ref: h,
      suppressContentEditableWarning: !0
    },
    className: p.root,
    ownerState: {}
  });
  return /* @__PURE__ */ x.jsx(v, J({}, b, {
    children: b.contentEditable ? l.map(({
      content: y,
      before: S,
      after: O
    }) => `${S.children}${y.children}${O.children}`).join("") : /* @__PURE__ */ x.jsx(w.Fragment, {
      children: l.map((y, S) => /* @__PURE__ */ x.jsx(HS, {
        slots: i,
        slotProps: a,
        element: y,
        classes: p
      }, S))
    })
  }));
});
process.env.NODE_ENV !== "production" && (US.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: o.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: o.arrayOf(o.shape({
    after: o.object.isRequired,
    before: o.object.isRequired,
    container: o.object.isRequired,
    content: o.object.isRequired
  })).isRequired,
  sectionListRef: o.oneOfType([o.func, o.shape({
    current: o.shape({
      getRoot: o.func.isRequired,
      getSectionContainer: o.func.isRequired,
      getSectionContent: o.func.isRequired,
      getSectionIndexFromDOMElement: o.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   */
  slotProps: o.object,
  /**
   * Overridable component slots.
   */
  slots: o.object
});
const zq = ["elements", "areAllSectionsEmpty", "defaultValue", "label", "value", "onChange", "id", "autoFocus", "endAdornment", "startAdornment", "renderSuffix", "slots", "slotProps", "contentEditable", "tabIndex", "onInput", "onPaste", "onKeyDown", "fullWidth", "name", "readOnly", "inputProps", "inputRef", "sectionListRef"], Wq = (e) => Math.round(e * 1e5) / 1e5, Ld = ae("div", {
  name: "MuiPickersInputBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => J({}, e.typography.body1, {
  color: (e.vars || e).palette.text.primary,
  cursor: "text",
  padding: 0,
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  letterSpacing: `${Wq(0.15 / 16)}em`,
  variants: [{
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }]
})), Sg = ae(VS, {
  name: "MuiPickersInputBase",
  slot: "SectionsContainer",
  overridesResolver: (e, t) => t.sectionsContainer
})(({
  theme: e
}) => ({
  padding: "4px 0 5px",
  fontFamily: e.typography.fontFamily,
  fontSize: "inherit",
  lineHeight: "1.4375em",
  // 23px
  flexGrow: 1,
  outline: "none",
  display: "flex",
  flexWrap: "nowrap",
  overflow: "hidden",
  letterSpacing: "inherit",
  // Baseline behavior
  width: "182px",
  variants: [{
    props: {
      isRtl: !0
    },
    style: {
      textAlign: "right /*! @noflip */"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      paddingTop: 1
    }
  }, {
    props: {
      adornedStart: !1,
      focused: !1,
      filled: !1
    },
    style: {
      color: "currentColor",
      opacity: 0
    }
  }, {
    // Can't use the object notation because label can be null or undefined
    props: ({
      adornedStart: t,
      focused: n,
      filled: r,
      label: i
    }) => !t && !n && !r && i == null,
    style: e.vars ? {
      opacity: e.vars.opacity.inputPlaceholder
    } : {
      opacity: e.palette.mode === "light" ? 0.42 : 0.5
    }
  }]
})), qq = ae(zS, {
  name: "MuiPickersInputBase",
  slot: "Section",
  overridesResolver: (e, t) => t.section
})(({
  theme: e
}) => ({
  fontFamily: e.typography.fontFamily,
  fontSize: "inherit",
  letterSpacing: "inherit",
  lineHeight: "1.4375em",
  // 23px
  display: "inline-block",
  whiteSpace: "nowrap"
})), Hq = ae(qS, {
  name: "MuiPickersInputBase",
  slot: "SectionContent",
  overridesResolver: (e, t) => t.content
})(({
  theme: e
}) => ({
  fontFamily: e.typography.fontFamily,
  lineHeight: "1.4375em",
  // 23px
  letterSpacing: "inherit",
  width: "fit-content",
  outline: "none"
})), Uq = ae(WS, {
  name: "MuiPickersInputBase",
  slot: "Separator",
  overridesResolver: (e, t) => t.separator
})(() => ({
  whiteSpace: "pre",
  letterSpacing: "inherit"
})), Yq = ae("input", {
  name: "MuiPickersInputBase",
  slot: "Input",
  overridesResolver: (e, t) => t.hiddenInput
})(J({}, Dj)), Gq = (e) => {
  const {
    focused: t,
    disabled: n,
    error: r,
    classes: i,
    fullWidth: a,
    readOnly: l,
    color: u,
    size: d,
    endAdornment: p,
    startAdornment: m
  } = e, h = {
    root: ["root", t && !n && "focused", n && "disabled", l && "readOnly", r && "error", a && "fullWidth", `color${ke(u)}`, d === "small" && "inputSizeSmall", !!m && "adornedStart", !!p && "adornedEnd"],
    notchedOutline: ["notchedOutline"],
    input: ["input"],
    sectionsContainer: ["sectionsContainer"],
    sectionContent: ["sectionContent"],
    sectionBefore: ["sectionBefore"],
    sectionAfter: ["sectionAfter"]
  };
  return We(h, Fq, i);
}, Bd = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = cn({
    props: t,
    name: "MuiPickersInputBase"
  }), {
    elements: i,
    areAllSectionsEmpty: a,
    value: l,
    onChange: u,
    id: d,
    endAdornment: p,
    startAdornment: m,
    renderSuffix: h,
    slots: g,
    slotProps: v,
    contentEditable: b,
    tabIndex: y,
    onInput: S,
    onPaste: O,
    onKeyDown: P,
    name: k,
    readOnly: R,
    inputProps: E,
    inputRef: M,
    sectionListRef: _
  } = r, I = ht(r, zq), F = w.useRef(null), T = It(n, F), $ = It(E == null ? void 0 : E.ref, M), N = eo(), W = ar();
  if (!W)
    throw new Error("MUI X: PickersInputBase should always be used inside a PickersTextField component");
  const L = (G) => {
    var Q;
    if (W.disabled) {
      G.stopPropagation();
      return;
    }
    (Q = W.onFocus) == null || Q.call(W, G);
  };
  w.useEffect(() => {
    W && W.setAdornedStart(!!m);
  }, [W, m]), w.useEffect(() => {
    W && (a ? W.onEmpty() : W.onFilled());
  }, [W, a]);
  const V = J({}, r, W, {
    isRtl: N
  }), z = Gq(V), X = (g == null ? void 0 : g.root) || Ld, le = Nt({
    elementType: X,
    externalSlotProps: v == null ? void 0 : v.root,
    externalForwardedProps: I,
    additionalProps: {
      "aria-invalid": W.error,
      ref: T
    },
    className: z.root,
    ownerState: V
  }), ne = (g == null ? void 0 : g.input) || Sg;
  return /* @__PURE__ */ x.jsxs(X, J({}, le, {
    children: [m, /* @__PURE__ */ x.jsx(US, {
      sectionListRef: _,
      elements: i,
      contentEditable: b,
      tabIndex: y,
      className: z.sectionsContainer,
      onFocus: L,
      onBlur: W.onBlur,
      onInput: S,
      onPaste: O,
      onKeyDown: P,
      slots: {
        root: ne,
        section: qq,
        sectionContent: Hq,
        sectionSeparator: Uq
      },
      slotProps: {
        root: {
          ownerState: V
        },
        sectionContent: {
          className: Ga.sectionContent
        },
        sectionSeparator: ({
          position: G
        }) => ({
          className: G === "before" ? Ga.sectionBefore : Ga.sectionAfter
        })
      }
    }), p, h ? h(J({}, W)) : null, /* @__PURE__ */ x.jsx(Yq, J({
      name: k,
      className: z.input,
      value: l,
      onChange: u,
      id: d,
      "aria-hidden": "true",
      tabIndex: -1,
      readOnly: R,
      required: W.required,
      disabled: W.disabled
    }, E, {
      ref: $
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (Bd.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: o.bool.isRequired,
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: o.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: o.arrayOf(o.shape({
    after: o.object.isRequired,
    before: o.object.isRequired,
    container: o.object.isRequired,
    content: o.object.isRequired
  })).isRequired,
  endAdornment: o.node,
  fullWidth: o.bool,
  id: o.string,
  inputProps: o.object,
  inputRef: gn,
  label: o.node,
  margin: o.oneOf(["dense", "none", "normal"]),
  name: o.string,
  onChange: o.func.isRequired,
  onClick: o.func.isRequired,
  onInput: o.func.isRequired,
  onKeyDown: o.func.isRequired,
  onPaste: o.func.isRequired,
  ownerState: o.any,
  readOnly: o.bool,
  renderSuffix: o.func,
  sectionListRef: o.oneOfType([o.func, o.shape({
    current: o.shape({
      getRoot: o.func.isRequired,
      getSectionContainer: o.func.isRequired,
      getSectionContent: o.func.isRequired,
      getSectionIndexFromDOMElement: o.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: o.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: o.object,
  startAdornment: o.node,
  style: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  value: o.string.isRequired
});
function Kq(e) {
  return ze("MuiPickersOutlinedInput", e);
}
const co = J({}, Ga, Ve("MuiPickersOutlinedInput", ["root", "notchedOutline", "input"])), Xq = ["children", "className", "label", "notched", "shrink"], Qq = ae("fieldset", {
  name: "MuiPickersOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (e, t) => t.notchedOutline
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%",
    borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
  };
}), R0 = ae("span")(({
  theme: e
}) => ({
  fontFamily: e.typography.fontFamily,
  fontSize: "inherit"
})), Zq = ae("legend")(({
  theme: e
}) => ({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden",
  // Fix Horizontal scroll when label too long
  variants: [{
    props: {
      withLabel: !1
    },
    style: {
      padding: 0,
      lineHeight: "11px",
      // sync with `height` in `legend` styles
      transition: e.transitions.create("width", {
        duration: 150,
        easing: e.transitions.easing.easeOut
      })
    }
  }, {
    props: {
      withLabel: !0
    },
    style: {
      display: "block",
      // Fix conflict with normalize.css and sanitize.css
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: "0.75em",
      visibility: "hidden",
      maxWidth: 0.01,
      transition: e.transitions.create("max-width", {
        duration: 50,
        easing: e.transitions.easing.easeOut
      }),
      whiteSpace: "nowrap",
      "& > span": {
        paddingLeft: 5,
        paddingRight: 5,
        display: "inline-block",
        opacity: 0,
        visibility: "visible"
      }
    }
  }, {
    props: {
      withLabel: !0,
      notched: !0
    },
    style: {
      maxWidth: "100%",
      transition: e.transitions.create("max-width", {
        duration: 100,
        easing: e.transitions.easing.easeOut,
        delay: 50
      })
    }
  }]
}));
function Jq(e) {
  const {
    className: t,
    label: n
  } = e, r = ht(e, Xq), i = n != null && n !== "", a = J({}, e, {
    withLabel: i
  });
  return /* @__PURE__ */ x.jsx(Qq, J({
    "aria-hidden": !0,
    className: t
  }, r, {
    ownerState: a,
    children: /* @__PURE__ */ x.jsx(Zq, {
      ownerState: a,
      children: i ? /* @__PURE__ */ x.jsx(R0, {
        children: n
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        /* @__PURE__ */ x.jsx(R0, {
          className: "notranslate",
          children: "​"
        })
      )
    })
  }));
}
const eH = ["label", "autoFocus", "ownerState", "notched"], tH = ae(Ld, {
  name: "MuiPickersOutlinedInput",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    padding: "0 14px",
    borderRadius: (e.vars || e).shape.borderRadius,
    [`&:hover .${co.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${co.notchedOutline}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
      }
    },
    [`&.${co.focused} .${co.notchedOutline}`]: {
      borderStyle: "solid",
      borderWidth: 2
    },
    [`&.${co.disabled}`]: {
      [`& .${co.notchedOutline}`]: {
        borderColor: (e.vars || e).palette.action.disabled
      },
      "*": {
        color: (e.vars || e).palette.action.disabled
      }
    },
    [`&.${co.error} .${co.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.error.main
    },
    variants: Object.keys((e.vars ?? e).palette).filter((n) => {
      var r;
      return ((r = (e.vars ?? e).palette[n]) == null ? void 0 : r.main) ?? !1;
    }).map((n) => ({
      props: {
        color: n
      },
      style: {
        [`&.${co.focused}:not(.${co.error}) .${co.notchedOutline}`]: {
          // @ts-ignore
          borderColor: (e.vars || e).palette[n].main
        }
      }
    }))
  };
}), nH = ae(Sg, {
  name: "MuiPickersOutlinedInput",
  slot: "SectionsContainer",
  overridesResolver: (e, t) => t.sectionsContainer
})({
  padding: "16.5px 0",
  variants: [{
    props: {
      size: "small"
    },
    style: {
      padding: "8.5px 0"
    }
  }]
}), rH = (e) => {
  const {
    classes: t
  } = e, r = We({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, Kq, t);
  return J({}, t, r);
}, Og = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = cn({
    props: t,
    name: "MuiPickersOutlinedInput"
  }), {
    label: i,
    ownerState: a,
    notched: l
  } = r, u = ht(r, eH), d = ar(), p = J({}, r, a, d, {
    color: (d == null ? void 0 : d.color) || "primary"
  }), m = rH(p);
  return /* @__PURE__ */ x.jsx(Bd, J({
    slots: {
      root: tH,
      input: nH
    },
    renderSuffix: (h) => /* @__PURE__ */ x.jsx(Jq, {
      shrink: !!(l || h.adornedStart || h.focused || h.filled),
      notched: !!(l || h.adornedStart || h.focused || h.filled),
      className: m.notchedOutline,
      label: i != null && i !== "" && (d != null && d.required) ? /* @__PURE__ */ x.jsxs(w.Fragment, {
        children: [i, " ", "*"]
      }) : i,
      ownerState: p
    })
  }, u, {
    label: i,
    classes: m,
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (Og.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: o.bool.isRequired,
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: o.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: o.arrayOf(o.shape({
    after: o.object.isRequired,
    before: o.object.isRequired,
    container: o.object.isRequired,
    content: o.object.isRequired
  })).isRequired,
  endAdornment: o.node,
  fullWidth: o.bool,
  id: o.string,
  inputProps: o.object,
  inputRef: gn,
  label: o.node,
  margin: o.oneOf(["dense", "none", "normal"]),
  name: o.string,
  notched: o.bool,
  onChange: o.func.isRequired,
  onClick: o.func.isRequired,
  onInput: o.func.isRequired,
  onKeyDown: o.func.isRequired,
  onPaste: o.func.isRequired,
  ownerState: o.any,
  readOnly: o.bool,
  renderSuffix: o.func,
  sectionListRef: o.oneOfType([o.func, o.shape({
    current: o.shape({
      getRoot: o.func.isRequired,
      getSectionContainer: o.func.isRequired,
      getSectionContent: o.func.isRequired,
      getSectionIndexFromDOMElement: o.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: o.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: o.object,
  startAdornment: o.node,
  style: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  value: o.string.isRequired
});
Og.muiName = "Input";
function oH(e) {
  return ze("MuiPickersFilledInput", e);
}
const ea = J({}, Ga, Ve("MuiPickersFilledInput", ["root", "underline", "input"])), iH = ["label", "autoFocus", "disableUnderline", "ownerState"], aH = ae(Ld, {
  name: "MuiPickersFilledInput",
  slot: "Root",
  overridesResolver: (e, t) => t.root,
  shouldForwardProp: (e) => cu(e) && e !== "disableUnderline"
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light", n = t ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", r = t ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", i = t ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", a = t ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return {
    backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r,
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.shorter,
      easing: e.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.hoverBg : i,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r
      }
    },
    [`&.${ea.focused}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r
    },
    [`&.${ea.disabled}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.disabledBg : a
    },
    variants: [...Object.keys((e.vars ?? e).palette).filter((l) => (e.vars ?? e).palette[l].main).map((l) => {
      var u;
      return {
        props: {
          color: l,
          disableUnderline: !1
        },
        style: {
          "&::after": {
            // @ts-ignore
            borderBottom: `2px solid ${(u = (e.vars || e).palette[l]) == null ? void 0 : u.main}`
          }
        }
      };
    }), {
      props: {
        disableUnderline: !1
      },
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${ea.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${ea.error}`]: {
          "&:before, &:after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})` : n}`,
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${ea.disabled}, .${ea.error}):before`]: {
          borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`
        },
        [`&.${ea.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, {
      props: ({
        startAdornment: l
      }) => !!l,
      style: {
        paddingLeft: 12
      }
    }, {
      props: ({
        endAdornment: l
      }) => !!l,
      style: {
        paddingRight: 12
      }
    }]
  };
}), sH = ae(Sg, {
  name: "MuiPickersFilledInput",
  slot: "sectionsContainer",
  overridesResolver: (e, t) => t.sectionsContainer
})({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      paddingTop: 21,
      paddingBottom: 4
    }
  }, {
    props: ({
      startAdornment: e
    }) => !!e,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      endAdornment: e
    }) => !!e,
    style: {
      paddingRight: 0
    }
  }, {
    props: {
      hiddenLabel: !0
    },
    style: {
      paddingTop: 16,
      paddingBottom: 17
    }
  }, {
    props: {
      hiddenLabel: !0,
      size: "small"
    },
    style: {
      paddingTop: 8,
      paddingBottom: 9
    }
  }]
}), lH = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, i = We({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, oH, t);
  return J({}, t, i);
}, Tg = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = cn({
    props: t,
    name: "MuiPickersFilledInput"
  }), {
    label: i,
    disableUnderline: a = !1,
    ownerState: l
  } = r, u = ht(r, iH), d = ar(), p = J({}, r, l, d, {
    color: (d == null ? void 0 : d.color) || "primary"
  }), m = lH(p);
  return /* @__PURE__ */ x.jsx(Bd, J({
    slots: {
      root: aH,
      input: sH
    },
    slotProps: {
      root: {
        disableUnderline: a
      }
    }
  }, u, {
    label: i,
    classes: m,
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (Tg.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: o.bool.isRequired,
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: o.bool.isRequired,
  disableUnderline: o.bool,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: o.arrayOf(o.shape({
    after: o.object.isRequired,
    before: o.object.isRequired,
    container: o.object.isRequired,
    content: o.object.isRequired
  })).isRequired,
  endAdornment: o.node,
  fullWidth: o.bool,
  hiddenLabel: o.bool,
  id: o.string,
  inputProps: o.object,
  inputRef: gn,
  label: o.node,
  margin: o.oneOf(["dense", "none", "normal"]),
  name: o.string,
  onChange: o.func.isRequired,
  onClick: o.func.isRequired,
  onInput: o.func.isRequired,
  onKeyDown: o.func.isRequired,
  onPaste: o.func.isRequired,
  ownerState: o.any,
  readOnly: o.bool,
  renderSuffix: o.func,
  sectionListRef: o.oneOfType([o.func, o.shape({
    current: o.shape({
      getRoot: o.func.isRequired,
      getSectionContainer: o.func.isRequired,
      getSectionContent: o.func.isRequired,
      getSectionIndexFromDOMElement: o.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: o.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: o.object,
  startAdornment: o.node,
  style: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  value: o.string.isRequired
});
Tg.muiName = "Input";
function cH(e) {
  return ze("MuiPickersFilledInput", e);
}
const Ks = J({}, Ga, Ve("MuiPickersInput", ["root", "input"])), uH = ["label", "autoFocus", "disableUnderline", "ownerState"], dH = ae(Ld, {
  name: "MuiPickersInput",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => {
  let n = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return e.vars && (n = `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`), {
    "label + &": {
      marginTop: 16
    },
    variants: [...Object.keys((e.vars ?? e).palette).filter((r) => (e.vars ?? e).palette[r].main).map((r) => ({
      props: {
        color: r
      },
      style: {
        "&::after": {
          // @ts-ignore
          borderBottom: `2px solid ${(e.vars || e).palette[r].main}`
        }
      }
    })), {
      props: {
        disableUnderline: !1
      },
      style: {
        "&::after": {
          background: "red",
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${Ks.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${Ks.error}`]: {
          "&:before, &:after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${n}`,
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${Ks.disabled}, .${Ks.error}):before`]: {
          borderBottom: `2px solid ${(e.vars || e).palette.text.primary}`,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            borderBottom: `1px solid ${n}`
          }
        },
        [`&.${Ks.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }]
  };
}), pH = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, i = We({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, cH, t);
  return J({}, t, i);
}, Eg = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = cn({
    props: t,
    name: "MuiPickersInput"
  }), {
    label: i,
    disableUnderline: a = !1,
    ownerState: l
  } = r, u = ht(r, uH), d = ar(), p = J({}, r, l, d, {
    disableUnderline: a,
    color: (d == null ? void 0 : d.color) || "primary"
  }), m = pH(p);
  return /* @__PURE__ */ x.jsx(Bd, J({
    slots: {
      root: dH
    }
  }, u, {
    label: i,
    classes: m,
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (Eg.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: o.bool.isRequired,
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: o.bool.isRequired,
  disableUnderline: o.bool,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: o.arrayOf(o.shape({
    after: o.object.isRequired,
    before: o.object.isRequired,
    container: o.object.isRequired,
    content: o.object.isRequired
  })).isRequired,
  endAdornment: o.node,
  fullWidth: o.bool,
  id: o.string,
  inputProps: o.object,
  inputRef: gn,
  label: o.node,
  margin: o.oneOf(["dense", "none", "normal"]),
  name: o.string,
  onChange: o.func.isRequired,
  onClick: o.func.isRequired,
  onInput: o.func.isRequired,
  onKeyDown: o.func.isRequired,
  onPaste: o.func.isRequired,
  ownerState: o.any,
  readOnly: o.bool,
  renderSuffix: o.func,
  sectionListRef: o.oneOfType([o.func, o.shape({
    current: o.shape({
      getRoot: o.func.isRequired,
      getSectionContainer: o.func.isRequired,
      getSectionContent: o.func.isRequired,
      getSectionIndexFromDOMElement: o.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: o.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: o.object,
  startAdornment: o.node,
  style: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  value: o.string.isRequired
});
Eg.muiName = "Input";
const fH = ["onFocus", "onBlur", "className", "color", "disabled", "error", "variant", "required", "InputProps", "inputProps", "inputRef", "sectionListRef", "elements", "areAllSectionsEmpty", "onClick", "onKeyDown", "onKeyUp", "onPaste", "onInput", "endAdornment", "startAdornment", "tabIndex", "contentEditable", "focused", "value", "onChange", "fullWidth", "id", "name", "helperText", "FormHelperTextProps", "label", "InputLabelProps"], mH = {
  standard: Eg,
  filled: Tg,
  outlined: Og
}, hH = ae(sr, {
  name: "MuiPickersTextField",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), gH = (e) => {
  const {
    focused: t,
    disabled: n,
    classes: r,
    required: i
  } = e;
  return We({
    root: ["root", t && !n && "focused", n && "disabled", i && "required"]
  }, Nq, r);
}, YS = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = cn({
    props: t,
    name: "MuiPickersTextField"
  }), {
    // Props used by FormControl
    onFocus: i,
    onBlur: a,
    className: l,
    color: u = "primary",
    disabled: d = !1,
    error: p = !1,
    variant: m = "outlined",
    required: h = !1,
    // Props used by PickersInput
    InputProps: g,
    inputProps: v,
    inputRef: b,
    sectionListRef: y,
    elements: S,
    areAllSectionsEmpty: O,
    onClick: P,
    onKeyDown: k,
    onKeyUp: R,
    onPaste: E,
    onInput: M,
    endAdornment: _,
    startAdornment: I,
    tabIndex: F,
    contentEditable: T,
    focused: $,
    value: N,
    onChange: W,
    fullWidth: L,
    id: V,
    name: z,
    // Props used by FormHelperText
    helperText: X,
    FormHelperTextProps: le,
    // Props used by InputLabel
    label: ne,
    InputLabelProps: G
  } = r, Q = ht(r, fH), be = w.useRef(null), we = It(n, be), se = Ir(V), U = X && se ? `${se}-helper-text` : void 0, de = ne && se ? `${se}-label` : void 0, ce = J({}, r, {
    color: u,
    disabled: d,
    error: p,
    focused: $,
    required: h,
    variant: m
  }), K = gH(ce), Z = mH[m];
  return /* @__PURE__ */ x.jsxs(hH, J({
    className: Me(K.root, l),
    ref: we,
    focused: $,
    onFocus: i,
    onBlur: a,
    disabled: d,
    variant: m,
    error: p,
    color: u,
    fullWidth: L,
    required: h,
    ownerState: ce
  }, Q, {
    children: [/* @__PURE__ */ x.jsx(Vh, J({
      htmlFor: se,
      id: de
    }, G, {
      children: ne
    })), /* @__PURE__ */ x.jsx(Z, J({
      elements: S,
      areAllSectionsEmpty: O,
      onClick: P,
      onKeyDown: k,
      onKeyUp: R,
      onInput: M,
      onPaste: E,
      endAdornment: _,
      startAdornment: I,
      tabIndex: F,
      contentEditable: T,
      value: N,
      onChange: W,
      id: se,
      fullWidth: L,
      inputProps: v,
      inputRef: b,
      sectionListRef: y,
      label: ne,
      name: z,
      role: "group",
      "aria-labelledby": de
    }, g)), X && /* @__PURE__ */ x.jsx(Bh, J({
      id: U
    }, le, {
      children: X
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (YS.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: o.bool.isRequired,
  className: o.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: o.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: o.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: o.bool.isRequired,
  disabled: o.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: o.arrayOf(o.shape({
    after: o.object.isRequired,
    before: o.object.isRequired,
    container: o.object.isRequired,
    content: o.object.isRequired
  })).isRequired,
  endAdornment: o.node,
  error: o.bool.isRequired,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: o.bool,
  FormHelperTextProps: o.object,
  fullWidth: o.bool,
  /**
   * The helper text content.
   */
  helperText: o.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: o.bool,
  id: o.string,
  InputLabelProps: o.object,
  inputProps: o.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: o.object,
  inputRef: gn,
  label: o.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: o.oneOf(["dense", "none", "normal"]),
  name: o.string,
  onBlur: o.func.isRequired,
  onChange: o.func.isRequired,
  onClick: o.func.isRequired,
  onFocus: o.func.isRequired,
  onInput: o.func.isRequired,
  onKeyDown: o.func.isRequired,
  onPaste: o.func.isRequired,
  readOnly: o.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: o.bool,
  sectionListRef: o.oneOfType([o.func, o.shape({
    current: o.shape({
      getRoot: o.func.isRequired,
      getSectionContainer: o.func.isRequired,
      getSectionContent: o.func.isRequired,
      getSectionIndexFromDOMElement: o.func.isRequired
    })
  })]),
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: o.oneOf(["medium", "small"]),
  startAdornment: o.node,
  style: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  value: o.string.isRequired,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: o.oneOf(["filled", "outlined", "standard"])
});
const yH = ["enableAccessibleFieldDOMStructure"], bH = ["InputProps", "readOnly"], vH = ["onPaste", "onKeyDown", "inputMode", "readOnly", "InputProps", "inputProps", "inputRef"], xH = (e) => {
  let {
    enableAccessibleFieldDOMStructure: t
  } = e, n = ht(e, yH);
  if (t) {
    const {
      InputProps: h,
      readOnly: g
    } = n, v = ht(n, bH);
    return J({}, v, {
      InputProps: J({}, h ?? {}, {
        readOnly: g
      })
    });
  }
  const {
    onPaste: r,
    onKeyDown: i,
    inputMode: a,
    readOnly: l,
    InputProps: u,
    inputProps: d,
    inputRef: p
  } = n, m = ht(n, vH);
  return J({}, m, {
    InputProps: J({}, u ?? {}, {
      readOnly: l
    }),
    inputProps: J({}, d ?? {}, {
      inputMode: a,
      onPaste: r,
      onKeyDown: i,
      ref: p
    })
  });
}, wH = ["slots", "slotProps", "InputProps", "inputProps"], Rg = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = cn({
    props: t,
    name: "MuiDateField"
  }), {
    slots: i,
    slotProps: a,
    InputProps: l,
    inputProps: u
  } = r, d = ht(r, wH), p = r, m = (i == null ? void 0 : i.textField) ?? (t.enableAccessibleFieldDOMStructure ? YS : ms), h = Nt({
    elementType: m,
    externalSlotProps: a == null ? void 0 : a.textField,
    externalForwardedProps: d,
    additionalProps: {
      ref: n
    },
    ownerState: p
  });
  h.inputProps = J({}, u, h.inputProps), h.InputProps = J({}, l, h.InputProps);
  const g = Aq(h), v = xH(g), b = Mq(J({}, v, {
    slots: i,
    slotProps: a
  }));
  return /* @__PURE__ */ x.jsx(m, J({}, b));
});
process.env.NODE_ENV !== "production" && (Rg.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: o.bool,
  className: o.string,
  /**
   * If `true`, a clear button will be shown in the field allowing value clearing.
   * @default false
   */
  clearable: o.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: o.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: o.elementType,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: o.object,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: o.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: o.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: o.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: o.bool,
  /**
   * Format of the date when rendered in the input(s).
   */
  format: o.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: o.oneOf(["dense", "spacious"]),
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: o.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: o.bool,
  /**
   * The helper text content.
   */
  helperText: o.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: o.bool,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: o.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: o.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: o.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: o.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: gn,
  /**
   * The label content.
   */
  label: o.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: o.oneOf(["dense", "none", "normal"]),
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: o.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: o.object,
  /**
   * Name attribute of the `input` element.
   */
  name: o.string,
  onBlur: o.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: o.func,
  /**
   * Callback fired when the clear button is clicked.
   */
  onClear: o.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: o.func,
  onFocus: o.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: o.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   * @default false
   */
  readOnly: o.bool,
  /**
   * The date used to generate a part of the new value that is not present in the format when both `value` and `defaultValue` are empty.
   * For example, on time fields it will be used to determine the date to set.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`. Value is rounded to the most granular section used.
   */
  referenceDate: o.object,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: o.bool,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: o.oneOfType([o.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), o.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: o.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: o.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: o.func,
  /**
   * If `true`, the format will respect the leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `8/16/2018`)
   * If `false`, the format will always add leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `08/16/2018`)
   *
   * Warning n°1: Luxon is not able to respect the leading zeroes when using macro tokens (e.g: "DD"), so `shouldRespectLeadingZeros={true}` might lead to inconsistencies when using `AdapterLuxon`.
   *
   * Warning n°2: When `shouldRespectLeadingZeros={true}`, the field will add an invisible character on the sections containing a single digit to make sure `onChange` is fired.
   * If you need to get the clean value from the input, you can remove this character using `input.value.replace(/\u200e/g, '')`.
   *
   * Warning n°3: When used in strict mode, dayjs and moment require to respect the leading zeros.
   * This mean that when using `shouldRespectLeadingZeros={false}`, if you retrieve the value directly from the input (not listening to `onChange`) and your format contains tokens without leading zeros, the value will not be parsed by your library.
   *
   * @default false
   */
  shouldRespectLeadingZeros: o.bool,
  /**
   * The size of the component.
   */
  size: o.oneOf(["medium", "small"]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: o.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: o.object,
  style: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: o.string,
  /**
   * The ref object used to imperatively interact with the field.
   */
  unstableFieldRef: o.oneOfType([o.func, o.object]),
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: o.object,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: o.oneOf(["filled", "outlined", "standard"])
});
const GS = ({
  shouldDisableDate: e,
  shouldDisableMonth: t,
  shouldDisableYear: n,
  minDate: r,
  maxDate: i,
  disableFuture: a,
  disablePast: l,
  timezone: u
}) => {
  const d = ya();
  return w.useCallback((p) => Yl({
    adapter: d,
    value: p,
    timezone: u,
    props: {
      shouldDisableDate: e,
      shouldDisableMonth: t,
      shouldDisableYear: n,
      minDate: r,
      maxDate: i,
      disableFuture: a,
      disablePast: l
    }
  }) !== null, [d, e, t, n, r, i, a, l, u]);
}, CH = (e, t, n) => (r, i) => {
  switch (i.type) {
    case "changeMonth":
      return J({}, r, {
        slideDirection: i.direction,
        currentMonth: i.newMonth,
        isMonthSwitchingAnimating: !e
      });
    case "changeMonthTimezone": {
      const a = i.newTimezone;
      if (n.getTimezone(r.currentMonth) === a)
        return r;
      let l = n.setTimezone(r.currentMonth, a);
      return n.getMonth(l) !== n.getMonth(r.currentMonth) && (l = n.setMonth(l, n.getMonth(r.currentMonth))), J({}, r, {
        currentMonth: l
      });
    }
    case "finishMonthSwitchingAnimation":
      return J({}, r, {
        isMonthSwitchingAnimating: !1
      });
    case "changeFocusedDay": {
      if (r.focusedDay != null && i.focusedDay != null && n.isSameDay(i.focusedDay, r.focusedDay))
        return r;
      const a = i.focusedDay != null && !t && !n.isSameMonth(r.currentMonth, i.focusedDay);
      return J({}, r, {
        focusedDay: i.focusedDay,
        isMonthSwitchingAnimating: a && !e && !i.withoutMonthSwitchingAnimation,
        currentMonth: a ? n.startOfMonth(i.focusedDay) : r.currentMonth,
        slideDirection: i.focusedDay != null && n.isAfterDay(i.focusedDay, r.currentMonth) ? "left" : "right"
      });
    }
    default:
      throw new Error("missing support");
  }
}, SH = (e) => {
  const {
    value: t,
    referenceDate: n,
    disableFuture: r,
    disablePast: i,
    disableSwitchToMonthOnDayFocus: a = !1,
    maxDate: l,
    minDate: u,
    onMonthChange: d,
    reduceAnimations: p,
    shouldDisableDate: m,
    timezone: h
  } = e, g = un(), v = w.useRef(CH(!!p, a, g)).current, b = w.useMemo(
    () => $o.getInitialReferenceValue({
      value: t,
      utils: g,
      timezone: h,
      props: e,
      referenceDate: n,
      granularity: To.day
    }),
    // We want the `referenceDate` to update on prop and `timezone` change (https://github.com/mui/mui-x/issues/10804)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n, h]
  ), [y, S] = w.useReducer(v, {
    isMonthSwitchingAnimating: !1,
    focusedDay: b,
    currentMonth: g.startOfMonth(b),
    slideDirection: "left"
  });
  w.useEffect(() => {
    S({
      type: "changeMonthTimezone",
      newTimezone: g.getTimezone(b)
    });
  }, [b, g]);
  const O = w.useCallback((M) => {
    S(J({
      type: "changeMonth"
    }, M)), d && d(M.newMonth);
  }, [d]), P = w.useCallback((M) => {
    const _ = M;
    g.isSameMonth(_, y.currentMonth) || O({
      newMonth: g.startOfMonth(_),
      direction: g.isAfterDay(_, y.currentMonth) ? "left" : "right"
    });
  }, [y.currentMonth, O, g]), k = GS({
    shouldDisableDate: m,
    minDate: u,
    maxDate: l,
    disableFuture: r,
    disablePast: i,
    timezone: h
  }), R = w.useCallback(() => {
    S({
      type: "finishMonthSwitchingAnimation"
    });
  }, []), E = Le((M, _) => {
    k(M) || S({
      type: "changeFocusedDay",
      focusedDay: M,
      withoutMonthSwitchingAnimation: _
    });
  });
  return {
    referenceDate: b,
    calendarState: y,
    changeMonth: P,
    changeFocusedDay: E,
    isDateDisabled: k,
    onMonthSwitchingAnimationEnd: R,
    handleChangeMonth: O
  };
}, OH = (e) => ze("MuiPickersFadeTransitionGroup", e);
Ve("MuiPickersFadeTransitionGroup", ["root"]);
const TH = (e) => {
  const {
    classes: t
  } = e;
  return We({
    root: ["root"]
  }, OH, t);
}, EH = ae(Nl, {
  name: "MuiPickersFadeTransitionGroup",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "block",
  position: "relative"
});
function KS(e) {
  const t = cn({
    props: e,
    name: "MuiPickersFadeTransitionGroup"
  }), {
    children: n,
    className: r,
    reduceAnimations: i,
    transKey: a
  } = t, l = TH(t), u = ir();
  return i ? n : /* @__PURE__ */ x.jsx(EH, {
    className: Me(l.root, r),
    children: /* @__PURE__ */ x.jsx(_i, {
      appear: !1,
      mountOnEnter: !0,
      unmountOnExit: !0,
      timeout: {
        appear: u.transitions.duration.enteringScreen,
        enter: u.transitions.duration.enteringScreen,
        exit: 0
      },
      children: n
    }, a)
  });
}
const RH = (e) => ze("MuiPickersSlideTransition", e), qr = Ve("MuiPickersSlideTransition", ["root", "slideEnter-left", "slideEnter-right", "slideEnterActive", "slideExit", "slideExitActiveLeft-left", "slideExitActiveLeft-right"]), kH = ["children", "className", "reduceAnimations", "slideDirection", "transKey", "classes"], PH = (e) => {
  const {
    classes: t,
    slideDirection: n
  } = e, r = {
    root: ["root"],
    exit: ["slideExit"],
    enterActive: ["slideEnterActive"],
    enter: [`slideEnter-${n}`],
    exitActive: [`slideExitActiveLeft-${n}`]
  };
  return We(r, RH, t);
}, DH = ae(Nl, {
  name: "MuiPickersSlideTransition",
  slot: "Root",
  overridesResolver: (e, t) => [t.root, {
    [`.${qr["slideEnter-left"]}`]: t["slideEnter-left"]
  }, {
    [`.${qr["slideEnter-right"]}`]: t["slideEnter-right"]
  }, {
    [`.${qr.slideEnterActive}`]: t.slideEnterActive
  }, {
    [`.${qr.slideExit}`]: t.slideExit
  }, {
    [`.${qr["slideExitActiveLeft-left"]}`]: t["slideExitActiveLeft-left"]
  }, {
    [`.${qr["slideExitActiveLeft-right"]}`]: t["slideExitActiveLeft-right"]
  }]
})(({
  theme: e
}) => {
  const t = e.transitions.create("transform", {
    duration: e.transitions.duration.complex,
    easing: "cubic-bezier(0.35, 0.8, 0.4, 1)"
  });
  return {
    display: "block",
    position: "relative",
    overflowX: "hidden",
    "& > *": {
      position: "absolute",
      top: 0,
      right: 0,
      left: 0
    },
    [`& .${qr["slideEnter-left"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      zIndex: 1
    },
    [`& .${qr["slideEnter-right"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      zIndex: 1
    },
    [`& .${qr.slideEnterActive}`]: {
      transform: "translate(0%)",
      transition: t
    },
    [`& .${qr.slideExit}`]: {
      transform: "translate(0%)"
    },
    [`& .${qr["slideExitActiveLeft-left"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      transition: t,
      zIndex: 0
    },
    [`& .${qr["slideExitActiveLeft-right"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      transition: t,
      zIndex: 0
    }
  };
});
function MH(e) {
  const t = cn({
    props: e,
    name: "MuiPickersSlideTransition"
  }), {
    children: n,
    className: r,
    reduceAnimations: i,
    transKey: a
    // extracting `classes` from `other`
  } = t, l = ht(t, kH), u = PH(t), d = ir();
  if (i)
    return /* @__PURE__ */ x.jsx("div", {
      className: Me(u.root, r),
      children: n
    });
  const p = {
    exit: u.exit,
    enterActive: u.enterActive,
    enter: u.enter,
    exitActive: u.exitActive
  };
  return /* @__PURE__ */ x.jsx(DH, {
    className: Me(u.root, r),
    childFactory: (m) => /* @__PURE__ */ w.cloneElement(m, {
      classNames: p
    }),
    role: "presentation",
    children: /* @__PURE__ */ x.jsx(Oh, J({
      mountOnEnter: !0,
      unmountOnExit: !0,
      timeout: d.transitions.duration.complex,
      classNames: p
    }, l, {
      children: n
    }), a)
  });
}
const _H = (e) => ze("MuiDayCalendar", e);
Ve("MuiDayCalendar", ["root", "header", "weekDayLabel", "loadingContainer", "slideTransition", "monthContainer", "weekContainer", "weekNumberLabel", "weekNumber"]);
const IH = ["parentProps", "day", "focusableDay", "selectedDays", "isDateDisabled", "currentMonthNumber", "isViewFocused"], jH = ["ownerState"], $H = (e) => {
  const {
    classes: t
  } = e;
  return We({
    root: ["root"],
    header: ["header"],
    weekDayLabel: ["weekDayLabel"],
    loadingContainer: ["loadingContainer"],
    slideTransition: ["slideTransition"],
    monthContainer: ["monthContainer"],
    weekContainer: ["weekContainer"],
    weekNumberLabel: ["weekNumberLabel"],
    weekNumber: ["weekNumber"]
  }, _H, t);
}, XS = (Sl + Ad * 2) * 6, AH = ae("div", {
  name: "MuiDayCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), NH = ae("div", {
  name: "MuiDayCalendar",
  slot: "Header",
  overridesResolver: (e, t) => t.header
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}), FH = ae(at, {
  name: "MuiDayCalendar",
  slot: "WeekDayLabel",
  overridesResolver: (e, t) => t.weekDayLabel
})(({
  theme: e
}) => ({
  width: 36,
  height: 40,
  margin: "0 2px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: (e.vars || e).palette.text.secondary
})), LH = ae(at, {
  name: "MuiDayCalendar",
  slot: "WeekNumberLabel",
  overridesResolver: (e, t) => t.weekNumberLabel
})(({
  theme: e
}) => ({
  width: 36,
  height: 40,
  margin: "0 2px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: e.palette.text.disabled
})), BH = ae(at, {
  name: "MuiDayCalendar",
  slot: "WeekNumber",
  overridesResolver: (e, t) => t.weekNumber
})(({
  theme: e
}) => J({}, e.typography.caption, {
  width: Sl,
  height: Sl,
  padding: 0,
  margin: `0 ${Ad}px`,
  color: e.palette.text.disabled,
  fontSize: "0.75rem",
  alignItems: "center",
  justifyContent: "center",
  display: "inline-flex"
})), VH = ae("div", {
  name: "MuiDayCalendar",
  slot: "LoadingContainer",
  overridesResolver: (e, t) => t.loadingContainer
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: XS
}), zH = ae(MH, {
  name: "MuiDayCalendar",
  slot: "SlideTransition",
  overridesResolver: (e, t) => t.slideTransition
})({
  minHeight: XS
}), WH = ae("div", {
  name: "MuiDayCalendar",
  slot: "MonthContainer",
  overridesResolver: (e, t) => t.monthContainer
})({
  overflow: "hidden"
}), qH = ae("div", {
  name: "MuiDayCalendar",
  slot: "WeekContainer",
  overridesResolver: (e, t) => t.weekContainer
})({
  margin: `${Ad}px 0`,
  display: "flex",
  justifyContent: "center"
});
function HH(e) {
  let {
    parentProps: t,
    day: n,
    focusableDay: r,
    selectedDays: i,
    isDateDisabled: a,
    currentMonthNumber: l,
    isViewFocused: u
  } = e, d = ht(e, IH);
  const {
    disabled: p,
    disableHighlightToday: m,
    isMonthSwitchingAnimating: h,
    showDaysOutsideCurrentMonth: g,
    slots: v,
    slotProps: b,
    timezone: y
  } = t, S = un(), O = $d(y), P = r !== null && S.isSameDay(n, r), k = i.some((N) => S.isSameDay(N, n)), R = S.isSameDay(n, O), E = (v == null ? void 0 : v.day) ?? pq, M = Nt({
    elementType: E,
    externalSlotProps: b == null ? void 0 : b.day,
    additionalProps: J({
      disableHighlightToday: m,
      showDaysOutsideCurrentMonth: g,
      role: "gridcell",
      isAnimating: h,
      // it is used in date range dragging logic by accessing `dataset.timestamp`
      "data-timestamp": S.toJsDate(n).valueOf()
    }, d),
    ownerState: J({}, t, {
      day: n,
      selected: k
    })
  }), _ = ht(M, jH), I = w.useMemo(() => p || a(n), [p, a, n]), F = w.useMemo(() => S.getMonth(n) !== l, [S, n, l]), T = w.useMemo(() => {
    const N = S.startOfMonth(S.setMonth(n, l));
    return g ? S.isSameDay(n, S.startOfWeek(N)) : S.isSameDay(n, N);
  }, [l, n, g, S]), $ = w.useMemo(() => {
    const N = S.endOfMonth(S.setMonth(n, l));
    return g ? S.isSameDay(n, S.endOfWeek(N)) : S.isSameDay(n, N);
  }, [l, n, g, S]);
  return /* @__PURE__ */ x.jsx(E, J({}, _, {
    day: n,
    disabled: I,
    autoFocus: u && P,
    today: R,
    outsideCurrentMonth: F,
    isFirstVisibleCell: T,
    isLastVisibleCell: $,
    selected: k,
    tabIndex: P ? 0 : -1,
    "aria-selected": k,
    "aria-current": R ? "date" : void 0
  }));
}
function UH(e) {
  const t = cn({
    props: e,
    name: "MuiDayCalendar"
  }), n = un(), {
    onFocusedDayChange: r,
    className: i,
    currentMonth: a,
    selectedDays: l,
    focusedDay: u,
    loading: d,
    onSelectedDaysChange: p,
    onMonthSwitchingAnimationEnd: m,
    readOnly: h,
    reduceAnimations: g,
    renderLoading: v = () => /* @__PURE__ */ x.jsx("span", {
      children: "..."
    }),
    slideDirection: b,
    TransitionProps: y,
    disablePast: S,
    disableFuture: O,
    minDate: P,
    maxDate: k,
    shouldDisableDate: R,
    shouldDisableMonth: E,
    shouldDisableYear: M,
    dayOfWeekFormatter: _ = (xe) => n.format(xe, "weekdayShort").charAt(0).toUpperCase(),
    hasFocus: I,
    onFocusedViewChange: F,
    gridLabelId: T,
    displayWeekNumber: $,
    fixedWeekNumber: N,
    autoFocus: W,
    timezone: L
  } = t, V = $d(L), z = $H(t), X = eo(), le = GS({
    shouldDisableDate: R,
    shouldDisableMonth: E,
    shouldDisableYear: M,
    minDate: P,
    maxDate: k,
    disablePast: S,
    disableFuture: O,
    timezone: L
  }), ne = si(), [G, Q] = or({
    name: "DayCalendar",
    state: "hasFocus",
    controlled: I,
    default: W ?? !1
  }), [be, we] = w.useState(() => u || V), se = Le((xe) => {
    h || p(xe);
  }), U = (xe) => {
    le(xe) || (r(xe), we(xe), F == null || F(!0), Q(!0));
  }, de = Le((xe, pe) => {
    switch (xe.key) {
      case "ArrowUp":
        U(n.addDays(pe, -7)), xe.preventDefault();
        break;
      case "ArrowDown":
        U(n.addDays(pe, 7)), xe.preventDefault();
        break;
      case "ArrowLeft": {
        const Ee = n.addDays(pe, X ? 1 : -1), Pe = n.addMonths(pe, X ? 1 : -1), Be = sl({
          utils: n,
          date: Ee,
          minDate: X ? Ee : n.startOfMonth(Pe),
          maxDate: X ? n.endOfMonth(Pe) : Ee,
          isDateDisabled: le,
          timezone: L
        });
        U(Be || Ee), xe.preventDefault();
        break;
      }
      case "ArrowRight": {
        const Ee = n.addDays(pe, X ? -1 : 1), Pe = n.addMonths(pe, X ? -1 : 1), Be = sl({
          utils: n,
          date: Ee,
          minDate: X ? n.startOfMonth(Pe) : Ee,
          maxDate: X ? Ee : n.endOfMonth(Pe),
          isDateDisabled: le,
          timezone: L
        });
        U(Be || Ee), xe.preventDefault();
        break;
      }
      case "Home":
        U(n.startOfWeek(pe)), xe.preventDefault();
        break;
      case "End":
        U(n.endOfWeek(pe)), xe.preventDefault();
        break;
      case "PageUp":
        U(n.addMonths(pe, 1)), xe.preventDefault();
        break;
      case "PageDown":
        U(n.addMonths(pe, -1)), xe.preventDefault();
        break;
    }
  }), ce = Le((xe, pe) => U(pe)), K = Le((xe, pe) => {
    G && n.isSameDay(be, pe) && (F == null || F(!1));
  }), Z = n.getMonth(a), ue = n.getYear(a), he = w.useMemo(() => l.filter((xe) => !!xe).map((xe) => n.startOfDay(xe)), [n, l]), B = `${ue}-${Z}`, ee = w.useMemo(() => /* @__PURE__ */ w.createRef(), [B]), ie = w.useMemo(() => {
    const xe = n.startOfMonth(a), pe = n.endOfMonth(a);
    return le(be) || n.isAfterDay(be, pe) || n.isBeforeDay(be, xe) ? sl({
      utils: n,
      date: be,
      minDate: xe,
      maxDate: pe,
      disablePast: S,
      disableFuture: O,
      isDateDisabled: le,
      timezone: L
    }) : be;
  }, [a, O, S, be, le, n, L]), ge = w.useMemo(() => {
    const xe = n.getWeekArray(a);
    let pe = n.addMonths(a, 1);
    for (; N && xe.length < N; ) {
      const Ee = n.getWeekArray(pe), Pe = n.isSameDay(xe[xe.length - 1][0], Ee[0][0]);
      Ee.slice(Pe ? 1 : 0).forEach((Be) => {
        xe.length < N && xe.push(Be);
      }), pe = n.addMonths(pe, 1);
    }
    return xe;
  }, [a, N, n]);
  return /* @__PURE__ */ x.jsxs(AH, {
    role: "grid",
    "aria-labelledby": T,
    className: z.root,
    children: [/* @__PURE__ */ x.jsxs(NH, {
      role: "row",
      className: z.header,
      children: [$ && /* @__PURE__ */ x.jsx(LH, {
        variant: "caption",
        role: "columnheader",
        "aria-label": ne.calendarWeekNumberHeaderLabel,
        className: z.weekNumberLabel,
        children: ne.calendarWeekNumberHeaderText
      }), B3(n, V).map((xe, pe) => /* @__PURE__ */ x.jsx(FH, {
        variant: "caption",
        role: "columnheader",
        "aria-label": n.format(xe, "weekday"),
        className: z.weekDayLabel,
        children: _(xe)
      }, pe.toString()))]
    }), d ? /* @__PURE__ */ x.jsx(VH, {
      className: z.loadingContainer,
      children: v()
    }) : /* @__PURE__ */ x.jsx(zH, J({
      transKey: B,
      onExited: m,
      reduceAnimations: g,
      slideDirection: b,
      className: Me(i, z.slideTransition)
    }, y, {
      nodeRef: ee,
      children: /* @__PURE__ */ x.jsx(WH, {
        ref: ee,
        role: "rowgroup",
        className: z.monthContainer,
        children: ge.map((xe, pe) => /* @__PURE__ */ x.jsxs(qH, {
          role: "row",
          className: z.weekContainer,
          "aria-rowindex": pe + 1,
          children: [$ && /* @__PURE__ */ x.jsx(BH, {
            className: z.weekNumber,
            role: "rowheader",
            "aria-label": ne.calendarWeekNumberAriaLabelText(n.getWeekNumber(xe[0])),
            children: ne.calendarWeekNumberText(n.getWeekNumber(xe[0]))
          }), xe.map((Ee, Pe) => /* @__PURE__ */ x.jsx(HH, {
            parentProps: t,
            day: Ee,
            selectedDays: he,
            focusableDay: ie,
            onKeyDown: de,
            onFocus: ce,
            onBlur: K,
            onDaySelect: se,
            isDateDisabled: le,
            currentMonthNumber: Z,
            isViewFocused: G,
            "aria-colindex": Pe + 1
          }, Ee.toString()))]
        }, `week-${xe[0]}`))
      })
    }))]
  });
}
function YH(e) {
  return ze("MuiPickersMonth", e);
}
const Zc = Ve("MuiPickersMonth", ["root", "monthButton", "disabled", "selected"]), GH = ["autoFocus", "className", "children", "disabled", "selected", "value", "tabIndex", "onClick", "onKeyDown", "onFocus", "onBlur", "aria-current", "aria-label", "monthsPerRow", "slots", "slotProps"], KH = (e) => {
  const {
    disabled: t,
    selected: n,
    classes: r
  } = e;
  return We({
    root: ["root"],
    monthButton: ["monthButton", t && "disabled", n && "selected"]
  }, YH, r);
}, XH = ae("div", {
  name: "MuiPickersMonth",
  slot: "Root",
  overridesResolver: (e, t) => [t.root]
})({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexBasis: "33.3%",
  variants: [{
    props: {
      monthsPerRow: 4
    },
    style: {
      flexBasis: "25%"
    }
  }]
}), QH = ae("button", {
  name: "MuiPickersMonth",
  slot: "MonthButton",
  overridesResolver: (e, t) => [t.monthButton, {
    [`&.${Zc.disabled}`]: t.disabled
  }, {
    [`&.${Zc.selected}`]: t.selected
  }]
})(({
  theme: e
}) => J({
  color: "unset",
  backgroundColor: "transparent",
  border: 0,
  outline: 0
}, e.typography.subtitle1, {
  margin: "8px 0",
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: "pointer",
  "&:focus": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : mt(e.palette.action.active, e.palette.action.hoverOpacity)
  },
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : mt(e.palette.action.active, e.palette.action.hoverOpacity)
  },
  "&:disabled": {
    cursor: "auto",
    pointerEvents: "none"
  },
  [`&.${Zc.disabled}`]: {
    color: (e.vars || e).palette.text.secondary
  },
  [`&.${Zc.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText,
    backgroundColor: (e.vars || e).palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  }
})), ZH = /* @__PURE__ */ w.memo(function(t) {
  const n = cn({
    props: t,
    name: "MuiPickersMonth"
  }), {
    autoFocus: r,
    className: i,
    children: a,
    disabled: l,
    selected: u,
    value: d,
    tabIndex: p,
    onClick: m,
    onKeyDown: h,
    onFocus: g,
    onBlur: v,
    "aria-current": b,
    "aria-label": y,
    slots: S,
    slotProps: O
  } = n, P = ht(n, GH), k = w.useRef(null), R = KH(n);
  An(() => {
    var _;
    r && ((_ = k.current) == null || _.focus());
  }, [r]);
  const E = (S == null ? void 0 : S.monthButton) ?? QH, M = Nt({
    elementType: E,
    externalSlotProps: O == null ? void 0 : O.monthButton,
    additionalProps: {
      children: a,
      disabled: l,
      tabIndex: p,
      ref: k,
      type: "button",
      role: "radio",
      "aria-current": b,
      "aria-checked": u,
      "aria-label": y,
      onClick: (_) => m(_, d),
      onKeyDown: (_) => h(_, d),
      onFocus: (_) => g(_, d),
      onBlur: (_) => v(_, d)
    },
    ownerState: n,
    className: R.monthButton
  });
  return /* @__PURE__ */ x.jsx(XH, J({
    className: Me(R.root, i),
    ownerState: n
  }, P, {
    children: /* @__PURE__ */ x.jsx(E, J({}, M))
  }));
});
function JH(e) {
  return ze("MuiMonthCalendar", e);
}
Ve("MuiMonthCalendar", ["root"]);
const eU = ["className", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "shouldDisableMonth", "readOnly", "disableHighlightToday", "autoFocus", "onMonthFocus", "hasFocus", "onFocusedViewChange", "monthsPerRow", "timezone", "gridLabelId", "slots", "slotProps"], tU = (e) => {
  const {
    classes: t
  } = e;
  return We({
    root: ["root"]
  }, JH, t);
};
function nU(e, t) {
  const n = un(), r = Ul(), i = cn({
    props: e,
    name: t
  });
  return J({
    disableFuture: !1,
    disablePast: !1
  }, i, {
    minDate: Zr(n, i.minDate, r.minDate),
    maxDate: Zr(n, i.maxDate, r.maxDate)
  });
}
const rU = ae("div", {
  name: "MuiMonthCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexWrap: "wrap",
  alignContent: "stretch",
  padding: "0 4px",
  width: Nd,
  // avoid padding increasing width over defined
  boxSizing: "border-box"
}), QS = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = nU(t, "MuiMonthCalendar"), {
    className: i,
    value: a,
    defaultValue: l,
    referenceDate: u,
    disabled: d,
    disableFuture: p,
    disablePast: m,
    maxDate: h,
    minDate: g,
    onChange: v,
    shouldDisableMonth: b,
    readOnly: y,
    autoFocus: S = !1,
    onMonthFocus: O,
    hasFocus: P,
    onFocusedViewChange: k,
    monthsPerRow: R = 3,
    timezone: E,
    gridLabelId: M,
    slots: _,
    slotProps: I
  } = r, F = ht(r, eU), {
    value: T,
    handleValueChange: $,
    timezone: N
  } = vg({
    name: "MonthCalendar",
    timezone: E,
    value: a,
    defaultValue: l,
    referenceDate: u,
    onChange: v,
    valueManager: $o
  }), W = $d(N), L = eo(), V = un(), z = w.useMemo(
    () => $o.getInitialReferenceValue({
      value: T,
      utils: V,
      props: r,
      timezone: N,
      referenceDate: u,
      granularity: To.month
    }),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  ), X = r, le = tU(X), ne = w.useMemo(() => V.getMonth(W), [V, W]), G = w.useMemo(() => T != null ? V.getMonth(T) : null, [T, V]), [Q, be] = w.useState(() => G || V.getMonth(z)), [we, se] = or({
    name: "MonthCalendar",
    state: "hasFocus",
    controlled: P,
    default: S ?? !1
  }), U = Le((B) => {
    se(B), k && k(B);
  }), de = w.useCallback((B) => {
    const ee = V.startOfMonth(m && V.isAfter(W, g) ? W : g), ie = V.startOfMonth(p && V.isBefore(W, h) ? W : h), ge = V.startOfMonth(B);
    return V.isBefore(ge, ee) || V.isAfter(ge, ie) ? !0 : b ? b(ge) : !1;
  }, [p, m, h, g, W, b, V]), ce = Le((B, ee) => {
    if (y)
      return;
    const ie = V.setMonth(T ?? z, ee);
    $(ie);
  }), K = Le((B) => {
    de(V.setMonth(T ?? z, B)) || (be(B), U(!0), O && O(B));
  });
  w.useEffect(() => {
    be((B) => G !== null && B !== G ? G : B);
  }, [G]);
  const Z = Le((B, ee) => {
    switch (B.key) {
      case "ArrowUp":
        K((12 + ee - 3) % 12), B.preventDefault();
        break;
      case "ArrowDown":
        K((12 + ee + 3) % 12), B.preventDefault();
        break;
      case "ArrowLeft":
        K((12 + ee + (L ? 1 : -1)) % 12), B.preventDefault();
        break;
      case "ArrowRight":
        K((12 + ee + (L ? -1 : 1)) % 12), B.preventDefault();
        break;
    }
  }), ue = Le((B, ee) => {
    K(ee);
  }), he = Le((B, ee) => {
    Q === ee && U(!1);
  });
  return /* @__PURE__ */ x.jsx(rU, J({
    ref: n,
    className: Me(le.root, i),
    ownerState: X,
    role: "radiogroup",
    "aria-labelledby": M
  }, F, {
    children: gg(V, T ?? z).map((B) => {
      const ee = V.getMonth(B), ie = V.format(B, "monthShort"), ge = V.format(B, "month"), xe = ee === G, pe = d || de(B);
      return /* @__PURE__ */ x.jsx(ZH, {
        selected: xe,
        value: ee,
        onClick: ce,
        onKeyDown: Z,
        autoFocus: we && ee === Q,
        disabled: pe,
        tabIndex: ee === Q && !pe ? 0 : -1,
        onFocus: ue,
        onBlur: he,
        "aria-current": ne === ee ? "date" : void 0,
        "aria-label": ge,
        monthsPerRow: R,
        slots: _,
        slotProps: I,
        children: ie
      }, ie);
    })
  }));
});
process.env.NODE_ENV !== "production" && (QS.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: o.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  className: o.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: o.object,
  /**
   * If `true` picker is disabled
   */
  disabled: o.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: o.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: o.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: o.bool,
  gridLabelId: o.string,
  hasFocus: o.bool,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: o.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: o.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: o.oneOf([3, 4]),
  /**
   * Callback fired when the value changes.
   * @template TDate
   * @param {TDate} value The new value.
   */
  onChange: o.func,
  onFocusedViewChange: o.func,
  onMonthFocus: o.func,
  /**
   * If `true` picker is readonly
   */
  readOnly: o.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid month using the validation props, except callbacks such as `shouldDisableMonth`.
   */
  referenceDate: o.object,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: o.func,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: o.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: o.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: o.object
});
function oU(e) {
  return ze("MuiPickersYear", e);
}
const Jc = Ve("MuiPickersYear", ["root", "yearButton", "selected", "disabled"]), iU = ["autoFocus", "className", "children", "disabled", "selected", "value", "tabIndex", "onClick", "onKeyDown", "onFocus", "onBlur", "aria-current", "yearsPerRow", "slots", "slotProps"], aU = (e) => {
  const {
    disabled: t,
    selected: n,
    classes: r
  } = e;
  return We({
    root: ["root"],
    yearButton: ["yearButton", t && "disabled", n && "selected"]
  }, oU, r);
}, sU = ae("div", {
  name: "MuiPickersYear",
  slot: "Root",
  overridesResolver: (e, t) => [t.root]
})({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexBasis: "33.3%",
  variants: [{
    props: {
      yearsPerRow: 4
    },
    style: {
      flexBasis: "25%"
    }
  }]
}), lU = ae("button", {
  name: "MuiPickersYear",
  slot: "YearButton",
  overridesResolver: (e, t) => [t.yearButton, {
    [`&.${Jc.disabled}`]: t.disabled
  }, {
    [`&.${Jc.selected}`]: t.selected
  }]
})(({
  theme: e
}) => J({
  color: "unset",
  backgroundColor: "transparent",
  border: 0,
  outline: 0
}, e.typography.subtitle1, {
  margin: "6px 0",
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: "pointer",
  "&:focus": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.focusOpacity})` : mt(e.palette.action.active, e.palette.action.focusOpacity)
  },
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : mt(e.palette.action.active, e.palette.action.hoverOpacity)
  },
  "&:disabled": {
    cursor: "auto",
    pointerEvents: "none"
  },
  [`&.${Jc.disabled}`]: {
    color: (e.vars || e).palette.text.secondary
  },
  [`&.${Jc.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText,
    backgroundColor: (e.vars || e).palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  }
})), cU = /* @__PURE__ */ w.memo(function(t) {
  const n = cn({
    props: t,
    name: "MuiPickersYear"
  }), {
    autoFocus: r,
    className: i,
    children: a,
    disabled: l,
    selected: u,
    value: d,
    tabIndex: p,
    onClick: m,
    onKeyDown: h,
    onFocus: g,
    onBlur: v,
    "aria-current": b,
    slots: y,
    slotProps: S
  } = n, O = ht(n, iU), P = w.useRef(null), k = aU(n);
  An(() => {
    var M;
    r && ((M = P.current) == null || M.focus());
  }, [r]);
  const R = (y == null ? void 0 : y.yearButton) ?? lU, E = Nt({
    elementType: R,
    externalSlotProps: S == null ? void 0 : S.yearButton,
    additionalProps: {
      children: a,
      disabled: l,
      tabIndex: p,
      ref: P,
      type: "button",
      role: "radio",
      "aria-current": b,
      "aria-checked": u,
      onClick: (M) => m(M, d),
      onKeyDown: (M) => h(M, d),
      onFocus: (M) => g(M, d),
      onBlur: (M) => v(M, d)
    },
    ownerState: n,
    className: k.yearButton
  });
  return /* @__PURE__ */ x.jsx(sU, J({
    className: Me(k.root, i),
    ownerState: n
  }, O, {
    children: /* @__PURE__ */ x.jsx(R, J({}, E))
  }));
});
function uU(e) {
  return ze("MuiYearCalendar", e);
}
Ve("MuiYearCalendar", ["root"]);
const dU = ["autoFocus", "className", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "readOnly", "shouldDisableYear", "disableHighlightToday", "onYearFocus", "hasFocus", "onFocusedViewChange", "yearsOrder", "yearsPerRow", "timezone", "gridLabelId", "slots", "slotProps"], pU = (e) => {
  const {
    classes: t
  } = e;
  return We({
    root: ["root"]
  }, uU, t);
};
function fU(e, t) {
  const n = un(), r = Ul(), i = cn({
    props: e,
    name: t
  });
  return J({
    disablePast: !1,
    disableFuture: !1
  }, i, {
    yearsPerRow: i.yearsPerRow ?? 3,
    minDate: Zr(n, i.minDate, r.minDate),
    maxDate: Zr(n, i.maxDate, r.maxDate)
  });
}
const mU = ae("div", {
  name: "MuiYearCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  overflowY: "auto",
  height: "100%",
  padding: "0 4px",
  width: Nd,
  maxHeight: $3,
  // avoid padding increasing width over defined
  boxSizing: "border-box",
  position: "relative"
}), ZS = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = fU(t, "MuiYearCalendar"), {
    autoFocus: i,
    className: a,
    value: l,
    defaultValue: u,
    referenceDate: d,
    disabled: p,
    disableFuture: m,
    disablePast: h,
    maxDate: g,
    minDate: v,
    onChange: b,
    readOnly: y,
    shouldDisableYear: S,
    onYearFocus: O,
    hasFocus: P,
    onFocusedViewChange: k,
    yearsOrder: R = "asc",
    yearsPerRow: E,
    timezone: M,
    gridLabelId: _,
    slots: I,
    slotProps: F
  } = r, T = ht(r, dU), {
    value: $,
    handleValueChange: N,
    timezone: W
  } = vg({
    name: "YearCalendar",
    timezone: M,
    value: l,
    defaultValue: u,
    referenceDate: d,
    onChange: b,
    valueManager: $o
  }), L = $d(W), V = eo(), z = un(), X = w.useMemo(
    () => $o.getInitialReferenceValue({
      value: $,
      utils: z,
      props: r,
      timezone: W,
      referenceDate: d,
      granularity: To.year
    }),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  ), le = r, ne = pU(le), G = w.useMemo(() => z.getYear(L), [z, L]), Q = w.useMemo(() => $ != null ? z.getYear($) : null, [$, z]), [be, we] = w.useState(() => Q || z.getYear(X)), [se, U] = or({
    name: "YearCalendar",
    state: "hasFocus",
    controlled: P,
    default: i ?? !1
  }), de = Le((Ee) => {
    U(Ee), k && k(Ee);
  }), ce = w.useCallback((Ee) => {
    if (h && z.isBeforeYear(Ee, L) || m && z.isAfterYear(Ee, L) || v && z.isBeforeYear(Ee, v) || g && z.isAfterYear(Ee, g))
      return !0;
    if (!S)
      return !1;
    const Pe = z.startOfYear(Ee);
    return S(Pe);
  }, [m, h, g, v, L, S, z]), K = Le((Ee, Pe) => {
    if (y)
      return;
    const Be = z.setYear($ ?? X, Pe);
    N(Be);
  }), Z = Le((Ee) => {
    ce(z.setYear($ ?? X, Ee)) || (we(Ee), de(!0), O == null || O(Ee));
  });
  w.useEffect(() => {
    we((Ee) => Q !== null && Ee !== Q ? Q : Ee);
  }, [Q]);
  const ue = R !== "desc" ? E * 1 : E * -1, he = V && R === "asc" || !V && R === "desc" ? -1 : 1, B = Le((Ee, Pe) => {
    switch (Ee.key) {
      case "ArrowUp":
        Z(Pe - ue), Ee.preventDefault();
        break;
      case "ArrowDown":
        Z(Pe + ue), Ee.preventDefault();
        break;
      case "ArrowLeft":
        Z(Pe - he), Ee.preventDefault();
        break;
      case "ArrowRight":
        Z(Pe + he), Ee.preventDefault();
        break;
    }
  }), ee = Le((Ee, Pe) => {
    Z(Pe);
  }), ie = Le((Ee, Pe) => {
    be === Pe && de(!1);
  }), ge = w.useRef(null), xe = It(n, ge);
  w.useEffect(() => {
    if (i || ge.current === null)
      return;
    const Ee = ge.current.querySelector('[tabindex="0"]');
    if (!Ee)
      return;
    const Pe = Ee.offsetHeight, Be = Ee.offsetTop, Ge = ge.current.clientHeight, Ie = ge.current.scrollTop, Dt = Be + Pe;
    Pe > Ge || Be < Ie || (ge.current.scrollTop = Dt - Ge / 2 - Pe / 2);
  }, [i]);
  const pe = z.getYearRange([v, g]);
  return R === "desc" && pe.reverse(), /* @__PURE__ */ x.jsx(mU, J({
    ref: xe,
    className: Me(ne.root, a),
    ownerState: le,
    role: "radiogroup",
    "aria-labelledby": _
  }, T, {
    children: pe.map((Ee) => {
      const Pe = z.getYear(Ee), Be = Pe === Q, Ge = p || ce(Ee);
      return /* @__PURE__ */ x.jsx(cU, {
        selected: Be,
        value: Pe,
        onClick: K,
        onKeyDown: B,
        autoFocus: se && Pe === be,
        disabled: Ge,
        tabIndex: Pe === be && !Ge ? 0 : -1,
        onFocus: ee,
        onBlur: ie,
        "aria-current": G === Pe ? "date" : void 0,
        yearsPerRow: E,
        slots: I,
        slotProps: F,
        children: z.format(Ee, "year")
      }, z.format(Ee, "year"));
    })
  }));
});
process.env.NODE_ENV !== "production" && (ZS.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: o.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  className: o.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: o.object,
  /**
   * If `true` picker is disabled
   */
  disabled: o.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: o.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: o.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: o.bool,
  gridLabelId: o.string,
  hasFocus: o.bool,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: o.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: o.object,
  /**
   * Callback fired when the value changes.
   * @template TDate
   * @param {TDate} value The new value.
   */
  onChange: o.func,
  onFocusedViewChange: o.func,
  onYearFocus: o.func,
  /**
   * If `true` picker is readonly
   */
  readOnly: o.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid year using the validation props, except callbacks such as `shouldDisableYear`.
   */
  referenceDate: o.object,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: o.func,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: o.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: o.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: o.object,
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: o.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: o.oneOf([3, 4])
});
const hU = (e) => ze("MuiPickersCalendarHeader", e), gU = Ve("MuiPickersCalendarHeader", ["root", "labelContainer", "label", "switchViewButton", "switchViewIcon"]), yU = ["slots", "slotProps", "currentMonth", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onMonthChange", "onViewChange", "view", "reduceAnimations", "views", "labelId", "className", "timezone", "format"], bU = ["ownerState"], vU = (e) => {
  const {
    classes: t
  } = e;
  return We({
    root: ["root"],
    labelContainer: ["labelContainer"],
    label: ["label"],
    switchViewButton: ["switchViewButton"],
    switchViewIcon: ["switchViewIcon"]
  }, hU, t);
}, xU = ae("div", {
  name: "MuiPickersCalendarHeader",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  alignItems: "center",
  marginTop: 12,
  marginBottom: 4,
  paddingLeft: 24,
  paddingRight: 12,
  // prevent jumping in safari
  maxHeight: 40,
  minHeight: 40
}), wU = ae("div", {
  name: "MuiPickersCalendarHeader",
  slot: "LabelContainer",
  overridesResolver: (e, t) => t.labelContainer
})(({
  theme: e
}) => J({
  display: "flex",
  overflow: "hidden",
  alignItems: "center",
  cursor: "pointer",
  marginRight: "auto"
}, e.typography.body1, {
  fontWeight: e.typography.fontWeightMedium
})), CU = ae("div", {
  name: "MuiPickersCalendarHeader",
  slot: "Label",
  overridesResolver: (e, t) => t.label
})({
  marginRight: 6
}), SU = ae(Ai, {
  name: "MuiPickersCalendarHeader",
  slot: "SwitchViewButton",
  overridesResolver: (e, t) => t.switchViewButton
})({
  marginRight: "auto",
  variants: [{
    props: {
      view: "year"
    },
    style: {
      [`.${gU.switchViewIcon}`]: {
        transform: "rotate(180deg)"
      }
    }
  }]
}), OU = ae(g3, {
  name: "MuiPickersCalendarHeader",
  slot: "SwitchViewIcon",
  overridesResolver: (e, t) => t.switchViewIcon
})(({
  theme: e
}) => ({
  willChange: "transform",
  transition: e.transitions.create("transform"),
  transform: "rotate(0deg)"
})), JS = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = si(), i = un(), a = cn({
    props: t,
    name: "MuiPickersCalendarHeader"
  }), {
    slots: l,
    slotProps: u,
    currentMonth: d,
    disabled: p,
    disableFuture: m,
    disablePast: h,
    maxDate: g,
    minDate: v,
    onMonthChange: b,
    onViewChange: y,
    view: S,
    reduceAnimations: O,
    views: P,
    labelId: k,
    className: R,
    timezone: E,
    format: M = `${i.formats.month} ${i.formats.year}`
  } = a, _ = ht(a, yU), I = a, F = vU(a), T = (l == null ? void 0 : l.switchViewButton) ?? SU, $ = Nt({
    elementType: T,
    externalSlotProps: u == null ? void 0 : u.switchViewButton,
    additionalProps: {
      size: "small",
      "aria-label": r.calendarViewSwitchingButtonAriaLabel(S)
    },
    ownerState: I,
    className: F.switchViewButton
  }), N = (l == null ? void 0 : l.switchViewIcon) ?? OU, W = Nt({
    elementType: N,
    externalSlotProps: u == null ? void 0 : u.switchViewIcon,
    ownerState: I,
    className: F.switchViewIcon
  }), L = ht(W, bU), V = () => b(i.addMonths(d, 1), "left"), z = () => b(i.addMonths(d, -1), "right"), X = I3(d, {
    disableFuture: m,
    maxDate: g,
    timezone: E
  }), le = j3(d, {
    disablePast: h,
    minDate: v,
    timezone: E
  }), ne = () => {
    if (!(P.length === 1 || !y || p))
      if (P.length === 2)
        y(P.find((Q) => Q !== S) || P[0]);
      else {
        const Q = P.indexOf(S) !== 0 ? 0 : 1;
        y(P[Q]);
      }
  };
  if (P.length === 1 && P[0] === "year")
    return null;
  const G = i.formatByString(d, M);
  return /* @__PURE__ */ x.jsxs(xU, J({}, _, {
    ownerState: I,
    className: Me(F.root, R),
    ref: n,
    children: [/* @__PURE__ */ x.jsxs(wU, {
      role: "presentation",
      onClick: ne,
      ownerState: I,
      "aria-live": "polite",
      className: F.labelContainer,
      children: [/* @__PURE__ */ x.jsx(KS, {
        reduceAnimations: O,
        transKey: G,
        children: /* @__PURE__ */ x.jsx(CU, {
          id: k,
          ownerState: I,
          className: F.label,
          children: G
        })
      }), P.length > 1 && !p && /* @__PURE__ */ x.jsx(T, J({}, $, {
        children: /* @__PURE__ */ x.jsx(N, J({}, L))
      }))]
    }), /* @__PURE__ */ x.jsx(_i, {
      in: S === "day",
      appear: !O,
      enter: !O,
      children: /* @__PURE__ */ x.jsx(k3, {
        slots: l,
        slotProps: u,
        onGoToPrevious: z,
        isPreviousDisabled: le,
        previousLabel: r.previousMonth,
        onGoToNext: V,
        isNextDisabled: X,
        nextLabel: r.nextMonth
      })
    })]
  }));
});
process.env.NODE_ENV !== "production" && (JS.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  className: o.string,
  currentMonth: o.object.isRequired,
  disabled: o.bool,
  disableFuture: o.bool,
  disablePast: o.bool,
  /**
   * Format used to display the date.
   * @default `${adapter.formats.month} ${adapter.formats.year}`
   */
  format: o.string,
  /**
   * Id of the calendar text element.
   * It is used to establish an `aria-labelledby` relationship with the calendar `grid` element.
   */
  labelId: o.string,
  maxDate: o.object.isRequired,
  minDate: o.object.isRequired,
  onMonthChange: o.func.isRequired,
  onViewChange: o.func,
  reduceAnimations: o.bool.isRequired,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: o.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  timezone: o.string.isRequired,
  view: o.oneOf(["day", "month", "year"]).isRequired,
  views: o.arrayOf(o.oneOf(["day", "month", "year"]).isRequired).isRequired
});
const TU = "@media (prefers-reduced-motion: reduce)", Ka = typeof navigator < "u" && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i), k0 = Ka && Ka[1] ? parseInt(Ka[1], 10) : null, P0 = Ka && Ka[2] ? parseInt(Ka[2], 10) : null, EU = k0 && k0 < 10 || P0 && P0 < 13 || !1, eO = () => vC(TU, {
  defaultMatches: !1
}) || EU, RU = (e) => ze("MuiDateCalendar", e);
Ve("MuiDateCalendar", ["root", "viewTransitionContainer"]);
const kU = ["autoFocus", "onViewChange", "value", "defaultValue", "referenceDate", "disableFuture", "disablePast", "onChange", "onYearChange", "onMonthChange", "reduceAnimations", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear", "view", "views", "openTo", "className", "disabled", "readOnly", "minDate", "maxDate", "disableHighlightToday", "focusedView", "onFocusedViewChange", "showDaysOutsideCurrentMonth", "fixedWeekNumber", "dayOfWeekFormatter", "slots", "slotProps", "loading", "renderLoading", "displayWeekNumber", "yearsOrder", "yearsPerRow", "monthsPerRow", "timezone"], PU = (e) => {
  const {
    classes: t
  } = e;
  return We({
    root: ["root"],
    viewTransitionContainer: ["viewTransitionContainer"]
  }, RU, t);
};
function DU(e, t) {
  const n = un(), r = Ul(), i = eO(), a = cn({
    props: e,
    name: t
  });
  return J({}, a, {
    loading: a.loading ?? !1,
    disablePast: a.disablePast ?? !1,
    disableFuture: a.disableFuture ?? !1,
    openTo: a.openTo ?? "day",
    views: a.views ?? ["year", "day"],
    reduceAnimations: a.reduceAnimations ?? i,
    renderLoading: a.renderLoading ?? (() => /* @__PURE__ */ x.jsx("span", {
      children: "..."
    })),
    minDate: Zr(n, a.minDate, r.minDate),
    maxDate: Zr(n, a.maxDate, r.maxDate)
  });
}
const MU = ae(A3, {
  name: "MuiDateCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexDirection: "column",
  height: hg
}), _U = ae(KS, {
  name: "MuiDateCalendar",
  slot: "ViewTransitionContainer",
  overridesResolver: (e, t) => t.viewTransitionContainer
})({}), tO = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = un(), i = Ir(), a = DU(t, "MuiDateCalendar"), {
    autoFocus: l,
    onViewChange: u,
    value: d,
    defaultValue: p,
    referenceDate: m,
    disableFuture: h,
    disablePast: g,
    onChange: v,
    onYearChange: b,
    onMonthChange: y,
    reduceAnimations: S,
    shouldDisableDate: O,
    shouldDisableMonth: P,
    shouldDisableYear: k,
    view: R,
    views: E,
    openTo: M,
    className: _,
    disabled: I,
    readOnly: F,
    minDate: T,
    maxDate: $,
    disableHighlightToday: N,
    focusedView: W,
    onFocusedViewChange: L,
    showDaysOutsideCurrentMonth: V,
    fixedWeekNumber: z,
    dayOfWeekFormatter: X,
    slots: le,
    slotProps: ne,
    loading: G,
    renderLoading: Q,
    displayWeekNumber: be,
    yearsOrder: we,
    yearsPerRow: se,
    monthsPerRow: U,
    timezone: de
  } = a, ce = ht(a, kU), {
    value: K,
    handleValueChange: Z,
    timezone: ue
  } = vg({
    name: "DateCalendar",
    timezone: de,
    value: d,
    defaultValue: p,
    referenceDate: m,
    onChange: v,
    valueManager: $o
  }), {
    view: he,
    setView: B,
    focusedView: ee,
    setFocusedView: ie,
    goToNextView: ge,
    setValueAndGoToNextView: xe
  } = RS({
    view: R,
    views: E,
    openTo: M,
    onChange: Z,
    onViewChange: u,
    autoFocus: l,
    focusedView: W,
    onFocusedViewChange: L
  }), {
    referenceDate: pe,
    calendarState: Ee,
    changeFocusedDay: Pe,
    changeMonth: Be,
    handleChangeMonth: Ge,
    isDateDisabled: Ie,
    onMonthSwitchingAnimationEnd: Dt
  } = SH({
    value: K,
    referenceDate: m,
    reduceAnimations: S,
    onMonthChange: y,
    minDate: T,
    maxDate: $,
    shouldDisableDate: O,
    disablePast: g,
    disableFuture: h,
    timezone: ue
  }), Re = I && K || T, $e = I && K || $, dt = `${i}-grid-label`, He = ee !== null, Je = (le == null ? void 0 : le.calendarHeader) ?? JS, Ze = Nt({
    elementType: Je,
    externalSlotProps: ne == null ? void 0 : ne.calendarHeader,
    additionalProps: {
      views: E,
      view: he,
      currentMonth: Ee.currentMonth,
      onViewChange: B,
      onMonthChange: (gt, kt) => Ge({
        newMonth: gt,
        direction: kt
      }),
      minDate: Re,
      maxDate: $e,
      disabled: I,
      disablePast: g,
      disableFuture: h,
      reduceAnimations: S,
      timezone: ue,
      labelId: dt
    },
    ownerState: a
  }), nt = Le((gt) => {
    const kt = r.startOfMonth(gt), xn = r.endOfMonth(gt), on = Ie(gt) ? sl({
      utils: r,
      date: gt,
      minDate: r.isBefore(T, kt) ? kt : T,
      maxDate: r.isAfter($, xn) ? xn : $,
      disablePast: g,
      disableFuture: h,
      isDateDisabled: Ie,
      timezone: ue
    }) : gt;
    on ? (xe(on, "finish"), y == null || y(kt)) : (ge(), Be(kt)), Pe(on, !0);
  }), Ne = Le((gt) => {
    const kt = r.startOfYear(gt), xn = r.endOfYear(gt), on = Ie(gt) ? sl({
      utils: r,
      date: gt,
      minDate: r.isBefore(T, kt) ? kt : T,
      maxDate: r.isAfter($, xn) ? xn : $,
      disablePast: g,
      disableFuture: h,
      isDateDisabled: Ie,
      timezone: ue
    }) : gt;
    on ? (xe(on, "finish"), b == null || b(on)) : (ge(), Be(kt)), Pe(on, !0);
  }), Ct = Le((gt) => Z(gt && Fu(r, gt, K ?? pe), "finish", he));
  w.useEffect(() => {
    K != null && r.isValid(K) && Be(K);
  }, [K]);
  const Rt = a, At = PU(Rt), Xt = {
    disablePast: g,
    disableFuture: h,
    maxDate: $,
    minDate: T
  }, je = {
    disableHighlightToday: N,
    readOnly: F,
    disabled: I,
    timezone: ue,
    gridLabelId: dt,
    slots: le,
    slotProps: ne
  }, ot = w.useRef(he);
  w.useEffect(() => {
    ot.current !== he && (ee === ot.current && ie(he, !0), ot.current = he);
  }, [ee, ie, he]);
  const vt = w.useMemo(() => [K], [K]);
  return /* @__PURE__ */ x.jsxs(MU, J({
    ref: n,
    className: Me(At.root, _),
    ownerState: Rt
  }, ce, {
    children: [/* @__PURE__ */ x.jsx(Je, J({}, Ze, {
      slots: le,
      slotProps: ne
    })), /* @__PURE__ */ x.jsx(_U, {
      reduceAnimations: S,
      className: At.viewTransitionContainer,
      transKey: he,
      ownerState: Rt,
      children: /* @__PURE__ */ x.jsxs("div", {
        children: [he === "year" && /* @__PURE__ */ x.jsx(ZS, J({}, Xt, je, {
          value: K,
          onChange: Ne,
          shouldDisableYear: k,
          hasFocus: He,
          onFocusedViewChange: (gt) => ie("year", gt),
          yearsOrder: we,
          yearsPerRow: se,
          referenceDate: pe
        })), he === "month" && /* @__PURE__ */ x.jsx(QS, J({}, Xt, je, {
          hasFocus: He,
          className: _,
          value: K,
          onChange: nt,
          shouldDisableMonth: P,
          onFocusedViewChange: (gt) => ie("month", gt),
          monthsPerRow: U,
          referenceDate: pe
        })), he === "day" && /* @__PURE__ */ x.jsx(UH, J({}, Ee, Xt, je, {
          onMonthSwitchingAnimationEnd: Dt,
          onFocusedDayChange: Pe,
          reduceAnimations: S,
          selectedDays: vt,
          onSelectedDaysChange: Ct,
          shouldDisableDate: O,
          shouldDisableMonth: P,
          shouldDisableYear: k,
          hasFocus: He,
          onFocusedViewChange: (gt) => ie("day", gt),
          showDaysOutsideCurrentMonth: V,
          fixedWeekNumber: z,
          dayOfWeekFormatter: X,
          displayWeekNumber: be,
          loading: G,
          renderLoading: Q
        }))]
      })
    })]
  }));
});
process.env.NODE_ENV !== "production" && (tO.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: o.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  className: o.string,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: o.func,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: o.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: o.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: o.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: o.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: o.bool,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: o.number,
  /**
   * Controlled focused view.
   */
  focusedView: o.oneOf(["day", "month", "year"]),
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: o.bool,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: o.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: o.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: o.oneOf([3, 4]),
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: o.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: o.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: o.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: o.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: o.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: o.oneOf(["day", "month", "year"]),
  /**
   * Make picker read only.
   * @default false
   */
  readOnly: o.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: o.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`.
   */
  referenceDate: o.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: o.func,
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: o.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: o.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: o.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: o.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: o.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: o.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: o.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: o.oneOf(["day", "month", "year"]),
  /**
   * Available views.
   */
  views: o.arrayOf(o.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: o.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: o.oneOf([3, 4])
});
function IU(e) {
  return ze("MuiPickersToolbar", e);
}
Ve("MuiPickersToolbar", ["root", "content"]);
const jU = ["children", "className", "toolbarTitle", "hidden", "titleId", "isLandscape", "classes", "landscapeDirection"], $U = (e) => {
  const {
    classes: t
  } = e;
  return We({
    root: ["root"],
    content: ["content"]
  }, IU, t);
}, AU = ae("div", {
  name: "MuiPickersToolbar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  padding: e.spacing(2, 3),
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      height: "auto",
      maxWidth: 160,
      padding: 16,
      justifyContent: "flex-start",
      flexWrap: "wrap"
    }
  }]
})), NU = ae("div", {
  name: "MuiPickersToolbar",
  slot: "Content",
  overridesResolver: (e, t) => t.content
})({
  display: "flex",
  flexWrap: "wrap",
  width: "100%",
  flex: 1,
  justifyContent: "space-between",
  alignItems: "center",
  flexDirection: "row",
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      justifyContent: "flex-start",
      alignItems: "flex-start",
      flexDirection: "column"
    }
  }, {
    props: {
      isLandscape: !0,
      landscapeDirection: "row"
    },
    style: {
      flexDirection: "row"
    }
  }]
}), FU = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = cn({
    props: t,
    name: "MuiPickersToolbar"
  }), {
    children: i,
    className: a,
    toolbarTitle: l,
    hidden: u,
    titleId: d
  } = r, p = ht(r, jU), m = r, h = $U(m);
  return u ? null : /* @__PURE__ */ x.jsxs(AU, J({
    ref: n,
    className: Me(h.root, a),
    ownerState: m
  }, p, {
    children: [/* @__PURE__ */ x.jsx(at, {
      color: "text.secondary",
      variant: "overline",
      id: d,
      children: l
    }), /* @__PURE__ */ x.jsx(NU, {
      className: h.content,
      ownerState: m,
      children: i
    })]
  }));
});
function LU(e) {
  return ze("MuiDatePickerToolbar", e);
}
Ve("MuiDatePickerToolbar", ["root", "title"]);
const BU = ["value", "isLandscape", "onChange", "toolbarFormat", "toolbarPlaceholder", "views", "className", "onViewChange", "view"], VU = (e) => {
  const {
    classes: t
  } = e;
  return We({
    root: ["root"],
    title: ["title"]
  }, LU, t);
}, zU = ae(FU, {
  name: "MuiDatePickerToolbar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), WU = ae(at, {
  name: "MuiDatePickerToolbar",
  slot: "Title",
  overridesResolver: (e, t) => t.title
})({
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      margin: "auto 16px auto auto"
    }
  }]
}), nO = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = cn({
    props: t,
    name: "MuiDatePickerToolbar"
  }), {
    value: i,
    isLandscape: a,
    toolbarFormat: l,
    toolbarPlaceholder: u = "––",
    views: d,
    className: p
  } = r, m = ht(r, BU), h = un(), g = si(), v = VU(r), b = w.useMemo(() => {
    if (!i)
      return u;
    const S = yg(h, {
      format: l,
      views: d
    }, !0);
    return h.formatByString(i, S);
  }, [i, l, u, h, d]), y = r;
  return /* @__PURE__ */ x.jsx(zU, J({
    ref: n,
    toolbarTitle: g.datePickerToolbarTitle,
    isLandscape: a,
    className: Me(v.root, p)
  }, m, {
    children: /* @__PURE__ */ x.jsx(WU, {
      variant: "h4",
      align: a ? "left" : "center",
      ownerState: y,
      className: v.title,
      children: b
    })
  }));
});
process.env.NODE_ENV !== "production" && (nO.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  className: o.string,
  disabled: o.bool,
  /**
   * If `true`, show the toolbar even in desktop mode.
   * @default `true` for Desktop, `false` for Mobile.
   */
  hidden: o.bool,
  isLandscape: o.bool.isRequired,
  onChange: o.func.isRequired,
  /**
   * Callback called when a toolbar is clicked
   * @template TView
   * @param {TView} view The view to open
   */
  onViewChange: o.func.isRequired,
  readOnly: o.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  titleId: o.string,
  /**
   * Toolbar date format.
   */
  toolbarFormat: o.string,
  /**
   * Toolbar value placeholder—it is displayed when the value is empty.
   * @default "––"
   */
  toolbarPlaceholder: o.node,
  value: o.object,
  /**
   * Currently visible picker view.
   */
  view: o.oneOf(["day", "month", "year"]).isRequired,
  /**
   * Available views.
   */
  views: o.arrayOf(o.oneOf(["day", "month", "year"]).isRequired).isRequired
});
function rO(e, t) {
  const n = un(), r = Ul(), i = cn({
    props: e,
    name: t
  }), a = w.useMemo(() => {
    var l;
    return ((l = i.localeText) == null ? void 0 : l.toolbarTitle) == null ? i.localeText : J({}, i.localeText, {
      datePickerToolbarTitle: i.localeText.toolbarTitle
    });
  }, [i.localeText]);
  return J({}, i, {
    localeText: a
  }, P3({
    views: i.views,
    openTo: i.openTo,
    defaultViews: ["year", "day"],
    defaultOpenTo: "day"
  }), {
    disableFuture: i.disableFuture ?? !1,
    disablePast: i.disablePast ?? !1,
    minDate: Zr(n, i.minDate, r.minDate),
    maxDate: Zr(n, i.maxDate, r.maxDate),
    slots: J({
      toolbar: nO
    }, i.slots)
  });
}
function qU(e) {
  return ze("MuiPickersPopper", e);
}
Ve("MuiPickersPopper", ["root", "paper"]);
const HU = ["PaperComponent", "popperPlacement", "ownerState", "children", "paperSlotProps", "paperClasses", "onPaperClick", "onPaperTouchStart"], UU = (e) => {
  const {
    classes: t
  } = e;
  return We({
    root: ["root"],
    paper: ["paper"]
  }, qU, t);
}, YU = ae(ps, {
  name: "MuiPickersPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  zIndex: e.zIndex.modal
})), GU = ae($i, {
  name: "MuiPickersPopper",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  outline: 0,
  transformOrigin: "top center",
  variants: [{
    props: ({
      placement: e
    }) => ["top", "top-start", "top-end"].includes(e),
    style: {
      transformOrigin: "bottom center"
    }
  }]
});
function KU(e, t) {
  return t.documentElement.clientWidth < e.clientX || t.documentElement.clientHeight < e.clientY;
}
function XU(e, t) {
  const n = w.useRef(!1), r = w.useRef(!1), i = w.useRef(null), a = w.useRef(!1);
  w.useEffect(() => {
    if (!e)
      return;
    function d() {
      a.current = !0;
    }
    return document.addEventListener("mousedown", d, !0), document.addEventListener("touchstart", d, !0), () => {
      document.removeEventListener("mousedown", d, !0), document.removeEventListener("touchstart", d, !0), a.current = !1;
    };
  }, [e]);
  const l = Le((d) => {
    if (!a.current)
      return;
    const p = r.current;
    r.current = !1;
    const m = Qn(i.current);
    if (!i.current || // is a TouchEvent?
    "clientX" in d && KU(d, m))
      return;
    if (n.current) {
      n.current = !1;
      return;
    }
    let h;
    d.composedPath ? h = d.composedPath().indexOf(i.current) > -1 : h = !m.documentElement.contains(d.target) || i.current.contains(d.target), !h && !p && t(d);
  }), u = () => {
    r.current = !0;
  };
  return w.useEffect(() => {
    if (e) {
      const d = Qn(i.current), p = () => {
        n.current = !0;
      };
      return d.addEventListener("touchstart", l), d.addEventListener("touchmove", p), () => {
        d.removeEventListener("touchstart", l), d.removeEventListener("touchmove", p);
      };
    }
  }, [e, l]), w.useEffect(() => {
    if (e) {
      const d = Qn(i.current);
      return d.addEventListener("click", l), () => {
        d.removeEventListener("click", l), r.current = !1;
      };
    }
  }, [e, l]), [i, u, u];
}
const QU = /* @__PURE__ */ w.forwardRef((e, t) => {
  const {
    PaperComponent: n,
    popperPlacement: r,
    ownerState: i,
    children: a,
    paperSlotProps: l,
    paperClasses: u,
    onPaperClick: d,
    onPaperTouchStart: p
    // picks up the style props provided by `Transition`
    // https://mui.com/material-ui/transitions/#child-requirement
  } = e, m = ht(e, HU), h = J({}, i, {
    placement: r
  }), g = Nt({
    elementType: n,
    externalSlotProps: l,
    additionalProps: {
      tabIndex: -1,
      elevation: 8,
      ref: t
    },
    className: u,
    ownerState: h
  });
  return /* @__PURE__ */ x.jsx(n, J({}, m, g, {
    onClick: (v) => {
      var b;
      d(v), (b = g.onClick) == null || b.call(g, v);
    },
    onTouchStart: (v) => {
      var b;
      p(v), (b = g.onTouchStart) == null || b.call(g, v);
    },
    ownerState: h,
    children: a
  }));
});
function ZU(e) {
  const t = cn({
    props: e,
    name: "MuiPickersPopper"
  }), {
    anchorEl: n,
    children: r,
    containerRef: i = null,
    shouldRestoreFocus: a,
    onBlur: l,
    onDismiss: u,
    open: d,
    role: p,
    placement: m,
    slots: h,
    slotProps: g,
    reduceAnimations: v
  } = t;
  w.useEffect(() => {
    function V(z) {
      d && z.key === "Escape" && u();
    }
    return document.addEventListener("keydown", V), () => {
      document.removeEventListener("keydown", V);
    };
  }, [u, d]);
  const b = w.useRef(null);
  w.useEffect(() => {
    p === "tooltip" || a && !a() || (d ? b.current = mr(document) : b.current && b.current instanceof HTMLElement && setTimeout(() => {
      b.current instanceof HTMLElement && b.current.focus();
    }));
  }, [d, p, a]);
  const [y, S, O] = XU(d, l ?? u), P = w.useRef(null), k = It(P, i), R = It(k, y), E = t, M = UU(E), _ = eO(), I = v ?? _, F = (V) => {
    V.key === "Escape" && (V.stopPropagation(), u());
  }, T = (h == null ? void 0 : h.desktopTransition) ?? I ? _i : os, $ = (h == null ? void 0 : h.desktopTrapFocus) ?? bl, N = (h == null ? void 0 : h.desktopPaper) ?? GU, W = (h == null ? void 0 : h.popper) ?? YU, L = Nt({
    elementType: W,
    externalSlotProps: g == null ? void 0 : g.popper,
    additionalProps: {
      transition: !0,
      role: p,
      open: d,
      anchorEl: n,
      placement: m,
      onKeyDown: F
    },
    className: M.root,
    ownerState: t
  });
  return /* @__PURE__ */ x.jsx(W, J({}, L, {
    children: ({
      TransitionProps: V,
      placement: z
    }) => /* @__PURE__ */ x.jsx($, J({
      open: d,
      disableAutoFocus: !0,
      disableRestoreFocus: !0,
      disableEnforceFocus: p === "tooltip",
      isEnabled: () => !0
    }, g == null ? void 0 : g.desktopTrapFocus, {
      children: /* @__PURE__ */ x.jsx(T, J({}, V, g == null ? void 0 : g.desktopTransition, {
        children: /* @__PURE__ */ x.jsx(QU, {
          PaperComponent: N,
          ownerState: E,
          popperPlacement: z,
          ref: R,
          onPaperClick: S,
          onPaperTouchStart: O,
          paperClasses: M.paper,
          paperSlotProps: g == null ? void 0 : g.desktopPaper,
          children: r
        })
      }))
    }))
  }));
}
const D0 = /* @__PURE__ */ new Set();
function JU(e, t = "warning") {
  if (process.env.NODE_ENV === "production")
    return;
  const n = Array.isArray(e) ? e.join(`
`) : e;
  D0.has(n) || (D0.add(n), t === "error" ? console.error(n) : console.warn(n));
}
const e6 = ({
  open: e,
  onOpen: t,
  onClose: n
}) => {
  const r = w.useRef(typeof e == "boolean").current, [i, a] = w.useState(!1);
  w.useEffect(() => {
    if (r) {
      if (typeof e != "boolean")
        throw new Error("You must not mix controlling and uncontrolled mode for `open` prop");
      a(e);
    }
  }, [r, e]);
  const l = w.useCallback((u) => {
    r || a(u), u && t && t(), !u && n && n();
  }, [r, t, n]);
  return {
    isOpen: i,
    setIsOpen: l
  };
}, t6 = (e) => {
  const {
    action: t,
    hasChanged: n,
    dateState: r,
    isControlled: i
  } = e, a = !i && !r.hasBeenModifiedSinceMount;
  return t.name === "setValueFromField" ? !0 : t.name === "setValueFromAction" ? a && ["accept", "today", "clear"].includes(t.pickerAction) ? !0 : n(r.lastPublishedValue) : t.name === "setValueFromView" && t.selectionState !== "shallow" || t.name === "setValueFromShortcut" ? a ? !0 : n(r.lastPublishedValue) : !1;
}, n6 = (e) => {
  const {
    action: t,
    hasChanged: n,
    dateState: r,
    isControlled: i,
    closeOnSelect: a
  } = e, l = !i && !r.hasBeenModifiedSinceMount;
  return t.name === "setValueFromAction" ? l && ["accept", "today", "clear"].includes(t.pickerAction) ? !0 : n(r.lastCommittedValue) : t.name === "setValueFromView" && t.selectionState === "finish" && a ? l ? !0 : n(r.lastCommittedValue) : t.name === "setValueFromShortcut" ? t.changeImportance === "accept" && n(r.lastCommittedValue) : !1;
}, r6 = (e) => {
  const {
    action: t,
    closeOnSelect: n
  } = e;
  return t.name === "setValueFromAction" ? !0 : t.name === "setValueFromView" ? t.selectionState === "finish" && n : t.name === "setValueFromShortcut" ? t.changeImportance === "accept" : !1;
}, o6 = ({
  props: e,
  valueManager: t,
  valueType: n,
  wrapperVariant: r,
  validator: i
}) => {
  const {
    onAccept: a,
    onChange: l,
    value: u,
    defaultValue: d,
    closeOnSelect: p = r === "desktop",
    timezone: m,
    referenceDate: h
  } = e, {
    current: g
  } = w.useRef(d), {
    current: v
  } = w.useRef(u !== void 0), [b, y] = w.useState(m);
  process.env.NODE_ENV !== "production" && (w.useEffect(() => {
    v !== (u !== void 0) && console.error([`MUI X: A component is changing the ${v ? "" : "un"}controlled value of a picker to be ${v ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", "Decide between using a controlled or uncontrolled valuefor the lifetime of the component.", "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
  }, [u]), w.useEffect(() => {
    !v && g !== d && console.error(["MUI X: A component is changing the defaultValue of an uncontrolled picker after being initialized. To suppress this warning opt to use a controlled value."].join(`
`));
  }, [JSON.stringify(g)]));
  const S = un(), O = ya(), {
    isOpen: P,
    setIsOpen: k
  } = e6(e), {
    timezone: R,
    value: E,
    handleValueChange: M
  } = bg({
    timezone: m,
    value: u,
    defaultValue: g,
    referenceDate: h,
    onChange: l,
    valueManager: t
  }), [_, I] = w.useState(() => {
    let Z;
    return E !== void 0 ? Z = E : g !== void 0 ? Z = g : Z = t.emptyValue, {
      draft: Z,
      lastPublishedValue: Z,
      lastCommittedValue: Z,
      lastControlledValue: u,
      hasBeenModifiedSinceMount: !1
    };
  }), F = t.getTimezone(S, _.draft);
  b !== m && (y(m), m && F && m !== F && I((Z) => J({}, Z, {
    draft: t.setTimezone(S, m, Z.draft)
  })));
  const {
    getValidationErrorForNewValue: T
  } = LS({
    props: e,
    validator: i,
    timezone: R,
    value: _.draft,
    onError: e.onError
  }), $ = Le((Z) => {
    const ue = {
      action: Z,
      dateState: _,
      hasChanged: (xe) => !t.areValuesEqual(S, Z.value, xe),
      isControlled: v,
      closeOnSelect: p
    }, he = t6(ue), B = n6(ue), ee = r6(ue);
    I((xe) => J({}, xe, {
      draft: Z.value,
      lastPublishedValue: he ? Z.value : xe.lastPublishedValue,
      lastCommittedValue: B ? Z.value : xe.lastCommittedValue,
      hasBeenModifiedSinceMount: !0
    }));
    let ie = null;
    const ge = () => (ie || (ie = {
      validationError: Z.name === "setValueFromField" ? Z.context.validationError : T(Z.value)
    }, Z.name === "setValueFromShortcut" && (ie.shortcut = Z.shortcut)), ie);
    he && M(Z.value, ge()), B && a && a(Z.value, ge()), ee && k(!1);
  });
  if (_.lastControlledValue !== u) {
    const Z = t.areValuesEqual(S, _.draft, E);
    I((ue) => J({}, ue, {
      lastControlledValue: u
    }, Z ? {} : {
      lastCommittedValue: E,
      lastPublishedValue: E,
      draft: E,
      hasBeenModifiedSinceMount: !0
    }));
  }
  const N = Le(() => {
    $({
      value: t.emptyValue,
      name: "setValueFromAction",
      pickerAction: "clear"
    });
  }), W = Le(() => {
    $({
      value: _.lastPublishedValue,
      name: "setValueFromAction",
      pickerAction: "accept"
    });
  }), L = Le(() => {
    $({
      value: _.lastPublishedValue,
      name: "setValueFromAction",
      pickerAction: "dismiss"
    });
  }), V = Le(() => {
    $({
      value: _.lastCommittedValue,
      name: "setValueFromAction",
      pickerAction: "cancel"
    });
  }), z = Le(() => {
    $({
      value: t.getTodayValue(S, R, n),
      name: "setValueFromAction",
      pickerAction: "today"
    });
  }), X = Le((Z) => {
    Z.preventDefault(), k(!0);
  }), le = Le((Z) => {
    Z == null || Z.preventDefault(), k(!1);
  }), ne = Le((Z, ue = "partial") => $({
    name: "setValueFromView",
    value: Z,
    selectionState: ue
  })), G = Le((Z, ue, he) => $({
    name: "setValueFromShortcut",
    value: Z,
    changeImportance: ue,
    shortcut: he
  })), Q = Le((Z, ue) => $({
    name: "setValueFromField",
    value: Z,
    context: ue
  })), be = {
    onClear: N,
    onAccept: W,
    onDismiss: L,
    onCancel: V,
    onSetToday: z,
    onOpen: X,
    onClose: le
  }, we = {
    value: _.draft,
    onChange: Q
  }, se = w.useMemo(() => t.cleanValue(S, _.draft), [S, t, _.draft]), U = {
    value: se,
    onChange: ne,
    onClose: le,
    open: P
  }, ce = J({}, be, {
    value: se,
    onChange: ne,
    onSelectShortcut: G,
    isValid: (Z) => {
      const ue = i({
        adapter: O,
        value: Z,
        timezone: R,
        props: e
      });
      return !t.hasError(ue);
    }
  }), K = w.useMemo(() => ({
    onOpen: X,
    onClose: le,
    open: P
  }), [P, le, X]);
  return {
    open: P,
    fieldProps: we,
    viewProps: U,
    layoutProps: ce,
    actions: be,
    contextValue: K
  };
}, i6 = ["className", "sx"], a6 = ({
  props: e,
  propsFromPickerValue: t,
  additionalViewProps: n,
  autoFocusView: r,
  rendererInterceptor: i,
  fieldRef: a
}) => {
  const {
    onChange: l,
    open: u,
    onClose: d
  } = t, {
    view: p,
    views: m,
    openTo: h,
    onViewChange: g,
    viewRenderers: v,
    timezone: b
  } = e, y = ht(e, i6), {
    view: S,
    setView: O,
    defaultView: P,
    focusedView: k,
    setFocusedView: R,
    setValueAndGoToNextView: E
  } = RS({
    view: p,
    views: m,
    openTo: h,
    onChange: l,
    onViewChange: g,
    autoFocus: r
  }), {
    hasUIView: M,
    viewModeLookup: _
  } = w.useMemo(() => m.reduce((L, V) => {
    let z;
    return v[V] != null ? z = "UI" : z = "field", L.viewModeLookup[V] = z, z === "UI" && (L.hasUIView = !0), L;
  }, {
    hasUIView: !1,
    viewModeLookup: {}
  }), [v, m]), I = w.useMemo(() => m.reduce((L, V) => v[V] != null && M3(V) ? L + 1 : L, 0), [v, m]), F = _[S], T = Le(() => F === "UI"), [$, N] = w.useState(F === "UI" ? S : null);
  return $ !== S && _[S] === "UI" && N(S), An(() => {
    F === "field" && u && (d(), setTimeout(() => {
      var L, V;
      (L = a == null ? void 0 : a.current) == null || L.setSelectedSections(S), (V = a == null ? void 0 : a.current) == null || V.focusField(S);
    }));
  }, [S]), An(() => {
    if (!u)
      return;
    let L = S;
    F === "field" && $ != null && (L = $), L !== P && _[L] === "UI" && _[P] === "UI" && (L = P), L !== S && O(L), R(L, !0);
  }, [u]), {
    hasUIView: M,
    shouldRestoreFocus: T,
    layoutProps: {
      views: m,
      view: $,
      onViewChange: O
    },
    renderCurrentView: () => {
      if ($ == null)
        return null;
      const L = v[$];
      if (L == null)
        return null;
      const V = J({}, y, n, t, {
        views: m,
        timezone: b,
        onChange: E,
        view: $,
        onViewChange: O,
        focusedView: k,
        onFocusedViewChange: R,
        showViewSwitcher: I > 1,
        timeViewsCount: I
      });
      return i ? i(v, $, V) : L(V);
    }
  };
};
function M0() {
  return typeof window > "u" ? "portrait" : window.screen && window.screen.orientation && window.screen.orientation.angle ? Math.abs(window.screen.orientation.angle) === 90 ? "landscape" : "portrait" : window.orientation && Math.abs(Number(window.orientation)) === 90 ? "landscape" : "portrait";
}
const s6 = (e, t) => {
  const [n, r] = w.useState(M0);
  return An(() => {
    const a = () => {
      r(M0());
    };
    return window.addEventListener("orientationchange", a), () => {
      window.removeEventListener("orientationchange", a);
    };
  }, []), oq(e, ["hours", "minutes", "seconds"]) ? !1 : (t || n) === "landscape";
}, l6 = ({
  props: e,
  propsFromPickerValue: t,
  propsFromPickerViews: n,
  wrapperVariant: r
}) => {
  const {
    orientation: i
  } = e, a = s6(n.views, i), l = eo();
  return {
    layoutProps: J({}, n, t, {
      isLandscape: a,
      isRtl: l,
      wrapperVariant: r,
      disabled: e.disabled,
      readOnly: e.readOnly
    })
  };
};
function c6(e) {
  const {
    props: t,
    pickerValueResponse: n
  } = e;
  return w.useMemo(() => ({
    value: n.viewProps.value,
    open: n.open,
    disabled: t.disabled ?? !1,
    readOnly: t.readOnly ?? !1
  }), [n.viewProps.value, n.open, t.disabled, t.readOnly]);
}
const oO = ({
  props: e,
  valueManager: t,
  valueType: n,
  wrapperVariant: r,
  additionalViewProps: i,
  validator: a,
  autoFocusView: l,
  rendererInterceptor: u,
  fieldRef: d
}) => {
  process.env.NODE_ENV !== "production" && e.renderInput != null && JU(["MUI X: The `renderInput` prop has been removed in version 6.0 of the Date and Time Pickers.", "You can replace it with the `textField` component slot in most cases.", "For more information, please have a look at the migration guide (https://mui.com/x/migration/migration-pickers-v5/#input-renderer-required-in-v5)."]);
  const p = o6({
    props: e,
    valueManager: t,
    valueType: n,
    wrapperVariant: r,
    validator: a
  }), m = a6({
    props: e,
    additionalViewProps: i,
    autoFocusView: l,
    fieldRef: d,
    propsFromPickerValue: p.viewProps,
    rendererInterceptor: u
  }), h = l6({
    props: e,
    wrapperVariant: r,
    propsFromPickerValue: p.layoutProps,
    propsFromPickerViews: m.layoutProps
  }), g = c6({
    props: e,
    pickerValueResponse: p
  });
  return {
    // Picker value
    open: p.open,
    actions: p.actions,
    fieldProps: p.fieldProps,
    // Picker views
    renderCurrentView: m.renderCurrentView,
    hasUIView: m.hasUIView,
    shouldRestoreFocus: m.shouldRestoreFocus,
    // Picker layout
    layoutProps: h.layoutProps,
    // Picker context
    contextValue: p.contextValue,
    // Picker owner state
    ownerState: g
  };
};
function iO(e) {
  return ze("MuiPickersLayout", e);
}
const ta = Ve("MuiPickersLayout", ["root", "landscape", "contentWrapper", "toolbar", "actionBar", "tabs", "shortcuts"]), u6 = ["onAccept", "onClear", "onCancel", "onSetToday", "actions"];
function aO(e) {
  const {
    onAccept: t,
    onClear: n,
    onCancel: r,
    onSetToday: i,
    actions: a
  } = e, l = ht(e, u6), u = si();
  if (a == null || a.length === 0)
    return null;
  const d = a == null ? void 0 : a.map((p) => {
    switch (p) {
      case "clear":
        return /* @__PURE__ */ x.jsx(En, {
          onClick: n,
          children: u.clearButtonLabel
        }, p);
      case "cancel":
        return /* @__PURE__ */ x.jsx(En, {
          onClick: r,
          children: u.cancelButtonLabel
        }, p);
      case "accept":
        return /* @__PURE__ */ x.jsx(En, {
          onClick: t,
          children: u.okButtonLabel
        }, p);
      case "today":
        return /* @__PURE__ */ x.jsx(En, {
          onClick: i,
          children: u.todayButtonLabel
        }, p);
      default:
        return null;
    }
  });
  return /* @__PURE__ */ x.jsx(Ri, J({}, l, {
    children: d
  }));
}
process.env.NODE_ENV !== "production" && (aO.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Ordered array of actions to display.
   * If empty, does not display that action bar.
   * @default `['cancel', 'accept']` for mobile and `[]` for desktop
   */
  actions: o.arrayOf(o.oneOf(["accept", "cancel", "clear", "today"]).isRequired),
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: o.bool,
  onAccept: o.func.isRequired,
  onCancel: o.func.isRequired,
  onClear: o.func.isRequired,
  onSetToday: o.func.isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
const d6 = ["items", "changeImportance", "isLandscape", "onChange", "isValid"], p6 = ["getValue"];
function sO(e) {
  const {
    items: t,
    changeImportance: n = "accept",
    onChange: r,
    isValid: i
  } = e, a = ht(e, d6);
  if (t == null || t.length === 0)
    return null;
  const l = t.map((u) => {
    let {
      getValue: d
    } = u, p = ht(u, p6);
    const m = d({
      isValid: i
    });
    return J({}, p, {
      label: p.label,
      onClick: () => {
        r(m, n, p);
      },
      disabled: !i(m)
    });
  });
  return /* @__PURE__ */ x.jsx(zl, J({
    dense: !0,
    sx: [{
      maxHeight: hg,
      maxWidth: 200,
      overflow: "auto"
    }, ...Array.isArray(a.sx) ? a.sx : [a.sx]]
  }, a, {
    children: l.map((u) => /* @__PURE__ */ x.jsx(xC, {
      children: /* @__PURE__ */ x.jsx(hd, J({}, u))
    }, u.id ?? u.label))
  }));
}
process.env.NODE_ENV !== "production" && (sO.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Importance of the change when picking a shortcut:
   * - "accept": fires `onChange`, fires `onAccept` and closes the picker.
   * - "set": fires `onChange` but do not fire `onAccept` and does not close the picker.
   * @default "accept"
   */
  changeImportance: o.oneOf(["accept", "set"]),
  className: o.string,
  component: o.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: o.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: o.bool,
  isLandscape: o.bool.isRequired,
  isValid: o.func.isRequired,
  /**
   * Ordered array of shortcuts to display.
   * If empty, does not display the shortcuts.
   * @default []
   */
  items: o.arrayOf(o.shape({
    getValue: o.func.isRequired,
    id: o.string,
    label: o.string.isRequired
  })),
  onChange: o.func.isRequired,
  style: o.object,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: o.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object])
});
function f6(e) {
  return e.view !== null;
}
const m6 = (e) => {
  const {
    classes: t,
    isLandscape: n
  } = e;
  return We({
    root: ["root", n && "landscape"],
    contentWrapper: ["contentWrapper"],
    toolbar: ["toolbar"],
    actionBar: ["actionBar"],
    tabs: ["tabs"],
    landscape: ["landscape"],
    shortcuts: ["shortcuts"]
  }, iO, t);
}, h6 = (e) => {
  const {
    wrapperVariant: t,
    onAccept: n,
    onClear: r,
    onCancel: i,
    onSetToday: a,
    view: l,
    views: u,
    onViewChange: d,
    value: p,
    onChange: m,
    onSelectShortcut: h,
    isValid: g,
    isLandscape: v,
    disabled: b,
    readOnly: y,
    children: S,
    slots: O,
    slotProps: P
    // TODO: Remove this "as" hack. It get introduced to mark `value` prop in PickersLayoutProps as not required.
    // The true type should be
    // - For pickers value: TDate | null
    // - For range pickers value: [TDate | null, TDate | null]
  } = e, k = m6(e), R = (O == null ? void 0 : O.actionBar) ?? aO, E = Nt({
    elementType: R,
    externalSlotProps: P == null ? void 0 : P.actionBar,
    additionalProps: {
      onAccept: n,
      onClear: r,
      onCancel: i,
      onSetToday: a,
      actions: t === "desktop" ? [] : ["cancel", "accept"]
    },
    className: k.actionBar,
    ownerState: J({}, e, {
      wrapperVariant: t
    })
  }), M = /* @__PURE__ */ x.jsx(R, J({}, E)), _ = O == null ? void 0 : O.toolbar, I = Nt({
    elementType: _,
    externalSlotProps: P == null ? void 0 : P.toolbar,
    additionalProps: {
      isLandscape: v,
      onChange: m,
      value: p,
      view: l,
      onViewChange: d,
      views: u,
      disabled: b,
      readOnly: y
    },
    className: k.toolbar,
    ownerState: J({}, e, {
      wrapperVariant: t
    })
  }), F = f6(I) && _ ? /* @__PURE__ */ x.jsx(_, J({}, I)) : null, T = S, $ = O == null ? void 0 : O.tabs, N = l && $ ? /* @__PURE__ */ x.jsx($, J({
    view: l,
    onViewChange: d,
    className: k.tabs
  }, P == null ? void 0 : P.tabs)) : null, W = (O == null ? void 0 : O.shortcuts) ?? sO, L = Nt({
    elementType: W,
    externalSlotProps: P == null ? void 0 : P.shortcuts,
    additionalProps: {
      isValid: g,
      isLandscape: v,
      onChange: h
    },
    className: k.shortcuts,
    ownerState: {
      isValid: g,
      isLandscape: v,
      onChange: h,
      wrapperVariant: t
    }
  }), V = l && W ? /* @__PURE__ */ x.jsx(W, J({}, L)) : null;
  return {
    toolbar: F,
    content: T,
    tabs: N,
    actionBar: M,
    shortcuts: V
  };
}, g6 = (e) => {
  const {
    isLandscape: t,
    classes: n
  } = e;
  return We({
    root: ["root", t && "landscape"],
    contentWrapper: ["contentWrapper"]
  }, iO, n);
}, y6 = ae("div", {
  name: "MuiPickersLayout",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "grid",
  gridAutoColumns: "max-content auto max-content",
  gridAutoRows: "max-content auto max-content",
  [`& .${ta.actionBar}`]: {
    gridColumn: "1 / 4",
    gridRow: 3
  },
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      [`& .${ta.toolbar}`]: {
        gridColumn: 1,
        gridRow: "2 / 3"
      },
      [`.${ta.shortcuts}`]: {
        gridColumn: "2 / 4",
        gridRow: 1
      }
    }
  }, {
    props: {
      isLandscape: !0,
      isRtl: !0
    },
    style: {
      [`& .${ta.toolbar}`]: {
        gridColumn: 3
      }
    }
  }, {
    props: {
      isLandscape: !1
    },
    style: {
      [`& .${ta.toolbar}`]: {
        gridColumn: "2 / 4",
        gridRow: 1
      },
      [`& .${ta.shortcuts}`]: {
        gridColumn: 1,
        gridRow: "2 / 3"
      }
    }
  }, {
    props: {
      isLandscape: !1,
      isRtl: !0
    },
    style: {
      [`& .${ta.shortcuts}`]: {
        gridColumn: 3
      }
    }
  }]
}), b6 = ae("div", {
  name: "MuiPickersLayout",
  slot: "ContentWrapper",
  overridesResolver: (e, t) => t.contentWrapper
})({
  gridColumn: 2,
  gridRow: 2,
  display: "flex",
  flexDirection: "column"
}), kg = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = cn({
    props: t,
    name: "MuiPickersLayout"
  }), {
    toolbar: i,
    content: a,
    tabs: l,
    actionBar: u,
    shortcuts: d
  } = h6(r), {
    sx: p,
    className: m,
    isLandscape: h,
    wrapperVariant: g
  } = r, v = g6(r);
  return /* @__PURE__ */ x.jsxs(y6, {
    ref: n,
    sx: p,
    className: Me(v.root, m),
    ownerState: r,
    children: [h ? d : i, h ? i : d, /* @__PURE__ */ x.jsx(b6, {
      className: v.contentWrapper,
      children: g === "desktop" ? /* @__PURE__ */ x.jsxs(w.Fragment, {
        children: [a, l]
      }) : /* @__PURE__ */ x.jsxs(w.Fragment, {
        children: [l, a]
      })
    }), u]
  });
});
process.env.NODE_ENV !== "production" && (kg.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  className: o.string,
  disabled: o.bool,
  isLandscape: o.bool.isRequired,
  /**
   * `true` if the application is in right-to-left direction.
   */
  isRtl: o.bool.isRequired,
  isValid: o.func.isRequired,
  onAccept: o.func.isRequired,
  onCancel: o.func.isRequired,
  onChange: o.func.isRequired,
  onClear: o.func.isRequired,
  onClose: o.func.isRequired,
  onDismiss: o.func.isRequired,
  onOpen: o.func.isRequired,
  onSelectShortcut: o.func.isRequired,
  onSetToday: o.func.isRequired,
  onViewChange: o.func.isRequired,
  /**
   * Force rendering in particular orientation.
   */
  orientation: o.oneOf(["landscape", "portrait"]),
  readOnly: o.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: o.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  value: o.any,
  view: o.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  views: o.arrayOf(o.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]).isRequired).isRequired,
  wrapperVariant: o.oneOf(["desktop", "mobile"])
});
const v6 = ["props", "getOpenDialogAriaText"], x6 = ["ownerState"], w6 = ["ownerState"], C6 = (e) => {
  var ge;
  let {
    props: t,
    getOpenDialogAriaText: n
  } = e, r = ht(e, v6);
  const {
    slots: i,
    slotProps: a,
    className: l,
    sx: u,
    format: d,
    formatDensity: p,
    enableAccessibleFieldDOMStructure: m,
    selectedSections: h,
    onSelectedSectionsChange: g,
    timezone: v,
    name: b,
    label: y,
    inputRef: S,
    readOnly: O,
    disabled: P,
    autoFocus: k,
    localeText: R,
    reduceAnimations: E
  } = t, M = w.useRef(null), _ = w.useRef(null), I = Ir(), F = ((ge = a == null ? void 0 : a.toolbar) == null ? void 0 : ge.hidden) ?? !1, {
    open: T,
    actions: $,
    hasUIView: N,
    layoutProps: W,
    renderCurrentView: L,
    shouldRestoreFocus: V,
    fieldProps: z,
    contextValue: X,
    ownerState: le
  } = oO(J({}, r, {
    props: t,
    fieldRef: _,
    autoFocusView: !0,
    additionalViewProps: {},
    wrapperVariant: "desktop"
  })), ne = i.inputAdornment ?? Vl, G = Nt({
    elementType: ne,
    externalSlotProps: a == null ? void 0 : a.inputAdornment,
    additionalProps: {
      position: "end"
    },
    ownerState: t
  }), Q = ht(G, x6), be = i.openPickerButton ?? Ai, we = Nt({
    elementType: be,
    externalSlotProps: a == null ? void 0 : a.openPickerButton,
    additionalProps: {
      disabled: P || O,
      onClick: T ? $.onClose : $.onOpen,
      "aria-label": n(z.value),
      edge: Q.position
    },
    ownerState: t
  }), se = ht(we, w6), U = i.openPickerIcon, de = Nt({
    elementType: U,
    externalSlotProps: a == null ? void 0 : a.openPickerIcon,
    ownerState: le
  }), ce = i.field, K = Nt({
    elementType: ce,
    externalSlotProps: a == null ? void 0 : a.field,
    additionalProps: J({}, z, F && {
      id: I
    }, {
      readOnly: O,
      disabled: P,
      className: l,
      sx: u,
      format: d,
      formatDensity: p,
      enableAccessibleFieldDOMStructure: m,
      selectedSections: h,
      onSelectedSectionsChange: g,
      timezone: v,
      label: y,
      name: b,
      autoFocus: k && !t.open,
      focused: T ? !0 : void 0
    }, S ? {
      inputRef: S
    } : {}),
    ownerState: t
  });
  N && (K.InputProps = J({}, K.InputProps, {
    ref: M
  }, !t.disableOpenPicker && {
    [`${Q.position}Adornment`]: /* @__PURE__ */ x.jsx(ne, J({}, Q, {
      children: /* @__PURE__ */ x.jsx(be, J({}, se, {
        children: /* @__PURE__ */ x.jsx(U, J({}, de))
      }))
    }))
  }));
  const Z = J({
    textField: i.textField,
    clearIcon: i.clearIcon,
    clearButton: i.clearButton
  }, K.slots), ue = i.layout ?? kg;
  let he = I;
  F && (y ? he = `${I}-label` : he = void 0);
  const B = J({}, a, {
    toolbar: J({}, a == null ? void 0 : a.toolbar, {
      titleId: I
    }),
    popper: J({
      "aria-labelledby": he
    }, a == null ? void 0 : a.popper)
  }), ee = It(_, K.unstableFieldRef);
  return {
    renderPicker: () => /* @__PURE__ */ x.jsxs(BS, {
      contextValue: X,
      localeText: R,
      children: [/* @__PURE__ */ x.jsx(ce, J({}, K, {
        slots: Z,
        slotProps: B,
        unstableFieldRef: ee
      })), /* @__PURE__ */ x.jsx(ZU, J({
        role: "dialog",
        placement: "bottom-start",
        anchorEl: M.current
      }, $, {
        open: T,
        slots: i,
        slotProps: B,
        shouldRestoreFocus: V,
        reduceAnimations: E,
        children: /* @__PURE__ */ x.jsx(ue, J({}, W, B == null ? void 0 : B.layout, {
          slots: i,
          slotProps: B,
          children: L()
        }))
      }))]
    })
  };
}, Xa = ({
  view: e,
  onViewChange: t,
  views: n,
  focusedView: r,
  onFocusedViewChange: i,
  value: a,
  defaultValue: l,
  referenceDate: u,
  onChange: d,
  className: p,
  classes: m,
  disableFuture: h,
  disablePast: g,
  minDate: v,
  maxDate: b,
  shouldDisableDate: y,
  shouldDisableMonth: S,
  shouldDisableYear: O,
  reduceAnimations: P,
  onMonthChange: k,
  monthsPerRow: R,
  onYearChange: E,
  yearsOrder: M,
  yearsPerRow: _,
  slots: I,
  slotProps: F,
  loading: T,
  renderLoading: $,
  disableHighlightToday: N,
  readOnly: W,
  disabled: L,
  showDaysOutsideCurrentMonth: V,
  dayOfWeekFormatter: z,
  sx: X,
  autoFocus: le,
  fixedWeekNumber: ne,
  displayWeekNumber: G,
  timezone: Q
}) => /* @__PURE__ */ x.jsx(tO, {
  view: e,
  onViewChange: t,
  views: n.filter(b0),
  focusedView: r && b0(r) ? r : null,
  onFocusedViewChange: i,
  value: a,
  defaultValue: l,
  referenceDate: u,
  onChange: d,
  className: p,
  classes: m,
  disableFuture: h,
  disablePast: g,
  minDate: v,
  maxDate: b,
  shouldDisableDate: y,
  shouldDisableMonth: S,
  shouldDisableYear: O,
  reduceAnimations: P,
  onMonthChange: k,
  monthsPerRow: R,
  onYearChange: E,
  yearsOrder: M,
  yearsPerRow: _,
  slots: I,
  slotProps: F,
  loading: T,
  renderLoading: $,
  disableHighlightToday: N,
  readOnly: W,
  disabled: L,
  showDaysOutsideCurrentMonth: V,
  dayOfWeekFormatter: z,
  sx: X,
  autoFocus: le,
  fixedWeekNumber: ne,
  displayWeekNumber: G,
  timezone: Q
}), lO = /* @__PURE__ */ w.forwardRef(function(t, n) {
  var p, m;
  const r = si(), i = un(), a = rO(t, "MuiDesktopDatePicker"), l = J({
    day: Xa,
    month: Xa,
    year: Xa
  }, a.viewRenderers), u = J({}, a, {
    viewRenderers: l,
    format: yg(i, a, !1),
    yearsPerRow: a.yearsPerRow ?? 4,
    slots: J({
      openPickerIcon: v3,
      field: Rg
    }, a.slots),
    slotProps: J({}, a.slotProps, {
      field: (h) => {
        var g;
        return J({}, cd((g = a.slotProps) == null ? void 0 : g.field, h), FS(a), {
          ref: n
        });
      },
      toolbar: J({
        hidden: !0
      }, (p = a.slotProps) == null ? void 0 : p.toolbar)
    })
  }), {
    renderPicker: d
  } = C6({
    props: u,
    valueManager: $o,
    valueType: "date",
    getOpenDialogAriaText: TS({
      utils: i,
      formatKey: "fullDate",
      contextTranslation: r.openDatePickerDialogue,
      propsTranslation: (m = u.localeText) == null ? void 0 : m.openDatePickerDialogue
    }),
    validator: Yl
  });
  return d();
});
lO.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: o.bool,
  className: o.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: o.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: o.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: o.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: o.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: o.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: o.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: o.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: o.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: o.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: o.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: o.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: o.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: gn,
  /**
   * The label content.
   */
  label: o.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: o.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: o.object,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: o.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: o.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: o.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: o.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onAccept: o.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: o.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: o.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: o.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: o.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: o.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: o.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: o.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: o.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: o.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: o.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: o.oneOf(["landscape", "portrait"]),
  readOnly: o.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: o.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: o.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: o.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: o.oneOfType([o.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), o.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: o.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: o.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: o.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: o.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: o.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: o.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: o.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: o.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: o.shape({
    day: o.func,
    month: o.func,
    year: o.func
  }),
  /**
   * Available views.
   */
  views: o.arrayOf(o.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: o.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 4
   */
  yearsPerRow: o.oneOf([3, 4])
};
const S6 = ae(fs)({
  [`& .${il.container}`]: {
    outline: 0
  },
  [`& .${il.paper}`]: {
    outline: 0,
    minWidth: Nd
  }
}), O6 = ae(Fh)({
  "&:first-of-type": {
    padding: 0
  }
});
function T6(e) {
  const {
    children: t,
    onDismiss: n,
    open: r,
    slots: i,
    slotProps: a
  } = e, l = (i == null ? void 0 : i.dialog) ?? S6, u = (i == null ? void 0 : i.mobileTransition) ?? _i;
  return /* @__PURE__ */ x.jsx(l, J({
    open: r,
    onClose: n
  }, a == null ? void 0 : a.dialog, {
    TransitionComponent: u,
    TransitionProps: a == null ? void 0 : a.mobileTransition,
    PaperComponent: i == null ? void 0 : i.mobilePaper,
    PaperProps: a == null ? void 0 : a.mobilePaper,
    children: /* @__PURE__ */ x.jsx(O6, {
      children: t
    })
  }));
}
const E6 = ["props", "getOpenDialogAriaText"], R6 = (e) => {
  var Q;
  let {
    props: t,
    getOpenDialogAriaText: n
  } = e, r = ht(e, E6);
  const {
    slots: i,
    slotProps: a,
    className: l,
    sx: u,
    format: d,
    formatDensity: p,
    enableAccessibleFieldDOMStructure: m,
    selectedSections: h,
    onSelectedSectionsChange: g,
    timezone: v,
    name: b,
    label: y,
    inputRef: S,
    readOnly: O,
    disabled: P,
    localeText: k
  } = t, R = w.useRef(null), E = Ir(), M = ((Q = a == null ? void 0 : a.toolbar) == null ? void 0 : Q.hidden) ?? !1, {
    open: _,
    actions: I,
    layoutProps: F,
    renderCurrentView: T,
    fieldProps: $,
    contextValue: N
  } = oO(J({}, r, {
    props: t,
    fieldRef: R,
    autoFocusView: !0,
    additionalViewProps: {},
    wrapperVariant: "mobile"
  })), W = i.field, L = Nt({
    elementType: W,
    externalSlotProps: a == null ? void 0 : a.field,
    additionalProps: J({}, $, M && {
      id: E
    }, !(P || O) && {
      onClick: I.onOpen,
      onKeyDown: iq(I.onOpen)
    }, {
      readOnly: O ?? !0,
      disabled: P,
      className: l,
      sx: u,
      format: d,
      formatDensity: p,
      enableAccessibleFieldDOMStructure: m,
      selectedSections: h,
      onSelectedSectionsChange: g,
      timezone: v,
      label: y,
      name: b
    }, S ? {
      inputRef: S
    } : {}),
    ownerState: t
  });
  L.inputProps = J({}, L.inputProps, {
    "aria-label": n($.value)
  });
  const V = J({
    textField: i.textField
  }, L.slots), z = i.layout ?? kg;
  let X = E;
  M && (y ? X = `${E}-label` : X = void 0);
  const le = J({}, a, {
    toolbar: J({}, a == null ? void 0 : a.toolbar, {
      titleId: E
    }),
    mobilePaper: J({
      "aria-labelledby": X
    }, a == null ? void 0 : a.mobilePaper)
  }), ne = It(R, L.unstableFieldRef);
  return {
    renderPicker: () => /* @__PURE__ */ x.jsxs(BS, {
      contextValue: N,
      localeText: k,
      children: [/* @__PURE__ */ x.jsx(W, J({}, L, {
        slots: V,
        slotProps: le,
        unstableFieldRef: ne
      })), /* @__PURE__ */ x.jsx(T6, J({}, I, {
        open: _,
        slots: i,
        slotProps: le,
        children: /* @__PURE__ */ x.jsx(z, J({}, F, le == null ? void 0 : le.layout, {
          slots: i,
          slotProps: le,
          children: T()
        }))
      }))]
    })
  };
}, cO = /* @__PURE__ */ w.forwardRef(function(t, n) {
  var p, m;
  const r = si(), i = un(), a = rO(t, "MuiMobileDatePicker"), l = J({
    day: Xa,
    month: Xa,
    year: Xa
  }, a.viewRenderers), u = J({}, a, {
    viewRenderers: l,
    format: yg(i, a, !1),
    slots: J({
      field: Rg
    }, a.slots),
    slotProps: J({}, a.slotProps, {
      field: (h) => {
        var g;
        return J({}, cd((g = a.slotProps) == null ? void 0 : g.field, h), FS(a), {
          ref: n
        });
      },
      toolbar: J({
        hidden: !1
      }, (p = a.slotProps) == null ? void 0 : p.toolbar)
    })
  }), {
    renderPicker: d
  } = R6({
    props: u,
    valueManager: $o,
    valueType: "date",
    getOpenDialogAriaText: TS({
      utils: i,
      formatKey: "fullDate",
      contextTranslation: r.openDatePickerDialogue,
      propsTranslation: (m = u.localeText) == null ? void 0 : m.openDatePickerDialogue
    }),
    validator: Yl
  });
  return d();
});
cO.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: o.bool,
  className: o.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: o.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: o.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: o.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: o.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: o.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: o.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: o.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: o.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: o.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: o.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: o.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: o.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: gn,
  /**
   * The label content.
   */
  label: o.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: o.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: o.object,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: o.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: o.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: o.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: o.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onAccept: o.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: o.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: o.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: o.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: o.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: o.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: o.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: o.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: o.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: o.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: o.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: o.oneOf(["landscape", "portrait"]),
  readOnly: o.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: o.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: o.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: o.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: o.oneOfType([o.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), o.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: o.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: o.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: o.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: o.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: o.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: o.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: o.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: o.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: o.shape({
    day: o.func,
    month: o.func,
    year: o.func
  }),
  /**
   * Available views.
   */
  views: o.arrayOf(o.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: o.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: o.oneOf([3, 4])
};
const k6 = ["desktopModeMediaQuery"], uO = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const r = cn({
    props: t,
    name: "MuiDatePicker"
  }), {
    desktopModeMediaQuery: i = aq
  } = r, a = ht(r, k6);
  return vC(i, {
    defaultMatches: !0
  }) ? /* @__PURE__ */ x.jsx(lO, J({
    ref: n
  }, a)) : /* @__PURE__ */ x.jsx(cO, J({
    ref: n
  }, a));
});
process.env.NODE_ENV !== "production" && (uO.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: o.bool,
  className: o.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: o.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: o.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: o.object,
  /**
   * CSS media query when `Mobile` mode will be changed to `Desktop`.
   * @default '@media (pointer: fine)'
   * @example '@media (min-width: 720px)' or theme.breakpoints.up("sm")
   */
  desktopModeMediaQuery: o.string,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: o.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: o.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: o.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: o.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: o.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: o.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: o.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: o.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: o.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: o.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: gn,
  /**
   * The label content.
   */
  label: o.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: o.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: o.object,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: o.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: o.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: o.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: o.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onAccept: o.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: o.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: o.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: o.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: o.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: o.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: o.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: o.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: o.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: o.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: o.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: o.oneOf(["landscape", "portrait"]),
  readOnly: o.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: o.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: o.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: o.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: o.oneOfType([o.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), o.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: o.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: o.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: o.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: o.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: o.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: o.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: o.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: o.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: o.shape({
    day: o.func,
    month: o.func,
    year: o.func
  }),
  /**
   * Available views.
   */
  views: o.arrayOf(o.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: o.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 4 on desktop, 3 on mobile
   */
  yearsPerRow: o.oneOf([3, 4])
});
const P6 = {
  // Year
  y: {
    sectionType: "year",
    contentType: "digit",
    maxLength: 4
  },
  yy: "year",
  yyy: {
    sectionType: "year",
    contentType: "digit",
    maxLength: 4
  },
  yyyy: "year",
  // Month
  M: {
    sectionType: "month",
    contentType: "digit",
    maxLength: 2
  },
  MM: "month",
  MMMM: {
    sectionType: "month",
    contentType: "letter"
  },
  MMM: {
    sectionType: "month",
    contentType: "letter"
  },
  L: {
    sectionType: "month",
    contentType: "digit",
    maxLength: 2
  },
  LL: "month",
  LLL: {
    sectionType: "month",
    contentType: "letter"
  },
  LLLL: {
    sectionType: "month",
    contentType: "letter"
  },
  // Day of the month
  d: {
    sectionType: "day",
    contentType: "digit",
    maxLength: 2
  },
  dd: "day",
  do: {
    sectionType: "day",
    contentType: "digit-with-letter"
  },
  // Day of the week
  E: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEEEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  i: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  ii: "weekDay",
  iii: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  iiii: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  // eslint-disable-next-line id-denylist
  e: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  ee: "weekDay",
  eee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeeeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  c: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  cc: "weekDay",
  ccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  cccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  ccccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  cccccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  // Meridiem
  a: "meridiem",
  aa: "meridiem",
  aaa: "meridiem",
  // Hours
  H: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  HH: "hours",
  h: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  hh: "hours",
  // Minutes
  m: {
    sectionType: "minutes",
    contentType: "digit",
    maxLength: 2
  },
  mm: "minutes",
  // Seconds
  s: {
    sectionType: "seconds",
    contentType: "digit",
    maxLength: 2
  },
  ss: "seconds"
}, D6 = {
  year: "yyyy",
  month: "LLLL",
  monthShort: "MMM",
  dayOfMonth: "d",
  dayOfMonthFull: "do",
  weekday: "EEEE",
  weekdayShort: "EEEEEE",
  hours24h: "HH",
  hours12h: "hh",
  meridiem: "aa",
  minutes: "mm",
  seconds: "ss",
  fullDate: "PP",
  keyboardDate: "P",
  shortDate: "MMM d",
  normalDate: "d MMMM",
  normalDateWithWeekday: "EEE, MMM d",
  fullTime: "p",
  fullTime12h: "hh:mm aa",
  fullTime24h: "HH:mm",
  keyboardDateTime: "P p",
  keyboardDateTime12h: "P hh:mm aa",
  keyboardDateTime24h: "P HH:mm"
};
class M6 {
  constructor(t) {
    this.isMUIAdapter = !0, this.isTimezoneCompatible = !1, this.lib = void 0, this.locale = void 0, this.formats = void 0, this.formatTokenMap = P6, this.escapedCharacters = {
      start: "'",
      end: "'"
    }, this.longFormatters = void 0, this.date = (l) => typeof l > "u" ? /* @__PURE__ */ new Date() : l === null ? null : new Date(l), this.getInvalidDate = () => /* @__PURE__ */ new Date("Invalid Date"), this.getTimezone = () => "default", this.setTimezone = (l) => l, this.toJsDate = (l) => l, this.getCurrentLocaleCode = () => this.locale.code, this.is12HourCycleInCurrentLocale = () => /a/.test(this.locale.formatLong.time({
      width: "short"
    })), this.expandFormat = (l) => {
      const u = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
      return l.match(u).map((d) => {
        const p = d[0];
        if (p === "p" || p === "P") {
          const m = this.longFormatters[p];
          return m(d, this.locale.formatLong);
        }
        return d;
      }).join("");
    }, this.formatNumber = (l) => l, this.getDayOfWeek = (l) => l.getDay() + 1;
    const {
      locale: n,
      formats: r,
      longFormatters: i,
      lib: a
    } = t;
    this.locale = n, this.formats = J({}, D6, r), this.longFormatters = i, this.lib = a || "date-fns";
  }
}
class _6 extends M6 {
  constructor({
    locale: t,
    formats: n
  } = {}) {
    if (process.env.NODE_ENV !== "production") {
      if (typeof Ii != "function")
        throw new Error(["MUI: The `date-fns` package v2.x is not compatible with this adapter.", "Please, install v3.x or v4.x of the package or use the `AdapterDateFns` instead."].join(`
`));
      if (!Cl)
        throw new Error("MUI: The minimum supported `date-fns` package version compatible with this adapter is `3.2.x`.");
    }
    super({
      locale: t ?? jd,
      formats: n,
      longFormatters: Cl
    }), this.parse = (r, i) => r === "" ? null : e3(r, i, /* @__PURE__ */ new Date(), {
      locale: this.locale
    }), this.isValid = (r) => r == null ? !1 : $u(r), this.format = (r, i) => this.formatByString(r, this.formats[i]), this.formatByString = (r, i) => GW(r, i, {
      locale: this.locale
    }), this.isEqual = (r, i) => r === null && i === null ? !0 : r === null || i === null ? !1 : i4(r, i), this.isSameYear = (r, i) => o3(r, i), this.isSameMonth = (r, i) => r3(r, i), this.isSameDay = (r, i) => J5(r, i), this.isSameHour = (r, i) => n3(r, i), this.isAfter = (r, i) => bm(r, i), this.isAfterYear = (r, i) => bm(r, a0(i)), this.isAfterDay = (r, i) => bm(r, i0(i)), this.isBefore = (r, i) => vm(r, i), this.isBeforeYear = (r, i) => vm(r, this.startOfYear(i)), this.isBeforeDay = (r, i) => vm(r, this.startOfDay(i)), this.isWithinRange = (r, [i, a]) => i3(r, {
      start: i,
      end: a
    }), this.startOfYear = (r) => hS(r), this.startOfMonth = (r) => nW(r), this.startOfWeek = (r) => oi(r, {
      locale: this.locale
    }), this.startOfDay = (r) => wl(r), this.endOfYear = (r) => a0(r), this.endOfMonth = (r) => tW(r), this.endOfWeek = (r) => rW(r, {
      locale: this.locale
    }), this.endOfDay = (r) => i0(r), this.addYears = (r, i) => ju(r, i), this.addMonths = (r, i) => xl(r, i), this.addWeeks = (r, i) => Iu(r, i), this.addDays = (r, i) => Ii(r, i), this.addHours = (r, i) => Y5(r, i), this.addMinutes = (r, i) => Q5(r, i), this.addSeconds = (r, i) => Z5(r, i), this.getYear = (r) => o4(r), this.getMonth = (r) => n4(r), this.getDate = (r) => XW(r), this.getHours = (r) => ZW(r), this.getMinutes = (r) => t4(r), this.getSeconds = (r) => r4(r), this.getMilliseconds = (r) => e4(r), this.setYear = (r, i) => p3(r, i), this.setMonth = (r, i) => a3(r, i), this.setDate = (r, i) => s3(r, i), this.setHours = (r, i) => l3(r, i), this.setMinutes = (r, i) => u3(r, i), this.setSeconds = (r, i) => d3(r, i), this.setMilliseconds = (r, i) => c3(r, i), this.getDaysInMonth = (r) => xS(r), this.getWeekArray = (r) => {
      const i = this.startOfWeek(this.startOfMonth(r)), a = this.endOfWeek(this.endOfMonth(r));
      let l = 0, u = i;
      const d = [];
      for (; this.isBefore(u, a); ) {
        const p = Math.floor(l / 7);
        d[p] = d[p] || [], d[p].push(u), u = this.addDays(u, 1), l += 1;
      }
      return d;
    }, this.getWeekNumber = (r) => dg(r, {
      locale: this.locale
    }), this.getYearRange = ([r, i]) => {
      const a = this.startOfYear(r), l = this.endOfYear(i), u = [];
      let d = a;
      for (; this.isBefore(d, l); )
        u.push(d), d = this.addYears(d, 1);
      return u;
    };
  }
}
const I6 = ({
  disabled: e = !1,
  value: t,
  onChange: n,
  error: r,
  name: i,
  label: a,
  readOnly: l = !1,
  min: u,
  minPeriod: d,
  minDirection: p,
  max: m,
  maxPeriod: h,
  maxDirection: g,
  message: v,
  messageComparison: b,
  messageAmount: y,
  messagePeriod: S,
  messageIsAfter: O,
  displayDays: P = !0
}) => {
  const [k, R] = Kt(!1), [E, M] = Kt(null), _ = () => {
    R(!k), M(v || null);
  }, I = (T, $) => {
    if (!(T === null || !$u(T))) {
      if (v && b && y && S && O) {
        let N = /* @__PURE__ */ new Date();
        switch (S) {
          case "days":
            N = O ? Ii(N, y) : p0(N, y);
            break;
          case "weeks":
            N = O ? Iu(N, y) : m0(N, y);
            break;
          case "months":
            N = O ? xl(N, y) : f0(N, y);
            break;
          case "years":
            N = O ? ju(N, y) : h0(N, y);
            break;
        }
        if (b === "lessthan" && T < N || b === "morethan" && T > N) {
          _();
          return;
        }
      }
      $(T);
    }
  }, F = (T, $, N) => {
    const W = N === "after";
    switch ($) {
      case "days":
        return W ? Ii(/* @__PURE__ */ new Date(), T) : p0(/* @__PURE__ */ new Date(), T + 1);
      case "weeks":
        return W ? Iu(/* @__PURE__ */ new Date(), T) : m0(/* @__PURE__ */ new Date(), T + 1);
      case "months":
        return W ? xl(/* @__PURE__ */ new Date(), T) : f0(/* @__PURE__ */ new Date(), T + 1);
      case "years":
        return W ? ju(/* @__PURE__ */ new Date(), T) : h0(/* @__PURE__ */ new Date(), T + 1);
    }
  };
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsxs(sr, { fullWidth: !0, size: "small", children: [
      /* @__PURE__ */ x.jsx(jr, { id: `${i}-label`, disabled: e, children: a }),
      /* @__PURE__ */ x.jsx(mg, { dateAdapter: _6, adapterLocale: jd, children: /* @__PURE__ */ x.jsx(
        uO,
        {
          "aria-labelledby": `${i}-label`,
          value: $u(t) ? t : null,
          disabled: e,
          readOnly: e || l,
          slotProps: {
            textField: { size: "small", error: !!r },
            field: { clearable: !0, onClear: () => n(void 0) },
            openPickerButton: {
              className: "openDatePickerIconButton"
            }
          },
          views: P ? ["day", "month", "year"] : ["month", "year"],
          onChange: (T) => I(T, n),
          minDate: u && d && p ? F(u, d, p) : void 0,
          maxDate: m && h && g ? F(m, h, g) : void 0
        }
      ) })
    ] }),
    r ? /* @__PURE__ */ x.jsx(at, { variant: "caption", color: "error", children: r.message }) : /* @__PURE__ */ x.jsx("br", {}),
    /* @__PURE__ */ x.jsxs(fs, { open: k, onClose: _, children: [
      /* @__PURE__ */ x.jsx(rs, { variant: "h4", component: "h2", children: "Warning" }),
      /* @__PURE__ */ x.jsx(Fh, { children: /* @__PURE__ */ x.jsx(at, { children: E }) }),
      /* @__PURE__ */ x.jsx(Ri, { children: /* @__PURE__ */ x.jsx(En, { onClick: _, children: "Close" }) })
    ] })
  ] });
};
function j6(e, t, n) {
  const r = e.includes(t) ? e.filter((i) => i !== t) : [...e, t];
  n(r);
}
const $6 = ({
  label: e,
  disabled: t,
  value: n,
  onChange: r,
  error: i,
  name: a,
  readOnly: l,
  options: u,
  control: d,
  direction: p = "horizontal",
  itemWrapperProps: m = {}
}) => /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
  /* @__PURE__ */ x.jsxs(sr, { fullWidth: !0, size: "small", sx: { pointerEvents: l ? "none" : "auto" }, children: [
    /* @__PURE__ */ x.jsx(jr, { id: `${a}-label`, children: e }),
    /* @__PURE__ */ x.jsx(Lh, { children: /* @__PURE__ */ x.jsxs(sn, { direction: p === "horizontal" ? "row" : "column", flexWrap: "wrap", columnGap: 3, rowGap: 2, children: [
      u.map(({ value: h, label: g, textField: v }) => {
        const b = lS(h), { sx: y = {}, ...S } = m;
        return /* @__PURE__ */ x.jsxs(Mr, { sx: { display: "flex", alignItems: "flex-start", ...y }, ...S, children: [
          /* @__PURE__ */ x.jsx(
            Sd,
            {
              control: /* @__PURE__ */ x.jsx(
                $h,
                {
                  value: h,
                  disabled: t || l,
                  checked: n.includes(h),
                  onChange: () => j6(n, h, r)
                }
              ),
              label: g || h
            }
          ),
          v && /* @__PURE__ */ x.jsx(
            cS,
            {
              dependsOn: {
                disabled: !!(t || l),
                name: a,
                value: h
              },
              control: d,
              textField: v
            },
            `${a}-${b}-additional`
          )
        ] }, `${a}-checkbox-${b}`);
      }),
      /* @__PURE__ */ x.jsx(Mr, { flexGrow: "1" })
    ] }) })
  ] }),
  i && /* @__PURE__ */ x.jsx(at, { variant: "caption", color: "error", children: i.message })
] });
function ba(e, t, n, r) {
  function i(a) {
    return a instanceof n ? a : new n(function(l) {
      l(a);
    });
  }
  return new (n || (n = Promise))(function(a, l) {
    function u(m) {
      try {
        p(r.next(m));
      } catch (h) {
        l(h);
      }
    }
    function d(m) {
      try {
        p(r.throw(m));
      } catch (h) {
        l(h);
      }
    }
    function p(m) {
      m.done ? a(m.value) : i(m.value).then(u, d);
    }
    p((r = r.apply(e, t || [])).next());
  });
}
const A6 = /* @__PURE__ */ new Map([
  // https://github.com/guzzle/psr7/blob/2d9260799e713f1c475d3c5fdc3d6561ff7441b2/src/MimeType.php
  ["1km", "application/vnd.1000minds.decision-model+xml"],
  ["3dml", "text/vnd.in3d.3dml"],
  ["3ds", "image/x-3ds"],
  ["3g2", "video/3gpp2"],
  ["3gp", "video/3gp"],
  ["3gpp", "video/3gpp"],
  ["3mf", "model/3mf"],
  ["7z", "application/x-7z-compressed"],
  ["7zip", "application/x-7z-compressed"],
  ["123", "application/vnd.lotus-1-2-3"],
  ["aab", "application/x-authorware-bin"],
  ["aac", "audio/x-acc"],
  ["aam", "application/x-authorware-map"],
  ["aas", "application/x-authorware-seg"],
  ["abw", "application/x-abiword"],
  ["ac", "application/vnd.nokia.n-gage.ac+xml"],
  ["ac3", "audio/ac3"],
  ["acc", "application/vnd.americandynamics.acc"],
  ["ace", "application/x-ace-compressed"],
  ["acu", "application/vnd.acucobol"],
  ["acutc", "application/vnd.acucorp"],
  ["adp", "audio/adpcm"],
  ["aep", "application/vnd.audiograph"],
  ["afm", "application/x-font-type1"],
  ["afp", "application/vnd.ibm.modcap"],
  ["ahead", "application/vnd.ahead.space"],
  ["ai", "application/pdf"],
  ["aif", "audio/x-aiff"],
  ["aifc", "audio/x-aiff"],
  ["aiff", "audio/x-aiff"],
  ["air", "application/vnd.adobe.air-application-installer-package+zip"],
  ["ait", "application/vnd.dvb.ait"],
  ["ami", "application/vnd.amiga.ami"],
  ["amr", "audio/amr"],
  ["apk", "application/vnd.android.package-archive"],
  ["apng", "image/apng"],
  ["appcache", "text/cache-manifest"],
  ["application", "application/x-ms-application"],
  ["apr", "application/vnd.lotus-approach"],
  ["arc", "application/x-freearc"],
  ["arj", "application/x-arj"],
  ["asc", "application/pgp-signature"],
  ["asf", "video/x-ms-asf"],
  ["asm", "text/x-asm"],
  ["aso", "application/vnd.accpac.simply.aso"],
  ["asx", "video/x-ms-asf"],
  ["atc", "application/vnd.acucorp"],
  ["atom", "application/atom+xml"],
  ["atomcat", "application/atomcat+xml"],
  ["atomdeleted", "application/atomdeleted+xml"],
  ["atomsvc", "application/atomsvc+xml"],
  ["atx", "application/vnd.antix.game-component"],
  ["au", "audio/x-au"],
  ["avi", "video/x-msvideo"],
  ["avif", "image/avif"],
  ["aw", "application/applixware"],
  ["azf", "application/vnd.airzip.filesecure.azf"],
  ["azs", "application/vnd.airzip.filesecure.azs"],
  ["azv", "image/vnd.airzip.accelerator.azv"],
  ["azw", "application/vnd.amazon.ebook"],
  ["b16", "image/vnd.pco.b16"],
  ["bat", "application/x-msdownload"],
  ["bcpio", "application/x-bcpio"],
  ["bdf", "application/x-font-bdf"],
  ["bdm", "application/vnd.syncml.dm+wbxml"],
  ["bdoc", "application/x-bdoc"],
  ["bed", "application/vnd.realvnc.bed"],
  ["bh2", "application/vnd.fujitsu.oasysprs"],
  ["bin", "application/octet-stream"],
  ["blb", "application/x-blorb"],
  ["blorb", "application/x-blorb"],
  ["bmi", "application/vnd.bmi"],
  ["bmml", "application/vnd.balsamiq.bmml+xml"],
  ["bmp", "image/bmp"],
  ["book", "application/vnd.framemaker"],
  ["box", "application/vnd.previewsystems.box"],
  ["boz", "application/x-bzip2"],
  ["bpk", "application/octet-stream"],
  ["bpmn", "application/octet-stream"],
  ["bsp", "model/vnd.valve.source.compiled-map"],
  ["btif", "image/prs.btif"],
  ["buffer", "application/octet-stream"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["c", "text/x-c"],
  ["c4d", "application/vnd.clonk.c4group"],
  ["c4f", "application/vnd.clonk.c4group"],
  ["c4g", "application/vnd.clonk.c4group"],
  ["c4p", "application/vnd.clonk.c4group"],
  ["c4u", "application/vnd.clonk.c4group"],
  ["c11amc", "application/vnd.cluetrust.cartomobile-config"],
  ["c11amz", "application/vnd.cluetrust.cartomobile-config-pkg"],
  ["cab", "application/vnd.ms-cab-compressed"],
  ["caf", "audio/x-caf"],
  ["cap", "application/vnd.tcpdump.pcap"],
  ["car", "application/vnd.curl.car"],
  ["cat", "application/vnd.ms-pki.seccat"],
  ["cb7", "application/x-cbr"],
  ["cba", "application/x-cbr"],
  ["cbr", "application/x-cbr"],
  ["cbt", "application/x-cbr"],
  ["cbz", "application/x-cbr"],
  ["cc", "text/x-c"],
  ["cco", "application/x-cocoa"],
  ["cct", "application/x-director"],
  ["ccxml", "application/ccxml+xml"],
  ["cdbcmsg", "application/vnd.contact.cmsg"],
  ["cda", "application/x-cdf"],
  ["cdf", "application/x-netcdf"],
  ["cdfx", "application/cdfx+xml"],
  ["cdkey", "application/vnd.mediastation.cdkey"],
  ["cdmia", "application/cdmi-capability"],
  ["cdmic", "application/cdmi-container"],
  ["cdmid", "application/cdmi-domain"],
  ["cdmio", "application/cdmi-object"],
  ["cdmiq", "application/cdmi-queue"],
  ["cdr", "application/cdr"],
  ["cdx", "chemical/x-cdx"],
  ["cdxml", "application/vnd.chemdraw+xml"],
  ["cdy", "application/vnd.cinderella"],
  ["cer", "application/pkix-cert"],
  ["cfs", "application/x-cfs-compressed"],
  ["cgm", "image/cgm"],
  ["chat", "application/x-chat"],
  ["chm", "application/vnd.ms-htmlhelp"],
  ["chrt", "application/vnd.kde.kchart"],
  ["cif", "chemical/x-cif"],
  ["cii", "application/vnd.anser-web-certificate-issue-initiation"],
  ["cil", "application/vnd.ms-artgalry"],
  ["cjs", "application/node"],
  ["cla", "application/vnd.claymore"],
  ["class", "application/octet-stream"],
  ["clkk", "application/vnd.crick.clicker.keyboard"],
  ["clkp", "application/vnd.crick.clicker.palette"],
  ["clkt", "application/vnd.crick.clicker.template"],
  ["clkw", "application/vnd.crick.clicker.wordbank"],
  ["clkx", "application/vnd.crick.clicker"],
  ["clp", "application/x-msclip"],
  ["cmc", "application/vnd.cosmocaller"],
  ["cmdf", "chemical/x-cmdf"],
  ["cml", "chemical/x-cml"],
  ["cmp", "application/vnd.yellowriver-custom-menu"],
  ["cmx", "image/x-cmx"],
  ["cod", "application/vnd.rim.cod"],
  ["coffee", "text/coffeescript"],
  ["com", "application/x-msdownload"],
  ["conf", "text/plain"],
  ["cpio", "application/x-cpio"],
  ["cpp", "text/x-c"],
  ["cpt", "application/mac-compactpro"],
  ["crd", "application/x-mscardfile"],
  ["crl", "application/pkix-crl"],
  ["crt", "application/x-x509-ca-cert"],
  ["crx", "application/x-chrome-extension"],
  ["cryptonote", "application/vnd.rig.cryptonote"],
  ["csh", "application/x-csh"],
  ["csl", "application/vnd.citationstyles.style+xml"],
  ["csml", "chemical/x-csml"],
  ["csp", "application/vnd.commonspace"],
  ["csr", "application/octet-stream"],
  ["css", "text/css"],
  ["cst", "application/x-director"],
  ["csv", "text/csv"],
  ["cu", "application/cu-seeme"],
  ["curl", "text/vnd.curl"],
  ["cww", "application/prs.cww"],
  ["cxt", "application/x-director"],
  ["cxx", "text/x-c"],
  ["dae", "model/vnd.collada+xml"],
  ["daf", "application/vnd.mobius.daf"],
  ["dart", "application/vnd.dart"],
  ["dataless", "application/vnd.fdsn.seed"],
  ["davmount", "application/davmount+xml"],
  ["dbf", "application/vnd.dbf"],
  ["dbk", "application/docbook+xml"],
  ["dcr", "application/x-director"],
  ["dcurl", "text/vnd.curl.dcurl"],
  ["dd2", "application/vnd.oma.dd2+xml"],
  ["ddd", "application/vnd.fujixerox.ddd"],
  ["ddf", "application/vnd.syncml.dmddf+xml"],
  ["dds", "image/vnd.ms-dds"],
  ["deb", "application/x-debian-package"],
  ["def", "text/plain"],
  ["deploy", "application/octet-stream"],
  ["der", "application/x-x509-ca-cert"],
  ["dfac", "application/vnd.dreamfactory"],
  ["dgc", "application/x-dgc-compressed"],
  ["dic", "text/x-c"],
  ["dir", "application/x-director"],
  ["dis", "application/vnd.mobius.dis"],
  ["disposition-notification", "message/disposition-notification"],
  ["dist", "application/octet-stream"],
  ["distz", "application/octet-stream"],
  ["djv", "image/vnd.djvu"],
  ["djvu", "image/vnd.djvu"],
  ["dll", "application/octet-stream"],
  ["dmg", "application/x-apple-diskimage"],
  ["dmn", "application/octet-stream"],
  ["dmp", "application/vnd.tcpdump.pcap"],
  ["dms", "application/octet-stream"],
  ["dna", "application/vnd.dna"],
  ["doc", "application/msword"],
  ["docm", "application/vnd.ms-word.template.macroEnabled.12"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["dot", "application/msword"],
  ["dotm", "application/vnd.ms-word.template.macroEnabled.12"],
  ["dotx", "application/vnd.openxmlformats-officedocument.wordprocessingml.template"],
  ["dp", "application/vnd.osgi.dp"],
  ["dpg", "application/vnd.dpgraph"],
  ["dra", "audio/vnd.dra"],
  ["drle", "image/dicom-rle"],
  ["dsc", "text/prs.lines.tag"],
  ["dssc", "application/dssc+der"],
  ["dtb", "application/x-dtbook+xml"],
  ["dtd", "application/xml-dtd"],
  ["dts", "audio/vnd.dts"],
  ["dtshd", "audio/vnd.dts.hd"],
  ["dump", "application/octet-stream"],
  ["dvb", "video/vnd.dvb.file"],
  ["dvi", "application/x-dvi"],
  ["dwd", "application/atsc-dwd+xml"],
  ["dwf", "model/vnd.dwf"],
  ["dwg", "image/vnd.dwg"],
  ["dxf", "image/vnd.dxf"],
  ["dxp", "application/vnd.spotfire.dxp"],
  ["dxr", "application/x-director"],
  ["ear", "application/java-archive"],
  ["ecelp4800", "audio/vnd.nuera.ecelp4800"],
  ["ecelp7470", "audio/vnd.nuera.ecelp7470"],
  ["ecelp9600", "audio/vnd.nuera.ecelp9600"],
  ["ecma", "application/ecmascript"],
  ["edm", "application/vnd.novadigm.edm"],
  ["edx", "application/vnd.novadigm.edx"],
  ["efif", "application/vnd.picsel"],
  ["ei6", "application/vnd.pg.osasli"],
  ["elc", "application/octet-stream"],
  ["emf", "image/emf"],
  ["eml", "message/rfc822"],
  ["emma", "application/emma+xml"],
  ["emotionml", "application/emotionml+xml"],
  ["emz", "application/x-msmetafile"],
  ["eol", "audio/vnd.digital-winds"],
  ["eot", "application/vnd.ms-fontobject"],
  ["eps", "application/postscript"],
  ["epub", "application/epub+zip"],
  ["es", "application/ecmascript"],
  ["es3", "application/vnd.eszigno3+xml"],
  ["esa", "application/vnd.osgi.subsystem"],
  ["esf", "application/vnd.epson.esf"],
  ["et3", "application/vnd.eszigno3+xml"],
  ["etx", "text/x-setext"],
  ["eva", "application/x-eva"],
  ["evy", "application/x-envoy"],
  ["exe", "application/octet-stream"],
  ["exi", "application/exi"],
  ["exp", "application/express"],
  ["exr", "image/aces"],
  ["ext", "application/vnd.novadigm.ext"],
  ["ez", "application/andrew-inset"],
  ["ez2", "application/vnd.ezpix-album"],
  ["ez3", "application/vnd.ezpix-package"],
  ["f", "text/x-fortran"],
  ["f4v", "video/mp4"],
  ["f77", "text/x-fortran"],
  ["f90", "text/x-fortran"],
  ["fbs", "image/vnd.fastbidsheet"],
  ["fcdt", "application/vnd.adobe.formscentral.fcdt"],
  ["fcs", "application/vnd.isac.fcs"],
  ["fdf", "application/vnd.fdf"],
  ["fdt", "application/fdt+xml"],
  ["fe_launch", "application/vnd.denovo.fcselayout-link"],
  ["fg5", "application/vnd.fujitsu.oasysgp"],
  ["fgd", "application/x-director"],
  ["fh", "image/x-freehand"],
  ["fh4", "image/x-freehand"],
  ["fh5", "image/x-freehand"],
  ["fh7", "image/x-freehand"],
  ["fhc", "image/x-freehand"],
  ["fig", "application/x-xfig"],
  ["fits", "image/fits"],
  ["flac", "audio/x-flac"],
  ["fli", "video/x-fli"],
  ["flo", "application/vnd.micrografx.flo"],
  ["flv", "video/x-flv"],
  ["flw", "application/vnd.kde.kivio"],
  ["flx", "text/vnd.fmi.flexstor"],
  ["fly", "text/vnd.fly"],
  ["fm", "application/vnd.framemaker"],
  ["fnc", "application/vnd.frogans.fnc"],
  ["fo", "application/vnd.software602.filler.form+xml"],
  ["for", "text/x-fortran"],
  ["fpx", "image/vnd.fpx"],
  ["frame", "application/vnd.framemaker"],
  ["fsc", "application/vnd.fsc.weblaunch"],
  ["fst", "image/vnd.fst"],
  ["ftc", "application/vnd.fluxtime.clip"],
  ["fti", "application/vnd.anser-web-funds-transfer-initiation"],
  ["fvt", "video/vnd.fvt"],
  ["fxp", "application/vnd.adobe.fxp"],
  ["fxpl", "application/vnd.adobe.fxp"],
  ["fzs", "application/vnd.fuzzysheet"],
  ["g2w", "application/vnd.geoplan"],
  ["g3", "image/g3fax"],
  ["g3w", "application/vnd.geospace"],
  ["gac", "application/vnd.groove-account"],
  ["gam", "application/x-tads"],
  ["gbr", "application/rpki-ghostbusters"],
  ["gca", "application/x-gca-compressed"],
  ["gdl", "model/vnd.gdl"],
  ["gdoc", "application/vnd.google-apps.document"],
  ["geo", "application/vnd.dynageo"],
  ["geojson", "application/geo+json"],
  ["gex", "application/vnd.geometry-explorer"],
  ["ggb", "application/vnd.geogebra.file"],
  ["ggt", "application/vnd.geogebra.tool"],
  ["ghf", "application/vnd.groove-help"],
  ["gif", "image/gif"],
  ["gim", "application/vnd.groove-identity-message"],
  ["glb", "model/gltf-binary"],
  ["gltf", "model/gltf+json"],
  ["gml", "application/gml+xml"],
  ["gmx", "application/vnd.gmx"],
  ["gnumeric", "application/x-gnumeric"],
  ["gpg", "application/gpg-keys"],
  ["gph", "application/vnd.flographit"],
  ["gpx", "application/gpx+xml"],
  ["gqf", "application/vnd.grafeq"],
  ["gqs", "application/vnd.grafeq"],
  ["gram", "application/srgs"],
  ["gramps", "application/x-gramps-xml"],
  ["gre", "application/vnd.geometry-explorer"],
  ["grv", "application/vnd.groove-injector"],
  ["grxml", "application/srgs+xml"],
  ["gsf", "application/x-font-ghostscript"],
  ["gsheet", "application/vnd.google-apps.spreadsheet"],
  ["gslides", "application/vnd.google-apps.presentation"],
  ["gtar", "application/x-gtar"],
  ["gtm", "application/vnd.groove-tool-message"],
  ["gtw", "model/vnd.gtw"],
  ["gv", "text/vnd.graphviz"],
  ["gxf", "application/gxf"],
  ["gxt", "application/vnd.geonext"],
  ["gz", "application/gzip"],
  ["gzip", "application/gzip"],
  ["h", "text/x-c"],
  ["h261", "video/h261"],
  ["h263", "video/h263"],
  ["h264", "video/h264"],
  ["hal", "application/vnd.hal+xml"],
  ["hbci", "application/vnd.hbci"],
  ["hbs", "text/x-handlebars-template"],
  ["hdd", "application/x-virtualbox-hdd"],
  ["hdf", "application/x-hdf"],
  ["heic", "image/heic"],
  ["heics", "image/heic-sequence"],
  ["heif", "image/heif"],
  ["heifs", "image/heif-sequence"],
  ["hej2", "image/hej2k"],
  ["held", "application/atsc-held+xml"],
  ["hh", "text/x-c"],
  ["hjson", "application/hjson"],
  ["hlp", "application/winhlp"],
  ["hpgl", "application/vnd.hp-hpgl"],
  ["hpid", "application/vnd.hp-hpid"],
  ["hps", "application/vnd.hp-hps"],
  ["hqx", "application/mac-binhex40"],
  ["hsj2", "image/hsj2"],
  ["htc", "text/x-component"],
  ["htke", "application/vnd.kenameaapp"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["hvd", "application/vnd.yamaha.hv-dic"],
  ["hvp", "application/vnd.yamaha.hv-voice"],
  ["hvs", "application/vnd.yamaha.hv-script"],
  ["i2g", "application/vnd.intergeo"],
  ["icc", "application/vnd.iccprofile"],
  ["ice", "x-conference/x-cooltalk"],
  ["icm", "application/vnd.iccprofile"],
  ["ico", "image/x-icon"],
  ["ics", "text/calendar"],
  ["ief", "image/ief"],
  ["ifb", "text/calendar"],
  ["ifm", "application/vnd.shana.informed.formdata"],
  ["iges", "model/iges"],
  ["igl", "application/vnd.igloader"],
  ["igm", "application/vnd.insors.igm"],
  ["igs", "model/iges"],
  ["igx", "application/vnd.micrografx.igx"],
  ["iif", "application/vnd.shana.informed.interchange"],
  ["img", "application/octet-stream"],
  ["imp", "application/vnd.accpac.simply.imp"],
  ["ims", "application/vnd.ms-ims"],
  ["in", "text/plain"],
  ["ini", "text/plain"],
  ["ink", "application/inkml+xml"],
  ["inkml", "application/inkml+xml"],
  ["install", "application/x-install-instructions"],
  ["iota", "application/vnd.astraea-software.iota"],
  ["ipfix", "application/ipfix"],
  ["ipk", "application/vnd.shana.informed.package"],
  ["irm", "application/vnd.ibm.rights-management"],
  ["irp", "application/vnd.irepository.package+xml"],
  ["iso", "application/x-iso9660-image"],
  ["itp", "application/vnd.shana.informed.formtemplate"],
  ["its", "application/its+xml"],
  ["ivp", "application/vnd.immervision-ivp"],
  ["ivu", "application/vnd.immervision-ivu"],
  ["jad", "text/vnd.sun.j2me.app-descriptor"],
  ["jade", "text/jade"],
  ["jam", "application/vnd.jam"],
  ["jar", "application/java-archive"],
  ["jardiff", "application/x-java-archive-diff"],
  ["java", "text/x-java-source"],
  ["jhc", "image/jphc"],
  ["jisp", "application/vnd.jisp"],
  ["jls", "image/jls"],
  ["jlt", "application/vnd.hp-jlyt"],
  ["jng", "image/x-jng"],
  ["jnlp", "application/x-java-jnlp-file"],
  ["joda", "application/vnd.joost.joda-archive"],
  ["jp2", "image/jp2"],
  ["jpe", "image/jpeg"],
  ["jpeg", "image/jpeg"],
  ["jpf", "image/jpx"],
  ["jpg", "image/jpeg"],
  ["jpg2", "image/jp2"],
  ["jpgm", "video/jpm"],
  ["jpgv", "video/jpeg"],
  ["jph", "image/jph"],
  ["jpm", "video/jpm"],
  ["jpx", "image/jpx"],
  ["js", "application/javascript"],
  ["json", "application/json"],
  ["json5", "application/json5"],
  ["jsonld", "application/ld+json"],
  // https://jsonlines.org/
  ["jsonl", "application/jsonl"],
  ["jsonml", "application/jsonml+json"],
  ["jsx", "text/jsx"],
  ["jxr", "image/jxr"],
  ["jxra", "image/jxra"],
  ["jxrs", "image/jxrs"],
  ["jxs", "image/jxs"],
  ["jxsc", "image/jxsc"],
  ["jxsi", "image/jxsi"],
  ["jxss", "image/jxss"],
  ["kar", "audio/midi"],
  ["karbon", "application/vnd.kde.karbon"],
  ["kdb", "application/octet-stream"],
  ["kdbx", "application/x-keepass2"],
  ["key", "application/x-iwork-keynote-sffkey"],
  ["kfo", "application/vnd.kde.kformula"],
  ["kia", "application/vnd.kidspiration"],
  ["kml", "application/vnd.google-earth.kml+xml"],
  ["kmz", "application/vnd.google-earth.kmz"],
  ["kne", "application/vnd.kinar"],
  ["knp", "application/vnd.kinar"],
  ["kon", "application/vnd.kde.kontour"],
  ["kpr", "application/vnd.kde.kpresenter"],
  ["kpt", "application/vnd.kde.kpresenter"],
  ["kpxx", "application/vnd.ds-keypoint"],
  ["ksp", "application/vnd.kde.kspread"],
  ["ktr", "application/vnd.kahootz"],
  ["ktx", "image/ktx"],
  ["ktx2", "image/ktx2"],
  ["ktz", "application/vnd.kahootz"],
  ["kwd", "application/vnd.kde.kword"],
  ["kwt", "application/vnd.kde.kword"],
  ["lasxml", "application/vnd.las.las+xml"],
  ["latex", "application/x-latex"],
  ["lbd", "application/vnd.llamagraphics.life-balance.desktop"],
  ["lbe", "application/vnd.llamagraphics.life-balance.exchange+xml"],
  ["les", "application/vnd.hhe.lesson-player"],
  ["less", "text/less"],
  ["lgr", "application/lgr+xml"],
  ["lha", "application/octet-stream"],
  ["link66", "application/vnd.route66.link66+xml"],
  ["list", "text/plain"],
  ["list3820", "application/vnd.ibm.modcap"],
  ["listafp", "application/vnd.ibm.modcap"],
  ["litcoffee", "text/coffeescript"],
  ["lnk", "application/x-ms-shortcut"],
  ["log", "text/plain"],
  ["lostxml", "application/lost+xml"],
  ["lrf", "application/octet-stream"],
  ["lrm", "application/vnd.ms-lrm"],
  ["ltf", "application/vnd.frogans.ltf"],
  ["lua", "text/x-lua"],
  ["luac", "application/x-lua-bytecode"],
  ["lvp", "audio/vnd.lucent.voice"],
  ["lwp", "application/vnd.lotus-wordpro"],
  ["lzh", "application/octet-stream"],
  ["m1v", "video/mpeg"],
  ["m2a", "audio/mpeg"],
  ["m2v", "video/mpeg"],
  ["m3a", "audio/mpeg"],
  ["m3u", "text/plain"],
  ["m3u8", "application/vnd.apple.mpegurl"],
  ["m4a", "audio/x-m4a"],
  ["m4p", "application/mp4"],
  ["m4s", "video/iso.segment"],
  ["m4u", "application/vnd.mpegurl"],
  ["m4v", "video/x-m4v"],
  ["m13", "application/x-msmediaview"],
  ["m14", "application/x-msmediaview"],
  ["m21", "application/mp21"],
  ["ma", "application/mathematica"],
  ["mads", "application/mads+xml"],
  ["maei", "application/mmt-aei+xml"],
  ["mag", "application/vnd.ecowin.chart"],
  ["maker", "application/vnd.framemaker"],
  ["man", "text/troff"],
  ["manifest", "text/cache-manifest"],
  ["map", "application/json"],
  ["mar", "application/octet-stream"],
  ["markdown", "text/markdown"],
  ["mathml", "application/mathml+xml"],
  ["mb", "application/mathematica"],
  ["mbk", "application/vnd.mobius.mbk"],
  ["mbox", "application/mbox"],
  ["mc1", "application/vnd.medcalcdata"],
  ["mcd", "application/vnd.mcd"],
  ["mcurl", "text/vnd.curl.mcurl"],
  ["md", "text/markdown"],
  ["mdb", "application/x-msaccess"],
  ["mdi", "image/vnd.ms-modi"],
  ["mdx", "text/mdx"],
  ["me", "text/troff"],
  ["mesh", "model/mesh"],
  ["meta4", "application/metalink4+xml"],
  ["metalink", "application/metalink+xml"],
  ["mets", "application/mets+xml"],
  ["mfm", "application/vnd.mfmp"],
  ["mft", "application/rpki-manifest"],
  ["mgp", "application/vnd.osgeo.mapguide.package"],
  ["mgz", "application/vnd.proteus.magazine"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mie", "application/x-mie"],
  ["mif", "application/vnd.mif"],
  ["mime", "message/rfc822"],
  ["mj2", "video/mj2"],
  ["mjp2", "video/mj2"],
  ["mjs", "application/javascript"],
  ["mk3d", "video/x-matroska"],
  ["mka", "audio/x-matroska"],
  ["mkd", "text/x-markdown"],
  ["mks", "video/x-matroska"],
  ["mkv", "video/x-matroska"],
  ["mlp", "application/vnd.dolby.mlp"],
  ["mmd", "application/vnd.chipnuts.karaoke-mmd"],
  ["mmf", "application/vnd.smaf"],
  ["mml", "text/mathml"],
  ["mmr", "image/vnd.fujixerox.edmics-mmr"],
  ["mng", "video/x-mng"],
  ["mny", "application/x-msmoney"],
  ["mobi", "application/x-mobipocket-ebook"],
  ["mods", "application/mods+xml"],
  ["mov", "video/quicktime"],
  ["movie", "video/x-sgi-movie"],
  ["mp2", "audio/mpeg"],
  ["mp2a", "audio/mpeg"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mp4a", "audio/mp4"],
  ["mp4s", "application/mp4"],
  ["mp4v", "video/mp4"],
  ["mp21", "application/mp21"],
  ["mpc", "application/vnd.mophun.certificate"],
  ["mpd", "application/dash+xml"],
  ["mpe", "video/mpeg"],
  ["mpeg", "video/mpeg"],
  ["mpg", "video/mpeg"],
  ["mpg4", "video/mp4"],
  ["mpga", "audio/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["mpm", "application/vnd.blueice.multipass"],
  ["mpn", "application/vnd.mophun.application"],
  ["mpp", "application/vnd.ms-project"],
  ["mpt", "application/vnd.ms-project"],
  ["mpy", "application/vnd.ibm.minipay"],
  ["mqy", "application/vnd.mobius.mqy"],
  ["mrc", "application/marc"],
  ["mrcx", "application/marcxml+xml"],
  ["ms", "text/troff"],
  ["mscml", "application/mediaservercontrol+xml"],
  ["mseed", "application/vnd.fdsn.mseed"],
  ["mseq", "application/vnd.mseq"],
  ["msf", "application/vnd.epson.msf"],
  ["msg", "application/vnd.ms-outlook"],
  ["msh", "model/mesh"],
  ["msi", "application/x-msdownload"],
  ["msl", "application/vnd.mobius.msl"],
  ["msm", "application/octet-stream"],
  ["msp", "application/octet-stream"],
  ["msty", "application/vnd.muvee.style"],
  ["mtl", "model/mtl"],
  ["mts", "model/vnd.mts"],
  ["mus", "application/vnd.musician"],
  ["musd", "application/mmt-usd+xml"],
  ["musicxml", "application/vnd.recordare.musicxml+xml"],
  ["mvb", "application/x-msmediaview"],
  ["mvt", "application/vnd.mapbox-vector-tile"],
  ["mwf", "application/vnd.mfer"],
  ["mxf", "application/mxf"],
  ["mxl", "application/vnd.recordare.musicxml"],
  ["mxmf", "audio/mobile-xmf"],
  ["mxml", "application/xv+xml"],
  ["mxs", "application/vnd.triscape.mxs"],
  ["mxu", "video/vnd.mpegurl"],
  ["n-gage", "application/vnd.nokia.n-gage.symbian.install"],
  ["n3", "text/n3"],
  ["nb", "application/mathematica"],
  ["nbp", "application/vnd.wolfram.player"],
  ["nc", "application/x-netcdf"],
  ["ncx", "application/x-dtbncx+xml"],
  ["nfo", "text/x-nfo"],
  ["ngdat", "application/vnd.nokia.n-gage.data"],
  ["nitf", "application/vnd.nitf"],
  ["nlu", "application/vnd.neurolanguage.nlu"],
  ["nml", "application/vnd.enliven"],
  ["nnd", "application/vnd.noblenet-directory"],
  ["nns", "application/vnd.noblenet-sealer"],
  ["nnw", "application/vnd.noblenet-web"],
  ["npx", "image/vnd.net-fpx"],
  ["nq", "application/n-quads"],
  ["nsc", "application/x-conference"],
  ["nsf", "application/vnd.lotus-notes"],
  ["nt", "application/n-triples"],
  ["ntf", "application/vnd.nitf"],
  ["numbers", "application/x-iwork-numbers-sffnumbers"],
  ["nzb", "application/x-nzb"],
  ["oa2", "application/vnd.fujitsu.oasys2"],
  ["oa3", "application/vnd.fujitsu.oasys3"],
  ["oas", "application/vnd.fujitsu.oasys"],
  ["obd", "application/x-msbinder"],
  ["obgx", "application/vnd.openblox.game+xml"],
  ["obj", "model/obj"],
  ["oda", "application/oda"],
  ["odb", "application/vnd.oasis.opendocument.database"],
  ["odc", "application/vnd.oasis.opendocument.chart"],
  ["odf", "application/vnd.oasis.opendocument.formula"],
  ["odft", "application/vnd.oasis.opendocument.formula-template"],
  ["odg", "application/vnd.oasis.opendocument.graphics"],
  ["odi", "application/vnd.oasis.opendocument.image"],
  ["odm", "application/vnd.oasis.opendocument.text-master"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogex", "model/vnd.opengex"],
  ["ogg", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["omdoc", "application/omdoc+xml"],
  ["onepkg", "application/onenote"],
  ["onetmp", "application/onenote"],
  ["onetoc", "application/onenote"],
  ["onetoc2", "application/onenote"],
  ["opf", "application/oebps-package+xml"],
  ["opml", "text/x-opml"],
  ["oprc", "application/vnd.palm"],
  ["opus", "audio/ogg"],
  ["org", "text/x-org"],
  ["osf", "application/vnd.yamaha.openscoreformat"],
  ["osfpvg", "application/vnd.yamaha.openscoreformat.osfpvg+xml"],
  ["osm", "application/vnd.openstreetmap.data+xml"],
  ["otc", "application/vnd.oasis.opendocument.chart-template"],
  ["otf", "font/otf"],
  ["otg", "application/vnd.oasis.opendocument.graphics-template"],
  ["oth", "application/vnd.oasis.opendocument.text-web"],
  ["oti", "application/vnd.oasis.opendocument.image-template"],
  ["otp", "application/vnd.oasis.opendocument.presentation-template"],
  ["ots", "application/vnd.oasis.opendocument.spreadsheet-template"],
  ["ott", "application/vnd.oasis.opendocument.text-template"],
  ["ova", "application/x-virtualbox-ova"],
  ["ovf", "application/x-virtualbox-ovf"],
  ["owl", "application/rdf+xml"],
  ["oxps", "application/oxps"],
  ["oxt", "application/vnd.openofficeorg.extension"],
  ["p", "text/x-pascal"],
  ["p7a", "application/x-pkcs7-signature"],
  ["p7b", "application/x-pkcs7-certificates"],
  ["p7c", "application/pkcs7-mime"],
  ["p7m", "application/pkcs7-mime"],
  ["p7r", "application/x-pkcs7-certreqresp"],
  ["p7s", "application/pkcs7-signature"],
  ["p8", "application/pkcs8"],
  ["p10", "application/x-pkcs10"],
  ["p12", "application/x-pkcs12"],
  ["pac", "application/x-ns-proxy-autoconfig"],
  ["pages", "application/x-iwork-pages-sffpages"],
  ["pas", "text/x-pascal"],
  ["paw", "application/vnd.pawaafile"],
  ["pbd", "application/vnd.powerbuilder6"],
  ["pbm", "image/x-portable-bitmap"],
  ["pcap", "application/vnd.tcpdump.pcap"],
  ["pcf", "application/x-font-pcf"],
  ["pcl", "application/vnd.hp-pcl"],
  ["pclxl", "application/vnd.hp-pclxl"],
  ["pct", "image/x-pict"],
  ["pcurl", "application/vnd.curl.pcurl"],
  ["pcx", "image/x-pcx"],
  ["pdb", "application/x-pilot"],
  ["pde", "text/x-processing"],
  ["pdf", "application/pdf"],
  ["pem", "application/x-x509-user-cert"],
  ["pfa", "application/x-font-type1"],
  ["pfb", "application/x-font-type1"],
  ["pfm", "application/x-font-type1"],
  ["pfr", "application/font-tdpfr"],
  ["pfx", "application/x-pkcs12"],
  ["pgm", "image/x-portable-graymap"],
  ["pgn", "application/x-chess-pgn"],
  ["pgp", "application/pgp"],
  ["php", "application/x-httpd-php"],
  ["php3", "application/x-httpd-php"],
  ["php4", "application/x-httpd-php"],
  ["phps", "application/x-httpd-php-source"],
  ["phtml", "application/x-httpd-php"],
  ["pic", "image/x-pict"],
  ["pkg", "application/octet-stream"],
  ["pki", "application/pkixcmp"],
  ["pkipath", "application/pkix-pkipath"],
  ["pkpass", "application/vnd.apple.pkpass"],
  ["pl", "application/x-perl"],
  ["plb", "application/vnd.3gpp.pic-bw-large"],
  ["plc", "application/vnd.mobius.plc"],
  ["plf", "application/vnd.pocketlearn"],
  ["pls", "application/pls+xml"],
  ["pm", "application/x-perl"],
  ["pml", "application/vnd.ctc-posml"],
  ["png", "image/png"],
  ["pnm", "image/x-portable-anymap"],
  ["portpkg", "application/vnd.macports.portpkg"],
  ["pot", "application/vnd.ms-powerpoint"],
  ["potm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  ["potx", "application/vnd.openxmlformats-officedocument.presentationml.template"],
  ["ppa", "application/vnd.ms-powerpoint"],
  ["ppam", "application/vnd.ms-powerpoint.addin.macroEnabled.12"],
  ["ppd", "application/vnd.cups-ppd"],
  ["ppm", "image/x-portable-pixmap"],
  ["pps", "application/vnd.ms-powerpoint"],
  ["ppsm", "application/vnd.ms-powerpoint.slideshow.macroEnabled.12"],
  ["ppsx", "application/vnd.openxmlformats-officedocument.presentationml.slideshow"],
  ["ppt", "application/powerpoint"],
  ["pptm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["pqa", "application/vnd.palm"],
  ["prc", "application/x-pilot"],
  ["pre", "application/vnd.lotus-freelance"],
  ["prf", "application/pics-rules"],
  ["provx", "application/provenance+xml"],
  ["ps", "application/postscript"],
  ["psb", "application/vnd.3gpp.pic-bw-small"],
  ["psd", "application/x-photoshop"],
  ["psf", "application/x-font-linux-psf"],
  ["pskcxml", "application/pskc+xml"],
  ["pti", "image/prs.pti"],
  ["ptid", "application/vnd.pvi.ptid1"],
  ["pub", "application/x-mspublisher"],
  ["pvb", "application/vnd.3gpp.pic-bw-var"],
  ["pwn", "application/vnd.3m.post-it-notes"],
  ["pya", "audio/vnd.ms-playready.media.pya"],
  ["pyv", "video/vnd.ms-playready.media.pyv"],
  ["qam", "application/vnd.epson.quickanime"],
  ["qbo", "application/vnd.intu.qbo"],
  ["qfx", "application/vnd.intu.qfx"],
  ["qps", "application/vnd.publishare-delta-tree"],
  ["qt", "video/quicktime"],
  ["qwd", "application/vnd.quark.quarkxpress"],
  ["qwt", "application/vnd.quark.quarkxpress"],
  ["qxb", "application/vnd.quark.quarkxpress"],
  ["qxd", "application/vnd.quark.quarkxpress"],
  ["qxl", "application/vnd.quark.quarkxpress"],
  ["qxt", "application/vnd.quark.quarkxpress"],
  ["ra", "audio/x-realaudio"],
  ["ram", "audio/x-pn-realaudio"],
  ["raml", "application/raml+yaml"],
  ["rapd", "application/route-apd+xml"],
  ["rar", "application/x-rar"],
  ["ras", "image/x-cmu-raster"],
  ["rcprofile", "application/vnd.ipunplugged.rcprofile"],
  ["rdf", "application/rdf+xml"],
  ["rdz", "application/vnd.data-vision.rdz"],
  ["relo", "application/p2p-overlay+xml"],
  ["rep", "application/vnd.businessobjects"],
  ["res", "application/x-dtbresource+xml"],
  ["rgb", "image/x-rgb"],
  ["rif", "application/reginfo+xml"],
  ["rip", "audio/vnd.rip"],
  ["ris", "application/x-research-info-systems"],
  ["rl", "application/resource-lists+xml"],
  ["rlc", "image/vnd.fujixerox.edmics-rlc"],
  ["rld", "application/resource-lists-diff+xml"],
  ["rm", "audio/x-pn-realaudio"],
  ["rmi", "audio/midi"],
  ["rmp", "audio/x-pn-realaudio-plugin"],
  ["rms", "application/vnd.jcp.javame.midlet-rms"],
  ["rmvb", "application/vnd.rn-realmedia-vbr"],
  ["rnc", "application/relax-ng-compact-syntax"],
  ["rng", "application/xml"],
  ["roa", "application/rpki-roa"],
  ["roff", "text/troff"],
  ["rp9", "application/vnd.cloanto.rp9"],
  ["rpm", "audio/x-pn-realaudio-plugin"],
  ["rpss", "application/vnd.nokia.radio-presets"],
  ["rpst", "application/vnd.nokia.radio-preset"],
  ["rq", "application/sparql-query"],
  ["rs", "application/rls-services+xml"],
  ["rsa", "application/x-pkcs7"],
  ["rsat", "application/atsc-rsat+xml"],
  ["rsd", "application/rsd+xml"],
  ["rsheet", "application/urc-ressheet+xml"],
  ["rss", "application/rss+xml"],
  ["rtf", "text/rtf"],
  ["rtx", "text/richtext"],
  ["run", "application/x-makeself"],
  ["rusd", "application/route-usd+xml"],
  ["rv", "video/vnd.rn-realvideo"],
  ["s", "text/x-asm"],
  ["s3m", "audio/s3m"],
  ["saf", "application/vnd.yamaha.smaf-audio"],
  ["sass", "text/x-sass"],
  ["sbml", "application/sbml+xml"],
  ["sc", "application/vnd.ibm.secure-container"],
  ["scd", "application/x-msschedule"],
  ["scm", "application/vnd.lotus-screencam"],
  ["scq", "application/scvp-cv-request"],
  ["scs", "application/scvp-cv-response"],
  ["scss", "text/x-scss"],
  ["scurl", "text/vnd.curl.scurl"],
  ["sda", "application/vnd.stardivision.draw"],
  ["sdc", "application/vnd.stardivision.calc"],
  ["sdd", "application/vnd.stardivision.impress"],
  ["sdkd", "application/vnd.solent.sdkm+xml"],
  ["sdkm", "application/vnd.solent.sdkm+xml"],
  ["sdp", "application/sdp"],
  ["sdw", "application/vnd.stardivision.writer"],
  ["sea", "application/octet-stream"],
  ["see", "application/vnd.seemail"],
  ["seed", "application/vnd.fdsn.seed"],
  ["sema", "application/vnd.sema"],
  ["semd", "application/vnd.semd"],
  ["semf", "application/vnd.semf"],
  ["senmlx", "application/senml+xml"],
  ["sensmlx", "application/sensml+xml"],
  ["ser", "application/java-serialized-object"],
  ["setpay", "application/set-payment-initiation"],
  ["setreg", "application/set-registration-initiation"],
  ["sfd-hdstx", "application/vnd.hydrostatix.sof-data"],
  ["sfs", "application/vnd.spotfire.sfs"],
  ["sfv", "text/x-sfv"],
  ["sgi", "image/sgi"],
  ["sgl", "application/vnd.stardivision.writer-global"],
  ["sgm", "text/sgml"],
  ["sgml", "text/sgml"],
  ["sh", "application/x-sh"],
  ["shar", "application/x-shar"],
  ["shex", "text/shex"],
  ["shf", "application/shf+xml"],
  ["shtml", "text/html"],
  ["sid", "image/x-mrsid-image"],
  ["sieve", "application/sieve"],
  ["sig", "application/pgp-signature"],
  ["sil", "audio/silk"],
  ["silo", "model/mesh"],
  ["sis", "application/vnd.symbian.install"],
  ["sisx", "application/vnd.symbian.install"],
  ["sit", "application/x-stuffit"],
  ["sitx", "application/x-stuffitx"],
  ["siv", "application/sieve"],
  ["skd", "application/vnd.koan"],
  ["skm", "application/vnd.koan"],
  ["skp", "application/vnd.koan"],
  ["skt", "application/vnd.koan"],
  ["sldm", "application/vnd.ms-powerpoint.slide.macroenabled.12"],
  ["sldx", "application/vnd.openxmlformats-officedocument.presentationml.slide"],
  ["slim", "text/slim"],
  ["slm", "text/slim"],
  ["sls", "application/route-s-tsid+xml"],
  ["slt", "application/vnd.epson.salt"],
  ["sm", "application/vnd.stepmania.stepchart"],
  ["smf", "application/vnd.stardivision.math"],
  ["smi", "application/smil"],
  ["smil", "application/smil"],
  ["smv", "video/x-smv"],
  ["smzip", "application/vnd.stepmania.package"],
  ["snd", "audio/basic"],
  ["snf", "application/x-font-snf"],
  ["so", "application/octet-stream"],
  ["spc", "application/x-pkcs7-certificates"],
  ["spdx", "text/spdx"],
  ["spf", "application/vnd.yamaha.smaf-phrase"],
  ["spl", "application/x-futuresplash"],
  ["spot", "text/vnd.in3d.spot"],
  ["spp", "application/scvp-vp-response"],
  ["spq", "application/scvp-vp-request"],
  ["spx", "audio/ogg"],
  ["sql", "application/x-sql"],
  ["src", "application/x-wais-source"],
  ["srt", "application/x-subrip"],
  ["sru", "application/sru+xml"],
  ["srx", "application/sparql-results+xml"],
  ["ssdl", "application/ssdl+xml"],
  ["sse", "application/vnd.kodak-descriptor"],
  ["ssf", "application/vnd.epson.ssf"],
  ["ssml", "application/ssml+xml"],
  ["sst", "application/octet-stream"],
  ["st", "application/vnd.sailingtracker.track"],
  ["stc", "application/vnd.sun.xml.calc.template"],
  ["std", "application/vnd.sun.xml.draw.template"],
  ["stf", "application/vnd.wt.stf"],
  ["sti", "application/vnd.sun.xml.impress.template"],
  ["stk", "application/hyperstudio"],
  ["stl", "model/stl"],
  ["stpx", "model/step+xml"],
  ["stpxz", "model/step-xml+zip"],
  ["stpz", "model/step+zip"],
  ["str", "application/vnd.pg.format"],
  ["stw", "application/vnd.sun.xml.writer.template"],
  ["styl", "text/stylus"],
  ["stylus", "text/stylus"],
  ["sub", "text/vnd.dvb.subtitle"],
  ["sus", "application/vnd.sus-calendar"],
  ["susp", "application/vnd.sus-calendar"],
  ["sv4cpio", "application/x-sv4cpio"],
  ["sv4crc", "application/x-sv4crc"],
  ["svc", "application/vnd.dvb.service"],
  ["svd", "application/vnd.svd"],
  ["svg", "image/svg+xml"],
  ["svgz", "image/svg+xml"],
  ["swa", "application/x-director"],
  ["swf", "application/x-shockwave-flash"],
  ["swi", "application/vnd.aristanetworks.swi"],
  ["swidtag", "application/swid+xml"],
  ["sxc", "application/vnd.sun.xml.calc"],
  ["sxd", "application/vnd.sun.xml.draw"],
  ["sxg", "application/vnd.sun.xml.writer.global"],
  ["sxi", "application/vnd.sun.xml.impress"],
  ["sxm", "application/vnd.sun.xml.math"],
  ["sxw", "application/vnd.sun.xml.writer"],
  ["t", "text/troff"],
  ["t3", "application/x-t3vm-image"],
  ["t38", "image/t38"],
  ["taglet", "application/vnd.mynfc"],
  ["tao", "application/vnd.tao.intent-module-archive"],
  ["tap", "image/vnd.tencent.tap"],
  ["tar", "application/x-tar"],
  ["tcap", "application/vnd.3gpp2.tcap"],
  ["tcl", "application/x-tcl"],
  ["td", "application/urc-targetdesc+xml"],
  ["teacher", "application/vnd.smart.teacher"],
  ["tei", "application/tei+xml"],
  ["teicorpus", "application/tei+xml"],
  ["tex", "application/x-tex"],
  ["texi", "application/x-texinfo"],
  ["texinfo", "application/x-texinfo"],
  ["text", "text/plain"],
  ["tfi", "application/thraud+xml"],
  ["tfm", "application/x-tex-tfm"],
  ["tfx", "image/tiff-fx"],
  ["tga", "image/x-tga"],
  ["tgz", "application/x-tar"],
  ["thmx", "application/vnd.ms-officetheme"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["tk", "application/x-tcl"],
  ["tmo", "application/vnd.tmobile-livetv"],
  ["toml", "application/toml"],
  ["torrent", "application/x-bittorrent"],
  ["tpl", "application/vnd.groove-tool-template"],
  ["tpt", "application/vnd.trid.tpt"],
  ["tr", "text/troff"],
  ["tra", "application/vnd.trueapp"],
  ["trig", "application/trig"],
  ["trm", "application/x-msterminal"],
  ["ts", "video/mp2t"],
  ["tsd", "application/timestamped-data"],
  ["tsv", "text/tab-separated-values"],
  ["ttc", "font/collection"],
  ["ttf", "font/ttf"],
  ["ttl", "text/turtle"],
  ["ttml", "application/ttml+xml"],
  ["twd", "application/vnd.simtech-mindmapper"],
  ["twds", "application/vnd.simtech-mindmapper"],
  ["txd", "application/vnd.genomatix.tuxedo"],
  ["txf", "application/vnd.mobius.txf"],
  ["txt", "text/plain"],
  ["u8dsn", "message/global-delivery-status"],
  ["u8hdr", "message/global-headers"],
  ["u8mdn", "message/global-disposition-notification"],
  ["u8msg", "message/global"],
  ["u32", "application/x-authorware-bin"],
  ["ubj", "application/ubjson"],
  ["udeb", "application/x-debian-package"],
  ["ufd", "application/vnd.ufdl"],
  ["ufdl", "application/vnd.ufdl"],
  ["ulx", "application/x-glulx"],
  ["umj", "application/vnd.umajin"],
  ["unityweb", "application/vnd.unity"],
  ["uoml", "application/vnd.uoml+xml"],
  ["uri", "text/uri-list"],
  ["uris", "text/uri-list"],
  ["urls", "text/uri-list"],
  ["usdz", "model/vnd.usdz+zip"],
  ["ustar", "application/x-ustar"],
  ["utz", "application/vnd.uiq.theme"],
  ["uu", "text/x-uuencode"],
  ["uva", "audio/vnd.dece.audio"],
  ["uvd", "application/vnd.dece.data"],
  ["uvf", "application/vnd.dece.data"],
  ["uvg", "image/vnd.dece.graphic"],
  ["uvh", "video/vnd.dece.hd"],
  ["uvi", "image/vnd.dece.graphic"],
  ["uvm", "video/vnd.dece.mobile"],
  ["uvp", "video/vnd.dece.pd"],
  ["uvs", "video/vnd.dece.sd"],
  ["uvt", "application/vnd.dece.ttml+xml"],
  ["uvu", "video/vnd.uvvu.mp4"],
  ["uvv", "video/vnd.dece.video"],
  ["uvva", "audio/vnd.dece.audio"],
  ["uvvd", "application/vnd.dece.data"],
  ["uvvf", "application/vnd.dece.data"],
  ["uvvg", "image/vnd.dece.graphic"],
  ["uvvh", "video/vnd.dece.hd"],
  ["uvvi", "image/vnd.dece.graphic"],
  ["uvvm", "video/vnd.dece.mobile"],
  ["uvvp", "video/vnd.dece.pd"],
  ["uvvs", "video/vnd.dece.sd"],
  ["uvvt", "application/vnd.dece.ttml+xml"],
  ["uvvu", "video/vnd.uvvu.mp4"],
  ["uvvv", "video/vnd.dece.video"],
  ["uvvx", "application/vnd.dece.unspecified"],
  ["uvvz", "application/vnd.dece.zip"],
  ["uvx", "application/vnd.dece.unspecified"],
  ["uvz", "application/vnd.dece.zip"],
  ["vbox", "application/x-virtualbox-vbox"],
  ["vbox-extpack", "application/x-virtualbox-vbox-extpack"],
  ["vcard", "text/vcard"],
  ["vcd", "application/x-cdlink"],
  ["vcf", "text/x-vcard"],
  ["vcg", "application/vnd.groove-vcard"],
  ["vcs", "text/x-vcalendar"],
  ["vcx", "application/vnd.vcx"],
  ["vdi", "application/x-virtualbox-vdi"],
  ["vds", "model/vnd.sap.vds"],
  ["vhd", "application/x-virtualbox-vhd"],
  ["vis", "application/vnd.visionary"],
  ["viv", "video/vnd.vivo"],
  ["vlc", "application/videolan"],
  ["vmdk", "application/x-virtualbox-vmdk"],
  ["vob", "video/x-ms-vob"],
  ["vor", "application/vnd.stardivision.writer"],
  ["vox", "application/x-authorware-bin"],
  ["vrml", "model/vrml"],
  ["vsd", "application/vnd.visio"],
  ["vsf", "application/vnd.vsf"],
  ["vss", "application/vnd.visio"],
  ["vst", "application/vnd.visio"],
  ["vsw", "application/vnd.visio"],
  ["vtf", "image/vnd.valve.source.texture"],
  ["vtt", "text/vtt"],
  ["vtu", "model/vnd.vtu"],
  ["vxml", "application/voicexml+xml"],
  ["w3d", "application/x-director"],
  ["wad", "application/x-doom"],
  ["wadl", "application/vnd.sun.wadl+xml"],
  ["war", "application/java-archive"],
  ["wasm", "application/wasm"],
  ["wav", "audio/x-wav"],
  ["wax", "audio/x-ms-wax"],
  ["wbmp", "image/vnd.wap.wbmp"],
  ["wbs", "application/vnd.criticaltools.wbs+xml"],
  ["wbxml", "application/wbxml"],
  ["wcm", "application/vnd.ms-works"],
  ["wdb", "application/vnd.ms-works"],
  ["wdp", "image/vnd.ms-photo"],
  ["weba", "audio/webm"],
  ["webapp", "application/x-web-app-manifest+json"],
  ["webm", "video/webm"],
  ["webmanifest", "application/manifest+json"],
  ["webp", "image/webp"],
  ["wg", "application/vnd.pmi.widget"],
  ["wgt", "application/widget"],
  ["wks", "application/vnd.ms-works"],
  ["wm", "video/x-ms-wm"],
  ["wma", "audio/x-ms-wma"],
  ["wmd", "application/x-ms-wmd"],
  ["wmf", "image/wmf"],
  ["wml", "text/vnd.wap.wml"],
  ["wmlc", "application/wmlc"],
  ["wmls", "text/vnd.wap.wmlscript"],
  ["wmlsc", "application/vnd.wap.wmlscriptc"],
  ["wmv", "video/x-ms-wmv"],
  ["wmx", "video/x-ms-wmx"],
  ["wmz", "application/x-msmetafile"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["word", "application/msword"],
  ["wpd", "application/vnd.wordperfect"],
  ["wpl", "application/vnd.ms-wpl"],
  ["wps", "application/vnd.ms-works"],
  ["wqd", "application/vnd.wqd"],
  ["wri", "application/x-mswrite"],
  ["wrl", "model/vrml"],
  ["wsc", "message/vnd.wfa.wsc"],
  ["wsdl", "application/wsdl+xml"],
  ["wspolicy", "application/wspolicy+xml"],
  ["wtb", "application/vnd.webturbo"],
  ["wvx", "video/x-ms-wvx"],
  ["x3d", "model/x3d+xml"],
  ["x3db", "model/x3d+fastinfoset"],
  ["x3dbz", "model/x3d+binary"],
  ["x3dv", "model/x3d-vrml"],
  ["x3dvz", "model/x3d+vrml"],
  ["x3dz", "model/x3d+xml"],
  ["x32", "application/x-authorware-bin"],
  ["x_b", "model/vnd.parasolid.transmit.binary"],
  ["x_t", "model/vnd.parasolid.transmit.text"],
  ["xaml", "application/xaml+xml"],
  ["xap", "application/x-silverlight-app"],
  ["xar", "application/vnd.xara"],
  ["xav", "application/xcap-att+xml"],
  ["xbap", "application/x-ms-xbap"],
  ["xbd", "application/vnd.fujixerox.docuworks.binder"],
  ["xbm", "image/x-xbitmap"],
  ["xca", "application/xcap-caps+xml"],
  ["xcs", "application/calendar+xml"],
  ["xdf", "application/xcap-diff+xml"],
  ["xdm", "application/vnd.syncml.dm+xml"],
  ["xdp", "application/vnd.adobe.xdp+xml"],
  ["xdssc", "application/dssc+xml"],
  ["xdw", "application/vnd.fujixerox.docuworks"],
  ["xel", "application/xcap-el+xml"],
  ["xenc", "application/xenc+xml"],
  ["xer", "application/patch-ops-error+xml"],
  ["xfdf", "application/vnd.adobe.xfdf"],
  ["xfdl", "application/vnd.xfdl"],
  ["xht", "application/xhtml+xml"],
  ["xhtml", "application/xhtml+xml"],
  ["xhvml", "application/xv+xml"],
  ["xif", "image/vnd.xiff"],
  ["xl", "application/excel"],
  ["xla", "application/vnd.ms-excel"],
  ["xlam", "application/vnd.ms-excel.addin.macroEnabled.12"],
  ["xlc", "application/vnd.ms-excel"],
  ["xlf", "application/xliff+xml"],
  ["xlm", "application/vnd.ms-excel"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsb", "application/vnd.ms-excel.sheet.binary.macroEnabled.12"],
  ["xlsm", "application/vnd.ms-excel.sheet.macroEnabled.12"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xlt", "application/vnd.ms-excel"],
  ["xltm", "application/vnd.ms-excel.template.macroEnabled.12"],
  ["xltx", "application/vnd.openxmlformats-officedocument.spreadsheetml.template"],
  ["xlw", "application/vnd.ms-excel"],
  ["xm", "audio/xm"],
  ["xml", "application/xml"],
  ["xns", "application/xcap-ns+xml"],
  ["xo", "application/vnd.olpc-sugar"],
  ["xop", "application/xop+xml"],
  ["xpi", "application/x-xpinstall"],
  ["xpl", "application/xproc+xml"],
  ["xpm", "image/x-xpixmap"],
  ["xpr", "application/vnd.is-xpr"],
  ["xps", "application/vnd.ms-xpsdocument"],
  ["xpw", "application/vnd.intercon.formnet"],
  ["xpx", "application/vnd.intercon.formnet"],
  ["xsd", "application/xml"],
  ["xsl", "application/xml"],
  ["xslt", "application/xslt+xml"],
  ["xsm", "application/vnd.syncml+xml"],
  ["xspf", "application/xspf+xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["xvm", "application/xv+xml"],
  ["xvml", "application/xv+xml"],
  ["xwd", "image/x-xwindowdump"],
  ["xyz", "chemical/x-xyz"],
  ["xz", "application/x-xz"],
  ["yaml", "text/yaml"],
  ["yang", "application/yang"],
  ["yin", "application/yin+xml"],
  ["yml", "text/yaml"],
  ["ymp", "text/x-suse-ymp"],
  ["z", "application/x-compress"],
  ["z1", "application/x-zmachine"],
  ["z2", "application/x-zmachine"],
  ["z3", "application/x-zmachine"],
  ["z4", "application/x-zmachine"],
  ["z5", "application/x-zmachine"],
  ["z6", "application/x-zmachine"],
  ["z7", "application/x-zmachine"],
  ["z8", "application/x-zmachine"],
  ["zaz", "application/vnd.zzazz.deck+xml"],
  ["zip", "application/zip"],
  ["zir", "application/vnd.zul"],
  ["zirz", "application/vnd.zul"],
  ["zmm", "application/vnd.handheld-entertainment+xml"],
  ["zsh", "text/x-scriptzsh"]
]);
function as(e, t, n) {
  const r = N6(e), { webkitRelativePath: i } = e, a = typeof t == "string" ? t : typeof i == "string" && i.length > 0 ? i : `./${e.name}`;
  return typeof r.path != "string" && _0(r, "path", a), _0(r, "relativePath", a), r;
}
function N6(e) {
  const { name: t } = e;
  if (t && t.lastIndexOf(".") !== -1 && !e.type) {
    const r = t.split(".").pop().toLowerCase(), i = A6.get(r);
    i && Object.defineProperty(e, "type", {
      value: i,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return e;
}
function _0(e, t, n) {
  Object.defineProperty(e, t, {
    value: n,
    writable: !1,
    configurable: !1,
    enumerable: !0
  });
}
const F6 = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  // macOs
  "Thumbs.db"
  // Windows
];
function L6(e) {
  return ba(this, void 0, void 0, function* () {
    return Lu(e) && B6(e.dataTransfer) ? q6(e.dataTransfer, e.type) : V6(e) ? z6(e) : Array.isArray(e) && e.every((t) => "getFile" in t && typeof t.getFile == "function") ? W6(e) : [];
  });
}
function B6(e) {
  return Lu(e);
}
function V6(e) {
  return Lu(e) && Lu(e.target);
}
function Lu(e) {
  return typeof e == "object" && e !== null;
}
function z6(e) {
  return Gm(e.target.files).map((t) => as(t));
}
function W6(e) {
  return ba(this, void 0, void 0, function* () {
    return (yield Promise.all(e.map((n) => n.getFile()))).map((n) => as(n));
  });
}
function q6(e, t) {
  return ba(this, void 0, void 0, function* () {
    if (e.items) {
      const n = Gm(e.items).filter((i) => i.kind === "file");
      if (t !== "drop")
        return n;
      const r = yield Promise.all(n.map(H6));
      return I0(dO(r));
    }
    return I0(Gm(e.files).map((n) => as(n)));
  });
}
function I0(e) {
  return e.filter((t) => F6.indexOf(t.name) === -1);
}
function Gm(e) {
  if (e === null)
    return [];
  const t = [];
  for (let n = 0; n < e.length; n++) {
    const r = e[n];
    t.push(r);
  }
  return t;
}
function H6(e) {
  if (typeof e.webkitGetAsEntry != "function")
    return j0(e);
  const t = e.webkitGetAsEntry();
  return t && t.isDirectory ? pO(t) : j0(e, t);
}
function dO(e) {
  return e.reduce((t, n) => [
    ...t,
    ...Array.isArray(n) ? dO(n) : [n]
  ], []);
}
function j0(e, t) {
  return ba(this, void 0, void 0, function* () {
    var n;
    if (globalThis.isSecureContext && typeof e.getAsFileSystemHandle == "function") {
      const a = yield e.getAsFileSystemHandle();
      if (a === null)
        throw new Error(`${e} is not a File`);
      if (a !== void 0) {
        const l = yield a.getFile();
        return l.handle = a, as(l);
      }
    }
    const r = e.getAsFile();
    if (!r)
      throw new Error(`${e} is not a File`);
    return as(r, (n = t == null ? void 0 : t.fullPath) !== null && n !== void 0 ? n : void 0);
  });
}
function U6(e) {
  return ba(this, void 0, void 0, function* () {
    return e.isDirectory ? pO(e) : Y6(e);
  });
}
function pO(e) {
  const t = e.createReader();
  return new Promise((n, r) => {
    const i = [];
    function a() {
      t.readEntries((l) => ba(this, void 0, void 0, function* () {
        if (l.length) {
          const u = Promise.all(l.map(U6));
          i.push(u), a();
        } else
          try {
            const u = yield Promise.all(i);
            n(u);
          } catch (u) {
            r(u);
          }
      }), (l) => {
        r(l);
      });
    }
    a();
  });
}
function Y6(e) {
  return ba(this, void 0, void 0, function* () {
    return new Promise((t, n) => {
      e.file((r) => {
        const i = as(r, e.fullPath);
        t(i);
      }, (r) => {
        n(r);
      });
    });
  });
}
var eu = {}, $0;
function G6() {
  return $0 || ($0 = 1, eu.__esModule = !0, eu.default = function(e, t) {
    if (e && t) {
      var n = Array.isArray(t) ? t : t.split(",");
      if (n.length === 0)
        return !0;
      var r = e.name || "", i = (e.type || "").toLowerCase(), a = i.replace(/\/.*$/, "");
      return n.some(function(l) {
        var u = l.trim().toLowerCase();
        return u.charAt(0) === "." ? r.toLowerCase().endsWith(u) : u.endsWith("/*") ? a === u.replace(/\/.*$/, "") : i === u;
      });
    }
    return !0;
  }), eu;
}
var K6 = G6();
const wm = /* @__PURE__ */ Rl(K6);
function A0(e) {
  return Z6(e) || Q6(e) || mO(e) || X6();
}
function X6() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Q6(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Z6(e) {
  if (Array.isArray(e)) return Km(e);
}
function N0(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function F0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? N0(Object(n), !0).forEach(function(r) {
      fO(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : N0(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function fO(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Ol(e, t) {
  return t9(e) || e9(e, t) || mO(e, t) || J6();
}
function J6() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function mO(e, t) {
  if (e) {
    if (typeof e == "string") return Km(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Km(e, t);
  }
}
function Km(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function e9(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], i = !0, a = !1, l, u;
    try {
      for (n = n.call(e); !(i = (l = n.next()).done) && (r.push(l.value), !(t && r.length === t)); i = !0)
        ;
    } catch (d) {
      a = !0, u = d;
    } finally {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (a) throw u;
      }
    }
    return r;
  }
}
function t9(e) {
  if (Array.isArray(e)) return e;
}
var n9 = typeof wm == "function" ? wm : wm.default, r9 = "file-invalid-type", o9 = "file-too-large", i9 = "file-too-small", a9 = "too-many-files", s9 = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = t.split(","), r = n.length > 1 ? "one of ".concat(n.join(", ")) : n[0];
  return {
    code: r9,
    message: "File type must be ".concat(r)
  };
}, L0 = function(t) {
  return {
    code: o9,
    message: "File is larger than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, B0 = function(t) {
  return {
    code: i9,
    message: "File is smaller than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, l9 = {
  code: a9,
  message: "Too many files"
};
function hO(e, t) {
  var n = e.type === "application/x-moz-file" || n9(e, t);
  return [n, n ? null : s9(t)];
}
function gO(e, t, n) {
  if (sa(e.size))
    if (sa(t) && sa(n)) {
      if (e.size > n) return [!1, L0(n)];
      if (e.size < t) return [!1, B0(t)];
    } else {
      if (sa(t) && e.size < t) return [!1, B0(t)];
      if (sa(n) && e.size > n) return [!1, L0(n)];
    }
  return [!0, null];
}
function sa(e) {
  return e != null;
}
function c9(e) {
  var t = e.files, n = e.accept, r = e.minSize, i = e.maxSize, a = e.multiple, l = e.maxFiles, u = e.validator;
  return !a && t.length > 1 || a && l >= 1 && t.length > l ? !1 : t.every(function(d) {
    var p = hO(d, n), m = Ol(p, 1), h = m[0], g = gO(d, r, i), v = Ol(g, 1), b = v[0], y = u ? u(d) : null;
    return h && b && !y;
  });
}
function Bu(e) {
  return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : typeof e.cancelBubble < "u" ? e.cancelBubble : !1;
}
function tu(e) {
  return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(t) {
    return t === "Files" || t === "application/x-moz-file";
  }) : !!e.target && !!e.target.files;
}
function V0(e) {
  e.preventDefault();
}
function u9(e) {
  return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function d9(e) {
  return e.indexOf("Edge/") !== -1;
}
function p9() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return u9(e) || d9(e);
}
function wo() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    for (var i = arguments.length, a = new Array(i > 1 ? i - 1 : 0), l = 1; l < i; l++)
      a[l - 1] = arguments[l];
    return t.some(function(u) {
      return !Bu(r) && u && u.apply(void 0, [r].concat(a)), Bu(r);
    });
  };
}
function f9() {
  return "showOpenFilePicker" in window;
}
function m9(e) {
  if (sa(e)) {
    var t = Object.entries(e).filter(function(n) {
      var r = Ol(n, 2), i = r[0], a = r[1], l = !0;
      return yO(i) || (console.warn('Skipped "'.concat(i, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), l = !1), (!Array.isArray(a) || !a.every(bO)) && (console.warn('Skipped "'.concat(i, '" because an invalid file extension was provided.')), l = !1), l;
    }).reduce(function(n, r) {
      var i = Ol(r, 2), a = i[0], l = i[1];
      return F0(F0({}, n), {}, fO({}, a, l));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: t
    }];
  }
  return e;
}
function h9(e) {
  if (sa(e))
    return Object.entries(e).reduce(function(t, n) {
      var r = Ol(n, 2), i = r[0], a = r[1];
      return [].concat(A0(t), [i], A0(a));
    }, []).filter(function(t) {
      return yO(t) || bO(t);
    }).join(",");
}
function g9(e) {
  return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function y9(e) {
  return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function yO(e) {
  return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || e === "application/*" || /\w+\/[-+.\w]+/g.test(e);
}
function bO(e) {
  return /^.*\.[\w]+$/.test(e);
}
var b9 = ["children"], v9 = ["open"], x9 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], w9 = ["refKey", "onChange", "onClick"];
function C9(e) {
  return T9(e) || O9(e) || vO(e) || S9();
}
function S9() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function O9(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function T9(e) {
  if (Array.isArray(e)) return Xm(e);
}
function Cm(e, t) {
  return k9(e) || R9(e, t) || vO(e, t) || E9();
}
function E9() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function vO(e, t) {
  if (e) {
    if (typeof e == "string") return Xm(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Xm(e, t);
  }
}
function Xm(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function R9(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], i = !0, a = !1, l, u;
    try {
      for (n = n.call(e); !(i = (l = n.next()).done) && (r.push(l.value), !(t && r.length === t)); i = !0)
        ;
    } catch (d) {
      a = !0, u = d;
    } finally {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (a) throw u;
      }
    }
    return r;
  }
}
function k9(e) {
  if (Array.isArray(e)) return e;
}
function z0(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function bn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? z0(Object(n), !0).forEach(function(r) {
      Qm(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : z0(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Qm(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Vu(e, t) {
  if (e == null) return {};
  var n = P9(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function P9(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
var Pg = /* @__PURE__ */ El(function(e, t) {
  var n = e.children, r = Vu(e, b9), i = Dg(r), a = i.open, l = Vu(i, v9);
  return eh(t, function() {
    return {
      open: a
    };
  }, [a]), /* @__PURE__ */ Ae.createElement(AM, null, n(bn(bn({}, l), {}, {
    open: a
  })));
});
Pg.displayName = "Dropzone";
var xO = {
  disabled: !1,
  getFilesFromEvent: L6,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !1,
  autoFocus: !1
};
Pg.defaultProps = xO;
Pg.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: o.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: o.objectOf(o.arrayOf(o.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: o.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: o.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: o.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: o.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: o.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: o.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: o.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: o.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: o.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: o.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: o.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: o.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: o.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: o.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: o.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: o.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: o.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: o.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: o.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: o.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: o.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: o.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: o.func
};
var Zm = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  acceptedFiles: [],
  fileRejections: []
};
function Dg() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = bn(bn({}, xO), e), n = t.accept, r = t.disabled, i = t.getFilesFromEvent, a = t.maxSize, l = t.minSize, u = t.multiple, d = t.maxFiles, p = t.onDragEnter, m = t.onDragLeave, h = t.onDragOver, g = t.onDrop, v = t.onDropAccepted, b = t.onDropRejected, y = t.onFileDialogCancel, S = t.onFileDialogOpen, O = t.useFsAccessApi, P = t.autoFocus, k = t.preventDropOnDocument, R = t.noClick, E = t.noKeyboard, M = t.noDrag, _ = t.noDragEventsBubbling, I = t.onError, F = t.validator, T = rr(function() {
    return h9(n);
  }, [n]), $ = rr(function() {
    return m9(n);
  }, [n]), N = rr(function() {
    return typeof S == "function" ? S : W0;
  }, [S]), W = rr(function() {
    return typeof y == "function" ? y : W0;
  }, [y]), L = Ti(null), V = Ti(null), z = Jm(D9, Zm), X = Cm(z, 2), le = X[0], ne = X[1], G = le.isFocused, Q = le.isFileDialogActive, be = Ti(typeof window < "u" && window.isSecureContext && O && f9()), we = function() {
    !be.current && Q && setTimeout(function() {
      if (V.current) {
        var $e = V.current.files;
        $e.length || (ne({
          type: "closeDialog"
        }), W());
      }
    }, 300);
  };
  mn(function() {
    return window.addEventListener("focus", we, !1), function() {
      window.removeEventListener("focus", we, !1);
    };
  }, [V, Q, W, be]);
  var se = Ti([]), U = function($e) {
    L.current && L.current.contains($e.target) || ($e.preventDefault(), se.current = []);
  };
  mn(function() {
    return k && (document.addEventListener("dragover", V0, !1), document.addEventListener("drop", U, !1)), function() {
      k && (document.removeEventListener("dragover", V0), document.removeEventListener("drop", U));
    };
  }, [L, k]), mn(function() {
    return !r && P && L.current && L.current.focus(), function() {
    };
  }, [L, P, r]);
  var de = $t(function(Re) {
    I ? I(Re) : console.error(Re);
  }, [I]), ce = $t(function(Re) {
    Re.preventDefault(), Re.persist(), Be(Re), se.current = [].concat(C9(se.current), [Re.target]), tu(Re) && Promise.resolve(i(Re)).then(function($e) {
      if (!(Bu(Re) && !_)) {
        var dt = $e.length, He = dt > 0 && c9({
          files: $e,
          accept: T,
          minSize: l,
          maxSize: a,
          multiple: u,
          maxFiles: d,
          validator: F
        }), Je = dt > 0 && !He;
        ne({
          isDragAccept: He,
          isDragReject: Je,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), p && p(Re);
      }
    }).catch(function($e) {
      return de($e);
    });
  }, [i, p, de, _, T, l, a, u, d, F]), K = $t(function(Re) {
    Re.preventDefault(), Re.persist(), Be(Re);
    var $e = tu(Re);
    if ($e && Re.dataTransfer)
      try {
        Re.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return $e && h && h(Re), !1;
  }, [h, _]), Z = $t(function(Re) {
    Re.preventDefault(), Re.persist(), Be(Re);
    var $e = se.current.filter(function(He) {
      return L.current && L.current.contains(He);
    }), dt = $e.indexOf(Re.target);
    dt !== -1 && $e.splice(dt, 1), se.current = $e, !($e.length > 0) && (ne({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), tu(Re) && m && m(Re));
  }, [L, m, _]), ue = $t(function(Re, $e) {
    var dt = [], He = [];
    Re.forEach(function(Je) {
      var Ze = hO(Je, T), nt = Cm(Ze, 2), Ne = nt[0], Ct = nt[1], Rt = gO(Je, l, a), At = Cm(Rt, 2), Xt = At[0], je = At[1], ot = F ? F(Je) : null;
      if (Ne && Xt && !ot)
        dt.push(Je);
      else {
        var vt = [Ct, je];
        ot && (vt = vt.concat(ot)), He.push({
          file: Je,
          errors: vt.filter(function(gt) {
            return gt;
          })
        });
      }
    }), (!u && dt.length > 1 || u && d >= 1 && dt.length > d) && (dt.forEach(function(Je) {
      He.push({
        file: Je,
        errors: [l9]
      });
    }), dt.splice(0)), ne({
      acceptedFiles: dt,
      fileRejections: He,
      isDragReject: He.length > 0,
      type: "setFiles"
    }), g && g(dt, He, $e), He.length > 0 && b && b(He, $e), dt.length > 0 && v && v(dt, $e);
  }, [ne, u, T, l, a, d, g, v, b, F]), he = $t(function(Re) {
    Re.preventDefault(), Re.persist(), Be(Re), se.current = [], tu(Re) && Promise.resolve(i(Re)).then(function($e) {
      Bu(Re) && !_ || ue($e, Re);
    }).catch(function($e) {
      return de($e);
    }), ne({
      type: "reset"
    });
  }, [i, ue, de, _]), B = $t(function() {
    if (be.current) {
      ne({
        type: "openDialog"
      }), N();
      var Re = {
        multiple: u,
        types: $
      };
      window.showOpenFilePicker(Re).then(function($e) {
        return i($e);
      }).then(function($e) {
        ue($e, null), ne({
          type: "closeDialog"
        });
      }).catch(function($e) {
        g9($e) ? (W($e), ne({
          type: "closeDialog"
        })) : y9($e) ? (be.current = !1, V.current ? (V.current.value = null, V.current.click()) : de(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : de($e);
      });
      return;
    }
    V.current && (ne({
      type: "openDialog"
    }), N(), V.current.value = null, V.current.click());
  }, [ne, N, W, O, ue, de, $, u]), ee = $t(function(Re) {
    !L.current || !L.current.isEqualNode(Re.target) || (Re.key === " " || Re.key === "Enter" || Re.keyCode === 32 || Re.keyCode === 13) && (Re.preventDefault(), B());
  }, [L, B]), ie = $t(function() {
    ne({
      type: "focus"
    });
  }, []), ge = $t(function() {
    ne({
      type: "blur"
    });
  }, []), xe = $t(function() {
    R || (p9() ? setTimeout(B, 0) : B());
  }, [R, B]), pe = function($e) {
    return r ? null : $e;
  }, Ee = function($e) {
    return E ? null : pe($e);
  }, Pe = function($e) {
    return M ? null : pe($e);
  }, Be = function($e) {
    _ && $e.stopPropagation();
  }, Ge = rr(function() {
    return function() {
      var Re = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, $e = Re.refKey, dt = $e === void 0 ? "ref" : $e, He = Re.role, Je = Re.onKeyDown, Ze = Re.onFocus, nt = Re.onBlur, Ne = Re.onClick, Ct = Re.onDragEnter, Rt = Re.onDragOver, At = Re.onDragLeave, Xt = Re.onDrop, je = Vu(Re, x9);
      return bn(bn(Qm({
        onKeyDown: Ee(wo(Je, ee)),
        onFocus: Ee(wo(Ze, ie)),
        onBlur: Ee(wo(nt, ge)),
        onClick: pe(wo(Ne, xe)),
        onDragEnter: Pe(wo(Ct, ce)),
        onDragOver: Pe(wo(Rt, K)),
        onDragLeave: Pe(wo(At, Z)),
        onDrop: Pe(wo(Xt, he)),
        role: typeof He == "string" && He !== "" ? He : "presentation"
      }, dt, L), !r && !E ? {
        tabIndex: 0
      } : {}), je);
    };
  }, [L, ee, ie, ge, xe, ce, K, Z, he, E, M, r]), Ie = $t(function(Re) {
    Re.stopPropagation();
  }, []), Dt = rr(function() {
    return function() {
      var Re = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, $e = Re.refKey, dt = $e === void 0 ? "ref" : $e, He = Re.onChange, Je = Re.onClick, Ze = Vu(Re, w9), nt = Qm({
        accept: T,
        multiple: u,
        type: "file",
        style: {
          border: 0,
          clip: "rect(0, 0, 0, 0)",
          clipPath: "inset(50%)",
          height: "1px",
          margin: "0 -1px -1px 0",
          overflow: "hidden",
          padding: 0,
          position: "absolute",
          width: "1px",
          whiteSpace: "nowrap"
        },
        onChange: pe(wo(He, he)),
        onClick: pe(wo(Je, Ie)),
        tabIndex: -1
      }, dt, V);
      return bn(bn({}, nt), Ze);
    };
  }, [V, n, u, he, r]);
  return bn(bn({}, le), {}, {
    isFocused: G && !r,
    getRootProps: Ge,
    getInputProps: Dt,
    rootRef: L,
    inputRef: V,
    open: pe(B)
  });
}
function D9(e, t) {
  switch (t.type) {
    case "focus":
      return bn(bn({}, e), {}, {
        isFocused: !0
      });
    case "blur":
      return bn(bn({}, e), {}, {
        isFocused: !1
      });
    case "openDialog":
      return bn(bn({}, Zm), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return bn(bn({}, e), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return bn(bn({}, e), {}, {
        isDragActive: t.isDragActive,
        isDragAccept: t.isDragAccept,
        isDragReject: t.isDragReject
      });
    case "setFiles":
      return bn(bn({}, e), {}, {
        acceptedFiles: t.acceptedFiles,
        fileRejections: t.fileRejections,
        isDragReject: t.isDragReject
      });
    case "reset":
      return bn({}, Zm);
    default:
      return e;
  }
}
function W0() {
}
let q0 = !1;
const M9 = () => {
  q0 || (console.warn(["MUI: The LoadingButton component functionality is now part of the Button component from Material UI.", "", "You should use `import Button from '@mui/material/Button'`", "or `import { Button } from '@mui/material'`"].join(`
`)), q0 = !0);
}, _9 = /* @__PURE__ */ w.forwardRef(function(t, n) {
  return M9(), /* @__PURE__ */ x.jsx(En, {
    ref: n,
    ...t
  });
}), wO = rn(/* @__PURE__ */ x.jsx("path", {
  d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zm4 18H6V4h7v5h5zM8 15.01l1.41 1.41L11 14.84V19h2v-4.16l1.59 1.59L16 15.01 12.01 11z"
}), "UploadFile"), I9 = rn(/* @__PURE__ */ x.jsx("path", {
  d: "M5 20h14v-2H5zM19 9h-4V3H9v6H5l7 7z"
}), "Download"), j9 = rn(/* @__PURE__ */ x.jsx("path", {
  d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3z"
}), "OpenInNew"), $9 = rn(/* @__PURE__ */ x.jsx("path", {
  d: "M19 5v14H5V5zm0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-4.86 8.86-3 3.87L9 13.14 6 17h12z"
}), "PhotoOutlined"), CO = rn(/* @__PURE__ */ x.jsx("path", {
  d: "M16 9v10H8V9zm-1.5-6h-5l-1 1H5v2h14V4h-3.5zM18 7H6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2z"
}), "DeleteOutlined"), SO = rn(/* @__PURE__ */ x.jsx("path", {
  d: "M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4m0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7"
}), "VisibilityOutlined"), OO = rn(/* @__PURE__ */ x.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2M9.29 16.29 5.7 12.7a.996.996 0 0 1 0-1.41c.39-.39 1.02-.39 1.41 0L10 14.17l6.88-6.88c.39-.39 1.02-.39 1.41 0s.39 1.02 0 1.41l-7.59 7.59c-.38.39-1.02.39-1.41 0"
}), "CheckCircleRounded"), A9 = rn(/* @__PURE__ */ x.jsx("path", {
  d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zM6 20V4h7v5h5v11z"
}), "InsertDriveFileOutlined");
function TO(e, t = 0) {
  if (!+e) return "0 Bytes";
  const n = 1e3, r = t < 0 ? 0 : t, i = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], a = Math.floor(Math.log(e) / Math.log(n));
  return `${parseFloat((e / Math.pow(n, a)).toFixed(r))} ${i[a]}`;
}
const N9 = 512e3, F9 = {
  "application/msword": [".doc"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
  "application/pdf": [".pdf"]
}, L9 = ({
  id: e,
  label: t,
  disabled: n,
  value: r = [],
  onChange: i,
  error: a,
  name: l,
  readOnly: u,
  allowMultiple: d = !1,
  acceptedMimeTypes: p = F9
}) => {
  const m = ir(), [h, g] = Kt(!1), [v, b] = Kt(!1), [y, S] = Kt(null), O = rr(() => {
    if (!p) return "";
    const L = Object.values(p).flat().map((z) => z.replace(".", "").toUpperCase()).sort();
    if (!L.length) return "";
    const V = L[L.length - 1];
    return L.length > 1 ? L.slice(0, -1).join(", ") + " or " + V : L[0];
  }, [p]);
  mn(() => () => {
    (r || []).forEach((L) => URL.revokeObjectURL(L == null ? void 0 : L.preview));
  }, [r]);
  const P = $t((L) => {
    g(!0), S(L.id);
  }, []), k = $t(() => {
    g(!1), S(null);
  }, []), R = $t(() => {
    const L = r == null ? void 0 : r.find((z) => z.id === y);
    L && URL.revokeObjectURL(L == null ? void 0 : L.preview);
    const V = (r || []).filter((z) => z.id !== y);
    i(V), g(!1), S(null);
  }, [r, y, i]), E = $t(
    (L) => {
      if (!L.length) return;
      b(!0);
      const z = [...d ? [...r || []] : []];
      L.forEach((X) => {
        const le = {
          id: e,
          filename: X.name,
          name: l,
          size: X.size,
          mime: X.type,
          preview: URL.createObjectURL(X)
        };
        z.push(le);
      }), setTimeout(() => {
        b(!1), i(z);
      }, 500);
    },
    [d, r, e, l, i]
  ), { getRootProps: M, getInputProps: _, isDragActive: I, isDragAccept: F, isDragReject: T } = Dg({
    multiple: d,
    accept: p,
    disabled: n || u,
    maxSize: N9,
    onDrop: E
  }), $ = T ? m.palette.error.main : m.palette.primary.dark, N = T || a ? m.palette.error.main : F ? m.palette.primary.main : dd[400], W = F ? m.palette.success.light : T ? m.palette.error.light : "transparent";
  return /* @__PURE__ */ x.jsxs(sr, { fullWidth: !0, children: [
    !!t && /* @__PURE__ */ x.jsx(
      jr,
      {
        sx: {
          mb: 2,
          fontWeight: 600,
          color: m.palette.text.primary,
          fontSize: m.typography.subtitle1.fontSize
        },
        id: `${l}-label`,
        children: t
      }
    ),
    /* @__PURE__ */ x.jsxs(Xn, { container: !0, rowSpacing: 1, columnSpacing: 3, children: [
      /* @__PURE__ */ x.jsxs(Xn, { size: { xs: 12, lg: 6 }, children: [
        /* @__PURE__ */ x.jsxs(
          sn,
          {
            ...M(),
            minHeight: "152px",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: W,
            sx: { cursor: "pointer" },
            borderRadius: m.spacing(1),
            border: `1px dashed ${N}`,
            children: [
              /* @__PURE__ */ x.jsx("input", { ..._() }),
              /* @__PURE__ */ x.jsx(sn, { alignItems: "center", justifyContent: "center", spacing: 1, children: v ? /* @__PURE__ */ x.jsx(Mi, {}) : /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
                /* @__PURE__ */ x.jsx(Mr, { pt: 1, pb: 0.5, children: /* @__PURE__ */ x.jsx(wO, { sx: { color: $ } }) }),
                !I && /* @__PURE__ */ x.jsxs(Mr, { children: [
                  /* @__PURE__ */ x.jsx(at, { display: "inline", color: "primary", sx: { textDecorationLine: "underline" }, children: "Click to upload" }),
                  /* @__PURE__ */ x.jsx(at, { display: "inline", children: " or drag and drop" })
                ] }),
                F && /* @__PURE__ */ x.jsx(at, { color: m.palette.primary.dark, fontWeight: "bold", children: "Drop file(s) here to upload" }),
                T && /* @__PURE__ */ x.jsx(at, { color: "error", children: "File type, size or count is not allowed" }),
                /* @__PURE__ */ x.jsxs(Mr, { pt: 0.5, children: [
                  O && /* @__PURE__ */ x.jsxs(at, { display: "inline", variant: "subtitle2", color: "secondary", children: [
                    O,
                    " "
                  ] }),
                  /* @__PURE__ */ x.jsx(at, { display: "inline", variant: "subtitle2", color: "secondary", children: "(max. 500kb)" })
                ] })
              ] }) })
            ]
          }
        ),
        a && /* @__PURE__ */ x.jsx(at, { variant: "caption", color: "error", children: a.message })
      ] }),
      /* @__PURE__ */ x.jsx(Xn, { size: { xs: 12, lg: 6 }, children: (r || []).map(
        (L) => L.id ? /* @__PURE__ */ x.jsx(
          B9,
          {
            size: L.size,
            type: L.mime,
            name: L.filename,
            canRemove: !n,
            preview: L.preview,
            onRemove: () => P(L)
          },
          L.id
        ) : null
      ) })
    ] }),
    /* @__PURE__ */ x.jsxs(fs, { open: h, onClose: k, children: [
      /* @__PURE__ */ x.jsx(rs, { variant: "h4", component: "h2", children: "Are you sure you want to remove this file?" }),
      /* @__PURE__ */ x.jsxs(Ri, { children: [
        /* @__PURE__ */ x.jsx(_9, { variant: "contained", color: "error", onClick: R, children: "Remove" }),
        /* @__PURE__ */ x.jsx(En, { variant: "outlined", color: "warning", onClick: k, children: "Keep" })
      ] })
    ] })
  ] });
}, B9 = ({ canRemove: e, directLink: t = !1, name: n, onRemove: r, preview: i, size: a, type: l }) => {
  const u = ir(), [d, p] = Kt(!1), m = ["image/jpg", "image/jpeg", "image/png", "image/bmp", "image/webp"].includes(l), h = l === "application/pdf", g = $t(
    (O) => {
      O.stopPropagation(), O.preventDefault(), r();
    },
    [r]
  ), v = $t(() => p(!0), []), b = $t(() => p(!1), []), y = $t(() => window.open(i, "_blank"), [i]), S = $t(() => {
    if (t) return;
    const O = document.createElement("a");
    O.href = i, O.download = n, document.body.appendChild(O), O.click(), document.body.removeChild(O);
  }, [t, n, i]);
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsxs(
      sn,
      {
        direction: "row",
        sx: { mb: 1, p: 2 },
        alignItems: "flex-start",
        justifyContent: "space-between",
        borderRadius: u.spacing(1),
        border: `1px solid ${u.palette.primary.main}`,
        children: [
          /* @__PURE__ */ x.jsxs(sn, { width: "100%", direction: "row", spacing: 2, pb: 1, children: [
            /* @__PURE__ */ x.jsx(ZC, { color: "primary", IconComponent: m ? $9 : A9 }),
            /* @__PURE__ */ x.jsxs(sn, { m: 1, maxWidth: "50%", children: [
              /* @__PURE__ */ x.jsx(
                at,
                {
                  sx: {
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis"
                  },
                  children: n
                }
              ),
              /* @__PURE__ */ x.jsxs(at, { variant: "subtitle2", color: "secondary", fontSize: "small", children: [
                "Uploaded - ",
                TO(a, 2)
              ] })
            ] })
          ] }),
          /* @__PURE__ */ x.jsx(OO, { color: "success" })
        ]
      }
    ),
    /* @__PURE__ */ x.jsxs(sn, { direction: "row", spacing: 1, children: [
      m && /* @__PURE__ */ x.jsx(Zo, { title: "Preview image", children: /* @__PURE__ */ x.jsx(En, { color: "secondary", variant: "outlined", sx: { minWidth: "auto" }, "aria-label": `View ${n}`, onClick: v, children: /* @__PURE__ */ x.jsx(SO, {}) }) }),
      h && /* @__PURE__ */ x.jsx(Zo, { title: "Preview in new tab", children: /* @__PURE__ */ x.jsx(En, { color: "primary", variant: "outlined", sx: { minWidth: "auto" }, "aria-label": `Open ${n} in new tab`, onClick: y, children: /* @__PURE__ */ x.jsx(j9, {}) }) }),
      /* @__PURE__ */ x.jsx(Zo, { title: "Download file", children: /* @__PURE__ */ x.jsx(
        En,
        {
          color: "primary",
          variant: "outlined",
          rel: "noopener noreferrer",
          sx: { minWidth: "auto" },
          "aria-label": `Download ${n}`,
          href: t ? i : "",
          target: t ? "_blank" : void 0,
          onClick: () => {
            t || S();
          },
          children: /* @__PURE__ */ x.jsx(I9, {})
        }
      ) }),
      e && /* @__PURE__ */ x.jsx(Zo, { title: "Remove file", children: /* @__PURE__ */ x.jsx(En, { variant: "outlined", "aria-label": "Remove file", onClick: g, color: "error", sx: { minWidth: "auto" }, children: /* @__PURE__ */ x.jsx(CO, {}) }) })
    ] }),
    /* @__PURE__ */ x.jsxs(fs, { open: d, onClose: b, maxWidth: "md", fullWidth: !0, children: [
      /* @__PURE__ */ x.jsx(rs, { children: n }),
      m && /* @__PURE__ */ x.jsx(Mr, { component: "img", src: i, alt: n, sx: { width: "100%", maxHeight: "80vh", objectFit: "contain" } }),
      /* @__PURE__ */ x.jsx(Ri, { children: /* @__PURE__ */ x.jsx(Ai, { onClick: b, color: "primary", children: "Close" }) })
    ] })
  ] });
}, zu = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  unit: "px"
}, La = (e, t, n) => Math.min(Math.max(e, t), n), V9 = (...e) => e.filter((t) => t && typeof t == "string").join(" "), H0 = (e, t) => e === t || e.width === t.width && e.height === t.height && e.x === t.x && e.y === t.y && e.unit === t.unit;
function z9(e, t, n, r) {
  const i = Co(e, n, r);
  return e.width && (i.height = i.width / t), e.height && (i.width = i.height * t), i.y + i.height > r && (i.height = r - i.y, i.width = i.height * t), i.x + i.width > n && (i.width = n - i.x, i.height = i.width / t), e.unit === "%" ? Si(i, n, r) : i;
}
function W9(e, t, n) {
  const r = Co(e, t, n);
  return r.x = (t - r.width) / 2, r.y = (n - r.height) / 2, e.unit === "%" ? Si(r, t, n) : r;
}
function Si(e, t, n) {
  return e.unit === "%" ? { ...zu, ...e, unit: "%" } : {
    unit: "%",
    x: e.x ? e.x / t * 100 : 0,
    y: e.y ? e.y / n * 100 : 0,
    width: e.width ? e.width / t * 100 : 0,
    height: e.height ? e.height / n * 100 : 0
  };
}
function Co(e, t, n) {
  return e.unit ? e.unit === "px" ? { ...zu, ...e, unit: "px" } : {
    unit: "px",
    x: e.x ? e.x * t / 100 : 0,
    y: e.y ? e.y * n / 100 : 0,
    width: e.width ? e.width * t / 100 : 0,
    height: e.height ? e.height * n / 100 : 0
  } : { ...zu, ...e, unit: "px" };
}
function U0(e, t, n, r, i, a = 0, l = 0, u = r, d = i) {
  const p = { ...e };
  let m = Math.min(a, r), h = Math.min(l, i), g = Math.min(u, r), v = Math.min(d, i);
  t && (t > 1 ? (m = l ? l * t : m, h = m / t, g = u * t) : (h = a ? a / t : h, m = h * t, v = d / t)), p.y < 0 && (p.height = Math.max(p.height + p.y, h), p.y = 0), p.x < 0 && (p.width = Math.max(p.width + p.x, m), p.x = 0);
  const b = r - (p.x + p.width);
  b < 0 && (p.x = Math.min(p.x, r - m), p.width += b);
  const y = i - (p.y + p.height);
  if (y < 0 && (p.y = Math.min(p.y, i - h), p.height += y), p.width < m && ((n === "sw" || n == "nw") && (p.x -= m - p.width), p.width = m), p.height < h && ((n === "nw" || n == "ne") && (p.y -= h - p.height), p.height = h), p.width > g && ((n === "sw" || n == "nw") && (p.x -= g - p.width), p.width = g), p.height > v && ((n === "nw" || n == "ne") && (p.y -= v - p.height), p.height = v), t) {
    const S = p.width / p.height;
    if (S < t) {
      const O = Math.max(p.width / t, h);
      (n === "nw" || n == "ne") && (p.y -= O - p.height), p.height = O;
    } else if (S > t) {
      const O = Math.max(p.height * t, m);
      (n === "sw" || n == "nw") && (p.x -= O - p.width), p.width = O;
    }
  }
  return p;
}
function q9(e, t, n, r) {
  const i = { ...e };
  return t === "ArrowLeft" ? r === "nw" ? (i.x -= n, i.y -= n, i.width += n, i.height += n) : r === "w" ? (i.x -= n, i.width += n) : r === "sw" ? (i.x -= n, i.width += n, i.height += n) : r === "ne" ? (i.y += n, i.width -= n, i.height -= n) : r === "e" ? i.width -= n : r === "se" && (i.width -= n, i.height -= n) : t === "ArrowRight" && (r === "nw" ? (i.x += n, i.y += n, i.width -= n, i.height -= n) : r === "w" ? (i.x += n, i.width -= n) : r === "sw" ? (i.x += n, i.width -= n, i.height -= n) : r === "ne" ? (i.y -= n, i.width += n, i.height += n) : r === "e" ? i.width += n : r === "se" && (i.width += n, i.height += n)), t === "ArrowUp" ? r === "nw" ? (i.x -= n, i.y -= n, i.width += n, i.height += n) : r === "n" ? (i.y -= n, i.height += n) : r === "ne" ? (i.y -= n, i.width += n, i.height += n) : r === "sw" ? (i.x += n, i.width -= n, i.height -= n) : r === "s" ? i.height -= n : r === "se" && (i.width -= n, i.height -= n) : t === "ArrowDown" && (r === "nw" ? (i.x += n, i.y += n, i.width -= n, i.height -= n) : r === "n" ? (i.y += n, i.height -= n) : r === "ne" ? (i.y += n, i.width -= n, i.height -= n) : r === "sw" ? (i.x -= n, i.width += n, i.height += n) : r === "s" ? i.height += n : r === "se" && (i.width += n, i.height += n)), i;
}
const Ba = { capture: !0, passive: !1 };
let H9 = 0;
const Ci = class uo extends NM {
  constructor() {
    super(...arguments), this.docMoveBound = !1, this.mouseDownOnCrop = !1, this.dragStarted = !1, this.evData = {
      startClientX: 0,
      startClientY: 0,
      startCropX: 0,
      startCropY: 0,
      clientX: 0,
      clientY: 0,
      isResize: !0
    }, this.componentRef = tv(), this.mediaRef = tv(), this.initChangeCalled = !1, this.instanceId = `rc-${H9++}`, this.state = {
      cropIsActive: !1,
      newCropIsBeingDrawn: !1
    }, this.onCropPointerDown = (t) => {
      const { crop: n, disabled: r } = this.props, i = this.getBox();
      if (!n)
        return;
      const a = Co(n, i.width, i.height);
      if (r)
        return;
      t.cancelable && t.preventDefault(), this.bindDocMove(), this.componentRef.current.focus({ preventScroll: !0 });
      const l = t.target.dataset.ord, u = !!l;
      let d = t.clientX, p = t.clientY, m = a.x, h = a.y;
      if (l) {
        const g = t.clientX - i.x, v = t.clientY - i.y;
        let b = 0, y = 0;
        l === "ne" || l == "e" ? (b = g - (a.x + a.width), y = v - a.y, m = a.x, h = a.y + a.height) : l === "se" || l === "s" ? (b = g - (a.x + a.width), y = v - (a.y + a.height), m = a.x, h = a.y) : l === "sw" || l == "w" ? (b = g - a.x, y = v - (a.y + a.height), m = a.x + a.width, h = a.y) : (l === "nw" || l == "n") && (b = g - a.x, y = v - a.y, m = a.x + a.width, h = a.y + a.height), d = m + i.x + b, p = h + i.y + y;
      }
      this.evData = {
        startClientX: d,
        startClientY: p,
        startCropX: m,
        startCropY: h,
        clientX: t.clientX,
        clientY: t.clientY,
        isResize: u,
        ord: l
      }, this.mouseDownOnCrop = !0, this.setState({ cropIsActive: !0 });
    }, this.onComponentPointerDown = (t) => {
      const { crop: n, disabled: r, locked: i, keepSelection: a, onChange: l } = this.props, u = this.getBox();
      if (r || i || a && n)
        return;
      t.cancelable && t.preventDefault(), this.bindDocMove(), this.componentRef.current.focus({ preventScroll: !0 });
      const d = t.clientX - u.x, p = t.clientY - u.y, m = {
        unit: "px",
        x: d,
        y: p,
        width: 0,
        height: 0
      };
      this.evData = {
        startClientX: t.clientX,
        startClientY: t.clientY,
        startCropX: d,
        startCropY: p,
        clientX: t.clientX,
        clientY: t.clientY,
        isResize: !0
      }, this.mouseDownOnCrop = !0, l(Co(m, u.width, u.height), Si(m, u.width, u.height)), this.setState({ cropIsActive: !0, newCropIsBeingDrawn: !0 });
    }, this.onDocPointerMove = (t) => {
      const { crop: n, disabled: r, onChange: i, onDragStart: a } = this.props, l = this.getBox();
      if (r || !n || !this.mouseDownOnCrop)
        return;
      t.cancelable && t.preventDefault(), this.dragStarted || (this.dragStarted = !0, a && a(t));
      const { evData: u } = this;
      u.clientX = t.clientX, u.clientY = t.clientY;
      let d;
      u.isResize ? d = this.resizeCrop() : d = this.dragCrop(), H0(n, d) || i(
        Co(d, l.width, l.height),
        Si(d, l.width, l.height)
      );
    }, this.onComponentKeyDown = (t) => {
      const { crop: n, disabled: r, onChange: i, onComplete: a } = this.props;
      if (r)
        return;
      const l = t.key;
      let u = !1;
      if (!n)
        return;
      const d = this.getBox(), p = this.makePixelCrop(d), m = (navigator.platform.match("Mac") ? t.metaKey : t.ctrlKey) ? uo.nudgeStepLarge : t.shiftKey ? uo.nudgeStepMedium : uo.nudgeStep;
      if (l === "ArrowLeft" ? (p.x -= m, u = !0) : l === "ArrowRight" ? (p.x += m, u = !0) : l === "ArrowUp" ? (p.y -= m, u = !0) : l === "ArrowDown" && (p.y += m, u = !0), u) {
        t.cancelable && t.preventDefault(), p.x = La(p.x, 0, d.width - p.width), p.y = La(p.y, 0, d.height - p.height);
        const h = Co(p, d.width, d.height), g = Si(p, d.width, d.height);
        i(h, g), a && a(h, g);
      }
    }, this.onHandlerKeyDown = (t, n) => {
      const {
        aspect: r = 0,
        crop: i,
        disabled: a,
        minWidth: l = 0,
        minHeight: u = 0,
        maxWidth: d,
        maxHeight: p,
        onChange: m,
        onComplete: h
      } = this.props, g = this.getBox();
      if (a || !i)
        return;
      if (t.key === "ArrowUp" || t.key === "ArrowDown" || t.key === "ArrowLeft" || t.key === "ArrowRight")
        t.stopPropagation(), t.preventDefault();
      else
        return;
      const v = (navigator.platform.match("Mac") ? t.metaKey : t.ctrlKey) ? uo.nudgeStepLarge : t.shiftKey ? uo.nudgeStepMedium : uo.nudgeStep, b = Co(i, g.width, g.height), y = q9(b, t.key, v, n), S = U0(
        y,
        r,
        n,
        g.width,
        g.height,
        l,
        u,
        d,
        p
      );
      if (!H0(i, S)) {
        const O = Si(S, g.width, g.height);
        m(S, O), h && h(S, O);
      }
    }, this.onDocPointerDone = (t) => {
      const { crop: n, disabled: r, onComplete: i, onDragEnd: a } = this.props, l = this.getBox();
      this.unbindDocMove(), !(r || !n) && this.mouseDownOnCrop && (this.mouseDownOnCrop = !1, this.dragStarted = !1, a && a(t), i && i(Co(n, l.width, l.height), Si(n, l.width, l.height)), this.setState({ cropIsActive: !1, newCropIsBeingDrawn: !1 }));
    }, this.onDragFocus = () => {
      var t;
      (t = this.componentRef.current) == null || t.scrollTo(0, 0);
    };
  }
  get document() {
    return document;
  }
  // We unfortunately get the bounding box every time as x+y changes
  // due to scrolling.
  getBox() {
    const t = this.mediaRef.current;
    if (!t)
      return { x: 0, y: 0, width: 0, height: 0 };
    const { x: n, y: r, width: i, height: a } = t.getBoundingClientRect();
    return { x: n, y: r, width: i, height: a };
  }
  componentDidUpdate(t) {
    const { crop: n, onComplete: r } = this.props;
    if (r && !t.crop && n) {
      const { width: i, height: a } = this.getBox();
      i && a && r(Co(n, i, a), Si(n, i, a));
    }
  }
  componentWillUnmount() {
    this.resizeObserver && this.resizeObserver.disconnect(), this.unbindDocMove();
  }
  bindDocMove() {
    this.docMoveBound || (this.document.addEventListener("pointermove", this.onDocPointerMove, Ba), this.document.addEventListener("pointerup", this.onDocPointerDone, Ba), this.document.addEventListener("pointercancel", this.onDocPointerDone, Ba), this.docMoveBound = !0);
  }
  unbindDocMove() {
    this.docMoveBound && (this.document.removeEventListener("pointermove", this.onDocPointerMove, Ba), this.document.removeEventListener("pointerup", this.onDocPointerDone, Ba), this.document.removeEventListener("pointercancel", this.onDocPointerDone, Ba), this.docMoveBound = !1);
  }
  getCropStyle() {
    const { crop: t } = this.props;
    if (t)
      return {
        top: `${t.y}${t.unit}`,
        left: `${t.x}${t.unit}`,
        width: `${t.width}${t.unit}`,
        height: `${t.height}${t.unit}`
      };
  }
  dragCrop() {
    const { evData: t } = this, n = this.getBox(), r = this.makePixelCrop(n), i = t.clientX - t.startClientX, a = t.clientY - t.startClientY;
    return r.x = La(t.startCropX + i, 0, n.width - r.width), r.y = La(t.startCropY + a, 0, n.height - r.height), r;
  }
  getPointRegion(t, n, r, i) {
    const { evData: a } = this, l = a.clientX - t.x, u = a.clientY - t.y;
    let d;
    i && n ? d = n === "nw" || n === "n" || n === "ne" : d = u < a.startCropY;
    let p;
    return r && n ? p = n === "nw" || n === "w" || n === "sw" : p = l < a.startCropX, p ? d ? "nw" : "sw" : d ? "ne" : "se";
  }
  resolveMinDimensions(t, n, r = 0, i = 0) {
    const a = Math.min(r, t.width), l = Math.min(i, t.height);
    return !n || !a && !l ? [a, l] : n > 1 ? a ? [a, a / n] : [l * n, l] : l ? [l * n, l] : [a, a / n];
  }
  resizeCrop() {
    const { evData: t } = this, { aspect: n = 0, maxWidth: r, maxHeight: i } = this.props, a = this.getBox(), [l, u] = this.resolveMinDimensions(a, n, this.props.minWidth, this.props.minHeight);
    let d = this.makePixelCrop(a);
    const p = this.getPointRegion(a, t.ord, l, u), m = t.ord || p;
    let h = t.clientX - t.startClientX, g = t.clientY - t.startClientY;
    (l && m === "nw" || m === "w" || m === "sw") && (h = Math.min(h, -l)), (u && m === "nw" || m === "n" || m === "ne") && (g = Math.min(g, -u));
    const v = {
      unit: "px",
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
    p === "ne" ? (v.x = t.startCropX, v.width = h, n ? (v.height = v.width / n, v.y = t.startCropY - v.height) : (v.height = Math.abs(g), v.y = t.startCropY - v.height)) : p === "se" ? (v.x = t.startCropX, v.y = t.startCropY, v.width = h, n ? v.height = v.width / n : v.height = g) : p === "sw" ? (v.x = t.startCropX + h, v.y = t.startCropY, v.width = Math.abs(h), n ? v.height = v.width / n : v.height = g) : p === "nw" && (v.x = t.startCropX + h, v.width = Math.abs(h), n ? (v.height = v.width / n, v.y = t.startCropY - v.height) : (v.height = Math.abs(g), v.y = t.startCropY + g));
    const b = U0(
      v,
      n,
      p,
      a.width,
      a.height,
      l,
      u,
      r,
      i
    );
    return n || uo.xyOrds.indexOf(m) > -1 ? d = b : uo.xOrds.indexOf(m) > -1 ? (d.x = b.x, d.width = b.width) : uo.yOrds.indexOf(m) > -1 && (d.y = b.y, d.height = b.height), d.x = La(d.x, 0, a.width - d.width), d.y = La(d.y, 0, a.height - d.height), d;
  }
  renderCropSelection() {
    const {
      ariaLabels: t = uo.defaultProps.ariaLabels,
      disabled: n,
      locked: r,
      renderSelectionAddon: i,
      ruleOfThirds: a,
      crop: l
    } = this.props, u = this.getCropStyle();
    if (l)
      return /* @__PURE__ */ Ae.createElement(
        "div",
        {
          style: u,
          className: "ReactCrop__crop-selection",
          onPointerDown: this.onCropPointerDown,
          "aria-label": t.cropArea,
          tabIndex: 0,
          onKeyDown: this.onComponentKeyDown,
          role: "group"
        },
        !n && !r && /* @__PURE__ */ Ae.createElement("div", { className: "ReactCrop__drag-elements", onFocus: this.onDragFocus }, /* @__PURE__ */ Ae.createElement("div", { className: "ReactCrop__drag-bar ord-n", "data-ord": "n" }), /* @__PURE__ */ Ae.createElement("div", { className: "ReactCrop__drag-bar ord-e", "data-ord": "e" }), /* @__PURE__ */ Ae.createElement("div", { className: "ReactCrop__drag-bar ord-s", "data-ord": "s" }), /* @__PURE__ */ Ae.createElement("div", { className: "ReactCrop__drag-bar ord-w", "data-ord": "w" }), /* @__PURE__ */ Ae.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-nw",
            "data-ord": "nw",
            tabIndex: 0,
            "aria-label": t.nwDragHandle,
            onKeyDown: (d) => this.onHandlerKeyDown(d, "nw"),
            role: "button"
          }
        ), /* @__PURE__ */ Ae.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-n",
            "data-ord": "n",
            tabIndex: 0,
            "aria-label": t.nDragHandle,
            onKeyDown: (d) => this.onHandlerKeyDown(d, "n"),
            role: "button"
          }
        ), /* @__PURE__ */ Ae.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-ne",
            "data-ord": "ne",
            tabIndex: 0,
            "aria-label": t.neDragHandle,
            onKeyDown: (d) => this.onHandlerKeyDown(d, "ne"),
            role: "button"
          }
        ), /* @__PURE__ */ Ae.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-e",
            "data-ord": "e",
            tabIndex: 0,
            "aria-label": t.eDragHandle,
            onKeyDown: (d) => this.onHandlerKeyDown(d, "e"),
            role: "button"
          }
        ), /* @__PURE__ */ Ae.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-se",
            "data-ord": "se",
            tabIndex: 0,
            "aria-label": t.seDragHandle,
            onKeyDown: (d) => this.onHandlerKeyDown(d, "se"),
            role: "button"
          }
        ), /* @__PURE__ */ Ae.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-s",
            "data-ord": "s",
            tabIndex: 0,
            "aria-label": t.sDragHandle,
            onKeyDown: (d) => this.onHandlerKeyDown(d, "s"),
            role: "button"
          }
        ), /* @__PURE__ */ Ae.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-sw",
            "data-ord": "sw",
            tabIndex: 0,
            "aria-label": t.swDragHandle,
            onKeyDown: (d) => this.onHandlerKeyDown(d, "sw"),
            role: "button"
          }
        ), /* @__PURE__ */ Ae.createElement(
          "div",
          {
            className: "ReactCrop__drag-handle ord-w",
            "data-ord": "w",
            tabIndex: 0,
            "aria-label": t.wDragHandle,
            onKeyDown: (d) => this.onHandlerKeyDown(d, "w"),
            role: "button"
          }
        )),
        i && /* @__PURE__ */ Ae.createElement("div", { className: "ReactCrop__selection-addon", onPointerDown: (d) => d.stopPropagation() }, i(this.state)),
        a && /* @__PURE__ */ Ae.createElement(Ae.Fragment, null, /* @__PURE__ */ Ae.createElement("div", { className: "ReactCrop__rule-of-thirds-hz" }), /* @__PURE__ */ Ae.createElement("div", { className: "ReactCrop__rule-of-thirds-vt" }))
      );
  }
  makePixelCrop(t) {
    const n = { ...zu, ...this.props.crop || {} };
    return Co(n, t.width, t.height);
  }
  render() {
    const { aspect: t, children: n, circularCrop: r, className: i, crop: a, disabled: l, locked: u, style: d, ruleOfThirds: p } = this.props, { cropIsActive: m, newCropIsBeingDrawn: h } = this.state, g = a ? this.renderCropSelection() : null, v = V9(
      "ReactCrop",
      i,
      m && "ReactCrop--active",
      l && "ReactCrop--disabled",
      u && "ReactCrop--locked",
      h && "ReactCrop--new-crop",
      a && t && "ReactCrop--fixed-aspect",
      a && r && "ReactCrop--circular-crop",
      a && p && "ReactCrop--rule-of-thirds",
      !this.dragStarted && a && !a.width && !a.height && "ReactCrop--invisible-crop",
      r && "ReactCrop--no-animate"
    );
    return /* @__PURE__ */ Ae.createElement("div", { ref: this.componentRef, className: v, style: d }, /* @__PURE__ */ Ae.createElement("div", { ref: this.mediaRef, className: "ReactCrop__child-wrapper", onPointerDown: this.onComponentPointerDown }, n), a ? /* @__PURE__ */ Ae.createElement("svg", { className: "ReactCrop__crop-mask", width: "100%", height: "100%" }, /* @__PURE__ */ Ae.createElement("defs", null, /* @__PURE__ */ Ae.createElement("mask", { id: `hole-${this.instanceId}` }, /* @__PURE__ */ Ae.createElement("rect", { width: "100%", height: "100%", fill: "white" }), r ? /* @__PURE__ */ Ae.createElement(
      "ellipse",
      {
        cx: `${a.x + a.width / 2}${a.unit}`,
        cy: `${a.y + a.height / 2}${a.unit}`,
        rx: `${a.width / 2}${a.unit}`,
        ry: `${a.height / 2}${a.unit}`,
        fill: "black"
      }
    ) : /* @__PURE__ */ Ae.createElement(
      "rect",
      {
        x: `${a.x}${a.unit}`,
        y: `${a.y}${a.unit}`,
        width: `${a.width}${a.unit}`,
        height: `${a.height}${a.unit}`,
        fill: "black"
      }
    ))), /* @__PURE__ */ Ae.createElement("rect", { fill: "black", fillOpacity: 0.5, width: "100%", height: "100%", mask: `url(#hole-${this.instanceId})` })) : void 0, g);
  }
};
Ci.xOrds = ["e", "w"], Ci.yOrds = ["n", "s"], Ci.xyOrds = ["nw", "ne", "se", "sw"], Ci.nudgeStep = 1, Ci.nudgeStepMedium = 10, Ci.nudgeStepLarge = 100, Ci.defaultProps = {
  ariaLabels: {
    cropArea: "Use the arrow keys to move the crop selection area",
    nwDragHandle: "Use the arrow keys to move the north west drag handle to change the crop selection area",
    nDragHandle: "Use the up and down arrow keys to move the north drag handle to change the crop selection area",
    neDragHandle: "Use the arrow keys to move the north east drag handle to change the crop selection area",
    eDragHandle: "Use the up and down arrow keys to move the east drag handle to change the crop selection area",
    seDragHandle: "Use the arrow keys to move the south east drag handle to change the crop selection area",
    sDragHandle: "Use the up and down arrow keys to move the south drag handle to change the crop selection area",
    swDragHandle: "Use the arrow keys to move the south west drag handle to change the crop selection area",
    wDragHandle: "Use the up and down arrow keys to move the west drag handle to change the crop selection area"
  }
};
let U9 = Ci;
const Y9 = rn(/* @__PURE__ */ x.jsx("path", {
  d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2M8.5 13.5l2.5 3.01L14.5 12l4.5 6H5z"
}), "Image"), G9 = 10485760, K9 = ({
  label: e = "",
  disabled: t = !1,
  value: n,
  onChange: r,
  error: i,
  name: a,
  readOnly: l,
  aspectRatio: u,
  id: d
}) => {
  const p = ir(), [m, h] = Kt(!1), [g, v] = Kt(!1), [b, y] = Kt(), [S, O] = Kt(!1), [P, k] = Kt(""), [R, E] = Kt(""), [M, _] = Kt(!1), [I, F] = Kt(!1), T = Ti(null);
  mn(() => () => {
    R && URL.revokeObjectURL(R);
  }, [R]);
  const $ = $t(() => {
    _(!0), setTimeout(() => {
      _(!1), h(!1), r(null);
    }, 500);
  }, [r]), N = $t(
    (se) => {
      const { width: U, height: de } = se.currentTarget;
      let ce;
      u ? ce = W9(z9({ unit: "%", width: 100 }, u, U, de), U, de) : ce = { x: 0, y: 0, width: U, height: de, unit: "px" }, y(ce);
    },
    [u]
  ), W = $t(
    (se) => {
      se && se.length > 0 && (O(!0), k(se[0].name), R && URL.revokeObjectURL(R), E(URL.createObjectURL(se[0])));
    },
    [R]
  ), L = $t(
    (se) => {
      v(!0), setTimeout(() => {
        v(!1);
        const U = URL.createObjectURL(se), de = {
          id: d,
          filename: se.name,
          size: se.size,
          preview: U
        };
        r(de), E(U);
      }, 1e3);
    },
    [r, d]
  ), V = $t(() => {
    const se = T.current;
    if (!se || !b) {
      console.error("Crop elements not available");
      return;
    }
    const U = document.createElement("canvas"), { x: de, y: ce, width: K, height: Z } = b, ue = se.naturalWidth / se.width, he = se.naturalHeight / se.height;
    U.width = K * ue, U.height = Z * he;
    const B = U.getContext("2d");
    B && (B.drawImage(se, de * ue, ce * he, K * ue, Z * he, 0, 0, U.width, U.height), U.toBlob((ee) => {
      if (ee) {
        const ie = new File([ee], P, { type: "image/png" });
        L(ie);
      }
    }, "image/png")), O(!1);
  }, [b, P, L]), { getRootProps: z, getInputProps: X, isDragActive: le, isDragAccept: ne, isDragReject: G } = Dg({
    multiple: !1,
    accept: { "image/jpeg": [], "image/png": [] },
    disabled: t || l,
    maxSize: G9,
    onDrop: W
  }), Q = G ? p.palette.error.main : p.palette.primary.dark, be = G || i ? p.palette.error.main : ne ? p.palette.primary.main : dd[400], we = ne ? p.palette.success.light : G ? p.palette.error.light : "transparent";
  return /* @__PURE__ */ x.jsxs(sr, { fullWidth: !0, children: [
    !!e && /* @__PURE__ */ x.jsx(
      jr,
      {
        sx: {
          mb: 2,
          fontWeight: 600,
          color: p.palette.text.primary,
          fontSize: p.typography.subtitle1.fontSize
        },
        id: `${a}-label`,
        children: e
      }
    ),
    /* @__PURE__ */ x.jsxs(Xn, { container: !0, spacing: 3, children: [
      /* @__PURE__ */ x.jsxs(Xn, { size: { xs: 12, lg: 6 }, children: [
        /* @__PURE__ */ x.jsxs(
          sn,
          {
            ...z(),
            minHeight: "152px",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: we,
            sx: { cursor: "pointer" },
            borderRadius: p.spacing(1),
            border: `1px dashed ${be}`,
            children: [
              /* @__PURE__ */ x.jsx("input", { ...X() }),
              /* @__PURE__ */ x.jsx(sn, { alignItems: "center", justifyContent: "center", spacing: 1, children: g ? /* @__PURE__ */ x.jsx(Mi, { variant: "indeterminate" }) : /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
                /* @__PURE__ */ x.jsx(Mr, { pt: 1, pb: 0.5, children: /* @__PURE__ */ x.jsx(wO, { sx: { color: Q } }) }),
                !le && /* @__PURE__ */ x.jsxs(Mr, { children: [
                  /* @__PURE__ */ x.jsx(at, { display: "inline", color: "primary", sx: { textDecorationLine: "underline" }, children: "Click to upload" }),
                  /* @__PURE__ */ x.jsx(at, { display: "inline", children: " or drag and drop" })
                ] }),
                ne && /* @__PURE__ */ x.jsx(at, { color: p.palette.primary.dark, fontWeight: "bold", children: "Drop file(s) here to upload" }),
                G && /* @__PURE__ */ x.jsx(at, { color: "error", children: "File type, size or count is not allowed" }),
                /* @__PURE__ */ x.jsxs(Mr, { pt: 0.5, children: [
                  /* @__PURE__ */ x.jsxs(at, { display: "inline", variant: "subtitle2", color: "secondary", children: [
                    "JPG, JPEG or PNG",
                    " "
                  ] }),
                  /* @__PURE__ */ x.jsx(at, { display: "inline", variant: "subtitle2", color: "secondary", children: "(max. 10MB)" })
                ] })
              ] }) })
            ]
          }
        ),
        i && /* @__PURE__ */ x.jsx(at, { variant: "caption", color: "error", children: i.message })
      ] }),
      /* @__PURE__ */ x.jsx(Xn, { size: { xs: 12, lg: 6 }, children: n && (n == null ? void 0 : n.preview) && /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
        /* @__PURE__ */ x.jsxs(
          sn,
          {
            direction: "row",
            sx: { mb: 1, p: 2 },
            alignItems: "flex-start",
            justifyContent: "space-between",
            borderRadius: p.spacing(1),
            border: `1px solid ${p.palette.primary.main}`,
            children: [
              /* @__PURE__ */ x.jsxs(sn, { width: "100%", direction: "row", spacing: 2, pb: 1, children: [
                /* @__PURE__ */ x.jsx(ZC, { color: "primary", IconComponent: Y9 }),
                /* @__PURE__ */ x.jsxs(sn, { m: 1, maxWidth: "50%", children: [
                  /* @__PURE__ */ x.jsx(
                    at,
                    {
                      sx: {
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis"
                      },
                      children: n.filename
                    }
                  ),
                  /* @__PURE__ */ x.jsxs(at, { variant: "subtitle2", color: "secondary", fontSize: "small", children: [
                    "Uploaded - ",
                    TO(n.size, 2)
                  ] })
                ] })
              ] }),
              /* @__PURE__ */ x.jsx(OO, { color: "success" })
            ]
          }
        ),
        /* @__PURE__ */ x.jsxs(sn, { direction: "row", spacing: 1, children: [
          /* @__PURE__ */ x.jsx(Zo, { title: "View file", children: /* @__PURE__ */ x.jsx(
            En,
            {
              color: "primary",
              variant: "outlined",
              sx: { minWidth: "auto" },
              "aria-label": `View ${n.filename}`,
              onClick: () => F(!0),
              children: /* @__PURE__ */ x.jsx(SO, {})
            }
          ) }),
          !t && !l && /* @__PURE__ */ x.jsx(Zo, { title: "Remove file", children: /* @__PURE__ */ x.jsx(
            En,
            {
              color: "error",
              variant: "outlined",
              sx: { minWidth: "auto" },
              "aria-label": `Remove ${n.filename}`,
              onClick: () => h(!0),
              children: /* @__PURE__ */ x.jsx(CO, {})
            }
          ) })
        ] })
      ] }) })
    ] }),
    /* @__PURE__ */ x.jsxs(Sm, { isOpen: m, onClose: () => h(!1), children: [
      /* @__PURE__ */ x.jsx(rs, { variant: "h4", component: "h2", children: "Are you sure you want to remove this file?" }),
      /* @__PURE__ */ x.jsxs(Ri, { children: [
        /* @__PURE__ */ x.jsx(En, { disabled: M, variant: "contained", color: "error", onClick: $, children: "Remove" }),
        /* @__PURE__ */ x.jsx(En, { variant: "outlined", color: "warning", onClick: () => h(!1), disabled: M, children: "Keep" })
      ] })
    ] }),
    /* @__PURE__ */ x.jsxs(Sm, { isOpen: I, onClose: () => F(!1), children: [
      /* @__PURE__ */ x.jsx("img", { src: (n == null ? void 0 : n.preview) || R, alt: "Preview", style: { maxWidth: "100%", maxHeight: "80vh", objectFit: "contain" } }),
      /* @__PURE__ */ x.jsx(Ri, { children: /* @__PURE__ */ x.jsx(En, { variant: "outlined", color: "secondary", onClick: () => F(!1), children: "Close" }) })
    ] }),
    /* @__PURE__ */ x.jsxs(Sm, { onClose: () => O(!1), isOpen: S, children: [
      /* @__PURE__ */ x.jsx(rs, { variant: "h4", component: "h2", children: "Crop picture" }),
      /* @__PURE__ */ x.jsx(U9, { crop: b, onChange: (se) => y(se), children: /* @__PURE__ */ x.jsx("img", { ref: T, src: R, alt: "Crop", onLoad: N }) }),
      /* @__PURE__ */ x.jsxs(Ri, { children: [
        /* @__PURE__ */ x.jsx(En, { disabled: !b, loading: M, variant: "contained", color: "primary", onClick: V, children: "Confirm" }),
        /* @__PURE__ */ x.jsx(En, { variant: "outlined", color: "secondary", onClick: () => O(!1), children: "Cancel" })
      ] })
    ] })
  ] });
}, Sm = ({ children: e, isOpen: t, onClose: n }) => /* @__PURE__ */ x.jsx(fs, { open: t, onClose: n, sx: { zIndex: 1500 }, slotProps: { paper: { sx: { p: 2 } } }, children: e }), X9 = ({ label: e, disabled: t, value: n = [], onChange: r, error: i, name: a, readOnly: l = !1, groupedOptions: u }) => {
  const d = (g) => {
    const { children: v, key: b, group: y } = g, S = h.length > parseInt(b) + v.length;
    return /* @__PURE__ */ x.jsxs("li", { children: [
      /* @__PURE__ */ x.jsx(at, { component: "p", variant: "caption", px: 2, py: 1, children: y }),
      /* @__PURE__ */ x.jsx(zl, { sx: { p: 0 }, children: v }),
      S && /* @__PURE__ */ x.jsx(vl, { sx: { mx: 0, my: 1 } })
    ] }, b);
  }, p = (g) => {
    const v = n.slice();
    v.splice(g, 1), r(v);
  }, m = () => u.map(({ group: g, options: v }) => {
    const b = v.flatMap((y) => {
      const S = n.findIndex((O) => y.value === O.value);
      return S !== void 0 && S !== -1 ? [{ ...n[S], index: S }] : [];
    }).filter(Boolean);
    if (b.length !== 0)
      return /* @__PURE__ */ x.jsxs(sn, { spacing: 2, children: [
        /* @__PURE__ */ x.jsx(at, { fontWeight: "bold", children: g }),
        /* @__PURE__ */ x.jsx(sn, { direction: "row", spacing: 1, children: b.map((y) => /* @__PURE__ */ x.jsx(hd, { label: y.label, sx: { width: "fit-content" }, onDelete: () => p(y.index) }, y.index)) })
      ] }, g);
  }), h = u.flatMap(
    (g) => g.options.map((v) => ({ group: g.group, label: v.label || v.value, value: v.value }))
  );
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsxs(sr, { fullWidth: !0, size: "small", children: [
      /* @__PURE__ */ x.jsx(jr, { id: `${a}-label`, children: e }),
      /* @__PURE__ */ x.jsxs(sn, { spacing: 2, children: [
        /* @__PURE__ */ x.jsx(
          wd,
          {
            getOptionLabel: (g) => g.label,
            groupBy: (g) => g.group,
            getOptionDisabled: (g) => !!(n != null && n.find((v) => v.label === g.label)),
            renderGroup: d,
            multiple: !0,
            disableClearable: !0,
            disabled: t,
            "aria-labelledby": `${a}-label`,
            size: "small",
            options: h,
            value: n,
            renderTags: () => null,
            renderInput: (g) => /* @__PURE__ */ x.jsx(ms, { ...g, error: !!i, "aria-invalid": !!i, placeholder: "Select option" }),
            onChange: (g, v) => r(v),
            readOnly: l,
            slotProps: { listbox: { sx: { p: 0 } } }
          }
        ),
        m()
      ] })
    ] }),
    i && /* @__PURE__ */ x.jsx(at, { variant: "caption", color: "error", children: i.message })
  ] });
};
var hu = { exports: {} }, Q9 = hu.exports, Y0;
function Z9() {
  return Y0 || (Y0 = 1, function(e, t) {
    (function(n, r) {
      e.exports = r();
    })(Q9, () => {
      return n = { 705: (i) => {
        i.exports = function(a, l) {
          const u = [];
          return l.length === 0 ? u.push({ text: a, highlight: !1 }) : l[0][0] > 0 && u.push({ text: a.slice(0, l[0][0]), highlight: !1 }), l.forEach((d, p) => {
            const m = d[0], h = d[1];
            u.push({ text: a.slice(m, h), highlight: !0 }), p === l.length - 1 ? h < a.length && u.push({ text: a.slice(h, a.length), highlight: !1 }) : h < l[p + 1][0] && u.push({ text: a.slice(h, l[p + 1][0]), highlight: !1 });
          }), u;
        };
      } }, r = {}, function i(a) {
        var l = r[a];
        if (l !== void 0) return l.exports;
        var u = r[a] = { exports: {} };
        return n[a](u, u.exports, i), u.exports;
      }(705);
      var n, r;
    });
  }(hu)), hu.exports;
}
var J9 = Z9();
const eY = /* @__PURE__ */ Rl(J9);
var Om, G0;
function tY() {
  return G0 || (G0 = 1, Om = function e(t, n) {
    if (t === n) return !0;
    if (t && n && typeof t == "object" && typeof n == "object") {
      if (t.constructor !== n.constructor) return !1;
      var r, i, a;
      if (Array.isArray(t)) {
        if (r = t.length, r != n.length) return !1;
        for (i = r; i-- !== 0; )
          if (!e(t[i], n[i])) return !1;
        return !0;
      }
      if (t.constructor === RegExp) return t.source === n.source && t.flags === n.flags;
      if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === n.valueOf();
      if (t.toString !== Object.prototype.toString) return t.toString() === n.toString();
      if (a = Object.keys(t), r = a.length, r !== Object.keys(n).length) return !1;
      for (i = r; i-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(n, a[i])) return !1;
      for (i = r; i-- !== 0; ) {
        var l = a[i];
        if (!e(t[l], n[l])) return !1;
      }
      return !0;
    }
    return t !== t && n !== n;
  }), Om;
}
var nY = tY();
const rY = /* @__PURE__ */ Rl(nY);
function Mo() {
  return Mo = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Mo.apply(null, arguments);
}
function ss(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.includes(r)) continue;
    n[r] = e[r];
  }
  return n;
}
function oY(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function iY(e) {
  var t = oY(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
const Qo = {
  NOT_LOADED: "NOT_LOADED",
  LOADING: "LOADING",
  LOADED: "LOADED",
  FAILED: "FAILED",
  AUTH_FAILURE: "AUTH_FAILURE"
}, aY = "https://maps.googleapis.com/maps/api/js";
class Tl {
  /**
   * Loads the Maps JavaScript API with the specified parameters.
   * Since the Maps library can only be loaded once per page, this will
   * produce a warning when called multiple times with different
   * parameters.
   *
   * The returned promise resolves when loading completes
   * and rejects in case of an error or when the loading was aborted.
   */
  static async load(t, n) {
    var r;
    const i = t.libraries ? t.libraries.split(",") : [], a = this.serializeParams(t);
    this.listeners.push(n), (r = window.google) != null && (r = r.maps) != null && r.importLibrary ? (this.serializedApiParams || (this.loadingStatus = Qo.LOADED), this.notifyLoadingStatusListeners()) : (this.serializedApiParams = a, this.initImportLibrary(t)), this.serializedApiParams && this.serializedApiParams !== a && console.warn("[google-maps-api-loader] The maps API has already been loaded with different parameters and will not be loaded again. Refresh the page for new values to have effect.");
    const l = ["maps", ...i];
    await Promise.all(l.map((u) => google.maps.importLibrary(u)));
  }
  /**
   * Serialize the parameters used to load the library for easier comparison.
   */
  static serializeParams(t) {
    return [t.v, t.key, t.language, t.region, t.authReferrerPolicy, t.solutionChannel].join("/");
  }
  /**
   * Creates the global `google.maps.importLibrary` function for bootstrapping.
   * This is essentially a formatted version of the dynamic loading script
   * from the official documentation with some minor adjustments.
   *
   * The created importLibrary function will load the Google Maps JavaScript API,
   * which will then replace the `google.maps.importLibrary` function with the full
   * implementation.
   *
   * @see https://developers.google.com/maps/documentation/javascript/load-maps-js-api#dynamic-library-import
   */
  static initImportLibrary(t) {
    if (window.google || (window.google = {}), window.google.maps || (window.google.maps = {}), window.google.maps.importLibrary) {
      console.error("[google-maps-api-loader-internal]: initImportLibrary must only be called once");
      return;
    }
    let n = null;
    const r = () => n || (n = new Promise((i, a) => {
      var l;
      const u = document.createElement("script"), d = new URLSearchParams();
      for (const [p, m] of Object.entries(t)) {
        const h = p.replace(/[A-Z]/g, (g) => "_" + g[0].toLowerCase());
        d.set(h, String(m));
      }
      d.set("loading", "async"), d.set("callback", "__googleMapsCallback__"), u.async = !0, u.src = aY + "?" + d.toString(), u.nonce = ((l = document.querySelector("script[nonce]")) == null ? void 0 : l.nonce) || "", u.onerror = () => {
        this.loadingStatus = Qo.FAILED, this.notifyLoadingStatusListeners(), a(new Error("The Google Maps JavaScript API could not load."));
      }, window.__googleMapsCallback__ = () => {
        this.loadingStatus = Qo.LOADED, this.notifyLoadingStatusListeners(), i();
      }, window.gm_authFailure = () => {
        this.loadingStatus = Qo.AUTH_FAILURE, this.notifyLoadingStatusListeners();
      }, this.loadingStatus = Qo.LOADING, this.notifyLoadingStatusListeners(), document.head.append(u);
    }), n);
    google.maps.importLibrary = (i) => r().then(() => google.maps.importLibrary(i));
  }
  /**
   * Calls all registered loadingStatusListeners after a status update.
   */
  static notifyLoadingStatusListeners() {
    for (const t of this.listeners)
      t(this.loadingStatus);
  }
}
Tl.loadingStatus = Qo.NOT_LOADED;
Tl.serializedApiParams = void 0;
Tl.listeners = [];
const sY = ["onLoad", "onError", "apiKey", "version", "libraries"], lY = ["children"], cY = "GMP_visgl_rgmlibrary_v1_default", Gl = Ae.createContext(null);
function uY() {
  const [e, t] = Kt({});
  return {
    mapInstances: e,
    addMapInstance: (a, l = "default") => {
      t((u) => Mo({}, u, {
        [l]: a
      }));
    },
    removeMapInstance: (a = "default") => {
      t((l) => ss(l, [a].map(iY)));
    },
    clearMapInstances: () => {
      t({});
    }
  };
}
function dY(e) {
  const {
    onLoad: t,
    onError: n,
    apiKey: r,
    version: i,
    libraries: a = []
  } = e, l = ss(e, sY), [u, d] = Kt(Tl.loadingStatus), [p, m] = Jm((b, y) => b[y.name] ? b : Mo({}, b, {
    [y.name]: y.value
  }), {}), h = rr(() => a == null ? void 0 : a.join(","), [a]), g = rr(() => JSON.stringify(Mo({
    apiKey: r,
    version: i
  }, l)), [r, i, l]), v = $t(async (b) => {
    var y;
    if (p[b])
      return p[b];
    if (!((y = google) != null && (y = y.maps) != null && y.importLibrary))
      throw new Error("[api-provider-internal] importLibrary was called before google.maps.importLibrary was defined.");
    const S = await window.google.maps.importLibrary(b);
    return m({
      name: b,
      value: S
    }), S;
  }, [p]);
  return mn(
    () => {
      (async () => {
        try {
          const b = Mo({
            key: r
          }, l);
          i && (b.v = i), (h == null ? void 0 : h.length) > 0 && (b.libraries = h), (b.channel === void 0 || b.channel < 0 || b.channel > 999) && delete b.channel, b.solutionChannel === void 0 ? b.solutionChannel = cY : b.solutionChannel === "" && delete b.solutionChannel, await Tl.load(b, (y) => d(y));
          for (const y of ["core", "maps", ...a])
            await v(y);
          t && t();
        } catch (b) {
          n ? n(b) : console.error("<ApiProvider> failed to load the Google Maps JavaScript API", b);
        }
      })();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, h, g]
  ), {
    status: u,
    loadedLibraries: p,
    importLibrary: v
  };
}
const pY = (e) => {
  const {
    children: t
  } = e, n = ss(e, lY), {
    mapInstances: r,
    addMapInstance: i,
    removeMapInstance: a,
    clearMapInstances: l
  } = uY(), {
    status: u,
    loadedLibraries: d,
    importLibrary: p
  } = dY(n), m = rr(() => ({
    mapInstances: r,
    addMapInstance: i,
    removeMapInstance: a,
    clearMapInstances: l,
    status: u,
    loadedLibraries: d,
    importLibrary: p
  }), [r, i, a, l, u, d, p]);
  return /* @__PURE__ */ Ae.createElement(Gl.Provider, {
    value: m
  }, t);
};
function fY(e, t) {
  for (const n of yY) {
    const r = t[n], i = EO[n];
    mn(() => {
      if (!e || !r) return;
      const a = google.maps.event.addListener(e, i, (l) => {
        r(mY(i, e, l));
      });
      return () => a.remove();
    }, [e, i, r]);
  }
}
function mY(e, t, n) {
  const r = {
    type: e,
    map: t,
    detail: {},
    stoppable: !1,
    stop: () => {
    }
  };
  if (hY.includes(e)) {
    const a = r, l = t.getCenter(), u = t.getZoom(), d = t.getHeading() || 0, p = t.getTilt() || 0, m = t.getBounds();
    return (!l || !m || !Number.isFinite(u)) && console.warn("[createEvent] at least one of the values from the map returned undefined. This is not expected to happen. Please report an issue at https://github.com/visgl/react-google-maps/issues/new"), a.detail = {
      center: (l == null ? void 0 : l.toJSON()) || {
        lat: 0,
        lng: 0
      },
      zoom: u || 0,
      heading: d,
      tilt: p,
      bounds: (m == null ? void 0 : m.toJSON()) || {
        north: 90,
        east: 180,
        south: -90,
        west: -180
      }
    }, a;
  } else if (gY.includes(e)) {
    var i;
    if (!n) throw new Error("[createEvent] mouse events must provide a srcEvent");
    const a = r;
    return a.domEvent = n.domEvent, a.stoppable = !0, a.stop = () => n.stop(), a.detail = {
      latLng: ((i = n.latLng) == null ? void 0 : i.toJSON()) || null,
      placeId: n.placeId
    }, a;
  }
  return r;
}
const EO = {
  onBoundsChanged: "bounds_changed",
  onCenterChanged: "center_changed",
  onClick: "click",
  onContextmenu: "contextmenu",
  onDblclick: "dblclick",
  onDrag: "drag",
  onDragend: "dragend",
  onDragstart: "dragstart",
  onHeadingChanged: "heading_changed",
  onIdle: "idle",
  onIsFractionalZoomEnabledChanged: "isfractionalzoomenabled_changed",
  onMapCapabilitiesChanged: "mapcapabilities_changed",
  onMapTypeIdChanged: "maptypeid_changed",
  onMousemove: "mousemove",
  onMouseout: "mouseout",
  onMouseover: "mouseover",
  onProjectionChanged: "projection_changed",
  onRenderingTypeChanged: "renderingtype_changed",
  onTilesLoaded: "tilesloaded",
  onTiltChanged: "tilt_changed",
  onZoomChanged: "zoom_changed",
  // note: onCameraChanged is an alias for the bounds_changed event,
  // since that is going to be fired in every situation where the camera is
  // updated.
  onCameraChanged: "bounds_changed"
}, hY = ["bounds_changed", "center_changed", "heading_changed", "tilt_changed", "zoom_changed"], gY = ["click", "contextmenu", "dblclick", "mousemove", "mouseout", "mouseover"], yY = Object.keys(EO);
function bY(e, t) {
  const n = Ti(void 0);
  (!n.current || !rY(t, n.current)) && (n.current = t), mn(e, n.current);
}
const vY = /* @__PURE__ */ new Set(["backgroundColor", "clickableIcons", "controlSize", "disableDefaultUI", "disableDoubleClickZoom", "draggable", "draggableCursor", "draggingCursor", "fullscreenControl", "fullscreenControlOptions", "gestureHandling", "headingInteractionEnabled", "isFractionalZoomEnabled", "keyboardShortcuts", "mapTypeControl", "mapTypeControlOptions", "mapTypeId", "maxZoom", "minZoom", "noClear", "panControl", "panControlOptions", "restriction", "rotateControl", "rotateControlOptions", "scaleControl", "scaleControlOptions", "scrollwheel", "streetView", "streetViewControl", "streetViewControlOptions", "styles", "tiltInteractionEnabled", "zoomControl", "zoomControlOptions"]);
function xY(e, t) {
  const n = {}, r = Object.keys(t);
  for (const i of r)
    vY.has(i) && (n[i] = t[i]);
  bY(() => {
    e && e.setOptions(n);
  }, [n]);
}
function RO() {
  var e;
  return ((e = Qa(Gl)) == null ? void 0 : e.status) || Qo.NOT_LOADED;
}
function wY(e, t) {
  const {
    viewport: n,
    viewState: r
  } = t, i = !!n;
  return th(() => {
    if (!e || !r) return;
    const {
      latitude: a,
      longitude: l,
      bearing: u,
      pitch: d,
      zoom: p
    } = r;
    e.moveCamera({
      center: {
        lat: a,
        lng: l
      },
      heading: u,
      tilt: d,
      zoom: p + 1
    });
  }, [e, r]), i;
}
function CY(e) {
  return !e || typeof e != "object" || !("lat" in e && "lng" in e) ? !1 : Number.isFinite(e.lat) && Number.isFinite(e.lng);
}
function kO(e) {
  return CY(e) ? e : e.toJSON();
}
function SY(e, t, n) {
  const r = n.center ? kO(n.center) : null;
  let i = null, a = null;
  r && Number.isFinite(r.lat) && Number.isFinite(r.lng) && (i = r.lat, a = r.lng);
  const l = Number.isFinite(n.zoom) ? n.zoom : null, u = Number.isFinite(n.heading) ? n.heading : null, d = Number.isFinite(n.tilt) ? n.tilt : null;
  th(() => {
    if (!e) return;
    const p = {};
    let m = !1;
    i !== null && a !== null && (t.current.center.lat !== i || t.current.center.lng !== a) && (p.center = {
      lat: i,
      lng: a
    }, m = !0), l !== null && t.current.zoom !== l && (p.zoom = l, m = !0), u !== null && t.current.heading !== u && (p.heading = u, m = !0), d !== null && t.current.tilt !== d && (p.tilt = d, m = !0), m && e.moveCamera(p);
  });
}
const OY = () => {
  const e = {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: 999,
    display: "flex",
    flexFlow: "column nowrap",
    textAlign: "center",
    justifyContent: "center",
    fontSize: ".8rem",
    color: "rgba(0,0,0,0.6)",
    background: "#dddddd",
    padding: "1rem 1.5rem"
  };
  return /* @__PURE__ */ Ae.createElement("div", {
    style: e
  }, /* @__PURE__ */ Ae.createElement("h2", null, "Error: AuthFailure"), /* @__PURE__ */ Ae.createElement("p", null, "A problem with your API key prevents the map from rendering correctly. Please make sure the value of the ", /* @__PURE__ */ Ae.createElement("code", null, "APIProvider.apiKey"), " prop is correct. Check the error-message in the console for further details."));
};
function TY() {
  const [e, t] = Kt(null), n = $t((r) => t(r), [t]);
  return [e, n];
}
function Mg() {
  return RO() === Qo.LOADED;
}
function EY() {
  const [, e] = Jm((t) => t + 1, 0);
  return e;
}
function RY(e, t) {
  const n = e.getCenter(), r = e.getZoom(), i = e.getHeading() || 0, a = e.getTilt() || 0, l = e.getBounds();
  (!n || !l || !Number.isFinite(r)) && console.warn("[useTrackedCameraState] at least one of the values from the map returned undefined. This is not expected to happen. Please report an issue at https://github.com/visgl/react-google-maps/issues/new"), Object.assign(t.current, {
    center: (n == null ? void 0 : n.toJSON()) || {
      lat: 0,
      lng: 0
    },
    zoom: r || 0,
    heading: i,
    tilt: a
  });
}
function kY(e) {
  const t = EY(), n = Ti({
    center: {
      lat: 0,
      lng: 0
    },
    heading: 0,
    tilt: 0,
    zoom: 0
  });
  return mn(() => {
    if (!e) return;
    const r = google.maps.event.addListener(e, "bounds_changed", () => {
      RY(e, n), t();
    });
    return () => r.remove();
  }, [e, t]), n;
}
const PY = ["id", "defaultBounds", "defaultCenter", "defaultZoom", "defaultHeading", "defaultTilt", "reuseMaps", "renderingType", "colorScheme"], DY = ["padding"];
class gu {
  static has(t) {
    return this.entries[t] && this.entries[t].length > 0;
  }
  static pop(t) {
    return this.entries[t] && this.entries[t].pop() || null;
  }
  static push(t, n) {
    this.entries[t] || (this.entries[t] = []), this.entries[t].push(n);
  }
}
gu.entries = {};
function MY(e, t) {
  const n = Mg(), [r, i] = Kt(null), [a, l] = TY(), u = kY(r), {
    id: d,
    defaultBounds: p,
    defaultCenter: m,
    defaultZoom: h,
    defaultHeading: g,
    defaultTilt: v,
    reuseMaps: b,
    renderingType: y,
    colorScheme: S
  } = e, O = ss(e, PY), P = e.zoom !== void 0 || e.defaultZoom !== void 0, k = e.center !== void 0 || e.defaultCenter !== void 0;
  !p && (!P || !k) && console.warn("<Map> component is missing configuration. You have to provide zoom and center (via the `zoom`/`defaultZoom` and `center`/`defaultCenter` props) or specify the region to show using `defaultBounds`. See https://visgl.github.io/react-google-maps/docs/api-reference/components/map#required"), !O.center && m && (O.center = m), !O.zoom && Number.isFinite(h) && (O.zoom = h), !O.heading && Number.isFinite(g) && (O.heading = g), !O.tilt && Number.isFinite(v) && (O.tilt = v);
  for (const E of Object.keys(O)) O[E] === void 0 && delete O[E];
  const R = Ti(void 0);
  return mn(
    () => {
      if (!a || !n) return;
      const {
        addMapInstance: E,
        removeMapInstance: M
      } = t, {
        mapId: _
      } = e, I = `${_ || "default"}:${y || "default"}:${S || "LIGHT"}`;
      let F, T;
      if (b && gu.has(I) ? (T = gu.pop(I), F = T.getDiv(), a.appendChild(F), T.setOptions(O), setTimeout(() => T.setCenter(T.getCenter()), 0)) : (F = document.createElement("div"), F.style.height = "100%", a.appendChild(F), T = new google.maps.Map(F, Mo({}, O, y ? {
        renderingType: y
      } : {}, S ? {
        colorScheme: S
      } : {}))), i(T), E(T, d), p) {
        const {
          padding: $
        } = p, N = ss(p, DY);
        T.fitBounds(N, $);
      } else (!P || !k) && T.fitBounds({
        east: 180,
        west: -180,
        south: -90,
        north: 90
      });
      if (R.current) {
        const {
          mapId: $,
          cameraState: N
        } = R.current;
        $ !== _ && T.setOptions(N);
      }
      return () => {
        R.current = {
          mapId: _,
          // eslint-disable-next-line react-hooks/exhaustive-deps
          cameraState: u.current
        }, F.remove(), b ? gu.push(I, T) : google.maps.event.clearInstanceListeners(T), i(null), M(d);
      };
    },
    // some dependencies are ignored in the list below:
    //  - defaultBounds and the default* camera props will only be used once, and
    //    changes should be ignored
    //  - mapOptions has special hooks that take care of updating the options
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      a,
      n,
      d,
      // these props can't be changed after initialization and require a new
      // instance to be created
      e.mapId,
      e.renderingType,
      e.colorScheme
    ]
  ), [r, l, u];
}
const PO = Ae.createContext(null), DO = (e) => {
  const {
    children: t,
    id: n,
    className: r,
    style: i
  } = e, a = Qa(Gl), l = RO();
  if (!a)
    throw new Error("<Map> can only be used inside an <ApiProvider> component.");
  const [u, d, p] = MY(e, a);
  SY(u, p, e), fY(u, e), xY(u, e);
  const m = wY(u, e), h = !!e.controlled;
  mn(() => {
    if (u)
      return m && u.setOptions({
        disableDefaultUI: !0
      }), (m || h) && u.setOptions({
        gestureHandling: "none",
        keyboardShortcuts: !1
      }), () => {
        u.setOptions({
          gestureHandling: e.gestureHandling,
          keyboardShortcuts: e.keyboardShortcuts
        });
      };
  }, [u, m, h, e.gestureHandling, e.keyboardShortcuts]);
  const g = e.center ? kO(e.center) : null;
  let v = null, b = null;
  g && Number.isFinite(g.lat) && Number.isFinite(g.lng) && (v = g.lat, b = g.lng);
  const y = rr(() => {
    var P, k, R, E, M;
    return {
      center: {
        lat: (P = v) != null ? P : 0,
        lng: (k = b) != null ? k : 0
      },
      zoom: (R = e.zoom) != null ? R : 0,
      heading: (E = e.heading) != null ? E : 0,
      tilt: (M = e.tilt) != null ? M : 0
    };
  }, [v, b, e.zoom, e.heading, e.tilt]);
  th(() => {
    if (!u || !h) return;
    u.moveCamera(y);
    const P = u.addListener("bounds_changed", () => {
      u.moveCamera(y);
    });
    return () => P.remove();
  }, [u, h, y]);
  const S = rr(() => Mo({
    width: "100%",
    height: "100%",
    position: "relative",
    // when using deckgl, the map should be sent to the back
    zIndex: m ? -1 : 0
  }, i), [i, m]), O = rr(() => ({
    map: u
  }), [u]);
  return l === Qo.AUTH_FAILURE ? /* @__PURE__ */ Ae.createElement("div", {
    style: Mo({
      position: "relative"
    }, r ? {} : S),
    className: r
  }, /* @__PURE__ */ Ae.createElement(OY, null)) : /* @__PURE__ */ Ae.createElement("div", Mo({
    ref: d,
    "data-testid": "map",
    style: r ? void 0 : S,
    className: r
  }, n ? {
    id: n
  } : {}), u ? /* @__PURE__ */ Ae.createElement(PO.Provider, {
    value: O
  }, t) : null);
};
DO.deckGLViewProps = !0;
const K0 = /* @__PURE__ */ new Set();
function _Y(...e) {
  const t = JSON.stringify(e);
  K0.has(t) || (K0.add(t), console.error(...e));
}
const _g = (e = null) => {
  const t = Qa(Gl), {
    map: n
  } = Qa(PO) || {};
  if (t === null)
    return _Y("useMap(): failed to retrieve APIProviderContext. Make sure that the <APIProvider> component exists and that the component you are calling `useMap()` from is a sibling of the <APIProvider>."), null;
  const {
    mapInstances: r
  } = t;
  return e !== null ? r[e] || null : n || r.default || null;
};
function MO(e) {
  const t = Mg(), n = Qa(Gl);
  return mn(() => {
    !t || !n || n.importLibrary(e);
  }, [t, n, e]), (n == null ? void 0 : n.loadedLibraries[e]) || null;
}
function nu(e, t, n) {
  mn(() => {
    if (!e || !t || !n) return;
    const r = google.maps.event.addListener(e, t, n);
    return () => r.remove();
  }, [e, t, n]);
}
function ru(e, t, n) {
  mn(() => {
    e && (e[t] = n);
  }, [e, t, n]);
}
function X0(e, t, n) {
  mn(() => {
    if (!(!e || !t || !n))
      return e.addEventListener(t, n), () => e.removeEventListener(t, n);
  }, [e, t, n]);
}
function IY(e) {
  return e.nodeType === Node.ELEMENT_NODE;
}
const jY = Ae.createContext(null), $Y = {
  BOTTOM: ["50%", "100%"]
}, AY = ({
  children: e,
  styles: t,
  className: n,
  anchorPoint: r
}) => {
  const [i, a] = r ?? $Y.BOTTOM, l = `translate(50%, 100%) translate(-${i}, -${a})`;
  return (
    // anchoring container
    /* @__PURE__ */ Ae.createElement("div", {
      style: {
        transform: l
      }
    }, /* @__PURE__ */ Ae.createElement("div", {
      className: n,
      style: t
    }, e))
  );
};
function NY(e) {
  const [t, n] = Kt(null), [r, i] = Kt(null), a = _g(), l = MO("marker"), {
    children: u,
    onClick: d,
    className: p,
    onMouseEnter: m,
    onMouseLeave: h,
    onDrag: g,
    onDragStart: v,
    onDragEnd: b,
    collisionBehavior: y,
    clickable: S,
    draggable: O,
    position: P,
    title: k,
    zIndex: R
  } = e, E = Q0.count(u);
  return mn(() => {
    if (!a || !l) return;
    const M = new l.AdvancedMarkerElement();
    M.map = a, n(M);
    let _ = null;
    return E > 0 && (_ = document.createElement("div"), _.isCustomMarker = !0, M.content = _, i(_)), () => {
      var I;
      M.map = null, (I = _) == null || I.remove(), n(null), i(null);
    };
  }, [a, l, E]), mn(() => {
    !t || !t.content || E > 0 || (t.content.className = p || "");
  }, [t, p, E]), ru(t, "position", P), ru(t, "title", k ?? ""), ru(t, "zIndex", R), ru(t, "collisionBehavior", y), mn(() => {
    t && (O !== void 0 ? t.gmpDraggable = O : g || v || b ? t.gmpDraggable = !0 : t.gmpDraggable = !1);
  }, [t, O, g, b, v]), mn(() => {
    if (!t) return;
    const M = S !== void 0 || !!d || !!m || !!h;
    t.gmpClickable = M, M && t != null && t.content && IY(t.content) && (t.content.style.pointerEvents = "none", t.content.firstElementChild && (t.content.firstElementChild.style.pointerEvents = "all"));
  }, [t, S, d, m, h]), nu(t, "click", d), nu(t, "drag", g), nu(t, "dragstart", v), nu(t, "dragend", b), X0(t == null ? void 0 : t.element, "mouseenter", m), X0(t == null ? void 0 : t.element, "mouseleave", h), [t, r];
}
El((e, t) => {
  const {
    children: n,
    style: r,
    className: i,
    anchorPoint: a
  } = e, [l, u] = NY(e), d = rr(() => l ? {
    marker: l
  } : null, [l]);
  return eh(t, () => l, [l]), u ? /* @__PURE__ */ Ae.createElement(jY.Provider, {
    value: d
  }, BM(/* @__PURE__ */ Ae.createElement(AY, {
    anchorPoint: a,
    styles: r,
    className: i
  }, n), u)) : null;
});
const FY = ["onClick", "onDrag", "onDragStart", "onDragEnd", "onMouseOver", "onMouseOut"];
function LY(e) {
  const [t, n] = Kt(null), r = _g(), {
    onClick: i,
    onDrag: a,
    onDragStart: l,
    onDragEnd: u,
    onMouseOver: d,
    onMouseOut: p
  } = e, m = ss(e, FY), {
    position: h,
    draggable: g
  } = m;
  return mn(() => {
    if (!r) {
      r === void 0 && console.error("<Marker> has to be inside a Map component.");
      return;
    }
    const v = new google.maps.Marker(m);
    return v.setMap(r), n(v), () => {
      v.setMap(null), n(null);
    };
  }, [r]), mn(() => {
    if (!t) return;
    const v = t, b = google.maps.event;
    return i && b.addListener(v, "click", i), a && b.addListener(v, "drag", a), l && b.addListener(v, "dragstart", l), u && b.addListener(v, "dragend", u), d && b.addListener(v, "mouseover", d), p && b.addListener(v, "mouseout", p), t.setDraggable(!!g), () => {
      b.clearInstanceListeners(v);
    };
  }, [t, g, i, a, l, u, d, p]), mn(() => {
    t && m && t.setOptions(m);
  }, [t, m]), mn(() => {
    g || !h || !t || t.setPosition(h);
  }, [g, h, t]), t;
}
El((e, t) => {
  const n = LY(e);
  return eh(t, () => n, [n]), /* @__PURE__ */ Ae.createElement(Ae.Fragment, null);
});
const BY = (e, t) => {
  const n = _g(), r = MO("places"), i = Mg(), [a, l] = Kt(null), [u, d] = Kt(!1), [p, m] = Kt(), [h, g] = Kt(null), [v, b] = Kt(null), [y, S] = Kt([]);
  mn(() => {
    if (!(!r || !n || !i))
      return g(new r.AutocompleteService()), b(new r.PlacesService(n)), m(new r.AutocompleteSessionToken()), () => g(null);
  }, [n, r, i]);
  const O = $t(
    async (R) => {
      const E = t ? { [Tn.country]: "us" } : void 0;
      if (d(!0), !h || !R) {
        S([]);
        return;
      }
      try {
        const M = await h.getPlacePredictions({ input: R, sessionToken: p, componentRestrictions: E });
        S(a ? [a, ...M.predictions] : M.predictions);
      } catch (M) {
        console.error(M);
      } finally {
        d(!1);
      }
    },
    [h, p, a, t]
  ), P = $t(
    (R) => {
      gh(O, 400)(R);
    },
    [O]
  );
  return { handleSuggestionClick: $t(
    (R) => {
      if (!r || !R) return;
      const E = {
        placeId: R.place_id,
        fields: ["geometry", "name", "formatted_address", "address_components"],
        sessionToken: p
      }, M = (_) => {
        e(_, R), S([]), m(new r.AutocompleteSessionToken()), l(R);
      };
      v == null || v.getDetails(E, M);
    },
    [e, r, v, p, l]
  ), onInputChange: P, predictionResults: y, selectedSuggestion: a, loading: u };
}, VY = rn(/* @__PURE__ */ x.jsx("path", {
  d: "M12 5.99 19.53 19H4.47zM12 2 1 21h22zm1 14h-2v2h2zm0-6h-2v4h2z"
}), "WarningAmberOutlined"), zY = [
  { name: Tn.addressLine1, label: "Address Line 1", required: !0 },
  { name: Tn.city, label: "City", required: !0 },
  { name: Tn.postalCode, label: "Postal Code", required: !0 },
  { name: Tn.addressLine2, label: "Address Line 2" },
  { name: Tn.country, label: "Country", required: !0 },
  { name: Tn.state, label: "State", required: !0 }
];
function WY(e) {
  return /* @__PURE__ */ x.jsx(
    $i,
    {
      ...e,
      elevation: 5,
      sx: {
        borderRadius: 2,
        display: "flex",
        flexDirection: "column",
        alignSelf: "stretch",
        border: "1px #AEAEAF",
        px: 2,
        py: 1,
        minWidth: "max-content",
        boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
        "& .MuiAutocomplete-noOptions": {
          px: 2,
          py: 1
        }
      },
      children: e.children
    }
  );
}
const qY = ({ option: e }) => {
  const t = e.structured_formatting.main_text_matched_substrings, n = eY(
    e.structured_formatting.main_text,
    t.map((i) => [i.offset, i.offset + i.length])
  ), r = FM();
  return /* @__PURE__ */ x.jsxs(Xn, { sx: { wordWrap: "break-word" }, children: [
    n.map((i) => /* @__PURE__ */ x.jsx(
      Mr,
      {
        component: "span",
        sx: {
          fontWeight: i.highlight ? "fontWeightBold" : "fontWeightRegular"
        },
        children: i.text
      },
      `${r}${i.text}`
    )),
    e.structured_formatting.secondary_text ? /* @__PURE__ */ x.jsx(at, { variant: "body1", sx: { color: "text.secondary" }, children: e.structured_formatting.secondary_text }) : null
  ] });
}, HY = ({ setManualMode: e, handlePlaceDetails: t, name: n, label: r, restrictToUS: i }) => {
  const { predictionResults: a, onInputChange: l, handleSuggestionClick: u, selectedSuggestion: d, loading: p } = BY(
    t,
    i
  ), m = ir();
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx("div", { children: /* @__PURE__ */ x.jsx(DO, { zoom: null, center: null }) }),
    /* @__PURE__ */ x.jsx(
      wd,
      {
        fullWidth: !0,
        autoComplete: !0,
        includeInputInList: !0,
        filterSelectedOptions: !0,
        loading: p,
        popupIcon: null,
        clearIcon: null,
        getOptionLabel: (h) => typeof h == "string" ? h : h.description,
        slots: {
          paper: WY
        },
        options: a,
        value: d,
        noOptionsText: /* @__PURE__ */ x.jsxs(Xn, { container: !0, direction: "row", display: "flex", alignItems: "flex-end", size: 12, children: [
          /* @__PURE__ */ x.jsxs(at, { variant: "caption", children: [
            "Sorry, we cannot find that address in the USPS database.",
            " ",
            /* @__PURE__ */ x.jsx(Io, { sx: { textDecoration: "underline", textDecorationColor: m.palette.primary.main }, onClick: () => e(!0), children: /* @__PURE__ */ x.jsx(at, { variant: "caption", color: "primary", children: "Please enter it manually" }) })
          ] }),
          /* @__PURE__ */ x.jsx(VY, { sx: { marginLeft: "0.4rem" }, color: "warning", fontSize: "small" })
        ] }),
        onChange: (h, g) => {
          u(g);
        },
        onInputChange: (h, g) => {
          l(g);
        },
        renderInput: (h) => {
          var b;
          const { InputProps: g, inputProps: v } = h;
          return /* @__PURE__ */ x.jsx(Id, { value: ((b = v.value) == null ? void 0 : b.toString()) ?? "", slotProps: { input: g, htmlInput: v }, label: r, name: n });
        },
        renderOption: (h, g) => {
          const { key: v, ...b } = h;
          return /* @__PURE__ */ x.jsx("li", { ...b, children: /* @__PURE__ */ x.jsx(Xn, { container: !0, sx: { alignItems: "center" }, children: /* @__PURE__ */ x.jsx(qY, { option: g }) }) }, v);
        }
      }
    )
  ] });
}, UY = ({
  googleMapsAPIKey: e,
  name: t,
  value: n,
  onChange: r,
  disabled: i,
  label: a,
  readOnly: l,
  restrictToUS: u,
  error: d,
  addressInputs: p = zY
}) => {
  const m = ir(), [h, g] = Kt(!1), v = (y, S) => {
    const O = n || {
      [Tn.addressLine1]: "",
      [Tn.addressLine2]: "",
      [Tn.postalCode]: "",
      [Tn.city]: "",
      [Tn.state]: "",
      [Tn.country]: ""
    };
    O[y] = S, r(O);
  }, b = (y, S) => {
    var P, k, R, E, M, _, I, F, T, $;
    const O = {
      [Tn.addressLine1]: (S == null ? void 0 : S.structured_formatting.main_text) ?? "",
      [Tn.addressLine2]: ((k = (P = y == null ? void 0 : y.address_components) == null ? void 0 : P.find((N) => N.types.includes("sublocality") || N.types.includes("neighborhood"))) == null ? void 0 : k.long_name) ?? "",
      [Tn.postalCode]: ((E = (R = y == null ? void 0 : y.address_components) == null ? void 0 : R.find((N) => N.types.includes("postal_code"))) == null ? void 0 : E.long_name) ?? "",
      [Tn.city]: ((_ = (M = y == null ? void 0 : y.address_components) == null ? void 0 : M.find((N) => N.types.includes("locality"))) == null ? void 0 : _.long_name) ?? "",
      [Tn.state]: ((F = (I = y == null ? void 0 : y.address_components) == null ? void 0 : I.find((N) => N.types.includes("administrative_area_level_1"))) == null ? void 0 : F.long_name) ?? "",
      [Tn.country]: (($ = (T = y == null ? void 0 : y.address_components) == null ? void 0 : T.find((N) => N.types.includes("country"))) == null ? void 0 : $.long_name) ?? ""
    };
    r(O);
  };
  return /* @__PURE__ */ x.jsxs(Xn, { container: !0, wrap: "wrap", spacing: { xs: 0, md: 4 }, children: [
    /* @__PURE__ */ x.jsx(Xn, { size: { xs: 12, md: 4 }, children: /* @__PURE__ */ x.jsx(pY, { apiKey: e, children: /* @__PURE__ */ x.jsx(HY, { label: a, name: t, setManualMode: g, handlePlaceDetails: b, restrictToUS: u }) }) }),
    /* @__PURE__ */ x.jsx(Xn, { size: { xs: 12, md: 4 }, container: !0, sx: { display: "flex", alignItems: "flex-end" }, children: /* @__PURE__ */ x.jsx(Io, { onClick: () => g(!0), sx: { textDecoration: "underline", pb: "0.625rem", textDecorationColor: m.palette.primary.main }, children: /* @__PURE__ */ x.jsx(at, { sx: {}, color: "primary", variant: "subtitle1", children: "Can't find your address? Enter it manually" }) }) }),
    /* @__PURE__ */ x.jsx(Xn, { size: { xs: 0, md: 4 } }),
    p.map(({ name: y, label: S, required: O }) => {
      if (u && y === Tn.country || !u && y === Tn.state) return;
      const P = d && O && !(n != null && n[y]) ? { type: "required", message: `${S} is required` } : void 0, k = n ? n[y] : "";
      return /* @__PURE__ */ x.jsx(Xn, { size: { xs: 12, md: 4 }, children: /* @__PURE__ */ x.jsx(sn, { gap: 0.5, children: /* @__PURE__ */ x.jsx(
        Id,
        {
          name: `${t}-${y}`,
          label: S,
          disabled: i || !h,
          value: k,
          onChange: (R) => v(y, R),
          error: P,
          readOnly: l
        }
      ) }) }, y);
    })
  ] });
}, YY = ({
  label: e,
  disabled: t,
  value: n,
  onChange: r,
  error: i,
  name: a,
  readOnly: l,
  min: u = -1 / 0,
  max: d = 1 / 0,
  textSuffix: p,
  helperText: m
}) => {
  const h = p && /* @__PURE__ */ x.jsx(Vl, { position: "end", children: /* @__PURE__ */ x.jsx(at, { variant: "caption", children: p }) });
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsxs(sr, { fullWidth: !0, size: "small", children: [
      /* @__PURE__ */ x.jsx(jr, { id: `${a}-label`, children: e }),
      /* @__PURE__ */ x.jsx(
        ms,
        {
          size: "small",
          type: "number",
          "aria-labelledby": `${a}-label`,
          value: n,
          error: !!i,
          slotProps: { htmlInput: { min: u, max: d, readOnly: l }, input: { endAdornment: h } },
          disabled: t,
          name: a,
          onChange: (g) => r(g.target.value),
          helperText: m
        }
      )
    ] }),
    i ? /* @__PURE__ */ x.jsx(at, { variant: "caption", color: "error", children: i.message }) : /* @__PURE__ */ x.jsx("br", {})
  ] });
}, GY = ({
  name: e,
  label: t,
  disabled: n = !1,
  value: r,
  onChange: i,
  options: a,
  error: l,
  readOnly: u = !1
}) => {
  const d = (p, m) => {
    const h = r || {};
    h[p] = m, i(h);
  };
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsxs(sr, { fullWidth: !0, size: "small", sx: { overflowX: "auto" }, children: [
      t && /* @__PURE__ */ x.jsx(jr, { id: `${e}-label`, disabled: n, children: t }),
      /* @__PURE__ */ x.jsxs(IC, { children: [
        /* @__PURE__ */ x.jsx($C, { children: /* @__PURE__ */ x.jsxs(Wm, { children: [
          /* @__PURE__ */ x.jsx(oa, {}),
          Array.from({ length: 10 }, (p, m) => /* @__PURE__ */ x.jsx(oa, { sx: { textAlign: "center" }, children: m + 1 }, m + 1)),
          /* @__PURE__ */ x.jsx(oa, {})
        ] }) }),
        /* @__PURE__ */ x.jsx(jC, { children: a.map(({ name: p, leftLabel: m, rightLabel: h }) => /* @__PURE__ */ x.jsxs(Wm, { children: [
          /* @__PURE__ */ x.jsx(oa, { children: m }),
          Array.from({ length: 10 }, (g, v) => {
            const b = v + 1;
            return /* @__PURE__ */ x.jsx(oa, { sx: { textAlign: "center" }, children: /* @__PURE__ */ x.jsx(
              Uh,
              {
                name: p,
                value: b,
                checked: (r == null ? void 0 : r[p]) === b,
                onChange: () => d(p, b),
                disabled: n || u
              }
            ) }, v + 1);
          }),
          /* @__PURE__ */ x.jsx(oa, { children: h })
        ] }, p)) })
      ] })
    ] }),
    l ? /* @__PURE__ */ x.jsx(at, { variant: "caption", color: "error", children: l.message }) : /* @__PURE__ */ x.jsx("br", {})
  ] });
}, KY = ({
  label: e,
  disabled: t,
  value: n = "",
  onChange: r,
  error: i,
  name: a,
  readOnly: l = !1,
  groupedOptions: u,
  disabledOptions: d = []
}) => {
  const p = (h) => {
    const { children: g, key: v, group: b } = h, y = m.length > parseInt(v) + g.length;
    return /* @__PURE__ */ x.jsxs("li", { children: [
      /* @__PURE__ */ x.jsx(at, { component: "p", variant: "caption", px: 2, py: 1, children: b }),
      /* @__PURE__ */ x.jsx(zl, { sx: { p: 0 }, children: g }),
      y && /* @__PURE__ */ x.jsx(vl, { sx: { mx: 0, my: 1 } })
    ] }, v);
  }, m = u.flatMap(
    (h) => h.options.map((g) => ({ group: h.group, label: g.label || g.value, value: g.value }))
  );
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsxs(sr, { fullWidth: !0, size: "small", children: [
      /* @__PURE__ */ x.jsx(jr, { id: `${a}-label`, children: e }),
      /* @__PURE__ */ x.jsx(sn, { spacing: 2, children: /* @__PURE__ */ x.jsx(
        wd,
        {
          getOptionLabel: (h) => h.label,
          groupBy: (h) => h.group,
          getOptionDisabled: (h) => !!d.find((g) => g === h.label),
          renderGroup: p,
          disableClearable: !0,
          disabled: t,
          "aria-labelledby": `${a}-label`,
          size: "small",
          options: m,
          value: m.find((h) => h.label === n),
          renderTags: () => null,
          renderInput: (h) => /* @__PURE__ */ x.jsx(ms, { ...h, error: !!i, "aria-invalid": !!i, placeholder: "Select option" }),
          onChange: (h, g) => r(g.value),
          readOnly: l,
          slotProps: { listbox: { sx: { p: 0 } } }
        }
      ) })
    ] }),
    i && /* @__PURE__ */ x.jsx(at, { variant: "caption", color: "error", children: i.message })
  ] });
}, XY = ({ label: e, disabled: t, value: n, onChange: r, error: i, readOnly: a }) => /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
  /* @__PURE__ */ x.jsx(sr, { fullWidth: !0, size: "small", sx: { pointerEvents: a ? "none" : "auto" }, children: /* @__PURE__ */ x.jsx(
    Sd,
    {
      disabled: t,
      control: /* @__PURE__ */ x.jsx($h, { disabled: t, value: "on", checked: n, onChange: (l) => r(l.target.checked) }),
      label: e
    }
  ) }),
  i && /* @__PURE__ */ x.jsx(at, { variant: "caption", color: "error", children: i.message })
] }), r7 = (e) => {
  const { label: t = "", name: n, control: r, type: i, rules: a, disabled: l = !1, readOnly: u } = e, {
    field: { value: d, onChange: p },
    formState: { errors: m }
  } = sS({ name: n, control: r, rules: a }), h = { name: n, label: t, disabled: l, readOnly: u, value: d, onChange: p, error: w5(m, n) };
  let g;
  switch (i) {
    case pr.Text:
      g = /* @__PURE__ */ x.jsx(
        Id,
        {
          ...h,
          rows: e.rows,
          multiline: e.multiline,
          maxLength: e.maxLength,
          maxWords: e.maxWords,
          textSuffix: e.textSuffix,
          helperText: e.helperText,
          placeholder: e.placeholder
        }
      );
      break;
    case pr.Date:
      g = /* @__PURE__ */ x.jsx(
        I6,
        {
          ...h,
          min: e.min,
          max: e.max,
          value: new Date(d),
          maxPeriod: e.maxPeriod,
          maxDirection: e.maxDirection,
          displayDays: e.displayDays
        }
      );
      break;
    case pr.Radio:
      g = /* @__PURE__ */ x.jsx(
        q5,
        {
          ...h,
          options: e.options,
          direction: e.direction,
          control: r,
          itemWrapperProps: e.itemWrapperProps
        }
      );
      break;
    case pr.Checkboxset:
      g = /* @__PURE__ */ x.jsx(
        $6,
        {
          ...h,
          options: e.options,
          direction: e.direction,
          control: r,
          itemWrapperProps: e.itemWrapperProps
        }
      );
      break;
    case pr.Checkbox:
      g = /* @__PURE__ */ x.jsx(XY, { ...h });
      break;
    case pr.Dropdown:
      g = /* @__PURE__ */ x.jsx(QC, { ...h, options: e.options, placeholderValue: e.placeholderValue });
      break;
    case pr.TagsAutocomplete:
      g = /* @__PURE__ */ x.jsx(X9, { ...h, groupedOptions: e.groupedOptions });
      break;
    case pr.PictureUploader:
      g = /* @__PURE__ */ x.jsx(K9, { ...h, id: e.id, readOnly: e.readOnly, aspectRatio: e.aspectRatio });
      break;
    case pr.FileUploader:
      g = /* @__PURE__ */ x.jsx(
        L9,
        {
          ...h,
          id: e.id,
          readOnly: e.readOnly,
          allowMultiple: e.allowMultiple,
          acceptedMimeTypes: e.acceptedMimeTypes
        }
      );
      break;
    case pr.AddressAutocomplete:
      g = /* @__PURE__ */ x.jsx(
        UY,
        {
          ...h,
          googleMapsAPIKey: e.googleMapsAPIKey,
          restrictToUS: e.restrictToUS,
          addressInputs: e.addressInputs
        }
      );
      break;
    case pr.SelectionRangeTable:
      g = /* @__PURE__ */ x.jsx(GY, { ...h, options: e.options });
      break;
    case pr.Number:
      g = /* @__PURE__ */ x.jsx(YY, { ...h, min: e.min, max: e.max, textSuffix: e.textSuffix, helperText: e.helperText });
      break;
    case pr.Autocomplete:
      g = /* @__PURE__ */ x.jsx(KY, { ...h, groupedOptions: e.groupedOptions, disabledOptions: e.disabledOptions });
      break;
    default:
      g = /* @__PURE__ */ x.jsx(x.Fragment, {});
  }
  return /* @__PURE__ */ x.jsx(Z1, { theme: XC, children: /* @__PURE__ */ x.jsx(sn, { gap: 0.5, children: g }) });
}, QY = ({ onClick: e, progress: t, formName: n }) => {
  const r = ir();
  return /* @__PURE__ */ x.jsx(Zo, { title: `${t}% Complete`, arrow: !0, placement: "top", children: /* @__PURE__ */ x.jsx(En, { color: "primary", variant: "outlined", onClick: e, children: /* @__PURE__ */ x.jsxs(sn, { direction: "row", alignItems: "center", gap: 1, children: [
    /* @__PURE__ */ x.jsxs(sn, { sx: { position: "relative" }, alignItems: "center", children: [
      /* @__PURE__ */ x.jsx(
        Mi,
        {
          variant: "determinate",
          value: 100,
          size: r.spacing(2),
          disableShrink: !0,
          sx: {
            color: r.palette.grey[50],
            position: "absolute",
            left: 0,
            [`& .${DA.circle}`]: {
              strokeLinecap: "round"
            }
          }
        }
      ),
      /* @__PURE__ */ x.jsx(Mi, { variant: "determinate", value: t, size: r.spacing(2), sx: { color: r.palette.primary.main } })
    ] }),
    n
  ] }) }) });
}, ZY = (e) => /* @__PURE__ */ w.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M22 11.0857V12.0057C21.9988 14.1621 21.3005 16.2604 20.0093 17.9875C18.7182 19.7147 16.9033 20.9782 14.8354 21.5896C12.7674 22.201 10.5573 22.1276 8.53447 21.3803C6.51168 20.633 4.78465 19.2518 3.61096 17.4428C2.43727 15.6338 1.87979 13.4938 2.02168 11.342C2.16356 9.19029 2.99721 7.14205 4.39828 5.5028C5.79935 3.86354 7.69279 2.72111 9.79619 2.24587C11.8996 1.77063 14.1003 1.98806 16.07 2.86572M22 4L12 14.01L9 11.01", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })), JY = ({ onClick: e, progress: t, tooltipText: n, loading: r = !1 }) => {
  const i = ir(), a = t === 100;
  return /* @__PURE__ */ x.jsx(x.Fragment, { children: a ? /* @__PURE__ */ x.jsx(En, { endIcon: /* @__PURE__ */ x.jsx(ZY, { stroke: "white" }), variant: "contained", color: "primary", onClick: e, children: "Submit Application" }) : /* @__PURE__ */ x.jsx(Zo, { title: n, arrow: !0, placement: "top", children: /* @__PURE__ */ x.jsx(
    En,
    {
      endIcon: /* @__PURE__ */ x.jsx(Mi, { variant: "determinate", value: t, size: i.spacing(2), sx: { color: i.palette.primary.main } }),
      variant: "outlined",
      color: "secondary",
      onClick: e,
      loading: r,
      children: /* @__PURE__ */ x.jsxs(sn, { direction: "row", alignItems: "center", gap: 1, children: [
        "Progress: ",
        t,
        "%"
      ] })
    }
  ) }) });
}, o7 = rg(QY), i7 = rg(JY), a7 = rg(QC);
export {
  Ez as API_FIELDS_APPLICATION,
  Pz as API_FIELDS_APPLICATION_LANGUAGE,
  kz as API_FIELDS_APPLICATION_PET,
  Tn as API_FIELDS_CONTACT,
  Dz as API_FIELDS_DEAL,
  Mz as API_FIELDS_STUDENT_FAMILY,
  Tz as CONTACT_CLASSIFICATION,
  a7 as DropdownField,
  r7 as FormField,
  pr as FormFieldType,
  o7 as FormProgressButton,
  ZC as GradientIcon,
  Rz as PUT_API_FIELDS_APPLICATION,
  i7 as ProgressButton,
  Id as TextField
};
//# sourceMappingURL=index.js.map
